webpackJsonp([35783957827783],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(59));
	__export(__webpack_require__(60));
	__export(__webpack_require__(61));
	__export(__webpack_require__(184));
	__export(__webpack_require__(33));
	__export(__webpack_require__(185));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	
	module.exports = __webpack_require__(28).default;


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuGlobal_1 = __webpack_require__(28);
	exports.GLOBAL_LISTENER_KEY = '*';
	exports.GENERIC_EVENT_KEY = 'event';
	var upperCaseFirstLetter = function (str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	};
	var camelize = function (str) {
	    return str.replace(/\W+/g, ' ').replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
	        return (index === 0) ? letter.toLowerCase() : letter.toUpperCase();
	    }).replace(/\s+/g, '');
	};
	var upsertInstanceRegistry = function (className) {
	    if (!HaikuGlobal_1.default.models[className]) {
	        HaikuGlobal_1.default.models[className] = [];
	    }
	    return HaikuGlobal_1.default.models[className];
	};
	var getInstanceRegistry = function (instance) {
	    var className = instance.getClassName();
	    return upsertInstanceRegistry(className);
	};
	var addInstanceToGlobalModelRegistry = function (instance) {
	    getInstanceRegistry(instance).push(instance);
	    return ++HaikuGlobal_1.default.idCounter;
	};
	var removeInstanceFromGlobalModelRegistry = function (instance) {
	    var registry = getInstanceRegistry(instance);
	    for (var i = 0; i < registry.length; i++) {
	        if (registry[i] === instance) {
	            registry.splice(i, 1);
	            return;
	        }
	    }
	};
	var HaikuBase = /** @class */ (function () {
	    function HaikuBase() {
	        this.cache = {};
	        this.$id = addInstanceToGlobalModelRegistry(this);
	        this.listeners = {};
	    }
	    HaikuBase.prototype.getId = function () {
	        return this.$id;
	    };
	    HaikuBase.prototype.getPrimaryKey = function () {
	        return this.getClassName() + ":" + this.getId();
	    };
	    HaikuBase.prototype.getClassName = function () {
	        return this.constructor.__name__;
	    };
	    HaikuBase.prototype.cacheSet = function (key, value) {
	        this.cache[key] = value;
	    };
	    HaikuBase.prototype.cacheGet = function (key) {
	        return this.cache[key];
	    };
	    HaikuBase.prototype.cacheFetch = function (key, provider) {
	        var valueExisting = this.cacheGet(key);
	        if (valueExisting !== undefined) {
	            return valueExisting;
	        }
	        var valueProvided = provider();
	        this.cacheSet(key, valueProvided);
	        return valueProvided;
	    };
	    HaikuBase.prototype.cacheUnset = function (key) {
	        this.cache[key] = undefined;
	    };
	    HaikuBase.prototype.cacheClear = function () {
	        this.cache = {};
	    };
	    HaikuBase.prototype.subcacheGet = function (key) {
	        return this.cacheGet(key);
	    };
	    HaikuBase.prototype.subcacheEnsure = function (key) {
	        if (!this.cacheGet(key)) {
	            this.cacheSet(key, {});
	        }
	    };
	    HaikuBase.prototype.subcacheClear = function (key) {
	        this.cacheSet(key, {});
	    };
	    HaikuBase.prototype.on = function (key, listener) {
	        if (!this.listeners[key]) {
	            this.listeners[key] = [];
	        }
	        this.listeners[key].push(listener);
	    };
	    HaikuBase.prototype.addEventListener = function (key, listener) {
	        this.on(key, listener);
	    };
	    HaikuBase.prototype.off = function (key, listener) {
	        if (!this.listeners[key]) {
	            return;
	        }
	        for (var i = this.listeners[key].length - 1; i >= 0; i--) {
	            if (this.listeners[key][i] === listener) {
	                this.listeners[key].splice(i, 1);
	            }
	        }
	    };
	    HaikuBase.prototype.removeEventListener = function (key, listener) {
	        this.off(key, listener);
	    };
	    HaikuBase.prototype.removeListener = function (key, listener) {
	        this.off(key, listener);
	    };
	    HaikuBase.prototype.emitToListeners = function (key, args) {
	        if (this.listeners[key]) {
	            for (var i = 0; i < this.listeners[key].length; i++) {
	                this.listeners[key][i].apply(null, args);
	            }
	        }
	    };
	    HaikuBase.prototype.emitToGenericListeners = function (key, args) {
	        if (this.listeners[exports.GLOBAL_LISTENER_KEY]) {
	            for (var i = 0; i < this.listeners[exports.GLOBAL_LISTENER_KEY].length; i++) {
	                this.listeners[exports.GLOBAL_LISTENER_KEY][i].apply(null, [key].concat(args));
	            }
	        }
	    };
	    HaikuBase.prototype.emitToAncestors = function (key) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        return; // no-op; Implemented by subclass
	    };
	    HaikuBase.prototype.emit = function (key) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        // Specific direct listeners (this.on('foo:bar'))
	        this.emitToListeners(key, args);
	        // Specific config object listeners (`onHaikuEventFooBar`)
	        this.emitToConfigHandlers(key, args);
	        // Generic direct listeners (this.on('*'))
	        this.emitToGenericListeners(key, args);
	        // Emit up the chain
	        this.emitToAncestors.apply(this, [key].concat(args));
	        var allArgs = [key].concat(args);
	        // Generic config object listeners ('event', 'onEvent', 'onHaikuEvent')
	        // for when the subscription name isn't known in advance, e.g. custom events
	        this.emitToConfigHandlers(exports.GENERIC_EVENT_KEY, allArgs);
	    };
	    HaikuBase.prototype.emitToConfigHandlers = function (key, args) {
	        if (!this.config) {
	            return;
	        }
	        // 'somebody:Did-Thing' -> 'somebodyDidThing'
	        var keyCamelCase = upperCaseFirstLetter(camelize(key));
	        // 'somebodyDidThing' -> 'onSomebodyDidThing'
	        var keyCamelCaseWithOnPrefix = "on" + keyCamelCase;
	        if (typeof this.config[keyCamelCaseWithOnPrefix] === 'function') {
	            this.config[keyCamelCaseWithOnPrefix].apply(null, args);
	        }
	        // 'somebodyDidThing' -> 'onHaikuSomebodyDidThing' (legacy)
	        var keyCamelCaseWithOnHaikuPrefix = "onHaiku" + keyCamelCase;
	        if (typeof this.config[keyCamelCaseWithOnHaikuPrefix] === 'function') {
	            this.config[keyCamelCaseWithOnHaikuPrefix].apply(null, args);
	        }
	    };
	    HaikuBase.prototype.matchesCriteria = function (criteria) {
	        if (!criteria) {
	            return false;
	        }
	        var answer = true;
	        for (var key in criteria) {
	            if (this[key] !== criteria[key]) {
	                answer = false;
	            }
	        }
	        return answer;
	    };
	    HaikuBase.prototype.destroy = function () {
	        removeInstanceFromGlobalModelRegistry(this);
	    };
	    HaikuBase.getRegistryForClass = function (klass) {
	        return upsertInstanceRegistry(klass.__name__);
	    };
	    return HaikuBase;
	}());
	exports.default = HaikuBase;
	//# sourceMappingURL=HaikuBase.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ELEMENTS_2D = {
	    circle: true,
	    ellipse: true,
	    foreignObject: true,
	    g: true,
	    image: true,
	    line: true,
	    mesh: true,
	    path: true,
	    polygon: true,
	    polyline: true,
	    rect: true,
	    // svg: true, // Since we host <svg> only underneath <div> it should be fine to set this?
	    switch: true,
	    symbol: true,
	    text: true,
	    textPath: true,
	    tspan: true,
	    unknown: true,
	    use: true,
	};
	exports.AUTO_SIZING_TOKEN = 'auto';
	// Coordinate (0, 0, 0) is the top left of the screen
	exports.SIZE_PROPORTIONAL = 0; // A percentage of the parent
	exports.SIZE_ABSOLUTE = 1; // A fixed size in screen pixels
	var IDENTITY = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	// Used for rendering downstream
	var FORMATS = {
	    THREE: 3,
	    TWO: 2,
	};
	var DIV = 'div';
	var SVG = 'svg';
	var TYPE_STRING = 'string';
	var virtualElementIsLayoutContainer = function (virtualElement) {
	    // A virtual element is a layout container if the element is a component…
	    return typeof virtualElement.elementName !== TYPE_STRING ||
	        // …or if it is a layout container defining its own coordinate system.
	        virtualElement.elementName === SVG ||
	        virtualElement.elementName === DIV;
	};
	var initializeNodeAttributes = function (node, isRootNode) {
	    if (!node || typeof node !== 'object') {
	        return;
	    }
	    if (!node.attributes) {
	        node.attributes = {};
	    }
	    if (!node.attributes.style) {
	        node.attributes.style = {};
	    }
	    node.isRootNode = isRootNode;
	    return node;
	};
	var initializeNodeLayout = function (node) {
	    node.layout = createLayoutSpec(!node.isRootNode && virtualElementIsLayoutContainer(node));
	    node.layout.matrix = createMatrix();
	    node.layout.format = ELEMENTS_2D[node.elementName]
	        ? FORMATS.TWO
	        : FORMATS.THREE;
	};
	var createMatrix = function () { return copyMatrix(IDENTITY); };
	var copyMatrix = function (m) { return m.slice(); };
	var multiplyMatrices = function (a, b) { return [
	    a[0] * b[0] + a[1] * b[4] + a[2] * b[8] + a[3] * b[12],
	    a[0] * b[1] + a[1] * b[5] + a[2] * b[9] + a[3] * b[13],
	    a[0] * b[2] + a[1] * b[6] + a[2] * b[10] + a[3] * b[14],
	    a[0] * b[3] + a[1] * b[7] + a[2] * b[11] + a[3] * b[15],
	    a[4] * b[0] + a[5] * b[4] + a[6] * b[8] + a[7] * b[12],
	    a[4] * b[1] + a[5] * b[5] + a[6] * b[9] + a[7] * b[13],
	    a[4] * b[2] + a[5] * b[6] + a[6] * b[10] + a[7] * b[14],
	    a[4] * b[3] + a[5] * b[7] + a[6] * b[11] + a[7] * b[15],
	    a[8] * b[0] + a[9] * b[4] + a[10] * b[8] + a[11] * b[12],
	    a[8] * b[1] + a[9] * b[5] + a[10] * b[9] + a[11] * b[13],
	    a[8] * b[2] + a[9] * b[6] + a[10] * b[10] + a[11] * b[14],
	    a[8] * b[3] + a[9] * b[7] + a[10] * b[11] + a[11] * b[15],
	    a[12] * b[0] + a[13] * b[4] + a[14] * b[8] + a[15] * b[12],
	    a[12] * b[1] + a[13] * b[5] + a[14] * b[9] + a[15] * b[13],
	    a[12] * b[2] + a[13] * b[6] + a[14] * b[10] + a[15] * b[14],
	    a[12] * b[3] + a[13] * b[7] + a[14] * b[11] + a[15] * b[15],
	]; };
	var multiplyArrayOfMatrices = function (arrayOfMatrices) {
	    var product = createMatrix();
	    for (var i = 0; i < arrayOfMatrices.length; i++) {
	        product = multiplyMatrices(product, arrayOfMatrices[i]);
	    }
	    return product;
	};
	var computeOrthonormalBasisMatrix = function (rotation, shear) {
	    var orthonormalBasisLayout = __assign({}, createLayoutSpec(), { rotation: rotation,
	        shear: shear });
	    var ignoredSize = { x: 0, y: 0, z: 0 };
	    return computeMatrix(orthonormalBasisLayout, ignoredSize);
	};
	var computeScaledBasisMatrix = function (rotation, scale, shear) {
	    var scaledBasisLayout = __assign({}, createLayoutSpec(), { rotation: rotation,
	        scale: scale,
	        shear: shear });
	    var ignoredSize = { x: 0, y: 0, z: 0 };
	    return computeMatrix(scaledBasisLayout, ignoredSize);
	};
	var clone = function (layout) {
	    if (!layout) {
	        return layout;
	    }
	    var out = {
	        shown: layout.shown,
	        opacity: layout.opacity,
	        mount: Object.assign({}, layout.mount),
	        offset: Object.assign({}, layout.offset),
	        origin: Object.assign({}, layout.origin),
	        translation: Object.assign({}, layout.translation),
	        rotation: Object.assign({}, layout.rotation),
	        scale: Object.assign({}, layout.scale),
	        shear: Object.assign({}, layout.shear),
	        sizeMode: Object.assign({}, layout.sizeMode),
	        sizeProportional: Object.assign({}, layout.sizeProportional),
	        sizeDifferential: Object.assign({}, layout.sizeDifferential),
	        sizeAbsolute: Object.assign({}, layout.sizeAbsolute),
	        size: null,
	        matrix: null,
	        computed: null,
	    };
	    if (layout.computed) {
	        out.computed = clone(layout.computed);
	    }
	    // Handle either a raw layout (no size or matrix) or a computed one (has size and matrix)
	    if (layout.matrix) {
	        out.matrix = layout.matrix.map(function (n) { return n; });
	    }
	    if (layout.size) {
	        out.size = Object.assign({}, layout.size);
	    }
	    return out;
	};
	/**
	 * The code below includes modified code from https://github.com/famous/engine
	 *
	 * The original code was released under the MIT license.
	 *
	 * MIT License (MIT)
	 *
	 * Copyright (c) 2015 Famous Industries Inc.
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */
	var createLayoutSpec = function (createCoordinateSystem) { return ({
	    shown: true,
	    opacity: 1.0,
	    offset: { x: 0, y: 0, z: 0 },
	    origin: createCoordinateSystem ? { x: 0.5, y: 0.5, z: 0.5 } : { x: 0, y: 0, z: 0 },
	    translation: { x: 0, y: 0, z: 0 },
	    rotation: { x: 0, y: 0, z: 0 },
	    scale: { x: 1, y: 1, z: 1 },
	    shear: { xy: 0, xz: 0, yz: 0 },
	    sizeMode: {
	        x: exports.SIZE_PROPORTIONAL,
	        y: exports.SIZE_PROPORTIONAL,
	        z: exports.SIZE_PROPORTIONAL,
	    },
	    sizeProportional: { x: 1, y: 1, z: 1 },
	    sizeDifferential: { x: 0, y: 0, z: 0 },
	    sizeAbsolute: { x: 0, y: 0, z: 0 },
	}); };
	var computeMatrix = function (layoutSpec, targetSize) {
	    var originX = layoutSpec.origin.x * targetSize.x;
	    var originY = layoutSpec.origin.y * targetSize.y;
	    var originZ = layoutSpec.origin.z * targetSize.z;
	    // We represent the matrix in column-major order, a convention in graphics programming.
	    var m = createMatrix();
	    // Only if necessary, apply rotation from Euler angles in order: Z then Y then X.
	    if (layoutSpec.rotation.x || layoutSpec.rotation.y || layoutSpec.rotation.z) {
	        var sx = Math.sin(layoutSpec.rotation.x);
	        var sy = Math.sin(layoutSpec.rotation.y);
	        var sz = Math.sin(layoutSpec.rotation.z);
	        var cx = Math.cos(layoutSpec.rotation.x);
	        var cy = Math.cos(layoutSpec.rotation.y);
	        var cz = Math.cos(layoutSpec.rotation.z);
	        var cxcz = cx * cz;
	        var cxsz = cx * sz;
	        var sxcz = sx * cz;
	        var sxsz = sx * sz;
	        m[0] = cy * cz;
	        m[4] = sy * sxcz - cxsz;
	        m[8] = sy * cxcz + sxsz;
	        m[1] = cy * sz;
	        m[5] = sy * sxsz + cxcz;
	        m[9] = sy * cxsz - sxcz;
	        m[2] = -sy;
	        m[6] = cy * sx;
	        m[10] = cy * cx;
	    }
	    // Only if necessary, apply shear.
	    if (layoutSpec.shear.xy || layoutSpec.shear.xz || layoutSpec.shear.yz) {
	        var shearXzProxy = layoutSpec.shear.xy * layoutSpec.shear.yz + layoutSpec.shear.xz;
	        m[8] += layoutSpec.shear.yz * m[4] + shearXzProxy * m[0];
	        m[9] += layoutSpec.shear.yz * m[5] + shearXzProxy * m[1];
	        m[10] += layoutSpec.shear.yz * m[6] + shearXzProxy * m[2];
	        m[4] += layoutSpec.shear.xy * m[0];
	        m[5] += layoutSpec.shear.xy * m[1];
	        m[6] += layoutSpec.shear.xy * m[2];
	    }
	    // Multiply nontrivial scale through.
	    if (layoutSpec.scale.x !== 1) {
	        m[0] *= layoutSpec.scale.x;
	        m[1] *= layoutSpec.scale.x;
	        m[2] *= layoutSpec.scale.x;
	    }
	    if (layoutSpec.scale.y !== 1) {
	        m[4] *= layoutSpec.scale.y;
	        m[5] *= layoutSpec.scale.y;
	        m[6] *= layoutSpec.scale.y;
	    }
	    if (layoutSpec.scale.z !== 1) {
	        m[8] *= layoutSpec.scale.z;
	        m[9] *= layoutSpec.scale.z;
	        m[10] *= layoutSpec.scale.z;
	    }
	    m[12] =
	        layoutSpec.offset.x +
	            layoutSpec.translation.x -
	            (m[0] * originX + m[4] * originY + m[8] * originZ);
	    m[13] =
	        layoutSpec.offset.y +
	            layoutSpec.translation.y -
	            (m[1] * originX + m[5] * originY + m[9] * originZ);
	    m[14] =
	        layoutSpec.offset.z +
	            layoutSpec.translation.z -
	            (m[2] * originX + m[6] * originY + m[10] * originZ);
	    return m;
	};
	exports.default = {
	    multiplyArrayOfMatrices: multiplyArrayOfMatrices,
	    clone: clone,
	    computeMatrix: computeMatrix,
	    computeOrthonormalBasisMatrix: computeOrthonormalBasisMatrix,
	    computeScaledBasisMatrix: computeScaledBasisMatrix,
	    createLayoutSpec: createLayoutSpec,
	    createMatrix: createMatrix,
	    copyMatrix: copyMatrix,
	    initializeNodeAttributes: initializeNodeAttributes,
	    initializeNodeLayout: initializeNodeLayout,
	    virtualElementIsLayoutContainer: virtualElementIsLayoutContainer,
	    FORMATS: FORMATS,
	    SIZE_ABSOLUTE: exports.SIZE_ABSOLUTE,
	    SIZE_PROPORTIONAL: exports.SIZE_PROPORTIONAL,
	};
	//# sourceMappingURL=Layout3D.js.map

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

	module.exports = {"name":"@haiku/core","version":"4.5.0","description":"Haiku Core is a JavaScript library for building user interfaces","homepage":"https://haiku.ai","directories":{"lib":"lib","dom":"dom","components":"components","dist":"dist"},"keywords":["animation","motion","component","web","browser","svg","rendering","engine"],"repository":"https://github.com/HaikuTeam/core","main":"index.js","scripts":{"lint":"tslint --exclude 'src/vendor/**' -p tsconfig.all.json -t stylish","lint-report":"yarn lint -t checkstyle -o checkstyle-result.xml","fix":"yarn lint --fix","ts":"cross-env NODE_ENV=test ts-node -r tsconfig-paths/register -P tsconfig.all.json","test":"yarn ts ./node_modules/.bin/tape 'test/**/*.test.ts' | tap-spec","test-report":"nyc yarn ts ./node_modules/.bin/tape 'test/**/*.test.ts' > test-result.tap","compile":"tsc","develop":"tsc --watch","bundle":"yarn compile && yarn ts ./scripts/bundle.ts","demos":"yarn ts ./scripts/demos.ts"},"authors":["Matthew Trost <matthew@haiku.ai>","Zack Brown <zack@haiku.ai>","Taylor Poe <taylor@haiku.ai>","Sasha Joseph <sasha@haiku.ai>"],"license":"MIT","devDependencies":{"@angular/core":"^6.0.9","async":"^2.5.0","chokidar":"^1.7.0","cross-env":"^5.1.6","depcheck":"^0.6.7","express":"4.14.1","filesize":"3.5.10","fs-extra":"^4.0.2","haiku-testing":"4.5.0","handlebars":"^4.0.8","istanbul-reporter-cobertura-haiku":"^1.0.2","jsdom":"^11.1.0","leaked-handles":"^5.2.0","nodemon":"1.11.0","nyc":"^13.0.1","opn":"^5.3.0","react":"^16.0.0","react-dom":"^16.0.0","react-router-dom":"^4.1.1","rollup":"^0.53.3","rollup-plugin-commonjs":"^8.2.6","rollup-plugin-json":"^2.3.0","rollup-plugin-node-resolve":"^3.0.0","rollup-plugin-uglify-es":"^0.0.1","rxjs":"^6.3.3","tap-spec":"^4.1.2","tape":"^4.9.0","ts-loader":"^4.4.2","ts-node":"^6.1.0","tsconfig-paths":"^3.3.2","tslint":"^5.11.0","tslint-config-haiku":"^1.0.16","tslint-no-circular-imports":"^0.5.0","typescript":"^3.0.3","webpack":"^4.16.0","webpack-cli":"^3.0.8"},"peerDependencies":{"@angular/core":"^6.0.9","react":"^16.0.0 || ^15.4.2","react-dom":"^16.0.0 || ^15.4.2"}}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2017 Ryan Florence
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function assign() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var t = args[0];
	    for (var s = void 0, i = 1, n = args.length; i < n; i++) {
	        s = args[i];
	        for (var p in s) {
	            if (Object.prototype.hasOwnProperty.call(s, p)) {
	                t[p] = s[p];
	            }
	        }
	    }
	    return t;
	}
	exports.default = assign;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var interactionModes_1 = __webpack_require__(53);
	exports.DEFAULTS = {
	    alwaysComputeSizing: false,
	    automount: true,
	    autoplay: true,
	    children: null,
	    clock: {},
	    contextMenu: 'enabled',
	    eventHandlers: null,
	    folder: null,
	    forceFlush: false,
	    frame: null,
	    freeze: false,
	    helpers: null,
	    hooks: null,
	    interactionMode: interactionModes_1.InteractionMode.LIVE,
	    loop: false,
	    mixpanel: '6f31d4f99cf71024ce27c3e404a79a61',
	    overflow: null,
	    overflowX: null,
	    overflowY: null,
	    placeholder: null,
	    position: 'relative',
	    preserve3d: 'auto',
	    seed: null,
	    sizing: null,
	    states: null,
	    timelines: null,
	    timestamp: null,
	    vanities: null,
	};
	/**
	 * Configuration from HaikuContext is forwarded to all HaikuComponent instances in its tree.
	 * For child instances, certain settings (such as `loop`) give unexpected behavior and
	 * other settings (such as `states`) don't make much sense to pass down. This specifies the
	 * settings that are considered safe to forward from the context to all subcomponents.
	 */
	var CHILD_SAFE_CONFIG = {
	    alwaysComputeSizing: true,
	    clock: true,
	    contextMenu: true,
	    folder: true,
	    freeze: true,
	    interactionMode: true,
	    mixpanel: true,
	    overflow: true,
	    overflowX: true,
	    overflowY: true,
	    preserve3d: true,
	    seed: true,
	    sizing: true,
	    timestamp: true,
	};
	var buildChildSafeConfig = function (config) {
	    var out = {};
	    for (var key in config) {
	        if (CHILD_SAFE_CONFIG[key]) {
	            out[key] = config[key];
	        }
	    }
	    return out;
	};
	function seed() {
	    return Math.random().toString(36).slice(2);
	}
	var CONFIG_KEYS_TO_MERGE = {
	    states: true,
	    eventHandlers: true,
	    timelines: true,
	    helpers: true,
	    vanities: true,
	    initialStates: true,
	};
	function build() {
	    var argums = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        argums[_i] = arguments[_i];
	    }
	    var config = {};
	    var args = argums.slice();
	    args.unshift(exports.DEFAULTS);
	    args.forEach(function (incoming) {
	        if (!incoming || typeof incoming !== 'object') {
	            return;
	        }
	        for (var key in incoming) {
	            if (incoming[key] === undefined) {
	                continue;
	            }
	            if (CONFIG_KEYS_TO_MERGE[key]) {
	                if (!config[key]) {
	                    config[key] = {};
	                }
	                config[key] = __assign({}, config[key], incoming[key]);
	            }
	            else {
	                config[key] = incoming[key];
	            }
	        }
	    });
	    // Validations
	    if (config.overflow && (config.overflowX || config.overflowY)) {
	        console.warn('[haiku core] `overflow` overrides `overflowY`/`overflowX`');
	        config.overflowX = null;
	        config.overflowY = null;
	    }
	    return config;
	}
	exports.default = {
	    build: build,
	    seed: seed,
	    DEFAULTS: exports.DEFAULTS,
	    buildChildSafeConfig: buildChildSafeConfig,
	};
	//# sourceMappingURL=Config.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var enhance_1 = __webpack_require__(30);
	var inject_1 = __webpack_require__(56);
	var VERSION = __webpack_require__(17).version;
	function buildRoot() {
	    // We need a global harness so we can...
	    // - have a single rAF loop even if we've got multiple Haiku Contexts on the same page
	    // - expose some global APIs that we hope to make available for all components
	    var ROOT = {};
	    // Window gets highest precedence since most likely we're running in DOM
	    if (typeof window !== 'undefined') {
	        ROOT = window;
	    }
	    else if (typeof global !== 'undefined') {
	        ROOT = global;
	    }
	    else {
	        // On the off-chance there is no real global, just use the orig object
	    }
	    if (!ROOT.haiku) {
	        ROOT.haiku = {};
	    }
	    // Avoid loading entities for incompatible versions.
	    if (!ROOT.haiku[VERSION]) {
	        ROOT.haiku[VERSION] = {};
	    }
	    if (!ROOT.haiku[VERSION].models) {
	        ROOT.haiku[VERSION].models = {};
	    }
	    if (!ROOT.haiku[VERSION].idCounter) {
	        // Legacy: we start the ID counter at 1000 to avoid edge case ID collisions when there are copies of Haiku
	        // sitting on the same page.
	        ROOT.haiku[VERSION].idCounter = 1000;
	    }
	    if (!ROOT.haiku[VERSION].enhance) {
	        /**
	         * @function enhance
	         * @description Given a function, decorate it with a .specification property that
	         * contains a descriptor of the serialized form of the function, including its params.
	         * This is used by the renderer as part of its automatic dependency injection mechanism.
	         */
	        ROOT.haiku[VERSION].enhance = enhance_1.default;
	    }
	    if (!ROOT.haiku[VERSION].inject) {
	        /**
	         * @function inject
	         * @description Variadic function that takes a function as the first argument and
	         * a collection of injection parameters as the remaining arguments, which are in turn
	         * used to 'enhance' (see above) the function, specifying the parameters it wants injected.
	         */
	        ROOT.haiku[VERSION].inject = inject_1.default;
	    }
	    return ROOT.haiku[VERSION];
	}
	var haiku = buildRoot();
	exports.default = haiku;
	//# sourceMappingURL=HaikuGlobal.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var Layout3D_1 = __webpack_require__(14);
	var array_unique_1 = __webpack_require__(142);
	var uniq = array_unique_1.default.uniq;
	var ALT_CLASS_NAME_ATTR = 'className'; // Ease of React integration
	var ATTR_EXEC_RE = /\[([a-zA-Z0-9]+)([$|^~])?(=)?"?(.+?)?"?( i)?]/;
	var ATTR_PREFIX = '[';
	var CLASS_NAME_ATTR = 'class';
	var CLASS_PREFIX = '.';
	var FUNCTION = 'function';
	var HAIKU_ID_ATTRIBUTE = 'haiku-id';
	var HAIKU_PREFIX = 'haiku:';
	var ID_PREFIX = '#';
	var PIECE_SEPARATOR = ',';
	var SPACE = ' ';
	var getFnName = function (fn) {
	    if (fn.name) {
	        return fn.name;
	    }
	    var str = fn.toString();
	    //                  | | <-- this space is always here via toString()
	    var reg = /function ([^(]*)/;
	    var ex = reg.exec(str);
	    return ex && ex[1];
	};
	exports.parseAttrSelector = function (selector) {
	    var matches = ATTR_EXEC_RE.exec(selector);
	    if (!matches) {
	        return null;
	    }
	    return {
	        key: matches[1],
	        operator: matches[3] && (matches[2] || '') + matches[3],
	        value: matches[4],
	        insensitive: !!matches[5],
	    };
	};
	exports.cssMatchByAttribute = function (node, attrKeyToMatch, attrOperator, attrValueToMatch, options) {
	    var attributes = node[options.attributes];
	    if (attributes) {
	        var attrValue = attributes[attrKeyToMatch];
	        // If no operator, do a simple presence check ([foo])
	        if (!attrOperator) {
	            return !!attrValue;
	        }
	        switch (attrOperator) {
	            case '=':
	                return attrValueToMatch === attrValue;
	            // case '~=':
	            // case '|=':
	            // case '^=':
	            // case '$=':
	            // case '*=':
	            default:
	                console.warn('Operator `' + attrOperator + '` not supported yet');
	                return false;
	        }
	    }
	};
	exports.cssMatchByClass = function (node, className, options) {
	    var attributes = node[options.attributes];
	    if (attributes) {
	        var foundClassName = attributes[CLASS_NAME_ATTR];
	        if (!foundClassName) {
	            foundClassName = attributes[ALT_CLASS_NAME_ATTR];
	        }
	        if (foundClassName) {
	            var classPieces = foundClassName.split(SPACE);
	            if (classPieces.indexOf(className) !== -1) {
	                return true;
	            }
	        }
	    }
	};
	exports.cssMatchByHaiku = function (node, haikuString, options) {
	    var attributes = node[options.attributes];
	    if (!attributes) {
	        return false;
	    }
	    if (!attributes[HAIKU_ID_ATTRIBUTE]) {
	        return false;
	    }
	    return attributes[HAIKU_ID_ATTRIBUTE] === haikuString;
	};
	exports.cssMatchById = function (node, id, options) {
	    var attributes = node[options.attributes];
	    if (attributes) {
	        if (attributes.id === id) {
	            return true;
	        }
	    }
	};
	exports.cssMatchByTagName = function (node, tagName, options) {
	    var val = node[options.name];
	    if (val) {
	        if (typeof val === 'string' && val === tagName) {
	            return true;
	        }
	        if (typeof val === FUNCTION) {
	            // Allow function constructors to act as the tag name
	            if (getFnName(val) === tagName) {
	                return true;
	            }
	        }
	        if (typeof val === 'object') {
	            // Allow for things like instances to act as the tag name
	            if (val.name === tagName || val.tagName === tagName) {
	                return true;
	            }
	        }
	    }
	};
	exports.cssMatchOne = function (node, piece, options) {
	    if (piece.slice(0, 6) === HAIKU_PREFIX) {
	        return exports.cssMatchByHaiku(node, piece.slice(6), options);
	    }
	    if (piece[0] === ID_PREFIX) {
	        return exports.cssMatchById(node, piece.slice(1, piece.length), options);
	    }
	    if (piece[0] === CLASS_PREFIX) {
	        return exports.cssMatchByClass(node, piece.slice(1, piece.length), options);
	    }
	    if (piece[0] === ATTR_PREFIX) {
	        var parsedAttr = exports.parseAttrSelector(piece);
	        if (!parsedAttr) {
	            return false;
	        }
	        return exports.cssMatchByAttribute(node, parsedAttr.key, parsedAttr.operator, parsedAttr.value, options);
	    }
	    return exports.cssMatchByTagName(node, piece, options);
	};
	exports.cssQueryList = function (list, query, options) {
	    var matches = [];
	    var pieces = query.split(PIECE_SEPARATOR);
	    for (var i = 0; i < pieces.length; i++) {
	        var piece = pieces[i].trim();
	        for (var j = 0; j < list.length; j++) {
	            var node = list[j];
	            if (exports.cssMatchOne(node, piece, options)) {
	                matches.push(node);
	            }
	        }
	    }
	    return matches;
	};
	exports.cssQueryTree = function (node, query, options) {
	    if (!node || typeof node !== 'object') {
	        return [];
	    }
	    return exports.cssQueryList(exports.manaFlattenTree(node, options), query, options);
	};
	exports.manaFlattenTree = function (node, options, unique, list, depth, index) {
	    if (unique === void 0) { unique = true; }
	    if (list === void 0) { list = []; }
	    if (depth === void 0) { depth = 0; }
	    if (index === void 0) { index = 0; }
	    list.push(node);
	    // Don't recurse down into the children of nested components, which should be 'invisible' to us.
	    // Nested components are indicated when their name is not a string, e.g. a component descriptor.
	    if (depth < 1 || typeof node[options.name] === 'string') {
	        var children = node[options.children];
	        if (!children || typeof children === 'string') {
	            return list;
	        }
	        if (Array.isArray(children)) {
	            var copies = children.slice(0);
	            // Without this, we'll have an infinite loop since the source child appears in both the
	            // original children and the snapshotted children arrays.
	            uniq(copies);
	            for (var i = 0; i < copies.length; i++) {
	                exports.manaFlattenTree(copies[i], options, false, list, depth + 1, i);
	            }
	        }
	        else if (typeof children === 'object') {
	            list.push(children);
	            return list;
	        }
	    }
	    return unique ? uniq(list) : list;
	};
	exports.visitManaTree = function (locator, mana, visitor, parent, index) {
	    if (!mana || typeof mana === 'string') {
	        return null;
	    }
	    visitor(mana.elementName, mana.attributes, mana.children, mana, locator, parent, index);
	    if (!mana.children) {
	        return null;
	    }
	    for (var i = 0; i < mana.children.length; i++) {
	        var child = mana.children[i];
	        exports.visitManaTree(locator + '.' + i, child, visitor, mana, i);
	    }
	};
	exports.visit = function (mana, visitor, parent) {
	    if (!mana || typeof mana !== 'object') {
	        return;
	    }
	    visitor(mana, parent);
	    var children = ((mana.__memory && mana.__memory.children) || mana.children);
	    if (children) {
	        for (var i = 0; i < children.length; i++) {
	            var child = children[i];
	            if (child && child.__memory && child.__memory.instance) {
	                continue;
	            }
	            exports.visit(child, visitor, mana);
	        }
	    }
	};
	exports.ascend = function (mana, ascender) {
	    if (!mana || typeof mana !== 'object') {
	        return;
	    }
	    ascender(mana);
	    if (mana.__memory) {
	        // Don't ascend beyond the scope of the host component instance
	        if (!mana.__memory.instance && mana.__memory.parent) {
	            exports.ascend(mana.__memory.parent, ascender);
	        }
	    }
	};
	exports.cloneNodeShallow = function (node) {
	    if (!node) {
	        return node;
	    }
	    return __assign({}, node, { attributes: exports.cloneAttributes(node.attributes), layout: Layout3D_1.default.clone(node.layout) });
	};
	exports.cloneAttributes = function (attributes) {
	    if (!attributes) {
	        return attributes;
	    }
	    var out = __assign({}, attributes);
	    if (attributes.style) {
	        out.style = Object.assign({}, attributes.style);
	    }
	    return out;
	};
	//# sourceMappingURL=HaikuNode.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var functionToRFO_1 = __webpack_require__(31);
	function enhance(fn, params) {
	    // Only create a specification if we don't already have one
	    if (!fn.specification) {
	        var rfo = functionToRFO_1.default(fn);
	        if (rfo && rfo.__function) {
	            // Cache this so we don't expensively parse each time
	            fn.specification = rfo.__function;
	            // Allow an explicit list of params to override ours
	            if (params) {
	                fn.specification.params = params;
	            }
	        }
	        else {
	            // Signal that this function is of an unknown kind
	            // so future runs don't try to parse this one again
	            fn.specification = true;
	        }
	    }
	}
	exports.default = enhance;
	//# sourceMappingURL=enhance.js.map

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Tokenizer_1 = __webpack_require__(55);
	function nth(n, type, arr) {
	    var none = { value: null, type: 'void' };
	    if (arr.length < 1 || n > arr.length) {
	        return none;
	    }
	    var f = 0;
	    for (var i = 0; i < arr.length; i++) {
	        if (arr[i].type === type) {
	            f += 1;
	        }
	        if (f === n) {
	            return arr[i];
	        }
	    }
	    return none;
	}
	function tokensToParams(tokens) {
	    if (tokens.length < 1) {
	        return [];
	    }
	    // HACK: Rather than property ast-ize this, we're just going to go through it linearly and make JSON.
	    var json = '';
	    var frag = '';
	    var next;
	    var token = tokens.shift();
	    var scopes = [];
	    while (token) {
	        switch (token.type) {
	            case 'whitespace':
	                frag = ' ';
	                break;
	            case 'comma':
	                frag = ',';
	                break;
	            case 'colon':
	                frag = ':';
	                break;
	            // Treat parens as an 'array' scope, e.g. at top level of function signature arguments
	            case 'paren_open':
	                frag = '[';
	                scopes.push('square');
	                break;
	            case 'paren_close':
	                frag = ']';
	                scopes.pop();
	                break;
	            case 'square_open':
	                frag = '[';
	                scopes.push('square');
	                break;
	            case 'square_close':
	                frag = ']';
	                scopes.pop();
	                break;
	            case 'curly_open':
	                frag = '{';
	                scopes.push('curly');
	                break;
	            case 'curly_close':
	                frag = '}';
	                scopes.pop();
	                break;
	            case 'rest':
	                next = tokens.shift();
	                frag = JSON.stringify({ __rest: next.value });
	                break;
	            case 'identifier':
	                frag = '"' + token.value + '"';
	                // If the next token is a comma, we are a self-referential property
	                if (tokens[0] &&
	                    (tokens[0].type === 'comma' ||
	                        tokens[0].type === 'square_close' ||
	                        tokens[0].type === 'curly_close')) {
	                    // Handle differently inside array vs object, e.g.:
	                    // { a: a, b: b } vs [ a, b, c ]
	                    var scope = scopes[scopes.length - 1];
	                    if (scope === 'square') {
	                        frag += '';
	                    }
	                    else {
	                        frag += ':"' + token.value + '"';
	                    }
	                }
	                break;
	            default:
	                frag = '';
	        }
	        json += frag;
	        token = tokens.shift();
	    }
	    return JSON.parse(json);
	}
	function signatureToParams(signature) {
	    var tokens = Tokenizer_1.tokenizeParameters(signature);
	    var clean = [];
	    for (var i = 0; i < tokens.length; i++) {
	        if (tokens[i].type !== 'whitespace') {
	            clean.push(tokens[i]);
	        }
	    }
	    try {
	        return tokensToParams(clean);
	    }
	    catch (exception) {
	        console.warn("Unable to parse signature " + signature, exception);
	        return [];
	    }
	}
	function functionToRFO(fn) {
	    var str = fn.toString();
	    // HACK: Remove paren wrapping if any was provided
	    if (str[str.length - 1] === ')') {
	        if (str[0] === '(') {
	            str = str.slice(1);
	        }
	    }
	    var pidx1 = str.indexOf('(');
	    var pidx2 = str.indexOf(')');
	    var prefix = str.slice(0, pidx1);
	    var signature = str.slice(pidx1, pidx2 + 1);
	    var suffix = str.slice(pidx2 + 1, str.length);
	    var body = suffix.slice(suffix.indexOf('{') + 1, suffix.length - 1).trim(); // Don't include braces or padding
	    var type = suffix.match(/^\s*=>\s*{/)
	        ? 'ArrowFunctionExpression'
	        : 'FunctionExpression';
	    var name = nth(2, 'identifier', Tokenizer_1.tokenizeParameters(prefix)).value;
	    var params = signatureToParams(signature);
	    var spec = {
	        type: type,
	        name: name,
	        params: params,
	        body: body,
	    };
	    // If the runtime function is labeled as an injectee, we *must* indicate as much
	    // in the specification so that serialization back to code wraps it properly
	    if (fn.injectee) {
	        spec.injectee = true;
	    }
	    return {
	        __function: spec,
	    };
	}
	exports.default = functionToRFO;
	//# sourceMappingURL=functionToRFO.js.map

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeOutBounce = function (x) {
	    var n1 = 7.5625;
	    var d1 = 2.75;
	    return x < 1 / d1
	        ? n1 * x * x
	        : x < 2 / d1
	            ? n1 * (x -= (1.5 / d1)) * x + .75
	            : x < 2.5 / d1
	                ? n1 * (x -= (2.25 / d1)) * x + .9375
	                : n1 * (x -= (2.625 / d1)) * x + .984375;
	};
	//# sourceMappingURL=easeOutBounce.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.abs = Math.abs;
	exports.asin = Math.asin;
	exports.floor = Math.floor;
	exports.cos = Math.cos;
	exports.pow = Math.pow;
	exports.sin = Math.sin;
	exports.sqrt = Math.sqrt;
	//# sourceMappingURL=math.js.map

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _index = __webpack_require__(71);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * -------------------------------------------------------
	 * Parallax Controller
	 * -------------------------------------------------------
	 *
	 * The global controller for setting up window scroll/resize
	 * listeners, managing and caching parallax element positions,
	 * determining which elements are inside the viewport based on
	 * scroll position, and then updating parallax element styles
	 * based on min/max offsets and current scroll position.
	 *
	 */
	function ParallaxController() {
	    // All parallax elements to be updated
	    var elements = [];
	
	    // Tracks current scroll y distance
	    var scrollY = 0;
	
	    // Window inner height
	    var windowHeight = 0;
	
	    // ID to increment for elements
	    var id = 0;
	
	    // Ticking
	    var ticking = false;
	
	    // Scroll direction
	    // let scrollDown = null;
	
	    // Passive support
	    var supportsPassive = (0, _index.testForPassiveScroll)();
	
	    function _addListeners() {
	        window.addEventListener('scroll', _handleScroll, supportsPassive ? { passive: true } : false);
	        window.addEventListener('resize', _handleResize, false);
	    }
	
	    function _removeListeners() {
	        window.removeEventListener('scroll', _handleScroll, supportsPassive ? { passive: true } : false);
	        window.removeEventListener('resize', _handleResize, false);
	    }
	
	    _addListeners();
	
	    /**
	     * Window scroll handler. Sets the 'scrollY'
	     * and then calls '_updateElementPositions()'.
	     */
	    function _handleScroll() {
	        // reference to prev scroll y
	        // const prevScrollY = scrollY;
	
	        // Save current scroll
	        scrollY = window.pageYOffset; // Supports IE 9 and up.
	
	        // direction
	        // scrollDown = scrollY > prevScrollY;
	
	        // Only called if the last animation request has been
	        // completed and there are parallax elements to update
	        if (!ticking && elements.length > 0) {
	            ticking = true;
	            window.requestAnimationFrame(_updateElementPositions);
	        }
	    }
	
	    /**
	     * Window resize handler. Sets the new window inner height
	     * then updates parallax element attributes and positions.
	     */
	    function _handleResize() {
	        _setWindowHeight();
	        _updateElementAttributes();
	        _updateElementPositions();
	    }
	
	    /**
	     * Creates a unique id to distinguish parallax elements.
	     * @return {Number}
	     */
	    function _createID() {
	        ++id;
	        return id;
	    }
	
	    /**
	     * Update element positions.
	     * Determines if the element is in view based on the cached
	     * attributes, if so set the elements parallax styles.
	     */
	    function _updateElementPositions() {
	        elements.forEach(function (element) {
	            if (element.props.disabled) return;
	
	            // check if the element is in view then
	            var isInView = (0, _index.isElementInView)(element, windowHeight, scrollY);
	
	            // set styles if it is
	            if (isInView) _setParallaxStyles(element);
	
	            // reset ticking so more animations can be called
	            ticking = false;
	        });
	    }
	
	    /**
	     * Update element attributes.
	     * Sets up the elements offsets based on the props passed from
	     * the component then caches the elements current position and
	     * other important attributes.
	     */
	    function _updateElementAttributes() {
	        elements.forEach(function (element) {
	            if (element.props.disabled) return;
	
	            _setupOffsets(element);
	
	            _cacheAttributes(element);
	        });
	    }
	
	    /**
	     * Remove parallax styles from all elements.
	     */
	    function _removeParallaxStyles() {
	        elements.forEach(function (element) {
	            _resetStyles(element);
	        });
	    }
	
	    /**
	     * Cache the window height.
	     */
	    function _setWindowHeight() {
	        var html = document.documentElement;
	        windowHeight = window.innerHeight || html.clientHeight;
	    }
	
	    /**
	     * Takes a parallax element and caches important values that
	     * cause layout reflow and paints. Stores the values as an
	     * attribute object accesible on the parallax element.
	     * @param {object} element
	     */
	    function _cacheAttributes(element) {
	        var _element$offsets = element.offsets,
	            yMin = _element$offsets.yMin,
	            yMax = _element$offsets.yMax,
	            xMax = _element$offsets.xMax,
	            xMin = _element$offsets.xMin;
	        var slowerScrollRate = element.props.slowerScrollRate;
	
	        // NOTE: Many of these cause layout and reflow so we're not
	        // calculating them on every frame -- instead these values
	        // are cached on the element to access later when determining
	        // the element's position and offset.
	
	        var el = element.elOuter;
	        var rect = el.getBoundingClientRect();
	        var elHeight = el.offsetHeight;
	        var elWidth = el.offsetWidth;
	        var scrollY = window.pageYOffset;
	
	        // NOTE: offsetYMax and offsetYMin are percents
	        // based of the height of the element. They must be
	        // calculated as px to correctly determine whether
	        // the element is in the viewport.
	        var yPercent = yMax.unit === '%' || yMin.unit === '%';
	        var xPercent = xMax.unit === '%' || xMin.unit === '%';
	
	        // X offsets
	        var yMinPx = yMin.value;
	        var yMaxPx = yMax.value;
	
	        if (yPercent) {
	            var h100 = elHeight / 100;
	            yMaxPx = yMax.value * h100;
	            yMinPx = yMin.value * h100; // negative value
	        }
	
	        // Y offsets
	        var xMinPx = xMax.value;
	        var xMaxPx = xMin.value;
	
	        if (xPercent) {
	            var w100 = elWidth / 100;
	            xMaxPx = xMax.value * w100;
	            xMinPx = xMin.value * w100; // negative value
	        }
	
	        // NOTE: must add the current scroll position when the
	        // element is checked so that we get its absolute position
	        // relative to the document and not the viewport then
	        // add the min/max offsets calculated above.
	        var top = 0;
	        var bottom = 0;
	
	        if (slowerScrollRate) {
	            top = rect.top + scrollY + yMinPx;
	            bottom = rect.bottom + scrollY + yMaxPx;
	        } else {
	            top = rect.top + scrollY + yMaxPx * -1;
	            bottom = rect.bottom + scrollY + yMinPx * -1;
	        }
	
	        // NOTE: Total distance the element will move from when
	        // the top enters the view to the bottom leaving
	        // accounting for elements height and max/min offsets.
	        var totalDist = windowHeight + (elHeight + Math.abs(yMinPx) + yMaxPx);
	
	        element.attributes = {
	            top: top,
	            bottom: bottom,
	            elHeight: elHeight,
	            elWidth: elWidth,
	            yMaxPx: yMaxPx,
	            yMinPx: yMinPx,
	            xMaxPx: xMaxPx,
	            xMinPx: xMinPx,
	            totalDist: totalDist
	        };
	    }
	
	    /**
	     * Takes a parallax element and parses the offset props to get the value
	     * and unit. Sets these values as offset object accessible on the element.
	     * @param {object} element
	     */
	    function _setupOffsets(element) {
	        var _element$props = element.props,
	            offsetYMin = _element$props.offsetYMin,
	            offsetYMax = _element$props.offsetYMax,
	            offsetXMax = _element$props.offsetXMax,
	            offsetXMin = _element$props.offsetXMin;
	
	
	        var yMin = (0, _index.parseValueAndUnit)(offsetYMin);
	        var yMax = (0, _index.parseValueAndUnit)(offsetYMax);
	        var xMin = (0, _index.parseValueAndUnit)(offsetXMax);
	        var xMax = (0, _index.parseValueAndUnit)(offsetXMin);
	
	        if (xMin.unit !== xMax.unit || yMin.unit !== yMax.unit) {
	            throw new Error('Must provide matching units for the min and max offset values of each axis.');
	        }
	
	        var xUnit = xMin.unit || '%';
	        var yUnit = yMin.unit || '%';
	
	        element.offsets = {
	            xUnit: xUnit,
	            yUnit: yUnit,
	            yMin: yMin,
	            yMax: yMax,
	            xMin: xMin,
	            xMax: xMax
	        };
	    }
	
	    /**
	     * Takes a parallax element and set the styles based on the
	     * offsets and percent the element has moved though the viewport.
	     * @param {object} element
	     */
	    function _setParallaxStyles(element) {
	        var top = element.attributes.top - scrollY;
	        var totalDist = element.attributes.totalDist;
	
	        // Percent the element has moved based on current and total distance to move
	
	        var percentMoved = (top * -1 + windowHeight) / totalDist * 100;
	
	        // Scale percentMoved to min/max percent determined by offset props
	        var slowerScrollRate = element.props.slowerScrollRate;
	
	        // Get the parallax X and Y offsets
	
	        var offsets = (0, _index.getParallaxOffsets)(element.offsets, percentMoved, slowerScrollRate);
	
	        // Apply styles
	        var el = element.elInner;
	
	        // prettier-ignore
	        el.style.transform = 'translate3d(' + offsets.x.value + offsets.x.unit + ', ' + offsets.y.value + offsets.y.unit + ', 0)';
	    }
	
	    /**
	     * Takes a parallax element and removes parallax offset styles.
	     * @param {object} element
	     */
	    function _resetStyles(element) {
	        var el = element.elInner;
	        el.style.transform = '';
	    }
	
	    /**
	     * -------------------------------------------------------
	     * Public methods
	     * -------------------------------------------------------
	     */
	
	    /**
	     * Gets the parallax elements in the controller
	     * @return {array} parallax elements
	     */
	    this.getElements = function () {
	        return elements;
	    };
	
	    /**
	     * Creates a new parallax element object with new id
	     * and options to store in the 'elements' array.
	     * @param {object} options
	     * @return {object} element
	     */
	    this.createElement = function (options) {
	        var id = _createID();
	        var newElement = _extends({
	            id: id
	        }, options);
	
	        var updatedElements = [].concat(_toConsumableArray(elements), [newElement]);
	        elements = updatedElements;
	        this.update();
	
	        return newElement;
	    };
	
	    /**
	     * Creates a new parallax element object with new id
	     * and options to store in the 'elements' array.
	     * @param {object} element
	     */
	    this.removeElement = function (element) {
	        var updatedElements = elements.filter(function (el) {
	            return el.id !== element.id;
	        });
	        elements = updatedElements;
	    };
	
	    /**
	     * Updates an existing parallax element object with new options.
	     * @param {object} element
	     * @param {object} options
	     */
	    this.updateElement = function (element, options) {
	        var updatedElements = elements.map(function (el) {
	            // create element with new options and replaces the old
	            if (el.id === element.id) {
	                // update props
	                el.props = options.props;
	            }
	            return el;
	        });
	
	        elements = updatedElements;
	
	        // call update to set attributes and positions based on the new options
	        this.update();
	    };
	
	    /**
	     * Remove element styles.
	     * @param {object} element
	     */
	    this.resetElementStyles = function (element) {
	        _resetStyles(element);
	    };
	
	    /**
	     * Updates all parallax element attributes and postitions.
	     */
	    this.update = function () {
	        _setWindowHeight();
	        _updateElementAttributes();
	        _updateElementPositions();
	    };
	
	    /**
	     * Removes listeners, reset all styles then nullifies the global ParallaxController.
	     */
	    this.destroy = function () {
	        _removeListeners();
	        _removeParallaxStyles();
	        window.ParallaxController = null;
	    };
	}
	
	/**
	 * Static method to instantiate the ParallaxController.
	 * Returns a new or existing instance of the ParallaxController.
	 * @returns {Object} ParallaxController
	 */
	ParallaxController.init = function () {
	    var hasWindow = typeof window !== 'undefined';
	
	    if (!hasWindow) {
	        throw new Error('Looks like ParallaxController.init() was called on the server. This method must be called on the client.');
	    }
	
	    var controller = new ParallaxController();
	
	    // Keep global reference for legacy versions <= 1.1.0
	    if (hasWindow && !window.ParallaxController) {
	        window.ParallaxController = controller;
	    }
	
	    return controller;
	};
	
	exports.default = ParallaxController;
	module.exports = exports['default'];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	
	module.exports = __webpack_require__(100).default;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	
	module.exports = __webpack_require__(103).default;


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var api_1 = __webpack_require__(50);
	var Config_1 = __webpack_require__(27);
	var HaikuBase_1 = __webpack_require__(13);
	var HaikuElement_1 = __webpack_require__(93);
	var HaikuHelpers_1 = __webpack_require__(94);
	var HaikuNode_1 = __webpack_require__(29);
	var HaikuTimeline_1 = __webpack_require__(95);
	var ColorUtils_1 = __webpack_require__(104);
	var consoleErrorOnce_1 = __webpack_require__(108);
	var interactionModes_1 = __webpack_require__(53);
	var isMutableProperty_1 = __webpack_require__(112);
	var KeyframeUtils_1 = __webpack_require__(51);
	var PathUtils_1 = __webpack_require__(105);
	var SVGPoints_1 = __webpack_require__(52);
	var Layout3D_1 = __webpack_require__(14);
	var Migration_1 = __webpack_require__(96);
	var enhance_1 = __webpack_require__(30);
	var functionToRFO_1 = __webpack_require__(31);
	var StateTransitionManager_1 = __webpack_require__(97);
	var Transitions_1 = __webpack_require__(98);
	var assign_1 = __webpack_require__(18);
	var invert_1 = __webpack_require__(145);
	var FUNCTION = 'function';
	var KEYFRAME_ZERO = 0;
	var OBJECT = 'object';
	var MAX_INT = 2147483646;
	var SCOPE_STRATA = { div: 'div', svg: 'svg' };
	var CDN_ROOT_STR = 'HAIKU|CDN|PROJECT|ROOT'.split('|').join('_'); // Split to avoid server-side munging
	// HACK: Required until DOM subtree-hydration race is fixed
	var ALWAYS_UPDATED_PROPERTIES = { 'controlFlow.placeholder': true };
	var parseD = function (value) {
	    // in case of d="" for any reason, don't try to expand this otherwise this will choke
	    // #TODO: arguably we should preprocess SVGs before things get this far; try svgo?
	    if (!value || value.length === 0) {
	        return [];
	    }
	    // Allow points to return an array for convenience, and let downstream marshal it
	    if (Array.isArray(value)) {
	        return value;
	    }
	    return SVGPoints_1.default.pathToPoints(value);
	};
	var generateD = function (value) {
	    if (typeof value === 'string') {
	        return value;
	    }
	    return SVGPoints_1.default.pointsToPath(value);
	};
	var parseColor = function (value) {
	    return ColorUtils_1.default.parseString(value);
	};
	var generateColor = function (value) {
	    return ColorUtils_1.default.generateString(value);
	};
	var parsePoints = function (value) {
	    if (Array.isArray(value)) {
	        return value;
	    }
	    return SVGPoints_1.default.polyPointsStringToPoints(value);
	};
	var generatePoints = function (value) {
	    if (typeof value === 'string') {
	        return value;
	    }
	    return SVGPoints_1.default.pointsToPolyString(value);
	};
	var isFunction = function (value) {
	    return typeof value === FUNCTION;
	};
	var INJECTABLES = {};
	var pkg = __webpack_require__(17);
	exports.VERSION = pkg.version;
	var STRING_TYPE = 'string';
	var OBJECT_TYPE = 'object';
	var HAIKU_ID_ATTRIBUTE = 'haiku-id';
	var DEFAULT_TIMELINE_NAME = 'Default';
	var CSS_QUERY_MAPPING = {
	    name: 'elementName',
	    attributes: 'attributes',
	    children: 'children',
	};
	// tslint:disable:variable-name function-name
	var HaikuComponent = /** @class */ (function (_super) {
	    __extends(HaikuComponent, _super);
	    function HaikuComponent(bytecode, context, host, config, container) {
	        var _this = _super.call(this) || this;
	        _this.parsedValueClusters = {};
	        _this.needsExpand = true;
	        _this.patches = [];
	        if (!bytecode.template) {
	            console.warn('[haiku core] adding missing template object');
	            bytecode.template = { elementName: 'div', attributes: {}, children: [] };
	        }
	        if (!bytecode.timelines) {
	            console.warn('[haiku core] adding missing timelines object');
	            bytecode.timelines = {};
	        }
	        if (!bytecode.timelines[DEFAULT_TIMELINE_NAME]) {
	            console.warn('[haiku core] adding missing default timeline');
	            bytecode.timelines[DEFAULT_TIMELINE_NAME] = {};
	        }
	        if (!context) {
	            throw new Error('Component requires a context');
	        }
	        if (!config) {
	            throw new Error('Config options required');
	        }
	        if (!config.seed) {
	            throw new Error('Seed value must be provided');
	        }
	        _this.PLAYER_VERSION = exports.VERSION; // #LEGACY
	        _this.CORE_VERSION = exports.VERSION;
	        _this.context = context;
	        _this.container = container;
	        _this.host = host;
	        _this.guests = {};
	        _this.bytecode = (config.hotEditingMode)
	            ? bytecode
	            : exports.clone(bytecode, _this); // Important because migrations mutate the bytecode
	        assertTemplate(_this.bytecode.template);
	        // Allow users to expose methods that can be called in event handlers
	        if (_this.bytecode.methods) {
	            for (var methodNameGiven in _this.bytecode.methods) {
	                if (!_this[methodNameGiven]) {
	                    _this[methodNameGiven] = _this.bytecode.methods[methodNameGiven].bind(_this);
	                }
	            }
	        }
	        _this._states = {}; // Storage for getter/setter actions in userland logic
	        _this.state = {}; // Public accessor object, e.g. this.state.foo = 1
	        // Instantiate StateTransitions. Responsible to store and execute any state transition.
	        _this.stateTransitionManager = new StateTransitionManager_1.default(_this);
	        _this.hooks = {};
	        _this.helpers = Object.assign({}, _this.bytecode.helpers, {
	            data: {},
	        });
	        // `assignConfig` calls bindStates because our incoming config, which
	        // could occur at any point during runtime, e.g. in React, may need to update internal states, etc.
	        // It also may populate hooks and helpers if passed in via configuration.
	        _this.assignConfig(config);
	        // Flag used internally to determine whether we need to re-render the full tree or can survive by just patching
	        _this.doesNeedFullFlush = false;
	        // If true, will continually flush the entire tree until explicitly set to false again
	        _this.doAlwaysFlush = false;
	        // If true, the component will assign 3D-preservation setting if one hasn't been set explicitly.
	        // If config.preserve3d is 'auto', the migration pre-phase will try to detect whether 3d is needed.
	        _this.doPreserve3d = (_this.config.preserve3d === true) ? true : false;
	        // Dictionary of event handler names to handler functions; used to efficiently manage multiple subscriptions
	        _this.registeredEventHandlers = {};
	        // The last HaikuElement in this scope to be hovered; used to help manage hover/unhover
	        _this.lastHoveredElement = null;
	        // Flag to determine whether this component should continue doing any work
	        _this.isDeactivated = false;
	        // Flag to indicate whether we are sleeping, an ephemeral condition where no rendering occurs
	        _this.isSleeping = false;
	        _this.helpers = {
	            data: {},
	        };
	        var helpers = Object.assign({}, HaikuHelpers_1.default.helpers, _this.getHelpers());
	        for (var helperName in helpers) {
	            _this.helpers[helperName] = helpers[helperName];
	        }
	        _this.helpers.now = function () {
	            if (_this.isLiveMode()) {
	                return (_this.config.timestamp || 1) + (_this.helpers.data.lastTimelineTime || 1);
	            }
	            return 1;
	        };
	        _this.helpers.rand = function () {
	            if (_this.isLiveMode()) {
	                var scopeKey = [
	                    _this.helpers.data.lastTimelineName,
	                    _this.helpers.data.lastTimelineTime,
	                    _this.helpers.data.lastPropertyName,
	                    _this.helpers.data.lastFlexId,
	                ].join('|');
	                var randKey = _this.config.seed + "@" + scopeKey;
	                var keyInt = stringToInt(randKey);
	                var outFloat = ((keyInt + 1) % MAX_INT) / MAX_INT;
	                return outFloat;
	            }
	            return 1;
	        };
	        _this.helpers.find = function (selector) {
	            return _this.querySelectorAll(selector);
	        };
	        var migrationOptions = {
	            attrsHyphToCamel: exports.ATTRS_HYPH_TO_CAMEL,
	            // During editing, we handle mutations directly in the app.
	            mutations: config.hotEditingMode ? undefined : {
	                // Random seed for adding instance uniqueness to ids at runtime.
	                referenceUniqueness: (config.hotEditingMode)
	                    ? undefined // During editing, Haiku.app pads ids unless this is undefined
	                    : Math.random().toString(36).slice(2),
	                haikuRoot: _this.getProjectRootPathWithTerminatingSlash(),
	            },
	        };
	        try {
	            Migration_1.runMigrationsPrePhase(_this, migrationOptions);
	        }
	        catch (exception) {
	            console.warn('[haiku core] caught error during migration pre-phase', exception);
	        }
	        // Ensure full tree is are properly set up and all render nodes are connected to their models
	        _this.render(__assign({}, _this.config));
	        try {
	            // If the bytecode we got happens to be in an outdated format, we automatically update it to the latest.
	            Migration_1.runMigrationsPostPhase(_this, migrationOptions, exports.VERSION);
	        }
	        catch (exception) {
	            console.warn('[haiku core] caught error during migration post-phase', exception);
	        }
	        _this.hydrateMutableTimelines();
	        if (!_this.host) {
	            _this.routeEventToHandlerAndEmit(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:did-initialize', [_this]);
	        }
	        else {
	            _this.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:did-initialize', [_this]);
	        }
	        // #FIXME: some handlers may still reference `_bytecode` directly.
	        _this._bytecode = _this.bytecode;
	        return _this;
	    }
	    /**
	     * @description Track elements that are at the horizon of what we want to render, i.e., a list of
	     * virtual elements that we don't want to make any updates lower than in the tree.
	     */
	    HaikuComponent.prototype.markHorizonElement = function (virtualElement) {
	        if (virtualElement && virtualElement.attributes) {
	            virtualElement.__horizon = true;
	        }
	    };
	    /**
	     * @description Returns true/false whether this element is one that we don't want to make any
	     *  updates further down its tree.
	     */
	    HaikuComponent.prototype.isHorizonElement = function (virtualElement) {
	        if (virtualElement && virtualElement.attributes) {
	            return virtualElement.__horizon;
	        }
	        return false;
	    };
	    HaikuComponent.prototype.isLiveMode = function () {
	        return interactionModes_1.isLiveMode(this.config.interactionMode);
	    };
	    HaikuComponent.prototype.isEditMode = function () {
	        return !this.isLiveMode();
	    };
	    HaikuComponent.prototype.registerGuest = function (subcomponent) {
	        this.guests[subcomponent.getId()] = subcomponent;
	    };
	    HaikuComponent.prototype.visitGuestHierarchy = function (visitor) {
	        visitor(this, this.$id, this.host);
	        for (var $id in this.guests) {
	            this.guests[$id].visitGuestHierarchy(visitor);
	        }
	    };
	    HaikuComponent.prototype.visitGuests = function (visitor) {
	        for (var $id in this.guests) {
	            visitor(this.guests[$id], $id);
	        }
	    };
	    // If the component needs to remount itself for some reason, make sure we fire the right events
	    HaikuComponent.prototype.callRemount = function (incomingConfig, skipMarkForFullFlush) {
	        var _this = this;
	        if (skipMarkForFullFlush === void 0) { skipMarkForFullFlush = false; }
	        this.visitGuestHierarchy(function (guest) {
	            if (guest === _this) {
	                guest.routeEventToHandlerAndEmit(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:will-mount', [guest]);
	            }
	            else {
	                guest.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:will-mount', [guest]);
	            }
	        });
	        // Note!: Only update config if we actually got incoming options!
	        if (incomingConfig) {
	            this.assignConfig(incomingConfig);
	        }
	        if (!skipMarkForFullFlush) {
	            this.markForFullFlush();
	            this.clearCaches(null);
	        }
	        // If autoplay is not wanted, stop the all timelines immediately after we've mounted
	        // (We have to mount first so that the component displays, but then pause it at that state.)
	        // If you don't want the component to show up at all, use options.automount=false.
	        var timelineInstances = this.getTimelines();
	        for (var timelineName in timelineInstances) {
	            var timelineInstance = timelineInstances[timelineName];
	            if (this.config.autoplay) {
	                if (timelineName === DEFAULT_TIMELINE_NAME) {
	                    // Assume we want to start the timeline from the beginning upon remount.
	                    // NOTE:
	                    // timeline.play() will normally trigger markForFullFlush because it assumes we need to render
	                    // from the get-go. However, in case of a callRemount, we might not want to do that since it can be kind of
	                    // like running the first frame twice. So we pass the option into play so it can conditionally skip the
	                    // markForFullFlush step.
	                    if (!timelineInstance.isPaused()) {
	                        timelineInstance.play({ skipMarkForFullFlush: skipMarkForFullFlush });
	                    }
	                }
	            }
	            else {
	                timelineInstance.pause();
	            }
	        }
	        this.context.contextMount();
	        this.visitGuestHierarchy(function (guest) {
	            if (guest === _this) {
	                guest.routeEventToHandlerAndEmit(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:did-mount', [guest]);
	            }
	            else {
	                guest.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:did-mount', [guest]);
	            }
	        });
	    };
	    HaikuComponent.prototype.destroy = function () {
	        var _this = this;
	        _super.prototype.destroy.call(this);
	        // Destroy all timelines we host.
	        var timelineInstances = this.getTimelines();
	        for (var timelineName in timelineInstances) {
	            var timelineInstance = timelineInstances[timelineName];
	            timelineInstance.destroy();
	        }
	        this.visitGuestHierarchy(function (component) {
	            // Clean up HaikuComponent dependents.
	            // TODO: is this step necessary?
	            if (component !== _this) {
	                component.destroy();
	            }
	        });
	        this.visitDescendants(function (child) {
	            // Clean up HaikuElement dependents.
	            child.destroy();
	        });
	    };
	    HaikuComponent.prototype.callUnmount = function () {
	        var _this = this;
	        // Since we're unmounting, pause all animations to avoid unnecessary calc while detached
	        var timelineInstances = this.getTimelines();
	        for (var timelineName in timelineInstances) {
	            var timelineInstance = timelineInstances[timelineName];
	            timelineInstance.pause();
	        }
	        this.context.contextUnmount();
	        this.visitGuestHierarchy(function (guest) {
	            if (guest === _this) {
	                guest.routeEventToHandlerAndEmit(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:will-unmount', [guest]);
	            }
	            else {
	                guest.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:will-unmount', [guest]);
	            }
	        });
	    };
	    HaikuComponent.prototype.assignConfig = function (incomingConfig) {
	        this.config = Config_1.default.build(this.config || {}, incomingConfig || {});
	        // Don't assign the context config if we're a guest component;
	        // assume only the top-level component should have this power
	        if (this.host) {
	            // Don't forget to update the configuration values shared by the context,
	            // but skip component assignment so we don't end up in an infinite loop
	            this.context.assignConfig(this.config, { skipComponentAssign: true });
	        }
	        var timelines = this.getTimelines();
	        for (var name_1 in timelines) {
	            var timeline = timelines[name_1];
	            timeline.assignOptions(this.config);
	        }
	        this.bindStates();
	        assign_1.default(this.hooks, this.config.hooks);
	        assign_1.default(this.helpers, this.config.helpers);
	        assign_1.default(this.bytecode.timelines, this.config.timelines);
	        return this;
	    };
	    HaikuComponent.prototype.set = function (key, value) {
	        this.callHook('state:change', { state: key, from: this.state[key], to: value });
	        this.state[key] = value;
	        return this;
	    };
	    HaikuComponent.prototype.get = function (key) {
	        return this.state[key];
	    };
	    HaikuComponent.prototype.setState = function (states, transitionParameter) {
	        // Do not set any state if invalid
	        if (!states || typeof states !== 'object') {
	            return this;
	        }
	        // Set states is delegated to stateTransitionManager
	        this.stateTransitionManager.setState(states, transitionParameter);
	        return this;
	    };
	    HaikuComponent.prototype.getStates = function () {
	        return this.state;
	    };
	    HaikuComponent.prototype.clearCaches = function (options) {
	        if (options === void 0) { options = {}; }
	        // HaikuBase implements a general-purpose caching mechanism which we also call here
	        this.cacheClear();
	        this.needsExpand = true;
	        // Don't forget to repopulate the states with originals when we clear cache
	        if (options.clearStates) {
	            this.clearStates();
	        }
	        this.hydrateMutableTimelines();
	        this.parsedValueClusters = {};
	        // Our managed timeline instances may have their own privately cached properties
	        var timelines = this.fetchTimelines();
	        for (var timelineName in timelines) {
	            timelines[timelineName].cacheClear();
	        }
	    };
	    HaikuComponent.prototype.cacheNodeWithSelectorKey = function (node) {
	        if (!node || typeof node !== 'object') {
	            return;
	        }
	        if (node.attributes && node.attributes[HAIKU_ID_ATTRIBUTE]) {
	            var selector = "haiku:" + node.attributes[HAIKU_ID_ATTRIBUTE];
	            var key = this.nodesCacheKey(selector);
	            var collection = this.cacheGet(key) || [];
	            if (collection.indexOf(node) === -1) {
	                collection.push(node);
	            }
	            this.cacheSet(key, collection);
	        }
	    };
	    HaikuComponent.prototype.clearStates = function () {
	        this._states = {};
	        this.bindStates();
	    };
	    HaikuComponent.prototype.getClock = function () {
	        return this.context.clock;
	    };
	    HaikuComponent.prototype.getTemplate = function () {
	        return this.bytecode.template;
	    };
	    HaikuComponent.prototype.getHelpers = function () {
	        return this.bytecode.helpers;
	    };
	    HaikuComponent.prototype.getTimelines = function () {
	        var _this = this;
	        return this.cacheFetch('getTimelines', function () {
	            return _this.fetchTimelines();
	        });
	    };
	    HaikuComponent.prototype.fetchTimelines = function () {
	        var names = Object.keys(this.bytecode.timelines);
	        for (var i = 0; i < names.length; i++) {
	            var name_2 = names[i];
	            if (!name_2) {
	                continue;
	            }
	            var existing = HaikuTimeline_1.default.where({
	                name: name_2,
	                component: this,
	            })[0];
	            if (!existing) {
	                HaikuTimeline_1.default.create(this, name_2, this.config);
	            }
	        }
	        var out = {};
	        var timelines = HaikuTimeline_1.default.where({ component: this });
	        for (var j = 0; j < timelines.length; j++) {
	            var timeline = timelines[j];
	            out[timeline.getName()] = timeline;
	        }
	        return out;
	    };
	    HaikuComponent.prototype.getTimeline = function (name) {
	        return this.getTimelines()[name];
	    };
	    HaikuComponent.prototype.fetchTimeline = function (name, descriptor) {
	        var found = this.getTimeline(name);
	        if (found) {
	            return found;
	        }
	        return HaikuTimeline_1.default.create(this, name, this.config);
	    };
	    HaikuComponent.prototype.getDefaultTimeline = function () {
	        var timelines = this.getTimelines();
	        return timelines[DEFAULT_TIMELINE_NAME];
	    };
	    HaikuComponent.prototype.stopAllTimelines = function () {
	        var timelines = this.getTimelines();
	        for (var name_3 in timelines) {
	            this.stopTimeline(name_3);
	        }
	    };
	    HaikuComponent.prototype.startAllTimelines = function () {
	        var timelines = this.getTimelines();
	        for (var name_4 in timelines) {
	            this.startTimeline(name_4);
	        }
	    };
	    HaikuComponent.prototype.startTimeline = function (timelineName) {
	        var descriptor = this.getTimelineDescriptor(timelineName);
	        var existing = this.fetchTimeline(timelineName, descriptor);
	        if (existing) {
	            existing.start();
	        }
	    };
	    HaikuComponent.prototype.stopTimeline = function (timelineName) {
	        var descriptor = this.getTimelineDescriptor(timelineName);
	        var existing = this.fetchTimeline(timelineName, descriptor);
	        if (existing) {
	            existing.stop();
	        }
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#gotoAndPlay
	     */
	    HaikuComponent.prototype.gotoAndPlay = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        this.getDefaultTimeline().gotoAndPlay(amount, unit);
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#gotoAndStop
	     */
	    HaikuComponent.prototype.gotoAndStop = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        this.getDefaultTimeline().gotoAndStop(amount, unit);
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#pause
	     */
	    HaikuComponent.prototype.pause = function () {
	        this.getDefaultTimeline().pause();
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#stop
	     */
	    HaikuComponent.prototype.stop = function () {
	        this.getDefaultTimeline().stop();
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#seek
	     */
	    HaikuComponent.prototype.seek = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        this.getDefaultTimeline().seek(amount, unit);
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#start
	     */
	    HaikuComponent.prototype.start = function () {
	        this.getDefaultTimeline().start();
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#play
	     */
	    HaikuComponent.prototype.play = function (options) {
	        if (options === void 0) { options = {}; }
	        this.getDefaultTimeline().play();
	    };
	    HaikuComponent.prototype.getTimelineDescriptor = function (timelineName) {
	        return this.bytecode.timelines[timelineName];
	    };
	    HaikuComponent.prototype.getInjectables = function () {
	        var injectables = {};
	        assign_1.default(injectables, this.getSummonablesSchema());
	        // Local states get precedence over global summonables, so assign them last
	        for (var key in this._states) {
	            var type = this._states[key] && this._states[key].type;
	            if (!type) {
	                type = typeof this._states[key];
	            }
	            injectables[key] = type;
	        }
	        return injectables;
	    };
	    /**
	     * @method _deactivate
	     * @description When hot-reloading a component during editing, this can be used to
	     * ensure that this component doesn't keep updating after its replacement is loaded.
	     */
	    HaikuComponent.prototype.deactivate = function () {
	        this.isDeactivated = true;
	    };
	    HaikuComponent.prototype.activate = function () {
	        this.isDeactivated = false;
	    };
	    HaikuComponent.prototype.sleepOn = function () {
	        this.isSleeping = true;
	    };
	    HaikuComponent.prototype.sleepOff = function () {
	        this.isSleeping = false;
	    };
	    /**
	     * @method dump
	     * @description Dump serializable info about this object
	     */
	    HaikuComponent.prototype.dump = function () {
	        var metadata = this.getBytecodeMetadata();
	        return metadata.relpath + ":" + this.getComponentId();
	    };
	    HaikuComponent.prototype.getBytecodeMetadata = function () {
	        return this.bytecode.metadata;
	    };
	    HaikuComponent.prototype.getBytecodeRelpath = function () {
	        var metadata = this.getBytecodeMetadata();
	        return metadata && metadata.relpath;
	    };
	    HaikuComponent.prototype.getBytecodeProject = function () {
	        var metadata = this.getBytecodeMetadata();
	        return metadata && metadata.project;
	    };
	    HaikuComponent.prototype.getBytecodeOrganization = function () {
	        var metadata = this.getBytecodeMetadata();
	        return metadata && metadata.organization;
	    };
	    HaikuComponent.prototype.getAddressableProperties = function (out) {
	        var _this = this;
	        if (out === void 0) { out = {}; }
	        if (!this.bytecode.states) {
	            return out;
	        }
	        var _loop_2 = function (name_5) {
	            var state = this_1.bytecode.states[name_5];
	            out[name_5] = {
	                name: name_5,
	                type: 'state',
	                prefix: name_5,
	                suffix: undefined,
	                fallback: state.value,
	                typedef: state.type,
	                mock: state.mock,
	                target: this_1,
	                value: function () {
	                    return _this.state[name_5]; // The current live value of this state as seen by the app
	                },
	            };
	        };
	        var this_1 = this;
	        for (var name_5 in this.bytecode.states) {
	            _loop_2(name_5);
	        }
	        return out;
	    };
	    HaikuComponent.prototype.bindStates = function () {
	        var allStates = assign_1.default({}, this.bytecode.states, this.config.states);
	        for (var stateSpecName in allStates) {
	            var stateSpec = allStates[stateSpecName];
	            // 'null' is the signal for an empty prop, not undefined.
	            if (!stateSpec || stateSpec.value === undefined) {
	                console.error('Property `' +
	                    stateSpecName +
	                    '` cannot be undefined; use null for empty states');
	                continue;
	            }
	            if (!this._states.hasOwnProperty(stateSpecName) || this.config.states.hasOwnProperty(stateSpecName)) {
	                this._states[stateSpecName] = stateSpec.value;
	                this.defineSettableState(stateSpec, stateSpecName);
	            }
	        }
	    };
	    HaikuComponent.prototype.defineSettableState = function (stateSpec, stateSpecName) {
	        var _this = this;
	        // Note: We define the getter/setter on the object itself, but the storage occurs on the pass-in statesTargetObject
	        Object.defineProperty(this.state, stateSpecName, {
	            configurable: true,
	            enumerable: true,
	            get: function () {
	                return _this._states[stateSpecName];
	            },
	            set: function (inputValue) {
	                if (stateSpec.setter) {
	                    // Important: We call the setter with a binding of the component, so it can access methods on `this`
	                    _this._states[stateSpecName] = stateSpec.setter.call(_this, inputValue);
	                }
	                else {
	                    _this._states[stateSpecName] = inputValue;
	                }
	                if (!_this.isDeactivated) {
	                    _this.emit('state:set', stateSpecName, _this._states[stateSpecName]);
	                }
	                return _this._states[stateSpecName];
	            },
	        });
	    };
	    HaikuComponent.prototype.allEventHandlers = function () {
	        return assign_1.default({}, this.bytecode.eventHandlers, this.config.eventHandlers);
	    };
	    HaikuComponent.prototype.eachEventHandler = function (iteratee) {
	        var eventHandlers = this.allEventHandlers();
	        for (var eventSelector in eventHandlers) {
	            for (var eventName in eventHandlers[eventSelector]) {
	                var descriptor = eventHandlers[eventSelector][eventName];
	                if (!descriptor || !descriptor.handler) {
	                    continue;
	                }
	                iteratee(eventSelector, eventName, descriptor);
	            }
	        }
	    };
	    HaikuComponent.prototype.routeEventToHandler = function (eventSelectorGiven, eventNameGiven, eventArgs) {
	        var _this = this;
	        if (this.isDeactivated) {
	            return;
	        }
	        this.eachEventHandler(function (eventSelector, eventName, _a) {
	            var handler = _a.handler;
	            if (eventNameGiven === eventName) {
	                if (eventSelectorGiven === eventSelector ||
	                    eventSelectorGiven === HaikuBase_1.GLOBAL_LISTENER_KEY) {
	                    _this.callEventHandler(eventSelector, eventName, handler, eventArgs);
	                    return;
	                }
	            }
	        });
	    };
	    HaikuComponent.prototype.setHook = function (hookName, hookFn) {
	        this.hooks[hookName] = hookFn;
	    };
	    HaikuComponent.prototype.callHook = function (hookName) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var _a;
	        if (typeof this.hooks[hookName] === 'function') {
	            (_a = this.hooks)[hookName].apply(_a, args);
	        }
	    };
	    HaikuComponent.prototype.callEventHandler = function (eventsSelector, eventName, handler, eventArgs) {
	        // Only fire the event listeners if the component is in 'live' interaction mode,
	        // i.e., not currently being edited inside the Haiku authoring environment
	        // However, some components rely on specific event hooks firing in Edit mode, too — they can
	        // whitelist their "edit mode" event names through `options`
	        if (!this.isLiveMode() &&
	            !(this.bytecode.options &&
	                this.bytecode.options.editModeEvents &&
	                this.bytecode.options.editModeEvents[eventName])) {
	            return;
	        }
	        this.callHook('action:before', this, eventName, eventsSelector, eventArgs);
	        try {
	            handler.apply(this, [this].concat(eventArgs));
	        }
	        catch (exception) {
	            consoleErrorOnce_1.default(exception);
	        }
	        this.callHook('action:after', this, eventName, eventsSelector, eventArgs);
	    };
	    HaikuComponent.prototype.routeEventToHandlerAndEmit = function (eventSelectorGiven, eventNameGiven, eventArgs) {
	        if (this.isDeactivated) {
	            return;
	        }
	        this.routeEventToHandler(eventSelectorGiven, eventNameGiven, eventArgs);
	        this.emit.apply(this, [eventNameGiven].concat(eventArgs));
	    };
	    HaikuComponent.prototype.routeEventToHandlerAndEmitWithoutBubbling = function (eventSelectorGiven, eventNameGiven, eventArgs) {
	        if (this.isDeactivated) {
	            return;
	        }
	        this.routeEventToHandler(eventSelectorGiven, eventNameGiven, eventArgs);
	        this.emitWithoutBubbling.apply(this, [eventNameGiven].concat(eventArgs));
	    };
	    HaikuComponent.prototype.routeEventToHandlerAndEmitWithoutBubblingAndWithoutGlobalHandlers = function (eventSelectorGiven, eventNameGiven, eventArgs) {
	        if (this.isDeactivated) {
	            return;
	        }
	        this.routeEventToHandler(eventSelectorGiven, eventNameGiven, eventArgs);
	        this.emitToListeners(eventNameGiven, eventArgs);
	        this.emitToGenericListeners(eventNameGiven, eventArgs);
	    };
	    /**
	     * @description A more expressive form of `emit` that allows the user to route
	     * events to specific collections of elements/components in the tree using labels,
	     * selectors, etc. This method is provided in lieu of providing an individual method
	     * for every possible topology.
	     */
	    HaikuComponent.prototype.send = function (route, name) {
	        var _this = this;
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        // Send to parent
	        if (route === 'emit' ||
	            route === 'up' ||
	            route === 'parent' ||
	            route === '<' // Cute: '>' is the opposite of CSS children selector '<'
	        ) {
	            this.emit.apply(this, [name].concat(args));
	            return;
	        }
	        // Send to children
	        if (route === 'down' ||
	            route === 'children' ||
	            route === '>' // CSS children selector
	        ) {
	            this.visitGuests(function (guest) {
	                guest.emitWithoutBubbling.apply(guest, [name].concat(args));
	            });
	            return;
	        }
	        // Send to siblings
	        if (route === 'sideways' ||
	            route === 'siblings' ||
	            route === '~' // CSS sibling selector
	        ) {
	            if (this.host) {
	                this.host.visitGuests(function (guest) {
	                    if (guest !== _this) {
	                        guest.emitWithoutBubbling.apply(guest, [name].concat(args));
	                    }
	                });
	            }
	            return;
	        }
	        // Send to everyone
	        if (route === '*') {
	            this.top.visitGuestHierarchy(function (guest) {
	                if (guest !== _this) {
	                    guest.emitWithoutBubbling.apply(guest, [name].concat(args));
	                }
	            });
	        }
	    };
	    HaikuComponent.prototype.emitToAncestors = function (name) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (this.host) {
	            // 1. Emit to listeners on the "wrapper" div
	            this.host.routeEventToHandler("haiku:" + exports.getNodeCompositeId(this.parentNode), name, [this].concat(args));
	            // 2. For convenience, emit to listeners on the root component of the hosts
	            this.host.routeEventToHandler("haiku:" + exports.getNodeCompositeId(this.host), name, [this].concat(args));
	        }
	    };
	    HaikuComponent.prototype.emitWithoutBubbling = function (key) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        this.routeEventToHandler(HaikuBase_1.GLOBAL_LISTENER_KEY, key, args);
	        this.emitToListeners(key, args);
	        this.emitToGenericListeners(key, args);
	    };
	    HaikuComponent.prototype.markForFullFlush = function () {
	        this.doesNeedFullFlush = true;
	    };
	    HaikuComponent.prototype.unmarkForFullFlush = function () {
	        this.doesNeedFullFlush = false;
	    };
	    HaikuComponent.prototype.shouldPerformFullFlush = function () {
	        return this.doesNeedFullFlush || this.doAlwaysFlush;
	    };
	    HaikuComponent.prototype.expandIfNeeded = function () {
	        if (this.needsExpand) {
	            expandNode(this.bytecode.template, this.container);
	            this.needsExpand = false;
	        }
	    };
	    HaikuComponent.prototype.performFullFlushRenderWithRenderer = function (renderer, options) {
	        if (options === void 0) { options = {}; }
	        this.context.getContainer(true); // Force recalc of container
	        // Since we will produce a full tree, we don't need a further full flush.
	        this.unmarkForFullFlush();
	        this.needsExpand = true;
	        this.render(options);
	        // Untyped code paths downstream depend on the output of this method
	        return renderer.render(this.container, this.bytecode.template, this);
	    };
	    HaikuComponent.prototype.performPatchRenderWithRenderer = function (renderer, options, skipCache) {
	        if (options === void 0) { options = {}; }
	        if (renderer.shouldCreateContainer) {
	            this.context.getContainer(true); // Force recalc of container
	        }
	        var patches = this.patch(options, skipCache);
	        renderer.patch(this, patches);
	        for (var $id in this.guests) {
	            var guest = this.guests[$id];
	            if (guest.shouldPerformFullFlush() && guest.target) {
	                guest.performFullFlushRenderWithRenderer(renderer, options);
	            }
	            else {
	                guest.performPatchRenderWithRenderer(renderer, options, skipCache);
	            }
	        }
	    };
	    HaikuComponent.prototype.render = function (options) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        // We register ourselves with our host here because render is guaranteed to be called
	        // both in our constructor and in the case that we were deactivated/reactivated.
	        // This must run before the isDeactivated check since we may use the registry to activate later.
	        if (this.host) {
	            this.host.registerGuest(this);
	        }
	        if (this.isDeactivated) {
	            // If deactivated, pretend like there is nothing to render
	            return;
	        }
	        this.clearCaches();
	        HaikuElement_1.default.findOrCreateByNode(this.container);
	        if (!this.container.__memory.subcomponent) {
	            // A semantically different thing than .subcomponent/.instance
	            this.container.__memory.containee = this;
	        }
	        hydrateNode(this.bytecode.template, // node
	        this.container, // parent
	        this, // instance (component)
	        this.context, this.host, 'div', // scope (the default is a div)
	        options, true);
	        this.applyLocalBehaviors(false, // isPatchOperation
	        false);
	        if (this.context.renderer.mount) {
	            this.eachEventHandler(function (eventSelector, eventName) {
	                var registrationKey = eventSelector + ":" + eventName;
	                if (_this.registeredEventHandlers[registrationKey]) {
	                    return;
	                }
	                _this.registeredEventHandlers[registrationKey] = true;
	                _this.context.renderer.mountEventListener(_this, eventSelector, eventName, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this.routeEventToHandlerAndEmit(eventSelector, eventName, args);
	                });
	            });
	        }
	        this.applyGlobalBehaviors(options);
	        // But also note we need to call subcomponent renders *after* our own behaviors,
	        // because we need the parent-to-child states to be set prior to this render call,
	        // otherwise the changes they produce won't be available for this render frame.
	        for (var $id in this.guests) {
	            this.guests[$id].render(__assign({}, this.guests[$id].config, Config_1.default.buildChildSafeConfig(options)));
	        }
	        this.expandIfNeeded();
	        return this.bytecode.template;
	    };
	    HaikuComponent.prototype.patch = function (options, skipCache) {
	        if (options === void 0) { options = {}; }
	        if (skipCache === void 0) { skipCache = false; }
	        if (this.isDeactivated) {
	            // If deactivated, pretend like there is nothing to render
	            return {};
	        }
	        this.applyLocalBehaviors(true, // isPatchOperation
	        skipCache);
	        this.applyGlobalBehaviors(options);
	        var patches = {};
	        this.expandIfNeeded();
	        for (var i = 0; i < this.patches.length; i++) {
	            var node = this.patches[i];
	            computeAndApplyLayout(node, node.__memory.parent);
	            patches[exports.getNodeCompositeId(node)] = node;
	        }
	        this.patches = [];
	        return patches;
	    };
	    HaikuComponent.prototype.applyGlobalBehaviors = function (options) {
	        if (options === void 0) { options = {}; }
	        if (!this.host && options.sizing) {
	            var didSizingChange = computeAndApplyPresetSizing(this.bytecode.template, this.container, options.sizing);
	            if (didSizingChange) {
	                this.patches.push(this.bytecode.template);
	            }
	        }
	    };
	    HaikuComponent.prototype.applyLocalBehaviors = function (isPatchOperation, skipCache) {
	        if (skipCache === void 0) { skipCache = false; }
	        var globalClockTime = this.context.clock.getExplicitTime();
	        var manaTree = this.manaTreeCached();
	        for (var timelineName in this.bytecode.timelines) {
	            var timelineInstance = this.getTimeline(timelineName);
	            timelineInstance.executePreUpdateHooks(globalClockTime);
	            var timelineTime = timelineInstance.getTime(); // Bounded time
	            var timelineDescriptor = this.bytecode.timelines[timelineName];
	            var mutableTimelineDescriptor = isPatchOperation
	                ? this.mutableTimelines[timelineName]
	                : timelineDescriptor;
	            if (!mutableTimelineDescriptor) {
	                mutableTimelineDescriptor = {};
	            }
	            for (var behaviorSelector in mutableTimelineDescriptor) {
	                var matchingElementsForBehavior = this.findMatchingNodesByCSSSelector(manaTree, behaviorSelector);
	                if (!matchingElementsForBehavior || matchingElementsForBehavior.length < 1) {
	                    continue;
	                }
	                var propertiesGroup = mutableTimelineDescriptor[behaviorSelector];
	                if (!propertiesGroup) {
	                    continue;
	                }
	                // This is our opportunity to group property operations that need to be in order
	                var propertyOperations = collatePropertyGroup(propertiesGroup);
	                for (var i = 0; i < matchingElementsForBehavior.length; i++) {
	                    var matchingElement = matchingElementsForBehavior[i];
	                    var compositeId = exports.getNodeCompositeId(matchingElement);
	                    for (var j = 0; j < propertyOperations.length; j++) {
	                        var propertyGroup = propertyOperations[j];
	                        for (var propertyName in propertyGroup) {
	                            var keyframeCluster = propertyGroup[propertyName];
	                            var grabbedValue = this.grabValue(timelineName, compositeId, matchingElement, propertyName, keyframeCluster, timelineTime, isPatchOperation, skipCache);
	                            var computedValue = grabbedValue.computedValue, didValueChangeSinceLastRequest = grabbedValue.didValueChangeSinceLastRequest, didValueOriginateFromExplicitKeyframeDefinition = grabbedValue.didValueOriginateFromExplicitKeyframeDefinition;
	                            if (computedValue === undefined) {
	                                continue;
	                            }
	                            // We always apply the property if...
	                            if (
	                            // - This is a full render
	                            !isPatchOperation ||
	                                // - The value in question has changed
	                                didValueChangeSinceLastRequest ||
	                                // - The value is in the whitelist of always-updated properties
	                                ALWAYS_UPDATED_PROPERTIES[propertyName] ||
	                                (
	                                // - The value was explicitly defined as a keyframe and...
	                                didValueOriginateFromExplicitKeyframeDefinition && (
	                                // - We haven't yet reached the end
	                                (timelineTime < timelineInstance.getMaxTime()) ||
	                                    // - The timeline is looping (we won't be hanging on the final keyframe)
	                                    timelineInstance.isLooping() ||
	                                    // - We just reached the final keyframe (but haven't already visited it)
	                                    timelineInstance.getLastFrame() !== timelineInstance.getBoundedFrame()))) {
	                                this.applyPropertyToNode(matchingElement, propertyName, computedValue, timelineInstance);
	                                if (isPatchOperation) {
	                                    this.patches.push(matchingElement);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            timelineInstance.executePostUpdateHooks(globalClockTime);
	        }
	    };
	    HaikuComponent.prototype.getProjectRootPathWithTerminatingSlash = function () {
	        var metadata = this.getBytecodeMetadata();
	        // If root is set and is not precisely this known magic string,
	        // assume the root actually defines a root path somewhere on the web we can resolve to.
	        if (metadata && metadata.root && metadata.root !== CDN_ROOT_STR) {
	            return metadata.root;
	        }
	        // Try to use a locally defined folder (i.e. during editing in Haiku),
	        // or fallback to a local path and hope we resolve to something meaningful.
	        return this.config.folder || (metadata && metadata.folder) || './';
	    };
	    HaikuComponent.prototype.applyPropertyToNode = function (node, name, value, timeline) {
	        var sender = (node.__memory.instance) ? node.__memory.instance : this; // Who sent the command
	        var receiver = node.__memory.subcomponent;
	        var type = (receiver && receiver.tagName) || node.elementName;
	        var addressables = receiver && receiver.getAddressableProperties();
	        var addressee = addressables && addressables[name] !== undefined && receiver;
	        if (addressee) {
	            // Note: Even though we apply the value to addressables of the subcomponent,
	            // we still proceed with application of properties directly to the wrapper.
	            // This is as a convenience, so that if a subcomponent wants to handle any property
	            // applied to its wrapper than it can do so, e.g. sizeAbsolute.x/sizeAbsolute.y.
	            addressee.set(name, value);
	        }
	        var vanity = exports.getVanity(type, name);
	        if (vanity) {
	            return vanity(name, node, value, this.context, timeline, receiver, sender);
	        }
	        var parts = name.split('.');
	        if (parts[0] === 'style' && parts[1]) {
	            return setStyle(parts[1], node, value);
	        }
	        return setAttribute(name, node, value);
	    };
	    HaikuComponent.prototype.findElementsByHaikuId = function (componentId) {
	        return this.findMatchingNodesByCSSSelector(this.manaTreeCached(), "haiku:" + componentId);
	    };
	    HaikuComponent.prototype.nodesCacheKey = function (selector) {
	        return 'nodes:' + selector;
	    };
	    HaikuComponent.prototype.manaTreeCached = function () {
	        var _this = this;
	        return this.cacheFetch('flatManaTree', function () { return HaikuNode_1.manaFlattenTree(_this.bytecode.template, CSS_QUERY_MAPPING); });
	    };
	    HaikuComponent.prototype.findMatchingNodesByCSSSelector = function (manaTree, selector) {
	        var nodes = this.cacheFetch(this.nodesCacheKey(selector), function () { return HaikuNode_1.cssQueryList(manaTree, selector, CSS_QUERY_MAPPING); });
	        var out = [];
	        for (var i = 0; i < nodes.length; i++) {
	            var node = nodes[i];
	            var repeatees = findRespectiveRepeatees(node);
	            // If the node in question is the descendant of a repeater, we need to find all repeated
	            // copies of it inside the host repeater. If any repeatees are returned that means the
	            // element is in fact a repeater, otherwise it is not a repeater, so just use the node.
	            if (repeatees.length > 0) {
	                out.push.apply(out, repeatees);
	            }
	            else {
	                out.push(node);
	            }
	        }
	        return out;
	    };
	    HaikuComponent.prototype.hydrateMutableTimelines = function () {
	        this.mutableTimelines = {};
	        if (this.bytecode.timelines) {
	            for (var timelineName in this.bytecode.timelines) {
	                for (var selector in this.bytecode.timelines[timelineName]) {
	                    for (var propertyName in this.bytecode.timelines[timelineName][selector]) {
	                        if (isMutableProperty_1.default(this.bytecode.timelines[timelineName][selector][propertyName], propertyName)) {
	                            if (!this.mutableTimelines[timelineName]) {
	                                this.mutableTimelines[timelineName] = {};
	                            }
	                            if (!this.mutableTimelines[timelineName][selector]) {
	                                this.mutableTimelines[timelineName][selector] = {};
	                            }
	                            this.mutableTimelines[timelineName][selector][propertyName] =
	                                this.bytecode.timelines[timelineName][selector][propertyName];
	                        }
	                    }
	                }
	            }
	        }
	    };
	    HaikuComponent.prototype.addHotComponent = function (hotComponent) {
	        if (!this.bytecode.timelines ||
	            !this.bytecode.timelines[hotComponent.timelineName] ||
	            !this.bytecode.timelines[hotComponent.timelineName][hotComponent.selector]) {
	            return;
	        }
	        var propertyGroup = this.bytecode.timelines[hotComponent.timelineName][hotComponent.selector];
	        if (!this.mutableTimelines[hotComponent.timelineName]) {
	            this.mutableTimelines[hotComponent.timelineName] = {};
	        }
	        if (!this.mutableTimelines[hotComponent.timelineName][hotComponent.selector]) {
	            this.mutableTimelines[hotComponent.timelineName][hotComponent.selector] = {};
	        }
	        Object.assign(this.mutableTimelines[hotComponent.timelineName][hotComponent.selector], hotComponent.propertyNames.reduce(function (hotProperties, propertyName) { return (hotProperties[propertyName] = propertyGroup[propertyName], hotProperties); }, {}));
	    };
	    HaikuComponent.prototype.controlTime = function (timelineName, timelineTime) {
	        var explicitTime = this.context.clock.getExplicitTime();
	        var timelineInstances = this.getTimelines();
	        for (var localTimelineName in timelineInstances) {
	            if (localTimelineName === timelineName) {
	                var timelineInstance = timelineInstances[timelineName];
	                timelineInstance.controlTime(timelineTime, explicitTime);
	            }
	        }
	        for (var $id in this.guests) {
	            this.guests[$id].controlTime(timelineName, 0);
	        }
	    };
	    HaikuComponent.prototype.getPropertiesGroup = function (timelineName, flexId) {
	        return (this.bytecode &&
	            this.bytecode.timelines &&
	            this.bytecode.timelines[timelineName] &&
	            this.bytecode.timelines[timelineName]["haiku:" + flexId]);
	    };
	    /**
	     * Execute state transitions.
	     */
	    HaikuComponent.prototype.tickStateTransitions = function () {
	        this.stateTransitionManager.tickStateTransitions();
	    };
	    /**
	     * Reset states to initial values by using State Transitions. Default to linear
	     */
	    HaikuComponent.prototype.resetStatesToInitialValuesWithTransition = function (duration, curve) {
	        if (curve === void 0) { curve = api_1.Curve.Linear; }
	        // Build initial states
	        var initialStates = assign_1.default({}, this.bytecode.states, this.config.states);
	        for (var key in initialStates) {
	            initialStates[key] = initialStates[key].value;
	        }
	        // Create state transition to initial state values
	        this.stateTransitionManager.setState(initialStates, { curve: curve, duration: duration });
	    };
	    Object.defineProperty(HaikuComponent.prototype, "top", {
	        /**
	         * @description Get the topmost component in the hierarchy.
	         */
	        get: function () {
	            if (this.host) {
	                return this.host.top;
	            }
	            return this;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuComponent.prototype.getRootComponent = function () {
	        if (this.host) {
	            return this.host.getRootComponent();
	        }
	        return this;
	    };
	    HaikuComponent.prototype.emitFromRootComponent = function (eventName, attachedObject) {
	        this.getRootComponent().emit(eventName, __assign({}, attachedObject, { componentTitle: this.title }));
	    };
	    HaikuComponent.prototype.evaluate = function (expr) {
	        // Make all injectables available within the scope of the function we'll create below,
	        // so users can freely evaluate an expression like this.evaluate('$user.mouse.x');
	        try {
	            // tslint:disable-next-line:no-function-constructor-with-string-args
	            var fn = new Function('$children', '$clock', '$component', '$container', '$context', '$core', '$element', '$host', '$if', '$index', '$mount', '$parent', '$payload', '$placeholder', '$repeat', '$state', '$timeline', '$top', '$tree', '$user', '$window', "return " + expr + ";\n");
	            return fn(this.summon('$children'), this.summon('$clock'), this.summon('$component'), this.summon('$container'), this.summon('$context'), this.summon('$core'), this.summon('$element'), this.summon('$host'), this.summon('$if'), this.summon('$index'), this.summon('$mount'), this.summon('$parent'), this.summon('$payload'), this.summon('$placeholder'), this.summon('$repeat'), this.summon('$state'), this.summon('$timeline'), this.summon('$top'), this.summon('$tree'), this.summon('$user'), this.summon('$window'));
	        }
	        catch (exception) {
	            console.warn("[haiku core] could not evaluate " + expr, exception);
	        }
	    };
	    HaikuComponent.prototype.summon = function (injectable) {
	        if (INJECTABLES[injectable] && INJECTABLES[injectable].summon) {
	            var out = {};
	            INJECTABLES[injectable].summon(out, // injectees
	            this, // component
	            this.bytecode.template, // node
	            DEFAULT_TIMELINE_NAME);
	            return out[injectable];
	        }
	    };
	    HaikuComponent.prototype.evaluateExpression = function (fn, timelineName, flexId, matchingElement, propertyName, keyframeMs, keyframeCluster) {
	        enhance_1.default(fn, null);
	        // We'll store the result of this evaluation in this variable
	        // (so we can cache it in case unexpected subsequent calls)
	        var evaluation;
	        if (fn.specification === true) {
	            // This function is of an unknown kind, so just evaluate it normally without magic dependency injection
	            evaluation = safeCall(fn, this, this._states);
	        }
	        else if (!Array.isArray(fn.specification.params)) {
	            // If for some reason we got a non-array params, just evaluate
	            evaluation = safeCall(fn, this, this._states);
	        }
	        else if (fn.specification.params.length < 1) {
	            // If for some reason we got 0 params, just evaluate it
	            evaluation = safeCall(fn, this, this._states);
	        }
	        else {
	            if (fn.specification.params.length < 1) {
	                // If the summon isn't in the destructured object format, just evaluate it
	                evaluation = safeCall(fn, this, this._states);
	            }
	            else {
	                var summoneesArray = this.summonSummonables(fn.specification.params, timelineName, flexId, matchingElement, propertyName, keyframeMs, keyframeCluster);
	                var previousSummoneesArray = this.getPreviousSummonees(timelineName, flexId, propertyName, keyframeMs);
	                if (areSummoneesDifferent(previousSummoneesArray, summoneesArray)) {
	                    this.cacheSummonees(timelineName, flexId, propertyName, keyframeMs, summoneesArray);
	                    evaluation = safeApply(fn, this, summoneesArray);
	                }
	                else {
	                    // Since nothing is different, return the previous evaluation
	                    evaluation = this.getPreviousEvaluation(timelineName, flexId, propertyName, keyframeMs);
	                }
	            }
	        }
	        // If the output is literally `NaN`, that is almost certainly useless and not what the user
	        // intended. This can happen commonly when editing in Haiku.app and creating dynamic behavior
	        // based on state payloads whose fields may be missing, especially with controlFlow.repeat.
	        if (Number.isNaN(evaluation)) {
	            evaluation = 1;
	        }
	        // Same for Infinity; as it's more likely than not that this is a mistake
	        if (typeof evaluation === 'number' && !isFinite(evaluation)) {
	            evaluation = 1;
	        }
	        // Store the result so we can return it on the next run without re-eval
	        if (fn.specification && fn.specification !== true) {
	            this.cacheEvaluation(timelineName, flexId, propertyName, keyframeMs, evaluation);
	        }
	        return evaluation;
	    };
	    HaikuComponent.prototype.summonSummonables = function (paramsArray, timelineName, flexId, matchingElement, propertyName, keyframeMs, keyframeCluster) {
	        var summonablesArray = [];
	        // Temporary storage, just creating one object here to avoid excessive allocations
	        var summonStorage = {};
	        for (var i = 0; i < paramsArray.length; i++) {
	            var summonsEntry = paramsArray[i];
	            // We'll store the output of the summons in this var, whether we're dealing with
	            // a complex nested summonable or a flat one
	            var summonsOutput = void 0;
	            // In case of a string, we will treat it as the key for the object to summon
	            if (typeof summonsEntry === 'string') {
	                // Treat the entry as the key to a known injectable
	                if (INJECTABLES[summonsEntry]) {
	                    summonStorage[summonsEntry] = undefined; // Clear out the old value before populating with the new one
	                    INJECTABLES[summonsEntry].summon(summonStorage, this, matchingElement, timelineName);
	                    summonsOutput = summonStorage[summonsEntry];
	                }
	                else {
	                    summonsOutput = this.state[summonsEntry];
	                }
	            }
	            // Whatever the request format was, populate the result in here
	            if (summonsOutput !== undefined) {
	                summonablesArray[i] = summonsOutput;
	            }
	        }
	        return summonablesArray;
	    };
	    HaikuComponent.prototype.fetchParsedValueCluster = function (timelineName, flexId, matchingElement, outputName, cluster, isPatchOperation, skipCache) {
	        var parseeWithKeys = this.getParseeWithKeys(timelineName, flexId, outputName, cluster);
	        if (!cluster) {
	            return parseeWithKeys;
	        }
	        var skipStableParsees = isPatchOperation && !skipCache;
	        if (skipStableParsees && this.clusterParseeIsStable(parseeWithKeys)) {
	            return parseeWithKeys;
	        }
	        for (var i = 0; i < parseeWithKeys.keys.length; i++) {
	            var ms = parseeWithKeys.keys[i];
	            var descriptor = cluster[ms];
	            if ((skipStableParsees && parseeWithKeys.parsee[ms] && !parseeWithKeys.parsee[ms].expression) ||
	                descriptor === undefined) {
	                continue;
	            }
	            if (isFunction(descriptor.value)) {
	                parseeWithKeys.parsee[ms] = {
	                    expression: true,
	                    value: this.evaluateExpression(descriptor.value, timelineName, flexId, matchingElement, outputName, ms, cluster),
	                };
	            }
	            else {
	                parseeWithKeys.parsee[ms] = {
	                    expression: false,
	                    value: descriptor.value,
	                };
	            }
	            if (descriptor.curve) {
	                parseeWithKeys.parsee[ms].curve = descriptor.curve;
	            }
	        }
	        if (parseeWithKeys.keys.length > 1) {
	            var parser = this.getParser(outputName);
	            if (!parser &&
	                // tslint:disable-next-line:triple-equals
	                parseFloat(parseeWithKeys.parsee[parseeWithKeys.keys[0]].value) ==
	                    parseeWithKeys.parsee[parseeWithKeys.keys[0]].value) {
	                parser = parseFloat;
	            }
	            if (!parser) {
	                return parseeWithKeys;
	            }
	            for (var j = 0; j < parseeWithKeys.keys.length; j++) {
	                var ms2 = parseeWithKeys.keys[j];
	                parseeWithKeys.parsee[ms2].value = parser(parseeWithKeys.parsee[ms2].value);
	            }
	            if (outputName === 'd') {
	                PathUtils_1.synchronizePathStructure.apply(void 0, parseeWithKeys.keys.map(function (ms) { return parseeWithKeys.parsee[ms].value; }));
	            }
	        }
	        return parseeWithKeys;
	    };
	    HaikuComponent.prototype.generateFinalValueFromParsedValue = function (timelineName, flexId, matchingElement, outputName, computedValue) {
	        if (computedValue === undefined) {
	            return;
	        }
	        var generator = this.getGenerator(outputName);
	        if (generator) {
	            return generator(computedValue);
	        }
	        return computedValue;
	    };
	    HaikuComponent.prototype.grabValue = function (timelineName, flexId, matchingElement, propertyName, keyframeCluster, timelineTime, isPatchOperation, skipCache) {
	        // Used by $helpers to calculate scope-specific values;
	        this.helpers.data = {
	            lastTimelineName: timelineName,
	            lastFlexId: flexId,
	            lastPropertyName: propertyName,
	            lastTimelineTime: timelineTime,
	        };
	        var parsedValueCluster = this.fetchParsedValueCluster(timelineName, flexId, matchingElement, propertyName, keyframeCluster, isPatchOperation, skipCache);
	        // If there is no property of that name, we would have gotten nothing back, so we can't forward this to Transitions
	        // since it expects to receive a populated cluster object
	        if (!parsedValueCluster) {
	            return {
	                computedValue: undefined,
	                didValueChangeSinceLastRequest: false,
	                didValueOriginateFromExplicitKeyframeDefinition: false,
	            };
	        }
	        var computedValueForTime;
	        if (!parsedValueCluster.parsee[KEYFRAME_ZERO]) {
	            parsedValueCluster.parsee[KEYFRAME_ZERO] = {
	                value: exports.getFallback(matchingElement && matchingElement.elementName, propertyName),
	            };
	        }
	        computedValueForTime = Transitions_1.calculateValue(parsedValueCluster.parsee, timelineTime, parsedValueCluster.keys);
	        // When expressions and other dynamic functionality is in play, data may be missing resulting in
	        // properties lacking defined values; in this case we try to do the right thing and fallback
	        // to a known usable value for the field. Especially needed with controlFlow.repeat.
	        if (computedValueForTime === undefined) {
	            computedValueForTime = exports.getFallback(matchingElement && matchingElement.elementName, propertyName);
	        }
	        var computedValue = this.generateFinalValueFromParsedValue(timelineName, flexId, matchingElement, propertyName, computedValueForTime);
	        var previousValue = this.cacheGet("values:" + timelineName + "|" + flexId + "|" + propertyName);
	        this.cacheSet("values:" + timelineName + "|" + flexId + "|" + propertyName, computedValue);
	        var didValueChangeSinceLastRequest = computedValue !== previousValue;
	        return {
	            computedValue: computedValue,
	            didValueChangeSinceLastRequest: didValueChangeSinceLastRequest,
	            didValueOriginateFromExplicitKeyframeDefinition: keyframeCluster && !!keyframeCluster[Math.round(timelineTime)],
	        };
	    };
	    HaikuComponent.prototype.getPreviousSummonees = function (timelineName, flexId, propertyName, keyframeMs) {
	        return this.cacheGet("summonees:" + timelineName + "|" + flexId + "|" + propertyName + "|" + keyframeMs);
	    };
	    HaikuComponent.prototype.cacheSummonees = function (timelineName, flexId, propertyName, keyframeMs, summonees) {
	        this.cacheSet("summonees:" + timelineName + "|" + flexId + "|" + propertyName + "|" + keyframeMs, summonees);
	        return summonees;
	    };
	    HaikuComponent.prototype.getPreviousEvaluation = function (timelineName, flexId, propertyName, keyframeMs) {
	        return this.cacheGet("evaluation:" + timelineName + "|" + flexId + "|" + propertyName + "|" + keyframeMs);
	    };
	    HaikuComponent.prototype.cacheEvaluation = function (timelineName, flexId, propertyName, keyframeMs, evaluation) {
	        this.cacheSet("evaluation:" + timelineName + "|" + flexId + "|" + propertyName + "|" + keyframeMs, evaluation);
	        return evaluation;
	    };
	    HaikuComponent.prototype.getParseeWithKeys = function (timelineName, flexId, outputName, cluster) {
	        if (!this.parsedValueClusters[timelineName]) {
	            this.parsedValueClusters[timelineName] = {};
	        }
	        if (!this.parsedValueClusters[timelineName][flexId]) {
	            this.parsedValueClusters[timelineName][flexId] = {};
	        }
	        if (!this.parsedValueClusters[timelineName][flexId][outputName]) {
	            this.parsedValueClusters[timelineName][flexId][outputName] = {
	                // The parsee object is mutated in place downstream
	                parsee: {},
	                keys: cluster ? KeyframeUtils_1.getSortedKeyframes(cluster) : [],
	            };
	        }
	        return this.parsedValueClusters[timelineName][flexId][outputName];
	    };
	    HaikuComponent.prototype.clusterParseeIsStable = function (parsedValueCluster) {
	        return parsedValueCluster.keys.every(function (ms) { return parsedValueCluster.parsee[ms] && !parsedValueCluster.parsee[ms].expression; });
	    };
	    HaikuComponent.prototype.didChangeValue = function (timelineName, flexId, matchingElement, outputName, outputValue) {
	        var answer = false;
	        var change = this.cacheGet("changes:" + timelineName + "|" + flexId + "|" + outputName);
	        if (change === undefined || change !== outputValue) {
	            this.cacheSet("changes:" + timelineName + "|" + flexId + "|" + outputName, outputValue);
	            answer = true;
	        }
	        return answer;
	    };
	    HaikuComponent.prototype.getSummonablesSchema = function () {
	        var summonablesSchema = {};
	        for (var key in INJECTABLES) {
	            summonablesSchema[key] = INJECTABLES[key].schema;
	        }
	        return summonablesSchema;
	    };
	    HaikuComponent.prototype.transformContextPointToLocalPoint = function (point) {
	        if (this.layoutAncestryMatrices) {
	            var matrix = Layout3D_1.default.multiplyArrayOfMatrices(this.layoutAncestryMatrices.reverse());
	            var inverse = invert_1.default([], matrix);
	            if (inverse !== null) {
	                HaikuElement_1.default.transformPointInPlace(point, inverse);
	            }
	        }
	        return point;
	    };
	    HaikuComponent.prototype.getParser = function (outputName) {
	        var foundParser = HaikuComponent.PARSERS[outputName];
	        return foundParser && foundParser.parse;
	    };
	    HaikuComponent.prototype.getGenerator = function (outputName) {
	        var foundGenerator = HaikuComponent.PARSERS[outputName];
	        return foundGenerator && foundGenerator.generate;
	    };
	    HaikuComponent.__name__ = 'HaikuComponent';
	    HaikuComponent.PLAYER_VERSION = exports.VERSION; // #LEGACY
	    HaikuComponent.CORE_VERSION = exports.VERSION;
	    HaikuComponent.INJECTABLES = INJECTABLES;
	    // When editing a component, any of these appearing inside an expression will trigger a warning.
	    // This is kept in the core so it's easier to compare these to the built-in injectables and
	    // other special treatment for JavaScript globals. "single source of truth" etc.
	    HaikuComponent.FORBIDDEN_EXPRESSION_TOKENS = {
	        // Keywords
	        new: true,
	        this: true,
	        with: true,
	        delete: true,
	        export: true,
	        extends: true,
	        super: true,
	        class: true,
	        abstract: true,
	        interface: true,
	        static: true,
	        label: true,
	        goto: true,
	        private: true,
	        import: true,
	        public: true,
	        // Future keywords
	        do: true,
	        native: true,
	        package: true,
	        transient: true,
	        implements: true,
	        protected: true,
	        throws: true,
	        synchronized: true,
	        final: true,
	        // Common globals
	        window: true,
	        document: true,
	        global: true,
	        // Danger
	        eval: true,
	        uneval: true,
	        Function: true,
	        EvalError: true,
	        // Module stuff to forbid
	        require: true,
	        module: true,
	        exports: true,
	        Module: true,
	        // Sandbox
	        arguments: true,
	        callee: true,
	        // Identifiers on built-in global objects
	        prototpye: true,
	        __proto__: true,
	        freeze: true,
	        setPrototypeOf: true,
	        constructor: true,
	        defineProperties: true,
	        defineProperty: true,
	    };
	    HaikuComponent.PARSERS = {
	        'style.stroke': { parse: parseColor, generate: generateColor },
	        'style.fill': { parse: parseColor, generate: generateColor },
	        'style.backgroundColor': { parse: parseColor, generate: generateColor },
	        'style.borderBottomColor': { parse: parseColor, generate: generateColor },
	        'style.borderColor': { parse: parseColor, generate: generateColor },
	        'style.borderLeftColor': { parse: parseColor, generate: generateColor },
	        'style.borderRightColor': { parse: parseColor, generate: generateColor },
	        'style.borderTopColor': { parse: parseColor, generate: generateColor },
	        'style.floodColor': { parse: parseColor, generate: generateColor },
	        'style.lightingColor': { parse: parseColor, generate: generateColor },
	        'style.stopColor': { parse: parseColor, generate: generateColor },
	        stroke: { parse: parseColor, generate: generateColor },
	        fill: { parse: parseColor, generate: generateColor },
	        floodColor: { parse: parseColor, generate: generateColor },
	        lightingColor: { parse: parseColor, generate: generateColor },
	        stopColor: { parse: parseColor, generate: generateColor },
	        backgroundColor: { parse: parseColor, generate: generateColor },
	        animateColor: { parse: parseColor, generate: generateColor },
	        feColor: { parse: parseColor, generate: generateColor },
	        // Note the hyphenated duplicates, for convenience
	        'flood-color': { parse: parseColor, generate: generateColor },
	        'lighting-color': { parse: parseColor, generate: generateColor },
	        'stop-color': { parse: parseColor, generate: generateColor },
	        'background-color': { parse: parseColor, generate: generateColor },
	        'animate-color': { parse: parseColor, generate: generateColor },
	        'fe-color': { parse: parseColor, generate: generateColor },
	        d: { parse: parseD, generate: generateD },
	        points: { parse: parsePoints, generate: generatePoints },
	    };
	    HaikuComponent.all = function () { return HaikuBase_1.default.getRegistryForClass(HaikuComponent); };
	    return HaikuComponent;
	}(HaikuElement_1.default));
	exports.default = HaikuComponent;
	var getNodeFlexId = function (node) {
	    var domId = (node &&
	        node.attributes &&
	        node.attributes.id);
	    var haikuId = (node &&
	        node.attributes &&
	        node.attributes[HAIKU_ID_ATTRIBUTE]);
	    return haikuId || domId;
	};
	exports.getNodeCompositeId = function (node) {
	    var flexId = getNodeFlexId(node);
	    // Treat the 0th repeater as the original (source) element
	    return (node.__memory && node.__memory.repeatee && node.__memory.repeatee.index)
	        ? flexId + "'" + node.__memory.repeatee.index
	        : flexId;
	};
	var collatePropertyGroup = function (propertiesGroup) {
	    var collation = [
	        {},
	        {},
	        {},
	        {},
	    ];
	    for (var propertyName in propertiesGroup) {
	        if (propertyName === 'controlFlow.if') {
	            collation[0][propertyName] = propertiesGroup[propertyName];
	        }
	        else if (propertyName === 'controlFlow.repeat') {
	            collation[1][propertyName] = propertiesGroup[propertyName];
	        }
	        else if (propertyName === 'controlFlow.placeholder') {
	            collation[2][propertyName] = propertiesGroup[propertyName];
	        }
	        else {
	            collation[3][propertyName] = propertiesGroup[propertyName];
	        }
	    }
	    return collation;
	};
	function isBytecode(thing) {
	    return thing && typeof thing === OBJECT_TYPE && thing.template;
	}
	function assertTemplate(template) {
	    if (!template) {
	        throw new Error('Empty template not allowed');
	    }
	    if (typeof template === OBJECT_TYPE) {
	        if (template.attributes) {
	            if (!template.attributes[HAIKU_ID_ATTRIBUTE]) {
	                console.warn('[haiku core] bytecode template has no id');
	            }
	        }
	        else {
	            console.warn('[haiku core] bytecode template has no attributes');
	        }
	        if (!template.elementName) {
	            console.warn('[haiku core] unexpected bytecode template format');
	        }
	        return template;
	    }
	    throw new Error('Unknown bytecode template format');
	}
	var needsVirtualChildren = function (child) { return typeof child === 'object' &&
	    child.__memory &&
	    ((child.__memory.if && !child.__memory.if.answer) ||
	        (child.__memory.repeater && !!child.__memory.repeater.repeatees)); };
	var reduceNodeMemoryChildren = function (children, out, doIncludeRepeatees) {
	    if (out === void 0) { out = []; }
	    if (doIncludeRepeatees === void 0) { doIncludeRepeatees = false; }
	    for (var i = 0; i < children.length; i++) {
	        var child = children[i];
	        if (!child) {
	            continue;
	        }
	        if (typeof child === 'object' && child.__memory) {
	            // Do not include any children that have been removed due to $if-logic
	            if (child.__memory.if && !child.__memory.if.answer) {
	                continue;
	            }
	            // If the child is a repeater, use the $repeats instead of itself
	            if (doIncludeRepeatees &&
	                child.__memory.repeater &&
	                child.__memory.repeater.repeatees) {
	                reduceNodeMemoryChildren(child.__memory.repeater.repeatees, out, false);
	                continue;
	            }
	            // If we got this far, the child is structurally normal
	            out.push(child);
	        }
	        else {
	            out.push(child);
	        }
	    }
	    return out;
	};
	var assembleNodeMemoryChildren = function (node, subtree) {
	    if (subtree) {
	        return [subtree];
	    }
	    if (node.__memory.placeholder) {
	        return [];
	    }
	    // To avoid creating garbage, only allow allocations here if we actually need virtual children.
	    if (!node.children || !node.children.some(needsVirtualChildren)) {
	        return;
	    }
	    return reduceNodeMemoryChildren(node.children, [], true);
	};
	var expandNode = function (node, parent) {
	    if (!node || typeof node !== 'object' || !node.__memory) {
	        return;
	    }
	    var children = node.children;
	    // Special case if our current original is the wrapper of a subcomponent.
	    var subtree = node.__memory.subcomponent && node.__memory.subcomponent.bytecode.template;
	    var assembled = assembleNodeMemoryChildren(node, subtree);
	    // Don't just overwrite, since node.__memory.children may've been set to vanity 'content'
	    if (assembled) {
	        node.__memory.children = assembled;
	    }
	    if (node.__memory.children) {
	        children = node.__memory.children;
	    }
	    /**
	     * When we compute layout, we have the following chicken/egg problem:
	     * 1. Nodes which are "auto"-sized consume their children's size to calculate their own size.
	     * 2. Nodes with a SIZE_PROPORTIONAL depend on parent absolute size to compute their target size. (DEPRECATED)
	     * 3. Nodes with an "auto"-sized parent consume their parent's bounds to calculate a translation offset.
	     *
	     * Thus, we perform the layout steps in the following order:
	     * 1. Compute the current node's layout.
	     *   1.a. If the current node is "auto"-sized, compute the size of the children. For each child,
	     *        we compute its bounding rect using its *local* transform (not using its parent size).
	     *        This is sufficient to obtain a bounding box in local coordinate space with respect to
	     *        an unknown container. We then use all of the rects to determine the outermost bbox,
	     *        which in turn is used to determine the current node's size.
	     *   1.b. If the current node is numerically sized, use that size.
	     * 2. Expand all children of the current node. By now, the parent should have a numeric size.
	     *   2.a. For SIZE_PROPORTIONAL nodes, compute the layout as proportion of the parent size.
	     *   2.b. For other nodes, compute its local size.
	     *   2.c. If the parent was "auto"-sized, it should have its bounds precalculated from the
	     *        previous pass. When this is the case, use the bounds to calculate an offset value
	     *        by which translation will be offset, aligning all children to be perfectly flush
	     *        with their container, no matter what size it is.
	     */
	    computeAndApplyLayout(node, parent);
	    if (children) {
	        for (var j = 0; j < children.length; j++) {
	            // Special case: The subtree of the subcomponent doesn't need to be re-expanded.
	            if (children[j] !== subtree) {
	                expandNode(children[j], node);
	            }
	        }
	    }
	};
	var computeAndApplyLayout = function (node, parent) {
	    // Don't assume the node has/needs a layout, for example, control-flow injectees
	    if (node.layout) {
	        node.layout.computed = HaikuElement_1.default.computeLayout(node, parent);
	    }
	};
	var hydrateNode = function (node, parent, component, context, host, scope, options, doConnectInstanceToNode) {
	    if (options === void 0) { options = {}; }
	    // Nothing to expand if the node happens to be text or unexpected type
	    if (!node || typeof node !== 'object') {
	        return;
	    }
	    // Hydrate a HaikuElement representation of all nodes in the tree.
	    // The instance is cached as node.__memory.element for performance purposes.
	    HaikuElement_1.default.findOrCreateByNode(node);
	    component.cacheNodeWithSelectorKey(node);
	    // Platform-specific renderers may depend on access to the parent.
	    node.__memory.parent = parent;
	    // So renderers can detect when different layout behavior is needed.
	    node.__memory.scope = scope || 'div';
	    // Give it a pointer back to the host context; used by HaikuElement
	    node.__memory.context = context;
	    Layout3D_1.default.initializeNodeAttributes(node, doConnectInstanceToNode);
	    // Give instances a pointer to their node and vice versa
	    if (doConnectInstanceToNode) {
	        node.__memory.instance = component;
	        // In the case that the node represents the root of an instance, treat the instance as the element;
	        // connect their references and override the equivalent action in findOrCreateByNode.
	        HaikuElement_1.default.connectNodeWithElement(node, node.__memory.instance);
	    }
	    // If the element name is missing it should still be safe to hydrate the children
	    if (typeof node.elementName === STRING_TYPE || !node.elementName) {
	        if (node.children) {
	            for (var i = 0; i < node.children.length; i++) {
	                hydrateNode(node.children[i], // node
	                node, // parent
	                component, // instance (component)
	                context, host, SCOPE_STRATA[node.elementName] || scope, // scope
	                options, false);
	            }
	        }
	        return;
	    }
	    if (isBytecode(node.elementName)) {
	        // Example structure showing how nodes and instances are related:
	        // <div root> instance id=1
	        //   <div>
	        //     <div>
	        //       <div wrap> subcomponent (instance id=2)
	        //         <div root> instance id=2
	        //           ...
	        if (!node.__memory.subcomponent) {
	            var config = Config_1.default.buildChildSafeConfig(__assign({}, context.config, options));
	            // Note: .render and thus .hydrateNode are called by the constructor,
	            // automatically connecting the root node to itself (see stanza above).
	            node.__memory.subcomponent = new HaikuComponent(node.elementName, context, // context
	            component, __assign({ loop: true }, config), node);
	            // Very important, as the guests collection is used in rendering/patching
	            component.registerGuest(node.__memory.subcomponent);
	        }
	        else {
	            // Reassigning is necessary since these objects may have changed between
	            // renders in the editing environment
	            node.__memory.subcomponent.context = context; // context
	            node.__memory.subcomponent.host = component; // host
	            node.__memory.subcomponent.container = node; // container
	            // Very important, as the guests collection is used in rendering/patching
	            component.registerGuest(node.__memory.subcomponent);
	            // Don't re-start any nested timelines that have been explicitly paused
	            if (!node.__memory.subcomponent.getDefaultTimeline().isPaused()) {
	                node.__memory.subcomponent.startTimeline(DEFAULT_TIMELINE_NAME);
	            }
	        }
	        return;
	    }
	    // In case we got a __reference node or other unknown
	    console.warn('[haiku core] cannot hydrate node');
	};
	var computeAndApplyPresetSizing = function (element, container, mode) {
	    var elementWidth = element.layout.sizeAbsolute.x;
	    var elementHeight = element.layout.sizeAbsolute.y;
	    // Some browsers does not work correctly with matrix3d transforms on SVGs
	    // with resulting subpixel rendering, so let's round up the size to avoid
	    // browser problems
	    var containerWidth = Math.ceil(container.layout.computed.size.x);
	    var containerHeight = Math.ceil(container.layout.computed.size.y);
	    // I.e., the amount by which we'd have to multiply the element's scale to make it
	    // exactly the same size as its container (without going above it)
	    var scaleDiffX = containerWidth / elementWidth;
	    var scaleDiffY = containerHeight / elementHeight;
	    // This makes sure that the sizing occurs with respect to a correct and consistent origin point,
	    // but only if the user didn't happen to explicitly set this value (we allow their override).
	    if (!element.attributes.style['transform-origin']) {
	        element.attributes.style['transform-origin'] = '0% 0% 0px';
	    }
	    // IMPORTANT: If any value has been changed on the element, you must set this to true.
	    // Otherwise the changed object won't go into the deltas dictionary, and the element won't update.
	    var changed = false;
	    switch (mode) {
	        // Make the base element its default scale, which is just a multiplier of one. This is the default.
	        case 'normal':
	            if (element.layout.scale.x !== 1.0 || element.layout.scale.y !== 1.0) {
	                changed = true;
	                element.layout.scale.x = element.layout.scale.y = 1.0;
	            }
	            break;
	        // Stretch the element to fit the container on both x and y dimensions (distortion allowed)
	        case 'stretch':
	            if (scaleDiffX !== element.layout.scale.x) {
	                changed = true;
	                element.layout.scale.x = scaleDiffX;
	            }
	            if (scaleDiffY !== element.layout.scale.y) {
	                changed = true;
	                element.layout.scale.y = scaleDiffY;
	            }
	            break;
	        // CONTAIN algorithm
	        // see https://developer.mozilla.org/en-US/docs/Web/CSS/background-size?v=example
	        // A keyword that scales the image as large as possible and maintains image aspect ratio
	        // (image doesn't get squished). Image is letterboxed within the container.
	        // When the image and container have different dimensions, the empty areas (either top/bottom of left/right)
	        // are filled with the background-color.
	        case 'contain':
	        case true: // (Legacy.)
	            var containScaleToUse = null;
	            // We're looking for the larger of the two scales that still allows both dimensions to fit in the box
	            // The rounding is necessary to avoid precision issues, where we end up comparing e.g. 2.0000000000001 to 2
	            if (~~(scaleDiffX * elementWidth) <= containerWidth &&
	                ~~(scaleDiffX * elementHeight) <= containerHeight) {
	                containScaleToUse = scaleDiffX;
	            }
	            if (~~(scaleDiffY * elementWidth) <= containerWidth &&
	                ~~(scaleDiffY * elementHeight) <= containerHeight) {
	                if (containScaleToUse === null) {
	                    containScaleToUse = scaleDiffY;
	                }
	                else {
	                    if (scaleDiffY >= containScaleToUse) {
	                        containScaleToUse = scaleDiffY;
	                    }
	                }
	            }
	            if (element.layout.scale.x !== containScaleToUse) {
	                changed = true;
	                element.layout.scale.x = containScaleToUse;
	            }
	            if (element.layout.scale.y !== containScaleToUse) {
	                changed = true;
	                element.layout.scale.y = containScaleToUse;
	            }
	            // Offset the translation so that the element remains centered within the letterboxing
	            var containTranslationOffsetX = -(containScaleToUse * elementWidth - containerWidth) / 2;
	            var containTranslationOffsetY = -(containScaleToUse * elementHeight - containerHeight) / 2;
	            if (element.layout.translation.x !== containTranslationOffsetX) {
	                changed = true;
	                element.layout.translation.x = containTranslationOffsetX;
	            }
	            if (element.layout.translation.y !== containTranslationOffsetY) {
	                changed = true;
	                element.layout.translation.y = containTranslationOffsetY;
	            }
	            break;
	        // COVER algorithm (inverse of CONTAIN)
	        // see https://developer.mozilla.org/en-US/docs/Web/CSS/background-size?v=example
	        // A keyword that is the inverse of contain. Scales the image as large as possible and maintains
	        // image aspect ratio (image doesn't get squished). The image "covers" the entire width or height
	        // of the container. When the image and container have different dimensions, the image is clipped
	        // either left/right or top/bottom.
	        case 'cover':
	            var coverScaleToUse = null;
	            // We're looking for the smaller of two scales that ensures the entire box is covered.
	            // The rounding is necessary to avoid precision issues, where we end up comparing e.g. 2.0000000000001 to 2
	            if (~~(scaleDiffX * elementHeight) >= containerHeight) {
	                coverScaleToUse = scaleDiffX;
	            }
	            else if (~~(scaleDiffY * elementWidth) >= containerWidth) {
	                coverScaleToUse = scaleDiffY;
	            }
	            else {
	                coverScaleToUse = Math.max(scaleDiffX, scaleDiffY);
	            }
	            if (element.layout.scale.x !== coverScaleToUse) {
	                changed = true;
	                element.layout.scale.x = coverScaleToUse;
	            }
	            if (element.layout.scale.y !== coverScaleToUse) {
	                changed = true;
	                element.layout.scale.y = coverScaleToUse;
	            }
	            // Offset the translation so that the element remains centered despite clipping
	            var coverTranslationOffsetX = -(coverScaleToUse * elementWidth - containerWidth) / 2;
	            var coverTranslationOffsetY = -(coverScaleToUse * elementHeight - containerHeight) / 2;
	            if (element.layout.translation.x !== coverTranslationOffsetX) {
	                changed = true;
	                element.layout.translation.x = coverTranslationOffsetX;
	            }
	            if (element.layout.translation.y !== coverTranslationOffsetY) {
	                changed = true;
	                element.layout.translation.y = coverTranslationOffsetY;
	            }
	            break;
	    }
	    return changed;
	};
	exports.clone = function (value, binding) {
	    if (!value) {
	        return value;
	    }
	    if (typeof value === 'boolean') {
	        return value;
	    }
	    if (typeof value === 'number') {
	        return value;
	    }
	    if (typeof value === 'string') {
	        return value;
	    }
	    if (typeof value === 'function') {
	        var fn = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return value.call.apply(value, [binding].concat(args));
	        };
	        // Core decorates injectee functions with metadata properties
	        for (var key in value) {
	            if (value.hasOwnProperty(key)) {
	                fn[key] = exports.clone(value[key], binding);
	            }
	        }
	        fn.__rfo = functionToRFO_1.default(value).__function;
	        return fn;
	    }
	    if (Array.isArray(value)) {
	        return value.map(function (el) { return exports.clone(el, binding); });
	    }
	    // Don't try to clone anything other than plain objects
	    if (typeof value === 'object' && value.constructor === Object) {
	        var out = {};
	        for (var key in value) {
	            if (!value.hasOwnProperty(key) || key.slice(0, 2) === '__') {
	                continue;
	            }
	            // If it looks like guest bytecode, don't clone it since
	            // (a) we're passing down *our* function binding, which will break event handling and
	            // (b) each HaikuComponent#constructor calls clone() on its own anyway
	            if (key === 'elementName' && typeof value[key] !== 'string') {
	                out[key] = value[key];
	            }
	            else {
	                out[key] = exports.clone(value[key], binding);
	            }
	        }
	        return out;
	    }
	    return value;
	};
	var setStyle = function (subkey, element, value) {
	    element.attributes.style[subkey] = value;
	};
	var setAttribute = function (key, element, value) {
	    var final = exports.ATTRS_CAMEL_TO_HYPH[key] || key;
	    element.attributes[final] = value;
	};
	var isNumeric = function (n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	};
	var isInteger = function (x) {
	    return x % 1 === 0;
	};
	var REACT_MATCHING_OPTIONS = {
	    name: 'type',
	    attributes: 'props',
	};
	var HAIKU_MATCHING_OPTIONS = {
	    name: 'elementName',
	    attributes: 'attributes',
	};
	var querySelectSubtree = function (surrogate, value) {
	    // First try the Haiku format
	    if (HaikuNode_1.cssMatchOne(surrogate, value, HAIKU_MATCHING_OPTIONS)) {
	        return surrogate;
	    }
	    // If no match yet, try the React format (TODO: Does this belong here?)
	    if (HaikuNode_1.cssMatchOne(surrogate, value, REACT_MATCHING_OPTIONS)) {
	        return surrogate;
	    }
	    // Visit the descendants (if any) and see if we have a match there
	    var children = (surrogate.children || // Haiku's format
	        (surrogate.props && surrogate.props.children) // React's format
	    );
	    // If no children, we definitely don't have a match in this subtree
	    if (!children) {
	        return null;
	    }
	    // Check for arrays first since arrays pass the typeof object check
	    if (Array.isArray(children)) {
	        for (var i = 0; i < children.length; i++) {
	            var found = querySelectSubtree(children[i], value);
	            // First time a match is found, break the loop and return it
	            if (found) {
	                return found;
	            }
	        }
	    }
	    // React may store 'children' as a single object
	    if (typeof children === 'object') {
	        return querySelectSubtree(children, value);
	    }
	};
	var querySelectSurrogates = function (surrogates, value) {
	    if (Array.isArray(surrogates)) {
	        // Return the first match we locate in the collection
	        return surrogates.map(function (surrogate) { return querySelectSurrogates(surrogate, value); })[0];
	    }
	    if (surrogates && typeof surrogates === 'object') {
	        return querySelectSubtree(surrogates, value);
	    }
	};
	var selectSurrogate = function (surrogates, value) {
	    // If the placeholder value is intended as an array index
	    if (Array.isArray(surrogates) && isNumeric(value) && isInteger(value)) {
	        if (surrogates[value]) {
	            return surrogates[value];
	        }
	    }
	    // If the placeholder value is intended as a key
	    if (surrogates && typeof surrogates === 'object' && typeof value === 'string') {
	        if (surrogates[value]) {
	            return surrogates[value];
	        }
	    }
	    return querySelectSurrogates(surrogates, value + '');
	};
	var getCanonicalPlaybackValue = function (value) {
	    if (typeof value !== 'object') {
	        return {
	            Default: value,
	        };
	    }
	    return value;
	};
	/**
	 * 'Vanities' are functions that provide special handling for applied properties.
	 * So for example, if a component wants to apply 'foo.bar'=3 to a <div> in its template,
	 * the renderer will look in the vanities dictionary to see if there is a
	 * vanity 'foo.bar' available, and if so, pass the value 3 into that function.
	 * The function, in turn, knows how to apply that value to the virtual element passed into
	 * it. In the future these will be defined by components themselves as inputs; for now,
	 * we are keeping a whitelist of possible vanity handlers which the renderer directly
	 * loads and calls.
	 */
	exports.getVanity = function (elementName, propertyName) {
	    if (elementName) {
	        if (exports.VANITIES[elementName] && exports.VANITIES[elementName][propertyName]) {
	            return exports.VANITIES[elementName][propertyName];
	        }
	    }
	    return exports.VANITIES['*'][propertyName];
	};
	/**
	 * Ensures layout before applying a layout vanity.
	 */
	var ensureLayout = function (node) {
	    if (!node.layout) {
	        Layout3D_1.default.initializeNodeLayout(node);
	    }
	};
	exports.LAYOUT_3D_VANITIES = {
	    // Layout has a couple of special values that relate to display
	    // but not to position:
	    shown: function (_, element, value) {
	        ensureLayout(element);
	        element.layout.shown = value;
	    },
	    // Opacity needs to have its opacity *layout* property set
	    // as opposed to its element attribute so the renderer can make a decision about
	    // where to put it based on the rendering medium's rules
	    opacity: function (_, element, value) {
	        ensureLayout(element);
	        element.layout.opacity = value;
	    },
	    // If you really want to set what we call 'position' then
	    // we do so on the element's attributes; this is mainly to
	    // enable the x/y positioning system for SVG elements.
	    'position.x': function (name, element, value) {
	        ensureLayout(element);
	        element.attributes.x = value;
	    },
	    'position.y': function (name, element, value) {
	        ensureLayout(element);
	        element.attributes.y = value;
	    },
	    // Everything that follows is a standard 3-coord component
	    // relating to the element's position in space
	    'rotation.x': function (_, element, value) {
	        ensureLayout(element);
	        element.layout.rotation.x = value;
	    },
	    'rotation.y': function (_, element, value) {
	        ensureLayout(element);
	        element.layout.rotation.y = value;
	    },
	    'rotation.z': function (_, element, value) {
	        ensureLayout(element);
	        element.layout.rotation.z = value;
	    },
	    'offset.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.offset.x = value;
	    },
	    'offset.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.offset.y = value;
	    },
	    'offset.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.offset.z = value;
	    },
	    'origin.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.origin.x = value;
	    },
	    'origin.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.origin.y = value;
	    },
	    'origin.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.origin.z = value;
	    },
	    'scale.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.scale.x = value;
	    },
	    'scale.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.scale.y = value;
	    },
	    'scale.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.scale.z = value;
	    },
	    'sizeAbsolute.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeAbsolute.x = value;
	    },
	    'sizeAbsolute.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeAbsolute.y = value;
	    },
	    'sizeAbsolute.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeAbsolute.z = value;
	    },
	    'sizeDifferential.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeDifferential.x = value;
	    },
	    'sizeDifferential.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeDifferential.y = value;
	    },
	    'sizeDifferential.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeDifferential.z = value;
	    },
	    'sizeMode.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeMode.x = value;
	    },
	    'sizeMode.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeMode.y = value;
	    },
	    'sizeMode.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeMode.z = value;
	    },
	    'sizeProportional.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeProportional.x = value;
	    },
	    'sizeProportional.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeProportional.y = value;
	    },
	    'sizeProportional.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeProportional.z = value;
	    },
	    'shear.xy': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.shear.xy = value;
	    },
	    'shear.xz': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.shear.xz = value;
	    },
	    'shear.yz': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.shear.yz = value;
	    },
	    'translation.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.translation.x = value;
	    },
	    'translation.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.translation.y = value;
	    },
	    'translation.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.translation.z = value;
	    },
	};
	exports.VANITIES = {
	    '*': __assign({}, exports.LAYOUT_3D_VANITIES, { 
	        // CSS style properties that need special handling
	        'style.WebkitTapHighlightColor': function (_, element, value) {
	            element.attributes.style.webkitTapHighlightColor = value;
	        }, 
	        // Text and other inner-content related vanities
	        content: function (name, element, value, context, timeline, receiver, sender) {
	            element.__memory.children = [value];
	            // If we don't do this, then content changes resulting from setState calls
	            // don't have the effect of flushing the content, and the rendered text doesn't change.
	            // DEMO: bind-numeric-state-to-text
	            // TODO: What is the best way to make this less expensive (while still functional)?
	            sender.patches.push(element);
	        }, 
	        // Playback-related vanities that involve controlling timeline or clock time
	        playback: function (name, element, value, context, timeline, receiver, sender) {
	            var canonicalValue = getCanonicalPlaybackValue(value);
	            for (var timelineName in canonicalValue) {
	                var timelineInstance = receiver && receiver.getTimeline(timelineName);
	                if (timelineInstance) {
	                    timelineInstance.setPlaybackStatus(canonicalValue[timelineName]);
	                }
	            }
	        }, 
	        // Control-flow vanities that alter the output structure of the component
	        'controlFlow.placeholder': function (name, element, value, context, timeline, receiver, sender) {
	            // For MVP's sake, structural behaviors not rendered during hot editing.
	            if (sender.config.hotEditingMode) {
	                return;
	            }
	            if (value === null || value === undefined) {
	                return;
	            }
	            if (typeof value !== 'number' && typeof value !== 'string') {
	                return;
	            }
	            var surrogates;
	            // Surrogates can be passed in as:
	            //   - React children (an array)
	            //   - A React subtree (we'll use query selectors to match)
	            //   - A Haiku subtree (we'll use query selectors to match)
	            //   - Key/value pairs
	            if (context.config.children) {
	                surrogates = context.config.children;
	                if (!Array.isArray(surrogates)) {
	                    surrogates = [surrogates];
	                }
	            }
	            else if (context.config.placeholder) {
	                surrogates = context.config.placeholder;
	            }
	            if (!surrogates) {
	                return;
	            }
	            var surrogate = selectSurrogate(surrogates, value);
	            if (surrogate === null || surrogate === undefined) {
	                return;
	            }
	            if (!element.__memory.placeholder) {
	                element.__memory.placeholder = {};
	            }
	            element.__memory.placeholder.value = value;
	            // If we are running via a framework adapter, allow that framework to provide its own placeholder mechanism.
	            // This is necessary e.g. in React where their element format needs to be converted into our 'mana' format
	            if (context.config.vanities['controlFlow.placeholder']) {
	                context.config.vanities['controlFlow.placeholder'](element, surrogate, value, context, timeline, receiver, sender);
	            }
	            else {
	                element.__memory.placeholder.surrogate = surrogate;
	            }
	        }, 'controlFlow.repeat': function (name, element, value, context, timeline, receiver, sender) {
	            var instructions;
	            if (Array.isArray(value)) {
	                instructions = value;
	            }
	            else if (isNumeric(value)) {
	                var arr = [];
	                for (var i = 0; i < value; i++) {
	                    arr.push({}); // Empty repeat payload spec
	                }
	                instructions = arr;
	            }
	            else {
	                return;
	            }
	            if (element.__memory.repeatee) {
	                // Don't repeat the repeatee of an existing repeater
	                if (element.__memory.repeatee.index > 0) {
	                    return;
	                }
	            }
	            if (element.__memory.repeater) {
	                if (element.__memory.repeater.changed) {
	                    element.__memory.repeater.changed = false;
	                }
	                else {
	                    // Save CPU by avoiding recomputing a repeat when we've already done so.
	                    // Although upstream HaikuComponent#applyLocalBehaviors does do diff comparisons,
	                    // it intentionally skips this comparison for complex properties i.e. arrays
	                    // and objects due to the intractability of smartly comparing for all cases.
	                    // We do a comparison that is fairly sensible in the repeat-exclusive case.
	                    if (isSameRepeatBehavior(element.__memory.repeater.instructions, instructions)) {
	                        return;
	                    }
	                }
	            }
	            if (!element.__memory.repeater) {
	                element.__memory.repeater = {};
	            }
	            element.__memory.repeater.instructions = instructions;
	            // Structural behaviors are not rendered during hot editing.
	            if (sender.config.hotEditingMode) {
	                // If we got at least one instruction, render that by default into the repeater
	                if (instructions.length > 0) {
	                    element.__memory.repeatee = {
	                        instructions: instructions,
	                        index: 0,
	                        payload: instructions[0],
	                        source: element,
	                    };
	                    applyPayloadToNode(element, instructions[0], sender, timeline);
	                    sender.patches.push(element);
	                    expandNode(element, element.__memory.parent);
	                }
	                return;
	            }
	            if (!element.__memory.repeater.repeatees) {
	                element.__memory.repeater.repeatees = [];
	            }
	            else {
	                // If the instructions have decreased on this run, remove the excess repeatees
	                element.__memory.repeater.repeatees.splice(instructions.length);
	            }
	            instructions.forEach(function (payload, index) {
	                var repeatee = (index === 0)
	                    ? element // The first element should be the source element
	                    : element.__memory.repeater.repeatees[index] || exports.clone(element, sender);
	                // We have to initialize the element's component instance, etc.
	                hydrateNode(repeatee, element.__memory.parent, // parent
	                sender, // component
	                sender.context, // context
	                sender, // host
	                element.__memory.scope, // scope (use same scope as source node)
	                sender.config, // options
	                false);
	                repeatee.__memory.repeatee = {
	                    index: index,
	                    instructions: instructions,
	                    payload: payload,
	                    source: element,
	                };
	                applyPayloadToNode(repeatee, payload, sender, timeline);
	                element.__memory.repeater.repeatees[index] = repeatee;
	            });
	            sender.patches.push(element);
	            expandNode(element, element.__memory.parent);
	        }, 'controlFlow.if': function (name, element, value, context, timeline, receiver, sender) {
	            // For MVP's sake, structural behaviors not rendered during hot editing.
	            if (sender.config.hotEditingMode) {
	                return;
	            }
	            // Assume our if-answer is only false if we got an explicit false value
	            var answer = value !== false;
	            if (element.__memory.if) {
	                // Save CPU by avoiding recomputing an if when we've already done so.
	                if (isSameIfBehavior(element.__memory.if.answer, answer)) {
	                    return;
	                }
	            }
	            element.__memory.if = {
	                answer: answer,
	            };
	            // Ensure that a change in repeat will trigger the necessary re-repeat
	            if (element.__memory.repeater) {
	                element.__memory.repeater.changed = true;
	            }
	            sender.markForFullFlush();
	        } }),
	};
	var applyPayloadToNode = function (node, payload, sender, timeline) {
	    // Apply the repeat payload to the element as if it were a normal timeline output
	    for (var propertyName in payload) {
	        // Control-flow occurs after presentational behaviors, meaning we are overriding
	        // whatever may have been set on the source element instance.
	        sender.applyPropertyToNode(node, // matchingElement
	        propertyName, payload[propertyName], // finalValue
	        timeline);
	    }
	};
	var isSameIfBehavior = function (prev, next) {
	    return prev === next;
	};
	var isSameRepeatBehavior = function (prevs, nexts) {
	    if (prevs === nexts) {
	        return true;
	    }
	    if (prevs.length !== nexts.length) {
	        return false;
	    }
	    var answer = true;
	    for (var i = 0; i < prevs.length; i++) {
	        if (!answer) {
	            break;
	        }
	        var prev = prevs[i];
	        var next = nexts[i];
	        if (prev === next) {
	            continue;
	        }
	        for (var key in next) {
	            if (next[key] !== prev[key]) {
	                answer = false;
	                break;
	            }
	        }
	    }
	    return answer;
	};
	var findRespectiveRepeatees = function (target) {
	    var repeatees = [];
	    // Required to fix a race condition that can occur during copy+paste in Haiku.app
	    if (!target.__memory) {
	        return repeatees;
	    }
	    // The host repeatee of the given target node, if the target is a repeater's descendant
	    var host;
	    if (target.__memory.repeatee) {
	        host = target;
	    }
	    else {
	        // Note that we do not ascend beyond the nearest host component instance
	        HaikuNode_1.ascend(target, function (node) {
	            if (node.__memory.repeatee) {
	                host = node;
	            }
	        });
	    }
	    // If we've found a host repeatee, the target is a descendant of a repeater,
	    // and we need to find its respective node within each repeatee.
	    if (host) {
	        var repeater = host.__memory.repeatee.source;
	        if (repeater.__memory.repeater.repeatees) {
	            repeater.__memory.repeater.repeatees.forEach(function (repeatee) {
	                HaikuNode_1.visit(repeatee, function (candidate) {
	                    if (areNodesRespective(target, candidate)) {
	                        repeatees.push(candidate);
	                    }
	                });
	            });
	        }
	    }
	    return repeatees;
	};
	var areNodesRespective = function (n1, n2) {
	    if (n1 === n2) {
	        return true;
	    }
	    // We assume that all nodes within the tree of a component have unique haiku-ids, and that
	    // these haiku-ids are not directly modified within repeater groups
	    if (
	    // If the haiku-id attribute is empty, assume the comparison isn't valid
	    n1.attributes[HAIKU_ID_ATTRIBUTE] &&
	        n1.attributes[HAIKU_ID_ATTRIBUTE] === n2.attributes[HAIKU_ID_ATTRIBUTE]) {
	        return true;
	    }
	    return false;
	};
	exports.getFallback = function (elementName, propertyName) {
	    if (elementName) {
	        if (LAYOUT_COORDINATE_SYSTEM_FALLBACKS[elementName] &&
	            LAYOUT_COORDINATE_SYSTEM_FALLBACKS[elementName][propertyName] !== undefined) {
	            return LAYOUT_COORDINATE_SYSTEM_FALLBACKS[elementName][propertyName];
	        }
	        if (exports.FALLBACKS[elementName] && exports.FALLBACKS[elementName][propertyName] !== undefined) {
	            return exports.FALLBACKS[elementName][propertyName];
	        }
	    }
	    return exports.FALLBACKS['*'][propertyName];
	};
	var LAYOUT_COORDINATE_SYSTEM_FALLBACKS = {
	    svg: {
	        'origin.x': 0.5,
	        'origin.y': 0.5,
	        'origin.z': 0.5,
	    },
	};
	var LAYOUT_DEFAULTS = Layout3D_1.default.createLayoutSpec();
	exports.FALLBACKS = {
	    '*': {
	        shown: LAYOUT_DEFAULTS.shown,
	        opacity: LAYOUT_DEFAULTS.opacity,
	        content: '',
	        'offset.x': LAYOUT_DEFAULTS.offset.x,
	        'offset.y': LAYOUT_DEFAULTS.offset.y,
	        'offset.z': LAYOUT_DEFAULTS.offset.z,
	        'origin.x': LAYOUT_DEFAULTS.origin.x,
	        'origin.y': LAYOUT_DEFAULTS.origin.y,
	        'origin.z': LAYOUT_DEFAULTS.origin.z,
	        'translation.x': LAYOUT_DEFAULTS.translation.x,
	        'translation.y': LAYOUT_DEFAULTS.translation.y,
	        'translation.z': LAYOUT_DEFAULTS.translation.z,
	        'rotation.x': LAYOUT_DEFAULTS.rotation.x,
	        'rotation.y': LAYOUT_DEFAULTS.rotation.y,
	        'rotation.z': LAYOUT_DEFAULTS.rotation.z,
	        'scale.x': LAYOUT_DEFAULTS.scale.x,
	        'scale.y': LAYOUT_DEFAULTS.scale.y,
	        'scale.z': LAYOUT_DEFAULTS.scale.z,
	        'shear.xy': LAYOUT_DEFAULTS.shear.xy,
	        'shear.xz': LAYOUT_DEFAULTS.shear.xz,
	        'shear.yz': LAYOUT_DEFAULTS.shear.yz,
	        'sizeAbsolute.x': LAYOUT_DEFAULTS.sizeAbsolute.x,
	        'sizeAbsolute.y': LAYOUT_DEFAULTS.sizeAbsolute.y,
	        'sizeAbsolute.z': LAYOUT_DEFAULTS.sizeAbsolute.z,
	        'sizeProportional.x': LAYOUT_DEFAULTS.sizeProportional.x,
	        'sizeProportional.y': LAYOUT_DEFAULTS.sizeProportional.y,
	        'sizeProportional.z': LAYOUT_DEFAULTS.sizeProportional.z,
	        'sizeDifferential.x': LAYOUT_DEFAULTS.sizeDifferential.x,
	        'sizeDifferential.y': LAYOUT_DEFAULTS.sizeDifferential.y,
	        'sizeDifferential.z': LAYOUT_DEFAULTS.sizeDifferential.z,
	        'sizeMode.x': LAYOUT_DEFAULTS.sizeMode.x,
	        'sizeMode.y': LAYOUT_DEFAULTS.sizeMode.y,
	        'sizeMode.z': LAYOUT_DEFAULTS.sizeMode.z,
	        'style.overflowX': 'hidden',
	        'style.overflowY': 'hidden',
	        'style.zIndex': 1,
	        'style.WebkitTapHighlightColor': 'rgba(0,0,0,0)',
	        width: 0,
	        height: 0,
	        x: 0,
	        y: 0,
	        r: 0,
	        cx: 0,
	        cy: 0,
	        rx: 0,
	        ry: 0,
	        x1: 0,
	        y1: 0,
	        x2: 0,
	        y2: 0,
	        playback: "loop" /* LOOP */,
	        'controlFlow.repeat': null,
	        'controlFlow.placeholder': null,
	    },
	};
	exports.LAYOUT_3D_SCHEMA = {
	    shown: 'boolean',
	    opacity: 'number',
	    'offset.x': 'number',
	    'offset.y': 'number',
	    'offset.z': 'number',
	    'origin.x': 'number',
	    'origin.y': 'number',
	    'origin.z': 'number',
	    'translation.x': 'number',
	    'translation.y': 'number',
	    'translation.z': 'number',
	    'rotation.x': 'number',
	    'rotation.y': 'number',
	    'rotation.z': 'number',
	    'scale.x': 'number',
	    'scale.y': 'number',
	    'scale.z': 'number',
	    'shear.xy': 'number',
	    'shear.xz': 'number',
	    'shear.yz': 'number',
	    'sizeAbsolute.x': 'number',
	    'sizeAbsolute.y': 'number',
	    'sizeAbsolute.z': 'number',
	    'sizeProportional.x': 'number',
	    'sizeProportional.y': 'number',
	    'sizeProportional.z': 'number',
	    'sizeDifferential.x': 'number',
	    'sizeDifferential.y': 'number',
	    'sizeDifferential.z': 'number',
	    'sizeMode.x': 'number',
	    'sizeMode.y': 'number',
	    'sizeMode.z': 'number',
	};
	exports.ATTRS_CAMEL_TO_HYPH = {
	    accentHeight: 'accent-height',
	    alignmentBaseline: 'alignment-baseline',
	    arabicForm: 'arabic-form',
	    baselineShift: 'baseline-shift',
	    capHeight: 'cap-height',
	    clipPath: 'clip-path',
	    clipRule: 'clip-rule',
	    colorInterpolation: 'color-interpolation',
	    colorInterpolationFilters: 'color-interpolation-filters',
	    colorProfile: 'color-profile',
	    colorRendering: 'color-rendering',
	    dominantBaseline: 'dominant-baseline',
	    enableBackground: 'enable-background',
	    fillOpacity: 'fill-opacity',
	    fillRule: 'fill-rule',
	    floodColor: 'flood-color',
	    floodOpacity: 'flood-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    fontSizeAdjust: 'font-size-adjust',
	    fontStretch: 'font-stretch',
	    fontStyle: 'font-style',
	    fontVariant: 'font-variant',
	    fontWeight: 'font-weight',
	    glyphName: 'glyph-name',
	    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	    glyphOrientationVertical: 'glyph-orientation-vertical',
	    horizAdvX: 'horiz-adv-x',
	    horizOriginX: 'horiz-origin-x',
	    imageRendering: 'image-rendering',
	    letterSpacing: 'letter-spacing',
	    lightingColor: 'lighting-color',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    overlinePosition: 'overline-position',
	    overlineThickness: 'overline-thickness',
	    panose1: 'panose-1',
	    paintOrder: 'paint-order',
	    pointerEvents: 'pointer-events',
	    renderingIntent: 'rendering-intent',
	    shapeRendering: 'shape-rendering',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strikethroughPosition: 'strikethrough-position',
	    strikethroughThickness: 'strikethrough-thickness',
	    strokeDasharray: 'stroke-dasharray',
	    strokeDashoffset: 'stroke-dashoffset',
	    strokeLinecap: 'stroke-linecap',
	    strokeLinejoin: 'stroke-linejoin',
	    strokeMiterlimit: 'stroke-miterlimit',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    textDecoration: 'text-decoration',
	    textRendering: 'text-rendering',
	    underlinePosition: 'underline-position',
	    underlineThickness: 'underline-thickness',
	    unicodeBidi: 'unicode-bidi',
	    unicodeRange: 'unicode-range',
	    unitsPerEm: 'units-per-em',
	    vAlphabetic: 'v-alphabetic',
	    vHanging: 'v-hanging',
	    vIdeographic: 'v-ideographic',
	    vMathematical: 'v-mathematical',
	    vectorEffect: 'vector-effect',
	    vertAdvY: 'vert-adv-y',
	    vertOriginX: 'vert-origin-x',
	    vertOriginY: 'vert-origin-y',
	    wordSpacing: 'word-spacing',
	    writingMode: 'writing-mode',
	    xHeight: 'x-height',
	};
	var PositionSchema = {
	    x: 'number',
	    y: 'number',
	    z: 'number',
	};
	exports.ATTRS_HYPH_TO_CAMEL = {};
	for (var camel in exports.ATTRS_CAMEL_TO_HYPH) {
	    exports.ATTRS_HYPH_TO_CAMEL[exports.ATTRS_CAMEL_TO_HYPH[camel]] = camel;
	}
	INJECTABLES.$element = {
	    schema: {
	        offset: PositionSchema,
	        attributes: {},
	        tagName: 'string',
	        matrix: [],
	        opacity: 'number',
	        origin: PositionSchema,
	        rotation: PositionSchema,
	        scale: PositionSchema,
	        shown: 'boolean',
	        size: { x: 'number', y: 'number' },
	        sizeAbsolute: PositionSchema,
	        sizeProportional: PositionSchema,
	        translation: PositionSchema,
	    },
	    summon: function (injectees, component, node) {
	        injectees.$element = HaikuElement_1.default.findOrCreateByNode(node);
	    },
	};
	INJECTABLES.$window = {
	    schema: {},
	    summon: function (injectees) {
	        injectees.$window = (typeof window !== 'undefined') ? window : {};
	    },
	};
	INJECTABLES.$mount = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$mount = component.context.renderer.mount;
	    },
	};
	INJECTABLES.$timeline = {
	    schema: {},
	    summon: function (injectees, component, node, timelineName) {
	        injectees.$timeline = component.getTimeline(timelineName);
	    },
	};
	INJECTABLES.$clock = {
	    schema: {
	        destroy: 'function',
	        getExplicitTime: 'function',
	        getFrameDuration: 'function',
	        getTime: 'function',
	        setTime: 'function',
	        isRunning: 'function',
	        run: 'function',
	        start: 'function',
	        assignOptions: 'function',
	    },
	    summon: function (injectees, component) {
	        injectees.$clock = component.getClock();
	    },
	};
	INJECTABLES.$core = {
	    schema: {
	        options: Config_1.DEFAULTS,
	        timeline: INJECTABLES.$timeline.schema,
	        clock: INJECTABLES.$clock.schema,
	    },
	    summon: function (injectees, component, node, timelineName) {
	        injectees.$core = {
	            component: component,
	            context: component.context,
	            options: component.config,
	            timeline: component.getTimeline(timelineName),
	            clock: component.getClock(),
	        };
	    },
	};
	INJECTABLES.$context = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$context = component.context;
	    },
	};
	INJECTABLES.$component = {
	    schema: INJECTABLES.$element.schema,
	    summon: function (injectees, component) {
	        injectees.$component = component;
	    },
	};
	INJECTABLES.$host = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$host = component.host;
	    },
	};
	INJECTABLES.$top = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$host = component.top;
	    },
	};
	INJECTABLES.$state = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$state = component.state;
	    },
	};
	INJECTABLES.$parent = {
	    schema: INJECTABLES.$element.schema,
	    summon: function (injectees, component, node) {
	        injectees.$parent = HaikuElement_1.default.findOrCreateByNode(node).parent;
	    },
	};
	INJECTABLES.$container = {
	    schema: INJECTABLES.$element.schema,
	    summon: function (injectees, component, node) {
	        var element = HaikuElement_1.default.findOrCreateByNode(node);
	        injectees.$container = element.owner;
	    },
	};
	INJECTABLES.$children = {
	    schema: INJECTABLES.$element.schema.children,
	    summon: function (injectees, component, node) {
	        injectees.$children = HaikuElement_1.default.findOrCreateByNode(node).children;
	    },
	};
	INJECTABLES.$tree = {
	    schema: {
	        parent: INJECTABLES.$element.schema,
	        chidren: INJECTABLES.$element.schema.children,
	        component: INJECTABLES.$element.schema,
	        root: INJECTABLES.$element.schema,
	        element: INJECTABLES.$element.schema,
	    },
	    summon: function (injectees, component, node) {
	        var element = HaikuElement_1.default.findOrCreateByNode(node);
	        injectees.$tree = {
	            element: element,
	            component: component,
	            parent: element.parent,
	            children: element.children,
	            root: element.owner,
	        };
	    },
	};
	INJECTABLES.$user = {
	    schema: {
	        mouse: {
	            x: 'number',
	            y: 'number',
	            down: 'boolean',
	            buttons: [],
	        },
	        mouches: [],
	        keys: {},
	        touches: [],
	        pan: {
	            x: 'number',
	            y: 'number',
	        },
	    },
	    summon: function (injectees, component, node) {
	        if (component.isLiveMode()) {
	            injectees.$user = component.context.getGlobalUserState();
	            // If we're inside another component, produce mouse coords in terms
	            // of our own coordinate space
	            if (component.host) {
	                Object.assign(injectees.$user.mouse, component.transformContextPointToLocalPoint(Object.assign({}, injectees.$user.mouse)));
	            }
	        }
	        else {
	            injectees.$user = {
	                mouse: {
	                    x: 1,
	                    y: 1,
	                    down: 0,
	                    buttons: [0, 0, 0],
	                },
	                pan: {
	                    x: 0,
	                    y: 0,
	                },
	                keys: {},
	                touches: [],
	                mouches: [],
	            };
	        }
	    },
	};
	var getRepeatHostNode = function (node) {
	    if (!node) {
	        return;
	    }
	    if (node.__memory.repeatee) {
	        return node;
	    }
	    return getRepeatHostNode(node.__memory && node.__memory.parent);
	};
	var getIfHostNode = function (node) {
	    if (!node) {
	        return;
	    }
	    if (node.__memory.if) {
	        return node;
	    }
	    return getIfHostNode(node.__memory && node.__memory.parent);
	};
	INJECTABLES.$flow = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        if (!injectees.$flow) {
	            injectees.$flow = {};
	        }
	        var repeatNode = getRepeatHostNode(node);
	        injectees.$flow.repeat = (repeatNode && repeatNode.__memory.repeatee) || {
	            instructions: [],
	            payload: {},
	            source: repeatNode,
	            index: 0,
	        };
	        var ifNode = getIfHostNode(node);
	        injectees.$flow.if = (ifNode && ifNode.__memory.if) || {
	            answer: null,
	        };
	        injectees.$flow.placeholder = node.__memory.placeholder || {
	            value: null,
	            surrogate: null,
	        };
	    },
	};
	INJECTABLES.$repeat = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        if (!injectees.$repeat) {
	            injectees.$repeat = {};
	        }
	        var repeatNode = getRepeatHostNode(node);
	        injectees.$repeat = (repeatNode && repeatNode.__memory.repeatee) || {
	            instructions: [],
	            payload: {},
	            source: repeatNode,
	            index: 0,
	        };
	    },
	};
	INJECTABLES.$if = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        if (!injectees.$if) {
	            injectees.$if = {};
	        }
	        var ifNode = getIfHostNode(node);
	        injectees.$if = (ifNode && ifNode.__memory.if) || {
	            answer: null,
	        };
	    },
	};
	INJECTABLES.$placeholder = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        if (!injectees.$placeholder) {
	            injectees.$placeholder = {};
	        }
	        injectees.$placeholder = node.__memory.placeholder || {
	            value: null,
	            surrogate: null,
	        };
	    },
	};
	INJECTABLES.$index = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        var repeatNode = getRepeatHostNode(node);
	        injectees.$index = (repeatNode &&
	            repeatNode.__memory.repeatee &&
	            repeatNode.__memory.repeatee.index) || 0;
	    },
	};
	INJECTABLES.$payload = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        var repeatNode = getRepeatHostNode(node);
	        injectees.$payload = (repeatNode &&
	            repeatNode.__memory.repeatee &&
	            repeatNode.__memory.repeatee.payload) || {};
	    },
	};
	INJECTABLES.$helpers = {
	    schema: {
	        now: 'function',
	        rand: 'function',
	        find: 'function',
	    },
	    summon: function (injectees, component) {
	        injectees.$helpers = component.helpers;
	    },
	};
	// List of JavaScript global built-in objects that we want to provide as an injectable.
	// In the future, we might end up passing in modified versions of these objects/functions.
	var BUILTIN_INJECTABLES = {
	    Infinity: Infinity,
	    NaN: NaN,
	    Object: Object,
	    Boolean: Boolean,
	    Math: Math,
	    Date: Date,
	    JSON: JSON,
	    Number: Number,
	    String: String,
	    RegExp: RegExp,
	    Array: Array,
	    isFinite: isFinite,
	    isNaN: isNaN,
	    parseFloat: parseFloat,
	    parseInt: parseInt,
	    decodeURI: decodeURI,
	    decodeURIComponent: decodeURIComponent,
	    encodeURI: encodeURI,
	    encodeURIComponent: encodeURIComponent,
	    // escape,
	    // unescape,
	    Error: Error,
	    ReferenceError: ReferenceError,
	    SyntaxError: SyntaxError,
	    TypeError: TypeError,
	    undefined: void (0),
	};
	var _loop_1 = function (builtinInjectableKey) {
	    INJECTABLES[builtinInjectableKey] = {
	        summon: function (injectees) {
	            injectees[builtinInjectableKey] = BUILTIN_INJECTABLES[builtinInjectableKey];
	        },
	    };
	};
	for (var builtinInjectableKey in BUILTIN_INJECTABLES) {
	    _loop_1(builtinInjectableKey);
	}
	/**
	 * When evaluating expressions written by the user, don't crash everything.
	 * Log the error (but only once, since we're animating) and then return a
	 * fairly safe all-purpose value (1).
	 */
	var safeCall = function (fn, hostInstance, hostStates) {
	    try {
	        return fn.call(hostInstance, hostStates);
	    }
	    catch (exception) {
	        consoleErrorOnce_1.default(exception);
	        return 1;
	    }
	};
	var safeApply = function (fn, hostInstance, summoneesArray) {
	    try {
	        return fn.apply(hostInstance, summoneesArray);
	    }
	    catch (exception) {
	        consoleErrorOnce_1.default(exception);
	        return 1;
	    }
	};
	var areSummoneesDifferent = function (previous, incoming) {
	    if (Array.isArray(previous) && Array.isArray(incoming)) {
	        if (previous.length !== incoming.length) {
	            return true;
	        }
	        // Do a shallow comparison of elements. We don't go deep because:
	        //   - It easily becomes too expensive to do this while rendering
	        //   - We can avoid needing to check for recursion
	        for (var i = 0; i < previous.length; i++) {
	            // Assume that objects are different since we don't want to do a deep comparison
	            if (previous[i] && typeof previous[i] === 'object') {
	                return true;
	            }
	            if (previous[i] !== incoming[i]) {
	                return true;
	            }
	        }
	        for (var j = 0; j < previous.length; j++) {
	            // Assume that objects are different since we don't want to do a deep comparison
	            if (incoming[j] && typeof incoming[j] === 'object') {
	                return true;
	            }
	            if (incoming[j] !== previous[j]) {
	                return true;
	            }
	        }
	        return false;
	    }
	    if (typeof previous === OBJECT && typeof incoming === OBJECT) {
	        if (previous === null && incoming === null) {
	            return false;
	        }
	        if (previous === null) {
	            return true;
	        }
	        if (incoming === null) {
	            return true;
	        }
	        // Do a shallow comparison of properties. We don't go deep because:
	        //   - It easily becomes too expensive to do this while rendering
	        //   - We can avoid needing to check for recursion
	        for (var pkey in previous) {
	            if (previous[pkey] !== incoming[pkey]) {
	                return true;
	            }
	        }
	        for (var ikey in incoming) {
	            if (incoming[ikey] !== previous[ikey]) {
	                return true;
	            }
	        }
	        return false;
	    }
	    return previous !== incoming;
	};
	var stringToInt = function (str) {
	    var hash = 5381;
	    var i = str.length;
	    while (i) {
	        hash = (hash * 33) ^ str.charCodeAt(--i);
	    }
	    return hash >>> 0;
	};
	//# sourceMappingURL=HaikuComponent.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var just_curves_1 = __webpack_require__(183);
	var cubicBezier_1 = __webpack_require__(61);
	var CENT = 1.0;
	var OBJECT = 'object';
	var NUMBER = 'number';
	var STRING = 'string';
	var PERCENT_REGEX = /^\d+(\.\d+)?%$/;
	var PERCENT_SYMBOL = '%';
	var isString = function (value) { return typeof value === STRING; };
	function percentOfTime(t0, t1, tnow) {
	    var span = t1 - t0;
	    if (span === 0) {
	        return CENT;
	    } // No divide-by-zero
	    var remaining = t1 - tnow;
	    return CENT - remaining / span;
	}
	function valueAtPercent(v0, v1, pc) {
	    var span = v1 - v0;
	    var gain = span * pc;
	    return v0 + gain;
	}
	function interpolateValue(v0, v1, t0, t1, tnow, curve) {
	    var pc = percentOfTime(t0, t1, tnow);
	    if (pc > CENT) {
	        pc = CENT;
	    }
	    if (curve) {
	        pc = curve(pc);
	    }
	    return valueAtPercent(v0, v1, pc);
	}
	exports.interpolate = function (now, curve, started, ends, origin, destination) {
	    // Return early if we aren't tweening anything.
	    if (origin === destination) {
	        return origin;
	    }
	    var curveFunc;
	    if (typeof curve === 'string') {
	        // If curve is a string, transform into a function using justCurves
	        curveFunc = just_curves_1.default[curve];
	    }
	    else if (Array.isArray(curve)) {
	        // If curve is an array defining a Bezier curve, create a proper function
	        curveFunc = cubicBezier_1.cubicBezier(curve[0], curve[1], curve[2], curve[3]);
	    }
	    else {
	        // TODO: handle the case of custom functions, concerns for not enabling this
	        // as of right now:
	        // - serialization issues in all their various forms
	        // (copy/paste, subcomponent, undo/redo, flush to disk)
	        // - need to make sure not to crash if the function doesn’t return a number
	        // (without a `typeof` check on every tick)
	        curveFunc = curve;
	    }
	    if (typeof curveFunc !== 'function') {
	        return origin;
	    }
	    if (Array.isArray(origin) && Array.isArray(destination)) {
	        var arrayOutput = [];
	        for (var i = 0; i < origin.length; i++) {
	            arrayOutput[i] = exports.interpolate(now, curveFunc, started, ends, origin[i], destination[i]);
	        }
	        return arrayOutput;
	    }
	    if (origin && typeof origin === OBJECT && destination && typeof destination === OBJECT) {
	        var objectOutput = {};
	        for (var key in origin) {
	            objectOutput[key] = exports.interpolate(now, curveFunc, started, ends, origin[key], destination[key]);
	        }
	        return objectOutput;
	    }
	    if (typeof origin === NUMBER && typeof destination === NUMBER) {
	        return interpolateValue(origin, destination, started, ends, now, curveFunc);
	    }
	    if (isString(origin) &&
	        isString(destination) &&
	        PERCENT_REGEX.test(origin) &&
	        PERCENT_REGEX.test(destination)) {
	        return interpolateValue(parseFloat(origin), parseFloat(destination), started, ends, now, curveFunc) + PERCENT_SYMBOL;
	    }
	    return origin;
	};
	//# sourceMappingURL=Interpolate.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Curve;
	(function (Curve) {
	    Curve["EaseInBack"] = "easeInBack";
	    Curve["EaseInCirc"] = "easeInCirc";
	    Curve["EaseInCubic"] = "easeInCubic";
	    Curve["EaseInExpo"] = "easeInExpo";
	    Curve["EaseInQuad"] = "easeInQuad";
	    Curve["EaseInQuart"] = "easeInQuart";
	    Curve["EaseInBounce"] = "easeInBounce";
	    Curve["EaseInElastic"] = "easeInElastic";
	    Curve["EaseInQuint"] = "easeInQuint";
	    Curve["EaseInSine"] = "easeInSine";
	    Curve["EaseOutBack"] = "easeOutBack";
	    Curve["EaseOutCirc"] = "easeOutCirc";
	    Curve["EaseOutCubic"] = "easeOutCubic";
	    Curve["EaseOutExpo"] = "easeOutExpo";
	    Curve["EaseOutQuad"] = "easeOutQuad";
	    Curve["EaseOutQuart"] = "easeOutQuart";
	    Curve["EaseOutBounce"] = "easeOutBounce";
	    Curve["EaseOutElastic"] = "easeOutElastic";
	    Curve["EaseOutQuint"] = "easeOutQuint";
	    Curve["EaseOutSine"] = "easeOutSine";
	    Curve["EaseInOutBack"] = "easeInOutBack";
	    Curve["EaseInOutCirc"] = "easeInOutCirc";
	    Curve["EaseInOutCubic"] = "easeInOutCubic";
	    Curve["EaseInOutExpo"] = "easeInOutExpo";
	    Curve["EaseInOutQuad"] = "easeInOutQuad";
	    Curve["EaseInOutQuart"] = "easeInOutQuart";
	    Curve["EaseInOutBounce"] = "easeInOutBounce";
	    Curve["EaseInOutElastic"] = "easeInOutElastic";
	    Curve["EaseInOutQuint"] = "easeInOutQuint";
	    Curve["EaseInOutSine"] = "easeInOutSine";
	    Curve["Linear"] = "linear";
	})(Curve = exports.Curve || (exports.Curve = {}));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var sortNumeric = function (a, b) { return a - b; };
	exports.getSortedKeyframes = function (propertyGroup) {
	    return Object.keys(propertyGroup).map(Number).sort(sortNumeric);
	};
	//# sourceMappingURL=KeyframeUtils.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var svg_points_1 = __webpack_require__(190);
	var parseCssValueString_1 = __webpack_require__(114);
	// In leiu of good math, this gives pretty good results for converting arcs to cubic beziers
	var MAGIC_BEZIER_ARC_RATIO = 1.8106602;
	var SVG_TYPES = {
	    g: true,
	    rect: true,
	    polyline: true,
	    polygon: true,
	    path: true,
	    line: true,
	    ellipse: true,
	    circle: true,
	};
	var SVG_POINT_NUMERIC_FIELDS = {
	    cx: true,
	    cy: true,
	    r: true,
	    rx: true,
	    ry: true,
	    x1: true,
	    x2: true,
	    x: true,
	    y: true,
	};
	var SVG_POINT_COMMAND_FIELDS = {
	    d: true,
	    points: true,
	};
	var SVG_COMMAND_TYPES = {
	    path: true,
	    polyline: true,
	    polygon: true,
	};
	function polyPointsStringToPoints(pointsString) {
	    if (!pointsString) {
	        return [];
	    }
	    if (Array.isArray(pointsString)) {
	        return pointsString;
	    }
	    // Normalize "x1,y1 x2,y2" syntax to "x1 y1 x2 y2" syntax before splitting.
	    var chunkedPoints = [];
	    var points = pointsString.trim().replace(/,/g, ' ').split(/\s+/g).map(Number);
	    for (var i = 0; i < points.length; i += 2) {
	        chunkedPoints.push(points.slice(i, i + 2));
	    }
	    return chunkedPoints;
	}
	function pointsToPolyString(points) {
	    if (!points) {
	        return '';
	    }
	    if (typeof points === 'string') {
	        return points;
	    }
	    var arr = [];
	    for (var i = 0; i < points.length; i++) {
	        var point = points[i];
	        var seg = point.join(',');
	        arr.push(seg);
	    }
	    return arr.join(' ');
	}
	function rectToPoints(x, y, width, height, rxIn, ryIn) {
	    var rx = rxIn;
	    var ry = ryIn;
	    if (rx || ry) {
	        if (rx && isNaN(ry)) {
	            ry = rx;
	        } // Assume equal radius if ry is not defined (SVG)
	        if (isNaN(rx)) {
	            rx = 0;
	        }
	        if (isNaN(ry)) {
	            ry = 0;
	        }
	        return [
	            {
	                y: y,
	                x: x + rx,
	                moveTo: true,
	            },
	            {
	                y: y,
	                x: x + width - rx,
	            },
	            {
	                x: x + width,
	                y: y + ry,
	                curve: {
	                    type: 'cubic',
	                    x1: x + width - rx + rx / MAGIC_BEZIER_ARC_RATIO,
	                    y1: y,
	                    x2: x + width,
	                    y2: y + ry / MAGIC_BEZIER_ARC_RATIO,
	                },
	            },
	            {
	                x: x + width,
	                y: y + height - ry,
	            },
	            {
	                x: x + width - rx,
	                y: y + height,
	                curve: {
	                    type: 'cubic',
	                    x1: x + width,
	                    y1: y + height - ry / MAGIC_BEZIER_ARC_RATIO,
	                    x2: x + width - rx + rx / MAGIC_BEZIER_ARC_RATIO,
	                    y2: y + height,
	                },
	            },
	            {
	                x: x + rx,
	                y: y + height,
	            },
	            {
	                x: x,
	                y: y + height - ry,
	                curve: {
	                    type: 'cubic',
	                    x1: x + rx - rx / MAGIC_BEZIER_ARC_RATIO,
	                    y1: y + height,
	                    x2: x,
	                    y2: y + height - ry / MAGIC_BEZIER_ARC_RATIO,
	                },
	            },
	            {
	                x: x,
	                y: y + ry,
	            },
	            {
	                y: y,
	                x: x + rx,
	                closed: true,
	                curve: {
	                    type: 'cubic',
	                    x1: x,
	                    y1: y + ry - ry / MAGIC_BEZIER_ARC_RATIO,
	                    x2: x + rx - rx / MAGIC_BEZIER_ARC_RATIO,
	                    y2: y,
	                },
	            },
	        ];
	    }
	    // Non-rounded rect
	    return [
	        {
	            x: x,
	            y: y,
	            moveTo: true,
	        },
	        {
	            y: y,
	            x: x + width,
	        },
	        {
	            x: x + width,
	            y: y + height,
	        },
	        {
	            x: x,
	            y: y + height,
	            closed: true,
	        },
	        {
	            x: x,
	            y: y,
	        },
	    ];
	}
	function circleToPoints(cx, cy, r) {
	    return ellipseToPoints(cx, cy, r, r);
	}
	function ellipseToPoints(cx, cy, rx, ry) {
	    return [
	        {
	            x: cx,
	            y: cy - ry,
	            moveTo: true,
	        },
	        {
	            x: cx + rx,
	            y: cy,
	            curve: {
	                type: 'cubic',
	                x1: cx + rx / MAGIC_BEZIER_ARC_RATIO,
	                y1: cy - ry,
	                x2: cx + rx,
	                y2: cy - ry / MAGIC_BEZIER_ARC_RATIO,
	            },
	        },
	        {
	            x: cx,
	            y: cy + ry,
	            curve: {
	                type: 'cubic',
	                x1: cx + rx,
	                y1: cy + ry / MAGIC_BEZIER_ARC_RATIO,
	                x2: cx + rx / MAGIC_BEZIER_ARC_RATIO,
	                y2: cy + ry,
	            },
	        },
	        {
	            x: cx - rx,
	            y: cy,
	            curve: {
	                type: 'cubic',
	                x1: cx - rx / MAGIC_BEZIER_ARC_RATIO,
	                y1: cy + ry,
	                x2: cx - rx,
	                y2: cy + ry / MAGIC_BEZIER_ARC_RATIO,
	            },
	        },
	        {
	            x: cx,
	            y: cy - ry,
	            closed: true,
	            curve: {
	                type: 'cubic',
	                x1: cx - rx,
	                y1: cy - ry / MAGIC_BEZIER_ARC_RATIO,
	                x2: cx - rx / MAGIC_BEZIER_ARC_RATIO,
	                y2: cy - ry,
	            },
	        },
	    ];
	}
	function lineToPoints(x1, y1, x2, y2) {
	    var shape = { x1: x1, y1: y1, x2: x2, y2: y2, type: 'line' };
	    return svg_points_1.default.toPoints(shape);
	}
	function pathToPoints(pathString) {
	    if (!pathString) {
	        return [];
	    }
	    var shape = { type: 'path', d: pathString };
	    return svg_points_1.default.toPoints(shape);
	}
	function pointsToPath(pointsArray) {
	    return svg_points_1.default.toPath(pointsArray);
	}
	function manaToPoints(mana) {
	    if (typeof mana.elementName === 'string' &&
	        SVG_TYPES[mana.elementName] &&
	        mana.elementName !== 'rect' &&
	        mana.elementName !== 'g') {
	        var shape = { type: mana.elementName };
	        if (SVG_COMMAND_TYPES[shape.type]) {
	            for (var f2 in SVG_POINT_COMMAND_FIELDS) {
	                if (mana.attributes[f2]) {
	                    shape[f2] = mana.attributes[f2];
	                }
	            }
	        }
	        else {
	            for (var f1 in SVG_POINT_NUMERIC_FIELDS) {
	                if (mana.attributes[f1]) {
	                    shape[f1] = Number(mana.attributes[f1]);
	                }
	            }
	        }
	        return svg_points_1.default.toPoints(shape);
	    }
	    // div, rect, svg ...
	    var width = parseCssValueString_1.default((mana.layout &&
	        mana.layout.computed &&
	        mana.layout.computed.size &&
	        mana.layout.computed.size.x) ||
	        (mana.rect && mana.rect.width) ||
	        (mana.attributes &&
	            mana.attributes.style &&
	            mana.attributes.style.width) ||
	        (mana.attributes && mana.attributes.width) ||
	        (mana.attributes && mana.attributes.x) ||
	        0, null).value;
	    var height = parseCssValueString_1.default((mana.layout &&
	        mana.layout.computed &&
	        mana.layout.computed.size &&
	        mana.layout.computed.size.y) ||
	        (mana.rect && mana.rect.height) ||
	        (mana.attributes &&
	            mana.attributes.style &&
	            mana.attributes.style.height) ||
	        (mana.attributes && mana.attributes.height) ||
	        (mana.attributes && mana.attributes.y) ||
	        0, null).value;
	    var left = parseCssValueString_1.default((mana.rect && mana.rect.left) ||
	        (mana.attributes.style && mana.attributes.style.left) ||
	        mana.attributes.x ||
	        0, null).value;
	    var top = parseCssValueString_1.default((mana.rect && mana.rect.top) ||
	        (mana.attributes.style && mana.attributes.style.top) ||
	        mana.attributes.y ||
	        0, null).value;
	    return svg_points_1.default.toPoints({
	        width: width,
	        height: height,
	        type: 'rect',
	        x: left,
	        y: top,
	    });
	}
	exports.default = {
	    rectToPoints: rectToPoints,
	    circleToPoints: circleToPoints,
	    ellipseToPoints: ellipseToPoints,
	    lineToPoints: lineToPoints,
	    pathToPoints: pathToPoints,
	    pointsToPath: pointsToPath,
	    polyPointsStringToPoints: polyPointsStringToPoints,
	    pointsToPolyString: pointsToPolyString,
	    manaToPoints: manaToPoints,
	};
	//# sourceMappingURL=SVGPoints.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Interaction mode types.
	 * @namespace {object}
	 */
	// tslint:disable-next-line:no-namespace
	var InteractionMode;
	(function (InteractionMode) {
	    InteractionMode.EDIT = 0; // Default mode, all is editable
	    InteractionMode.LIVE = 1; // Live mode
	})(InteractionMode = exports.InteractionMode || (exports.InteractionMode = {}));
	/**
	 * @method isPreviewMode
	 * @argument mode The mode to compare, must ve a valid InteractionMode type.
	 * @description Utility that returns a boolean indicating if the provided
	 * mode is 'preview' mode.
	 * @returns boolean
	 */
	function isPreviewMode(mode) {
	    return mode === InteractionMode.LIVE;
	}
	exports.isPreviewMode = isPreviewMode;
	/**
	 * @method isLiveMode
	 * @argument mode The mode to compare, must ve a valid InteractionMode type.
	 * @description Utility that returns a boolean indicating if the provided
	 * mode is 'preview' mode.
	 * @returns boolean
	 */
	function isLiveMode(mode) {
	    return isPreviewMode(mode);
	}
	exports.isLiveMode = isLiveMode;
	//# sourceMappingURL=interactionModes.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Layout3D_1 = __webpack_require__(14);
	var formatTransform_1 = __webpack_require__(116);
	var scopeOfElement_1 = __webpack_require__(117);
	var SVG = 'svg';
	function hasExplicitStyle(domElement, key) {
	    if (!domElement.haiku) {
	        return false;
	    }
	    if (!domElement.haiku.explicitStyles) {
	        return false;
	    }
	    return domElement.haiku.explicitStyles[key] !== undefined;
	}
	/**
	 * SVG tags which can receive width and height styles.
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/width}
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/height}
	 */
	exports.SVG_SIZEABLES = {
	    feBlend: true,
	    feColorMatrix: true,
	    feComponentTransfer: true,
	    feComposite: true,
	    feConvolveMatrix: true,
	    feDiffuseLighting: true,
	    feDisplacementMap: true,
	    feDropShadow: true,
	    feFlood: true,
	    feGaussianBlur: true,
	    feImage: true,
	    feMerge: true,
	    feMorphology: true,
	    feOffset: true,
	    feSpecularLighting: true,
	    feTile: true,
	    feTurbulence: true,
	    filter: true,
	    foreignObject: true,
	    image: true,
	    mask: true,
	    pattern: true,
	    rect: true,
	    use: true,
	};
	function applyCssLayout(domElement, virtualElement, nodeLayout, computedLayout, context) {
	    // No point continuing if there's no computedLayout contents
	    if (computedLayout.opacity === undefined && !computedLayout.size && !computedLayout.matrix) {
	        return;
	    }
	    var elementScope = scopeOfElement_1.default(virtualElement);
	    if (nodeLayout.shown === false) {
	        if (domElement.style.visibility !== 'hidden') {
	            domElement.style.visibility = 'hidden';
	        }
	    }
	    else if (nodeLayout.shown === true) {
	        if (domElement.style.visibility !== 'visible') {
	            domElement.style.visibility = 'visible';
	        }
	    }
	    if (!hasExplicitStyle(domElement, 'opacity')) {
	        // No opacity defined means use whatever the previously defined opacity was
	        if (computedLayout.opacity === undefined) {
	            // no-op
	        }
	        else {
	            var finalOpacity = void 0;
	            if (computedLayout.opacity >= 0.999) {
	                finalOpacity = 1;
	            }
	            else if (computedLayout.opacity <= 0.0001) {
	                finalOpacity = 0;
	            }
	            else {
	                finalOpacity = computedLayout.opacity;
	            }
	            var opacityString = '' + finalOpacity;
	            if (domElement.style.opacity !== opacityString) {
	                domElement.style.opacity = opacityString;
	            }
	        }
	    }
	    if (computedLayout.size) {
	        if (elementScope === SVG) {
	            // Only set width/height attributes on SVG elements that can potentially receive them
	            // (and do something with them).
	            if (exports.SVG_SIZEABLES[virtualElement.elementName]) {
	                if (computedLayout.size.x !== undefined &&
	                    domElement.getAttribute('width') === null &&
	                    domElement.getAttribute('width') !== computedLayout.size.x) {
	                    domElement.setAttribute('width', computedLayout.size.x);
	                }
	                if (computedLayout.size.y !== undefined &&
	                    domElement.getAttribute('height') === null &&
	                    domElement.getAttribute('height') !== computedLayout.size.y) {
	                    domElement.setAttribute('height', computedLayout.size.y);
	                }
	            }
	        }
	        else {
	            if (!hasExplicitStyle(domElement, 'width')) {
	                if (computedLayout.size.x !== undefined) {
	                    var sizeXString = parseFloat(computedLayout.size.x.toFixed(2)) + 'px';
	                    if (domElement.style.width !== sizeXString) {
	                        domElement.style.width = sizeXString;
	                    }
	                }
	                if (computedLayout.size.y !== undefined) {
	                    var sizeYString = parseFloat(computedLayout.size.y.toFixed(2)) + 'px';
	                    if (domElement.style.height !== sizeYString) {
	                        domElement.style.height = sizeYString;
	                    }
	                }
	            }
	        }
	    }
	    if (Layout3D_1.default.virtualElementIsLayoutContainer(virtualElement) && !domElement.style.transformOrigin) {
	        // Reset the transform-origin so that our layout system can be self-contained.
	        domElement.style.transformOrigin = '0% 0% 0px';
	    }
	    if (computedLayout.matrix) {
	        var matrixString = formatTransform_1.default(computedLayout.matrix, nodeLayout.format);
	        if (matrixString === domElement.haiku.cachedTransform) {
	            return;
	        }
	        domElement.haiku.cachedTransform = matrixString;
	        if (elementScope === SVG &&
	            // IE doesn't support using transform on the CSS style in SVG elements, so if we are in SVG, and if we are
	            // inside an IE context, use the transform attribute itself. Always prefer the transform attribute for 2D inner
	            // SVG attributes, which have more consistent cross-browser behavior.
	            (nodeLayout.format === Layout3D_1.default.FORMATS.TWO ||
	                context.config.platform.isIE ||
	                context.config.platform.isEdge)) {
	            domElement.setAttribute('transform', matrixString);
	        }
	        else if (!hasExplicitStyle(domElement, 'transform') && !domElement.getAttribute('transform')) {
	            // A domElement might have an explicit transform override set, in which case, don't
	            // attach the style transform to this node, because we will likely clobber what they've set
	            domElement.style.transform = matrixString;
	        }
	    }
	}
	exports.default = applyCssLayout;
	//# sourceMappingURL=applyCssLayout.js.map

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.tokenize = function (source, regexps) {
	    var tokens = [];
	    var chunk = source;
	    var total = chunk.length;
	    var iterations = 0;
	    while (chunk.length > 0) {
	        for (var i = 0; i < regexps.length; i++) {
	            var regexp = regexps[i];
	            var match = regexp.re.exec(chunk);
	            if (match) {
	                var value = match[0];
	                tokens.push({ value: value, type: regexp.type });
	                // Need to slice the chunk at the value match length
	                chunk = chunk.slice(match[0].length, chunk.length);
	                break;
	            }
	        }
	        // We've probably failed to parse correctly if we get here
	        if (iterations++ > total) {
	            throw new Error("Unable to tokenize expression " + source);
	        }
	    }
	    return tokens;
	};
	// Order matters
	var PARAMETERS_REGEXPS = [
	    { type: 'whitespace', re: /^[\s]+/ },
	    { type: 'paren_open', re: /^\(/ },
	    { type: 'paren_close', re: /^\)/ },
	    { type: 'square_open', re: /^\[/ },
	    { type: 'square_close', re: /^]/ },
	    { type: 'curly_open', re: /^\{/ },
	    { type: 'curly_close', re: /^\}/ },
	    { type: 'rest', re: /^\.\.\./ },
	    { type: 'colon', re: /^:/ },
	    { type: 'comma', re: /^,/ },
	    { type: 'identifier', re: /^[a-zA-Z0-9_$]+/ },
	];
	exports.tokenizeParameters = function (source) {
	    return exports.tokenize(source, PARAMETERS_REGEXPS);
	};
	var SYMBOLS = '~!@#$%^&*-_=+/|:\'<,>.?'.split('').join('\\');
	var DIRECTIVE_REGEXPS = [
	    { type: 'whitespace', re: /^[\s]+/ },
	    { type: 'paren_open', re: /^\(/ },
	    { type: 'paren_close', re: /^\)/ },
	    // If you want to count -123 as a negative number, use ^-?\d at column 56
	    { type: 'number', re: /^0b[01]+|^0o[0-7]+|^0x[\da-f]+|^\d*\.?\d+(?:e[+-]?\d+)?/i },
	    { type: 'symbol', re: new RegExp('^([$' + SYMBOLS + '][$' + SYMBOLS + ']*)([^\\n\\S]*:(?!:))?') },
	    { type: 'identifier', re: new RegExp('^([$A-Za-z_\\x7f-\\uffff][$\\w\\x7f-\\uffff]*)([^\\n\\S]*:(?!:))?') },
	];
	exports.tokenizeDirective = function (source) {
	    var tokens = exports.tokenize(source, DIRECTIVE_REGEXPS).filter(function (token) {
	        return token.type !== 'whitespace';
	    });
	    tokens.forEach(function (token) {
	        if (token.type === 'number') {
	            token.value = Number(token.value);
	        }
	    });
	    return tokens;
	};
	exports.isNumeric = function (n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	};
	//# sourceMappingURL=Tokenizer.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var enhance_1 = __webpack_require__(30);
	function inject() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var fn = args.shift();
	    if (typeof fn !== 'function') {
	        console.warn('[haiku core] Inject expects a function as the first argument');
	        return fn;
	    }
	    if (args.length > 0) {
	        enhance_1.default(fn, args);
	    }
	    else {
	        enhance_1.default(fn, null); // If no args here, let 'enhance' try to parse them out
	    }
	    // Used by Haiku.app
	    fn.injectee = true;
	    return fn;
	}
	exports.default = inject;
	//# sourceMappingURL=inject.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function createTextNode(domElement, textContent) {
	    return domElement.ownerDocument.createTextNode(textContent);
	}
	exports.default = createTextNode;
	//# sourceMappingURL=createTextNode.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isTextNode(virtualElement) {
	    return (typeof virtualElement !== 'object');
	}
	exports.default = isTextNode;
	//# sourceMappingURL=isTextNode.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pi = Math.PI;
	exports.tau = 2 * exports.pi;
	exports.epsilon = 0.0001;
	exports.c1 = 1.70158;
	exports.c2 = exports.c1 * 1.525;
	exports.c3 = exports.c1 + 1;
	exports.c4 = exports.tau / 3;
	exports.c5 = exports.tau / 4.5;
	//# sourceMappingURL=constants.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var c = "cubic-bezier";
	var s = "steps";
	exports.ease = c + "(.25,.1,.25,1)";
	exports.easeIn = c + "(.42,0,1,1)";
	exports.easeInBack = c + "(.6,-.28,.735,.045)";
	exports.easeInCirc = c + "(.6,.04,.98,.335)";
	exports.easeInCubic = c + "(.55,.055,.675,.19)";
	exports.easeInExpo = c + "(.95,.05,.795,.035)";
	exports.easeInOut = c + "(.42,0,.58,1)";
	exports.easeInOutBack = c + "(.68,-.55,.265,1.55)";
	exports.easeInOutCirc = c + "(.785,.135,.15,.86)";
	exports.easeInOutCubic = c + "(.645,.045,.355,1)";
	exports.easeInOutExpo = c + "(1,0,0,1)";
	exports.easeInOutQuad = c + "(.455,.03,.515,.955)";
	exports.easeInOutQuart = c + "(.77,0,.175,1)";
	exports.easeInOutQuint = c + "(.86,0,.07,1)";
	exports.easeInOutSine = c + "(.445,.05,.55,.95)";
	exports.easeInQuad = c + "(.55,.085,.68,.53)";
	exports.easeInQuart = c + "(.895,.03,.685,.22)";
	exports.easeInQuint = c + "(.755,.05,.855,.06)";
	exports.easeInSine = c + "(.47,0,.745,.715)";
	exports.easeOut = c + "(0,0,.58,1)";
	exports.easeOutBack = c + "(.175,.885,.32,1.275)";
	exports.easeOutCirc = c + "(.075,.82,.165,1)";
	exports.easeOutCubic = c + "(.215,.61,.355,1)";
	exports.easeOutExpo = c + "(.19,1,.22,1)";
	exports.easeOutQuad = c + "(.25,.46,.45,.94)";
	exports.easeOutQuart = c + "(.165,.84,.44,1)";
	exports.easeOutQuint = c + "(.23,1,.32,1)";
	exports.easeOutSine = c + "(.39,.575,.565,1)";
	exports.elegantSlowStartEnd = c + "(.175,.885,.32,1.275)";
	exports.linear = c + "(0,0,1,1)";
	exports.stepEnd = s + "(1,0)";
	exports.stepStart = s + "(1,1)";
	//# sourceMappingURL=cssEasings.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var math_1 = __webpack_require__(33);
	var constants_1 = __webpack_require__(59);
	var bezier = function (n1, n2, t) {
	    return 3 * n1 * (1 - t) * (1 - t) * t + 3 * n2 * (1 - t) * t * t + t * t * t;
	};
	exports.cubicBezier = function (p0, p1, p2, p3) {
	    if (p0 < 0 || p0 > 1 || p2 < 0 || p2 > 1) {
	        return function (x) { return x; };
	    }
	    return function (x) {
	        if (x === 0 || x === 1) {
	            return x;
	        }
	        var start = 0;
	        var end = 1;
	        var limit = 19;
	        do {
	            var mid = (start + end) * .5;
	            var xEst = bezier(p0, p2, mid);
	            if (math_1.abs(x - xEst) < constants_1.epsilon) {
	                return bezier(p1, p3, mid);
	            }
	            if (xEst < x) {
	                start = mid;
	            }
	            else {
	                end = mid;
	            }
	        } while (--limit);
	        // limit is reached
	        return x;
	    };
	};
	//# sourceMappingURL=cubicBezier.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 *
	 * Internet Systems Consortium license (ISC)
	 *
	 * Copyright (c) 2016 Colin Meinke
	 *
	 * Permission to use, copy, modify, and/or distribute this software for any purpose
	 * with or without fee is hereby granted, provided that the above copyright notice
	 * and this permission notice appear in all copies.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 * FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT,
	 * OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE,
	 * DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
	 * ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var convertQuadraticToCubicBezier = function (spec, prevSpec) { return prevSpec ?
	    {
	        curve: {
	            type: 'cubic',
	            x1: prevSpec.x + 2 / 3 * (spec.curve.x1 - prevSpec.x),
	            y1: prevSpec.y + 2 / 3 * (spec.curve.y1 - prevSpec.y),
	            x2: spec.x + 2 / 3 * (spec.curve.x1 - spec.x),
	            y2: spec.y + 2 / 3 * (spec.curve.y1 - spec.y),
	        },
	        x: spec.x,
	        y: spec.y,
	    } :
	    // This should never happen, but just return the original spec if we didn't have a starting point.
	    spec; };
	var toPoints = function (spec) {
	    switch (spec.type) {
	        case 'circle':
	            return getPointsFromCircle(spec);
	        case 'ellipse':
	            return getPointsFromEllipse(spec);
	        case 'line':
	            return getPointsFromLine(spec);
	        case 'path':
	            return getPointsFromPath(spec);
	        case 'polygon':
	            return getPointsFromPolygon(spec);
	        case 'polyline':
	            return getPointsFromPolyline(spec);
	        case 'rect':
	            return getPointsFromRect(spec);
	        default:
	            return [];
	    }
	};
	var getPointsFromCircle = function (_a) {
	    var cx = _a.cx, cy = _a.cy, r = _a.r;
	    return [
	        {
	            x: cx,
	            y: cy - r,
	            moveTo: true,
	        },
	        {
	            x: cx,
	            y: cy + r,
	            curve: {
	                type: 'arc',
	                rx: r,
	                ry: r,
	                sweepFlag: 1,
	            },
	        },
	        {
	            x: cx,
	            y: cy - r,
	            curve: {
	                type: 'arc',
	                rx: r,
	                ry: r,
	                sweepFlag: 1,
	            },
	        },
	    ];
	};
	var getPointsFromEllipse = function (_a) {
	    var cx = _a.cx, cy = _a.cy, rx = _a.rx, ry = _a.ry;
	    return [
	        {
	            x: cx,
	            y: cy - ry,
	            moveTo: true,
	        },
	        {
	            x: cx,
	            y: cy + ry,
	            curve: {
	                rx: rx,
	                ry: ry,
	                type: 'arc',
	                sweepFlag: 1,
	            },
	        },
	        {
	            x: cx,
	            y: cy - ry,
	            curve: {
	                rx: rx,
	                ry: ry,
	                type: 'arc',
	                sweepFlag: 1,
	            },
	        },
	    ];
	};
	var getPointsFromLine = function (_a) {
	    var x1 = _a.x1, x2 = _a.x2, y1 = _a.y1, y2 = _a.y2;
	    return [
	        {
	            x: x1,
	            y: y1,
	            moveTo: true,
	        },
	        {
	            x: x2,
	            y: y2,
	        },
	    ];
	};
	var validCommands = /[MmLlHhVvCcSsQqTtAaZz]/g;
	var commandLengths = {
	    A: 7,
	    C: 6,
	    H: 1,
	    L: 2,
	    M: 2,
	    Q: 4,
	    S: 4,
	    T: 2,
	    V: 1,
	    Z: 0,
	};
	var relativeCommands = [
	    'a',
	    'c',
	    'h',
	    'l',
	    'm',
	    'q',
	    's',
	    't',
	    'v',
	];
	var PARSING_REGEXPS = {
	    command: /^[MmLlHhVvCcSsQqTtAaZz]/g,
	    whitespace: /^[\s]+/,
	    comma: /^,/,
	    number: /^0b[01]+|^0o[0-7]+|^0x[\da-f]+|^-?\d*\.?\d+(?:e[+-]?\d+)?/i,
	};
	var isRelative = function (command) { return relativeCommands.indexOf(command) !== -1; };
	var optionalArcKeys = ['xAxisRotation', 'largeArcFlag', 'sweepFlag'];
	var getCommands = function (d) { return d && d.match(validCommands); };
	function tokenize(d) {
	    var tokens = [];
	    var chunk = d;
	    while (chunk.length > 0) {
	        for (var regexpName in PARSING_REGEXPS) {
	            var match = PARSING_REGEXPS[regexpName].exec(chunk);
	            if (match) {
	                tokens.push({
	                    type: regexpName,
	                    raw: match[0],
	                });
	                // Need to slice the chunk at the original match length
	                chunk = chunk.slice(match[0].length, chunk.length);
	                break;
	            }
	        }
	    }
	    return tokens;
	}
	var getParams = function (d) {
	    var tokens = tokenize(d);
	    var fixed = tokens.filter(function (t) {
	        return t.type === 'number' || t.type === 'command' || t.type === 'comma';
	    }).map(function (t) {
	        return t.raw;
	    }).join(' ');
	    var segs = fixed.split(validCommands)
	        .map(function (p) {
	        return p.trim();
	    })
	        .filter(function (p) {
	        return p.length > 0;
	    });
	    return segs.map(function (s) {
	        return s.split(/[ ,]+/)
	            .map(function (n) {
	            return parseFloat(n);
	        })
	            .filter(function (n) {
	            return !isNaN(n);
	        });
	    });
	};
	var getPointsFromPath = function (_a) {
	    var d = _a.d;
	    var commands = getCommands(d);
	    if (!commands) {
	        return [];
	    }
	    var params = getParams(d);
	    var points = [];
	    var moveTo;
	    for (var i = 0, l = commands.length; i < l; i++) {
	        var command = commands[i];
	        var upperCaseCommand = command.toUpperCase();
	        var commandLength = commandLengths[upperCaseCommand];
	        var relative = isRelative(command);
	        var prevPoint = (points.length < 1) ? null : points[points.length - 1];
	        if (commandLength > 0) {
	            var commandParams = params.shift();
	            var iterations = commandParams.length / commandLength;
	            for (var j = 0; j < iterations; j++) {
	                prevPoint = (points.length < 1) ? null : points[points.length - 1];
	                switch (upperCaseCommand) {
	                    case 'M':
	                        var x = (relative && prevPoint ? prevPoint.x : 0) + commandParams.shift();
	                        var y = (relative && prevPoint ? prevPoint.y : 0) + commandParams.shift();
	                        moveTo = {
	                            x: x,
	                            y: y,
	                        };
	                        points.push({
	                            x: x,
	                            y: y,
	                            moveTo: true,
	                        });
	                        break;
	                    case 'L':
	                        points.push({
	                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                            y: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                        });
	                        break;
	                    case 'H':
	                        points.push({
	                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                            y: prevPoint.y,
	                        });
	                        break;
	                    case 'V':
	                        points.push({
	                            x: prevPoint.x,
	                            y: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                        });
	                        break;
	                    case 'A':
	                        points.push({
	                            curve: {
	                                type: 'arc',
	                                rx: commandParams.shift(),
	                                ry: commandParams.shift(),
	                                xAxisRotation: commandParams.shift(),
	                                largeArcFlag: commandParams.shift(),
	                                sweepFlag: commandParams.shift(),
	                            },
	                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                            y: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                        });
	                        for (var _i = 0, optionalArcKeys_1 = optionalArcKeys; _i < optionalArcKeys_1.length; _i++) {
	                            var k = optionalArcKeys_1[_i];
	                            if (points[points.length - 1].curve[k] === 0) {
	                                delete points[points.length - 1].curve[k];
	                            }
	                        }
	                        break;
	                    case 'C':
	                        points.push({
	                            curve: {
	                                type: 'cubic',
	                                x1: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                                y1: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                                x2: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                                y2: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                            },
	                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                            y: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                        });
	                        break;
	                    case 'S':
	                        var sx2 = (relative ? prevPoint.x : 0) + commandParams.shift();
	                        var sy2 = (relative ? prevPoint.y : 0) + commandParams.shift();
	                        var sx = (relative ? prevPoint.x : 0) + commandParams.shift();
	                        var sy = (relative ? prevPoint.y : 0) + commandParams.shift();
	                        var diff = {
	                            x: null,
	                            y: null,
	                        };
	                        var sx1 = void 0;
	                        var sy1 = void 0;
	                        if (prevPoint.curve && prevPoint.curve.type === 'cubic') {
	                            diff.x = Math.abs(prevPoint.x - prevPoint.curve.x2);
	                            diff.y = Math.abs(prevPoint.y - prevPoint.curve.y2);
	                            sx1 = prevPoint.x < prevPoint.curve.x2 ? prevPoint.x - diff.x : prevPoint.x + diff.x;
	                            sy1 = prevPoint.y < prevPoint.curve.y2 ? prevPoint.y - diff.y : prevPoint.y + diff.y;
	                        }
	                        else {
	                            diff.x = Math.abs(sx - sx2);
	                            diff.y = Math.abs(sy - sy2);
	                            sx1 = prevPoint.x;
	                            sy1 = prevPoint.y;
	                        }
	                        points.push({
	                            curve: {
	                                type: 'cubic',
	                                x1: sx1,
	                                y1: sy1,
	                                x2: sx2,
	                                y2: sy2,
	                            },
	                            x: sx,
	                            y: sy,
	                        });
	                        break;
	                    case 'Q':
	                        points.push(convertQuadraticToCubicBezier({
	                            curve: {
	                                type: 'quadratic',
	                                x1: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                                y1: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                            },
	                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                            y: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                        }, prevPoint));
	                        break;
	                    case 'T':
	                        var tx = (relative ? prevPoint.x : 0) + commandParams.shift();
	                        var ty = (relative ? prevPoint.y : 0) + commandParams.shift();
	                        var tx1 = void 0;
	                        var ty1 = void 0;
	                        if (prevPoint.curve && prevPoint.curve.type === 'quadratic') {
	                            var diff_1 = {
	                                x: Math.abs(prevPoint.x - prevPoint.curve.x1),
	                                y: Math.abs(prevPoint.y - prevPoint.curve.y1),
	                            };
	                            tx1 = prevPoint.x < prevPoint.curve.x1 ? prevPoint.x - diff_1.x : prevPoint.x + diff_1.x;
	                            ty1 = prevPoint.y < prevPoint.curve.y1 ? prevPoint.y - diff_1.y : prevPoint.y + diff_1.y;
	                        }
	                        else {
	                            tx1 = prevPoint.x;
	                            ty1 = prevPoint.y;
	                        }
	                        points.push(convertQuadraticToCubicBezier({
	                            curve: {
	                                type: 'quadratic',
	                                x1: tx1,
	                                y1: ty1,
	                            },
	                            x: tx,
	                            y: ty,
	                        }, prevPoint));
	                        break;
	                }
	            }
	        }
	        else if (prevPoint !== null) {
	            if (upperCaseCommand === 'Z') {
	                prevPoint.closed = true;
	            }
	            if (moveTo !== undefined && (prevPoint.x !== moveTo.x || prevPoint.y !== moveTo.y)) {
	                points.push({
	                    x: moveTo.x,
	                    y: moveTo.y,
	                });
	            }
	        }
	    }
	    return points;
	};
	var getPointsFromPolygon = function (_a) {
	    var points = _a.points;
	    return getPointsFromPoints({
	        points: points,
	        closed: true,
	    });
	};
	var getPointsFromPolyline = function (_a) {
	    var points = _a.points;
	    return getPointsFromPoints({
	        points: points,
	        closed: false,
	    });
	};
	var getPointsFromPoints = function (_a) {
	    var closed = _a.closed, points = _a.points;
	    var numbers = points.split(/[\s,]+/).map(function (n) { return parseFloat(n); });
	    var p = numbers.reduce(function (arr, point, i) {
	        if (i % 2 === 0) {
	            arr.push({ x: point });
	        }
	        else {
	            arr[(i - 1) / 2].y = point;
	        }
	        return arr;
	    }, []);
	    if (closed) {
	        p.push(__assign({}, p[0]));
	    }
	    p[0].moveTo = true;
	    return p;
	};
	var getPointsFromRect = function (_a) {
	    var height = _a.height, rx = _a.rx, ry = _a.ry, width = _a.width, x = _a.x, y = _a.y;
	    if (rx || ry) {
	        return getPointsFromRectWithCornerRadius({
	            height: height,
	            width: width,
	            x: x,
	            y: y,
	            rx: rx || ry,
	            ry: ry || rx,
	            type: 'rect',
	        });
	    }
	    return getPointsFromBasicRect({
	        height: height,
	        width: width,
	        x: x,
	        y: y,
	    });
	};
	var getPointsFromBasicRect = function (_a) {
	    var height = _a.height, width = _a.width, x = _a.x, y = _a.y;
	    return [
	        {
	            x: x,
	            y: y,
	            moveTo: true,
	        },
	        {
	            y: y,
	            x: x + width,
	        },
	        {
	            x: x + width,
	            y: y + height,
	        },
	        {
	            x: x,
	            y: y + height,
	        },
	        {
	            x: x,
	            y: y,
	        },
	    ];
	};
	var getPointsFromRectWithCornerRadius = function (_a) {
	    var height = _a.height, rx = _a.rx, ry = _a.ry, width = _a.width, x = _a.x, y = _a.y;
	    var curve = {
	        rx: rx,
	        ry: ry,
	        type: 'arc',
	        sweepFlag: 1,
	    };
	    return [
	        {
	            y: y,
	            x: x + rx,
	            moveTo: true,
	        },
	        {
	            y: y,
	            x: x + width - rx,
	        },
	        {
	            curve: curve,
	            x: x + width,
	            y: y + ry,
	        },
	        {
	            x: x + width,
	            y: y + height - ry,
	        },
	        {
	            curve: curve,
	            x: x + width - rx,
	            y: y + height,
	        },
	        {
	            x: x + rx,
	            y: y + height,
	        },
	        {
	            curve: curve,
	            x: x,
	            y: y + height - ry,
	        },
	        {
	            x: x,
	            y: y + ry,
	        },
	        {
	            curve: curve,
	            y: y,
	            x: x + rx,
	        },
	    ];
	};
	exports.default = toPoints;
	//# sourceMappingURL=toPoints.js.map

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propValidation = __webpack_require__(72);
	
	var _ParallaxController = __webpack_require__(37);
	
	var _ParallaxController2 = _interopRequireDefault(_ParallaxController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Parallax = function (_Component) {
	    _inherits(Parallax, _Component);
	
	    function Parallax() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Parallax);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Parallax.__proto__ || Object.getPrototypeOf(Parallax)).call.apply(_ref, [this].concat(args))), _this), _this.mapRefOuter = function (ref) {
	            _this._outer = ref;
	        }, _this.mapRefInner = function (ref) {
	            _this._inner = ref;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Parallax, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Make sure the provided controller is an instance of the Parallax Controller
	            var isInstance = this.controller instanceof _ParallaxController2.default;
	
	            // Throw if neither context or global is available
	            if (!this.controller && !isInstance) {
	                throw new Error("Must wrap your application's <Parallax /> components in a <ParallaxProvider />.");
	            }
	
	            // Deprecation warning for <=1.0.0
	            // If no context is available but the window global is then warn
	            if (!this.context.parallaxController && window.ParallaxController) {
	                console.log('Calling ParallaxController.init() has been deprecated in favor of using the <ParallaxProvider /> component. For usage details see: https://github.com/jscottsmith/react-scroll-parallax/tree/v1.1.0#usage');
	            }
	
	            // create a new parallax element and save the reference
	            this.element = this.controller.createElement({
	                elInner: this._inner,
	                elOuter: this._outer,
	                props: {
	                    disabled: this.props.disabled,
	                    offsetXMax: this.props.offsetXMax,
	                    offsetXMin: this.props.offsetXMin,
	                    offsetYMax: this.props.offsetYMax,
	                    offsetYMin: this.props.offsetYMin,
	                    slowerScrollRate: this.props.slowerScrollRate
	                }
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // updates the elements props when relevant parallax props change
	            if (this.props.disabled !== nextProps.disabled || this.props.offsetXMax !== nextProps.offsetXMax || this.props.offsetXMin !== nextProps.offsetXMin || this.props.offsetYMax !== nextProps.offsetYMax || this.props.offsetYMin !== nextProps.offsetYMin || this.props.slowerScrollRate !== nextProps.slowerScrollRate) {
	                this.controller.updateElement(this.element, {
	                    props: {
	                        disabled: nextProps.disabled,
	                        offsetXMax: nextProps.offsetXMax,
	                        offsetXMin: nextProps.offsetXMin,
	                        offsetYMax: nextProps.offsetYMax,
	                        offsetYMin: nextProps.offsetYMin,
	                        slowerScrollRate: nextProps.slowerScrollRate
	                    }
	                });
	            }
	            // resets element styles when disabled
	            if (this.props.disabled !== nextProps.disabled && nextProps.disabled) {
	                this.controller.resetElementStyles(this.element);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.controller.removeElement(this.element);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                className = _props.className,
	                Tag = _props.tag,
	                styleOuter = _props.styleOuter,
	                styleInner = _props.styleInner;
	
	
	            var rootClass = 'parallax-outer' + (className ? ' ' + className : '');
	
	            return _react2.default.createElement(
	                Tag,
	                {
	                    className: rootClass,
	                    ref: this.mapRefOuter,
	                    style: styleOuter
	                },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: 'parallax-inner',
	                        ref: this.mapRefInner,
	                        style: styleInner
	                    },
	                    children
	                )
	            );
	        }
	    }, {
	        key: 'controller',
	        get: function get() {
	            // Legacy versions may use the global, not context
	            return this.context.parallaxController || window.ParallaxController;
	        }
	
	        // refs
	
	    }]);
	
	    return Parallax;
	}(_react.Component);
	
	Parallax.defaultProps = {
	    disabled: false,
	    offsetYMax: 0,
	    offsetYMin: 0,
	    offsetXMax: 0,
	    offsetXMin: 0,
	    slowerScrollRate: false, // determines whether scroll rate is faster or slower than standard scroll
	    tag: 'div'
	};
	Parallax.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool.isRequired,
	    offsetXMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    offsetXMin: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    offsetYMax: _propValidation.offsetMax,
	    offsetYMin: _propValidation.offsetMin,
	    slowerScrollRate: _propTypes2.default.bool.isRequired,
	    styleOuter: _propTypes2.default.object,
	    styleInner: _propTypes2.default.object,
	    tag: _propTypes2.default.string.isRequired
	};
	Parallax.contextTypes = {
	    parallaxController: _propTypes2.default.object // not required because this could be rendered on the server.
	};
	exports.default = Parallax;
	module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testForPassiveScroll = exports.scaleBetween = exports.parseValueAndUnit = exports.isElementInView = exports.getParallaxOffsets = exports.clamp = undefined;
	
	var _clamp2 = __webpack_require__(208);
	
	var _clamp3 = _interopRequireDefault(_clamp2);
	
	var _getParallaxOffsets2 = __webpack_require__(209);
	
	var _getParallaxOffsets3 = _interopRequireDefault(_getParallaxOffsets2);
	
	var _isElementInView2 = __webpack_require__(210);
	
	var _isElementInView3 = _interopRequireDefault(_isElementInView2);
	
	var _parseValueAndUnit2 = __webpack_require__(211);
	
	var _parseValueAndUnit3 = _interopRequireDefault(_parseValueAndUnit2);
	
	var _scaleBetween2 = __webpack_require__(212);
	
	var _scaleBetween3 = _interopRequireDefault(_scaleBetween2);
	
	var _testForPassiveScroll2 = __webpack_require__(213);
	
	var _testForPassiveScroll3 = _interopRequireDefault(_testForPassiveScroll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.clamp = _clamp3.default;
	exports.getParallaxOffsets = _getParallaxOffsets3.default;
	exports.isElementInView = _isElementInView3.default;
	exports.parseValueAndUnit = _parseValueAndUnit3.default;
	exports.scaleBetween = _scaleBetween3.default;
	exports.testForPassiveScroll = _testForPassiveScroll3.default;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.offsetMin = offsetMin;
	exports.offsetMax = offsetMax;
	function offsetMin(props, propName) {
	    var componentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ANONYMOUS';
	
	    var value = props[propName];
	    var isValid = typeof value === 'string' || typeof value === 'number';
	
	    if (!isValid) {
	        return new Error('[' + propName + '] in ' + componentName + ' must be a string with with "%"" or "px" units or number.');
	    }
	
	    if (props[propName]) {
	        if (typeof value === 'string') {
	            value = parseInt(value, 10);
	        }
	        return value <= 0 ? null : new Error('[' + propName + '] in ' + componentName + ' is greater than zero. [' + propName + '] must be less than or equal to zero.');
	    }
	    return null;
	}
	
	function offsetMax(props, propName) {
	    var componentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ANONYMOUS';
	
	    var value = props[propName];
	    var isValid = typeof value === 'string' || typeof value === 'number';
	
	    if (!isValid) {
	        return new Error('[' + propName + '] in ' + componentName + ' must be a string with with "%"" or "px" units or number.');
	    }
	
	    if (props[propName]) {
	        if (typeof value === 'string') {
	            value = parseInt(value, 10);
	        }
	        return value >= 0 ? null : new Error('[' + propName + '] in ' + componentName + ' is less than zero. [' + propName + '] must be greater than or equal to zero.');
	    }
	    return null;
	}

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuBase_1 = __webpack_require__(13);
	var HaikuGlobal_1 = __webpack_require__(28);
	var assign_1 = __webpack_require__(18);
	var raf_1 = __webpack_require__(188);
	var NUMBER = 'number';
	var DEFAULT_OPTIONS = {
	    // frameDuration: Number
	    // Time to elapse per frame (ms)
	    frameDuration: 16.666,
	    // frameDelay: Number
	    // How long to wait between each tick (ms)
	    frameDelay: 16.666,
	    // marginOfErrorForDelta: Number
	    // A bit of grace when calculating whether a new frame should be run
	    marginOfErrorForDelta: 1.0,
	    // run: Boolean
	    // Whether or not the clock should run by default
	    run: true,
	};
	// The global animation harness is a singleton
	// We don't want to create new ones even on reload
	if (!HaikuGlobal_1.default.HaikuGlobalAnimationHarness) {
	    var queue_1 = [];
	    var frame_1 = function () {
	        var length = queue_1.length;
	        for (var i = 0; i < length; i++) {
	            queue_1[i]();
	        }
	        HaikuGlobal_1.default.HaikuGlobalAnimationHarness.raf = raf_1.default.request(frame_1);
	    };
	    HaikuGlobal_1.default.HaikuGlobalAnimationHarness = {
	        // Array of functions to call on every rAF tick
	        queue: queue_1,
	        // The main frame function, loops through all those who
	        // need an animation tick and calls them
	        frame: frame_1,
	        // Need a mechanism to cancel the rAF loop, or else some contexts
	        // (e.g. tests) will have leaked handles
	        cancel: function () {
	            if (HaikuGlobal_1.default.HaikuGlobalAnimationHarness.raf) {
	                raf_1.default.cancel(HaikuGlobal_1.default.HaikuGlobalAnimationHarness.raf);
	            }
	        },
	    };
	    // Trigger the loop to start; we'll push frame functions into its queue later
	    HaikuGlobal_1.default.HaikuGlobalAnimationHarness.frame();
	}
	// tslint:disable:variable-name
	var HaikuClock = /** @class */ (function (_super) {
	    __extends(HaikuClock, _super);
	    function HaikuClock(tickables, options) {
	        var _this = _super.call(this) || this;
	        _this.boundRunner = function () {
	            _this.run();
	        };
	        _this._tickables = tickables;
	        _this.assignOptions(options);
	        _this._isRunning = false;
	        _this.reinitialize();
	        if (_this.options.run) {
	            // Bind to avoid `this`-detachment when called by raf
	            HaikuGlobal_1.default.HaikuGlobalAnimationHarness.queue.push(_this.boundRunner);
	        }
	        // Tests and others may need this to cancel the rAF loop, to avoid leaked handles
	        _this.GLOBAL_ANIMATION_HARNESS = HaikuGlobal_1.default.HaikuGlobalAnimationHarness;
	        return _this;
	    }
	    HaikuClock.prototype.reinitialize = function () {
	        this._numLoopsRun = 0;
	        this._localFramesElapsed = 0;
	        this._localTimeElapsed = 0;
	        this._deltaSinceLastTick = 0;
	        this._localExplicitlySetTime = null;
	        return this;
	    };
	    HaikuClock.prototype.addTickable = function (tickable) {
	        this._tickables.push(tickable);
	        return this;
	    };
	    HaikuClock.prototype.assignOptions = function (options) {
	        this.options = assign_1.default(this.options || {}, DEFAULT_OPTIONS, options || {});
	        return this;
	    };
	    HaikuClock.prototype.run = function () {
	        if (this.isRunning()) {
	            // If time is "controlled" we are locked to an explicitly set local time, so no math is needed.
	            if (this.isTimeControlled()) {
	                this.tick();
	            }
	            else {
	                // If we got here, we need to evaluate the time elapsed, and determine if we've waited long enough for a frame
	                this._numLoopsRun++;
	                var prevTime = this._localTimeElapsed;
	                var nextTime = prevTime + this.options.frameDuration;
	                var deltaSinceLastTick = nextTime - prevTime + this._deltaSinceLastTick;
	                if (deltaSinceLastTick >=
	                    this.options.frameDelay - this.options.marginOfErrorForDelta) {
	                    this.tick();
	                    this._localFramesElapsed++;
	                    this._localTimeElapsed = nextTime;
	                    this._deltaSinceLastTick = 0; // Must reset delta when frame has been completed
	                }
	                else {
	                    // If we got here, this loop is faster than the desired speed; wait till next call
	                    this._deltaSinceLastTick = deltaSinceLastTick;
	                }
	            }
	        }
	    };
	    HaikuClock.prototype.tick = function () {
	        for (var i = 0; i < this._tickables.length; i++) {
	            this._tickables[i].performTick();
	        }
	    };
	    HaikuClock.prototype.getTime = function () {
	        return this.getExplicitTime();
	    };
	    HaikuClock.prototype.setTime = function (time) {
	        this._localExplicitlySetTime = parseInt(time || 0, 10);
	        return this;
	    };
	    HaikuClock.prototype.getFPS = function () {
	        return Math.round(1000 / this.options.frameDuration);
	    };
	    /**
	     * @method getExplicitTime
	     * @description Return either the running time or the controlled time, depending on whether this
	     * clock is in control mode or not.
	     */
	    HaikuClock.prototype.getExplicitTime = function () {
	        if (this.isTimeControlled()) {
	            return this.getControlledTime();
	        }
	        return this.getRunningTime();
	    };
	    /**
	     * @method getControlledTime
	     * @description Return the value of time that has been explicitly controlled.
	     */
	    HaikuClock.prototype.getControlledTime = function () {
	        return this._localExplicitlySetTime;
	    };
	    HaikuClock.prototype.isTimeControlled = function () {
	        return typeof this._localExplicitlySetTime === NUMBER;
	    };
	    /**
	     * @method getRunningTime
	     * @description Return the running time, which is the value of time that has elapsed whether or
	     * not time has been 'controlled' in control mode.
	     */
	    HaikuClock.prototype.getRunningTime = function () {
	        return this._localTimeElapsed;
	    };
	    HaikuClock.prototype.isRunning = function () {
	        return this._isRunning;
	    };
	    HaikuClock.prototype.start = function () {
	        this._isRunning = true;
	        return this;
	    };
	    HaikuClock.prototype.stop = function () {
	        this._isRunning = false;
	        return this;
	    };
	    HaikuClock.prototype.getFrameDuration = function () {
	        return this.options.frameDuration;
	    };
	    HaikuClock.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        for (var i = 0; i < HaikuGlobal_1.default.HaikuGlobalAnimationHarness.queue.length; i++) {
	            if (HaikuGlobal_1.default.HaikuGlobalAnimationHarness.queue[i] === this.boundRunner) {
	                HaikuGlobal_1.default.HaikuGlobalAnimationHarness.queue.splice(i, 1);
	                return;
	            }
	        }
	    };
	    Object.defineProperty(HaikuClock.prototype, "frameDuration", {
	        get: function () {
	            return this.options.frameDuration;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuClock.prototype, "frameDelay", {
	        get: function () {
	            return this.options.frameDelay;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuClock.prototype, "time", {
	        get: function () {
	            return this.getExplicitTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuClock.__name__ = 'HaikuClock';
	    return HaikuClock;
	}(HaikuBase_1.default));
	exports.default = HaikuClock;
	//# sourceMappingURL=HaikuClock.js.map

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var Config_1 = __webpack_require__(27);
	var HaikuBase_1 = __webpack_require__(13);
	var HaikuClock_1 = __webpack_require__(91);
	var HaikuComponent_1 = __webpack_require__(48);
	var pkg = __webpack_require__(17);
	var VERSION = pkg.version;
	/**
	 * @class HaikuContext
	 * @description Represents the root of a Haiku component tree within an application.
	 * A Haiku component tree may contain many components, but there is only one context.
	 * The context is where information shared by all components in the tree should go, e.g. clock time.
	 */
	// tslint:disable:variable-name
	var HaikuContext = /** @class */ (function (_super) {
	    __extends(HaikuContext, _super);
	    function HaikuContext(mount, renderer, platform, bytecode, config) {
	        var _this = _super.call(this) || this;
	        if (!renderer) {
	            throw new Error('Context requires a renderer');
	        }
	        if (!bytecode) {
	            throw new Error('Context requires bytecode');
	        }
	        _this.PLAYER_VERSION = VERSION; // #LEGACY
	        _this.CORE_VERSION = VERSION;
	        _this.assignConfig(config || {}, null);
	        _this.mount = mount;
	        // Make some Haiku internals available on the mount object for hot editing hooks, or for debugging convenience.
	        if (_this.mount && !_this.mount.haiku) {
	            _this.mount.haiku = {
	                context: _this,
	            };
	        }
	        _this.renderer = renderer;
	        // Initialize sets up top-level dom listeners so we don't run it if we don't have a mount
	        if (_this.mount && _this.renderer.initialize) {
	            _this.renderer.initialize();
	        }
	        _this.platform = platform;
	        // List of tickable objects managed by this context. These are invoked on every clock tick.
	        // These are removed when context unmounts and re-added in case of re-mount
	        _this.tickables = [];
	        // Our own tick method is the main driver for animation inside of this context
	        _this.tickables.push({ performTick: _this.tick.bind(_this) });
	        if (_this.config.frame) {
	            _this.tickables.push({ performTick: _this.config.frame });
	        }
	        _this.clock = new HaikuClock_1.default(_this.tickables, _this.config.clock || {});
	        // We need to start the loop even if we aren't autoplaying,
	        // because we still need time to be calculated even if we don't 'tick'.
	        _this.clock.run();
	        _this.container = _this.renderer.createContainer({
	            elementName: bytecode,
	            attributes: {},
	            children: [bytecode.template],
	        });
	        _this.component = new HaikuComponent_1.default(bytecode, _this, // context
	        null, // host
	        _this.config, _this.container);
	        // If configured, bootstrap the Haiku right-click context menu
	        if (_this.mount && _this.renderer.menuize && _this.config.contextMenu !== 'disabled') {
	            _this.renderer.menuize(_this.component);
	        }
	        // By default, Haiku tracks usage by transmitting component metadata to Mixpanel when initialized.
	        // Developers can disable this by setting the `mixpanel` option to a falsy value.
	        // To transmit metadata to your own Mixpanel account, set the `mixpanel` option to your Mixpanel API token.
	        // Don't set up Mixpanel if we're running on localhost since we don't want test data to be tracked
	        if (_this.mount &&
	            _this.platform &&
	            _this.platform.location &&
	            _this.platform.location.hostname !== 'localhost' &&
	            _this.platform.location.hostname !== '0.0.0.0') {
	            // If configured, initialize Mixpanel with the given API token
	            if (_this.renderer.mixpanel && _this.config.mixpanel) {
	                _this.renderer.mixpanel(_this.config.mixpanel, _this.component);
	            }
	        }
	        // Just a counter for the number of clock ticks that have occurred; used to determine first-frame for mounting
	        _this.ticks = 0;
	        // Assuming the user wants the app to mount immediately (the default), let's do the mount.
	        if (_this.config.automount) {
	            // Starting the clock has the effect of doing a render at time 0, a.k.a., mounting!
	            _this.component.getClock().start();
	        }
	        return _this;
	    }
	    /**
	     * @method getRootComponent
	     * @description Returns the HaikuComponent managed by this context.
	     */
	    HaikuContext.prototype.getRootComponent = function () {
	        return this.component;
	    };
	    /**
	     * @method getClock
	     * @description Returns the HaikuClock instance associated with this context.
	     */
	    HaikuContext.prototype.getClock = function () {
	        return this.clock;
	    };
	    /**
	     * @method contextMount
	     * @description Adds this context the global update loop.
	     */
	    HaikuContext.prototype.contextMount = function () {
	        if (this.unmountedTickables) {
	            // Gotta remember to _remove_ the tickables so we don't end up with dupes if we re-mount later
	            var unmounted = this.unmountedTickables.splice(0);
	            for (var i = 0; i < unmounted.length; i++) {
	                this.addTickable(unmounted[i]);
	            }
	        }
	    };
	    /**
	     * @method contextUnmount
	     * @description Removes this context from global update loop.
	     */
	    HaikuContext.prototype.contextUnmount = function () {
	        this.unmountedTickables = this.tickables.splice(0);
	    };
	    HaikuContext.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.component.destroy();
	        this.renderer.destroy();
	        this.clock.destroy();
	    };
	    /**
	     * @method addTickable
	     * @description Add a tickable object to the list of those that will be called on every clock tick.
	     * This only adds if the given object isn't already present in the list.
	     */
	    HaikuContext.prototype.addTickable = function (tickable) {
	        var alreadyAdded = false;
	        for (var i = 0; i < this.tickables.length; i++) {
	            if (tickable === this.tickables[i]) {
	                alreadyAdded = true;
	                break;
	            }
	        }
	        if (!alreadyAdded) {
	            this.tickables.push(tickable);
	        }
	    };
	    /**
	     * @method assignConfig
	     * @description Updates internal configuration options, assigning those passed in.
	     * Also updates the configuration of the clock instance and managed component instance.
	     */
	    HaikuContext.prototype.assignConfig = function (config, options) {
	        this.config = __assign({}, config);
	        if (this.clock) { // This method may run before the clock is initialized
	            this.clock.assignOptions(this.config.clock);
	        }
	        if (this.component) { // This method may run before the managed component is initialized
	            if (!options || !options.skipComponentAssign) { // Avoid an infinite loop if the managed component is updating us
	                this.component.assignConfig(this.config);
	            }
	        }
	    };
	    /**
	     * @method getContainer
	     * @description Returns the container, a virtual-element-like object that provides sizing
	     * constraints at the topmost/outermost level from which the descendant layout can be calculated.
	     */
	    HaikuContext.prototype.getContainer = function (doForceRecalc) {
	        if (doForceRecalc === void 0) { doForceRecalc = false; }
	        if (doForceRecalc || this.renderer.shouldCreateContainer) {
	            this.renderer.createContainer(this.container); // The container is mutated in place
	        }
	        return this.container;
	    };
	    /**
	     * @method performFullFlushRender
	     * @description Updates the entire component tree, flushing updates to the rendering medium.
	     */
	    HaikuContext.prototype.performFullFlushRender = function () {
	        if (!this.mount) {
	            return;
	        }
	        this.component.performFullFlushRenderWithRenderer(this.renderer, this.config);
	    };
	    /**
	     * @method performPatchRender
	     * @description Updates the component tree, but only updating properties we know have changed.
	     */
	    HaikuContext.prototype.performPatchRender = function (skipCache) {
	        if (skipCache === void 0) { skipCache = false; }
	        if (!this.mount) {
	            return;
	        }
	        this.component.performPatchRenderWithRenderer(this.renderer, this.config, skipCache);
	    };
	    /**
	     * @method updateMountRootStyles
	     * @description Reconciles the properties of the rendering medium's mount element with any
	     * configuration options that have been passed in, e.g. CSS overflow settings.
	     */
	    HaikuContext.prototype.updateMountRootStyles = function () {
	        if (!this.mount) {
	            return;
	        }
	        // We can assume the mount has only one child since we only mount one component into it (#?)
	        var root = this.mount && this.mount.children[0];
	        if (root) {
	            if (this.config.position && root.style.position !== this.config.position) {
	                root.style.position = this.config.position;
	            }
	            if (this.config.overflow) {
	                root.style.overflow = this.config.overflow;
	            }
	            else {
	                if (this.config.overflowX &&
	                    root.style.overflowX !== this.config.overflowX) {
	                    root.style.overflowX = this.config.overflowX;
	                }
	                if (this.config.overflowY &&
	                    root.style.overflowY !== this.config.overflowY) {
	                    root.style.overflowY = this.config.overflowY;
	                }
	            }
	        }
	    };
	    /**
	     * @method tick
	     * @description Advances the component animation by one tick. Note that one tick is not necessarily
	     * equivalent to one frame. If the animation frame loop is running too fast, the clock may wait before
	     * incrementing the frame number. In other words, a tick implies an update but not necessarily a change.
	     */
	    HaikuContext.prototype.tick = function (skipCache) {
	        var _this = this;
	        if (skipCache === void 0) { skipCache = false; }
	        try {
	            var flushed = false;
	            // Only continue ticking and updating if our root component is still activated and awake;
	            // this is mainly a hacky internal hook used during hot editing inside Haiku Desktop
	            if (!this.component.isDeactivated && !this.component.isSleeping) {
	                // This incrementation MUST occur before the blocks below, especially #callRemount,
	                // because #callRemount (and friends?) may result in a 'component:will-mount' action
	                // firing, which in turn may call this.pause()/this.gotoAndStop(). Internally those
	                // methods rely on #tick(), which means they can result in an infinite remount loop.
	                var ticks = this.ticks;
	                this.ticks++;
	                // Perform any necessary updates that have to occur in all copmonents in the scene
	                this.component.visitGuestHierarchy(function (component) {
	                    // State transitions are bound to clock time, so we update them on every tick
	                    component.tickStateTransitions();
	                    // The top-level component isn't controlled through playback status, so we must skip it
	                    // otherwise its behavior will not reflect the playback setting specified via options
	                    if (component === _this.component) {
	                        return;
	                    }
	                });
	                // After we've hydrated the tree the first time, we can proceed with patches --
	                // unless the component indicates it wants a full flush per its internal settings.
	                if (this.component.shouldPerformFullFlush() || this.config.forceFlush || ticks < 1) {
	                    this.performFullFlushRender();
	                    flushed = true;
	                }
	                else {
	                    this.performPatchRender(skipCache);
	                }
	                // We update the mount root *after* we complete the render pass because configuration
	                // from the top level should unset anything that the component set.
	                // Specifically important wrt overflow, where the component probably defines
	                // overflowX/overflowY: hidden, but our configuration might define them as visible.
	                this.updateMountRootStyles();
	                // Do any initialization that may need to occur if we happen to be on the very first tick
	                if (ticks < 1) {
	                    // If this is the 0th (first) tick, notify anybody listening that we've mounted
	                    // If we've already flushed, _don't_ request to trigger a re-flush (second arg)
	                    this.component.callRemount(null, flushed);
	                }
	            }
	        }
	        catch (exception) {
	            console.warn('[haiku core] caught error during tick', exception);
	            if (this.component) {
	                this.component.deactivate();
	            }
	        }
	    };
	    /**
	     * @method getGlobalUserState
	     * @description Since the core renderer is medium-agnostic, we rely on the renderer to provide data
	     * about the current user (the mouse position, for example). This method is just a convenience wrapper.
	     */
	    HaikuContext.prototype.getGlobalUserState = function () {
	        return this.renderer && this.renderer.getUser && this.renderer.getUser();
	    };
	    /**
	     * @function createComponentFactory
	     * @description Returns a factory function that can create a HaikuComponent and run it upon a mount.
	     * The created instance runs using the passed-in renderer, bytecode, options, and platform.
	     */
	    HaikuContext.createComponentFactory = function (rendererClass, bytecode, haikuConfigFromFactoryCreator, platform) {
	        if (!rendererClass) {
	            throw new Error('A runtime renderer class object is required');
	        }
	        if (!bytecode) {
	            throw new Error('A runtime `bytecode` object is required');
	        }
	        // Note that haiku Config may be passed at this level, or below at the factory invocation level.
	        var haikuConfigFromTop = Config_1.default.build({
	            // The seed value should remain constant from here on, because it is used for PRNG
	            seed: Config_1.default.seed(),
	            // The now-value is used to compute a current date with respect to the current time
	            timestamp: Date.now(),
	        }, 
	        // The bytecode itself may contain configuration for playback, etc., but is lower precedence than config passed in
	        bytecode && bytecode.options, haikuConfigFromFactoryCreator);
	        /**
	         * @function HaikuComponentFactory
	         * @description Creates a HaikuContext instance, with a component, and returns the component.
	         * The (renderer, bytecode) pair are bootstrapped into the given mount element, and played.
	         */
	        var HaikuComponentFactory = function (mount, haikuConfigFromFactory) {
	            // Merge any config received "late" with the config we might have already gotten during bootstrapping
	            var haikuConfigMerged = Config_1.default.build(haikuConfigFromTop, haikuConfigFromFactory);
	            // Previously these were initialized in the scope above, but I moved them here which seemed to resolve
	            // an initialization/mounting issue when running in React.
	            var renderer = new rendererClass(mount, haikuConfigMerged);
	            var context = new HaikuContext(mount, renderer, platform, bytecode, haikuConfigMerged);
	            var component = context.getRootComponent();
	            // These properties are added for convenience as hot editing hooks inside Haiku Desktop (and elsewhere?).
	            // It's a bit hacky to just expose these in this way, but it proves pretty convenient downstream.
	            HaikuComponentFactory.bytecode = bytecode;
	            HaikuComponentFactory.renderer = renderer;
	            // Note that these ones could theoretically change if this factory was called more than once; use with care
	            HaikuComponentFactory.mount = mount;
	            HaikuComponentFactory.context = context;
	            HaikuComponentFactory.component = component;
	            // Finally, return the HaikuComponent instance which can also be used for programmatic behavior
	            return component;
	        };
	        HaikuComponentFactory.PLAYER_VERSION = VERSION; // #LEGACY
	        HaikuComponentFactory.CORE_VERSION = VERSION;
	        return HaikuComponentFactory;
	    };
	    // Also expose so we can programatically choose an instance on the page
	    HaikuContext.PLAYER_VERSION = VERSION; // #LEGACY
	    HaikuContext.CORE_VERSION = VERSION; // #LEGACY
	    HaikuContext.__name__ = 'HaikuContext';
	    return HaikuContext;
	}(HaikuBase_1.default));
	exports.default = HaikuContext;
	//# sourceMappingURL=HaikuContext.js.map

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuBase_1 = __webpack_require__(13);
	var HaikuNode_1 = __webpack_require__(29);
	var Layout3D_1 = __webpack_require__(14);
	exports.HAIKU_ID_ATTRIBUTE = 'haiku-id';
	exports.HAIKU_TITLE_ATTRIBUTE = 'haiku-title';
	exports.HAIKU_VAR_ATTRIBUTE = 'haiku-var';
	exports.HAIKU_SOURCE_ATTRIBUTE = 'haiku-source';
	exports.HAIKU_LOCKED_ATTRIBUTE = 'haiku-locked';
	var SVG_PRIMITIVE_NAMES = {
	    rect: true,
	    line: true,
	    circle: true,
	    ellipse: true,
	    path: true,
	    polygon: true,
	    polyline: true,
	};
	var DEFAULT_DEPTH = 0;
	var DEFAULT_TAG_NAME = 'div';
	var COMPONENT_PSEUDO_TAG_NAME = DEFAULT_TAG_NAME;
	var SIZING_AXES = ['x', 'y', 'z'];
	var TEXT_PSEUDO_TAG_NAME = '__text__';
	var CSS_QUERY_MAPPING = {
	    name: 'elementName',
	    attributes: 'attributes',
	    children: 'children',
	};
	var LAYOUT_DEFAULTS = Layout3D_1.default.createLayoutSpec();
	var HaikuElement = /** @class */ (function (_super) {
	    __extends(HaikuElement, _super);
	    function HaikuElement() {
	        var _this = _super.call(this) || this;
	        _this.isHovered = false;
	        return _this;
	    }
	    Object.defineProperty(HaikuElement.prototype, "childNodes", {
	        get: function () {
	            return (this.node &&
	                ((this.memory && this.memory.children) || this.node.children)) || [];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "children", {
	        get: function () {
	            return this.childNodes.map(function (childNode) {
	                return HaikuElement.findOrCreateByNode(childNode);
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "attributes", {
	        get: function () {
	            return (this.node && this.node.attributes) || {};
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "type", {
	        get: function () {
	            return (this.node && this.node.elementName) || DEFAULT_TAG_NAME;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "title", {
	        get: function () {
	            return this.attributes[exports.HAIKU_TITLE_ATTRIBUTE];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "source", {
	        get: function () {
	            return this.attributes[exports.HAIKU_SOURCE_ATTRIBUTE];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "id", {
	        get: function () {
	            return this.attributes.id;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "className", {
	        get: function () {
	            return this.attributes.class;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "tagName", {
	        get: function () {
	            if (this.isTextNode()) {
	                return TEXT_PSEUDO_TAG_NAME;
	            }
	            if (this.isComponent()) {
	                return COMPONENT_PSEUDO_TAG_NAME;
	            }
	            return this.type || DEFAULT_TAG_NAME;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "nodeType", {
	        get: function () {
	            if (this.isTextNode()) {
	                return 3;
	            }
	            return 1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "subcomponent", {
	        /**
	         * @method subcomponent
	         * @description Returns the HaikuComponent instance that manages nodes below this one.
	         * This node is considered the 'wrapper' node and its child is considered the 'root'.
	         */
	        get: function () {
	            return this.memory && this.memory.subcomponent;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "instance", {
	        /**
	         * @method instance
	         * @description Returns the HaikuComponent instance that manages this node and those beneath.
	         * This node is considered the 'root' node of the instance.
	         */
	        get: function () {
	            return this.memory && this.memory.instance;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "containee", {
	        /**
	         * @method containee
	         * @description Returns the HaikuComponent instance into which this node was passed as a container.
	         */
	        get: function () {
	            return this.memory && this.memory.containee;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "owner", {
	        get: function () {
	            if (this.instance) {
	                return this.instance;
	            }
	            return this.parent && this.parent.owner;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "top", {
	        get: function () {
	            return this.instanceContext && this.instanceContext.component;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "instanceContext", {
	        get: function () {
	            return this.memory && this.memory.context;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "parentNode", {
	        get: function () {
	            return this.memory && this.memory.parent;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "memory", {
	        get: function () {
	            return this.node && this.node.__memory;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "parent", {
	        get: function () {
	            return this.parentNode && HaikuElement.findOrCreateByNode(this.parentNode);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "layout", {
	        get: function () {
	            return this.node && this.node.layout && this.node.layout.computed;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "layoutMatrix", {
	        get: function () {
	            return (this.layout && this.layout.matrix) || Layout3D_1.default.createMatrix();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "layoutAncestry", {
	        get: function () {
	            var ancestry = [];
	            if (this.layout) {
	                ancestry.unshift(this.layout);
	            }
	            // tslint:disable-next-line:no-this-assignment
	            var ancestor = this;
	            while (ancestor.parent) {
	                ancestor = ancestor.parent;
	                var layout = ancestor.layout;
	                if (layout) {
	                    ancestry.unshift(layout);
	                }
	            }
	            return ancestry;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "layoutAncestryMatrices", {
	        get: function () {
	            return this.layoutAncestry.filter(function (layout) { return !!layout.matrix; }).map(function (layout) { return layout.matrix; });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "rootSVG", {
	        get: function () {
	            var parent = this.parent;
	            while (parent) {
	                if (parent.type === 'svg') {
	                    return parent;
	                }
	                parent = parent.parent;
	            }
	            return undefined;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "isChildOfDefs", {
	        get: function () {
	            var parent = this.parent;
	            while (parent) {
	                if (parent.type === 'defs') {
	                    return true;
	                }
	                parent = parent.parent;
	            }
	            return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuElement.prototype.getTranscludedElement = function () {
	        if (this.type !== 'use') {
	            return this;
	        }
	        var href = this.attributes['xlink:href'] || this.attributes.href;
	        if (!href) {
	            return;
	        }
	        var rootSVG = this.rootSVG;
	        if (!rootSVG) {
	            return;
	        }
	        var address = href.substr(1);
	        var out;
	        this.rootSVG.visit(function (desc) {
	            if (desc.id === address) {
	                out = desc;
	                return false;
	            }
	        });
	        return out;
	    };
	    Object.defineProperty(HaikuElement.prototype, "rawLayout", {
	        get: function () {
	            return this.node && this.node.layout;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "shown", {
	        get: function () {
	            return this.layout && this.layout.shown;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "opacity", {
	        get: function () {
	            return this.layout && this.layout.opacity;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "shear", {
	        get: function () {
	            return this.layout && this.layout.shear;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "matrix", {
	        get: function () {
	            return this.layout && this.layout.matrix;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "translation", {
	        get: function () {
	            return (this.layout && this.layout.translation) || __assign({}, LAYOUT_DEFAULTS.translation);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "rotation", {
	        get: function () {
	            return (this.layout && this.layout.rotation) || __assign({}, LAYOUT_DEFAULTS.rotation);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "scale", {
	        get: function () {
	            return (this.layout && this.layout.scale) || __assign({}, LAYOUT_DEFAULTS.scale);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "origin", {
	        get: function () {
	            return (this.layout && this.layout.origin) || __assign({}, LAYOUT_DEFAULTS.origin);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "offset", {
	        get: function () {
	            return (this.layout && this.layout.offset) || __assign({}, LAYOUT_DEFAULTS.offset);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "targets", {
	        get: function () {
	            return (this.memory && this.memory.targets) || [];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "target", {
	        get: function () {
	            // Assume the most recently added target is the canonical target due to an implementation
	            // detail in the Haiku editing environment; FIXME. On 3 Jun 2018 was changed from the first
	            // added to the last added one to fix a bug related to ungrouping
	            return this.targets[this.targets.length - 1];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "rotationX", {
	        get: function () {
	            return this.rotation && this.rotation.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "rotationY", {
	        get: function () {
	            return this.rotation && this.rotation.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "rotationZ", {
	        get: function () {
	            return this.rotation && this.rotation.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "scaleX", {
	        get: function () {
	            return this.scale && this.scale.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "scaleY", {
	        get: function () {
	            return this.scale && this.scale.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "scaleZ", {
	        get: function () {
	            return this.scale && this.scale.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "positionX", {
	        get: function () {
	            return this.translation && this.translation.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "positionY", {
	        get: function () {
	            return this.translation && this.translation.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "positionZ", {
	        get: function () {
	            return this.translation && this.translation.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "translationX", {
	        get: function () {
	            return this.translation && this.translation.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "translationY", {
	        get: function () {
	            return this.translation && this.translation.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "translationZ", {
	        get: function () {
	            return this.translation && this.translation.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "originX", {
	        get: function () {
	            return this.origin && this.origin.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "originY", {
	        get: function () {
	            return this.origin && this.origin.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "originZ", {
	        get: function () {
	            return this.origin && this.origin.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "offsetX", {
	        get: function () {
	            return this.offset && this.offset.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "offsetY", {
	        get: function () {
	            return this.offset && this.offset.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "offsetZ", {
	        get: function () {
	            return this.offset && this.offset.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizePrecomputed", {
	        /**
	         * @description Returns the size as computed when the layout was last rendered.
	         */
	        get: function () {
	            return this.layout && this.layout.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizePrecomputedX", {
	        get: function () {
	            return this.sizePrecomputed && this.sizePrecomputed.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizePrecomputedY", {
	        get: function () {
	            return this.sizePrecomputed && this.sizePrecomputed.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizePrecomputedZ", {
	        get: function () {
	            return this.sizePrecomputed && this.sizePrecomputed.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "size", {
	        get: function () {
	            return {
	                x: this.sizeX,
	                y: this.sizeY,
	                z: this.sizeZ,
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeX", {
	        get: function () {
	            return this.computeSizeX();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeY", {
	        get: function () {
	            return this.computeSizeY();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeZ", {
	        get: function () {
	            return this.computeSizeZ();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "width", {
	        get: function () {
	            return this.sizeX;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "height", {
	        get: function () {
	            return this.sizeY;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "depth", {
	        get: function () {
	            return this.sizeZ;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "attributeWidth", {
	        get: function () {
	            if (this.attributes && this.attributes.width) {
	                return Number(this.attributes.width);
	            }
	            return;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "attributeHeight", {
	        get: function () {
	            if (this.attributes && this.attributes.height) {
	                return Number(this.attributes.height);
	            }
	            return;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeAbsolute", {
	        get: function () {
	            return (this.rawLayout && this.rawLayout.sizeAbsolute) || __assign({}, LAYOUT_DEFAULTS.sizeAbsolute);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeAbsoluteX", {
	        get: function () {
	            return this.sizeAbsolute && this.sizeAbsolute.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeAbsoluteY", {
	        get: function () {
	            return this.sizeAbsolute && this.sizeAbsolute.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeAbsoluteZ", {
	        get: function () {
	            return this.sizeAbsolute && this.sizeAbsolute.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeMode", {
	        get: function () {
	            return this.rawLayout && this.rawLayout.sizeMode;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeModeX", {
	        get: function () {
	            return this.sizeMode && this.sizeMode.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeModeY", {
	        get: function () {
	            return this.sizeMode && this.sizeMode.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeModeZ", {
	        get: function () {
	            return this.sizeMode && this.sizeMode.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeProportional", {
	        get: function () {
	            return (this.rawLayout && this.rawLayout.sizeProportional) || __assign({}, LAYOUT_DEFAULTS.sizeProportional);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeProportionalX", {
	        get: function () {
	            return this.sizeProportional && this.sizeProportional.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeProportionalY", {
	        get: function () {
	            return this.sizeProportional && this.sizeProportional.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeProportionalZ", {
	        get: function () {
	            return this.sizeProportional && this.sizeProportional.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeDifferential", {
	        get: function () {
	            return (this.rawLayout && this.rawLayout.sizeDifferential) || __assign({}, LAYOUT_DEFAULTS.sizeDifferential);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeDifferentialX", {
	        get: function () {
	            return this.sizeDifferential && this.sizeDifferential.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeDifferentialY", {
	        get: function () {
	            return this.sizeDifferential && this.sizeDifferential.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeDifferentialZ", {
	        get: function () {
	            return this.sizeDifferential && this.sizeDifferential.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "properties", {
	        get: function () {
	            return {
	                shown: this.shown,
	                opacity: this.opacity,
	                offset: this.offset,
	                origin: this.origin,
	                translation: this.translation,
	                rotation: this.rotation,
	                scale: this.scale,
	                shear: this.shear,
	                sizeMode: this.sizeMode,
	                sizeProportional: this.sizeProportional,
	                sizeDifferential: this.sizeDifferential,
	                sizeAbsolute: this.sizeAbsolute,
	                size: this.size,
	                matrix: this.matrix,
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "componentId", {
	        get: function () {
	            return this.getComponentId();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuElement.prototype.computeSize = function () {
	        return {
	            x: this.computeSizeX(),
	            y: this.computeSizeY(),
	            z: this.computeSizeZ(),
	        };
	    };
	    HaikuElement.prototype.computeBoundsForAxis = function (axis) {
	        if (axis === 'x') {
	            return this.computeContentBoundsX();
	        }
	        if (axis === 'y') {
	            return this.computeContentBoundsY();
	        }
	        if (axis === 'z') {
	            return this.computeContentBoundsZ();
	        }
	    };
	    HaikuElement.prototype.computeContentBounds = function () {
	        return __assign({}, this.computeContentBoundsX(), this.computeContentBoundsY(), this.computeContentBoundsZ());
	    };
	    HaikuElement.prototype.computeContentBoundsX = function () {
	        if (typeof this.sizeAbsolute.x === 'number') {
	            return {
	                left: null,
	                right: null,
	            };
	        }
	        var lefts = [];
	        var rights = [];
	        var children = this.children;
	        if (children.length < 1) {
	            return {
	                left: null,
	                right: null,
	            };
	        }
	        for (var i = 0; i < children.length; i++) {
	            var child = children[i];
	            // These fields should account for the child's translation, rotation, scale, etc.
	            var _a = child.getLocallyTransformedBoundingClientRect(), left = _a.left, right = _a.right;
	            lefts.push(left);
	            rights.push(right);
	        }
	        return {
	            left: Math.min.apply(Math, lefts),
	            right: Math.max.apply(Math, rights),
	        };
	    };
	    HaikuElement.prototype.computeContentBoundsY = function () {
	        if (typeof this.sizeAbsolute.y === 'number') {
	            return {
	                top: null,
	                bottom: null,
	            };
	        }
	        var tops = [];
	        var bottoms = [];
	        var children = this.children;
	        if (children.length < 1) {
	            return {
	                top: null,
	                bottom: null,
	            };
	        }
	        for (var i = 0; i < children.length; i++) {
	            var child = children[i];
	            // These fields should account for the child's translation, rotation, scale, etc.
	            var _a = child.getLocallyTransformedBoundingClientRect(), top_1 = _a.top, bottom = _a.bottom;
	            tops.push(top_1);
	            bottoms.push(bottom);
	        }
	        return {
	            top: Math.min.apply(Math, tops),
	            bottom: Math.max.apply(Math, bottoms),
	        };
	    };
	    HaikuElement.prototype.computeContentBoundsZ = function () {
	        return {
	            front: null,
	            back: null,
	        };
	    };
	    HaikuElement.prototype.computeSizeForAxis = function (axis) {
	        if (axis === 'x') {
	            return this.computeSizeX();
	        }
	        if (axis === 'y') {
	            return this.computeSizeY();
	        }
	        if (axis === 'z') {
	            return this.computeSizeZ();
	        }
	    };
	    /**
	     * @description For elements that only have a single child, we can save some computation
	     * by looking up their defined absolute size instead of computing their bounding box.
	     * In particular this is useful in the case of the component wrapper div and its one child.
	     */
	    HaikuElement.prototype.getOnlyChildSize = function (axis) {
	        var children = this.children;
	        if (children.length !== 1) {
	            return;
	        }
	        var child = children[0];
	        if (!child || typeof child !== 'object') {
	            return;
	        }
	        if (typeof child.sizeAbsolute[axis] === 'number') {
	            return child.sizeAbsolute[axis];
	        }
	        return child.getOnlyChildSize(axis);
	    };
	    HaikuElement.prototype.computeSizeX = function () {
	        // SVG primitives use native SVG layout instead of our system
	        if (this.isSvgPrimitive() && typeof this.attributeWidth === 'number') {
	            return this.attributeWidth;
	        }
	        if (typeof this.sizeAbsolute.x === 'number') {
	            return this.sizeAbsolute.x;
	        }
	        var onlyChildSize = this.getOnlyChildSize('x');
	        if (typeof onlyChildSize === 'number') {
	            return onlyChildSize;
	        }
	        var _a = this.computeContentBoundsX(), left = _a.left, right = _a.right;
	        return right - left;
	    };
	    HaikuElement.prototype.computeSizeY = function () {
	        // SVG primitives use native SVG layout instead of our system
	        if (this.isSvgPrimitive() && typeof this.attributeHeight === 'number') {
	            return this.attributeHeight;
	        }
	        if (typeof this.sizeAbsolute.y === 'number') {
	            return this.sizeAbsolute.y;
	        }
	        var onlyChildSize = this.getOnlyChildSize('y');
	        if (typeof onlyChildSize === 'number') {
	            return onlyChildSize;
	        }
	        var _a = this.computeContentBoundsY(), top = _a.top, bottom = _a.bottom;
	        return bottom - top;
	    };
	    HaikuElement.prototype.computeSizeZ = function () {
	        if (typeof this.sizeAbsolute.z === 'number') {
	            return this.sizeAbsolute.z;
	        }
	        var onlyChildSize = this.getOnlyChildSize('z');
	        if (typeof onlyChildSize === 'number') {
	            return onlyChildSize;
	        }
	        var _a = this.computeContentBoundsZ(), front = _a.front, back = _a.back;
	        return back - front;
	    };
	    HaikuElement.prototype.getComponentId = function () {
	        return this.attributes[exports.HAIKU_ID_ATTRIBUTE];
	    };
	    HaikuElement.prototype.isSimpleNode = function () {
	        return !this.isComponent();
	    };
	    HaikuElement.prototype.isTextNode = function () {
	        return typeof this.node !== 'object';
	    };
	    HaikuElement.prototype.isComponent = function () {
	        return !!this.instance;
	    };
	    HaikuElement.prototype.isWrapper = function () {
	        return !!this.subcomponent;
	    };
	    HaikuElement.prototype.isSvgPrimitive = function () {
	        return !!SVG_PRIMITIVE_NAMES[this.tagName];
	    };
	    HaikuElement.prototype.componentMatches = function (selector) {
	        if (!this.isComponent()) {
	            return false;
	        }
	        var trimmed = selector.trim();
	        var source = this.source;
	        var title = this.title;
	        var id = this.id;
	        return (trimmed === COMPONENT_PSEUDO_TAG_NAME ||
	            trimmed === source ||
	            trimmed === title ||
	            trimmed === id);
	    };
	    HaikuElement.prototype.matches = function (selector) {
	        return (this.componentMatches(selector) ||
	            HaikuNode_1.cssMatchOne(this.node, selector, CSS_QUERY_MAPPING));
	    };
	    HaikuElement.prototype.visit = function (iteratee, filter) {
	        var result = iteratee(this);
	        if (result !== false) {
	            return this.visitDescendants(iteratee, filter);
	        }
	        return result;
	    };
	    HaikuElement.prototype.visitDescendants = function (iteratee, filter) {
	        if (this.parent && this.parent.isWrapper()) {
	            // Avoids traversing down into a subcomponent.
	            return true;
	        }
	        var children = filter ? this.children.filter(filter) : this.children;
	        for (var i = 0; i < children.length; i++) {
	            var result = children[i].visit(iteratee, filter);
	            if (result === false) {
	                return result;
	            }
	        }
	        return true;
	    };
	    HaikuElement.prototype.querySelector = function (selector) {
	        var _this = this;
	        return this.cacheFetch("querySelector:" + selector, function () {
	            var out;
	            _this.visitDescendants(function (element) {
	                if (element.matches(selector)) {
	                    out = element;
	                    // Returning `false` short-circuits the visitor
	                    return false;
	                }
	            });
	            return out;
	        });
	    };
	    HaikuElement.prototype.querySelectorAll = function (selector) {
	        var _this = this;
	        return this.cacheFetch("querySelectorAll:" + selector, function () {
	            var out = [];
	            _this.visitDescendants(function (element) {
	                if (element.matches(selector)) {
	                    out.push(element);
	                }
	            });
	            return out;
	        });
	    };
	    HaikuElement.prototype.getRawBoundingBoxPoints = function () {
	        var _a = this.computeSize(), x = _a.x, y = _a.y;
	        return [
	            { x: 0, y: 0, z: 0 }, { x: x / 2, y: 0, z: 0 }, { x: x, y: 0, z: 0 },
	            { x: 0, y: y / 2, z: 0 }, { x: x / 2, y: y / 2, z: 0 }, { x: x, y: y / 2, z: 0 },
	            { y: y, x: 0, z: 0 }, { y: y, x: x / 2, z: 0 }, { y: y, x: x, z: 0 },
	        ];
	    };
	    HaikuElement.prototype.getLocallyTransformedBoundingBoxPoints = function () {
	        return HaikuElement.transformPointsInPlace(this.getRawBoundingBoxPoints(), HaikuElement.computeLayout(this.node, null).matrix);
	    };
	    HaikuElement.prototype.getLocallyTransformedBoundingClientRect = function () {
	        var points = this.getLocallyTransformedBoundingBoxPoints();
	        return HaikuElement.getRectFromPoints(points);
	    };
	    HaikuElement.prototype.getNearestDefinedNonZeroAncestorSizeX = function () {
	        var x = this.sizeAbsolute.x;
	        if (typeof x === 'number' && x > 0) {
	            return x;
	        }
	        if (this.parent) {
	            return this.parent.getNearestDefinedNonZeroAncestorSizeX();
	        }
	        return 1;
	    };
	    HaikuElement.prototype.getNearestDefinedNonZeroAncestorSizeY = function () {
	        var y = this.sizeAbsolute.y;
	        if (typeof y === 'number' && y > 0) {
	            return y;
	        }
	        if (this.parent) {
	            return this.parent.getNearestDefinedNonZeroAncestorSizeY();
	        }
	        return 1;
	    };
	    HaikuElement.prototype.getNearestDefinedNonZeroAncestorSizeZ = function () {
	        var z = this.sizeAbsolute.z;
	        if (typeof z === 'number' && z > 0) {
	            return z;
	        }
	        if (this.parent) {
	            return this.parent.getNearestDefinedNonZeroAncestorSizeZ();
	        }
	        return 1;
	    };
	    HaikuElement.prototype.triggerHover = function (event) {
	        var manager = this.top;
	        // In case of the root container of a render tree
	        if (!manager) {
	            manager = this.containee;
	        }
	        // Not sure how we'd get here, but if we do, skip this process
	        if (!manager || manager.isDeactivated) {
	            return;
	        }
	        // tslint:disable-next-line:no-this-assignment
	        var hoverable = this;
	        // If no last hovered element, there's nothing to unhover.
	        var mustUnhover = manager.lastHoveredElement !== undefined;
	        var hovers = [];
	        while (hoverable) {
	            // If the last hovered element is an ancestor,
	            // we _don't_ want to unhover it—that's the
	            // annoying browser behavior we're trying to
	            // "fix" in the first place.
	            if (mustUnhover && manager.lastHoveredElement === hoverable) {
	                mustUnhover = false;
	            }
	            // If we are hovered here, by virtue of this algorithm we are hovered above.
	            if (hoverable.isHovered) {
	                break;
	            }
	            hovers.push(hoverable);
	            hoverable.isHovered = true;
	            hoverable = hoverable.parent;
	        }
	        hovers.forEach(function (hov) {
	            var delegator = HaikuElement.getElementEventDelegator(hov);
	            if (delegator && !delegator.isDeactivated) {
	                delegator.routeEventToHandlerAndEmitWithoutBubblingAndWithoutGlobalHandlers(hov.selector, 'hover', [hov, hov.target, event]);
	            }
	        });
	        var unhovers = [];
	        // We must be in a different branch of the tree.
	        if (mustUnhover) {
	            var unhoverable = manager.lastHoveredElement;
	            // Stop until we hit the common hovered ancestor (wherever we break'ed above).
	            while (unhoverable && unhoverable !== hoverable) {
	                unhovers.push(unhoverable);
	                unhoverable.isHovered = false;
	                unhoverable = unhoverable.parent;
	            }
	        }
	        unhovers.forEach(function (unhov) {
	            var delegator = HaikuElement.getElementEventDelegator(unhov);
	            if (delegator && !delegator.isDeactivated) {
	                delegator.routeEventToHandlerAndEmitWithoutBubblingAndWithoutGlobalHandlers(unhov.selector, 'unhover', [unhov, unhov.target, event]);
	            }
	        });
	        manager.lastHoveredElement = this;
	    };
	    Object.defineProperty(HaikuElement.prototype, "selector", {
	        get: function () {
	            return "haiku:" + this.getComponentId();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuElement.prototype.dump = function () {
	        return this.$id + ":<" + this.tagName + ">(" + (this.getComponentId() || '[container]') + ")";
	    };
	    HaikuElement.getElementEventDelegator = function (el) {
	        if (!el) {
	            return;
	        }
	        if (el.isComponent()) {
	            return el;
	        }
	        return el.owner;
	    };
	    HaikuElement.transformVectorByMatrix = function (out, v, m) {
	        out[0] = m[0] * v[0] + m[4] * v[1] + m[8] * v[2] + m[12];
	        out[1] = m[1] * v[0] + m[5] * v[1] + m[9] * v[2] + m[13];
	        out[2] = m[2] * v[0] + m[6] * v[1] + m[10] * v[2] + m[14];
	        return out;
	    };
	    HaikuElement.getRectFromPoints = function (points) {
	        var top = Math.min(points[0].y, points[2].y, points[6].y, points[8].y);
	        var bottom = Math.max(points[0].y, points[2].y, points[6].y, points[8].y);
	        var left = Math.min(points[0].x, points[2].x, points[6].x, points[8].x);
	        var right = Math.max(points[0].x, points[2].x, points[6].x, points[8].x);
	        var width = Math.abs(bottom - top);
	        var height = Math.abs(right - left);
	        return {
	            top: top,
	            right: right,
	            bottom: bottom,
	            left: left,
	            width: width,
	            height: height,
	        };
	    };
	    HaikuElement.getBoundingBoxPoints = function (points) {
	        var x1 = points[0].x;
	        var y1 = points[0].y;
	        var x2 = points[0].x;
	        var y2 = points[0].y;
	        points.forEach(function (point) {
	            if (point.x < x1) {
	                x1 = point.x;
	            }
	            else if (point.x > x2) {
	                x2 = point.x;
	            }
	            if (point.y < y1) {
	                y1 = point.y;
	            }
	            else if (point.y > y2) {
	                y2 = point.y;
	            }
	        });
	        var w = x2 - x1;
	        var h = y2 - y1;
	        return [
	            { x: x1, y: y1, z: 0 }, { x: x1 + w / 2, y: y1, z: 0 }, { x: x2, y: y1, z: 0 },
	            { x: x1, y: y1 + h / 2, z: 0 }, { x: x1 + w / 2, y: y1 + h / 2, z: 0 }, { x: x2, y: y1 + h / 2, z: 0 },
	            { x: x1, y: y2, z: 0 }, { x: x1 + w / 2, y: y2, z: 0 }, { x: x2, y: y2, z: 0 },
	        ];
	    };
	    HaikuElement.transformPointsInPlace = function (points, matrix) {
	        for (var i = 0; i < points.length; i++) {
	            HaikuElement.transformPointInPlace(points[i], matrix);
	        }
	        return points;
	    };
	    HaikuElement.transformPointInPlace = function (point, matrix) {
	        var offset = HaikuElement.transformVectorByMatrix([], [point.x, point.y, point.z], matrix);
	        point.x = offset[0];
	        point.y = offset[1];
	        point.z = offset[2];
	        return point;
	    };
	    HaikuElement.getAncestry = function (ancestors, element) {
	        ancestors.unshift(element);
	        if (element.parent) {
	            HaikuElement.getAncestry(ancestors, element.parent);
	        }
	        return ancestors;
	    };
	    // tslint:disable-next-line:variable-name
	    HaikuElement.__name__ = 'HaikuElement';
	    HaikuElement.findByNode = function (node) {
	        var registry = HaikuBase_1.default.getRegistryForClass(HaikuElement);
	        for (var i = 0; i < registry.length; i++) {
	            if (registry[i].node === node) {
	                return registry[i];
	            }
	        }
	        return;
	    };
	    HaikuElement.connectNodeWithElement = function (node, element) {
	        // In case the element wasn't initialized yet
	        if (element) {
	            element.node = node;
	        }
	        // In case we got a string or null node
	        if (node && typeof node === 'object') {
	            // The purpose of the __memory object is to allow a mutable reference to be
	            // passed around even when the node's base attributes are cloned. Also
	            // to consolidate a host of __* properties which were becoming unweildy.
	            //
	            // Important: Platform-specific renderers may attach properties to this object;
	            // for example the HaikuDOMRenderer attaches list of .targets (DOM nodes).
	            if (!node.__memory) {
	                node.__memory = {};
	            }
	            node.__memory.element = element;
	        }
	    };
	    HaikuElement.createByNode = function (node) {
	        var element = new HaikuElement();
	        HaikuElement.connectNodeWithElement(node, element);
	        return element;
	    };
	    HaikuElement.findOrCreateByNode = function (node) {
	        var found;
	        if (node && typeof node === 'object') {
	            found = node.__memory && node.__memory.element;
	        }
	        if (!found) {
	            found = HaikuElement.findByNode(node);
	        }
	        if (found) {
	            HaikuElement.connectNodeWithElement(node, found);
	            return found;
	        }
	        return HaikuElement.createByNode(node);
	    };
	    HaikuElement.useAutoSizing = function (givenValue) {
	        return (givenValue === Layout3D_1.AUTO_SIZING_TOKEN ||
	            // Legacy. Because HaikuComponent#render gets called before Migration.runMigrations,
	            // the legacy value won't be correctly migrated to 'auto' by the time this gets called
	            // for the very first time, so we keep it around for backwards compat. Jun 22, 2018.
	            givenValue === true);
	    };
	    HaikuElement.computeLayout = function (targetNode, parentNode) {
	        var layoutSpec = targetNode.layout;
	        var targetSize = {
	            x: null,
	            y: null,
	            z: null,
	        };
	        var parentBounds = (parentNode &&
	            parentNode.layout &&
	            parentNode.layout.computed &&
	            parentNode.layout.computed.bounds);
	        var targetBounds = {
	            left: null,
	            top: null,
	            right: null,
	            bottom: null,
	            front: null,
	            back: null,
	        };
	        var leftOffset = 0;
	        var topOffset = 0;
	        if (parentBounds) {
	            if (typeof parentBounds.left === 'number') {
	                leftOffset += parentBounds.left;
	            }
	            if (typeof parentBounds.top === 'number') {
	                topOffset += parentBounds.top;
	            }
	        }
	        var targetElement = HaikuElement.findOrCreateByNode(targetNode);
	        // We'll define this later if any axes are requesting SIZE_PROPORTIONAL. It isn't needed for SIZE_ABSOLUTE.
	        var parentsizeAbsolute;
	        for (var i = 0; i < SIZING_AXES.length; i++) {
	            var sizeAxis = SIZING_AXES[i];
	            switch (layoutSpec.sizeMode[sizeAxis]) {
	                case Layout3D_1.SIZE_PROPORTIONAL:
	                    if (!parentsizeAbsolute) {
	                        parentsizeAbsolute = (parentNode &&
	                            parentNode.layout &&
	                            parentNode.layout.computed &&
	                            parentNode.layout.computed.size) || { x: 0, y: 0, z: 0 };
	                        if (parentsizeAbsolute.z === undefined || parentsizeAbsolute.z === null) {
	                            parentsizeAbsolute.z = DEFAULT_DEPTH;
	                        }
	                        if (parentsizeAbsolute.x === 0 && parentsizeAbsolute.y === 0 && parentsizeAbsolute.z === 0) {
	                            // Size must be inherited from an ancestor above parent. Traverse upward until we find it.
	                            var traversalParentNode = targetNode;
	                            while (traversalParentNode) {
	                                traversalParentNode = traversalParentNode.__memory && traversalParentNode.__memory.parent;
	                                if (traversalParentNode && traversalParentNode.layout && traversalParentNode.layout.computed) {
	                                    Object.assign(parentsizeAbsolute, traversalParentNode.layout.computed.size);
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                    // Size is calculated as: parentSizeValue * sizeProportional + sizeProportional.
	                    targetSize[sizeAxis] = parentsizeAbsolute[sizeAxis] * layoutSpec.sizeProportional[sizeAxis] +
	                        layoutSpec.sizeDifferential[sizeAxis];
	                    break;
	                case Layout3D_1.SIZE_ABSOLUTE:
	                    var givenValue = layoutSpec.sizeAbsolute[sizeAxis];
	                    // Implements "auto"-sizing: Use content size if available, otherwise fallback to parent
	                    if (HaikuElement.useAutoSizing(givenValue)) {
	                        targetSize[sizeAxis] = targetElement.computeSizeForAxis(sizeAxis);
	                        Object.assign(targetBounds, targetElement.computeBoundsForAxis(sizeAxis));
	                    }
	                    else {
	                        targetSize[sizeAxis] = givenValue; // Assume the given value is numeric
	                    }
	                    break;
	            }
	        }
	        var virtualSpec = __assign({}, layoutSpec, { offset: {
	                x: layoutSpec.offset.x - leftOffset,
	                y: layoutSpec.offset.y - topOffset,
	                z: layoutSpec.offset.z,
	            } });
	        var targetMatrix = Layout3D_1.default.computeMatrix(virtualSpec, targetSize);
	        return {
	            shown: layoutSpec.shown,
	            opacity: layoutSpec.opacity,
	            offset: layoutSpec.offset,
	            origin: layoutSpec.origin,
	            translation: layoutSpec.translation,
	            rotation: layoutSpec.rotation,
	            scale: layoutSpec.scale,
	            shear: layoutSpec.shear,
	            sizeMode: layoutSpec.sizeMode,
	            sizeProportional: layoutSpec.sizeProportional,
	            sizeDifferential: layoutSpec.sizeDifferential,
	            sizeAbsolute: layoutSpec.sizeAbsolute,
	            size: targetSize,
	            matrix: targetMatrix,
	            bounds: targetBounds,
	        };
	    };
	    return HaikuElement;
	}(HaikuBase_1.default));
	exports.default = HaikuElement;
	//# sourceMappingURL=HaikuElement.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var pkg = __webpack_require__(17);
	var VERSION = pkg.version;
	// We need a global harness so we can attach helpers
	var MAIN = ((typeof window !== 'undefined')
	    ? window
	    : (typeof global !== 'undefined')
	        ? global
	        : {});
	if (!MAIN.HaikuHelpers) {
	    MAIN.HaikuHelpers = {};
	}
	// Different versions may have different helpers, so keep that in mind...
	if (!MAIN.HaikuHelpers[VERSION]) {
	    MAIN.HaikuHelpers[VERSION] = {
	        helpers: {},
	    };
	}
	var exp = MAIN.HaikuHelpers[VERSION];
	exp.register = function (name, method) {
	    exp.helpers[name] = method;
	    return exp;
	};
	exports.default = exp;
	//# sourceMappingURL=HaikuHelpers.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuBase_1 = __webpack_require__(13);
	var getActionsMaxTime_1 = __webpack_require__(109);
	var getTimelineMaxTime_1 = __webpack_require__(111);
	var Tokenizer_1 = __webpack_require__(55);
	var assign_1 = __webpack_require__(18);
	var NUMBER = 'number';
	var DEFAULT_OPTIONS = {
	    // loop: Boolean
	    // Determines whether this timeline should loop (start at its beginning when finished)
	    loop: true,
	};
	var TimeUnit;
	(function (TimeUnit) {
	    TimeUnit["Millisecond"] = "ms";
	    TimeUnit["Frame"] = "fr";
	})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
	var PlaybackFlag;
	(function (PlaybackFlag) {
	    PlaybackFlag["ONCE"] = "once";
	    PlaybackFlag["PLAY"] = "play";
	    PlaybackFlag["LOOP"] = "loop";
	    PlaybackFlag["STOP"] = "stop";
	    PlaybackFlag["SEEK"] = "seek";
	})(PlaybackFlag = exports.PlaybackFlag || (exports.PlaybackFlag = {}));
	var makePlaybackProc = function (body) {
	    // tslint:disable-next-line:no-function-constructor-with-string-args
	    return new Function('$time', body);
	};
	var PLAYBACK_FLAGS = {
	    once: true,
	    play: true,
	    loop: true,
	    stop: true,
	    seek: true,
	};
	// tslint:disable:variable-name
	var HaikuTimeline = /** @class */ (function (_super) {
	    __extends(HaikuTimeline, _super);
	    function HaikuTimeline(component, name, options) {
	        var _this = _super.call(this) || this;
	        _this.component = component;
	        _this.name = name;
	        _this.assignOptions(options || {});
	        _this.globalClockTime = 0;
	        _this.localElapsedTime = 0;
	        _this.localControlledTime = null; // Only set this to a number if time is 'controlled'
	        _this.areUpdatesFrozen = !!_this.options.freeze;
	        _this.isTimelineLooping = !!_this.options.loop;
	        _this.isTimelinePlaying = true;
	        _this.offsetCalculator = null;
	        _this.lastFrame = null;
	        _this.numLoops = 0;
	        return _this;
	    }
	    HaikuTimeline.prototype.getMs = function (amount, unit) {
	        switch (unit) {
	            case "fr" /* Frame */:
	                return Math.round(this.getFrameDuration() * amount);
	            case "ms" /* Millisecond */:
	            default:
	                // The only currently valid alternative to TimeUnit.Frame is TimeUnit.Millisecond.
	                return amount;
	        }
	    };
	    HaikuTimeline.prototype.getFrameDuration = function () {
	        return this.component.getClock().getFrameDuration();
	    };
	    HaikuTimeline.prototype.assignOptions = function (options) {
	        this.options = assign_1.default(this.options || {}, DEFAULT_OPTIONS, options || {});
	    };
	    HaikuTimeline.prototype.ensureClockIsRunning = function () {
	        var clock = this.component.getClock();
	        if (!clock.isRunning()) {
	            clock.start();
	        }
	    };
	    /**
	     * @method setComponent
	     * @description Internal hook to allow Haiku to hot swap on-stage components during editing.
	     */
	    HaikuTimeline.prototype.setComponent = function (component) {
	        this.component = component;
	    };
	    HaikuTimeline.prototype.doUpdateWithGlobalClockTime = function (globalClockTime) {
	        if (this.isFrozen()) {
	            return;
	        }
	        var prevGlobalClockTime = this.getClockTime();
	        var deltaGlobalClockTime = globalClockTime - prevGlobalClockTime;
	        this.globalClockTime = globalClockTime;
	        // If we update with the global clock time while a timeline is paused, the next
	        // time we resume playing it will "jump forward" to the time that has elapsed.
	        if (this.isPaused()) {
	            return;
	        }
	        this.doUpdateWithTimeDelta(deltaGlobalClockTime);
	    };
	    HaikuTimeline.prototype.doUpdateWithTimeDelta = function (deltaClockTime) {
	        var ceilTime = this.getCeilTime();
	        var prevElapsedTime = this.getElapsedTime();
	        var newElapsedTime = prevElapsedTime + deltaClockTime;
	        var didLoop = HaikuTimeline.didTimeLoop(prevElapsedTime, newElapsedTime, ceilTime);
	        this.setElapsedTime(newElapsedTime);
	        // If we are a looping timeline, reset to zero once we've gone past our max
	        if (this.isLooping() && didLoop) {
	            this.numLoops++;
	            // Avoid log DoS for too-short timelines
	            if (this.getMaxTime() > 200) {
	                this.component.callHook('timeline:loop', {
	                    localElapsedTime: newElapsedTime,
	                    maxExplicitlyDefinedTime: this.getMaxTime(),
	                    globalClockTime: this.getClockTime(),
	                    boundedFrame: this.getBoundedFrame(),
	                    loopCount: this.numLoops,
	                });
	            }
	        }
	    };
	    HaikuTimeline.prototype.executePreUpdateHooks = function (globalClockTime) {
	        this.doUpdateWithGlobalClockTime(globalClockTime);
	    };
	    HaikuTimeline.prototype.executePostUpdateHooks = function (globalClockTime) {
	        if (this.isFrozen() || this.isPaused()) {
	            return;
	        }
	        var frame = this.getBoundedFrame();
	        var time = Math.round(this.getBoundedTime());
	        this.component.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, "timeline:" + this.getName() + ":" + frame, [frame, time]);
	        // Allow users to subscribe to the 'frame' event globally
	        this.component.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, 'frame', [frame, time]);
	        // Deprecated; please use the 'frame' event instead. This is used by the Haiku Share Page.
	        this.emit('tick', frame, time);
	        this.lastFrame = frame;
	    };
	    HaikuTimeline.prototype.getLastFrame = function () {
	        return this.lastFrame;
	    };
	    HaikuTimeline.prototype.controlTime = function (controlledTimeToSet, newGlobalClockTime) {
	        this.setControlledTime(parseInt(controlledTimeToSet || 0, 10));
	        // Need to update the properties so that accessors like .getFrame() work after this update.
	        this.doUpdateWithGlobalClockTime(newGlobalClockTime);
	    };
	    HaikuTimeline.prototype.isTimeControlled = function () {
	        return typeof this.getControlledTime() === NUMBER;
	    };
	    /**
	     * @method getName
	     * @description Return the name of this timeline
	     */
	    HaikuTimeline.prototype.getName = function () {
	        return this.name;
	    };
	    /**
	     * @method getMaxTime
	     * @description Return the maximum time that this timeline will reach, in ms.
	     */
	    HaikuTimeline.prototype.getMaxTime = function () {
	        var _this = this;
	        return this.cacheFetch('getMaxTime', function () {
	            var descriptorMax = _this.getMaxKeyframeTime();
	            var actionsMax = _this.getMaxActionsTime();
	            return Math.max(descriptorMax, actionsMax);
	        });
	    };
	    HaikuTimeline.prototype.getMaxKeyframeTime = function () {
	        return getTimelineMaxTime_1.default(this.getDescriptor());
	    };
	    HaikuTimeline.prototype.getMaxActionsTime = function () {
	        return Math.round(getActionsMaxTime_1.default(this.name, this.component.bytecode.eventHandlers, this.getFrameDuration()));
	    };
	    HaikuTimeline.prototype.getDescriptor = function () {
	        return this.component.getTimelineDescriptor(this.name);
	    };
	    /**
	     * @description The millisecond value for the beginning of one frame past the max.
	     */
	    HaikuTimeline.prototype.getCeilTime = function () {
	        return this.getMaxTime() + this.getMs(1, "fr" /* Frame */);
	    };
	    /**
	     * @method getClockTime
	     * @description fseek the global clock time that this timeline is at, in ms,
	     * whether or not our local time matches it or it has exceeded our max.
	     * This value is ultimately managed by the clock and passed in.
	     */
	    HaikuTimeline.prototype.getClockTime = function () {
	        return this.globalClockTime;
	    };
	    /**
	     * @method getElapsedTime
	     * @description Return the amount of time that has elapsed on this timeline since
	     * it started updating, up to the most recent time update it received from the clock.
	     * Note that for inactive ftimelines, this value will cease increasing as of the last update.
	     */
	    HaikuTimeline.prototype.getElapsedTime = function () {
	        return this.localElapsedTime;
	    };
	    HaikuTimeline.prototype.setElapsedTime = function (t) {
	        this.localElapsedTime = t;
	    };
	    /**
	     * @description If time has been explicitly set here via time control, this value will
	     * be the number of that setting.
	     */
	    HaikuTimeline.prototype.getControlledTime = function () {
	        return this.localControlledTime;
	    };
	    HaikuTimeline.prototype.setControlledTime = function (t) {
	        this.localControlledTime = t;
	    };
	    /**
	     * @description Return the locally elapsed time, or the maximum time of this timeline,
	     * whichever is smaller. Useful if you want to know what the "effective" time of this
	     * timeline is, not necessarily how much has elapsed in an absolute sense. This is used
	     * in the renderer to determine what value to calculate "now" deterministically.
	     */
	    HaikuTimeline.prototype.getBoundedTime = function () {
	        var max = this.getMaxTime();
	        var time = (this.isTimeControlled())
	            ? this.getControlledTime()
	            : this.getElapsedTime();
	        if (this.offsetCalculator) {
	            try {
	                time = this.offsetCalculator.call(this, time);
	            }
	            catch (exception) {
	                // no-op
	            }
	        }
	        if (this.isLooping()) {
	            var looped = HaikuTimeline.modulo(Math.round(time), this.getCeilTime());
	            return looped;
	        }
	        // Don't allow negative time
	        if (time < 0.000001) {
	            time = 0;
	        }
	        return Math.min(time, max);
	    };
	    /**
	     * @description Convenience wrapper. Currently returns the bounded time. There's an argument
	     * that this should return the elapsed time, though. #TODO
	     */
	    HaikuTimeline.prototype.getTime = function () {
	        return this.getBoundedTime();
	    };
	    /**
	     * @description Return the current frame up to the maximum frame available for this timeline's duration.
	     */
	    HaikuTimeline.prototype.getBoundedFrame = function () {
	        var time = this.getTime(); // Returns the bounded time
	        var timeStep = this.component.getClock().getFrameDuration();
	        return Math.round(time / timeStep);
	    };
	    /**
	     * @method getUnboundedFrame
	     * @description Return the current frame, even if it is above the maximum frame.
	     */
	    HaikuTimeline.prototype.getUnboundedFrame = function () {
	        var time = this.getElapsedTime(); // The elapsed time can go larger than the max time; see timeline.js
	        var timeStep = this.component.getClock().getFrameDuration();
	        return Math.round(time / timeStep);
	    };
	    /**
	     * @method getFrame
	     * @description Return the bounded frame.
	     * There's an argument that this should return the absolute frame. #TODO
	     */
	    HaikuTimeline.prototype.getFrame = function () {
	        return this.getBoundedFrame();
	    };
	    /**
	     * @method isPlaying
	     * @description Returns T/F if the timeline is playing
	     */
	    HaikuTimeline.prototype.isPlaying = function () {
	        return this.isTimelinePlaying;
	    };
	    HaikuTimeline.prototype.setPlaying = function (isPlaying) {
	        if (isPlaying === void 0) { isPlaying = true; }
	        this.isTimelinePlaying = !!isPlaying;
	    };
	    HaikuTimeline.prototype.isPaused = function () {
	        return !this.isPlaying();
	    };
	    /**
	     * @method isFinished
	     * @description Returns T/F if the timeline is finished.
	     * If this timeline is set to loop, it is never "finished".
	     */
	    HaikuTimeline.prototype.isFinished = function () {
	        if (this.isLooping() || this.isTimeControlled()) {
	            return false;
	        }
	        return this.getElapsedTime() > this.getMaxTime();
	    };
	    HaikuTimeline.prototype.isUnfinished = function () {
	        return !this.isFinished();
	    };
	    HaikuTimeline.prototype.getDuration = function () {
	        return this.getMaxTime() || 0;
	    };
	    HaikuTimeline.prototype.setRepeat = function (bool) {
	        if (bool === void 0) { bool = true; }
	        this.isTimelineLooping = !!bool;
	    };
	    HaikuTimeline.prototype.getRepeat = function () {
	        return this.isTimelineLooping;
	    };
	    HaikuTimeline.prototype.isRepeating = function () {
	        return this.getRepeat();
	    };
	    HaikuTimeline.prototype.isLooping = function () {
	        return this.isRepeating();
	    };
	    /**
	     * @method isFrozen
	     * @description Returns T/F if the timeline is frozen
	     */
	    HaikuTimeline.prototype.isFrozen = function () {
	        return this.areUpdatesFrozen;
	    };
	    HaikuTimeline.prototype.freeze = function () {
	        this.areUpdatesFrozen = true;
	    };
	    HaikuTimeline.prototype.unfreeze = function () {
	        this.areUpdatesFrozen = false;
	    };
	    HaikuTimeline.prototype.start = function () {
	        this.startSoftly(0);
	        this.emit('start');
	    };
	    HaikuTimeline.prototype.startSoftly = function (maybeElapsedTime) {
	        this.setPlaying(true);
	        this.setElapsedTime(maybeElapsedTime || 0);
	    };
	    HaikuTimeline.prototype.stop = function () {
	        this.stopSoftly();
	        this.emit('stop');
	    };
	    HaikuTimeline.prototype.stopSoftly = function () {
	        this.setPlaying(false);
	    };
	    HaikuTimeline.prototype.pause = function () {
	        this.pauseSoftly();
	        this.emit('pause');
	    };
	    HaikuTimeline.prototype.pauseSoftly = function () {
	        this.setPlaying(false);
	    };
	    HaikuTimeline.prototype.play = function (options) {
	        if (options === void 0) { options = {}; }
	        this.playSoftly();
	        if (!options || !options.skipMarkForFullFlush) {
	            this.component.markForFullFlush();
	        }
	        this.emit('play');
	    };
	    HaikuTimeline.prototype.playSoftly = function () {
	        this.ensureClockIsRunning();
	        this.setPlaying(true);
	        // When playing after exiting controlled-time mode, start from the last controlled time.
	        if (this.isTimeControlled()) {
	            this.setElapsedTime(this.getControlledTime());
	            // To properly exit controlled-time mode, we need to set controlled time to null.
	            this.setControlledTime(null);
	        }
	    };
	    HaikuTimeline.prototype.seek = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        var ms = this.getMs(amount, unit);
	        this.seekSoftly(ms);
	        this.component.markForFullFlush();
	        this.emit('seek', ms);
	    };
	    HaikuTimeline.prototype.seekSoftly = function (ms) {
	        this.ensureClockIsRunning();
	        this.controlTime(ms, this.component.getClock().getTime());
	        this.setElapsedTime(this.getControlledTime());
	    };
	    HaikuTimeline.prototype.gotoAndPlay = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        var ms = this.getMs(amount, unit);
	        this.seekSoftly(ms);
	        this.play(null);
	    };
	    HaikuTimeline.prototype.gotoAndStop = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        this.seekSoftly(this.getMs(amount, unit));
	        if (this.component && this.component.context && this.component.context.tick) {
	            this.component.context.tick();
	        }
	        this.pause();
	    };
	    HaikuTimeline.prototype.setPlaybackStatus = function (input) {
	        var _a = this.parsePlaybackStatus(input), flag = _a.flag, time = _a.time, proc = _a.proc;
	        if (flag === "loop" /* LOOP */) {
	            this.setRepeat(true);
	        }
	        if (flag === "once" /* ONCE */) {
	            this.setRepeat(false);
	        }
	        // If the sending timeline is frozen, don't inadvertently unfreeze its component's guests
	        if (flag === "loop" /* LOOP */ || // In the current API, loop also connotes play
	            flag === "once" /* ONCE */ ||
	            flag === "play" /* PLAY */) {
	            if (!this.isPlaying()) {
	                this.play();
	            }
	        }
	        if (flag === "stop" /* STOP */) {
	            if (this.isPlaying()) {
	                this.stop();
	            }
	        }
	        if (flag === "seek" /* SEEK */) {
	            this.seek(time || 0, "ms" /* Millisecond */);
	        }
	        if (typeof proc === 'function') {
	            this.offsetCalculator = proc;
	        }
	    };
	    HaikuTimeline.prototype.parsePlaybackStatus = function (input) {
	        if (!input) {
	            return {
	                flag: "loop" /* LOOP */,
	            };
	        }
	        // If an object, assume it takes the format of a flag payload
	        if (typeof input === 'object') {
	            return input;
	        }
	        if (typeof input === 'number' && Tokenizer_1.isNumeric(input)) {
	            return {
	                flag: "seek" /* SEEK */,
	                // Assume the input is frames and convert to our internal format, milliseconds
	                time: this.getMs(Number(input), "fr" /* Frame */),
	            };
	        }
	        if (typeof input === 'string') {
	            var tokens = this.cacheFetch("getPlaybackStatusTokens:" + input, function () {
	                return Tokenizer_1.tokenizeDirective(input).map(function (_a) {
	                    var value = _a.value;
	                    return value;
	                });
	            });
	            // If no tokens, assume the default: A looping timeline
	            if (tokens.length < 1) {
	                return {
	                    flag: "loop" /* LOOP */,
	                };
	            }
	            // Fast-path if we got a single playback flag string
	            if (tokens.length === 1 && PLAYBACK_FLAGS[tokens[0]]) {
	                return {
	                    flag: tokens[0],
	                };
	            }
	            var finals = [];
	            // Convert any known number-unit tuples in the token stream into their canonical
	            // ms-based time value. For example [100,ms]->[100], or [10]->[166] (frames to ms).
	            for (var i = 0; i < tokens.length; i++) {
	                var curr = tokens[i];
	                var next = tokens[i + 1];
	                if (typeof curr === 'number') {
	                    if (next === 'ms') {
	                        finals.push(this.getMs(curr, "ms" /* Millisecond */));
	                        i++;
	                        continue;
	                    }
	                    if (next === 'fr') {
	                        finals.push(this.getMs(curr, "fr" /* Frame */));
	                        i++;
	                        continue;
	                    }
	                    // Frames are assumed to be the default that an end-user would write
	                    if (next !== 'fr') {
	                        finals.push(this.getMs(curr, "fr" /* Frame */));
	                        continue;
	                    }
	                }
	                finals.push(curr);
	            }
	            if (finals.length > 1) {
	                // E.g. if we got +100, make it loop+100
	                if (!PLAYBACK_FLAGS[finals[0]]) {
	                    finals.unshift("loop" /* LOOP */);
	                }
	            }
	            var expr = finals.map(function (val) {
	                if (PLAYBACK_FLAGS[val]) {
	                    return '$time';
	                }
	                return val;
	            }).join(' ');
	            var proc = void 0;
	            try {
	                proc = makePlaybackProc("return " + expr + ";");
	            }
	            catch (exception) {
	                // no-op
	            }
	            var out = {
	                proc: proc,
	                flag: finals[0],
	            };
	            return out;
	        }
	        return {
	            flag: "loop" /* LOOP */,
	        };
	    };
	    /**
	     * @deprecated
	     * TODO: Please change this to a getter.
	     */
	    HaikuTimeline.prototype.duration = function () {
	        return this.getDuration();
	    };
	    Object.defineProperty(HaikuTimeline.prototype, "repeat", {
	        get: function () {
	            return this.getRepeat();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuTimeline.prototype, "time", {
	        get: function () {
	            return this.getTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuTimeline.prototype, "max", {
	        get: function () {
	            return this.getMaxTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuTimeline.prototype, "frame", {
	        get: function () {
	            return this.getFrame();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuTimeline.__name__ = 'HaikuTimeline';
	    HaikuTimeline.all = function () { return HaikuBase_1.default.getRegistryForClass(HaikuTimeline); };
	    HaikuTimeline.where = function (criteria) {
	        var all = HaikuTimeline.all();
	        return all.filter(function (timeline) {
	            return timeline.matchesCriteria(criteria);
	        });
	    };
	    HaikuTimeline.create = function (component, name, config) {
	        return new HaikuTimeline(component, name, config);
	    };
	    /**
	     * @description Modulus, but returns zero if the second number is zero,
	     * and calculates an appropriate "cycle" if the number is negative.
	     */
	    HaikuTimeline.modulo = function (n, ceil) {
	        if (ceil === 0) {
	            return 0;
	        }
	        return ((n % ceil) + ceil) % ceil;
	    };
	    /**
	     * @description Given a previous elapsed time (a), a new elapsed time (b), and a max
	     * time (max), determine whether the given timeline has looped between (a) and (b).
	     *
	     * E.g.:
	     *   0----------100
	     *        62        103  true
	     *
	     *   0----------100
	     *        62    100  true
	     *
	     *   0----------100
	     *        62   99  false
	     *
	     *   0----------100
	     *              100  110  false
	     *
	     *   0----------100
	     *               101  110  false
	     *
	     *   0----------100
	     *              100
	     *              100  false
	     *
	     *   0----------100
	     *   0          100  false
	     *
	     *   0----------100
	     *   0
	     *   0  false
	     */
	    HaikuTimeline.didTimeLoop = function (a, b, ceil) {
	        var ma = HaikuTimeline.modulo(a, ceil);
	        var mb = HaikuTimeline.modulo(b, ceil);
	        return mb < ma;
	    };
	    return HaikuTimeline;
	}(HaikuBase_1.default));
	exports.default = HaikuTimeline;
	//# sourceMappingURL=HaikuTimeline.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuNode_1 = __webpack_require__(29);
	var compareSemver_1 = __webpack_require__(107);
	var migrateAutoSizing_1 = __webpack_require__(113);
	var applyCssLayout_1 = __webpack_require__(54);
	var functionToRFO_1 = __webpack_require__(31);
	var reifyRFO_1 = __webpack_require__(122);
	var UpgradeVersionRequirement;
	(function (UpgradeVersionRequirement) {
	    UpgradeVersionRequirement["OriginSupport"] = "3.2.0";
	    UpgradeVersionRequirement["TimelineDefaultFrames"] = "3.2.23";
	    UpgradeVersionRequirement["CamelAutoSizingOffset3DOmnibus"] = "3.5.2";
	})(UpgradeVersionRequirement || (UpgradeVersionRequirement = {}));
	var HAIKU_ID_ATTRIBUTE = 'haiku-id';
	var HAIKU_SOURCE_ATTRIBUTE = 'haiku-source';
	var HAIKU_VAR_ATTRIBUTE = 'haiku-var';
	var HAIKU_ROOT_DEFAULT_REGEX = /^web\+haikuroot:\/\//;
	var HAIKU_ROOT_DEFAULT = 'web+haikuroot://';
	var SRC_ATTRIBUTE = 'src';
	var HREF_ATTRIBUTE = 'href';
	var XLINKHREF_ATTRIBUTE = 'xlink:href';
	var requiresUpgrade = function (coreVersion, requiredVersion) { return !coreVersion ||
	    compareSemver_1.default(coreVersion, requiredVersion) < 0; };
	var areKeyframesDefined = function (keyframeGroup) {
	    return (keyframeGroup &&
	        Object.keys(keyframeGroup).length > 0);
	};
	var ensure3dPreserved = function (node) {
	    if (!node || !node.attributes || !node.attributes.style) {
	        return;
	    }
	    var changed = false;
	    // Only preserve 3D behavior if the node hasn't been *explicitly* defined yet
	    if (!node.attributes.style.transformStyle) {
	        node.attributes.style.transformStyle = 'preserve-3d';
	        changed = true;
	        if (!node.attributes.style.perspective) {
	            node.attributes.style.perspective = 'inherit';
	        }
	    }
	    return changed;
	};
	/**
	 * Migrations are a mechanism to modify our bytecode from legacy format to the current format.
	 * This always runs against production components' bytecode to ensure their data is a format
	 * that the current version of the engine knows how to handle. There are two phases to migration:
	 * the pre-phase, which runs before an initial .render call, and a post-phase, which runs after.
	 */
	exports.runMigrationsPrePhase = function (component, options) {
	    var bytecode = component.bytecode;
	    if (!bytecode.states) {
	        bytecode.states = {};
	    }
	    if (!bytecode.metadata) {
	        bytecode.metadata = {};
	    }
	    var coreVersion = bytecode.metadata.core || bytecode.metadata.player;
	    // Convert the properties array to the states dictionary
	    if (bytecode.properties) {
	        var properties = bytecode.properties;
	        delete bytecode.properties;
	        for (var i = 0; i < properties.length; i++) {
	            var propertySpec = properties[i];
	            var updatedSpec = {};
	            if (propertySpec.value !== undefined) {
	                updatedSpec.value = propertySpec.value;
	            }
	            if (propertySpec.type !== undefined) {
	                updatedSpec.type = propertySpec.type;
	            }
	            if (propertySpec.setter !== undefined) {
	                updatedSpec.set = propertySpec.setter;
	            }
	            if (propertySpec.getter !== undefined) {
	                updatedSpec.get = propertySpec.getter;
	            }
	            if (propertySpec.set !== undefined) {
	                updatedSpec.set = propertySpec.set;
	            }
	            if (propertySpec.get !== undefined) {
	                updatedSpec.get = propertySpec.get;
	            }
	            bytecode.states[propertySpec.name] = updatedSpec;
	        }
	    }
	    // Convert the eventHandlers array into a dictionary
	    // [{selector:'foo',name:'onclick',handler:function}] => {'foo':{'onclick':{handler:function}}}
	    if (Array.isArray(bytecode.eventHandlers)) {
	        var eventHandlers = bytecode.eventHandlers;
	        delete bytecode.eventHandlers;
	        bytecode.eventHandlers = {};
	        for (var j = 0; j < eventHandlers.length; j++) {
	            var eventHandlerSpec = eventHandlers[j];
	            if (!bytecode.eventHandlers[eventHandlerSpec.selector]) {
	                bytecode.eventHandlers[eventHandlerSpec.selector] = {};
	            }
	            bytecode.eventHandlers[eventHandlerSpec.selector][eventHandlerSpec.name] = {
	                handler: eventHandlerSpec.handler,
	            };
	        }
	    }
	    if (bytecode.timelines) {
	        // Expand all bytecode properties represented as shorthand.
	        for (var timelineName in bytecode.timelines) {
	            for (var selector in bytecode.timelines[timelineName]) {
	                for (var property in bytecode.timelines[timelineName][selector]) {
	                    if (bytecode.timelines[timelineName][selector][property] === null) {
	                        delete bytecode.timelines[timelineName][selector][property];
	                    }
	                    else if (typeof bytecode.timelines[timelineName][selector][property] !== 'object') {
	                        bytecode.timelines[timelineName][selector][property] = {
	                            0: {
	                                value: bytecode.timelines[timelineName][selector][property],
	                            },
	                        };
	                    }
	                }
	            }
	        }
	    }
	    var needsOmnibusUpgrade = requiresUpgrade(coreVersion, "3.5.2" /* CamelAutoSizingOffset3DOmnibus */);
	    var referencesToUpdate = {};
	    if (bytecode.template) {
	        // y-overflow + preserve-3d leads to various rendering bugs, so for now, disable when overflow is available.
	        // #FIXME
	        var autoPreserve3d_1 = component.config.preserve3d === 'auto' && component.config.overflowY !== 'visible';
	        HaikuNode_1.visitManaTree('0', bytecode.template, function (_, attributes) {
	            if (typeof attributes !== 'object') {
	                return;
	            }
	            if (options.mutations) {
	                if (attributes.id) {
	                    var prev = attributes.id;
	                    var next = prev + '-' + options.mutations.referenceUniqueness;
	                    attributes.id = next;
	                    referencesToUpdate["#" + prev] = "#" + next;
	                    referencesToUpdate['url(#' + prev + ')'] = 'url(#' + next + ')';
	                }
	            }
	        }, null, 0);
	        HaikuNode_1.visitManaTree('0', bytecode.template, function (elementName, attributes) {
	            if (typeof attributes !== 'object') {
	                return;
	            }
	            var timelineProperties = bytecode.timelines.Default["haiku:" + attributes[HAIKU_ID_ATTRIBUTE]] || {};
	            // Hoist xlink:href up to the timeline if not already done. Older versions of Haiku installed xlink:href in the
	            // attributes dictionary.
	            if (attributes[XLINKHREF_ATTRIBUTE]) {
	                timelineProperties[XLINKHREF_ATTRIBUTE] = { 0: { value: attributes[XLINKHREF_ATTRIBUTE] } };
	                delete attributes[XLINKHREF_ATTRIBUTE];
	            }
	            if (options.mutations) {
	                for (var property in timelineProperties) {
	                    if (property !== SRC_ATTRIBUTE && property !== XLINKHREF_ATTRIBUTE && property !== HREF_ATTRIBUTE) {
	                        continue;
	                    }
	                    for (var keyframe in timelineProperties[property]) {
	                        var value = timelineProperties[property][keyframe].value;
	                        if (HAIKU_ROOT_DEFAULT_REGEX.test(value)) {
	                            timelineProperties[property][keyframe].value = value.replace(HAIKU_ROOT_DEFAULT, options.mutations.haikuRoot);
	                        }
	                        else if (referencesToUpdate[value]) {
	                            timelineProperties[property][keyframe].value = referencesToUpdate[value];
	                        }
	                    }
	                }
	            }
	            // Switch the legacy 'source' attribute to the new 'haiku-source'
	            if (attributes.source) {
	                attributes[HAIKU_SOURCE_ATTRIBUTE] = attributes.source;
	                delete attributes.source;
	            }
	            if (attributes.identifier) {
	                attributes[HAIKU_VAR_ATTRIBUTE] = attributes.identifier;
	                delete attributes.identifier;
	            }
	            // Legacy backgroundColor was a root prop; in newer versions it's style.backgroundColor.
	            // We only want to update this if the user *hasn't* explicitly set style.backroundColor.
	            if (timelineProperties.backgroundColor && !timelineProperties['style.backgroundColor']) {
	                timelineProperties['style.backgroundColor'] = timelineProperties.backgroundColor;
	                delete timelineProperties.backgroundColor;
	            }
	            if (needsOmnibusUpgrade) {
	                var transformStyleGroup = timelineProperties['style.transformStyle'];
	                if (transformStyleGroup && transformStyleGroup[0] && transformStyleGroup[0].value === 'flat') {
	                    delete timelineProperties['style.transformStyle'];
	                }
	                var perspectiveGroup = timelineProperties['style.perspective'];
	                if (perspectiveGroup && perspectiveGroup[0] && perspectiveGroup[0].value === 'none') {
	                    delete timelineProperties['style.perspective'];
	                }
	                // Retire sizing layout from any SVG sizeable in favor of explicit properties.
	                if (typeof elementName === 'string' && applyCssLayout_1.SVG_SIZEABLES[elementName]) {
	                    if (timelineProperties['sizeAbsolute.x']) {
	                        timelineProperties.width = { 0: { value: timelineProperties['sizeAbsolute.x'][0].value } };
	                        delete timelineProperties['sizeAbsolute.x'];
	                        delete timelineProperties['sizeMode.x'];
	                    }
	                    if (timelineProperties['sizeAbsolute.y']) {
	                        timelineProperties.height = { 0: { value: timelineProperties['sizeAbsolute.y'][0].value } };
	                        delete timelineProperties['sizeAbsolute.y'];
	                        delete timelineProperties['sizeMode.y'];
	                    }
	                    if (timelineProperties['sizeProportional.x']) {
	                        timelineProperties.width = {
	                            0: { value: Number(timelineProperties['sizeProportional.x'][0].value) * 100 + "%" },
	                        };
	                        delete timelineProperties['sizeProportional.x'];
	                        delete timelineProperties['sizeMode.x'];
	                    }
	                    if (timelineProperties['sizeProportional.y']) {
	                        timelineProperties.height = {
	                            0: { value: Number(timelineProperties['sizeProportional.y'][0].value) * 100 + "%" },
	                        };
	                        delete timelineProperties['sizeProportional.y'];
	                        delete timelineProperties['sizeMode.y'];
	                    }
	                }
	            }
	            // If we see that any 3D transformations are applied, automatically override flat perspective
	            // if it hasn't been automatically set, so that 3D perspective "just works"
	            if (!component.doPreserve3d &&
	                autoPreserve3d_1 && (areKeyframesDefined(timelineProperties['rotation.x']) ||
	                areKeyframesDefined(timelineProperties['rotation.y']) ||
	                areKeyframesDefined(timelineProperties['translation.z']) ||
	                areKeyframesDefined(timelineProperties['scale.z']))) {
	                component.doPreserve3d = true;
	            }
	            if (!bytecode.timelines.Default["haiku:" + attributes[HAIKU_ID_ATTRIBUTE]] &&
	                Object.keys(timelineProperties).length > 0) {
	                // Update with our hot object if we inadvertently created this object during migration.
	                bytecode.timelines.Default["haiku:" + attributes[HAIKU_ID_ATTRIBUTE]] = timelineProperties;
	            }
	        }, null, 0);
	    }
	    if (bytecode.timelines) {
	        // Although not ideal, it's likely beneficial to do another pass through the timelines to fill in
	        // reference uniqueness. This may allow us to avoid a rerender below.
	        for (var timelineName in bytecode.timelines) {
	            for (var selector in bytecode.timelines[timelineName]) {
	                if (needsOmnibusUpgrade) {
	                    // Migrate auto-sizing.
	                    migrateAutoSizing_1.default(bytecode.timelines[timelineName][selector]);
	                }
	                // Ensure ID-based selectors like #box work.
	                if (referencesToUpdate[selector]) {
	                    bytecode.timelines[timelineName][referencesToUpdate[selector]] = bytecode.timelines[timelineName][selector];
	                    delete bytecode.timelines[timelineName][selector];
	                    selector = referencesToUpdate[selector];
	                }
	                for (var propertyName in bytecode.timelines[timelineName][selector]) {
	                    if (needsOmnibusUpgrade) {
	                        // Migrate camel-case property names.
	                        var camelVariant = options.attrsHyphToCamel[propertyName];
	                        if (camelVariant) {
	                            bytecode.timelines[timelineName][selector][camelVariant] =
	                                bytecode.timelines[timelineName][selector][propertyName];
	                            delete bytecode.timelines[timelineName][selector][propertyName];
	                        }
	                    }
	                    for (var keyframeMs in bytecode.timelines[timelineName][selector][propertyName]) {
	                        var keyframeDesc = bytecode.timelines[timelineName][selector][propertyName][keyframeMs];
	                        if (keyframeDesc && referencesToUpdate[keyframeDesc.value]) {
	                            keyframeDesc.value = referencesToUpdate[keyframeDesc.value];
	                        }
	                    }
	                }
	            }
	        }
	    }
	};
	exports.runMigrationsPostPhase = function (component, options, version) {
	    var bytecode = component.bytecode;
	    var coreVersion = bytecode.metadata.core || bytecode.metadata.player;
	    var needsRerender = false;
	    if (component.doPreserve3d) {
	        var node = component.node;
	        if (node) {
	            var didNodePreserve3dChange = ensure3dPreserved(node);
	            if (didNodePreserve3dChange) {
	                component.patches.push(node);
	            }
	        }
	        // The wrapper also needs preserve-3d set for 3d-preservation to work
	        var parent_1 = component.parentNode; // This should be the "wrapper div" node
	        if (parent_1) {
	            var didParentPreserve3dChange = ensure3dPreserved(parent_1);
	            if (didParentPreserve3dChange) {
	                component.patches.push(parent_1);
	            }
	        }
	    }
	    var needsCamelAutoSizingOffsetOmnibus = requiresUpgrade(coreVersion, "3.5.2" /* CamelAutoSizingOffset3DOmnibus */);
	    if (needsCamelAutoSizingOffsetOmnibus) {
	        var alsoMigrateOrigin_1 = requiresUpgrade(coreVersion, "3.2.0" /* OriginSupport */);
	        component.visit(function (element) {
	            var offsetX = 0;
	            var offsetY = 0;
	            var timelineProperties = bytecode.timelines.Default["haiku:" + element.getComponentId()];
	            if (!timelineProperties) {
	                return;
	            }
	            // Note: the migrations below are incorrect if align properties were ever defined on an element with explicit
	            // size. Since in practice this never happened, this is fine.
	            if (timelineProperties['align.x']) {
	                var alignX = timelineProperties['align.x'][0] && timelineProperties['align.x'][0].value;
	                if (typeof alignX === 'number') {
	                    offsetX += alignX * element.getNearestDefinedNonZeroAncestorSizeX();
	                }
	            }
	            if (timelineProperties['align.y']) {
	                var alignY = timelineProperties['align.y'][0] && timelineProperties['align.y'][0].value;
	                if (typeof alignY === 'number') {
	                    offsetY += alignY * element.getNearestDefinedNonZeroAncestorSizeY();
	                }
	            }
	            if (timelineProperties['mount.x']) {
	                var mountX = timelineProperties['mount.x'][0] && timelineProperties['mount.x'][0].value;
	                if (typeof mountX === 'number') {
	                    offsetX -= mountX * element.getNearestDefinedNonZeroAncestorSizeX();
	                }
	            }
	            if (timelineProperties['mount.y']) {
	                var mountY = timelineProperties['mount.y'][0] && timelineProperties['mount.y'][0].value;
	                if (typeof mountY === 'number') {
	                    offsetY -= mountY * element.getNearestDefinedNonZeroAncestorSizeY();
	                }
	            }
	            if (alsoMigrateOrigin_1) {
	                // Prior to explicit origin support, we were applying a default origin of (0, 0, 0) for all objects, then
	                // allowing the browser default for SVG elements (50%, 50%, 0px) be the effective transform-origin. This led to
	                // inaccuracies in the layout system, specifically related to addressing translation on SVG elements and
	                // addressing origin in general. Since as of the introduction of explicit origin support we had not made layout
	                // offset addressable in Haiku, we can "backport" to the old coordinate system by simply offsetting layout
	                // by its "origin error".
	                if (element.tagName === 'svg') {
	                    offsetX += 0.5 * element.getNearestDefinedNonZeroAncestorSizeX();
	                    offsetY += 0.5 * element.getNearestDefinedNonZeroAncestorSizeY();
	                }
	                else {
	                    offsetX += element.originX * element.getNearestDefinedNonZeroAncestorSizeX();
	                    offsetY += element.originY * element.getNearestDefinedNonZeroAncestorSizeY();
	                }
	            }
	            if (offsetX !== 0) {
	                timelineProperties['offset.x'] = { 0: { value: offsetX } };
	                needsRerender = true;
	            }
	            if (offsetY !== 0) {
	                timelineProperties['offset.y'] = { 0: { value: offsetY } };
	                needsRerender = true;
	            }
	            delete timelineProperties['align.x'];
	            delete timelineProperties['align.y'];
	            delete timelineProperties['align.z'];
	            delete timelineProperties['mount.x'];
	            delete timelineProperties['mount.y'];
	            delete timelineProperties['mount.z'];
	        });
	    }
	    component.eachEventHandler(function (eventSelector, eventName, _a) {
	        var handler = _a.handler;
	        if (!handler) {
	            console.warn("Unable to migrate event handler for " + eventSelector + " " + eventName + " in " + component.$id);
	            return;
	        }
	        var rfo = handler.__rfo || functionToRFO_1.default(handler).__function;
	        var params = rfo.params;
	        var body = rfo.body;
	        var changed = false;
	        if (requiresUpgrade(coreVersion, "3.2.23" /* TimelineDefaultFrames */)) {
	            (['.seek(', '.gotoAndPlay(', '.gotoAndStop(']).forEach(function (methodSignature) {
	                for (var cursor = 0; cursor < body.length; ++cursor) {
	                    if (body.substring(cursor, cursor + methodSignature.length) !== methodSignature) {
	                        continue;
	                    }
	                    changed = true;
	                    // We have matched e.g. this.getDefaultTimeline().seek( at the string index of ".seek(".
	                    // Using the assumption that the method arguments do not contain string arguments with parentheses inside,
	                    // we can apply a simple parenthesis-balancing algorithm here.
	                    cursor += methodSignature.length;
	                    var openParens = 1;
	                    while (openParens > 0 && cursor < body.length) {
	                        if (body[cursor] === '(') {
	                            openParens++;
	                        }
	                        else if (body[cursor] === ')') {
	                            openParens--;
	                        }
	                        ++cursor;
	                    }
	                    // Essentially, replace .seek(foo) with .seek(foo, 'ms').
	                    body = body.slice(0, cursor - 1) + ", 'ms')" + body.slice(cursor);
	                }
	            });
	        }
	        if (params.length < 4) {
	            params = ['component', 'element', 'target', 'event'];
	            changed = true;
	        }
	        if (changed) {
	            bytecode.eventHandlers[eventSelector][eventName].handler = reifyRFO_1.default(__assign({}, rfo, { params: params,
	                body: body }));
	        }
	    });
	    if (needsRerender) {
	        component.clearCaches();
	        component.markForFullFlush();
	    }
	    // Ensure the bytecode metadata core version is recent.
	    bytecode.metadata.core = version;
	};
	//# sourceMappingURL=Migration.js.map

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var api_1 = __webpack_require__(50);
	var Interpolate_1 = __webpack_require__(49);
	var StateTransitionManager = /** @class */ (function () {
	    function StateTransitionManager(component) {
	        this.component = component;
	        // Store running state transitions
	        this.transitions = {};
	        this.clock = this.component.getClock();
	        this.states = this.component.state;
	    }
	    /**
	     * Create a new state transition.
	     */
	    StateTransitionManager.prototype.setState = function (transitionEnd, parameter) {
	        var _a, _b, _c, _d;
	        // If not a transition, execute it right away
	        if (!parameter) {
	            for (var key in transitionEnd) {
	                delete this.transitions[key];
	            }
	            for (var key in transitionEnd) {
	                var from = this.states[key];
	                var to = transitionEnd[key];
	                if (from !== to) {
	                    this.component.callHook('state:change', {
	                        from: from,
	                        to: to,
	                        state: key,
	                    });
	                }
	            }
	            this.setStates(transitionEnd);
	            return;
	        }
	        // Get current time
	        var currentTime = this.clock.getTime();
	        // Set default values than assign parameters
	        var transitionParameter = { duration: 0, curve: api_1.Curve.Linear, queue: false };
	        Object.assign(transitionParameter, parameter);
	        // Copy current states as transition start (needed to calculate interpolation)
	        for (var key in transitionEnd) {
	            // Ignore state if it doesn't pre exist
	            if (key in this.states) {
	                var from = this.states[key];
	                var to = transitionEnd[key];
	                // queued transitions are add into queue
	                // If parameter.queue is true, it is a queued setState
	                // If state transition for key is not created, process like a queued SetState
	                if (transitionParameter.queue && this.transitions[key]) {
	                    if (from !== to) {
	                        this.component.callHook('state:change', {
	                            from: from,
	                            to: to,
	                            queued: true,
	                            state: key,
	                            duration: transitionParameter.duration,
	                        });
	                    }
	                    this.transitions[key].push({
	                        transitionParameter: transitionParameter,
	                        transitionEnd: (_a = {}, _a[key] = to, _a),
	                        transitionStart: (_b = {}, _b[key] = from, _b),
	                        startTime: currentTime,
	                        endTime: currentTime + transitionParameter.duration,
	                        duration: transitionParameter.duration,
	                    });
	                    // non queued transitions are overwrite transition queue
	                }
	                else {
	                    if (from !== to) {
	                        this.component.callHook('state:change', {
	                            from: from,
	                            to: to,
	                            started: true,
	                            state: key,
	                            duration: transitionParameter.duration,
	                        });
	                    }
	                    this.transitions[key] = [{
	                            transitionParameter: transitionParameter,
	                            transitionEnd: (_c = {}, _c[key] = to, _c),
	                            transitionStart: (_d = {}, _d[key] = from, _d),
	                            startTime: currentTime,
	                            endTime: currentTime + transitionParameter.duration,
	                            duration: transitionParameter.duration,
	                        }];
	                }
	            }
	        }
	        // Make sure state is update on setState call
	        this.tickStateTransitions();
	    };
	    // We technically could call HaikuComponent::setStates, but passing only
	    // state parameters instead whole HaikuComponent to contructor make this class
	    // less coupled
	    StateTransitionManager.prototype.setStates = function (states) {
	        for (var key in states) {
	            this.states[key] = states[key];
	        }
	    };
	    StateTransitionManager.prototype.isExpired = function (transition, currentTime) {
	        return this.clock.getTime() >= transition.endTime;
	    };
	    /**
	     * Should be called on every tick. It cleans expired state transitions
	     * and execute interpolation of running state transitions.
	     */
	    StateTransitionManager.prototype.tickStateTransitions = function () {
	        var _a;
	        var currentTime = this.clock.getTime();
	        var interpolatedStates = {};
	        // For each state, process state transition queue
	        for (var stateName in this.transitions) {
	            // On queued states, only first transition is processed, other transitions are in queue.
	            if (this.transitions[stateName].length > 0) {
	                var transition = this.transitions[stateName][0];
	                if (this.isExpired(transition, currentTime)) {
	                    this.component.callHook('state:change', {
	                        finished: true,
	                        state: stateName,
	                        to: transition.transitionEnd[stateName],
	                        duration: transition.duration,
	                    });
	                    // If expired, assign transitionEnd.
	                    // NOTE: In the future, with custom transition function implemented calculating
	                    // interpolation at endTime will be necessary (eg. a user defined curve that at
	                    // endTime isn't 100%, but let's say 60%)
	                    Object.assign(interpolatedStates, transition.transitionEnd);
	                    // Remove expired transition.
	                    this.transitions[stateName].splice(0, 1);
	                    if (transition.transitionParameter.onComplete instanceof Function) {
	                        transition.transitionParameter.onComplete();
	                    }
	                    // Update next queued state transition or delete empty transition vector for performance reasons
	                    if (this.transitions[stateName].length > 0) {
	                        this.component.callHook('state:change', {
	                            started: true,
	                            state: stateName,
	                            to: this.transitions[stateName][0].transitionEnd[stateName],
	                        });
	                        this.transitions[stateName][0].transitionStart = (_a = {}, _a[stateName] = interpolatedStates[stateName], _a);
	                        this.transitions[stateName][0].startTime = currentTime;
	                        this.transitions[stateName][0].endTime = currentTime + this.transitions[stateName][0].duration;
	                    }
	                    else {
	                        delete this.transitions[stateName];
	                    }
	                }
	                else {
	                    // Calculate interpolated states.
	                    Object.assign(interpolatedStates, Interpolate_1.interpolate(currentTime, transition.transitionParameter.curve, transition.startTime, transition.endTime, transition.transitionStart, transition.transitionEnd));
	                }
	            }
	        }
	        this.setStates(interpolatedStates);
	    };
	    /**
	     * Delete every running transition
	     */
	    StateTransitionManager.prototype.deleteAllStateTransitions = function () {
	        this.transitions = {};
	    };
	    Object.defineProperty(StateTransitionManager.prototype, "numQueuedTransitions", {
	        get: function () {
	            var numQueuedTransition = 0;
	            for (var stateName in this.transitions) {
	                numQueuedTransition += this.transitions[stateName].length;
	            }
	            return numQueuedTransition;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return StateTransitionManager;
	}());
	exports.default = StateTransitionManager;
	//# sourceMappingURL=StateTransitionManager.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var KeyframeUtils_1 = __webpack_require__(51);
	var Interpolate_1 = __webpack_require__(49);
	// 0:    { value: { ... } }
	// 2500: { value: { ... } }
	// 5000: { value: { ... } }
	var getKeyframesList = function (sorted, nowValue) {
	    for (var i = 0; i < sorted.length; i++) {
	        var j = i + 1;
	        var current = sorted[i];
	        var next = sorted[j];
	        if (current <= nowValue) {
	            if (next > nowValue) {
	                return [current, next];
	            }
	            if (j >= sorted.length) {
	                return [current];
	            }
	        }
	    }
	};
	exports.calculateValue = function (keyframeGroup, nowValue, sortedKeyframes) {
	    if (!sortedKeyframes) {
	        // tslint:disable-next-line:no-parameter-reassignment
	        sortedKeyframes = KeyframeUtils_1.getSortedKeyframes(keyframeGroup);
	    }
	    var keyframesList = getKeyframesList(sortedKeyframes, nowValue);
	    if (!keyframesList || keyframesList.length < 1) {
	        return;
	    }
	    var currentKeyframe = keyframesList[0];
	    var currentTransition = keyframeGroup[currentKeyframe];
	    var nextKeyframe = keyframesList[1];
	    var nextTransition = keyframeGroup[nextKeyframe];
	    var finalValue = getTransitionValue(currentKeyframe, currentTransition, nextKeyframe, nextTransition, nowValue);
	    return finalValue;
	};
	var getTransitionValue = function (currentKeyframe, currentTransition, nextKeyframe, nextTransition, nowValue) {
	    var currentValue = currentTransition.value;
	    if (!currentTransition.curve) {
	        return currentValue;
	    } // No curve indicates immediate transition
	    if (!nextTransition) {
	        return currentValue;
	    } // We have gone past the final transition
	    var finalValue = Interpolate_1.interpolate(nowValue, currentTransition.curve, currentKeyframe, nextKeyframe, currentValue, nextTransition.value);
	    return finalValue;
	};
	//# sourceMappingURL=Transitions.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuContext_1 = __webpack_require__(92);
	var dom_1 = __webpack_require__(134);
	var pkg = __webpack_require__(17);
	var VERSION = pkg.version;
	/**
	 * Example ways in which the export of this module is invoked:
	 *
	 * // via embed snippet
	 * window.HaikuPlayer['2.0.125'](require('./code/main/code.js')) // #LEGACY
	 * window.HaikuCore['2.0.125'](require('./code/main/code.js'))
	 *
	 * // via module require
	 * var HaikuDOMAdapter = require('@haiku/core/dom')
	 * module.exports = HaikuDOMAdapter(require('./code/main/code.js'))
	 */
	/**
	 * @function HaikuDOMAdapter
	 * @description Given a bytecode object, return a factory function which can create a DOM-playable component.
	 */
	// tslint:disable-next-line:variable-name
	var HaikuDOMAdapter = function (bytecode, config, safeWindow) {
	    if (!config) {
	        // tslint:disable-next-line:no-parameter-reassignment
	        config = {};
	    }
	    if (!safeWindow) {
	        if (typeof window !== 'undefined') {
	            // tslint:disable-next-line:no-parameter-reassignment
	            safeWindow = window;
	        }
	    }
	    return HaikuContext_1.default.createComponentFactory(dom_1.default, bytecode, config, // Note: Full config object, of which options is one property!
	    safeWindow);
	};
	HaikuDOMAdapter.defineOnWindow = function () {
	    // Allow multiple instances of different versions to exist on the same page
	    if (typeof window !== 'undefined') {
	        if (!window.HaikuResolve) {
	            var haikuResolutions_1 = {};
	            window.HaikuResolve = function (playerVersion) {
	                if (haikuResolutions_1[playerVersion]) {
	                    return haikuResolutions_1[playerVersion];
	                }
	                var matches = playerVersion.match(/^(\d+)\.(\d+)\.(\d+)$/).map(Number);
	                if (!matches) {
	                    return;
	                }
	                var _ = matches[0], major = matches[1], minor = matches[2], patch = matches[3];
	                var compatibleVersions = Object.keys(window.HaikuCore)
	                    .map(function (semver) { return semver.split('.').map(Number); })
	                    .filter(function (semverParts) {
	                    if (semverParts.length !== 3 || semverParts[0] !== major) {
	                        return false;
	                    }
	                    return semverParts[1] >= minor && ((semverParts[1] > minor) ? true : semverParts[2] >= patch);
	                });
	                if (compatibleVersions.length === 0) {
	                    return;
	                }
	                compatibleVersions.sort(function (_a, _b) {
	                    var __ = _a[0], aMinor = _a[1], aPatch = _a[2];
	                    var ___ = _b[0], bMinor = _b[1], bPatch = _b[2];
	                    if (aMinor < bMinor) {
	                        return -1;
	                    }
	                    if (aMinor > bMinor) {
	                        return 1;
	                    }
	                    return aPatch < bPatch ? -1 : 1;
	                });
	                return haikuResolutions_1[playerVersion] =
	                    window.HaikuCore[compatibleVersions[compatibleVersions.length - 1].join('.')];
	            };
	        }
	        if (!window.HaikuCore) {
	            window.HaikuCore = {};
	        }
	        window.HaikuCore[VERSION] = HaikuDOMAdapter;
	    }
	};
	HaikuDOMAdapter.defineOnWindow();
	exports.default = HaikuDOMAdapter;
	//# sourceMappingURL=HaikuDOMAdapter.js.map

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuDOMAdapter_1 = __webpack_require__(99);
	exports.default = HaikuDOMAdapter_1.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable-next-line:variable-name
	var EventsDict = {};
	var eventsList = [
	    'onAbort',
	    'onAnimationEnd',
	    'onAnimationIteration',
	    'onAnimationStart',
	    'onBlur',
	    'onCanPlay',
	    'onCanPlayThrough',
	    'onChange',
	    'onClick',
	    'onCompositionEnd',
	    'onCompositionStart',
	    'onCompositionUpdate',
	    'onContextMenu',
	    'onCopy',
	    'onCut',
	    'onDoubleClick',
	    'onDrag',
	    'onDragEnd',
	    'onDragEnter',
	    'onDragExit',
	    'onDragLeave',
	    'onDragOver',
	    'onDragStart',
	    'onDrop',
	    'onDurationChange',
	    'onEmptied',
	    'onEncrypted',
	    'onEnded',
	    'onError',
	    'onFocus',
	    'onInput',
	    'onKeyDown',
	    'onKeyPress',
	    'onKeyUp',
	    'onLoad',
	    'onLoadedData',
	    'onLoadedMetadata',
	    'onLoadStart',
	    'onMouseDown',
	    'onMouseEnter',
	    'onMouseLeave',
	    'onMouseMove',
	    'onMouseOut',
	    'onMouseOver',
	    'onMouseUp',
	    'onPaste',
	    'onPause',
	    'onPlay',
	    'onPlaying',
	    'onProgress',
	    'onRateChange',
	    'onScroll',
	    'onSeeked',
	    'onSeeking',
	    'onSelect',
	    'onStalled',
	    'onSubmit',
	    'onSuspend',
	    'onTimeUpdate',
	    'onTouchCancel',
	    'onTouchEnd',
	    'onTouchMove',
	    'onTouchStart',
	    'onTransitionEnd',
	    'onVolumeChange',
	    'onWaiting',
	    'onWheel',
	];
	for (var i = 0; i < eventsList.length; i++) {
	    var name_1 = eventsList[i];
	    EventsDict[name_1] = 'func';
	    EventsDict[name_1 + 'Capture'] = 'func';
	}
	exports.default = EventsDict;
	//# sourceMappingURL=EventsDict.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(21);
	var Config_1 = __webpack_require__(27);
	var getParsedProperty_1 = __webpack_require__(110);
	var StringUtils_1 = __webpack_require__(106);
	var EventsDict_1 = __webpack_require__(101);
	var DEFAULT_HOST_ELEMENT_TAG_NAME = 'div';
	// tslint:disable-next-line:function-name
	function HaikuReactDOMAdapter(haikuComponentFactory, optionalRawBytecode) {
	    var HaikuReactComponentInternal = /** @class */ (function (_super) {
	        __extends(HaikuReactComponentInternal, _super);
	        function HaikuReactComponentInternal(props) {
	            var _this = _super.call(this, props) || this;
	            _this.state = {
	                // This random id is used to give us a hook to query the DOM for our mount element,
	                // even in cases where React mysteriously decides not to pass us its ref.
	                randomId: 'haiku-reactroot-' + StringUtils_1.randomString(24),
	            };
	            return _this;
	        }
	        HaikuReactComponentInternal.prototype.componentWillReceiveProps = function (nextPropsRaw) {
	            if (this.haiku) {
	                var haikuConfig = this.buildHaikuCompatibleConfigFromRawProps(nextPropsRaw);
	                this.haiku.assignConfig(haikuConfig);
	            }
	        };
	        HaikuReactComponentInternal.prototype.componentWillUnmount = function () {
	            if (this.haiku) {
	                this.haiku.callUnmount();
	            }
	        };
	        HaikuReactComponentInternal.prototype.componentDidMount = function () {
	            this.attemptMount();
	        };
	        HaikuReactComponentInternal.prototype.attemptMount = function () {
	            if (this.mount) {
	                this.createContext(this.props);
	            }
	        };
	        HaikuReactComponentInternal.prototype.buildHaikuCompatibleConfigFromRawProps = function (rawProps) {
	            var _this = this;
	            // Note that these vanities are called _after_ an initial render,
	            // i.e., after this.mount is supposed to have been attached.
	            var haikuConfig = {
	                ref: this.mount,
	                vanities: {
	                    'controlFlow.placeholder': function (element, surrogate, value, context, timeline, receiver, sender) { return visit(_this.mount, function (node) {
	                        var flexId = flexIdIfSame(element, node);
	                        if (flexId) {
	                            if (element.__memory.placeholder.surrogate !== surrogate) {
	                                if (typeof surrogate.type === 'string' ||
	                                    (typeof surrogate.type === 'function' && surrogate.type.isHaikuAdapter)) {
	                                    // What *should happen* in the DOM renderer is:
	                                    // this new swapped DOM element will be updated (not replaced!)
	                                    // with the attributes of the virtual element at the same position
	                                    var div = document.createElement('div');
	                                    node.parentNode.replaceChild(div, node);
	                                    // tslint:disable-next-line:no-parameter-reassignment
	                                    node = div;
	                                }
	                                node.style.visibility = 'hidden';
	                                ReactDOM.render(surrogate, node);
	                                window.requestAnimationFrame(function () {
	                                    element.__memory.placeholder.surrogate = surrogate;
	                                    node.style.visibility = 'visible';
	                                });
	                                sender.markHorizonElement(element);
	                                sender.markForFullFlush();
	                            }
	                        }
	                    }); },
	                },
	            };
	            // It's assumed that anything the user wants to pass into the Haiku engine should be
	            // assigned among the whitelisted properties
	            if (rawProps) {
	                for (var verboseKeyName in rawProps) {
	                    // We already should have subscribed at the React host element level;
	                    // we don't pass in otherwise we can end up with multiple events fired
	                    if (EventsDict_1.default[verboseKeyName]) {
	                        continue;
	                    }
	                    haikuConfig = __assign({}, haikuConfig, getParsedProperty_1.default(rawProps, verboseKeyName));
	                }
	            }
	            return haikuConfig;
	        };
	        HaikuReactComponentInternal.prototype.createContext = function (rawProps) {
	            var haikuConfig = this.buildHaikuCompatibleConfigFromRawProps(rawProps);
	            var haikuAdapter;
	            if (rawProps.haikuAdapter) {
	                if (rawProps.haikuCode) {
	                    haikuAdapter = rawProps.haikuAdapter(rawProps.haikuCode);
	                }
	                else if (optionalRawBytecode) {
	                    haikuAdapter = rawProps.haikuAdapter(optionalRawBytecode);
	                }
	                else {
	                    throw new Error('A Haiku code object is required if you supply a Haiku adapter');
	                }
	            }
	            else {
	                // Otherwise default to the adapter which was initialized in the wrapper module
	                haikuAdapter = haikuComponentFactory;
	            }
	            if (!haikuAdapter) {
	                throw new Error('A Haiku adapter is required');
	            }
	            // Reuse existing mounted component if one exists
	            if (!this.haiku) {
	                this.haiku = haikuAdapter(// eslint-disable-line
	                this.mount, haikuConfig);
	            }
	            else {
	                // If the component already exists, update its options and make sure it remounts.
	                // This action is important if we are in e.g. React Router.
	                //
	                // Important: Note that we should NOT call remount if we just initialized the instance (i.e. stanza above)
	                // because we'll end up pausing the timelines before the first mount, resulting in a blank context.
	                this.haiku.callRemount(haikuConfig);
	            }
	        };
	        HaikuReactComponentInternal.prototype.buildHostElementPropsFromRawProps = function (rawProps) {
	            var _this = this;
	            var propsForReactHostElement = {};
	            var _loop_1 = function (key) {
	                if (willReactProbablyHandleProp(rawProps[key], key)) {
	                    if (EventsDict_1.default[key]) {
	                        // We wrap it because listeners expect to receive the Haiku component
	                        // instance as an argument; and for convenience we provide the native
	                        // event in addition to it and React's proxy
	                        propsForReactHostElement[key] = function (proxy) {
	                            return rawProps[key].call(_this, proxy, proxy && proxy.nativeEvent, _this.haiku);
	                        };
	                    }
	                    else {
	                        propsForReactHostElement[key] = rawProps[key];
	                    }
	                }
	            };
	            for (var key in rawProps) {
	                _loop_1(key);
	            }
	            // Style objects are excluded above, but we definitely want it if provided
	            var stylesForHostElement = rawProps.style || {};
	            // Merge our basic host props with some defaults we want to assign
	            return __assign({ id: this.state.randomId, style: __assign({ position: 'relative', margin: 0, padding: 0, border: 0, width: '100%', height: '100%', transform: 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)' }, stylesForHostElement) }, propsForReactHostElement);
	        };
	        HaikuReactComponentInternal.prototype.assignMountFromRef = function (element) {
	            this.mount = element;
	        };
	        HaikuReactComponentInternal.prototype.render = function () {
	            var _this = this;
	            var hostElementProps = this.buildHostElementPropsFromRawProps(this.props);
	            // Having this ref assigned like this is critical to the adapter working,
	            // so we override it despite what the host element props might say
	            hostElementProps.ref = function (element) {
	                _this.assignMountFromRef(element);
	            };
	            return React.createElement(hostElementProps.tagName || DEFAULT_HOST_ELEMENT_TAG_NAME, hostElementProps);
	        };
	        HaikuReactComponentInternal.React = React;
	        HaikuReactComponentInternal.ReactDOM = ReactDOM;
	        // This setting is required to do proper setup for placeholder/inject vanities
	        HaikuReactComponentInternal.isHaikuAdapter = true;
	        return HaikuReactComponentInternal;
	    }(React.Component));
	    return HaikuReactComponentInternal;
	}
	exports.default = HaikuReactDOMAdapter;
	function willReactProbablyHandleProp(prop, key) {
	    // Exclude any 'complex' properties like objects
	    if (prop && typeof prop === 'object') {
	        return false;
	    }
	    // Assume functions, which are usually event listeners, are handled by Haiku
	    if (typeof prop === 'function') {
	        if (EventsDict_1.default[key]) {
	            return true;
	        }
	        return false;
	    }
	    // Exclude props we know target Haiku config
	    return !Config_1.DEFAULTS.hasOwnProperty(key);
	}
	function visit(el, visitor) {
	    if (el) {
	        visitor(el);
	        if (el.children) {
	            for (var i = 0; i < el.children.length; i++) {
	                visit(el.children[i], visitor);
	            }
	        }
	    }
	}
	function flexIdIfSame(virtual, dom) {
	    if (virtual.attributes) {
	        if (virtual.attributes['haiku-id']) {
	            if (dom.getAttribute('haiku-id') === virtual.attributes['haiku-id']) {
	                return virtual.attributes['haiku-id'];
	            }
	        }
	        if (virtual.attributes.id) {
	            if (dom.getAttribute('id') === virtual.attributes.id) {
	                return virtual.attributes.id;
	            }
	        }
	    }
	    return null;
	}
	//# sourceMappingURL=HaikuReactDOMAdapter.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuReactDOMAdapter_1 = __webpack_require__(102);
	exports.default = HaikuReactDOMAdapter_1.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var color_string_1 = __webpack_require__(144);
	var STRING = 'string';
	var OBJECT = 'object';
	function parseString(str) {
	    if (!str) {
	        return null;
	    }
	    if (typeof str === OBJECT || (typeof str === STRING && str.trim().slice(0, 3) === 'url')) {
	        return str;
	    }
	    return color_string_1.get(String(str));
	}
	function generateString(desc) {
	    if (typeof desc === STRING) {
	        return desc;
	    }
	    if (!desc) {
	        return 'none';
	    }
	    return color_string_1.to(desc.model, desc.value);
	}
	exports.default = {
	    parseString: parseString,
	    generateString: generateString,
	};
	//# sourceMappingURL=ColorUtils.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SVGPathReversal_1 = __webpack_require__(189);
	var SVGPoints_1 = __webpack_require__(52);
	exports.splitSegmentInSVGPoints = function (points, pt1Index, pt2Index, t) {
	    if (pt2Index === points.length) {
	        // tslint:disable-next-line
	        pt2Index = 0;
	    }
	    var h1;
	    var h2;
	    if (points[pt2Index].curve) {
	        h1 = { x: points[pt2Index].curve.x1, y: points[pt2Index].curve.y1 };
	        h2 = { x: points[pt2Index].curve.x2, y: points[pt2Index].curve.y2 };
	    }
	    else {
	        h1 = points[pt1Index];
	        h2 = points[pt2Index];
	    }
	    var newPts = exports.cubicBezierSplit(t, points[pt1Index], h1, h2, points[pt2Index]);
	    if (points[pt2Index].curve) {
	        points[pt2Index].curve.x1 = newPts[1][1].x;
	        points[pt2Index].curve.y1 = newPts[1][1].y;
	        points[pt2Index].curve.x2 = newPts[1][2].x;
	        points[pt2Index].curve.y2 = newPts[1][2].y;
	    }
	    var newCurve = null;
	    if (points[pt2Index].curve) {
	        newCurve = {
	            type: 'cubic',
	            x1: newPts[0][1].x,
	            y1: newPts[0][1].y,
	            x2: newPts[0][2].x,
	            y2: newPts[0][2].y,
	        };
	    }
	    var newPoint = {
	        x: newPts[0][3].x,
	        y: newPts[0][3].y,
	        curve: newCurve,
	    };
	    points.splice(pt2Index, 0, newPoint);
	};
	// NOTE: See Bezier curve splitting here: https://pomax.github.io/bezierinfo/#matrixsplit
	exports.cubicBezierSplit = function (t, anchor1, handle1, handle2, anchor2) {
	    var cubicSegmentMatrix1 = [
	        1,
	        0,
	        0,
	        0,
	        -(t - 1),
	        t,
	        0,
	        0,
	        Math.pow(t - 1, 2),
	        -2 * t * (t - 1),
	        t * t,
	        0,
	        -Math.pow(t - 1, 3),
	        3 * t * Math.pow(t - 1, 2),
	        -3 * t * t * (t - 1),
	        t * t * t,
	    ];
	    var x1 = exports.mat4_multiply_vec4(cubicSegmentMatrix1, { x: anchor1.x, y: handle1.x, z: handle2.x, w: anchor2.x });
	    var y1 = exports.mat4_multiply_vec4(cubicSegmentMatrix1, { x: anchor1.y, y: handle1.y, z: handle2.y, w: anchor2.y });
	    var cubicSegmentMatrix2 = [
	        -Math.pow(t - 1, 3),
	        3 * t * Math.pow(t - 1, 2),
	        -3 * t * t * (t - 1),
	        t * t * t,
	        0,
	        Math.pow(t - 1, 2),
	        -2 * t * (t - 1),
	        t * t,
	        0,
	        0,
	        -(t - 1),
	        t,
	        0,
	        0,
	        0,
	        1,
	    ];
	    var x2 = exports.mat4_multiply_vec4(cubicSegmentMatrix2, { x: anchor1.x, y: handle1.x, z: handle2.x, w: anchor2.x });
	    var y2 = exports.mat4_multiply_vec4(cubicSegmentMatrix2, { x: anchor1.y, y: handle1.y, z: handle2.y, w: anchor2.y });
	    return [
	        [{ x: x1.x, y: y1.x }, { x: x1.y, y: y1.y }, { x: x1.z, y: y1.z }, { x: x1.w, y: y1.w }],
	        [{ x: x2.x, y: y2.x }, { x: x2.y, y: y2.y }, { x: x2.z, y: y2.z }, { x: x2.w, y: y2.w }],
	    ];
	};
	exports.distance = function (a, b) {
	    return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
	};
	// tslint:disable-next-line:variable-name
	exports.mat4_multiply_vec4 = function (m, v) {
	    return {
	        x: v.x * m[0] + v.y * m[1] + v.z * m[2] + v.w * m[3],
	        y: v.x * m[4] + v.y * m[5] + v.z * m[6] + v.w * m[7],
	        z: v.x * m[8] + v.y * m[9] + v.z * m[10] + v.w * m[11],
	        w: v.x * m[12] + v.y * m[13] + v.z * m[14] + v.w * m[15],
	    };
	};
	exports.polygonArea = function (points) {
	    var area = 0;
	    var a;
	    var b = points[points.length - 1];
	    for (var i = 0; i < points.length; i++) {
	        a = b;
	        b = points[i];
	        area += a.y * b.x - a.x * b.y;
	    }
	    return area / 2;
	};
	exports.polygonLength = function (points) {
	    var perimeter = 0;
	    var a;
	    var b = points[points.length - 1];
	    for (var i = 0; i < points.length; i++) {
	        a = b;
	        b = points[i];
	        perimeter += exports.distance(a, b);
	    }
	    return perimeter;
	};
	exports.distributeTotalVertices = function (path, totalVertices) {
	    var pointsToAdd = totalVertices - path.length;
	    if (pointsToAdd <= 0) {
	        return;
	    }
	    // Find the length of every segment (approximate)
	    // NOTE: This computes distance across the vertices, not along the actual bezier curve.
	    // A possible improvement would be finding true distance along the curve, but at a much
	    // higher computational cost.
	    var segments = [];
	    for (var i = 0; i < path.length; i++) {
	        segments.push({
	            index: i,
	            length: exports.distance(path[i], path[(i + 1) % path.length]),
	            splits: 0,
	        });
	    }
	    var addedPoints = 0;
	    while (addedPoints < pointsToAdd) {
	        // Sort by length, accounting for number of splits
	        segments.sort(function (a, b) { return (a.length / (a.splits || 1) - b.length / (b.splits || 1)); });
	        // Split the longest segment again
	        segments[segments.length - 1].splits++;
	        addedPoints++;
	    }
	    // Apply the splits
	    segments.sort(function (a, b) { return (a.index - b.index); });
	    var inserted = 0;
	    for (var i = 0; i < segments.length; i++) {
	        while (segments[i].splits > 0) {
	            // NOTE: This splits at linear values for t
	            // A possible improvement would be finding truly equidistant points along the curve
	            // at much higher computational cost.
	            exports.splitSegmentInSVGPoints(path, i + inserted, (i + inserted + 1) % path.length, 1 / (segments[i].splits + 1));
	            inserted++;
	            segments[i].splits--;
	        }
	    }
	};
	exports.rotatePathForSmallestDistance = function (source, dest) {
	    if (source.length !== dest.length) {
	        throw new Error('Mismatched source and destination length.');
	    }
	    var moveToPopped = false;
	    if (source[0].moveTo && dest[0].moveTo) {
	        source.shift();
	        dest.shift();
	        moveToPopped = true;
	    }
	    var smallestOffset = 0;
	    var minDistance = Infinity;
	    for (var rotationOffset = 0; rotationOffset < source.length; rotationOffset++) {
	        var distanceSum = 0;
	        for (var i = 0; i < source.length; i++) {
	            var dist = exports.distance(source[i], dest[(rotationOffset + i) % dest.length]);
	            distanceSum += dist;
	        }
	        if (distanceSum < minDistance) {
	            minDistance = distanceSum;
	            smallestOffset = rotationOffset;
	        }
	    }
	    if (smallestOffset === 0) {
	        if (moveToPopped) {
	            source.unshift({
	                x: source[source.length - 1].x,
	                y: source[source.length - 1].y,
	                moveTo: true,
	            });
	            dest.unshift({
	                x: dest[dest.length - 1].x,
	                y: dest[dest.length - 1].y,
	                moveTo: true,
	            });
	        }
	        return;
	    }
	    var closed = dest[dest.length - 1].closed;
	    var spliced = dest.splice(0, smallestOffset);
	    dest.splice.apply(dest, [source.length, 0].concat(spliced));
	    // Clean up
	    if (closed) {
	        dest[dest.length - 1].closed = true;
	    }
	    if (moveToPopped) {
	        source.unshift({
	            x: source[source.length - 1].x,
	            y: source[source.length - 1].y,
	            moveTo: true,
	        });
	        dest.unshift({
	            x: dest[dest.length - 1].x,
	            y: dest[dest.length - 1].y,
	            moveTo: true,
	        });
	    }
	    for (var i = 0; i < dest.length; i++) {
	        if (i < dest.length - 1 && dest[i].closed) {
	            delete dest[i].closed;
	        }
	        if (i > 0 && dest[i].moveTo) {
	            delete dest[i].moveTo;
	        }
	    }
	};
	exports.ensurePathClockwise = function (path) {
	    if (exports.polygonArea(path) > 0) {
	        var reversed = SVGPathReversal_1.reverseNormalizedPath(SVGPathReversal_1.normalizePath(SVGPoints_1.default.pointsToPath(path)));
	        path.splice(0, path.length);
	        var reversedPoints = SVGPoints_1.default.pathToPoints(reversed);
	        for (var i = 0; i < reversedPoints.length; i++) {
	            path.push(reversedPoints[i]);
	        }
	    }
	};
	exports.normalizePointCurves = function (path) {
	    for (var i = 1; i < path.length; i++) {
	        if (path[i].curve) {
	            // Convert quadratic to cubic bezier
	            if (path[i].curve.type === 'quadratic') {
	                var newCurve = {
	                    type: 'cubic',
	                };
	                newCurve.x1 = path[i - 1].x + 2 / 3 * (path[i].curve.x1 - path[i - 1].x);
	                newCurve.y1 = path[i - 1].y + 2 / 3 * (path[i].curve.y1 - path[i - 1].y);
	                newCurve.x2 = path[i].x + 2 / 3 * (path[i].curve.x1 - path[i].x);
	                newCurve.y2 = path[i].y + 2 / 3 * (path[i].curve.y2 - path[i].y);
	                path[i].curve = newCurve;
	            }
	            else if (path[i].curve.type === 'arc') {
	                console.warn('Paths with arcs are not yet supported.');
	            }
	            continue;
	        }
	        path[i].curve = {
	            type: 'cubic',
	            x1: path[i - 1].x,
	            y1: path[i - 1].y,
	            x2: path[i].x,
	            y2: path[i].y,
	        };
	    }
	};
	exports.isMultiShape = function (path) {
	    for (var i = 0; i < path.length; i++) {
	        if (path[i].closed && i < path.length - 1) {
	            return true;
	        }
	    }
	    return false;
	};
	exports.synchronizePathStructure = function () {
	    var paths = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        paths[_i] = arguments[_i];
	    }
	    // Multi-shape not yet supported for magic-morph
	    if (paths.some(exports.isMultiShape)) {
	        return;
	    }
	    var maxVerts = Math.max.apply(Math, paths.map(function (path) { return path.length; }));
	    var validPaths = paths.filter(function (path) { return path.length && !path.some(function (_a) {
	        var x = _a.x, y = _a.y;
	        return isNaN(x) || isNaN(y);
	    }); });
	    validPaths.forEach(function (path) {
	        exports.ensurePathClockwise(path);
	        exports.distributeTotalVertices(path, maxVerts);
	        exports.normalizePointCurves(path);
	    });
	    for (var i = 0; i < validPaths.length - 1; i++) {
	        exports.rotatePathForSmallestDistance(validPaths[i], validPaths[i + 1]);
	    }
	};
	//# sourceMappingURL=PathUtils.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Quick-and-dirty way to generate unique DOM-friendly ids on the fly...
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ALPHABET = 'abcdefghijklmnopqrstuvwxyz';
	exports.randomString = function (len) {
	    var str = '';
	    while (str.length < len) {
	        str += exports.ALPHABET[Math.floor(Math.random() * exports.ALPHABET.length)];
	    }
	    return str;
	};
	//# sourceMappingURL=StringUtils.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2017. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Simple semver comparitor function for semvers.
	 *
	 * Used for determining if a semver a = x.y.z is less than, greater than, or equal to a semver b = x'.y'.z'. Returns 1
	 * if a > b, -1 if a < b, or 0 if they are equal.
	 *
	 * @param {string} a
	 * @param {string} b
	 * @returns {number}
	 */
	var compareSemver = function (a, b) {
	    var semverA = a.split('.');
	    var semverB = b.split('.');
	    if (semverA.length !== 3 || semverB.length !== 3) {
	        throw new Error("Invalid semver comparison: " + a + ", " + b);
	    }
	    for (var i = 0; i < 3; ++i) {
	        if (semverA[i] < semverB[i]) {
	            return -1;
	        }
	        if (semverA[i] > semverB[i]) {
	            return 1;
	        }
	    }
	    return 0;
	};
	exports.default = compareSemver;
	//# sourceMappingURL=compareSemver.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function generateLogger() {
	    var CONSOLE_ERRORS = {};
	    return function consoleErrorOnce(err) {
	        var str = err && err.message.toString();
	        if (!CONSOLE_ERRORS[str]) {
	            CONSOLE_ERRORS[str] = true;
	            console.error(err);
	        }
	    };
	}
	exports.default = generateLogger();
	//# sourceMappingURL=consoleErrorOnce.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = (function (name, actions, mspf) {
	    var max = 0;
	    if (!actions) {
	        return max;
	    }
	    for (var selector in actions) {
	        for (var eventName in actions[selector]) {
	            var _a = eventName.split(':'), _ = _a[0], // always "timeline"
	            timelineNameOfListener = _a[1], frameKeyOfListener = _a[2];
	            // Skip non-frame-listener events
	            if (!timelineNameOfListener || !frameKeyOfListener) {
	                continue;
	            }
	            // Skip frame listeners for timelines other than us
	            if (timelineNameOfListener !== name) {
	                continue;
	            }
	            var frameOfListener = Number(frameKeyOfListener);
	            var timeOfListener = frameOfListener * mspf;
	            if (timeOfListener > max) {
	                max = timeOfListener;
	            }
	        }
	    }
	    return max;
	});
	//# sourceMappingURL=getActionsMaxTime.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var HAIKU_CONFIG_PROPS_RENAME_MAPPING = {
	    haikuOptions: 'options',
	    haikuStates: 'states',
	    haikuInitialStates: 'states',
	    haikuEventHandlers: 'eventHandlers',
	    haikuTimelines: 'timelines',
	    haikuVanities: 'vanities',
	};
	/**
	 * Parses a specific property specified by `verboseKeyName` from the `props`
	 * object, renaming and merging legacy props as necessary.
	 * This method is mainly used by the React and Vue adapters.
	 * @param props
	 * @param verboseKeyName
	 * @returns {Object}
	 */
	var getParsedProperty = function (props, verboseKeyName) {
	    var result = {};
	    var haikuConfigRemappedKey = HAIKU_CONFIG_PROPS_RENAME_MAPPING[verboseKeyName];
	    var haikuConfigFinalKey = haikuConfigRemappedKey || verboseKeyName;
	    // Special case: Options used to be a separate object, so if we see this legacy
	    // format, just merge it in with the root level of the new options
	    if (haikuConfigFinalKey === 'options') {
	        for (var optionsSubKey in props[verboseKeyName]) {
	            result[optionsSubKey] = props[verboseKeyName][optionsSubKey];
	        }
	    }
	    else {
	        result[haikuConfigFinalKey] = props[verboseKeyName];
	    }
	    return result;
	};
	exports.default = getParsedProperty;
	//# sourceMappingURL=getParsedProperty.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function getTimelineMaxTime(descriptor) {
	    var max = 0;
	    for (var selector in descriptor) {
	        var group = descriptor[selector];
	        for (var output in group) {
	            var keyframes = group[output];
	            if (typeof keyframes !== 'object') {
	                // In case this is run before migrations, continue (non-object keyframes means only 0-keyframe).
	                continue;
	            }
	            var keys = Object.keys(keyframes);
	            for (var i = 0; i < keys.length; i++) {
	                var key = parseInt(keys[i], 10);
	                if (key > max) {
	                    max = key;
	                }
	            }
	        }
	    }
	    return max;
	}
	exports.default = getTimelineMaxTime;
	//# sourceMappingURL=getTimelineMaxTime.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @method isMutableProperty
	 * @description Mechanism to determine if a property is mutated within the timeline.
	 */
	function isMutableProperty(property, propertyName) {
	    // For now, we can use a "naive" set of sufficient (but not necessary) conditions for immutability of a property:
	    //   1. Has exactly one keyframe.
	    //   2. The keyframe is "0".
	    //   3. The value at keyframe "0" is not a function (and so it cannot be mutated by changes in the state container).
	    // Although there is a more complete definition of immutability, this is enough to identify a property which is
	    // "likely mutable".
	    return Object.keys(property).length !== 1
	        || !property.hasOwnProperty('0')
	        || typeof property[0].value === 'function'
	        || /^controlFlow/.test(propertyName);
	}
	exports.default = isMutableProperty;
	//# sourceMappingURL=isMutableProperty.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Layout3D_1 = __webpack_require__(14);
	var migrateAutoSizing = function (propertyGroup) {
	    migrateAutoSizingForProperty(propertyGroup, 'sizeAbsolute.x');
	    migrateAutoSizingForProperty(propertyGroup, 'sizeAbsolute.y');
	};
	var migrateAutoSizingForProperty = function (propertyGroup, propertyName) {
	    if (propertyGroup[propertyName]) {
	        for (var keyframeMs in propertyGroup[propertyName]) {
	            if (propertyGroup[propertyName][keyframeMs].value === true) {
	                propertyGroup[propertyName][keyframeMs].value = Layout3D_1.AUTO_SIZING_TOKEN;
	            }
	        }
	    }
	};
	exports.default = migrateAutoSizing;
	//# sourceMappingURL=migrateAutoSizing.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function parseCssValueString(str, optionalPropertyHint) {
	    if (typeof str === 'number') {
	        return {
	            value: str,
	            unit: null,
	        };
	    }
	    if (str === null || str === undefined) {
	        return {
	            value: null,
	            unit: null,
	        };
	    }
	    var num;
	    var nmatch = str.match(/([+-]?[\d|.]+)/);
	    if (nmatch) {
	        num = Number(nmatch[0]);
	    }
	    else {
	        num = 0;
	    }
	    var unit;
	    var smatch = str.match(/(em|px|%|turn|deg|in)/);
	    if (smatch) {
	        unit = smatch[0];
	    }
	    else {
	        if (optionalPropertyHint && optionalPropertyHint.match(/rotate/)) {
	            unit = 'deg';
	        }
	        else {
	            unit = null;
	        }
	    }
	    return {
	        unit: unit,
	        value: num,
	    };
	}
	exports.default = parseCssValueString;
	//# sourceMappingURL=parseCssValueString.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Returns true iff a transform value is "essentially" a specified basis int.
	 */
	exports.transformValueIsEssentiallyInt = function (transformValue, basis) { return Math.abs(transformValue - basis) < 1e-6; };
	//# sourceMappingURL=transformValueIsEssentiallyInt.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * This file contains modified code from https://github.com/famous/engine
	 *
	 * The original code was released under the MIT license.
	 *
	 * MIT License (MIT)
	 *
	 * Copyright (c) 2015 Famous Industries Inc.
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */
	var transformValueIsEssentiallyInt_1 = __webpack_require__(115);
	var Layout3D_1 = __webpack_require__(14);
	var TRANSFORM_ZERO = '0';
	var TRANSFORM_COMMA = ',';
	var simplifyTransform = function (transform) { return transformValueIsEssentiallyInt_1.transformValueIsEssentiallyInt(transform, 0) ? TRANSFORM_ZERO : transform; };
	function formatTransform(transform, format) {
	    if (format === Layout3D_1.default.FORMATS.TWO) {
	        // Example: matrix(1,0,0,0,0,1)
	        // 2d matrix is: matrix(scaleX(),skewY(),skewX(),scaleY(),translateX(),translateY())
	        // Modify via: matrix(a,b,c,d,tx,ty) <= matrix3d(a,b,0,0,c,d,0,0,0,0,1,0,tx,ty,0,1)
	        return "matrix(" + [
	            transform[0],
	            transform[1],
	            transform[4],
	            transform[5],
	            transform[12],
	            transform[13],
	        ].map(simplifyTransform).join(TRANSFORM_COMMA) + ")";
	    }
	    // Example: matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,716,243,0,1)
	    return "matrix3d(" + transform.map(simplifyTransform).join(TRANSFORM_COMMA) + ")";
	}
	exports.default = formatTransform;
	//# sourceMappingURL=formatTransform.js.map

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function scopeOfElement(mana) {
	    if (mana.__memory.scope) {
	        return mana.__memory.scope;
	    }
	    if (mana.__memory && mana.__memory.parent) {
	        return scopeOfElement(mana.__memory.parent);
	    }
	    return null;
	}
	exports.default = scopeOfElement;
	//# sourceMappingURL=scopeOfElement.js.map

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReservedWords_1 = __webpack_require__(119);
	var WRAP_PREFIX = '_$';
	var WRAP_SUFFIX = '$_';
	var VALIDITY_REGEX = /(^[^a-zA-Z_\$])|([^a-zA-Z_\$0-9])/g;
	function charReplacer(c) {
	    return WRAP_PREFIX + c.charCodeAt(0) + WRAP_SUFFIX;
	}
	function isInt(value) {
	    return !isNaN(parseInt(value, 10)) && parseInt(value, 10) === parseFloat(value);
	}
	/**
	 * @function toIdentifier
	 * @description Converts arbitrary text into a valid JavaScript identifier.
	 * This operation should be reversible.
	 */
	function toIdentifier(str) {
	    var out = str;
	    out = out.replace(VALIDITY_REGEX, charReplacer);
	    if (ReservedWords_1.default.WORDS[out]) {
	        return "" + WRAP_PREFIX + out + WRAP_SUFFIX;
	    }
	    return out;
	}
	exports.toIdentifier = toIdentifier;
	/**
	 * @function toText
	 * @description Inverse of toIdentifier
	 */
	function toText(str) {
	    return str.replace(/_\$([a-zA-Z_0-9]+)\$_/g, function (full) {
	        var part = full.slice(2, full.length - 2);
	        // Ignore JavaScript keywords that we may have wrapped
	        if (isInt(part)) {
	            return String.fromCharCode(parseInt(part, 10));
	        }
	        return part;
	    });
	}
	exports.toText = toText;
	//# sourceMappingURL=JavaScriptIdentifier.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Just a dictionary of all JavaScript reserved words (current and future).
	 * This is used during code generation to ensure that neither element attributes
	 * nor user-defined states collide with known keywords which will cause problems
	 * with codegen and runtime exceptions.
	 */
	/* tslint:disable */
	var WORDS = {
	    'enum': true,
	    'function': true,
	    'implements': true,
	    'with': true,
	    'abstract': true,
	    'arguments': true,
	    'await': true,
	    'boolean': true,
	    'break': true,
	    'byte': true,
	    'case': true,
	    'catch': true,
	    'char': true,
	    'class': true,
	    'const': true,
	    'continue': true,
	    'debugger': true,
	    'default': true,
	    'delete': true,
	    'do': true,
	    'double': true,
	    'else': true,
	    'eval': true,
	    'export': true,
	    'extends': true,
	    'false': true,
	    'final': true,
	    'finally': true,
	    'float': true,
	    'for': true,
	    'goto': true,
	    'if': true,
	    'import': true,
	    'in': true,
	    'instanceof': true,
	    'int': true,
	    'interface': true,
	    'let': true,
	    'long': true,
	    'native': true,
	    'new': true,
	    'null': true,
	    'package': true,
	    'private': true,
	    'protected': true,
	    'public': true,
	    'return': true,
	    'short': true,
	    'static': true,
	    'super': true,
	    'switch': true,
	    'synchronized': true,
	    'this': true,
	    'throw': true,
	    'throws': true,
	    'transient': true,
	    'true': true,
	    'try': true,
	    'typeof': true,
	    'undefined': true,
	    'var': true,
	    'void': true,
	    'volatile': true,
	    'while': true,
	    'yield': true,
	};
	/* tslint:enable */
	var isReserved = function (word) {
	    return WORDS[word];
	};
	exports.default = {
	    isReserved: isReserved,
	    WORDS: WORDS,
	};
	//# sourceMappingURL=ReservedWords.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var marshalParams_1 = __webpack_require__(121);
	function functionSpecificationToFunction(name, params, body, type) {
	    if (type === void 0) { type = 'FunctionExpression'; }
	    var fn;
	    if (type === 'ArrowFunctionExpression') {
	        // tslint:disable-next-line:no-function-constructor-with-string-args
	        fn = new Function('\n' +
	            'return ' +
	            (name || '') +
	            '(' +
	            marshalParams_1.default(params) +
	            ') => {\n' +
	            '  ' +
	            (body || '') +
	            '\n' +
	            '}\n')();
	    }
	    else {
	        // tslint:disable-next-line:no-function-constructor-with-string-args
	        fn = new Function('\n' +
	            'return function ' +
	            (name || '') +
	            '(' +
	            marshalParams_1.default(params) +
	            ') {\n' +
	            '  ' +
	            (body || '') +
	            '\n' +
	            '}\n')();
	    }
	    return fn;
	}
	exports.default = functionSpecificationToFunction;
	//# sourceMappingURL=functionSpecificationToFunction.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var JavaScriptIdentifier_1 = __webpack_require__(118);
	var data = {
	    baddies: 0,
	};
	function arrayParamToString(param) {
	    var pieces = [];
	    for (var i = 0; i < param.length; i++) {
	        pieces.push(stringifyParam(param[i], null));
	    }
	    return '[ ' + pieces.join(', ') + ' ]';
	}
	function objectParamToString(param) {
	    var pieces = [];
	    // Special case, an object that describes a rest parameter
	    if (param.__rest) {
	        return '...' + param.__rest;
	    }
	    for (var key in param) {
	        pieces.push(stringifyParam(param[key], key));
	    }
	    return '{ ' + pieces.join(', ') + ' }';
	}
	function stringifyParam(param, key) {
	    if (param && typeof param === 'string') {
	        return JavaScriptIdentifier_1.toIdentifier(param);
	    }
	    if (param && Array.isArray(param)) {
	        // Let `a: []` be a signal that we only want to access 'a'
	        if (param.length < 1) {
	            return key;
	        }
	        if (key) {
	            // e.g.: a, a: [...] <~ To allow reference to the destructure root
	            return key + ', ' + key + ': ' + arrayParamToString(param);
	        }
	        return arrayParamToString(param);
	    }
	    if (param && typeof param === 'object') {
	        // Let `a: {}` be a signal that we only want to access 'a'
	        if (Object.keys(param).length < 1) {
	            return key;
	        }
	        if (key) {
	            // e.g. a, a: { ... } <~ To allow reference to the destructure root
	            return key + ', ' + key + ': ' + objectParamToString(param);
	        }
	        return objectParamToString(param);
	    }
	    // In case we get something we just can't handle, create something unique and noticeably ugly.
	    return '__' + data.baddies++ + '__';
	}
	function marshalParams(params) {
	    return params
	        .map(function (param) {
	        // Need wrap function to avoid passing the index (key) to stringifyParam, which uses that to detect something
	        return stringifyParam(param, null);
	    })
	        .join(', ');
	}
	exports.default = marshalParams;
	//# sourceMappingURL=marshalParams.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var functionSpecificationToFunction_1 = __webpack_require__(120);
	var inject_1 = __webpack_require__(56);
	function reifyRFO(rfo) {
	    var fn = functionSpecificationToFunction_1.default(rfo.name || '', rfo.params, rfo.body, rfo.type);
	    // Upstream can signal that this function needs to become 'injected'
	    // in order to function properly using this flag
	    if (rfo.injectee) {
	        inject_1.default.apply(null, [fn].concat(rfo.params));
	    }
	    return fn;
	}
	exports.default = reifyRFO;
	//# sourceMappingURL=reifyRFO.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuBase_1 = __webpack_require__(13);
	var HaikuComponent_1 = __webpack_require__(48);
	var assign_1 = __webpack_require__(18);
	var applyLayout_1 = __webpack_require__(124);
	var assignAttributes_1 = __webpack_require__(125);
	var createRightClickMenu_1 = __webpack_require__(128);
	var createSvgElement_1 = __webpack_require__(129);
	var createTextNode_1 = __webpack_require__(57);
	var getElementSize_1 = __webpack_require__(130);
	var getLocalDomEventPosition_1 = __webpack_require__(131);
	var getTypeAsString_1 = __webpack_require__(132);
	var isBlankString_1 = __webpack_require__(135);
	var isTextNode_1 = __webpack_require__(58);
	var normalizeName_1 = __webpack_require__(139);
	var removeElement_1 = __webpack_require__(140);
	var replaceElementWithText_1 = __webpack_require__(141);
	var isNil = function (v) {
	    return v === undefined || v === null;
	};
	var connectTarget = function (virtualNode, domElement) {
	    if (virtualNode && typeof virtualNode === 'object') {
	        // This normally happens in HaikuComponent.hydrateNode, but we might be operating
	        // as a thin-renderer where no hydration has occurred; so do the bootstrapping here.
	        if (!virtualNode.__memory) {
	            virtualNode.__memory = {};
	        }
	        // A virtual node can have multiple targets in the DOM due to an implementation
	        // detail in the Haiku editing environment; FIXME
	        if (!virtualNode.__memory.targets) {
	            virtualNode.__memory.targets = [];
	        }
	        if (virtualNode.__memory.targets.indexOf(domElement) === -1) {
	            virtualNode.__memory.targets.push(domElement);
	        }
	    }
	};
	// tslint:disable:variable-name
	var HaikuDOMRenderer = /** @class */ (function (_super) {
	    __extends(HaikuDOMRenderer, _super);
	    function HaikuDOMRenderer(mount, config) {
	        var _this = _super.call(this) || this;
	        _this.shouldListenerReceiveEvent = function (name, rewritten, event, match, mount) {
	            if (name === 'hover' || name === 'unhover') {
	                return event.target === match;
	            }
	            if (name === 'keyup' || name === 'keydown' || name === 'keypress') {
	                // See not about keyboard handling in HaikuDOMRenderer#decideMountElement
	                if (mount === _this.getWindow()) {
	                    return true;
	                }
	            }
	            // Since we subscribe to events from the root element, we rewrite these as 'mouseover' and 'mouseout'
	            // so we can adequately capture "bubbled" enters/leaves to meet the 99% expectation of users. Then
	            // we mimic the bubbling logic here so the semantics align with normal DOM semantics
	            if (name === 'mouseenter' || name === 'mouseleave') {
	                return (match === event.target &&
	                    ( // Don't fire if the user's mouse went from inside the child into the target
	                    !match.contains ||
	                        !match.contains(event.relatedTarget)));
	            }
	            return (match === event.target ||
	                (match.contains && match.contains(event.target)));
	        };
	        _this.mount = mount;
	        _this.user = {
	            mouse: {
	                x: 0,
	                y: 0,
	                down: 0,
	                buttons: [0, 0, 0],
	            },
	            keys: {},
	            touches: [],
	            mouches: [],
	        };
	        _this.config = config;
	        _this.shouldCreateContainer = true;
	        // Ensure we don't conflict with existing content in the mount
	        _this.clear();
	        return _this;
	    }
	    HaikuDOMRenderer.prototype.clear = function () {
	        if (this.mount) {
	            while (this.mount.firstChild) {
	                this.mount.removeChild(this.mount.firstChild);
	            }
	        }
	    };
	    HaikuDOMRenderer.prototype.getMountForComponent = function (component) {
	        // The component without a host is the root component, and uses this node.
	        if (!component.host) {
	            return this.mount;
	        }
	        return component.target && component.target.parentNode;
	    };
	    HaikuDOMRenderer.prototype.render = function (virtualContainer, virtualTree, component) {
	        return HaikuDOMRenderer.renderTree(
	        // The injected mount is for the case that the caller wants to render into a node
	        // other than the root node of the context, for example calling render on a subcomponent
	        this.getMountForComponent(component), virtualContainer, [virtualTree], component, false, // isPatchOperation
	        false);
	    };
	    HaikuDOMRenderer.prototype.patch = function (component, deltas) {
	        // The component upstream may use an empty value to indicate a no-op
	        if (!deltas || Object.keys(deltas).length < 1) {
	            return;
	        }
	        for (var compositeId in deltas) {
	            var virtualElement = deltas[compositeId];
	            var parentVirtualElement = virtualElement.__memory && virtualElement.__memory.parent;
	            var domTargets = virtualElement.__memory && virtualElement.__memory.targets;
	            if (!domTargets) {
	                continue;
	            }
	            for (var i = 0; i < domTargets.length; i++) {
	                var domTarget = domTargets[i];
	                if (!domTarget.parentNode) {
	                    continue;
	                }
	                HaikuDOMRenderer.updateElement(domTarget, // DOM node
	                virtualElement, // mana node
	                domTarget.parentNode, // DOM node
	                parentVirtualElement, // mana node
	                component, true);
	            }
	        }
	    };
	    HaikuDOMRenderer.prototype.menuize = function (component) {
	        return createRightClickMenu_1.default(this.mount, component);
	    };
	    HaikuDOMRenderer.prototype.mixpanel = function (mixpanelToken, component) {
	        return mixpanelInit(mixpanelToken, component);
	    };
	    HaikuDOMRenderer.prototype.hasSizing = function () {
	        return this.config && this.config.sizing && this.config.sizing !== 'normal';
	    };
	    HaikuDOMRenderer.prototype.getZoom = function () {
	        return ((this.config && this.config.zoom) || 1.0);
	    };
	    HaikuDOMRenderer.prototype.getPan = function () {
	        return {
	            x: (this.config && this.config.pan && this.config.pan.x) || 0,
	            y: (this.config && this.config.pan && this.config.pan.y) || 0,
	        };
	    };
	    HaikuDOMRenderer.prototype.createContainer = function (out) {
	        if (out === void 0) { out = {}; }
	        var size;
	        if (this.mount) {
	            size = getElementSize_1.default(this.mount);
	        }
	        else {
	            console.warn('[haiku dom renderer] mount empty; using fallback size');
	            size = { x: 1, y: 1 };
	        }
	        out.layout = {
	            computed: {
	                size: size,
	            },
	        };
	        if (!this.hasSizing() || !this.config.alwaysComputeSizing) {
	            this.shouldCreateContainer = false;
	        }
	        return out;
	    };
	    HaikuDOMRenderer.prototype.getDocument = function () {
	        return this.mount.ownerDocument;
	    };
	    HaikuDOMRenderer.prototype.getWindow = function () {
	        var doc = this.getDocument();
	        return doc.defaultView || doc.parentWindow;
	    };
	    HaikuDOMRenderer.prototype.initialize = function () {
	        var _this = this;
	        var user = this.user;
	        var setMouse = function (mouseEvent) {
	            // Since the mount itself might be subject to sizing styles that we cannot
	            // use to calculate appropriately, use the top element i.e. the 'artboard'
	            var topElement = _this.mount.childNodes[0];
	            if (topElement) {
	                var pos = getLocalDomEventPosition_1.default(mouseEvent, topElement);
	                user.mouse.x = pos.x;
	                user.mouse.y = pos.y;
	            }
	        };
	        var setTouches = function (touchEvent) {
	            user.touches.splice(0);
	            // Since the mount itself might be subject to sizing styles that we cannot
	            // use to calculate appropriately, use the top element i.e. the 'artboard'
	            var topElement = _this.mount.childNodes[0];
	            if (topElement) {
	                for (var i = 0; i < touchEvent.touches.length; i++) {
	                    var touch = touchEvent.touches[i];
	                    var pos = getLocalDomEventPosition_1.default(touch, topElement);
	                    user.touches.push(pos);
	                }
	            }
	        };
	        var setMouches = function () {
	            user.mouches.splice(0);
	            // Only treat a mouse like a touch if it is down.
	            if (user.mouse.down) {
	                user.mouches.push(user.mouse);
	            }
	            user.mouches.push.apply(user.mouches, user.touches);
	        };
	        var clearKey = function () {
	            for (var which in user.keys) {
	                user.keys[which] = 0;
	            }
	        };
	        var clearMouse = function () {
	            user.mouse.down = 0;
	            user.touches.splice(0);
	            for (var i = 0; i < user.mouse.buttons.length; i++) {
	                user.mouse.buttons[i] = 0;
	            }
	        };
	        var clearMouch = function () {
	            user.mouches.splice(0);
	        };
	        var clearTouch = function () {
	            user.touches.splice(0);
	        };
	        var doc = this.getDocument();
	        var win = this.getWindow();
	        this.mount.addEventListener('mousedown', function (mouseEvent) {
	            ++user.mouse.down;
	            ++user.mouse.buttons[mouseEvent.button];
	            setMouse(mouseEvent);
	            setMouches();
	        });
	        this.mount.addEventListener('mouseup', function (mouseEvent) {
	            clearMouse();
	            clearMouch();
	            setMouches();
	        });
	        var lastMoveTarget;
	        // NOTE: if there are perf or interop issues that arise from
	        //       attaching event listeners directly to host window,
	        //       could expose a haikuOption for reverting to "attach to mount" behavior
	        win.addEventListener('mousemove', function (mouseEvent) {
	            setMouse(mouseEvent);
	            setMouches();
	            if (lastMoveTarget !== mouseEvent.target) {
	                lastMoveTarget = mouseEvent.target;
	                var moveElement = void 0;
	                // If the move has taken us outside of our component, use the mount
	                if (_this.mount.contains(mouseEvent.target)) {
	                    moveElement = _this.getHaikuElementFromTarget(mouseEvent.target);
	                }
	                else {
	                    moveElement = _this.getHaikuElementFromTarget(_this.mount);
	                }
	                if (moveElement) {
	                    moveElement.triggerHover(mouseEvent);
	                }
	            }
	        });
	        win.addEventListener('mouseenter', function (mouseEvent) {
	            clearMouse();
	            clearMouch();
	        });
	        win.addEventListener('mouseleave', function (mouseEvent) {
	            clearMouse();
	            clearMouch();
	        });
	        this.mount.addEventListener('wheel', function (mouseEvent) {
	            setMouse(mouseEvent);
	            setMouches();
	        }, {
	            passive: true,
	        });
	        doc.addEventListener('keydown', function (keyEvent) {
	            if (user.keys[keyEvent.which] === undefined) {
	                user.keys[keyEvent.which] = 0;
	            }
	            ++user.keys[keyEvent.which];
	        });
	        doc.addEventListener('keyup', function (keyEvent) {
	            if (user.keys[keyEvent.which] === undefined) {
	                user.keys[keyEvent.which] = 0;
	            }
	            // Known Mac "feature" where keyup never fires while meta key (91) is down
	            // When right-click menu is toggled we don't get all mouseup events
	            if (keyEvent.which === 91 || keyEvent.which === 17) {
	                clearKey();
	            }
	            user.keys[keyEvent.which] = 0;
	        });
	        // If there's any sizing mode that requires computation of container size
	        // and alwaysComputeSizing is *disabled*, make an "overriding" assumption
	        // that we probably want to recompute the container when media queries change.
	        if (this.hasSizing() && !this.config.alwaysComputeSizing) {
	            win.addEventListener('resize', function () {
	                _this.shouldCreateContainer = true;
	            });
	            win.addEventListener('orientationchange', function () {
	                _this.shouldCreateContainer = true;
	            });
	        }
	        win.addEventListener('blur', function (blurEvent) {
	            clearKey();
	            clearMouse();
	            clearTouch();
	            clearMouch();
	        });
	        win.addEventListener('focus', function (blurEvent) {
	            clearKey();
	            clearMouse();
	            clearTouch();
	            clearMouch();
	        });
	        win.addEventListener('touchstart', function (touchEvent) {
	            setTouches(touchEvent);
	            setMouches();
	        }, {
	            passive: true,
	        });
	        win.addEventListener('touchend', function (touchEvent) {
	            clearTouch();
	            clearMouch();
	        });
	        win.addEventListener('touchmove', function (touchEvent) {
	            setTouches(touchEvent);
	            setMouches();
	        }, {
	            passive: true,
	        });
	        win.addEventListener('touchenter', function (touchEvent) {
	            clearTouch();
	            clearMouch();
	        });
	        win.addEventListener('touchleave', function (touchEvent) {
	            clearTouch();
	            clearMouch();
	        });
	    };
	    HaikuDOMRenderer.prototype.decideMountElement = function (component, selector, name) {
	        // For keyboard events, if subscribed to the component, and if the component is the runtime root,
	        // we automatically attach its handler to window, as this is the 98%-case desired behavior
	        if (name === 'keyup' || name === 'keydown' || name === 'keypress') {
	            if (!component.host && "haiku:" + component.getComponentId() === selector) {
	                var win = this.getWindow();
	                return win;
	            }
	        }
	        // Otherwise, fallthrough and assume we want to listen to our own mount element
	        return this.mount;
	    };
	    HaikuDOMRenderer.prototype.mountEventListener = function (component, selector, name, listener) {
	        var _this = this;
	        var rewritten = name;
	        if (name === 'mouseenter') {
	            rewritten = 'mouseover';
	        }
	        else if (name === 'mouseleave') {
	            rewritten = 'mouseout';
	        }
	        // Convert haiku:* selectors into proper attribute selectors
	        var query = selector;
	        if (selector.slice(0, 6) === 'haiku:') {
	            query = "[haiku-id=\"" + selector.slice(6) + "\"]";
	        }
	        var mount = this.decideMountElement(component, selector, name);
	        // Since elements inside out tree may be added or removed at will, event listener
	        // management (i.e. cleanup and re-registration) becomes a problem. Rather than solve
	        // that tangle, we register listeners on our mount element, which is assumed to
	        // remain through the lifespan of the component, and then delegate the events as
	        // appropriate per their respective specifications.
	        mount.addEventListener(rewritten, function (domEvent) {
	            // If no explicit selector/target for the event, just fire the listener
	            if (!selector || selector === HaikuBase_1.GLOBAL_LISTENER_KEY ||
	                !domEvent || !domEvent.target) {
	                listener(null, _this.wrapEvent(name, domEvent, null, component));
	                return;
	            }
	            // If no queryable node has been rendered, we can't perform a match
	            if (!component.target || !component.target.parentNode) {
	                return;
	            }
	            // If the event originated from the element or its descendants
	            var match = component.target.parentNode.querySelector(query);
	            if (match) {
	                if (_this.shouldListenerReceiveEvent(name, rewritten, domEvent, match, mount)) {
	                    listener(_this.getHaikuElementFromTarget(match), domEvent.target, _this.wrapEvent(name, domEvent, match, component));
	                    return;
	                }
	            }
	        });
	    };
	    HaikuDOMRenderer.prototype.getHaikuElementFromTarget = function (target) {
	        return (target &&
	            target.haiku &&
	            target.haiku.element &&
	            target.haiku.element.__memory &&
	            target.haiku.element.__memory.element);
	    };
	    /**
	     * @description An opportunity to return an event aligned with our own API semantics.
	     * Keep in mind that the three elements involved here may be different:
	     *   this.mount - the host node for the component, the node we actually attach listeners to.
	     *   event.target - the element on which the event actually originated
	     *   elementListenedTo - the element that the user is listening to the event on
	     */
	    HaikuDOMRenderer.prototype.wrapEvent = function (eventName, nativeEvent, elementListenedTo, hostComponent) {
	        return nativeEvent;
	    };
	    HaikuDOMRenderer.prototype.getUser = function () {
	        var zoom = this.getZoom();
	        var pan = this.getPan();
	        return {
	            zoom: zoom,
	            pan: pan,
	            mouse: {
	                x: (this.user.mouse.x) / zoom,
	                y: (this.user.mouse.y) / zoom,
	                z: 0,
	                down: this.user.mouse.down,
	                buttons: this.user.mouse.buttons.slice(),
	            },
	            keys: __assign({}, this.user.keys),
	            touches: this.user.touches.slice(),
	            mouches: this.user.mouches.slice(),
	        };
	    };
	    HaikuDOMRenderer.createTagNode = function (domElement, virtualElement, parentVirtualElement, component) {
	        var tagName = normalizeName_1.default(getTypeAsString_1.default(virtualElement));
	        var compositeId = HaikuComponent_1.getNodeCompositeId(virtualElement);
	        var newDomElement;
	        if (SVG_ELEMENT_NAMES[tagName]) {
	            // SVG
	            newDomElement = createSvgElement_1.default(domElement, tagName);
	        }
	        else {
	            // Normal DOM
	            newDomElement = domElement.ownerDocument.createElement(tagName);
	        }
	        // This didn't happen in renderTree because the element didn't exist yet.
	        if (!newDomElement.haiku) {
	            newDomElement.haiku = {
	                // This is used to detect whether the element's host component has changed.
	                // Don't remove this without understanding the effect on Haiku.app.
	                component: component,
	                explicitStyles: {},
	            };
	        }
	        component.subcacheEnsure(compositeId);
	        var incomingKey = virtualElement.key ||
	            (virtualElement.attributes && virtualElement.attributes.key);
	        if (incomingKey !== undefined && incomingKey !== null) {
	            newDomElement.haiku.key = incomingKey;
	        }
	        // updateElement recurses down into setAttributes, etc.
	        HaikuDOMRenderer.updateElement(newDomElement, virtualElement, domElement, parentVirtualElement, component, null);
	        return newDomElement;
	    };
	    HaikuDOMRenderer.appendChild = function (alreadyChildElement, virtualElement, parentDomElement, parentVirtualElement, component) {
	        var domElementToInsert = isTextNode_1.default(virtualElement)
	            ? createTextNode_1.default(parentDomElement, virtualElement)
	            : HaikuDOMRenderer.createTagNode(parentDomElement, virtualElement, parentVirtualElement, component);
	        applyLayout_1.default(domElementToInsert, virtualElement, component);
	        parentDomElement.appendChild(domElementToInsert);
	        return domElementToInsert;
	    };
	    HaikuDOMRenderer.replaceElement = function (domElement, virtualElement, parentDomNode, parentVirtualElement, component) {
	        var compositeId = HaikuComponent_1.getNodeCompositeId(virtualElement);
	        component.subcacheClear(compositeId);
	        var newElement = isTextNode_1.default(virtualElement)
	            ? createTextNode_1.default(domElement, virtualElement)
	            : HaikuDOMRenderer.createTagNode(domElement, virtualElement, parentVirtualElement, component);
	        applyLayout_1.default(newElement, virtualElement, component);
	        parentDomNode.replaceChild(newElement, domElement);
	        return newElement;
	    };
	    HaikuDOMRenderer.updateElement = function (domElement, virtualElement, parentNode, parentVirtualElement, component, isPatchOperation) {
	        var compositeId = HaikuComponent_1.getNodeCompositeId(virtualElement);
	        // If a text node, go straight to 'replace' since we don't know the tag name
	        if (isTextNode_1.default(virtualElement)) {
	            replaceElementWithText_1.default(domElement, virtualElement, component);
	            return virtualElement;
	        }
	        if (!domElement.haiku) {
	            domElement.haiku = {
	                // This is used to detect whether the element's host component has changed.
	                // Don't remove this without understanding the effect on Haiku.app.
	                component: component,
	                explicitStyles: {},
	            };
	        }
	        component.subcacheEnsure(compositeId);
	        if (!domElement.haiku.element) {
	            // Must clone so we get a correct picture of differences in attributes between runs, e.g. for detecting attribute
	            // removals
	            domElement.haiku.element = HaikuDOMRenderer.cloneVirtualElement(virtualElement);
	        }
	        var domTagName = domElement.tagName.toLowerCase().trim();
	        var elName = normalizeName_1.default(getTypeAsString_1.default(virtualElement));
	        var virtualElementTagName = elName.toLowerCase().trim();
	        var incomingKey = virtualElement.key || (virtualElement.attributes && virtualElement.attributes.key);
	        var existingKey = domElement.haiku && domElement.haiku.key;
	        var isKeyDifferent = incomingKey !== null && incomingKey !== undefined && incomingKey !== existingKey;
	        // For so-called 'horizon' elements, we assume that we've ceded control to another renderer,
	        // so the most we want to do is update the attributes and layout properties, but leave the rest alone
	        if (!component.isHorizonElement(virtualElement)) {
	            if (domTagName !== virtualElementTagName) {
	                return HaikuDOMRenderer.replaceElement(domElement, virtualElement, parentNode, parentVirtualElement, component);
	            }
	            if (isKeyDifferent) {
	                return HaikuDOMRenderer.replaceElement(domElement, virtualElement, parentNode, parentVirtualElement, component);
	            }
	        }
	        if (virtualElement.attributes && typeof virtualElement.attributes === 'object') {
	            assignAttributes_1.default(domElement, virtualElement, component, isPatchOperation);
	        }
	        applyLayout_1.default(domElement, virtualElement, component);
	        if (incomingKey !== undefined && incomingKey !== null) {
	            domElement.haiku.key = incomingKey;
	        }
	        var instance = (virtualElement &&
	            virtualElement.__memory &&
	            virtualElement.__memory.instance) || component;
	        var children = (virtualElement.__memory && virtualElement.__memory.children) || virtualElement.children;
	        if (Array.isArray(children)) {
	            // For performance, we don't render children during a patch operation, except in the case
	            // that we have some text content, which we (hack) need to always assume needs an update.
	            // TODO: Fix this hack and make smarter
	            var doSkipChildren = (isPatchOperation &&
	                children[0] instanceof Object);
	            HaikuDOMRenderer.renderTree(domElement, virtualElement, children, instance, isPatchOperation, doSkipChildren);
	        }
	        else if (!children) {
	            // In case of falsy virtual children, we still need to remove elements that were already there
	            HaikuDOMRenderer.renderTree(domElement, virtualElement, [], instance, isPatchOperation, null);
	        }
	        return domElement;
	    };
	    HaikuDOMRenderer.renderTree = function (domElement, virtualElement, virtualChildren, component, isPatchOperation, doSkipChildren) {
	        connectTarget(virtualElement, domElement);
	        var compositeId = HaikuComponent_1.getNodeCompositeId(virtualElement);
	        if (!domElement.haiku) {
	            domElement.haiku = {
	                // This is used to detect whether the element's host component has changed.
	                // Don't remove this without understanding the effect on Haiku.app.
	                component: component,
	                explicitStyles: {},
	            };
	        }
	        domElement.haiku.virtual = virtualElement;
	        // Must clone so we get a correct picture of differences in attributes
	        // between runs, e.g. for detecting attribute removals
	        domElement.haiku.element = HaikuDOMRenderer.cloneVirtualElement(virtualElement);
	        component.subcacheEnsure(compositeId);
	        if (!Array.isArray(virtualChildren)) {
	            return domElement;
	        }
	        // For so-called 'horizon' elements, we assume that we've ceded control to another renderer,
	        // so the most we want to do is update the attributes and layout properties, but leave the rest alone
	        if (component.isHorizonElement(virtualElement)) {
	            return domElement;
	        }
	        // During patch renders we don't want to drill down and update children as
	        // we're just going to end up doing a lot of unnecessary DOM writes
	        if (doSkipChildren) {
	            return domElement;
	        }
	        while (virtualChildren.length > 0 && isBlankString_1.default(virtualChildren[0])) {
	            virtualChildren.shift();
	        }
	        // Store a copy of the array here, otherwise we can hit a race where as we remove
	        // elements from the DOM, the childNodes array gets shifted and the indices get offset, leading
	        // to removals not occurring properly
	        var domChildNodes = [];
	        for (var k = 0; k < domElement.childNodes.length; k++) {
	            domChildNodes[k] = domElement.childNodes[k];
	        }
	        var max = virtualChildren.length;
	        if (max < domChildNodes.length) {
	            max = domChildNodes.length;
	        }
	        for (var i = 0; i < max; i++) {
	            var virtualChild = virtualChildren[i];
	            var domChild = domChildNodes[i];
	            if (isNil(virtualChild) && !domChild) {
	                // empty
	            }
	            else if (isNil(virtualChild) && domChild) {
	                removeElement_1.default(domChild, compositeId, component);
	            }
	            else {
	                if (!domChild) {
	                    var insertedElement = HaikuDOMRenderer.appendChild(null, virtualChild, domElement, virtualElement, component);
	                    connectTarget(virtualChild, insertedElement);
	                }
	                else {
	                    // Circumstances in which we want to completely *replace* the element:
	                    // - We see that our cached target element is not the one at this location
	                    // - We see that the DOM id doesn't match the incoming one
	                    // - we see that the haiku-id doesn't match the incoming one.
	                    // If we now have an element that is different, we need to trigger a full re-render
	                    // of itself and all of its children, because e.g. url(#...) references will retain pointers to
	                    // old elements and this is the only way to clear the DOM to get a correct render.
	                    var shouldReplace = HaikuDOMRenderer.shouldElementBeReplaced(domChild, virtualChild, component);
	                    if (shouldReplace) {
	                        var newElement = HaikuDOMRenderer.replaceElement(domChild, virtualChild, domElement, virtualElement, component);
	                        connectTarget(virtualChild, newElement);
	                    }
	                    else {
	                        HaikuDOMRenderer.updateElement(domChild, virtualChild, domElement, virtualElement, component, isPatchOperation);
	                        connectTarget(virtualChild, domChild);
	                    }
	                }
	            }
	        }
	        return domElement;
	    };
	    HaikuDOMRenderer.shouldElementBeReplaced = function (domElement, virtualElement, component) {
	        if (domElement.haiku) {
	            var compositeIdNew = HaikuComponent_1.getNodeCompositeId(virtualElement);
	            var compositeIdOld = HaikuComponent_1.getNodeCompositeId(domElement.haiku.element);
	            if (compositeIdNew !== compositeIdOld) {
	                return true;
	            }
	            if (domElement.haiku.component) {
	                // If the element carried at this node has a different host component,
	                // we should do a full replacement, since the cache of the two instances
	                // are different and may result in different (cached) rendering output
	                if (domElement.haiku.component !== component) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    HaikuDOMRenderer.cloneAttributes = function (attributes) {
	        if (!attributes) {
	            return {};
	        }
	        var clone = {};
	        for (var key in attributes) {
	            clone[key] = attributes[key];
	        }
	        return clone;
	    };
	    HaikuDOMRenderer.cloneVirtualElement = function (virtualElement) {
	        return {
	            elementName: virtualElement.elementName,
	            attributes: HaikuDOMRenderer.cloneAttributes(virtualElement.attributes),
	            children: (virtualElement.__memory && virtualElement.__memory.children) || virtualElement.children,
	            __memory: virtualElement.__memory,
	        };
	    };
	    HaikuDOMRenderer.__name__ = 'HaikuDOMRenderer';
	    return HaikuDOMRenderer;
	}(HaikuBase_1.default));
	exports.default = HaikuDOMRenderer;
	var SVG_ELEMENT_NAMES = {
	    a: true,
	    altGlyph: true,
	    altGlyphDef: true,
	    altGlyphItem: true,
	    animate: true,
	    animateColor: true,
	    animateMotion: true,
	    animateTransform: true,
	    circle: true,
	    clipPath: true,
	    'color-profile': true,
	    cursor: true,
	    defs: true,
	    desc: true,
	    discard: true,
	    ellipse: true,
	    feBlend: true,
	    feColorMatrix: true,
	    feComponentTransfer: true,
	    feComposite: true,
	    feConvolveMatrix: true,
	    feDiffuseLighting: true,
	    feDisplacementMap: true,
	    feDistantLight: true,
	    feFlood: true,
	    feFuncA: true,
	    feFuncB: true,
	    feFuncG: true,
	    feFuncR: true,
	    feGaussianBlur: true,
	    feImage: true,
	    feMerge: true,
	    feMergeNode: true,
	    feMorphology: true,
	    feOffset: true,
	    fePointLight: true,
	    feSpecularLighting: true,
	    feSpotLight: true,
	    feTile: true,
	    feTurbulence: true,
	    filter: true,
	    font: true,
	    'font-face': true,
	    'font-face-format': true,
	    'font-face-name': true,
	    'font-face-src': true,
	    'font-face-uri': true,
	    foreignObject: true,
	    g: true,
	    glyph: true,
	    glyphRef: true,
	    hkern: true,
	    image: true,
	    line: true,
	    linearGradient: true,
	    marker: true,
	    mask: true,
	    metadata: true,
	    'missing-glyph': true,
	    mpath: true,
	    path: true,
	    pattern: true,
	    polygon: true,
	    polyline: true,
	    radialGradient: true,
	    rect: true,
	    script: true,
	    set: true,
	    stop: true,
	    style: true,
	    svg: true,
	    switch: true,
	    symbol: true,
	    text: true,
	    textPath: true,
	    title: true,
	    tref: true,
	    tspan: true,
	    use: true,
	    view: true,
	    vkern: true,
	};
	/* tslint:disable */
	var mixpanelSnippetInjector = new Function("\n  (function(e,a){if(!a.__SV){var b=window;try{var c,l,i,j=b.location,g=j.hash;c=function(a,b){return(l=a.match(RegExp(b+\"=([^&]*)\")))?l[1]:null};g&&c(g,\"state\")&&(i=JSON.parse(decodeURIComponent(c(g,\"state\"))),\"mpeditor\"===i.action&&(b.sessionStorage.setItem(\"_mpcehash\",g),history.replaceState(i.desiredHash||\"\",e.title,j.pathname+j.search)))}catch(m){}var k,h;window['mixpanel']=a;a._i=[];a.init=function(b,c,f){function e(b,a){var c=a.split(\".\");2==c.length&&(b=b[c[0]],a=c[1]);b[a]=function(){b.push([a].concat(Array.prototype.slice.call(arguments,\n  0)))}}var d=a;\"undefined\"!==typeof f?d=a[f]=[]:f=\"mixpanel\";d.people=d.people||[];d.toString=function(b){var a=\"mixpanel\";\"mixpanel\"!==f&&(a+=\".\"+f);b||(a+=\" (stub)\");return a};d.people.toString=function(){return d.toString(1)+\".people (stub)\"};k=\"disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user\".split(\" \");\n  for(h=0;h<k.length;h++)e(d,k[h]);a._i.push([b,c,f])};a.__SV=1.2;}})(document,window.mixpanel||[]);\n");
	var mixpanelInit = function (mixpanelToken, component) {
	    // Only initialize Mixpanel if we're running in the browser
	    if (typeof window !== 'undefined') {
	        // Don't initialize multiple times if multiple components are on the page
	        if (!window.mixpanel) {
	            mixpanelSnippetInjector();
	            var head = document.getElementsByTagName('head')[0];
	            var script = document.createElement('script');
	            script.async = true;
	            script.type = 'text/javascript';
	            script.src = 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
	            head.appendChild(script);
	            window.mixpanel.init(mixpanelToken, { ip: false });
	        }
	        var metadata = (component.bytecode && component.bytecode.metadata) || {};
	        window.mixpanel.track('component:initialize', assign_1.default({
	            platform: 'dom',
	        }, metadata));
	    }
	};
	//# sourceMappingURL=HaikuDOMRenderer.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var applyCssLayout_1 = __webpack_require__(54);
	var modernizr_1 = __webpack_require__(186);
	var getWindowsBrowserVersion_1 = __webpack_require__(133);
	var isEdge_1 = __webpack_require__(136);
	var isIE_1 = __webpack_require__(137);
	var isMobile_1 = __webpack_require__(138);
	var isTextNode_1 = __webpack_require__(58);
	var safeWindow = typeof window !== 'undefined' && window;
	var PLATFORM_INFO = {
	    hasWindow: !!safeWindow,
	    isMobile: isMobile_1.default(safeWindow),
	    isIE: isIE_1.default(safeWindow),
	    isEdge: isEdge_1.default(safeWindow),
	    windowsBrowserVersion: getWindowsBrowserVersion_1.default(safeWindow),
	    hasPreserve3d: modernizr_1.default.hasPreserve3d(safeWindow),
	};
	function applyLayout(domElement, virtualElement, component) {
	    if (isTextNode_1.default(virtualElement)) {
	        return domElement;
	    }
	    if (virtualElement.layout) {
	        var computedLayout = virtualElement.layout.computed;
	        // No computed layout means the el is not shown
	        if (!computedLayout) {
	            if (domElement.style.display !== 'none') {
	                domElement.style.display = 'none';
	            }
	        }
	        else {
	            if (domElement.style.display !== 'block') {
	                domElement.style.display = 'block';
	            }
	            component.config.platform = PLATFORM_INFO;
	            applyCssLayout_1.default(domElement, virtualElement, virtualElement.layout, computedLayout, component);
	        }
	    }
	    return domElement;
	}
	exports.default = applyLayout;
	//# sourceMappingURL=applyLayout.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assignClass_1 = __webpack_require__(126);
	var assignStyle_1 = __webpack_require__(127);
	var STYLE = 'style';
	var OBJECT = 'object';
	var CLASS = 'class';
	var CLASS_NAME = 'className';
	var NS = 'http://www.w3.org/1999/xlink';
	var XLINK_HREF = 'xlink:href';
	var setAttribute = function (domElement, virtualElement, key, val) {
	    if (key === XLINK_HREF) {
	        var p0 = domElement.getAttributeNS(NS, key);
	        if (p0 !== val) {
	            domElement.setAttributeNS(NS, key, val);
	        }
	    }
	    else {
	        var p1 = domElement.getAttribute(key);
	        if (p1 !== val) {
	            domElement.setAttribute(key, val);
	        }
	    }
	};
	function assignAttributes(domElement, virtualElement, component, isPatchOperation) {
	    if (!isPatchOperation) {
	        // Remove any attributes from the previous run that aren't present this time around
	        if (domElement.haiku && domElement.haiku.element) {
	            for (var oldKey in domElement.haiku.element.attributes) {
	                var oldValue = domElement.haiku.element.attributes[oldKey];
	                var newValue = virtualElement.attributes[oldKey];
	                if (oldKey !== STYLE) {
	                    // Removal of old styles is handled downstream; see assignStyle()
	                    if (newValue === null || newValue === undefined || oldValue !== newValue) {
	                        domElement.removeAttribute(oldKey);
	                    }
	                }
	            }
	        }
	    }
	    for (var key in virtualElement.attributes) {
	        var anotherNewValue = virtualElement.attributes[key];
	        if (key === STYLE &&
	            anotherNewValue &&
	            typeof anotherNewValue === OBJECT) {
	            if (Object.keys(anotherNewValue).length > 0) {
	                assignStyle_1.default(domElement, anotherNewValue, component, isPatchOperation);
	            }
	            continue;
	        }
	        if ((key === CLASS || key === CLASS_NAME) && anotherNewValue) {
	            assignClass_1.default(domElement, anotherNewValue);
	            continue;
	        }
	        // It's (almost?) never beneficial to write `NaN` to a DOM attribute here;
	        // this is a very hot path, and the result is a deluge of not-catchable errors.
	        if (Number.isNaN(anotherNewValue)) {
	            continue;
	        }
	        setAttribute(domElement, virtualElement, key, anotherNewValue);
	    }
	    return domElement;
	}
	exports.default = assignAttributes;
	//# sourceMappingURL=assignAttributes.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function assignClass(domElement, className) {
	    if (domElement.className !== className) {
	        domElement.setAttribute('class', className);
	    }
	    return domElement;
	}
	exports.default = assignClass;
	//# sourceMappingURL=assignClass.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function assignStyle(domElement, style, component, isPatchOperation) {
	    if (!isPatchOperation) {
	        // If we have an element from a previous run, remove any old styles that aren't part of the new one
	        if (domElement.haiku &&
	            domElement.haiku.element &&
	            domElement.haiku.element.attributes &&
	            domElement.haiku.element.attributes.style) {
	            for (var oldStyleKey in domElement.haiku.element.attributes.style) {
	                var newStyleValue = style[oldStyleKey];
	                if (newStyleValue === null || newStyleValue === undefined) {
	                    domElement.style.removeProperty(oldStyleKey);
	                }
	            }
	        }
	    }
	    for (var key in style) {
	        var newProp = style[key];
	        var previousProp = domElement.haiku.explicitStyles[key];
	        if (previousProp !== newProp) {
	            domElement.haiku.explicitStyles[key] = style[key];
	            domElement.style[key] = style[key];
	        }
	    }
	    return domElement;
	}
	exports.default = assignStyle;
	//# sourceMappingURL=assignStyle.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var MENU_GLOBAL_ID = 'haiku-right-click-menu';
	var WIDTH = 167;
	/* tslint:disable */
	var haikuIcon = '' +
	    '<svg style="transform:translateY(3px);margin-right:3px;" width="13px" height="13px" viewBox="0 0 9 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
	    '    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
	    '        <g id="menu" transform="translate(-9.000000, -50.000000)" fill-rule="nonzero" fill="#899497">' +
	    '            <g id="favicon" transform="translate(9.000000, 50.000000)">' +
	    '                <path d="M5.74649098,4.70558699 L5.74649098,5.7788098 C5.74649098,5.91256161 5.63820821,6.02098888 5.50463465,6.02098888 C5.46594093,6.02098888 5.42936949,6.0118902 5.39693775,5.99571295 C5.39186133,5.99396865 5.38680829,5.99204493 5.38178599,5.98993877 L2.13374851,4.62783436 C2.06585827,4.62681598 2.00074372,4.59703732 1.95556434,4.54557114 C1.89645814,4.50141795 1.85818531,4.43085101 1.85818531,4.35133305 L1.85818531,1.57454768 C1.85079926,1.56515108 1.8440022,1.55516354 1.83787126,1.54461783 L1.68370002,1.48221012 L0.983781643,1.19888682 L0.983781643,7.82711613 L1.85818531,8.18107016 L1.85818531,5.95344076 C1.85818531,5.94997543 1.858258,5.94652709 1.85840193,5.9430972 C1.85672094,5.90820764 1.86258618,5.87240498 1.87695925,5.83803981 C1.92855792,5.7146704 2.07026431,5.65654454 2.19346932,5.70821207 L5.45803735,7.07733924 L5.52116709,7.10578612 C5.64702981,7.11429403 5.74649098,7.21922045 5.74649098,7.34740828 L5.74649098,7.82711613 L6.61247795,8.17766313 L6.62089465,8.18107016 L6.62089465,4.31849373 L5.74649098,4.70558699 Z M5.26277832,4.81941585 L3.49887951,4.07970322 L2.78717926,4.37673832 L5.26277832,5.41491119 L5.26277832,4.81941585 Z M2.34189798,6.29557771 L2.34189798,8.21792436 L3.21630165,7.86397033 L3.21630165,6.66226962 L2.34189798,6.29557771 Z M2.10489107,8.84091277 C2.10327842,8.84094453 2.10166189,8.84096049 2.10004164,8.84096049 C2.03531005,8.84096049 1.97651801,8.81549628 1.93311099,8.77402594 L1.68370002,8.67306569 L0.701593132,8.27551396 C0.587217854,8.25628853 0.500068976,8.15667879 0.500068976,8.03668718 L0.500068976,8.02395302 C0.499977217,8.01997372 0.499976799,8.01598483 0.500068976,8.01198924 L0.500068976,0.83309739 C0.499984517,0.829434725 0.499977444,0.825763881 0.500048734,0.822087163 C0.499977444,0.818410445 0.499984517,0.814739601 0.500068976,0.811076936 L0.500068976,0.808477267 C0.500068976,0.734695385 0.533019284,0.66861973 0.584988773,0.624200019 C0.607223642,0.603893466 0.633376716,0.587129584 0.662911804,0.575173935 L2.00126808,0.0334143141 C2.06884262,-0.00448997495 2.15253254,-0.011953956 2.22949057,0.0203769852 L3.48533098,0.547969766 C3.4886593,0.547833737 3.49200497,0.54776506 3.49536665,0.54776506 C3.62894021,0.54776506 3.73722298,0.656192325 3.73722298,0.789944134 L3.73722298,0.821385651 C3.73731302,0.82532856 3.73731342,0.829280598 3.73722298,0.833238872 L3.73722298,2.40767185 L5.26277832,1.79239207 L5.26277832,0.83309739 C5.26269386,0.829434725 5.26268678,0.825763881 5.26275807,0.822087163 C5.26268678,0.818410445 5.26269386,0.814739601 5.26277832,0.811076936 L5.26277832,0.789944134 C5.26277832,0.660231597 5.36461961,0.55433711 5.49260447,0.548059437 L6.76397742,0.0334143141 C6.83155196,-0.00448997495 6.91524188,-0.011953956 6.99219991,0.0203769852 L8.30051205,0.570013732 C8.41385044,0.590099999 8.49993232,0.689222468 8.49993232,0.808477267 L8.49993232,0.821385589 C8.50002236,0.825328562 8.50002276,0.829280602 8.49993232,0.833238878 L8.49993232,8.03668718 C8.49993232,8.12601922 8.45162927,8.20405443 8.37974945,8.24603352 C8.3570412,8.26726508 8.33012837,8.28475773 8.2996029,8.29711428 L6.99757749,8.82416735 C6.91291064,8.85844005 6.82080599,8.84496071 6.75103698,8.79637735 L6.41724228,8.661259 L5.42562114,8.25985596 C5.34756383,8.22825877 5.29312904,8.1630773 5.27221467,8.08767347 C5.26662904,8.06827265 5.26340051,8.04787145 5.26285962,8.02680084 C5.26269203,8.02187767 5.26266414,8.01693859 5.26277832,8.01198924 L5.26277832,7.52049562 L5.25953529,7.51903428 L5.26277832,7.51181809 L5.26277832,7.52048475 L3.70001431,6.86512047 L3.70001431,8.03470119 C3.70001431,8.04191065 3.69969971,8.04904653 3.6990835,8.05609582 C3.69873979,8.1589341 3.63726868,8.25619133 3.53617314,8.29711428 L2.23486815,8.82387573 C2.19216118,8.84116329 2.14756179,8.84630123 2.10489107,8.84091277 Z M7.10460732,8.21821598 L8.01621965,7.84920008 L8.01621965,1.21243815 L7.10460732,1.58145405 L7.10460732,2.39098426 C7.10460732,2.46741667 7.06924708,2.53557924 7.0140137,2.5799642 C6.98940081,2.61105066 6.95679973,2.63650623 6.91764171,2.65284921 L4.12647169,3.81777145 L5.37396115,4.34092148 L6.74176427,3.73540324 C6.86393122,3.68132067 7.00675126,3.73664611 7.06076176,3.85897608 C7.06205348,3.86190175 7.06328271,3.86483924 7.06445002,3.86778706 C7.08982637,3.90609857 7.10460732,3.95205809 7.10460732,4.00147448 L7.10460732,8.21821598 Z M6.62089465,1.57454768 C6.6135086,1.56515108 6.60671153,1.55516354 6.6005806,1.54461783 L6.44640936,1.48221012 L5.74649098,1.19888682 L5.74649098,1.76114471 L6.62089465,2.11509874 L6.62089465,1.57454768 Z M2.34189798,4.03783399 L3.25351031,3.65736362 L3.25351031,1.21243815 L2.34189798,1.58145405 L2.34189798,4.03783399 Z M3.73722298,2.92984272 L3.73722298,3.45548138 L6.10302085,2.46809239 L5.50003848,2.22400828 C5.49794123,2.22315933 5.49586104,2.22228613 5.49379809,2.22138914 L3.73722298,2.92984272 Z M6.20555471,0.822087163 L6.64164504,0.998614246 L6.89809383,1.10242338 L7.57200867,0.829626174 L6.89232837,0.544084781 L6.20555471,0.822087163 Z M1.44284537,0.822087163 L1.8789357,0.998614246 L2.13538449,1.10242338 L2.80929933,0.829626174 L2.12961903,0.544084781 L1.44284537,0.822087163 Z" id="Combined-Shape"></path>' +
	    '            </g>' +
	    '        </g>' +
	    '    </g>' +
	    '</svg>';
	var sharePageIcon = '' +
	    '<svg style="transform:translate(-1px, 3px);margin-right:1px;" width="14px" height="14px" viewBox="0 0 11 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
	    '  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
	    '      <g id="menu" transform="translate(-8.000000, -32.000000)">' +
	    '          <g id="0884-focus" transform="translate(8.500000, 32.000000)">' +
	    '              <rect id="Rectangle-3" fill="#899497" x="4.72222222" y="0" width="1" height="1.66666667" rx="0.5"></rect>' +
	    '              <rect id="Rectangle-3-Copy" fill="#899497" x="4.72222222" y="8.33333333" width="1" height="1.66666667" rx="0.5"></rect>' +
	    '              <g id="Group" transform="translate(5.000000, 5.555556) rotate(90.000000) translate(-5.000000, -5.555556) translate(3.888889, 0.555556)" fill="#899497">' +
	    '                  <rect id="Rectangle-3-Copy-3" x="0.277777778" y="0" width="1" height="1.66666667" rx="0.5"></rect>' +
	    '                  <rect id="Rectangle-3-Copy-2" x="0.277777778" y="8.33333333" width="1" height="1.66666667" rx="0.5"></rect>' +
	    '              </g>' +
	    '              <circle id="Oval" stroke="#899497" stroke-width="0.66" cx="5" cy="5" r="3.33333333"></circle>' +
	    '              <circle id="Oval-2" fill="#899497" cx="5" cy="5" r="1.11111111"></circle>' +
	    '          </g>' +
	    '      </g>' +
	    '  </g>' +
	    '</svg>';
	var forkIcon = '' +
	    '<svg style="margin-right:5px;transform:translate(1px,3px);" width="11px" height="13px" viewBox="0 0 11 14" xmlns="http://www.w3.org/2000/svg">' +
	    '    <g fill="#899497" fill-rule="evenodd">' +
	    '        <path d="M1.764 2.506c.544 0 .964-.394.964-.853 0-.46-.42-.853-.964-.853S.8 1.194.8 1.653c0 .459.42.853.964.853zm0 .8C.79 3.306 0 2.566 0 1.653S.79 0 1.764 0s1.764.74 1.764 1.653-.79 1.653-1.764 1.653zm7.472-.8c.544 0 .964-.394.964-.853 0-.46-.42-.853-.964-.853s-.964.394-.964.853c0 .459.42.853.964.853zm0 .8c-.974 0-1.764-.74-1.764-1.653S8.262 0 9.236 0 11 .74 11 1.653s-.79 1.653-1.764 1.653zM1.764 13.2c.544 0 .964-.394.964-.853 0-.459-.42-.853-.964-.853s-.964.394-.964.853c0 .46.42.853.964.853zm0 .8C.79 14 0 13.26 0 12.347s.79-1.653 1.764-1.653 1.764.74 1.764 1.653S2.738 14 1.764 14z"/>' +
	    '        <path d="M9.636 3.028h-.8v-.421h.8v1.497c0 2.241-1.525 2.711-5.326 2.711-1.307 0-2.01.707-2.193 2.252l-.795-.094c.229-1.928 1.253-2.958 2.988-2.958 3.34 0 4.526-.365 4.526-1.911V2.61c0-.003 0-.003.8-.004v.422z"/>' +
	    '        <path d="M1.33 3h.8v8h-.8z"/>' +
	    '    </g>' +
	    '</svg>';
	/* tslint:enable */
	// Haiku servers will substitute the _actual_ full string in any js file,
	// so it's split into pieces here to avoid that build step
	var SUBSTITUTION_STRING = 'HAIKU' + '_' + 'SHARE' + '_' + 'UUID';
	function setBoxShadow(el, color) {
	    el.style['-webkit-box-shadow'] = '0 1px 4px 0 ' + color;
	    el.style['-moz-box-shadow'] = '0 1px 4px 0 ' + color;
	    el.style['box-shadow'] = '0 1px 4px 0 ' + color;
	}
	function px(num) {
	    return num + 'px';
	}
	function findOrCreateMenuElement(doc) {
	    var menu = doc.getElementById(MENU_GLOBAL_ID);
	    if (menu) {
	        return menu;
	    }
	    menu = doc.createElement('div');
	    menu.setAttribute('id', MENU_GLOBAL_ID);
	    menu.style.position = 'absolute';
	    menu.style.zIndex = 2147483647;
	    setBoxShadow(menu, 'rgba(10,2,21,0.25)');
	    menu.style.borderRadius = px(3);
	    menu.style.display = 'none';
	    menu.style.backgroundColor = 'rgba(255,255,255,0.95)';
	    menu.style.overflow = 'hidden';
	    menu.style.cursor = 'default';
	    menu.style.fontFamily = 'Helvetica, Arial, sans-serif';
	    menu.style.fontWeight = 'Bold';
	    menu.style.fontSize = px(10);
	    menu.style.padding = '0 0 7px';
	    menu.style.color = 'black';
	    menu.style.margin = '0';
	    menu.style.boxSizing = 'content-box';
	    menu.style.textDecoration = 'none';
	    menu.style.fontStyle = 'none';
	    doc.body.appendChild(menu);
	    return menu;
	}
	function truncate(str, len) {
	    if (str.length > len) {
	        return str.slice(0, len - 3) + '...';
	    }
	    return str;
	}
	function createRightClickMenu(domElement, component) {
	    var doc = domElement.ownerDocument;
	    var menu = findOrCreateMenuElement(doc);
	    var escaper = doc.createElement('textarea');
	    var metadata = component.bytecode && component.bytecode.metadata;
	    var isPublic = false;
	    var isForkable = false;
	    if (metadata && metadata.project && metadata.organization && window && window.fetch) {
	        try {
	            window.fetch("https://inkstone-edge.haiku.ai/v0/community/" + metadata.organization + "/" + metadata.project + "/metadata")
	                .then(function (response) { return response.json(); })
	                .then(function (responseJson) {
	                isPublic = responseJson.IsPublic;
	                isForkable = responseJson.IsForkable;
	            });
	        }
	        catch (e) {
	            // ...noop. We were unable to determine forkability.
	        }
	    }
	    function escapeHTML(html) {
	        escaper.textContent = html;
	        return escaper.innerHTML.replace(/[><,{}[\]"']/gi, '');
	    }
	    // revealMenu(100,100) // Uncomment me to render the menu while testing
	    function revealMenu(mx, my) {
	        var lines = [];
	        var titleLine = null;
	        /* tslint:disable */
	        if (metadata && metadata.project) {
	            var who = truncate(escapeHTML(metadata.project), 25);
	            var org = '';
	            if (metadata.organization) {
	                org = truncate(escapeHTML(metadata.organization), 11);
	                who = '"' + who + '" <span style="font-weight:normal;">by</span> ' + org;
	            }
	            var byline = who;
	            titleLine =
	                '<p style="margin:0;margin-bottom:4px;padding:12px 13px 7px;line-height:12px;text-align:center;border-bottom:1px solid rgba(140,140,140,.14);">' +
	                    byline +
	                    '</p>';
	        }
	        if (isPublic && metadata && metadata.uuid && metadata.uuid !== SUBSTITUTION_STRING) {
	            lines.push('<a onMouseOver="this.style.backgroundColor=\'rgba(140,140,140,.07)\'" onMouseOut="this.style.backgroundColor=\'transparent\'" style="display:block;color:black;text-decoration:none;padding: 5px 13px;line-height:12px;" href="https://share.haiku.ai/' +
	                escapeHTML(metadata.uuid) +
	                '" target="_blank">' +
	                sharePageIcon +
	                ' View on Haiku Community</a>');
	        }
	        if (isForkable) {
	            lines.push('<a onMouseOver="this.style.backgroundColor=\'rgba(140,140,140,.07)\'" onMouseOut="this.style.backgroundColor=\'transparent\'" style="display:block;color:black;text-decoration:none;padding: 5px 13px;line-height:12px;" href="https://share.haiku.ai/u/' +
	                escapeHTML(metadata.organization + "/" + metadata.project + "/fork") +
	                '" target="_blank">' +
	                forkIcon +
	                ' Fork this component</a>');
	        }
	        lines.push('<a onMouseOver="this.style.backgroundColor=\'rgba(140,140,140,.07)\'" onMouseOut="this.style.backgroundColor=\'transparent\'" style="display:block;color:black;text-decoration:none;padding: 5px 13px;line-height:12px;" href="https://www.haikuforteams.com" target="_blank">' +
	            haikuIcon +
	            '  Crafted in Haiku Animator</a>');
	        /* tslint:enable */
	        if (lines.length < 1) {
	            return undefined;
	        }
	        menu.style.width = 'auto';
	        menu.style.minWidth = WIDTH;
	        menu.style.height = 'auto';
	        menu.style.top = px(my);
	        menu.style.left = px(mx);
	        menu.style.pointerEvents = 'auto';
	        menu.style.display = 'block';
	        menu.innerHTML = titleLine ? titleLine + lines.join('\n') : lines.join('\n');
	    }
	    function hideMenu(nativeEvent) {
	        if (nativeEvent.button === 2 || nativeEvent.ctrlKey) {
	            // Firefox treats contextmenu mouseups as clicks for some reason. This short-circuits that behavior.
	            return;
	        }
	        menu.style.width = px(0);
	        menu.style.minWidth = px(0);
	        menu.style.height = px(0);
	        menu.style.top = px(0);
	        menu.style.left = px(0);
	        menu.style.pointerEvents = 'none';
	        menu.style.display = 'none';
	    }
	    domElement.addEventListener('contextmenu', function (contextmenuEvent) {
	        contextmenuEvent.preventDefault();
	        var mx = contextmenuEvent.pageX;
	        var my = contextmenuEvent.pageY;
	        if (component.mixpanel) {
	            component.mixpanel.track('component:contextmenu');
	        }
	        revealMenu(mx, my);
	    });
	    doc.addEventListener('click', hideMenu);
	}
	exports.default = createRightClickMenu;
	//# sourceMappingURL=createRightClickMenu.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
	function createSvgElement(domElement, tagName) {
	    return domElement.ownerDocument.createElementNS(SVG_NAMESPACE, tagName);
	}
	exports.default = createSvgElement;
	//# sourceMappingURL=createSvgElement.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function getElementSize(domElement) {
	    // Get fractional size when on DOM
	    if (domElement.getBoundingClientRect instanceof Function) {
	        var rect = domElement.getBoundingClientRect();
	        return { x: rect.width, y: rect.height };
	    }
	    // Fallback to rounded offsetWidth/offsetHeight
	    if (domElement.offsetWidth !== undefined) {
	        return { x: domElement.offsetWidth, y: domElement.offsetHeight };
	    }
	    return { x: 1, y: 1 };
	}
	exports.default = getElementSize;
	//# sourceMappingURL=getElementSize.js.map

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var getDomEventPosition = function (event, doc) {
	    var x = -1;
	    var y = -1;
	    if (event.hasOwnProperty('pageX')) {
	        x = event.pageX;
	        y = event.pageY;
	    }
	    else if (event.clientX || event.clientY) {
	        x = event.clientX + doc.body.scrollLeft + doc.documentElement.scrollLeft;
	        y = event.clientY + doc.body.scrollTop + doc.documentElement.scrollTop;
	    }
	    return {
	        x: ~~x,
	        y: ~~y,
	    };
	};
	exports.default = (function (event, domElement) {
	    var doc = domElement.ownerDocument;
	    var viewPosition = getDomEventPosition(event, doc);
	    var elementRect = domElement.getBoundingClientRect();
	    var x = viewPosition.x - elementRect.left;
	    var y = viewPosition.y - elementRect.top;
	    if (domElement.offsetWidth !== elementRect.width) {
	        x *= domElement.offsetWidth / elementRect.width;
	    }
	    if (domElement.offsetHeight !== elementRect.height) {
	        y *= domElement.offsetHeight / elementRect.height;
	    }
	    return {
	        x: x,
	        y: y,
	        pageX: viewPosition.x,
	        pageY: viewPosition.y,
	    };
	});
	//# sourceMappingURL=getLocalDomEventPosition.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var STRING = 'string';
	var FUNCTION = 'function';
	var OBJECT = 'object';
	function getType(virtualElement) {
	    var typeValue = virtualElement.elementName;
	    if (typeValue && typeValue.default) {
	        return typeValue.default;
	    }
	    return typeValue;
	}
	function thingToTagName(thing) {
	    if (typeof thing === STRING && thing.length > 0) {
	        return thing;
	    }
	    if (typeof thing === FUNCTION) {
	        return fnToTagName(thing);
	    }
	    if (thing && typeof thing === OBJECT) {
	        return objToTagName(thing);
	    }
	    warnOnce('Got blank/malformed virtual element object; falling back to <div>');
	    return 'div';
	}
	function objToTagName(obj) {
	    // if (obj.name) return obj.name
	    // if (obj.metadata && obj.metadata.name) return obj.metadata.name
	    // _warnOnce('Got blank/malformed virtual element object; falling back to <div>')
	    return 'div';
	}
	function fnToTagName(fn) {
	    if (fn.name) {
	        return fn.name;
	    }
	    if (fn.displayName) {
	        return fn.displayName;
	    }
	    if (fn.constructor) {
	        if (fn.constructor.name !== 'Function') {
	            return fn.constructor.name;
	        }
	    }
	}
	function getTypeAsString(virtualElement) {
	    var typeValue = getType(virtualElement);
	    typeValue = thingToTagName(typeValue);
	    if (!typeValue) {
	        throw new Error('Node has no discernable name');
	    }
	    return typeValue;
	}
	exports.default = getTypeAsString;
	var warnings = {};
	function warnOnce(warning) {
	    if (warnings[warning]) {
	        return void 0;
	    }
	    warnings[warning] = true;
	    console.warn('[haiku core] warning:', warning);
	}
	//# sourceMappingURL=getTypeAsString.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function getWindowsBrowser(window) {
	    var rv = -1;
	    if (!window) {
	        return rv;
	    }
	    if (!window.navigator) {
	        return rv;
	    }
	    if (!window.navigator.userAgent) {
	        return rv;
	    }
	    if (!window.navigator.appName) {
	        return rv;
	    }
	    if (window.navigator.appName === 'Microsoft Internet Explorer') {
	        var ua = window.navigator.userAgent;
	        var re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})');
	        if (re.exec(ua) !== null) {
	            rv = parseFloat(RegExp.$1);
	        }
	    }
	    else if (window.navigator.appName === 'Netscape') {
	        rv = (window.navigator.appVersion.indexOf('Trident') === -1) ? 12 : 11;
	    }
	    return rv;
	}
	exports.default = getWindowsBrowser;
	//# sourceMappingURL=getWindowsBrowserVersion.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuDOMRenderer_1 = __webpack_require__(123);
	exports.default = HaikuDOMRenderer_1.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isBlankString(thing) {
	    return thing === '';
	}
	exports.default = isBlankString;
	//# sourceMappingURL=isBlankString.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isEdge(window) {
	    if (!window) {
	        return false;
	    }
	    if (!window.navigator) {
	        return false;
	    }
	    if (!window.navigator.userAgent) {
	        return false;
	    }
	    return /Edge\/\d./i.test(window.navigator.userAgent);
	}
	exports.default = isEdge;
	//# sourceMappingURL=isEdge.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isIE(window) {
	    if (!window) {
	        return false;
	    }
	    if (!window.navigator) {
	        return false;
	    }
	    if (!window.navigator.userAgent) {
	        return false;
	    }
	    return (window.navigator.userAgent.indexOf('MSIE') !== -1 ||
	        navigator.appVersion.indexOf('Trident') > 0);
	}
	exports.default = isIE;
	//# sourceMappingURL=isIE.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isMobile(window) {
	    if (!window) {
	        return false;
	    }
	    if (!window.navigator) {
	        return false;
	    }
	    if (!window.navigator.userAgent) {
	        return false;
	    }
	    return /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
	}
	exports.default = isMobile;
	//# sourceMappingURL=isMobile.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function normalizeName(tagName) {
	    if (tagName[0] === tagName[0].toUpperCase()) {
	        return tagName + '-component';
	    }
	    return tagName;
	}
	exports.default = normalizeName;
	//# sourceMappingURL=normalizeName.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function removeElement(domElement, compositeId, component) {
	    component.subcacheClear(compositeId);
	    domElement.parentNode.removeChild(domElement);
	    return domElement;
	}
	exports.default = removeElement;
	//# sourceMappingURL=removeElement.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var createTextNode_1 = __webpack_require__(57);
	function replaceElementWithText(domElement, textContent, component) {
	    if (domElement) {
	        if (domElement.textContent !== textContent) {
	            var parentNode = domElement.parentNode;
	            var textNode = createTextNode_1.default(domElement, textContent);
	            parentNode.replaceChild(textNode, domElement);
	        }
	    }
	    return domElement;
	}
	exports.default = replaceElementWithText;
	//# sourceMappingURL=replaceElementWithText.js.map

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2014-2016, Jon Schlinkert
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function uniq(arr) {
	    var len = arr.length;
	    var i = -1;
	    while (i++ < len) {
	        var j = i + 1;
	        for (; j < arr.length; ++j) {
	            if (arr[i] === arr[j]) {
	                arr.splice(j--, 1);
	            }
	        }
	    }
	    return arr;
	}
	function immutable(arr) {
	    var arrayLength = arr.length;
	    var newArray = new Array(arrayLength);
	    for (var i = 0; i < arrayLength; i++) {
	        newArray[i] = arr[i];
	    }
	    return uniq(newArray);
	}
	exports.default = {
	    uniq: uniq,
	    immutable: immutable,
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2015 Dmitry Ivanov
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    aliceblue: [240, 248, 255],
	    antiquewhite: [250, 235, 215],
	    aqua: [0, 255, 255],
	    aquamarine: [127, 255, 212],
	    azure: [240, 255, 255],
	    beige: [245, 245, 220],
	    bisque: [255, 228, 196],
	    black: [0, 0, 0],
	    blanchedalmond: [255, 235, 205],
	    blue: [0, 0, 255],
	    blueviolet: [138, 43, 226],
	    brown: [165, 42, 42],
	    burlywood: [222, 184, 135],
	    cadetblue: [95, 158, 160],
	    chartreuse: [127, 255, 0],
	    chocolate: [210, 105, 30],
	    coral: [255, 127, 80],
	    cornflowerblue: [100, 149, 237],
	    cornsilk: [255, 248, 220],
	    crimson: [220, 20, 60],
	    cyan: [0, 255, 255],
	    darkblue: [0, 0, 139],
	    darkcyan: [0, 139, 139],
	    darkgoldenrod: [184, 134, 11],
	    darkgray: [169, 169, 169],
	    darkgreen: [0, 100, 0],
	    darkgrey: [169, 169, 169],
	    darkkhaki: [189, 183, 107],
	    darkmagenta: [139, 0, 139],
	    darkolivegreen: [85, 107, 47],
	    darkorange: [255, 140, 0],
	    darkorchid: [153, 50, 204],
	    darkred: [139, 0, 0],
	    darksalmon: [233, 150, 122],
	    darkseagreen: [143, 188, 143],
	    darkslateblue: [72, 61, 139],
	    darkslategray: [47, 79, 79],
	    darkslategrey: [47, 79, 79],
	    darkturquoise: [0, 206, 209],
	    darkviolet: [148, 0, 211],
	    deeppink: [255, 20, 147],
	    deepskyblue: [0, 191, 255],
	    dimgray: [105, 105, 105],
	    dimgrey: [105, 105, 105],
	    dodgerblue: [30, 144, 255],
	    firebrick: [178, 34, 34],
	    floralwhite: [255, 250, 240],
	    forestgreen: [34, 139, 34],
	    fuchsia: [255, 0, 255],
	    gainsboro: [220, 220, 220],
	    ghostwhite: [248, 248, 255],
	    gold: [255, 215, 0],
	    goldenrod: [218, 165, 32],
	    gray: [128, 128, 128],
	    green: [0, 128, 0],
	    greenyellow: [173, 255, 47],
	    grey: [128, 128, 128],
	    honeydew: [240, 255, 240],
	    hotpink: [255, 105, 180],
	    indianred: [205, 92, 92],
	    indigo: [75, 0, 130],
	    ivory: [255, 255, 240],
	    khaki: [240, 230, 140],
	    lavender: [230, 230, 250],
	    lavenderblush: [255, 240, 245],
	    lawngreen: [124, 252, 0],
	    lemonchiffon: [255, 250, 205],
	    lightblue: [173, 216, 230],
	    lightcoral: [240, 128, 128],
	    lightcyan: [224, 255, 255],
	    lightgoldenrodyellow: [250, 250, 210],
	    lightgray: [211, 211, 211],
	    lightgreen: [144, 238, 144],
	    lightgrey: [211, 211, 211],
	    lightpink: [255, 182, 193],
	    lightsalmon: [255, 160, 122],
	    lightseagreen: [32, 178, 170],
	    lightskyblue: [135, 206, 250],
	    lightslategray: [119, 136, 153],
	    lightslategrey: [119, 136, 153],
	    lightsteelblue: [176, 196, 222],
	    lightyellow: [255, 255, 224],
	    lime: [0, 255, 0],
	    limegreen: [50, 205, 50],
	    linen: [250, 240, 230],
	    magenta: [255, 0, 255],
	    maroon: [128, 0, 0],
	    mediumaquamarine: [102, 205, 170],
	    mediumblue: [0, 0, 205],
	    mediumorchid: [186, 85, 211],
	    mediumpurple: [147, 112, 219],
	    mediumseagreen: [60, 179, 113],
	    mediumslateblue: [123, 104, 238],
	    mediumspringgreen: [0, 250, 154],
	    mediumturquoise: [72, 209, 204],
	    mediumvioletred: [199, 21, 133],
	    midnightblue: [25, 25, 112],
	    mintcream: [245, 255, 250],
	    mistyrose: [255, 228, 225],
	    moccasin: [255, 228, 181],
	    navajowhite: [255, 222, 173],
	    navy: [0, 0, 128],
	    oldlace: [253, 245, 230],
	    olive: [128, 128, 0],
	    olivedrab: [107, 142, 35],
	    orange: [255, 165, 0],
	    orangered: [255, 69, 0],
	    orchid: [218, 112, 214],
	    palegoldenrod: [238, 232, 170],
	    palegreen: [152, 251, 152],
	    paleturquoise: [175, 238, 238],
	    palevioletred: [219, 112, 147],
	    papayawhip: [255, 239, 213],
	    peachpuff: [255, 218, 185],
	    peru: [205, 133, 63],
	    pink: [255, 192, 203],
	    plum: [221, 160, 221],
	    powderblue: [176, 224, 230],
	    purple: [128, 0, 128],
	    rebeccapurple: [102, 51, 153],
	    red: [255, 0, 0],
	    rosybrown: [188, 143, 143],
	    royalblue: [65, 105, 225],
	    saddlebrown: [139, 69, 19],
	    salmon: [250, 128, 114],
	    sandybrown: [244, 164, 96],
	    seagreen: [46, 139, 87],
	    seashell: [255, 245, 238],
	    sienna: [160, 82, 45],
	    silver: [192, 192, 192],
	    skyblue: [135, 206, 235],
	    slateblue: [106, 90, 205],
	    slategray: [112, 128, 144],
	    slategrey: [112, 128, 144],
	    snow: [255, 250, 250],
	    springgreen: [0, 255, 127],
	    steelblue: [70, 130, 180],
	    tan: [210, 180, 140],
	    teal: [0, 128, 128],
	    thistle: [216, 191, 216],
	    tomato: [255, 99, 71],
	    turquoise: [64, 224, 208],
	    violet: [238, 130, 238],
	    wheat: [245, 222, 179],
	    white: [255, 255, 255],
	    whitesmoke: [245, 245, 245],
	    yellow: [255, 255, 0],
	    yellowgreen: [154, 205, 50],
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2011 Heather Arthur <fayearthur@gmail.com>
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var color_names_1 = __webpack_require__(143);
	var reverseNames = {};
	// create a list of reverse color names
	for (var name_1 in color_names_1.default) {
	    if (color_names_1.default.hasOwnProperty(name_1)) {
	        reverseNames[color_names_1.default[name_1]] = name_1;
	    }
	}
	exports.get = function (string) {
	    var prefix = string.substring(0, 3).toLowerCase();
	    var val;
	    var model;
	    switch (prefix) {
	        case 'hsl':
	            val = getHsl(string);
	            model = 'hsl';
	            break;
	        case 'hwb':
	            val = getHwb(string);
	            model = 'hwb';
	            break;
	        default:
	            val = getRgb(string);
	            model = 'rgb';
	            break;
	    }
	    if (!val) {
	        return null;
	    }
	    return {
	        model: model,
	        value: val,
	    };
	};
	var getRgb = function (string) {
	    if (!string) {
	        return null;
	    }
	    var abbr = /^#([a-f0-9]{3,4})$/i;
	    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
	    var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d.]+)\s*)?\)$/;
	    var per = /^rgba?\(\s*([+-]?[\d.]+)%\s*,\s*([+-]?[\d.]+)%\s*,\s*([+-]?[\d.]+)%\s*(?:,\s*([+-]?[\d.]+)\s*)?\)$/;
	    var keyword = /(\D+)/;
	    var rgb = [0, 0, 0, 1];
	    var match;
	    var i;
	    var hexAlpha;
	    var hexMatch = string.match(hex);
	    var abbrMatch = string.match(abbr);
	    var rgbaMatch = string.match(rgba);
	    var perMatch = string.match(per);
	    var keywordMatch = string.match(keyword);
	    if (hexMatch) {
	        match = hexMatch;
	        hexAlpha = match[2];
	        match = match[1];
	        for (i = 0; i < 3; i++) {
	            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
	            var i2 = i * 2;
	            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
	        }
	        if (hexAlpha) {
	            rgb[3] = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
	        }
	    }
	    else if (abbrMatch) {
	        match = abbrMatch;
	        match = match[1];
	        hexAlpha = match[3];
	        for (i = 0; i < 3; i++) {
	            rgb[i] = parseInt(match[i] + match[i], 16);
	        }
	        if (hexAlpha) {
	            rgb[3] = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
	        }
	    }
	    else if (rgbaMatch) {
	        match = rgbaMatch;
	        for (i = 0; i < 3; i++) {
	            rgb[i] = parseInt(match[i + 1], 0);
	        }
	        if (match[4]) {
	            rgb[3] = parseFloat(match[4]);
	        }
	    }
	    else if (perMatch) {
	        match = perMatch;
	        for (i = 0; i < 3; i++) {
	            rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	        }
	        if (match[4]) {
	            rgb[3] = parseFloat(match[4]);
	        }
	    }
	    else if (keywordMatch) {
	        match = keywordMatch;
	        if (match[1] === 'transparent') {
	            return [0, 0, 0, 0];
	        }
	        rgb = color_names_1.default[match[1]];
	        if (!rgb) {
	            return null;
	        }
	        rgb[3] = 1;
	        return rgb;
	    }
	    else {
	        return null;
	    }
	    for (i = 0; i < 3; i++) {
	        rgb[i] = clamp(rgb[i], 0, 255);
	    }
	    rgb[3] = clamp(rgb[3], 0, 1);
	    return rgb;
	};
	var getHsl = function (string) {
	    if (!string) {
	        return null;
	    }
	    var hsl = /^hsla?\(\s*([+-]?\d*[.]?\d+)(?:deg)?\s*,\s*([+-]?[\d.]+)%\s*,\s*([+-]?[\d.]+)%\s*(?:,\s*([+-]?[\d.]+)\s*)?\)$/;
	    var match = string.match(hsl);
	    if (match) {
	        var alpha = parseFloat(match[4]);
	        var h = (parseFloat(match[1]) % 360 + 360) % 360;
	        var s = clamp(parseFloat(match[2]), 0, 100);
	        var l = clamp(parseFloat(match[3]), 0, 100);
	        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
	        return [h, s, l, a];
	    }
	    return null;
	};
	var getHwb = function (string) {
	    if (!string) {
	        return null;
	    }
	    var hwb = /^hwb\(\s*([+-]?\d*[.]?\d+)(?:deg)?\s*,\s*([+-]?[\d.]+)%\s*,\s*([+-]?[\d.]+)%\s*(?:,\s*([+-]?[\d.]+)\s*)?\)$/;
	    var match = string.match(hwb);
	    if (match) {
	        var alpha = parseFloat(match[4]);
	        var h = (parseFloat(match[1]) % 360 + 360) % 360;
	        var w = clamp(parseFloat(match[2]), 0, 100);
	        var b = clamp(parseFloat(match[3]), 0, 100);
	        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
	        return [h, w, b, a];
	    }
	    return null;
	};
	exports.to = function (model, rgba) {
	    switch (model) {
	        case 'hex':
	            return ('#' +
	                hexDouble(rgba[0]) +
	                hexDouble(rgba[1]) +
	                hexDouble(rgba[2]) +
	                (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : ''));
	        case 'rgb':
	            return rgba.length < 4 || rgba[3] === 1
	                ? 'rgb(' +
	                    Math.round(rgba[0]) +
	                    ', ' +
	                    Math.round(rgba[1]) +
	                    ', ' +
	                    Math.round(rgba[2]) +
	                    ')'
	                : 'rgba(' +
	                    Math.round(rgba[0]) +
	                    ', ' +
	                    Math.round(rgba[1]) +
	                    ', ' +
	                    Math.round(rgba[2]) +
	                    ', ' +
	                    rgba[3] +
	                    ')';
	        case 'hsl':
	            return rgba.length < 4 || rgba[3] === 1
	                ? 'hsl(' + rgba[0] + ', ' + rgba[1] + '%, ' + rgba[2] + '%)'
	                : 'hsla(' +
	                    rgba[0] +
	                    ', ' +
	                    rgba[1] +
	                    '%, ' +
	                    rgba[2] +
	                    '%, ' +
	                    rgba[3] +
	                    ')';
	        case 'hwb':
	            // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	            // (hwb have alpha optional & 1 is default value)
	            var a = '';
	            if (rgba.length >= 4 && rgba[3] !== 1) {
	                a = ', ' + rgba[3];
	            }
	            return 'hwb(' + rgba[0] + ', ' + rgba[1] + '%, ' + rgba[2] + '%' + a + ')';
	    }
	};
	var clamp = function (num, min, max) { return Math.min(Math.max(min, num), max); };
	var hexDouble = function (num) {
	    var str = num.toString(16).toUpperCase();
	    return str.length < 2 ? '0' + str : str;
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Inverts a mat4
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	function invert(out, a) {
	    var a00 = a[0];
	    var a01 = a[1];
	    var a02 = a[2];
	    var a03 = a[3];
	    var a10 = a[4];
	    var a11 = a[5];
	    var a12 = a[6];
	    var a13 = a[7];
	    var a20 = a[8];
	    var a21 = a[9];
	    var a22 = a[10];
	    var a23 = a[11];
	    var a30 = a[12];
	    var a31 = a[13];
	    var a32 = a[14];
	    var a33 = a[15];
	    var b00 = a00 * a11 - a01 * a10;
	    var b01 = a00 * a12 - a02 * a10;
	    var b02 = a00 * a13 - a03 * a10;
	    var b03 = a01 * a12 - a02 * a11;
	    var b04 = a01 * a13 - a03 * a11;
	    var b05 = a02 * a13 - a03 * a12;
	    var b06 = a20 * a31 - a21 * a30;
	    var b07 = a20 * a32 - a22 * a30;
	    var b08 = a20 * a33 - a23 * a30;
	    var b09 = a21 * a32 - a22 * a31;
	    var b10 = a21 * a33 - a23 * a31;
	    var b11 = a22 * a33 - a23 * a32;
	    // Calculate the determinant
	    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	    if (!det) {
	        return null;
	    }
	    det = 1.0 / det;
	    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
	    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
	    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
	    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
	    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
	    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
	    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
	    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
	    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
	    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
	    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
	    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
	    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
	    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
	    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
	    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
	    return out;
	}
	exports.default = invert;
	//# sourceMappingURL=invert.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.ease = internal_1.cubicBezier(.25, .1, .25, .1);
	//# sourceMappingURL=ease.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeIn = internal_1.cubicBezier(.42, 0, 1, 1);
	//# sourceMappingURL=easeIn.js.map

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInBack = function (x) { return internal_1.c3 * x * x * x - internal_1.c1 * x * x; };
	//# sourceMappingURL=easeInBack.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var easeOutBounce_1 = __webpack_require__(32);
	exports.easeInBounce = function (x) { return 1 - easeOutBounce_1.easeOutBounce(1 - x); };
	//# sourceMappingURL=easeInBounce.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInCirc = function (x) { return 1 - internal_1.sqrt(1 - (x * x)); };
	//# sourceMappingURL=easeInCirc.js.map

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeInCubic = function (x) { return x * x * x; };
	//# sourceMappingURL=easeInCubic.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInElastic = function (n) {
	    return !n || n === 1 ? n : -1 * internal_1.sin((n - 1.1) * internal_1.tau * 2.5) * internal_1.pow(2, 10 * (n - 1));
	};
	//# sourceMappingURL=easeInElastic.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInExpo = function (x) { return x === 0 ? 0 : internal_1.pow(2, 10 * x - 10); };
	//# sourceMappingURL=easeInExpo.js.map

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInOut = internal_1.cubicBezier(.42, 0, .58, 1);
	//# sourceMappingURL=easeInOut.js.map

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInOutBack = function (x) { return x < 0.5
	    ? (internal_1.pow(2 * x, 2) * ((internal_1.c2 + 1) * 2 * x - internal_1.c2)) / 2
	    : (internal_1.pow(2 * x - 2, 2) * ((internal_1.c2 + 1) * (x * 2 - 2) + internal_1.c2) + 2) / 2; };
	//# sourceMappingURL=easeInOutBack.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var easeOutBounce_1 = __webpack_require__(32);
	exports.easeInOutBounce = function (x) { return x < 0.5
	    ? (1 - easeOutBounce_1.easeOutBounce(1 - 2 * x)) / 2
	    : (1 + easeOutBounce_1.easeOutBounce(2 * x - 1)) / 2; };
	//# sourceMappingURL=easeInOutBounce.js.map

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInOutCirc = function (x) { return x < 0.5
	    ? (1 - internal_1.sqrt(1 - internal_1.pow(2 * x, 2))) / 2
	    : (internal_1.sqrt(1 - internal_1.pow(-2 * x + 2, 2)) + 1) / 2; };
	//# sourceMappingURL=easeInOutCirc.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInOutCubic = function (x) { return x < 0.5
	    ? 4 * x * x * x
	    : 1 - internal_1.pow(-2 * x + 2, 3) / 2; };
	//# sourceMappingURL=easeInOutCubic.js.map

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInOutElastic = function (n) {
	    if (!n || n === 1) {
	        return n;
	    }
	    n *= 2;
	    if (n < 1) {
	        return -0.5 * (internal_1.pow(2, 10 * (n - 1)) * internal_1.sin((n - 1.1) * internal_1.tau / .4));
	    }
	    return internal_1.pow(2, -10 * (n - 1)) * internal_1.sin((n - 1.1) * internal_1.tau / .4) * .5 + 1;
	};
	//# sourceMappingURL=easeInOutElastic.js.map

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInOutExpo = function (x) { return x === 0
	    ? 0 : x === 1
	    ? 1 : x < 0.5
	    ? internal_1.pow(2, 20 * x - 10) / 2
	    : (2 - internal_1.pow(2, -20 * x + 10)) / 2; };
	//# sourceMappingURL=easeInOutExpo.js.map

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInOutQuad = function (x) { return x < 0.5 ? 2 * x * x : 1 - internal_1.pow(-2 * x + 2, 2) / 2; };
	//# sourceMappingURL=easeInOutQuad.js.map

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInOutQuart = function (x) { return x < 0.5
	    ? 8 * x * x * x * x
	    : 1 - internal_1.pow(-2 * x + 2, 4) / 2; };
	//# sourceMappingURL=easeInOutQuart.js.map

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInOutQuint = function (x) { return x < 0.5
	    ? 16 * x * x * x * x * x
	    : 1 - internal_1.pow(-2 * x + 2, 5) / 2; };
	//# sourceMappingURL=easeInOutQuint.js.map

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInOutSine = function (x) { return -(internal_1.cos(internal_1.pi * x) - 1) / 2; };
	//# sourceMappingURL=easeInOutSine.js.map

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeInQuad = function (x) { return x * x; };
	//# sourceMappingURL=easeInQuad.js.map

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeInQuart = function (x) { return x * x * x * x; };
	//# sourceMappingURL=easeInQuart.js.map

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeInQuint = function (x) { return x * x * x * x * x; };
	//# sourceMappingURL=easeInQuint.js.map

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeInSine = function (x) { return 1 - internal_1.cos(x * internal_1.pi / 2); };
	//# sourceMappingURL=easeInSine.js.map

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeOut = internal_1.cubicBezier(0, 0, .58, 1);
	//# sourceMappingURL=easeOut.js.map

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeOutBack = function (x) { return 1 + internal_1.c3 * internal_1.pow(x - 1, 3) + internal_1.c1 * internal_1.pow(x - 1, 2); };
	//# sourceMappingURL=easeOutBack.js.map

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeOutCirc = function (x) { return internal_1.sqrt(1 - ((x - 1) * (x - 1))); };
	//# sourceMappingURL=easeOutCirc.js.map

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeOutCubic = function (x) { return 1 - internal_1.pow(1 - x, 3); };
	//# sourceMappingURL=easeOutCubic.js.map

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeOutElastic = function (n) {
	    if (!n || n === 1) {
	        return n;
	    }
	    var s, a = 0.1, p = 0.4;
	    if (!a || a < 1) {
	        a = 1;
	        s = p / 4;
	    }
	    else {
	        s = p * Math.asin(1 / a) / internal_1.tau;
	    }
	    return (a * internal_1.pow(2, -10 * n) * internal_1.sin((n - s) * (internal_1.tau) / p) + 1);
	};
	//# sourceMappingURL=easeOutElastic.js.map

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeOutExpo = function (x) { return x === 1 ? 1 : 1 - internal_1.pow(2, -10 * x); };
	//# sourceMappingURL=easeOutExpo.js.map

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeOutQuad = function (x) { return 1 - (1 - x) * (1 - x); };
	//# sourceMappingURL=easeOutQuad.js.map

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeOutQuart = function (x) { return 1 - internal_1.pow(1 - x, 4); };
	//# sourceMappingURL=easeOutQuart.js.map

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeOutQuint = function (x) { return 1 - internal_1.pow(1 - x, 5); };
	//# sourceMappingURL=easeOutQuint.js.map

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.easeOutSine = function (x) { return internal_1.sin(x * internal_1.pi / 2); };
	//# sourceMappingURL=easeOutSine.js.map

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(146));
	__export(__webpack_require__(147));
	__export(__webpack_require__(148));
	__export(__webpack_require__(149));
	__export(__webpack_require__(150));
	__export(__webpack_require__(151));
	__export(__webpack_require__(152));
	__export(__webpack_require__(153));
	__export(__webpack_require__(154));
	__export(__webpack_require__(155));
	__export(__webpack_require__(156));
	__export(__webpack_require__(157));
	__export(__webpack_require__(158));
	__export(__webpack_require__(159));
	__export(__webpack_require__(160));
	__export(__webpack_require__(161));
	__export(__webpack_require__(162));
	__export(__webpack_require__(163));
	__export(__webpack_require__(164));
	__export(__webpack_require__(165));
	__export(__webpack_require__(166));
	__export(__webpack_require__(167));
	__export(__webpack_require__(168));
	__export(__webpack_require__(169));
	__export(__webpack_require__(170));
	__export(__webpack_require__(32));
	__export(__webpack_require__(171));
	__export(__webpack_require__(172));
	__export(__webpack_require__(173));
	__export(__webpack_require__(174));
	__export(__webpack_require__(175));
	__export(__webpack_require__(176));
	__export(__webpack_require__(177));
	__export(__webpack_require__(178));
	__export(__webpack_require__(180));
	__export(__webpack_require__(181));
	__export(__webpack_require__(182));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Animations change at a constant speed
	 */
	exports.linear = function (x) { return x; };
	//# sourceMappingURL=linear.js.map

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.stepEnd = internal_1.steps(1, 0);
	//# sourceMappingURL=stepEnd.js.map

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(2);
	exports.stepStart = internal_1.steps(1, 1);
	//# sourceMappingURL=stepStart.js.map

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var css = __webpack_require__(60);
	exports.css = css;
	var curves = __webpack_require__(179);
	var internal_1 = __webpack_require__(2);
	exports.cubicBezier = internal_1.cubicBezier;
	exports.frames = internal_1.frames;
	exports.steps = internal_1.steps;
	exports.default = curves;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var math_1 = __webpack_require__(33);
	exports.frames = function (n) {
	    var q = 1 / (n - 1);
	    return function (x) {
	        var o = math_1.floor(x * n) * q;
	        return x >= 0 && o < 0 ? 0 : x <= 1 && o > 1 ? 1 : o;
	    };
	};
	//# sourceMappingURL=frames.js.map

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.steps = function (count, pos) {
	    var q = count / 1;
	    var p = pos === 'end'
	        ? 0 : pos === 'start'
	        ? 1 : pos || 0;
	    return function (x) { return x >= 1 ? 1 : (p * q + x) - (p * q + x) % q; };
	};
	//# sourceMappingURL=steps.js.map

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Note: Only the source of
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/css/transformstylepreserve3d.js
	 *
	 * The MIT License
	 *
	 * Copyright (c) 2016 Modernizr
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function hasPreserve3d(window) {
	    if (!window) {
	        return false;
	    }
	    if (!window.document) {
	        return false;
	    }
	    var outerAnchor;
	    var innerAnchor;
	    var CSS = window.CSS;
	    var result = false;
	    var tmp;
	    if (CSS && CSS.supports && CSS.supports('(transform-style: preserve-3d)')) {
	        return true;
	    }
	    outerAnchor = window.document.createElement('a');
	    innerAnchor = window.document.createElement('a');
	    outerAnchor.style.cssText =
	        'display: block; transform-style: preserve-3d; transform-origin: right; transform: rotateY(40deg);';
	    innerAnchor.style.cssText =
	        'display: block; width: 9px; height: 1px; background: #000; transform-origin: right; transform: rotateY(40deg);';
	    outerAnchor.appendChild(innerAnchor);
	    window.document.documentElement.appendChild(outerAnchor);
	    tmp = innerAnchor.getBoundingClientRect();
	    window.document.documentElement.removeChild(outerAnchor);
	    result = tmp.width && tmp.width < 4;
	    return result;
	}
	exports.default = {
	    hasPreserve3d: hasPreserve3d,
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2013 Braveg1rl
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable */
	// Generated by CoffeeScript 1.7.1
	var getNanoSeconds, hrtime, loadTime;
	var invoke;
	if (typeof performance !== 'undefined' &&
	    performance !== null &&
	    performance.now) {
	    invoke = function () {
	        return performance.now();
	    };
	}
	else if (typeof process !== 'undefined' &&
	    process !== null &&
	    process.hrtime) {
	    invoke = function () {
	        return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function () {
	        var hr;
	        hr = hrtime();
	        return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	}
	else if (Date.now) {
	    invoke = function () {
	        return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	}
	else {
	    invoke = function () {
	        return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	}
	function now() {
	    return invoke();
	}
	exports.default = now;
	//# sourceMappingURL=index.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	/* tslint:disable */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2017 Chris Dickinson
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	var performance_now_1 = __webpack_require__(187);
	var root = typeof window === 'undefined' ? global : window;
	var vendors = ['moz', 'webkit'];
	var suffix = 'AnimationFrame';
	var raf;
	var caf;
	if (typeof window !== 'undefined') {
	    raf = window['request' + suffix];
	    caf = window['cancel' + suffix] || window['cancelRequest' + suffix];
	    for (var i = 0; !raf && i < vendors.length; i++) {
	        raf = window[vendors[i] + 'Request' + suffix];
	        caf =
	            window[vendors[i] + 'Cancel' + suffix] ||
	                window[vendors[i] + 'CancelRequest' + suffix];
	    }
	    // Some versions of FF have rAF but not cAF
	    if (!raf || !caf) {
	        var last_1 = 0, id_1 = 0, queue_1 = [], frameDuration_1 = 1000 / 60;
	        raf = function (callback) {
	            if (queue_1.length === 0) {
	                var _now = performance_now_1.default(), next = Math.max(0, frameDuration_1 - (_now - last_1));
	                last_1 = next + _now;
	                setTimeout(function () {
	                    var cp = queue_1.slice(0);
	                    // Clear queue here to prevent
	                    // callbacks from appending listeners
	                    // to the current frame's queue
	                    queue_1.length = 0;
	                    for (var i = 0; i < cp.length; i++) {
	                        if (!cp[i].cancelled) {
	                            try {
	                                cp[i].callback(last_1);
	                            }
	                            catch (e) {
	                                setTimeout(function () {
	                                    throw e;
	                                }, 0);
	                            }
	                        }
	                    }
	                }, Math.round(next));
	            }
	            queue_1.push({
	                handle: ++id_1,
	                callback: callback,
	                cancelled: false,
	            });
	            return id_1;
	        };
	        caf = function (handle) {
	            for (var i = 0; i < queue_1.length; i++) {
	                if (queue_1[i].handle === handle) {
	                    queue_1[i].cancelled = true;
	                }
	            }
	        };
	    }
	}
	else {
	    // Turn raf and caf into noops outside of the web.
	    // This should help with leaked handles/isomorphic rendering.
	    raf = caf = function () { };
	}
	function rafCall(fn) {
	    // Wrap in a new function to prevent
	    // `cancel` potentially being assigned
	    // to the native rAF function
	    return raf.call(root, fn);
	}
	function cafCall() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return caf.apply(root, args);
	}
	exports.default = {
	    request: rafCall,
	    cancel: cafCall,
	};
	//# sourceMappingURL=index.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * https://github.com/Pomax/svg-to-something
	 *
	 * This code is in the public domain, except in jurisdictions that do
	 * not recognise the public domain, where this code is MIT licensed.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Normalise an SVG path to absolute coordinates
	 * and full commands, rather than relative coordinates
	 * and/or shortcut commands.
	 */
	exports.normalizePath = function (d) {
	    // preprocess "d" so that we have spaces between values
	    // tslint:disable-next-line:no-parameter-reassignment
	    d = d.replace(/,/g, ' ') // replace commas with spaces
	        .replace(/-/g, ' - ') // add spacing around minus signs
	        .replace(/-\s+/g, '-') // remove spacing to the right of minus signs.
	        .replace(/([a-zA-Z])/g, ' $1 ');
	    // set up the variables used in this function
	    var instructions = d.replace(/([a-zA-Z])\s?/g, '|$1').split('|');
	    var instructionLength = instructions.length;
	    var i;
	    var instruction;
	    var op;
	    var lop;
	    var args = [];
	    var alen;
	    var a;
	    var sx = 0;
	    var sy = 0;
	    var x = 0;
	    var y = 0;
	    var cx = 0;
	    var cy = 0;
	    var cx2 = 0;
	    var cy2 = 0;
	    var normalized = '';
	    // we run through the instruction list starting at 1, not 0,
	    // because we split up "|M x y ...." so the first element will
	    // always be an empty string. By design.
	    for (i = 1; i < instructionLength; i++) {
	        // which instruction is this?
	        instruction = instructions[i];
	        op = instruction.substring(0, 1);
	        lop = op.toLowerCase();
	        // what are the arguments? note that we need to convert
	        // all strings into numbers, or + will do silly things.
	        args = instruction.replace(op, '').trim().split(' ');
	        args = args.filter(function (v) { return (v !== ''); }).map(parseFloat);
	        alen = args.length;
	        // we could use a switch, but elaborate code in a "case" with
	        // fallthrough is just horrid to read. So let's use ifthen
	        // statements instead.
	        // moveto command (plus possible lineto)
	        if (lop === 'm') {
	            normalized += 'M ';
	            if (op === 'm') {
	                x += args[0];
	                y += args[1];
	            }
	            else {
	                x = args[0];
	                y = args[1];
	            }
	            // records start position, for dealing
	            // with the shape close operator ('Z')
	            sx = x;
	            sy = y;
	            normalized += x + ' ' + y + ' ';
	            if (alen > 2) {
	                for (a = 0; a < alen; a += 2) {
	                    if (op === 'm') {
	                        x += args[a];
	                        y += args[a + 1];
	                    }
	                    else {
	                        x = args[a];
	                        y = args[a + 1];
	                    }
	                    normalized += 'L ' + x + ' ' + y + ' ';
	                }
	            }
	            // lineto commands
	        }
	        else if (lop === 'l') {
	            for (a = 0; a < alen; a += 2) {
	                if (op === 'l') {
	                    x += args[a];
	                    y += args[a + 1];
	                }
	                else {
	                    x = args[a];
	                    y = args[a + 1];
	                }
	                normalized += 'L ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 'h') {
	            for (a = 0; a < alen; a++) {
	                if (op === 'h') {
	                    x += args[a];
	                }
	                else {
	                    x = args[a];
	                }
	                normalized += 'L ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 'v') {
	            for (a = 0; a < alen; a++) {
	                if (op === 'v') {
	                    y += args[a];
	                }
	                else {
	                    y = args[a];
	                }
	                normalized += 'L ' + x + ' ' + y + ' ';
	            }
	            // quadratic curveto commands
	        }
	        else if (lop === 'q') {
	            for (a = 0; a < alen; a += 4) {
	                if (op === 'q') {
	                    cx = x + args[a];
	                    cy = y + args[a + 1];
	                    x += args[a + 2];
	                    y += args[a + 3];
	                }
	                else {
	                    cx = args[a];
	                    cy = args[a + 1];
	                    x = args[a + 2];
	                    y = args[a + 3];
	                }
	                normalized += 'Q ' + cx + ' ' + cy + ' ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 't') {
	            for (a = 0; a < alen; a += 2) {
	                // reflect previous cx/cy over x/y
	                cx = x + (x - cx);
	                cy = y + (y - cy);
	                // then get real end point
	                if (op === 't') {
	                    x += args[a];
	                    y += args[a + 1];
	                }
	                else {
	                    x = args[a];
	                    y = args[a + 1];
	                }
	                normalized += 'Q ' + cx + ' ' + cy + ' ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 'c') {
	            for (a = 0; a < alen; a += 6) {
	                if (op === 'c') {
	                    cx = x + args[a];
	                    cy = y + args[a + 1];
	                    cx2 = x + args[a + 2];
	                    cy2 = y + args[a + 3];
	                    x += args[a + 4];
	                    y += args[a + 5];
	                }
	                else {
	                    cx = args[a];
	                    cy = args[a + 1];
	                    cx2 = args[a + 2];
	                    cy2 = args[a + 3];
	                    x = args[a + 4];
	                    y = args[a + 5];
	                }
	                normalized += 'C ' + cx + ' ' + cy + ' ' + cx2 + ' ' + cy2 + ' ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 's') {
	            for (a = 0; a < alen; a += 4) {
	                // reflect previous cx2/cy2 over x/y
	                cx = x + (x - cx2);
	                cy = y + (y - cy2);
	                // then get real control and end point
	                if (op === 's') {
	                    cx2 = x + args[a];
	                    cy2 = y + args[a + 1];
	                    x += args[a + 2];
	                    y += args[a + 3];
	                }
	                else {
	                    cx2 = args[a];
	                    cy2 = args[a + 1];
	                    x = args[a + 2];
	                    y = args[a + 3];
	                }
	                normalized += 'C ' + cx + ' ' + cy + ' ' + cx2 + ' ' + cy2 + ' ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 'z') {
	            normalized += 'Z ';
	            // not unimportant: path closing changes the current x/y coordinate
	            x = sx;
	            y = sy;
	        }
	    }
	    return normalized.trim();
	};
	/**
	 * Reverse an SVG path.
	 * As long as the input path is normalised, this is actually really
	 * simple to do. As all pathing commands are symmetrical, meaning
	 * that they render the same when you reverse the coordinate order,
	 * the grand trick here is to reverse the path (making sure to keep
	 * coordinates ordered pairwise) and shift the operators left by
	 * one or two coordinate pairs depending on the operator:
	 *
	 *   - Z disappears,
	 *   - M becomes Z,
	 *   - L moves to 2 spots earlier (skipping one coordinate),
	 *   - Q moves to 2 spots earlier (skipping one coordinate),
	 *   - C moves to 4 spots earlier (skipping two coordinates),
	 *   - the path start must become M.
	 */
	exports.reverseNormalizedPath = function (normalized) {
	    var terms = normalized.split(' ');
	    var tlen = terms.length;
	    var tlen1 = tlen - 1;
	    var t;
	    var reversed = [];
	    var x;
	    var y;
	    var pair;
	    var pairs;
	    var shift;
	    var matcher = new RegExp('[MLCQZ]', '');
	    for (t = 0; t < tlen; t++) {
	        var term = terms[t];
	        // Is this an operator? If it is, run through its
	        // argument list, which we know is fixed length.
	        if (matcher.test(term)) {
	            // how many coordinate pairs do we need to read,
	            // and by how many pairs should this operator be
	            // shifted left?
	            if (term === 'C') {
	                pairs = 3;
	                shift = 2;
	            }
	            else if (term === 'Q') {
	                pairs = 2;
	                shift = 1;
	            }
	            else if (term === 'L') {
	                pairs = 1;
	                shift = 1;
	            }
	            else if (term === 'M') {
	                pairs = 1;
	                shift = 0;
	            }
	            else /*if (term === 'Z')*/ {
	                reversed.push('M');
	                continue;
	            }
	            // do the argument reading and operator shifting
	            if (pairs === shift) {
	                reversed.push(term);
	            }
	            for (pair = 0; pair < pairs; pair++) {
	                if (pair === shift) {
	                    reversed.push(term);
	                }
	                x = terms[++t];
	                y = terms[++t];
	                reversed.push(y);
	                reversed.push(x);
	            }
	        }
	        else {
	            var pre = terms.slice(Math.max(t - 3, 0), 3).join(' ');
	            var post = terms.slice(t + 1, Math.min(t + 4, tlen1)).join(' ');
	            var range = pre + ' [' + term + '] ' + post;
	            throw new Error(('Error while trying to reverse normalized SVG path, at position ' + t + ' (' + range + ').\n' +
	                'Either the path is not normalised, or it\'s malformed.'));
	        }
	    }
	    // generating the reversed path string involves
	    // running through our transformed terms in reverse.
	    var revstring = '';
	    var rlen1 = reversed.length - 1;
	    var r;
	    for (r = rlen1; r > 0; r--) {
	        revstring += reversed[r] + ' ';
	    }
	    revstring += 'Z';
	    revstring = revstring.replace(/M M/g, 'Z M');
	    return revstring;
	};
	//# sourceMappingURL=SVGPathReversal.js.map

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 *
	 * Internet Systems Consortium license (ISC)
	 *
	 * Copyright (c) 2016 Colin Meinke
	 *
	 * Permission to use, copy, modify, and/or distribute this software for any purpose
	 * with or without fee is hereby granted, provided that the above copyright notice
	 * and this permission notice appear in all copies.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 * FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT,
	 * OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE,
	 * DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
	 * ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var toPath_1 = __webpack_require__(191);
	var toPoints_1 = __webpack_require__(62);
	exports.default = {
	    toPath: toPath_1.default,
	    toPoints: toPoints_1.default,
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 *
	 * Internet Systems Consortium license (ISC)
	 *
	 * Copyright (c) 2016 Colin Meinke
	 *
	 * Permission to use, copy, modify, and/or distribute this software for any purpose
	 * with or without fee is hereby granted, provided that the above copyright notice
	 * and this permission notice appear in all copies.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 * FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT,
	 * OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE,
	 * DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
	 * ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var toPoints_1 = __webpack_require__(62);
	function pointsToD(p) {
	    var d = '';
	    var i = 0;
	    var firstPoint;
	    for (var _i = 0, p_1 = p; _i < p_1.length; _i++) {
	        var point = p_1[_i];
	        var curve = point.curve, moveTo_1 = point.moveTo, x = point.x, y = point.y;
	        var isFirstPoint = i === 0 || moveTo_1;
	        var isLastPoint = i === p.length - 1 || p[i + 1].moveTo;
	        var prevPoint = i === 0 ? null : p[i - 1];
	        if (isFirstPoint) {
	            firstPoint = point;
	            if (!isLastPoint) {
	                d += "M" + x + "," + y;
	            }
	        }
	        else if (curve) {
	            switch (curve.type) {
	                case 'arc':
	                    var _a = point.curve, _b = _a.largeArcFlag, largeArcFlag = _b === void 0 ? 0 : _b, rx = _a.rx, ry = _a.ry, _c = _a.sweepFlag, sweepFlag = _c === void 0 ? 0 : _c, _d = _a.xAxisRotation, xAxisRotation = _d === void 0 ? 0 : _d;
	                    d += "A" + rx + "," + ry + "," + xAxisRotation + "," + largeArcFlag + "," + sweepFlag + "," + x + "," + y;
	                    break;
	                case 'cubic':
	                    var _e = point.curve, cx1 = _e.x1, cy1 = _e.y1, cx2 = _e.x2, cy2 = _e.y2;
	                    d += "C" + cx1 + "," + cy1 + "," + cx2 + "," + cy2 + "," + x + "," + y;
	                    break;
	                case 'quadratic':
	                    var _f = point.curve, qx1 = _f.x1, qy1 = _f.y1;
	                    d += "Q" + qx1 + "," + qy1 + "," + x + "," + y;
	                    break;
	            }
	            if (isLastPoint && x === firstPoint.x && y === firstPoint.y) {
	                d += 'Z';
	            }
	        }
	        else if (isLastPoint && x === firstPoint.x && y === firstPoint.y) {
	            d += 'Z';
	        }
	        else if (x !== prevPoint.x && y !== prevPoint.y) {
	            d += "L" + x + "," + y;
	        }
	        else if (x !== prevPoint.x) {
	            d += "H" + x;
	        }
	        else if (y !== prevPoint.y) {
	            d += "V" + y;
	        }
	        i++;
	    }
	    return d;
	}
	function toPath(s) {
	    var points = Array.isArray(s) ? s : toPoints_1.default(s);
	    return pointsToD(points);
	}
	exports.default = toPath;
	//# sourceMappingURL=toPath.js.map

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Parallax = __webpack_require__(70);
	
	var _Parallax2 = _interopRequireDefault(_Parallax);
	
	var _propValidation = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var constainerStyle = {
	    position: 'relative',
	    overflow: 'hidden',
	    width: '100%',
	    height: '50vh'
	};
	
	var absoluteStyle = {
	    position: 'absolute',
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	};
	
	var ParallaxBanner = function ParallaxBanner(_ref) {
	    var children = _ref.children,
	        className = _ref.className,
	        layers = _ref.layers,
	        style = _ref.style,
	        disabled = _ref.disabled;
	
	    return _react2.default.createElement(
	        'div',
	        {
	            style: _extends({}, constainerStyle, style),
	            className: 'parallax-banner' + (className ? ' ' + className : '')
	        },
	        layers.map(function (_ref2, i) {
	            var image = _ref2.image,
	                amount = _ref2.amount,
	                slowerScrollRate = _ref2.slowerScrollRate,
	                children = _ref2.children,
	                _ref2$expanded = _ref2.expanded,
	                expanded = _ref2$expanded === undefined ? true : _ref2$expanded;
	
	            // if this is an expanded layer overwrite the top/bottom styles with negative margins
	            var expandedStyle = expanded ? {
	                top: amount * 100 * -1 + '%',
	                bottom: amount * 100 * -1 + '%'
	            } : {};
	
	            return _react2.default.createElement(
	                _Parallax2.default,
	                {
	                    key: 'layer-' + i,
	                    offsetYMax: amount * 100 + '%',
	                    offsetYMin: amount * -1 * 100 + '%',
	                    slowerScrollRate: slowerScrollRate,
	                    styleInner: absoluteStyle,
	                    styleOuter: absoluteStyle,
	                    disabled: disabled
	                },
	                image ? _react2.default.createElement('div', {
	                    className: 'parallax-banner-layer-' + i,
	                    style: _extends({
	                        backgroundImage: 'url(' + image + ')',
	                        backgroundPosition: 'center',
	                        backgroundSize: 'cover'
	                    }, absoluteStyle, expandedStyle)
	                }) : _react2.default.createElement(
	                    'div',
	                    {
	                        className: 'parallax-banner-layer-' + i,
	                        style: _extends({}, absoluteStyle, expandedStyle)
	                    },
	                    children
	                )
	            );
	        }),
	        children
	    );
	};
	
	ParallaxBanner.defaultProps = {
	    disabled: false
	};
	
	ParallaxBanner.propTypes = {
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    disabled: _propTypes2.default.bool.isRequired,
	    layers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        amount: _propTypes2.default.number.isRequired,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	        expanded: _propTypes2.default.bool,
	        image: _propTypes2.default.string,
	        slowerScrollRate: _propTypes2.default.bool
	    })),
	    style: _propTypes2.default.object
	};
	
	exports.default = ParallaxBanner;
	module.exports = exports['default'];

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ParallaxController = __webpack_require__(37);
	
	var _ParallaxController2 = _interopRequireDefault(_ParallaxController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParallaxProvider = function (_Component) {
	    _inherits(ParallaxProvider, _Component);
	
	    function ParallaxProvider() {
	        _classCallCheck(this, ParallaxProvider);
	
	        return _possibleConstructorReturn(this, (ParallaxProvider.__proto__ || Object.getPrototypeOf(ParallaxProvider)).apply(this, arguments));
	    }
	
	    _createClass(ParallaxProvider, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            // Passes down the reference to the controller
	            var parallaxController = this.parallaxController;
	
	            return { parallaxController: parallaxController };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // Don't initialize on the server
	            var isServer = typeof window === 'undefined';
	
	            if (!isServer) {
	                // Must not be the server so kick it off...
	                this.parallaxController = _ParallaxController2.default.init();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.parallaxController = this.parallaxController.destroy();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	
	
	            return children;
	        }
	    }]);
	
	    return ParallaxProvider;
	}(_react.Component);
	
	ParallaxProvider.propTypes = {
	    children: _propTypes2.default.node.isRequired
	};
	ParallaxProvider.childContextTypes = {
	    parallaxController: _propTypes2.default.object
	};
	exports.default = ParallaxProvider;
	module.exports = exports['default'];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ParallaxController = exports.ParallaxBanner = exports.ParallaxProvider = exports.Parallax = undefined;
	
	var _Parallax2 = __webpack_require__(70);
	
	var _Parallax3 = _interopRequireDefault(_Parallax2);
	
	var _ParallaxProvider2 = __webpack_require__(206);
	
	var _ParallaxProvider3 = _interopRequireDefault(_ParallaxProvider2);
	
	var _ParallaxBanner2 = __webpack_require__(205);
	
	var _ParallaxBanner3 = _interopRequireDefault(_ParallaxBanner2);
	
	var _ParallaxController2 = __webpack_require__(37);
	
	var _ParallaxController3 = _interopRequireDefault(_ParallaxController2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Parallax = _Parallax3.default;
	exports.ParallaxProvider = _ParallaxProvider3.default;
	exports.ParallaxBanner = _ParallaxBanner3.default;
	exports.ParallaxController = _ParallaxController3.default;

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = clamp;
	function clamp(number, lower, upper) {
	    number = number <= upper ? number : upper;
	    number = number >= lower ? number : lower;
	    return number;
	}
	module.exports = exports["default"];

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = getParallaxOffsets;
	
	var _index = __webpack_require__(71);
	
	/**
	 * Gets the parallax X and Y offsets to be applied to an element
	 * based upon the percent the element has moved in the viewport
	 * and the min/max offsets
	 * @returns {Object}
	 */
	
	function getParallaxOffsets(offsets, percentMoved, slowerScrollRate) {
	    var yMin = offsets.yMin,
	        yMax = offsets.yMax,
	        xMin = offsets.xMin,
	        xMax = offsets.xMax;
	
	
	    var yUnit = yMax.unit;
	    var xUnit = xMax.unit;
	
	    // sets parallax to faster or slower than the rate of scroll
	    var x = 0;
	    var y = 0;
	
	    if (slowerScrollRate) {
	        x = (0, _index.scaleBetween)(percentMoved, xMin.value, xMax.value, 0, 100);
	        y = (0, _index.scaleBetween)(percentMoved, yMin.value, yMax.value, 0, 100);
	    } else {
	        // flipped max/min
	        x = (0, _index.scaleBetween)(percentMoved, xMax.value, xMin.value, 0, 100);
	        y = (0, _index.scaleBetween)(percentMoved, yMax.value, yMin.value, 0, 100);
	    }
	
	    return {
	        x: {
	            value: x,
	            unit: xUnit
	        },
	        y: {
	            value: y,
	            unit: yUnit
	        }
	    };
	}
	module.exports = exports['default'];

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = isElementInView;
	/**
	 * Takes a parallax element and returns whether the element
	 * is in view based on the cached position of the element,
	 * current scroll position and the window height.
	 * @param {object} element
	 * @return {boolean} isInView
	 */
	function isElementInView(element, windowHeight, scrollY) {
	    var top = element.attributes.top - scrollY;
	    var bottom = element.attributes.bottom - scrollY;
	
	    var topInView = top >= 0 && top <= windowHeight;
	    var bottomInView = bottom >= 0 && bottom <= windowHeight;
	    var covering = top <= 0 && bottom >= windowHeight;
	
	    var isInView = topInView || bottomInView || covering;
	
	    return isInView;
	}
	module.exports = exports["default"];

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = parseValueAndUnit;
	/**
	 * Determines the unit of a string and parses the value
	 *
	 * @param {string} str
	 * @param {object} out
	 * @return {object} The parsed value and the unit if any
	 */
	function parseValueAndUnit(str) {
	    var out = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { value: 0, unit: 'px' };
	
	    var isValid = typeof str === 'number' || typeof str === 'string';
	
	    if (!isValid) {
	        throw new Error('Invalid value provided. Must provide a value as a string or number');
	    }
	
	    str = String(str);
	    out.value = parseFloat(str, 10);
	    out.unit = str.match(/[\d.\-\+]*\s*(.*)/)[1] || '%'; // default to percent
	
	    var validUnits = ['px', '%'];
	    var isValidUnit = validUnits.find(function (unit) {
	        return unit === out.unit;
	    });
	
	    if (!isValidUnit) {
	        throw new Error('Invalid unit provided. Must provide a unit of px in or %');
	    }
	
	    return out;
	}
	module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = scaleBetween;
	// Scale between AKA normalize
	function scaleBetween(value, newMin, newMax, oldMin, oldMax) {
	    return (newMax - newMin) * (value - oldMin) / (oldMax - oldMin) + newMin;
	}
	module.exports = exports["default"];

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = testForPassiveScroll;
	function testForPassiveScroll() {
	    var supportsPassiveOption = false;
	    try {
	        var opts = Object.defineProperty({}, 'passive', {
	            get: function get() {
	                supportsPassiveOption = true;
	            }
	        });
	        window.addEventListener('test', null, opts);
	        window.removeEventListener('test', null, opts);
	    } catch (e) {}
	    return supportsPassiveOption;
	}
	module.exports = exports['default'];

/***/ }),
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(16);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardWithIcon = function (_React$PureComponent) {
	  _inherits(CardWithIcon, _React$PureComponent);
	
	  function CardWithIcon() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CardWithIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
	      play: 'stop'
	    }, _this.animate = function () {
	      _this.setState({ play: 'loop' });
	    }, _this.pause = function () {
	      _this.setState({ play: 'stop' });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CardWithIcon.prototype.render = function render() {
	    var icon = _react2.default.createElement(this.props.icon, { states: { play: { value: this.state.play } } });
	    return _react2.default.createElement(
	      'div',
	      { style: this.props.style, onMouseEnter: this.animate, onMouseLeave: this.pause },
	      _react2.default.createElement(
	        'div',
	        { style: { height: 90 } },
	        icon
	      ),
	      this.props.children
	    );
	  };
	
	  return CardWithIcon;
	}(_react2.default.PureComponent);
	
	exports.default = (0, _radium2.default)(CardWithIcon);
	module.exports = exports['default'];

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, exports) {

	/**
	 * toString ref.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Return the type of `val`.
	 *
	 * @param {Mixed} val
	 * @return {String}
	 * @api public
	 */
	
	module.exports = function(val){
	  switch (toString.call(val)) {
	    case '[object Date]': return 'date';
	    case '[object RegExp]': return 'regexp';
	    case '[object Arguments]': return 'arguments';
	    case '[object Array]': return 'array';
	    case '[object Error]': return 'error';
	  }
	
	  if (val === null) return 'null';
	  if (val === undefined) return 'undefined';
	  if (val !== val) return 'nan';
	  if (val && val.nodeType === 1) return 'element';
	
	  if (isBuffer(val)) return 'buffer';
	
	  val = val.valueOf
	    ? val.valueOf()
	    : Object.prototype.valueOf.apply(val);
	
	  return typeof val;
	};
	
	// code borrowed from https://github.com/feross/is-buffer/blob/master/index.js
	function isBuffer(obj) {
	  return !!(obj != null &&
	    (obj._isBuffer || // For Safari 5-7 (missing Object.prototype.constructor)
	      (obj.constructor &&
	      typeof obj.constructor.isBuffer === 'function' &&
	      obj.constructor.isBuffer(obj))
	    ))
	}


/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ v1.0.9 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var frame = 0, // is an animation frame pending?
	    timeout = 0, // is a timeout pending?
	    interval = 0, // are any timers active?
	    pokeDelay = 1000, // how frequently we check for clock skew
	    taskHead,
	    taskTail,
	    clockLast = 0,
	    clockNow = 0,
	    clockSkew = 0,
	    clock = typeof performance === "object" && performance.now ? performance : Date,
	    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	function timeout$1(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	}
	
	function interval$1(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	}
	
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionId = getTransitionId;
	exports.extend = extend;
	exports.once = once;
	exports.timingDefaults = void 0;
	var transitionId = 0;
	
	function getTransitionId() {
	  return ++transitionId;
	}
	
	function extend(obj, props) {
	  for (var i in props) {
	    obj[i] = props[i];
	  }
	}
	
	function once(func) {
	  var called = false;
	  return function transitionEvent() {
	    if (!called) {
	      called = true;
	      func.call(this);
	    }
	  };
	}
	
	var linear = function linear(t) {
	  return +t;
	};
	
	var timingDefaults = {
	  delay: 0,
	  duration: 250,
	  ease: linear
	};
	exports.timingDefaults = timingDefaults;

/***/ }),
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.numeric = numeric;
	
	function numeric(beg, end) {
	  var a = +beg;
	  var b = +end - a;
	  return function (t) {
	    return a + b * t;
	  };
	}

/***/ }),
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	var _code_deco1_code = __webpack_require__(424);
	var _code_deco3_code = __webpack_require__(426);
	var _code_deco2_code = __webpack_require__(425);
	module.exports = {
	  metadata: {
	    uuid: "31fbcb64-be05-4425-b6ec-e08f320070d1",
	    version: "0.0.1",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon1",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon1",
	    username: "tina@haiku.ai",
	    root: "https://cdn.haiku.ai/92626370-383e-46ea-94da-c5468a70905a/d1295858d2008135a02c5cb2d36e46917468f646/",
	    core: "4.5.0",
	    title: "Circle",
	    type: "haiku",
	    relpath: "code/circle/code.js"
	  },
	  options: {},
	  states: { playIt: { type: "string", value: "stop", edited: true } },
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:86901a49c16e": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Circle-2188d689141ec7f9": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 77.051,
	        "sizeAbsolute.y": 78.31,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:ec7fbc8a8697": {
	        x1: "11.5377345%",
	        y1: "12.6679657%",
	        x2: "81.4801051%",
	        y2: "86.2801745%"
	      },
	      "haiku:6acb031fb4f9": { stopColor: "#EF33F8", offset: "0%" },
	      "haiku:02b9525e5691": { stopColor: "#F75D4A", offset: "100%" },
	      "haiku:f50d0a2467f9": {
	        "sizeAbsolute.y": 62,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 62,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeMode.y": 1,
	        "translation.x": 37.772000000000006,
	        "translation.y": 38.23900000000002,
	        "style.zIndex": 1,
	        "rotation.z": {
	          "0": { value: 6.285, edited: true, curve: "linear" },
	          "2000": { value: 12.566 }
	        }
	      },
	      "haiku:d18faa2e8e8b": {
	        fill: "url(#b43b03491e11)",
	        fillRule: "nonzero",
	        "translation.x": -4
	      },
	      "haiku:0d9f47694e83": {
	        d:
	          "M35.3,61.3 C35.0238576,61.3 34.8,61.0761424 34.8,60.8 C34.8,60.5238576 35.0238576,60.3 35.3,60.3 C36.28867,60.3 37.2713129,60.2513827 38.2455964,60.154817 C38.5203923,60.1275807 38.7652378,60.3282674 38.7924741,60.6030633 C38.8197104,60.8778592 38.6190237,61.1227047 38.3442278,61.149941 C37.3371807,61.2497541 36.3216206,61.3 35.3,61.3 Z M42.3675314,60.4768597 C42.0988487,60.5406112 41.8293576,60.3744817 41.7656062,60.105799 C41.7018547,59.8371164 41.8679843,59.5676253 42.1366669,59.5038738 C43.0956773,59.2763254 44.0407201,59.0009688 44.9689255,58.6790982 C45.2298267,58.5886264 45.5146709,58.7267867 45.6051427,58.9876879 C45.6956145,59.2485892 45.5574542,59.5334333 45.296553,59.6239052 C44.3366319,59.9567738 43.3592953,60.2415397 42.3675314,60.4768597 Z M49.0530041,58.0304871 C48.8066131,58.155171 48.5057974,58.0565079 48.3811135,57.8101169 C48.2564296,57.5637259 48.3550927,57.2629102 48.6014837,57.1382263 C49.4792984,56.6940163 50.3341695,56.2060601 51.1630097,55.6764118 C51.3956996,55.5277175 51.7048726,55.5958094 51.853567,55.8284994 C52.0022613,56.0611893 51.9341694,56.3703623 51.7014795,56.5190567 C50.8445375,57.0666627 49.9606492,57.5711817 49.0530041,58.0304871 Z M54.9984029,54.0865111 C54.7876617,54.2649564 54.4721636,54.2387754 54.2937183,54.0280341 C54.115273,53.8172929 54.141454,53.5017948 54.3521952,53.3233495 C55.1030654,52.6875496 55.8219782,52.014664 56.5060656,51.3074213 C56.6980515,51.108937 57.0145902,51.103669 57.2130745,51.2956549 C57.4115588,51.4876408 57.4168268,51.8041795 57.2248409,52.0026638 C56.5177092,52.7337307 55.7745777,53.4292845 54.9984029,54.0865111 Z M59.8472613,48.9052637 C59.6831757,49.1273685 59.3701065,49.1744023 59.1480017,49.0103167 C58.925897,48.846231 58.8788632,48.5331619 59.0429488,48.3110571 C59.6277051,47.5195365 60.172652,46.69933 60.6755177,45.8535107 C60.8166361,45.6161497 61.1234542,45.5381297 61.3608151,45.6792481 C61.5981761,45.8203665 61.6761961,46.1271846 61.5350777,46.3645456 C61.0151756,47.2390201 60.4517871,48.0869831 59.8472613,48.9052637 Z M63.3978637,42.6841564 C63.2901823,42.9384384 62.996753,43.0572817 62.742471,42.9496003 C62.488189,42.841919 62.3693457,42.5484897 62.4770271,42.2942077 C62.8602874,41.3891655 63.1980955,40.4647045 63.4889481,39.5237959 C63.5705014,39.2599708 63.8504859,39.1122103 64.114311,39.1937637 C64.3781361,39.275317 64.5258965,39.5553015 64.4443432,39.8191265 C64.1435532,40.7921825 63.7942064,41.748221 63.3978637,42.6841564 Z M65.3891571,35.8176786 C65.3440584,36.0901134 65.0866466,36.2744057 64.8142118,36.229307 C64.5417771,36.1842083 64.3574847,35.9267965 64.4025834,35.6543617 C64.5626978,34.6871339 64.674883,33.7093162 64.7383177,32.7234122 C64.7560484,32.4478396 64.9938178,32.2388176 65.2693903,32.2565483 C65.5449629,32.2742791 65.7539849,32.5120484 65.7362542,32.787621 C65.6706814,33.8067557 65.5547013,34.8176501 65.3891571,35.8176786 Z M65.7370653,28.825027 C65.7546826,29.1006068 65.5455627,29.3382901 65.2699828,29.3559074 C64.994403,29.3735247 64.7567198,29.1644047 64.7391025,28.8888249 C64.6760611,27.9026945 64.5642497,26.9246402 64.4044894,25.9571659 C64.3594989,25.6847132 64.5438934,25.4273747 64.8163461,25.3823842 C65.0887988,25.3373937 65.3461373,25.5217883 65.3911278,25.7942409 C65.5563057,26.7945229 65.6718992,27.8056603 65.7370653,28.825027 Z M64.4525349,21.8074169 C64.533846,22.0713167 64.3858286,22.3511655 64.1219288,22.4324766 C63.858029,22.5137877 63.5781802,22.3657703 63.4968691,22.1018704 C63.2068235,21.1605106 62.8697914,20.23557 62.4872742,19.3300203 C62.379821,19.0756418 62.4989276,18.7823193 62.7533061,18.6748661 C63.0076846,18.567413 63.3010071,18.6865195 63.4084603,18.940898 C63.8040349,19.877359 64.1525794,20.8338939 64.4525349,21.8074169 Z M61.572573,15.298695 C61.7131185,15.5363956 61.6343587,15.8430247 61.3966582,15.9835702 C61.1589576,16.1241157 60.8523285,16.0453559 60.711783,15.8076553 C60.2109049,14.9605345 59.6678729,14.1389378 59.0849521,13.3459406 C58.9213981,13.1234441 58.9691805,12.8104883 59.191677,12.6469343 C59.4141736,12.4833803 59.7271293,12.5311627 59.8906833,12.7536593 C60.4933134,13.5734688 61.054724,14.4228718 61.572573,15.298695 Z M57.2820539,9.65664496 C57.4735061,9.85564411 57.4673881,10.1721675 57.268389,10.3636197 C57.0693898,10.5550719 56.7528665,10.5489539 56.5614142,10.3499547 C55.8792777,9.64092875 55.1622263,8.96615961 54.4131224,8.32838176 C54.2028628,8.14936925 54.1775319,7.83380179 54.3565444,7.62354211 C54.5355569,7.41328243 54.8511244,7.3879516 55.0613841,7.56696411 C55.8357321,8.22623452 56.576939,8.92373474 57.2820539,9.65664496 Z M51.7649247,5.12159673 C51.997247,5.27086493 52.0645755,5.58020509 51.9153073,5.81252731 C51.7660391,6.04484953 51.456699,6.11217812 51.2243767,5.96290991 C50.3967066,5.43112764 49.5429003,4.94098504 48.6660466,4.49454507 C48.4199634,4.36925465 48.3220416,4.06819688 48.447332,3.82211372 C48.5726224,3.57603056 48.8736802,3.47810869 49.1197633,3.6033991 C50.0264114,4.06500854 50.9091955,4.57178638 51.7649247,5.12159673 Z M45.3156488,1.98272379 C45.5764896,2.07336985 45.7144597,2.35830621 45.6238136,2.61914698 C45.5331676,2.87998774 45.2482312,3.01795781 44.9873904,2.92731175 C44.0595236,2.60486416 43.1147982,2.32890853 42.1560843,2.10074041 C41.8874451,2.03680591 41.7214992,1.7672017 41.7854337,1.49856256 C41.8493682,1.22992341 42.1189724,1.0639775 42.3876116,1.127912 C43.3790693,1.36387297 44.3560778,1.64925854 45.3156488,1.98272379 Z M38.4703951,0.462827937 C38.7450758,0.491202335 38.9447466,0.736877059 38.9163722,1.01155779 C38.8879978,1.28623852 38.6423231,1.48590926 38.3676423,1.45753486 C37.3932375,1.35687927 36.4103277,1.30422266 35.4212596,1.30024386 C35.1451195,1.29913301 34.9221642,1.07437668 34.923275,0.798236537 C34.9243859,0.522096396 35.1491422,0.299141104 35.4252824,0.300251953 C36.4473417,0.304363465 37.4632016,0.358785291 38.4703951,0.462827937 Z M31.3519687,0.553234316 C31.6258324,0.517832531 31.8765416,0.711144106 31.9119433,0.985007803 C31.9473451,1.2588715 31.7540336,1.50958071 31.4801699,1.54498249 C30.5013388,1.67151393 29.5327596,1.84664107 28.577091,2.0693739 C28.3081562,2.13205316 28.0393299,1.96485002 27.9766506,1.69591524 C27.9139714,1.42698045 28.0811745,1.15815414 28.3501093,1.09547488 C29.3383497,0.865150717 30.3398963,0.684062777 31.3519687,0.553234316 Z M24.4541655,2.28487298 C24.7122504,2.18665484 25.0010911,2.31625245 25.0993092,2.57433734 C25.1975273,2.83242223 25.0679297,3.1212629 24.8098449,3.21948103 C23.889629,3.56968319 22.988301,3.96582827 22.1089041,4.40620412 C21.861991,4.52985088 21.5615929,4.42992374 21.4379461,4.18301062 C21.3142994,3.9360975 21.4142265,3.63569936 21.6611396,3.5120526 C22.57049,3.05667694 23.5025497,2.6470249 24.4541655,2.28487298 Z M18.1151448,5.59866968 C18.3431545,5.44289366 18.6542744,5.50145065 18.8100504,5.72946039 C18.9658264,5.95747013 18.9072694,6.26858997 18.6792597,6.42436599 C17.8666612,6.97953246 17.0821283,7.57503519 16.3286845,8.20841291 C16.1173079,8.38610525 15.8019053,8.35879881 15.6242129,8.14742227 C15.4465206,7.93604573 15.473827,7.62064308 15.6852036,7.44295074 C16.4640672,6.78820401 17.2750868,6.17259644 18.1151448,5.59866968 Z M12.7706168,10.2406048 C12.9568137,10.03668 13.2730698,10.0223086 13.4769946,10.2085054 C13.6809195,10.3947023 13.6952909,10.7109584 13.509094,10.9148833 C12.845669,11.6414736 12.2187402,12.4006507 11.6308798,13.1894454 C11.4658663,13.4108616 11.1526031,13.4565849 10.9311869,13.2915714 C10.7097707,13.1265578 10.6640473,12.8132946 10.8290608,12.5918784 C11.4367595,11.7764646 12.0848297,10.9916864 12.7706168,10.2406048 Z M8.59854831,16.0480828 C8.73230057,15.8064945 9.03657427,15.719076 9.27816265,15.8528283 C9.51975103,15.9865805 9.60716948,16.2908542 9.47341723,16.5324426 C8.99707097,17.3928372 8.5640053,18.2767846 8.17606761,19.181215 C8.06721283,19.4349969 7.77323773,19.5524835 7.51945584,19.4436287 C7.26567394,19.3347739 7.1481873,19.0407988 7.25704208,18.787017 C7.65819825,17.8517693 8.10600547,16.9377323 8.59854831,16.0480828 Z M5.88862462,22.6955121 C5.96183246,22.4292506 6.23702679,22.2727496 6.50328836,22.3459574 C6.76954993,22.4191653 6.92605089,22.6943596 6.85284305,22.9606212 C6.59258501,23.9071962 6.37959949,24.868131 6.21498614,25.8406818 C6.16890192,26.1129517 5.91082498,26.2963113 5.63855515,26.2502271 C5.36628533,26.2041429 5.18292568,25.9460659 5.2290099,25.6737961 C5.39923021,24.6681189 5.61948155,23.6744026 5.88862462,22.6955121 Z M4.82277087,29.6106431 C4.83335463,29.3347036 5.0656276,29.1195903 5.34156708,29.1301741 C5.61750656,29.1407578 5.83261987,29.3730308 5.82203612,29.6489703 C5.80743591,30.0296266 5.80007897,30.4112885 5.80000064,30.7937223 C5.80000001,31.4034053 5.81811037,32.0054013 5.8543255,32.6054175 C5.87096233,32.8810583 5.66099817,33.1179961 5.38535741,33.1346329 C5.10971665,33.1512697 4.87277885,32.9413056 4.85614202,32.6656648 C4.81871479,32.0455664 4.79999999,31.4234786 4.80000065,30.7936194 C4.8000816,30.3983717 4.80768353,30.0040001 4.82277087,29.6106431 Z M5.37148074,36.7059786 C5.31830787,36.435004 5.49487109,36.1722305 5.76584573,36.1190576 C6.03682038,36.0658848 6.29959385,36.242448 6.35276673,36.5134226 C6.5425862,37.480763 6.78055544,38.4355649 7.06549967,39.3750339 C7.14564912,39.6392889 6.99640213,39.9184838 6.73214718,39.9986332 C6.46789224,40.0787827 6.18869731,39.9295357 6.10854786,39.6652808 C5.81386992,38.6937195 5.56777475,37.7063139 5.37148074,36.7059786 Z M7.55266058,43.4799243 C7.43773406,43.2288336 7.54811687,42.9321181 7.79920751,42.8171916 C8.05029814,42.702265 8.34701367,42.8126479 8.46194019,43.0637385 C8.87141383,43.9583535 9.32550362,44.8315573 9.82228394,45.6802706 C9.96177958,45.9185888 9.88166805,46.2248674 9.64334982,46.3643631 C9.4050316,46.5038587 9.09875294,46.4237472 8.9592573,46.185429 C8.44560376,45.307889 7.97607303,44.4049927 7.55266058,43.4799243 Z M11.2815959,49.6001613 C11.1112436,49.3828259 11.149331,49.0685428 11.3666665,48.8981905 C11.584002,48.7278383 11.898285,48.7659257 12.0686373,48.9832611 C12.6755439,49.7575527 13.3207587,50.5013033 14.0016456,51.2115799 C14.19274,51.4109226 14.1860534,51.7274345 13.9867106,51.9185289 C13.7873679,52.1096233 13.470856,52.1029367 13.2797616,51.9035939 C12.5759322,51.1693846 11.9089704,50.4005659 11.2815959,49.6001613 Z M16.2508423,54.6211428 C16.0352847,54.4485463 16.0004579,54.1338853 16.1730543,53.9183277 C16.3456508,53.7027702 16.6603118,53.6679433 16.8758694,53.8405398 C17.643925,54.4555202 18.4421444,55.0318955 19.2674843,55.5672768 C19.4991537,55.7175561 19.5651335,56.0271868 19.4148541,56.2588563 C19.2645748,56.4905257 18.9549442,56.5565055 18.7232747,56.4062261 C17.8700193,55.8527365 17.0448289,55.2568861 16.2508423,54.6211428 Z M22.3234492,58.4096329 C22.0736115,58.2920077 21.966432,57.9941201 22.0840573,57.7442823 C22.2016825,57.4944445 22.4995701,57.3872651 22.7494079,57.5048903 C23.6390392,57.9237345 24.5496438,58.2978528 25.4782021,58.6256128 C25.7385987,58.717527 25.8751808,59.0031313 25.7832666,59.2635279 C25.6913525,59.5239245 25.4057482,59.6605066 25.1453516,59.5685925 C24.1850883,59.2296412 23.2434105,58.8427566 22.3234492,58.4096329 Z M29.1464446,60.6788671 C28.8759218,60.6234412 28.7015513,60.3592076 28.7569773,60.0886848 C28.8124032,59.818162 29.0766368,59.6437915 29.3471596,59.6992175 C30.3080417,59.8960873 31.2808592,60.0451929 32.2630167,60.1456161 C32.5377268,60.1737045 32.7376532,60.4191712 32.7095648,60.6938814 C32.6814763,60.9685915 32.4360096,61.1685179 32.1612995,61.1404294 C31.1458777,61.036605 30.1400201,60.8824354 29.1464446,60.6788671 Z"
	      },
	      "haiku:9aad37dc9f66": {
	        "sizeAbsolute.y": "auto",
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "style.margin": "0",
	        "translation.x": 37.978,
	        "translation.y": 37.987,
	        "origin.x": 0.497,
	        "origin.y": -2.691,
	        "style.zIndex": 3,
	        "rotation.z": {
	          "0": { value: 6.285, edited: true, curve: "linear" },
	          "2000": { value: -0.044 }
	        },
	        playback: {
	          "0": {
	            value: Haiku.inject(function(playIt) {
	              return playIt;
	            }, "playIt"),
	            edited: true
	          }
	        }
	      },
	      "haiku:3921cfb70f51": {
	        "translation.x": 37.576,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "sizeAbsolute.y": "auto",
	        "style.margin": "0",
	        "translation.y": 38.725,
	        "sizeMode.z": 1,
	        "origin.x": -2.196,
	        "origin.y": 2.847,
	        "style.zIndex": 4,
	        playback: {
	          "0": {
	            value: Haiku.inject(function(playIt) {
	              return playIt;
	            }, "playIt"),
	            edited: true
	          }
	        },
	        "rotation.z": {
	          "0": { value: 6.285, edited: true, curve: "linear" },
	          "2000": { value: 0.01, curve: "easeInOutQuad", edited: true },
	          "2017": { value: -0.005 }
	        }
	      },
	      "haiku:d4dce7142d2c": {
	        "sizeAbsolute.y": "auto",
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "style.margin": "0",
	        "translation.x": 37.749,
	        "translation.y": 38.43700000000002,
	        "origin.x": 2.584,
	        "origin.y": 1.858,
	        "style.zIndex": 5,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "2000": { value: 6.284, edited: true }
	        },
	        playback: {
	          "0": {
	            value: Haiku.inject(function(playIt) {
	              return playIt;
	            }, "playIt"),
	            edited: true
	          }
	        }
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Circle-2188d689141ec7f9",
	      "haiku-title": "Circle"
	    },
	    children: [
	      {
	        elementName: _code_deco1_code,
	        attributes: {
	          "haiku-id": "d4dce7142d2c",
	          "haiku-var": "_code_deco1_code",
	          "haiku-title": "Deco1",
	          "haiku-source": "./code/deco1/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: _code_deco3_code,
	        attributes: {
	          "haiku-id": "3921cfb70f51",
	          "haiku-var": "_code_deco3_code",
	          "haiku-title": "Deco3",
	          "haiku-source": "./code/deco3/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: _code_deco2_code,
	        attributes: {
	          "haiku-id": "9aad37dc9f66",
	          "haiku-var": "_code_deco2_code",
	          "haiku-title": "Deco2",
	          "haiku-source": "./code/deco2/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "f50d0a2467f9",
	          "haiku-title": "border",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon1.sketch.contents/slices/border.svg"
	        },
	        children: [
	          {
	            elementName: "defs",
	            attributes: { "haiku-id": "4eeac322a522" },
	            children: [
	              {
	                elementName: "linearGradient",
	                attributes: {
	                  "haiku-id": "ec7fbc8a8697",
	                  "haiku-title": "linearGradient-1-267764",
	                  id: "b43b03491e11"
	                },
	                children: [
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "6acb031fb4f9" },
	                    children: []
	                  },
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "02b9525e5691" },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            elementName: "g",
	            attributes: {
	              "haiku-id": "86901a49c16e",
	              "haiku-title": "Page-1",
	              id: "2c4e89bad6fa"
	            },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "d18faa2e8e8b",
	                  "haiku-title": "VersionControl-icon",
	                  id: "5ee0488e4232"
	                },
	                children: [
	                  {
	                    elementName: "path",
	                    attributes: {
	                      "haiku-id": "0d9f47694e83",
	                      "haiku-title": "border",
	                      id: "16ce7aeb2447"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	module.exports = {
	  metadata: {
	    uuid: "31fbcb64-be05-4425-b6ec-e08f320070d1",
	    version: "0.0.1",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon1",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon1",
	    username: "tina@haiku.ai",
	    root: "https://cdn.haiku.ai/92626370-383e-46ea-94da-c5468a70905a/d1295858d2008135a02c5cb2d36e46917468f646/",
	    core: "4.5.0",
	    title: "Deco1",
	    type: "haiku",
	    relpath: "code/deco1/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Deco1-b2dcea53f1bacc28": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 12.023,
	        "sizeAbsolute.y": 11.058,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:Deco1-93323a590a1d4aec": {
	        "sizeAbsolute.y": 9,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 9,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeMode.y": 1,
	        "translation.x": 6.011500000000001,
	        "translation.y": 5.529,
	        "style.zIndex": 1,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "667": { value: 6.284 }
	        }
	      },
	      "haiku:Page-1-a5006cf507b205ff": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Version-Control-Icon-8ba9777542b560b8": {
	        fill: "#F75D4A",
	        "translation.x": -53,
	        "translation.y": -6
	      },
	      "haiku:Deco1-8252c58147baf7c5": {
	        x: 53.7,
	        y: 6.1,
	        width: 8,
	        height: 8,
	        rx: 2
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Deco1-b2dcea53f1bacc28",
	      "haiku-title": "Deco1"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Deco1-93323a590a1d4aec",
	          "haiku-title": "deco1",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon1.sketch.contents/slices/deco1.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-a5006cf507b205ff", id: "Page-1" },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "Version-Control-Icon-8ba9777542b560b8",
	                  id: "VersionControl-icon"
	                },
	                children: [
	                  {
	                    elementName: "rect",
	                    attributes: {
	                      "haiku-id": "Deco1-8252c58147baf7c5",
	                      id: "deco1"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	module.exports = {
	  metadata: {
	    uuid: "31fbcb64-be05-4425-b6ec-e08f320070d1",
	    version: "0.0.1",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon1",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon1",
	    username: "tina@haiku.ai",
	    root: "https://cdn.haiku.ai/92626370-383e-46ea-94da-c5468a70905a/d1295858d2008135a02c5cb2d36e46917468f646/",
	    core: "4.5.0",
	    title: "Deco2",
	    type: "haiku",
	    relpath: "code/deco2/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Deco2-20cb245cfb651e73": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 9.793,
	        "sizeAbsolute.y": 9.131,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:Deco2-d86fd6656e8c6872": {
	        "sizeAbsolute.y": 8,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 8,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeMode.y": 1,
	        "translation.x": 4.8965000000000005,
	        "translation.y": 4.5655,
	        "style.zIndex": 1,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "667": { value: 6.284 }
	        }
	      },
	      "haiku:Page-1-746d6e09d76475e1": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Version-Control-Icon-b0fc5f92d45a70a8": {
	        fill: "#EF33F8",
	        "translation.x": -1,
	        "translation.y": -28
	      },
	      "haiku:Deco2-5ce41be234881a8e": {
	        x: 1.92784756,
	        y: 29.2277064,
	        width: 5.94212411,
	        height: 5.94212411,
	        rx: 1,
	        "translation.x": -14.996046,
	        "translation.y": 6.41213,
	        "rotation.z": 5.77704
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Deco2-20cb245cfb651e73",
	      "haiku-title": "Deco2"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Deco2-d86fd6656e8c6872",
	          "haiku-title": "deco2",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon1.sketch.contents/slices/deco2.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-746d6e09d76475e1", id: "Page-1" },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "Version-Control-Icon-b0fc5f92d45a70a8",
	                  id: "VersionControl-icon"
	                },
	                children: [
	                  {
	                    elementName: "rect",
	                    attributes: {
	                      "haiku-id": "Deco2-5ce41be234881a8e",
	                      id: "deco2"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	module.exports = {
	  metadata: {
	    uuid: "31fbcb64-be05-4425-b6ec-e08f320070d1",
	    version: "0.0.1",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon1",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon1",
	    username: "tina@haiku.ai",
	    root: "https://cdn.haiku.ai/92626370-383e-46ea-94da-c5468a70905a/d1295858d2008135a02c5cb2d36e46917468f646/",
	    core: "4.5.0",
	    title: "Deco3",
	    type: "haiku",
	    relpath: "code/deco3/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Deco3-0c407b0457d72f75": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 8.663,
	        "sizeAbsolute.y": 8.432,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:c81ff797d81e": {
	        "sizeAbsolute.y": 7,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 7,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeMode.y": 1,
	        "translation.x": 4.3315,
	        "translation.y": 4.215999999999999,
	        "style.zIndex": 3,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "667": { value: 6.284 }
	        }
	      },
	      "haiku:0e3415a4d8f1": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:b69c7fd05e64": {
	        fill: "#FFAC39",
	        "translation.x": -50,
	        "translation.y": -51
	      },
	      "haiku:b71eb2d0a9f9": {
	        x: 50.7289379,
	        y: 51.1678868,
	        width: 5.94212411,
	        height: 5.94212411,
	        rx: 1,
	        "translation.x": 1.922135,
	        "translation.y": -1.841123,
	        "rotation.z": 0.034907
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Deco3-0c407b0457d72f75",
	      "haiku-title": "Deco3"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "c81ff797d81e",
	          "haiku-title": "deco3",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon1.sketch.contents/slices/deco3.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: {
	              "haiku-id": "0e3415a4d8f1",
	              "haiku-title": "Page-1",
	              id: "c008d085398b"
	            },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "b69c7fd05e64",
	                  "haiku-title": "VersionControl-icon",
	                  id: "914059e2709d"
	                },
	                children: [
	                  {
	                    elementName: "rect",
	                    attributes: {
	                      "haiku-id": "b71eb2d0a9f9",
	                      "haiku-title": "deco3",
	                      id: "29aa99b68293"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	var _code_circle_code = __webpack_require__(423);
	module.exports = {
	  metadata: {
	    uuid: "31fbcb64-be05-4425-b6ec-e08f320070d1",
	    version: "0.0.1",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon1",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon1",
	    username: "tina@haiku.ai",
	    root: "https://cdn.haiku.ai/92626370-383e-46ea-94da-c5468a70905a/d1295858d2008135a02c5cb2d36e46917468f646/",
	    core: "4.5.0",
	    title: "Main",
	    type: "haiku",
	    relpath: "code/main/code.js"
	  },
	  options: {},
	  states: { play: { type: "string", value: "stop", edited: true } },
	  eventHandlers: {
	    "haiku:Main-03757d2ca1026e0a": {
	      hover: {
	        handler: function(component, element, target, event) {
	          this.setState({ play: "loop" });
	        }
	      },
	      unhover: {
	        handler: function(component, element, target, event) {
	          this.setState({ play: "stop" });
	        }
	      }
	    }
	  },
	  timelines: {
	    Default: {
	      "haiku:Main-03757d2ca1026e0a": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "hidden",
	        "style.overflowY": "hidden",
	        "sizeAbsolute.x": 81.213,
	        "sizeAbsolute.y": 74.053,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:Icon1-5a530655b76c73dc": {
	        "sizeMode.x": 1,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 30,
	        "style.margin": "0",
	        "sizeAbsolute.y": 38,
	        "sizeMode.y": 1,
	        "translation.x": 40.6065,
	        "translation.y": 37.0265,
	        "style.zIndex": 1
	      },
	      "haiku:Linear-Gradient-1-A44b9b-659a6a0289f90e07": {
	        x1: "25.9791435%",
	        y1: "12.6679657%",
	        x2: "69.6602845%",
	        y2: "86.2801745%"
	      },
	      "haiku:Stop-663045ddff4d9762": { stopColor: "#EF33F8", offset: "0%" },
	      "haiku:Stop-ddc62ab713ff2724": { stopColor: "#F75D4A", offset: "100%" },
	      "haiku:Page-1-aed4846ae4b681b4": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Version-Control-Icon-f0eb42befac85cab": {
	        fill: "url(#linearGradient-1-a44b9b)",
	        fillRule: "nonzero",
	        "translation.x": -22,
	        "translation.y": -10
	      },
	      "haiku:Icon1-4cadfdab3a7275f6": {
	        d:
	          "M47,35.46 L47,31.5333333 C47,29.4382667 45.3175,27.7333333 43.25,27.7333333 L29.5,27.7333333 L29.5,22.54 C32.35,21.9522667 34.5,19.3936 34.5,16.3333333 C34.5,12.8424 31.695,10 28.25,10 C24.805,10 22,12.8424 22,16.3333333 C22,19.3910667 24.15,21.9497333 27,22.54 L27,27.7333333 L27,30.2666667 L27,35.46 C24.15,36.0477333 22,38.6064 22,41.6666667 C22,45.1576 24.805,48 28.25,48 C31.695,48 34.5,45.1576 34.5,41.6666667 C34.5,38.6089333 32.35,36.0502667 29.5,35.46 L29.5,30.2666667 L43.25,30.2666667 C43.94,30.2666667 44.5,30.8341333 44.5,31.5333333 L44.5,35.46 C41.65,36.0477333 39.5,38.6064 39.5,41.6666667 C39.5,45.1576 42.305,48 45.75,48 C49.195,48 52,45.1576 52,41.6666667 C52,38.6089333 49.85,36.0502667 47,35.46 Z M24.5,16.3333333 C24.5,14.2382667 26.1825,12.5333333 28.25,12.5333333 C30.3175,12.5333333 32,14.2382667 32,16.3333333 C32,18.4284 30.3175,20.1333333 28.25,20.1333333 C26.1825,20.1333333 24.5,18.4284 24.5,16.3333333 Z M32,41.6666667 C32,43.7617333 30.3175,45.4666667 28.25,45.4666667 C26.1825,45.4666667 24.5,43.7617333 24.5,41.6666667 C24.5,39.5716 26.1825,37.8666667 28.25,37.8666667 C30.3175,37.8666667 32,39.5716 32,41.6666667 Z M45.75,45.4666667 C43.6825,45.4666667 42,43.7617333 42,41.6666667 C42,39.5716 43.6825,37.8666667 45.75,37.8666667 C47.8175,37.8666667 49.5,39.5716 49.5,41.6666667 C49.5,43.7617333 47.8175,45.4666667 45.75,45.4666667 Z"
	      },
	      "haiku:Circle-1aaa0a3e0d60b12a": {
	        "translation.x": 40.55325,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "sizeAbsolute.y": "auto",
	        "style.margin": "0",
	        "translation.y": 38.26975000000001,
	        "sizeMode.z": 1,
	        "origin.x": 0.5,
	        "origin.y": 0.5,
	        "style.zIndex": 2,
	        playback: {
	          "0": {
	            value: Haiku.inject(function(play) {
	              return play;
	            }, "play"),
	            edited: true
	          }
	        },
	        playIt: {
	          "0": {
	            value: Haiku.inject(function(play) {
	              return play;
	            }, "play"),
	            edited: true
	          }
	        }
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
	    children: [
	      {
	        elementName: _code_circle_code,
	        attributes: {
	          "haiku-id": "Circle-1aaa0a3e0d60b12a",
	          "haiku-var": "_code_circle_code",
	          "haiku-title": "Circle",
	          "haiku-source": "./code/circle/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Icon1-5a530655b76c73dc",
	          "haiku-title": "Icon1",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon1.sketch.contents/slices/Icon1.svg"
	        },
	        children: [
	          {
	            elementName: "defs",
	            attributes: { "haiku-id": "Defs-2302c131ddce6fc2" },
	            children: [
	              {
	                elementName: "linearGradient",
	                attributes: {
	                  "haiku-id": "Linear-Gradient-1-A44b9b-659a6a0289f90e07",
	                  id: "linearGradient-1-a44b9b"
	                },
	                children: [
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-663045ddff4d9762" },
	                    children: []
	                  },
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-ddc62ab713ff2724" },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-aed4846ae4b681b4", id: "Page-1" },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "Version-Control-Icon-f0eb42befac85cab",
	                  id: "VersionControl-icon"
	                },
	                children: [
	                  {
	                    elementName: "path",
	                    attributes: {
	                      "haiku-id": "Icon1-4cadfdab3a7275f6",
	                      id: "Icon1"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	var HaikuDOMAdapter = __webpack_require__(38)
	module.exports = HaikuDOMAdapter(__webpack_require__(427))

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1) // Installed as a peer dependency of '@haiku/core'
	var ReactDOM = __webpack_require__(21) // Installed as a peer dependency of '@haiku/core'
	var HaikuReactAdapter = __webpack_require__(39)
	var HaikuReactComponent = HaikuReactAdapter(__webpack_require__(428))
	if (HaikuReactComponent.default) HaikuReactComponent = HaikuReactComponent.default
	module.exports = HaikuReactComponent

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	// By default, a react-dom module is exported; see code/main/* for other options
	module.exports = __webpack_require__(429)

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	var _code_deco1_code = __webpack_require__(432);
	var _code_deco2_code = __webpack_require__(433);
	var _code_deco3_code = __webpack_require__(434);
	module.exports = {
	  metadata: {
	    username: "tina@haiku.ai",
	    uuid: "67a900ef-ed0f-491d-bee4-d8a023cf6ea0",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon2",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon2",
	    version: "0.0.3",
	    root: "https://cdn.haiku.ai/9fec979d-d44c-4994-b16b-ee78d60c5e95/5f95a2978fb21498c9f76103836200625255c63b/",
	    core: "4.5.0",
	    title: "Circle",
	    type: "haiku",
	    relpath: "code/circle/code.js"
	  },
	  options: {},
	  states: { PlayIt: { type: "string", value: "stop", edited: true } },
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:1451c8c56aee": {
	        "style.margin": "0",
	        "sizeAbsolute.y": 62,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 62,
	        "sizeMode.x": 1,
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "translation.x": 38.097,
	        "translation.y": 41.20750000000002,
	        "style.zIndex": 1,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "2000": { value: 6.283 }
	        }
	      },
	      "haiku:608b0a30c0f7": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:df4f96f88976": {
	        x1: "21.6788863%",
	        y1: "10.7570105%",
	        x2: "50%",
	        y2: "100%"
	      },
	      "haiku:48ab1044e0c8": { stopColor: "#04B6CB", offset: "0%" },
	      "haiku:5d0e95e6bf0b": { stopColor: "#A3CE32", offset: "100%" },
	      "haiku:Circle-2188d689141ec7f9": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 76.669,
	        "sizeAbsolute.y": 81.672,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:62bbe169da2d": {
	        fill: "url(#25b5284f55b7)",
	        fillRule: "nonzero",
	        "translation.x": 1
	      },
	      "haiku:644fccdd1627": {
	        d:
	          "M30.3,61.3 C30.0238576,61.3 29.8,61.0761424 29.8,60.8 C29.8,60.5238576 30.0238576,60.3 30.3,60.3 C31.28867,60.3 32.2713129,60.2513827 33.2455964,60.154817 C33.5203923,60.1275807 33.7652378,60.3282674 33.7924741,60.6030633 C33.8197104,60.8778592 33.6190237,61.1227047 33.3442278,61.149941 C32.3371807,61.2497541 31.3216206,61.3 30.3,61.3 Z M37.3675314,60.4768597 C37.0988487,60.5406112 36.8293576,60.3744817 36.7656062,60.105799 C36.7018547,59.8371164 36.8679843,59.5676253 37.1366669,59.5038738 C38.0956773,59.2763254 39.0407201,59.0009688 39.9689255,58.6790982 C40.2298267,58.5886264 40.5146709,58.7267867 40.6051427,58.9876879 C40.6956145,59.2485892 40.5574542,59.5334333 40.296553,59.6239052 C39.3366319,59.9567738 38.3592953,60.2415397 37.3675314,60.4768597 Z M44.0530041,58.0304871 C43.8066131,58.155171 43.5057974,58.0565079 43.3811135,57.8101169 C43.2564296,57.5637259 43.3550927,57.2629102 43.6014837,57.1382263 C44.4792984,56.6940163 45.3341695,56.2060601 46.1630097,55.6764118 C46.3956996,55.5277175 46.7048726,55.5958094 46.853567,55.8284994 C47.0022613,56.0611893 46.9341694,56.3703623 46.7014795,56.5190567 C45.8445375,57.0666627 44.9606492,57.5711817 44.0530041,58.0304871 Z M49.9984029,54.0865111 C49.7876617,54.2649564 49.4721636,54.2387754 49.2937183,54.0280341 C49.115273,53.8172929 49.141454,53.5017948 49.3521952,53.3233495 C50.1030654,52.6875496 50.8219782,52.014664 51.5060656,51.3074213 C51.6980515,51.108937 52.0145902,51.103669 52.2130745,51.2956549 C52.4115588,51.4876408 52.4168268,51.8041795 52.2248409,52.0026638 C51.5177092,52.7337307 50.7745777,53.4292845 49.9984029,54.0865111 Z M54.8472613,48.9052637 C54.6831757,49.1273685 54.3701065,49.1744023 54.1480017,49.0103167 C53.925897,48.846231 53.8788632,48.5331619 54.0429488,48.3110571 C54.6277051,47.5195365 55.172652,46.69933 55.6755177,45.8535107 C55.8166361,45.6161497 56.1234542,45.5381297 56.3608151,45.6792481 C56.5981761,45.8203665 56.6761961,46.1271846 56.5350777,46.3645456 C56.0151756,47.2390201 55.4517871,48.0869831 54.8472613,48.9052637 Z M58.3978637,42.6841564 C58.2901823,42.9384384 57.996753,43.0572817 57.742471,42.9496003 C57.488189,42.841919 57.3693457,42.5484897 57.4770271,42.2942077 C57.8602874,41.3891655 58.1980955,40.4647045 58.4889481,39.5237959 C58.5705014,39.2599708 58.8504859,39.1122103 59.114311,39.1937637 C59.3781361,39.275317 59.5258965,39.5553015 59.4443432,39.8191265 C59.1435532,40.7921825 58.7942064,41.748221 58.3978637,42.6841564 Z M60.3891571,35.8176786 C60.3440584,36.0901134 60.0866466,36.2744057 59.8142118,36.229307 C59.5417771,36.1842083 59.3574847,35.9267965 59.4025834,35.6543617 C59.5626978,34.6871339 59.674883,33.7093162 59.7383177,32.7234122 C59.7560484,32.4478396 59.9938178,32.2388176 60.2693903,32.2565483 C60.5449629,32.2742791 60.7539849,32.5120484 60.7362542,32.787621 C60.6706814,33.8067557 60.5547013,34.8176501 60.3891571,35.8176786 Z M60.7370653,28.825027 C60.7546826,29.1006068 60.5455627,29.3382901 60.2699828,29.3559074 C59.994403,29.3735247 59.7567198,29.1644047 59.7391025,28.8888249 C59.6760611,27.9026945 59.5642497,26.9246402 59.4044894,25.9571659 C59.3594989,25.6847132 59.5438934,25.4273747 59.8163461,25.3823842 C60.0887988,25.3373937 60.3461373,25.5217883 60.3911278,25.7942409 C60.5563057,26.7945229 60.6718992,27.8056603 60.7370653,28.825027 Z M59.4525349,21.8074169 C59.533846,22.0713167 59.3858286,22.3511655 59.1219288,22.4324766 C58.858029,22.5137877 58.5781802,22.3657703 58.4968691,22.1018704 C58.2068235,21.1605106 57.8697914,20.23557 57.4872742,19.3300203 C57.379821,19.0756418 57.4989276,18.7823193 57.7533061,18.6748661 C58.0076846,18.567413 58.3010071,18.6865195 58.4084603,18.940898 C58.8040349,19.877359 59.1525794,20.8338939 59.4525349,21.8074169 Z M56.572573,15.298695 C56.7131185,15.5363956 56.6343587,15.8430247 56.3966582,15.9835702 C56.1589576,16.1241157 55.8523285,16.0453559 55.711783,15.8076553 C55.2109049,14.9605345 54.6678729,14.1389378 54.0849521,13.3459406 C53.9213981,13.1234441 53.9691805,12.8104883 54.191677,12.6469343 C54.4141736,12.4833803 54.7271293,12.5311627 54.8906833,12.7536593 C55.4933134,13.5734688 56.054724,14.4228718 56.572573,15.298695 Z M52.2820539,9.65664496 C52.4735061,9.85564411 52.4673881,10.1721675 52.268389,10.3636197 C52.0693898,10.5550719 51.7528665,10.5489539 51.5614142,10.3499547 C50.8792777,9.64092875 50.1622263,8.96615961 49.4131224,8.32838176 C49.2028628,8.14936925 49.1775319,7.83380179 49.3565444,7.62354211 C49.5355569,7.41328243 49.8511244,7.3879516 50.0613841,7.56696411 C50.8357321,8.22623452 51.576939,8.92373474 52.2820539,9.65664496 Z M46.7649247,5.12159673 C46.997247,5.27086493 47.0645755,5.58020509 46.9153073,5.81252731 C46.7660391,6.04484953 46.456699,6.11217812 46.2243767,5.96290991 C45.3967066,5.43112764 44.5429003,4.94098504 43.6660466,4.49454507 C43.4199634,4.36925465 43.3220416,4.06819688 43.447332,3.82211372 C43.5726224,3.57603056 43.8736802,3.47810869 44.1197633,3.6033991 C45.0264114,4.06500854 45.9091955,4.57178638 46.7649247,5.12159673 Z M40.3156488,1.98272379 C40.5764896,2.07336985 40.7144597,2.35830621 40.6238136,2.61914698 C40.5331676,2.87998774 40.2482312,3.01795781 39.9873904,2.92731175 C39.0595236,2.60486416 38.1147982,2.32890853 37.1560843,2.10074041 C36.8874451,2.03680591 36.7214992,1.7672017 36.7854337,1.49856256 C36.8493682,1.22992341 37.1189724,1.0639775 37.3876116,1.127912 C38.3790693,1.36387297 39.3560778,1.64925854 40.3156488,1.98272379 Z M33.4703951,0.462827937 C33.7450758,0.491202335 33.9447466,0.736877059 33.9163722,1.01155779 C33.8879978,1.28623852 33.6423231,1.48590926 33.3676423,1.45753486 C32.3932375,1.35687927 31.4103277,1.30422266 30.4212596,1.30024386 C30.1451195,1.29913301 29.9221642,1.07437668 29.923275,0.798236537 C29.9243859,0.522096396 30.1491422,0.299141104 30.4252824,0.300251953 C31.4473417,0.304363465 32.4632016,0.358785291 33.4703951,0.462827937 Z M26.3519687,0.553234316 C26.6258324,0.517832531 26.8765416,0.711144106 26.9119433,0.985007803 C26.9473451,1.2588715 26.7540336,1.50958071 26.4801699,1.54498249 C25.5013388,1.67151393 24.5327596,1.84664107 23.577091,2.0693739 C23.3081562,2.13205316 23.0393299,1.96485002 22.9766506,1.69591524 C22.9139714,1.42698045 23.0811745,1.15815414 23.3501093,1.09547488 C24.3383497,0.865150717 25.3398963,0.684062777 26.3519687,0.553234316 Z M19.4541655,2.28487298 C19.7122504,2.18665484 20.0010911,2.31625245 20.0993092,2.57433734 C20.1975273,2.83242223 20.0679297,3.1212629 19.8098449,3.21948103 C18.889629,3.56968319 17.988301,3.96582827 17.1089041,4.40620412 C16.861991,4.52985088 16.5615929,4.42992374 16.4379461,4.18301062 C16.3142994,3.9360975 16.4142265,3.63569936 16.6611396,3.5120526 C17.57049,3.05667694 18.5025497,2.6470249 19.4541655,2.28487298 Z M13.1151448,5.59866968 C13.3431545,5.44289366 13.6542744,5.50145065 13.8100504,5.72946039 C13.9658264,5.95747013 13.9072694,6.26858997 13.6792597,6.42436599 C12.8666612,6.97953246 12.0821283,7.57503519 11.3286845,8.20841291 C11.1173079,8.38610525 10.8019053,8.35879881 10.6242129,8.14742227 C10.4465206,7.93604573 10.473827,7.62064308 10.6852036,7.44295074 C11.4640672,6.78820401 12.2750868,6.17259644 13.1151448,5.59866968 Z M7.77061682,10.2406048 C7.95681368,10.03668 8.2730698,10.0223086 8.47699464,10.2085054 C8.68091949,10.3947023 8.69529086,10.7109584 8.509094,10.9148833 C7.84566901,11.6414736 7.21874019,12.4006507 6.63087984,13.1894454 C6.46586629,13.4108616 6.15260307,13.4565849 5.93118686,13.2915714 C5.70977065,13.1265578 5.66404727,12.8132946 5.82906082,12.5918784 C6.4367595,11.7764646 7.08482971,10.9916864 7.77061682,10.2406048 Z M3.59854831,16.0480828 C3.73230057,15.8064945 4.03657427,15.719076 4.27816265,15.8528283 C4.51975103,15.9865805 4.60716948,16.2908542 4.47341723,16.5324426 C3.99707097,17.3928372 3.5640053,18.2767846 3.17606761,19.181215 C3.06721283,19.4349969 2.77323773,19.5524835 2.51945584,19.4436287 C2.26567394,19.3347739 2.1481873,19.0407988 2.25704208,18.787017 C2.65819825,17.8517693 3.10600547,16.9377323 3.59854831,16.0480828 Z M0.888624617,22.6955121 C0.961832457,22.4292506 1.23702679,22.2727496 1.50328836,22.3459574 C1.76954993,22.4191653 1.92605089,22.6943596 1.85284305,22.9606212 C1.59258501,23.9071962 1.37959949,24.868131 1.21498614,25.8406818 C1.16890192,26.1129517 0.910824976,26.2963113 0.638555154,26.2502271 C0.366285333,26.2041429 0.182925676,25.9460659 0.229009898,25.6737961 C0.399230205,24.6681189 0.61948155,23.6744026 0.888624617,22.6955121 Z M-0.177229126,29.6106431 C-0.166645372,29.3347036 0.0656275999,29.1195903 0.341567078,29.1301741 C0.617506555,29.1407578 0.832619872,29.3730308 0.822036119,29.6489703 C0.807435914,30.0296266 0.800078972,30.4112885 0.800000643,30.7937223 C0.800000013,31.4034053 0.818110367,32.0054013 0.854325505,32.6054175 C0.870962335,32.8810583 0.660998166,33.1179961 0.385357409,33.1346329 C0.109716652,33.1512697 -0.127221147,32.9413056 -0.143857977,32.6656648 C-0.181285214,32.0455664 -0.200000007,31.4234786 -0.199999347,30.7936194 C-0.199918404,30.3983717 -0.192316467,30.0040001 -0.177229126,29.6106431 Z M0.37148074,36.7059786 C0.318307869,36.435004 0.49487109,36.1722305 0.765845733,36.1190576 C1.03682038,36.0658848 1.29959385,36.242448 1.35276673,36.5134226 C1.5425862,37.480763 1.78055544,38.4355649 2.06549967,39.3750339 C2.14564912,39.6392889 1.99640213,39.9184838 1.73214718,39.9986332 C1.46789224,40.0787827 1.18869731,39.9295357 1.10854786,39.6652808 C0.813869924,38.6937195 0.567774749,37.7063139 0.37148074,36.7059786 Z M2.55266058,43.4799243 C2.43773406,43.2288336 2.54811687,42.9321181 2.79920751,42.8171916 C3.05029814,42.702265 3.34701367,42.8126479 3.46194019,43.0637385 C3.87141383,43.9583535 4.32550362,44.8315573 4.82228394,45.6802706 C4.96177958,45.9185888 4.88166805,46.2248674 4.64334982,46.3643631 C4.4050316,46.5038587 4.09875294,46.4237472 3.9592573,46.185429 C3.44560376,45.307889 2.97607303,44.4049927 2.55266058,43.4799243 Z M6.2815959,49.6001613 C6.11124362,49.3828259 6.14933102,49.0685428 6.3666665,48.8981905 C6.58400198,48.7278383 6.89828501,48.7659257 7.06863729,48.9832611 C7.67554386,49.7575527 8.32075866,50.5013033 9.0016456,51.2115799 C9.19274001,51.4109226 9.1860534,51.7274345 8.98671064,51.9185289 C8.78736787,52.1096233 8.47085601,52.1029367 8.27976159,51.9035939 C7.57593218,51.1693846 6.90897043,50.4005659 6.2815959,49.6001613 Z M11.2508423,54.6211428 C11.0352847,54.4485463 11.0004579,54.1338853 11.1730543,53.9183277 C11.3456508,53.7027702 11.6603118,53.6679433 11.8758694,53.8405398 C12.643925,54.4555202 13.4421444,55.0318955 14.2674843,55.5672768 C14.4991537,55.7175561 14.5651335,56.0271868 14.4148541,56.2588563 C14.2645748,56.4905257 13.9549442,56.5565055 13.7232747,56.4062261 C12.8700193,55.8527365 12.0448289,55.2568861 11.2508423,54.6211428 Z M17.3234492,58.4096329 C17.0736115,58.2920077 16.966432,57.9941201 17.0840573,57.7442823 C17.2016825,57.4944445 17.4995701,57.3872651 17.7494079,57.5048903 C18.6390392,57.9237345 19.5496438,58.2978528 20.4782021,58.6256128 C20.7385987,58.717527 20.8751808,59.0031313 20.7832666,59.2635279 C20.6913525,59.5239245 20.4057482,59.6605066 20.1453516,59.5685925 C19.1850883,59.2296412 18.2434105,58.8427566 17.3234492,58.4096329 Z M24.1464446,60.6788671 C23.8759218,60.6234412 23.7015513,60.3592076 23.7569773,60.0886848 C23.8124032,59.818162 24.0766368,59.6437915 24.3471596,59.6992175 C25.3080417,59.8960873 26.2808592,60.0451929 27.2630167,60.1456161 C27.5377268,60.1737045 27.7376532,60.4191712 27.7095648,60.6938814 C27.6814763,60.9685915 27.4360096,61.1685179 27.1612995,61.1404294 C26.1458777,61.036605 25.1400201,60.8824354 24.1464446,60.6788671 Z"
	      },
	      "haiku:e8dd91e61623": {
	        "style.margin": "0",
	        "translation.x": 37.551,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "sizeAbsolute.y": "auto",
	        "style.position": "absolute",
	        "translation.y": 40.629,
	        "sizeMode.z": 1,
	        "origin.x": -0.841,
	        "origin.y": -2.626,
	        "style.zIndex": 3,
	        playback: {
	          "0": {
	            value: Haiku.inject(function(PlayIt) {
	              return PlayIt;
	            }, "PlayIt"),
	            edited: true
	          }
	        },
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "2000": { value: -6.309 }
	        }
	      },
	      "haiku:ce5aa4c80587": {
	        "style.margin": "0",
	        "translation.x": 38.388,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "sizeAbsolute.y": "auto",
	        "style.position": "absolute",
	        "translation.y": 42.365,
	        "sizeMode.z": 1,
	        "origin.x": 0.16,
	        "origin.y": 4.36,
	        "style.zIndex": 4,
	        playback: {
	          "0": {
	            value: Haiku.inject(function(PlayIt) {
	              return PlayIt;
	            }, "PlayIt"),
	            edited: true
	          }
	        },
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "2000": { value: -6.284, edited: true }
	        }
	      },
	      "haiku:a9af35c9d205": {
	        "style.margin": "0",
	        "translation.x": 37.512,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "sizeAbsolute.y": "auto",
	        "style.position": "absolute",
	        "translation.y": 41.391,
	        "sizeMode.z": 1,
	        "origin.x": 2.844,
	        "origin.y": 0.93,
	        "style.zIndex": 5,
	        playback: {
	          "0": {
	            value: Haiku.inject(function(PlayIt) {
	              return PlayIt;
	            }, "PlayIt"),
	            edited: true
	          }
	        },
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "2000": { value: 6.283 }
	        }
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Circle-2188d689141ec7f9",
	      "haiku-title": "Circle"
	    },
	    children: [
	      {
	        elementName: _code_deco1_code,
	        attributes: {
	          "haiku-id": "a9af35c9d205",
	          "haiku-var": "_code_deco1_code",
	          "haiku-title": "Deco1",
	          "haiku-source": "./code/deco1/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: _code_deco2_code,
	        attributes: {
	          "haiku-id": "ce5aa4c80587",
	          "haiku-var": "_code_deco2_code",
	          "haiku-title": "Deco2",
	          "haiku-source": "./code/deco2/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: _code_deco3_code,
	        attributes: {
	          "haiku-id": "e8dd91e61623",
	          "haiku-var": "_code_deco3_code",
	          "haiku-title": "Deco3",
	          "haiku-source": "./code/deco3/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "1451c8c56aee",
	          "haiku-title": "Oval",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon2.sketch.contents/slices/Oval.svg"
	        },
	        children: [
	          {
	            elementName: "defs",
	            attributes: { "haiku-id": "d10dae5a2d40" },
	            children: [
	              {
	                elementName: "linearGradient",
	                attributes: {
	                  "haiku-id": "df4f96f88976",
	                  "haiku-title": "linearGradient-1-2db749",
	                  id: "25b5284f55b7"
	                },
	                children: [
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "48ab1044e0c8" },
	                    children: []
	                  },
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "5d0e95e6bf0b" },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            elementName: "g",
	            attributes: {
	              "haiku-id": "608b0a30c0f7",
	              "haiku-title": "Page-1",
	              id: "2c4e89bad6fa"
	            },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "62bbe169da2d",
	                  "haiku-title": "HaikuCore-icon",
	                  id: "7aae61431e5d"
	                },
	                children: [
	                  {
	                    elementName: "path",
	                    attributes: {
	                      "haiku-id": "644fccdd1627",
	                      "haiku-title": "Oval",
	                      id: "647ed0d1906f"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	module.exports = {
	  metadata: {
	    uuid: "67a900ef-ed0f-491d-bee4-d8a023cf6ea0",
	    version: "0.0.1",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon2",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon2",
	    username: "tina@haiku.ai",
	    root: "https://cdn.haiku.ai/9fec979d-d44c-4994-b16b-ee78d60c5e95/5f95a2978fb21498c9f76103836200625255c63b/",
	    core: "4.5.0",
	    title: "Deco1",
	    type: "haiku",
	    relpath: "code/deco1/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Deco1-b2dcea53f1bacc28": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 12.943,
	        "sizeAbsolute.y": 11.955,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:d290ae049778": {
	        "sizeAbsolute.y": 10,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 11,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeMode.y": 1,
	        "translation.x": 6.4715,
	        "translation.y": 5.9775,
	        "style.zIndex": 3,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "667": { value: 6.284 }
	        }
	      },
	      "haiku:745e06598933": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:6b40c34ae663": {
	        fill: "#FFAC39",
	        "translation.x": -9,
	        "translation.y": -51
	      },
	      "haiku:83c14f131bda": {
	        x: 10.6641016,
	        y: 52.1805668,
	        width: 8,
	        height: 8,
	        rx: 2,
	        "translation.x": 30.054901,
	        "translation.y": 0.194718,
	        "rotation.z": 0.523599
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Deco1-b2dcea53f1bacc28",
	      "haiku-title": "Deco1"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "d290ae049778",
	          "haiku-title": "deco1",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon2.sketch.contents/slices/deco1.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: {
	              "haiku-id": "745e06598933",
	              "haiku-title": "Page-1",
	              id: "a6d1a92b457e"
	            },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "6b40c34ae663",
	                  "haiku-title": "HaikuCore-icon",
	                  id: "31ba2b315aa0"
	                },
	                children: [
	                  {
	                    elementName: "rect",
	                    attributes: {
	                      "haiku-id": "83c14f131bda",
	                      "haiku-title": "deco1",
	                      id: "c008e8ddfe68"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	module.exports = {
	  metadata: {
	    uuid: "67a900ef-ed0f-491d-bee4-d8a023cf6ea0",
	    version: "0.0.1",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon2",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon2",
	    username: "tina@haiku.ai",
	    root: "https://cdn.haiku.ai/9fec979d-d44c-4994-b16b-ee78d60c5e95/5f95a2978fb21498c9f76103836200625255c63b/",
	    core: "4.5.0",
	    title: "Deco2",
	    type: "haiku",
	    relpath: "code/deco2/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Deco2-20cb245cfb651e73": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 8.666,
	        "sizeAbsolute.y": 8.321,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:7eaee227506e": {
	        "sizeAbsolute.y": 7,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 7,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeMode.y": 1,
	        "translation.x": 4.333,
	        "translation.y": 4.160499999999999,
	        "style.zIndex": 4,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "667": { value: 6.284 }
	        }
	      },
	      "haiku:61060159ee1d": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:818bdcfdd51d": {
	        fill: "#A3CE32",
	        "translation.x": -7,
	        "translation.y": -4
	      },
	      "haiku:ac405177b446": {
	        x: 7.32893795,
	        y: 4.78998906,
	        width: 5.94212411,
	        height: 5.94212411,
	        rx: 1,
	        "translation.x": 0.420298,
	        "translation.y": -0.528424,
	        "rotation.z": 0.05236
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Deco2-20cb245cfb651e73",
	      "haiku-title": "Deco2"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "7eaee227506e",
	          "haiku-title": "deco2",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon2.sketch.contents/slices/deco2.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: {
	              "haiku-id": "61060159ee1d",
	              "haiku-title": "Page-1",
	              id: "fc88fb5fbeef"
	            },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "818bdcfdd51d",
	                  "haiku-title": "HaikuCore-icon",
	                  id: "61a7d42c98f5"
	                },
	                children: [
	                  {
	                    elementName: "rect",
	                    attributes: {
	                      "haiku-id": "ac405177b446",
	                      "haiku-title": "deco2",
	                      id: "0d6d88e8fc0a"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	module.exports = {
	  metadata: {
	    uuid: "67a900ef-ed0f-491d-bee4-d8a023cf6ea0",
	    version: "0.0.1",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon2",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon2",
	    username: "tina@haiku.ai",
	    root: "https://cdn.haiku.ai/9fec979d-d44c-4994-b16b-ee78d60c5e95/5f95a2978fb21498c9f76103836200625255c63b/",
	    core: "4.5.0",
	    title: "Deco3",
	    type: "haiku",
	    relpath: "code/deco3/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Deco3-0c407b0457d72f75": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 9,
	        "sizeAbsolute.y": 9,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:e52175b974ac": {
	        "sizeAbsolute.y": 9,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 9,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeMode.y": 1,
	        "translation.x": 4.5,
	        "translation.y": 4.5,
	        "style.zIndex": 5,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "667": { value: 6.284 }
	        }
	      },
	      "haiku:672a0beeee34": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:29bc7be5d93c": {
	        fill: "#04B6CB",
	        "translation.x": -54,
	        "translation.y": -16
	      },
	      "haiku:f7272cb855f6": {
	        x: 55.4146654,
	        y: 17.7146654,
	        width: 5.94212411,
	        height: 5.94212411,
	        rx: 1,
	        "translation.x": 5.009919,
	        "translation.y": 52.115261,
	        "rotation.z": 5.410521
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Deco3-0c407b0457d72f75",
	      "haiku-title": "Deco3"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "e52175b974ac",
	          "haiku-title": "deco3",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon2.sketch.contents/slices/deco3.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: {
	              "haiku-id": "672a0beeee34",
	              "haiku-title": "Page-1",
	              id: "c008d085398b"
	            },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "29bc7be5d93c",
	                  "haiku-title": "HaikuCore-icon",
	                  id: "9d17eb90600f"
	                },
	                children: [
	                  {
	                    elementName: "rect",
	                    attributes: {
	                      "haiku-id": "f7272cb855f6",
	                      "haiku-title": "deco3",
	                      id: "29aa99b68293"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	var _code_circle_code = __webpack_require__(431);
	module.exports = {
	  metadata: {
	    version: "0.0.3",
	    username: "tina@haiku.ai",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon2",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon2",
	    uuid: "67a900ef-ed0f-491d-bee4-d8a023cf6ea0",
	    root: "https://cdn.haiku.ai/9fec979d-d44c-4994-b16b-ee78d60c5e95/5f95a2978fb21498c9f76103836200625255c63b/",
	    core: "4.5.0",
	    title: "Main",
	    type: "haiku",
	    relpath: "code/main/code.js"
	  },
	  options: {},
	  states: { play: { type: "string", value: "stop", edited: true } },
	  eventHandlers: {
	    "haiku:Main-03757d2ca1026e0a": {
	      hover: {
	        handler: function(component, element, target, event) {
	          this.setState({ play: "loop" });
	        }
	      },
	      unhover: {
	        handler: function(component, element, target, event) {
	          this.setState({ play: "stop" });
	        }
	      }
	    }
	  },
	  timelines: {
	    Default: {
	      "haiku:Main-03757d2ca1026e0a": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "hidden",
	        "style.overflowY": "hidden",
	        "sizeAbsolute.x": 100.402,
	        "sizeAbsolute.y": 81.872,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:Cog-Icon-f30f200d0748e297": {
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 41,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 38,
	        "sizeMode.y": 1,
	        "translation.x": 50.5,
	        "translation.y": 40.899993896484375,
	        "style.zIndex": 2
	      },
	      "haiku:Linear-Gradient-1-5ecbc7-e32da9ac9ce0d616": {
	        x1: "21.6215522%",
	        y1: "15.3187264%",
	        x2: "50%",
	        y2: "94.1878588%"
	      },
	      "haiku:Stop-7d22cd2176cbbf69": { stopColor: "#04B6CB", offset: "0%" },
	      "haiku:Stop-cda765f4f066c2f2": { stopColor: "#A3CE32", offset: "100%" },
	      "haiku:Linear-Gradient-2-5ecbc7-ffda7821e90a14fb": {
	        x1: "21.6215522%",
	        y1: "10.7570105%",
	        x2: "50%",
	        y2: "100%"
	      },
	      "haiku:Stop-f187087d3d09e249": { stopColor: "#04B6CB", offset: "0%" },
	      "haiku:Stop-f2e1a2b5fe3f15fd": { stopColor: "#A3CE32", offset: "100%" },
	      "haiku:Page-1-25d2b85c05c9524d": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Haiku-Core-Icon-fcc961643b954a64": {
	        fillRule: "nonzero",
	        "translation.x": -10,
	        "translation.y": -12
	      },
	      "haiku:Cog-Icon-1162f9ddfaf1a8ef": {
	        "translation.x": 10.3,
	        "translation.y": 11.8
	      },
	      "haiku:Shape-c7f11c1e365d4a4c": {
	        d:
	          "M26.648,37.804 C26.5,37.804 26.352,37.772 26.216,37.706 C25.97,37.588 25.784,37.376 25.698,37.118 C24.884,34.656 22.594,33.002 20,33.002 C17.406,33.002 15.114,34.656 14.302,37.118 C14.216,37.376 14.03,37.588 13.784,37.706 C13.538,37.824 13.256,37.836 13.002,37.742 C10.918,36.964 8.99,35.848 7.272,34.43 C7.062,34.256 6.932,34.006 6.912,33.736 C6.892,33.466 6.982,33.198 7.162,32.994 C8.886,31.058 9.174,28.25 7.876,26.002 C6.808,24.152 4.814,23.002 2.674,23.002 C2.268,23.002 1.86,23.044 1.464,23.126 C1.198,23.182 0.92,23.126 0.696,22.972 C0.472,22.818 0.32,22.58 0.274,22.312 C0.092,21.22 0,20.108 0,19.004 C0,17.9 0.092,16.788 0.274,15.696 C0.318,15.428 0.47,15.19 0.696,15.036 C0.922,14.882 1.198,14.826 1.464,14.882 C1.86,14.964 2.268,15.006 2.674,15.006 C4.814,15.006 6.808,13.856 7.876,12.006 C9.172,9.76 8.886,6.95 7.162,5.014 C6.982,4.812 6.89,4.544 6.912,4.272 C6.934,4 7.062,3.75 7.272,3.578 C8.99,2.158 10.92,1.044 13.002,0.266 C13.256,0.17 13.54,0.184 13.784,0.302 C14.028,0.42 14.216,0.632 14.302,0.89 C15.116,3.352 17.406,5.006 20,5.006 C22.594,5.006 24.886,3.352 25.698,0.89 C25.784,0.632 25.97,0.42 26.216,0.302 C26.462,0.184 26.744,0.172 26.998,0.266 C29.082,1.044 31.01,2.16 32.728,3.578 C32.938,3.752 33.068,4.002 33.088,4.272 C33.108,4.542 33.018,4.81 32.838,5.014 C31.114,6.95 30.826,9.758 32.124,12.006 C33.192,13.858 35.186,15.006 37.326,15.006 C37.732,15.006 38.14,14.964 38.536,14.882 C38.802,14.826 39.08,14.882 39.304,15.036 C39.528,15.19 39.68,15.428 39.726,15.696 C39.908,16.788 40,17.9 40,19.004 C40,20.108 39.908,21.22 39.726,22.312 C39.682,22.58 39.53,22.818 39.304,22.972 C39.078,23.126 38.802,23.182 38.536,23.126 C38.14,23.044 37.732,23.002 37.326,23.002 C35.186,23.002 33.192,24.152 32.124,26.002 C30.828,28.248 31.114,31.058 32.838,32.994 C33.018,33.196 33.11,33.464 33.088,33.736 C33.066,34.008 32.938,34.258 32.728,34.43 C31.01,35.85 29.082,36.964 26.998,37.742 C26.884,37.784 26.766,37.806 26.648,37.806 L26.648,37.804 Z M9.308,33.482 C10.396,34.286 11.564,34.962 12.802,35.502 C14.126,32.772 16.9,31 20,31 C23.1,31 25.874,32.772 27.198,35.502 C28.436,34.962 29.604,34.286 30.692,33.482 C28.99,30.97 28.844,27.684 30.392,25 C31.816,22.532 34.474,21 37.326,21 C37.512,21 37.7,21.006 37.886,21.02 C37.962,20.348 38,19.672 38,19.002 C38,18.332 37.962,17.654 37.886,16.984 C37.7,16.998 37.512,17.004 37.326,17.004 C34.474,17.004 31.816,15.472 30.392,13.004 C28.842,10.32 28.988,7.032 30.692,4.522 C29.604,3.718 28.436,3.042 27.198,2.502 C25.874,5.232 23.1,7.004 20,7.004 C16.9,7.004 14.126,5.232 12.802,2.502 C11.564,3.042 10.396,3.718 9.308,4.522 C11.01,7.034 11.156,10.32 9.608,13.004 C8.184,15.472 5.526,17.004 2.674,17.004 C2.488,17.004 2.3,16.998 2.114,16.984 C2.038,17.656 2,18.332 2,19.002 C2,19.672 2.038,20.35 2.114,21.02 C2.3,21.006 2.488,21 2.674,21 C5.526,21 8.184,22.534 9.608,25 C11.158,27.684 11.012,30.972 9.308,33.482 Z",
	        fill: "url(#linearGradient-1-5ecbc7)"
	      },
	      "haiku:Shape-8ddb638da94880d0": {
	        d:
	          "M20,25 C16.692,25 14,22.308 14,19 C14,15.692 16.692,13 20,13 C23.308,13 26,15.692 26,19 C26,22.308 23.308,25 20,25 Z M20,15 C17.794,15 16,16.794 16,19 C16,21.206 17.794,23 20,23 C22.206,23 24,21.206 24,19 C24,16.794 22.206,15 20,15 Z",
	        fill: "url(#linearGradient-2-5ecbc7)"
	      },
	      "haiku:Circle-2dba6ebd7b0693fc": {
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "sizeAbsolute.y": "auto",
	        "translation.x": 50.201,
	        "translation.y": 41.03600000000001,
	        "sizeMode.z": 1,
	        "origin.x": 0.5,
	        "origin.y": 0.5,
	        "style.zIndex": 1,
	        playback: {
	          "0": {
	            value: Haiku.inject(function(play) {
	              return play;
	            }, "play"),
	            edited: true
	          }
	        },
	        PlayIt: {
	          "0": {
	            value: Haiku.inject(function(play) {
	              return play;
	            }, "play"),
	            edited: true
	          }
	        }
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
	    children: [
	      {
	        elementName: _code_circle_code,
	        attributes: {
	          "haiku-id": "Circle-2dba6ebd7b0693fc",
	          "haiku-var": "_code_circle_code",
	          "haiku-title": "Circle",
	          "haiku-source": "./code/circle/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Cog-Icon-f30f200d0748e297",
	          "haiku-title": "Cog icon",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon2.sketch.contents/slices/Cog icon.svg"
	        },
	        children: [
	          {
	            elementName: "defs",
	            attributes: { "haiku-id": "Defs-d32f24d4442ff82f" },
	            children: [
	              {
	                elementName: "linearGradient",
	                attributes: {
	                  "haiku-id": "Linear-Gradient-1-5ecbc7-e32da9ac9ce0d616",
	                  id: "linearGradient-1-5ecbc7"
	                },
	                children: [
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-7d22cd2176cbbf69" },
	                    children: []
	                  },
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-cda765f4f066c2f2" },
	                    children: []
	                  }
	                ]
	              },
	              {
	                elementName: "linearGradient",
	                attributes: {
	                  "haiku-id": "Linear-Gradient-2-5ecbc7-ffda7821e90a14fb",
	                  id: "linearGradient-2-5ecbc7"
	                },
	                children: [
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-f187087d3d09e249" },
	                    children: []
	                  },
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-f2e1a2b5fe3f15fd" },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-25d2b85c05c9524d", id: "Page-1" },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "Haiku-Core-Icon-fcc961643b954a64",
	                  id: "HaikuCore-icon"
	                },
	                children: [
	                  {
	                    elementName: "g",
	                    attributes: {
	                      "haiku-id": "Cog-Icon-1162f9ddfaf1a8ef",
	                      id: "Cog-icon"
	                    },
	                    children: [
	                      {
	                        elementName: "path",
	                        attributes: {
	                          "haiku-id": "Shape-c7f11c1e365d4a4c",
	                          id: "Shape"
	                        },
	                        children: []
	                      },
	                      {
	                        elementName: "path",
	                        attributes: {
	                          "haiku-id": "Shape-8ddb638da94880d0",
	                          id: "Shape"
	                        },
	                        children: []
	                      }
	                    ]
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var HaikuDOMAdapter = __webpack_require__(38)
	module.exports = HaikuDOMAdapter(__webpack_require__(435))

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1) // Installed as a peer dependency of '@haiku/core'
	var ReactDOM = __webpack_require__(21) // Installed as a peer dependency of '@haiku/core'
	var HaikuReactAdapter = __webpack_require__(39)
	var HaikuReactComponent = HaikuReactAdapter(__webpack_require__(436))
	if (HaikuReactComponent.default) HaikuReactComponent = HaikuReactComponent.default
	module.exports = HaikuReactComponent

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	// By default, a react-dom module is exported; see code/main/* for other options
	module.exports = __webpack_require__(437)

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	var _code_deco1_code = __webpack_require__(440);
	var _code_deco2_code = __webpack_require__(441);
	var _code_deco3_code = __webpack_require__(442);
	module.exports = {
	  metadata: {
	    version: "0.0.1",
	    username: "tina@haiku.ai",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon3",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon3",
	    uuid: "58cfb188-fd09-4522-857f-5c360ba7039e",
	    root: "https://cdn.haiku.ai/ecbab1b7-350c-4db4-ae46-f4da53963612/80b581d854fba9f81f33f065dfdb5d5b95871c62/",
	    core: "4.5.0",
	    title: "Circle",
	    type: "haiku",
	    relpath: "code/circle/code.js"
	  },
	  options: {},
	  states: { PlayIt: { type: "string", value: "stop", edited: true } },
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Circle-2188d689141ec7f9": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 95.655,
	        "sizeAbsolute.y": 81.934,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:f79f92ef6116": {
	        "sizeAbsolute.y": "auto",
	        "translation.x": 49.068,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "style.position": "absolute",
	        "style.margin": "0",
	        "translation.y": 41.285,
	        "sizeMode.z": 1,
	        "origin.x": 2.358,
	        "origin.y": -2.541,
	        "style.zIndex": 3,
	        playback: {
	          "0": {
	            value: Haiku.inject(function(PlayIt) {
	              return PlayIt;
	            }, "PlayIt"),
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "2000": {
	            value: Haiku.inject(function(PlayIt) {
	              return PlayIt;
	            }, "PlayIt"),
	            edited: true
	          }
	        },
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "2000": { value: -6.284, edited: true }
	        }
	      },
	      "haiku:ed4fe6bab5b6": {
	        "sizeMode.x": 1,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 62,
	        "style.margin": "0",
	        "sizeAbsolute.y": 62,
	        "sizeMode.y": 1,
	        "translation.x": 48.982,
	        "translation.y": 41.336,
	        "style.zIndex": 1,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "2000": { value: 6.289 }
	        }
	      },
	      "haiku:e7c744e551a3": {
	        x1: "24.7107004%",
	        y1: "5.52635576%",
	        x2: "80.2882749%",
	        y2: "84.322403%"
	      },
	      "haiku:a69aada6bec8": { stopColor: "#8934FF", offset: "0%" },
	      "haiku:c2c2c63af1ff": { stopColor: "#04B6CB", offset: "100%" },
	      "haiku:1335c9f9fd94": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:87a7c91c9246": {
	        fill: "url(#982ad81a6a7d)",
	        fillRule: "nonzero",
	        "translation.x": -3
	      },
	      "haiku:ce246bcfc051": {
	        d:
	          "M34.3,61.3 C34.0238576,61.3 33.8,61.0761424 33.8,60.8 C33.8,60.5238576 34.0238576,60.3 34.3,60.3 C35.28867,60.3 36.2713129,60.2513827 37.2455964,60.154817 C37.5203923,60.1275807 37.7652378,60.3282674 37.7924741,60.6030633 C37.8197104,60.8778592 37.6190237,61.1227047 37.3442278,61.149941 C36.3371807,61.2497541 35.3216206,61.3 34.3,61.3 Z M41.3675314,60.4768597 C41.0988487,60.5406112 40.8293576,60.3744817 40.7656062,60.105799 C40.7018547,59.8371164 40.8679843,59.5676253 41.1366669,59.5038738 C42.0956773,59.2763254 43.0407201,59.0009688 43.9689255,58.6790982 C44.2298267,58.5886264 44.5146709,58.7267867 44.6051427,58.9876879 C44.6956145,59.2485892 44.5574542,59.5334333 44.296553,59.6239052 C43.3366319,59.9567738 42.3592953,60.2415397 41.3675314,60.4768597 Z M48.0530041,58.0304871 C47.8066131,58.155171 47.5057974,58.0565079 47.3811135,57.8101169 C47.2564296,57.5637259 47.3550927,57.2629102 47.6014837,57.1382263 C48.4792984,56.6940163 49.3341695,56.2060601 50.1630097,55.6764118 C50.3956996,55.5277175 50.7048726,55.5958094 50.853567,55.8284994 C51.0022613,56.0611893 50.9341694,56.3703623 50.7014795,56.5190567 C49.8445375,57.0666627 48.9606492,57.5711817 48.0530041,58.0304871 Z M53.9984029,54.0865111 C53.7876617,54.2649564 53.4721636,54.2387754 53.2937183,54.0280341 C53.115273,53.8172929 53.141454,53.5017948 53.3521952,53.3233495 C54.1030654,52.6875496 54.8219782,52.014664 55.5060656,51.3074213 C55.6980515,51.108937 56.0145902,51.103669 56.2130745,51.2956549 C56.4115588,51.4876408 56.4168268,51.8041795 56.2248409,52.0026638 C55.5177092,52.7337307 54.7745777,53.4292845 53.9984029,54.0865111 Z M58.8472613,48.9052637 C58.6831757,49.1273685 58.3701065,49.1744023 58.1480017,49.0103167 C57.925897,48.846231 57.8788632,48.5331619 58.0429488,48.3110571 C58.6277051,47.5195365 59.172652,46.69933 59.6755177,45.8535107 C59.8166361,45.6161497 60.1234542,45.5381297 60.3608151,45.6792481 C60.5981761,45.8203665 60.6761961,46.1271846 60.5350777,46.3645456 C60.0151756,47.2390201 59.4517871,48.0869831 58.8472613,48.9052637 Z M62.3978637,42.6841564 C62.2901823,42.9384384 61.996753,43.0572817 61.742471,42.9496003 C61.488189,42.841919 61.3693457,42.5484897 61.4770271,42.2942077 C61.8602874,41.3891655 62.1980955,40.4647045 62.4889481,39.5237959 C62.5705014,39.2599708 62.8504859,39.1122103 63.114311,39.1937637 C63.3781361,39.275317 63.5258965,39.5553015 63.4443432,39.8191265 C63.1435532,40.7921825 62.7942064,41.748221 62.3978637,42.6841564 Z M64.3891571,35.8176786 C64.3440584,36.0901134 64.0866466,36.2744057 63.8142118,36.229307 C63.5417771,36.1842083 63.3574847,35.9267965 63.4025834,35.6543617 C63.5626978,34.6871339 63.674883,33.7093162 63.7383177,32.7234122 C63.7560484,32.4478396 63.9938178,32.2388176 64.2693903,32.2565483 C64.5449629,32.2742791 64.7539849,32.5120484 64.7362542,32.787621 C64.6706814,33.8067557 64.5547013,34.8176501 64.3891571,35.8176786 Z M64.7370653,28.825027 C64.7546826,29.1006068 64.5455627,29.3382901 64.2699828,29.3559074 C63.994403,29.3735247 63.7567198,29.1644047 63.7391025,28.8888249 C63.6760611,27.9026945 63.5642497,26.9246402 63.4044894,25.9571659 C63.3594989,25.6847132 63.5438934,25.4273747 63.8163461,25.3823842 C64.0887988,25.3373937 64.3461373,25.5217883 64.3911278,25.7942409 C64.5563057,26.7945229 64.6718992,27.8056603 64.7370653,28.825027 Z M63.4525349,21.8074169 C63.533846,22.0713167 63.3858286,22.3511655 63.1219288,22.4324766 C62.858029,22.5137877 62.5781802,22.3657703 62.4968691,22.1018704 C62.2068235,21.1605106 61.8697914,20.23557 61.4872742,19.3300203 C61.379821,19.0756418 61.4989276,18.7823193 61.7533061,18.6748661 C62.0076846,18.567413 62.3010071,18.6865195 62.4084603,18.940898 C62.8040349,19.877359 63.1525794,20.8338939 63.4525349,21.8074169 Z M60.572573,15.298695 C60.7131185,15.5363956 60.6343587,15.8430247 60.3966582,15.9835702 C60.1589576,16.1241157 59.8523285,16.0453559 59.711783,15.8076553 C59.2109049,14.9605345 58.6678729,14.1389378 58.0849521,13.3459406 C57.9213981,13.1234441 57.9691805,12.8104883 58.191677,12.6469343 C58.4141736,12.4833803 58.7271293,12.5311627 58.8906833,12.7536593 C59.4933134,13.5734688 60.054724,14.4228718 60.572573,15.298695 Z M56.2820539,9.65664496 C56.4735061,9.85564411 56.4673881,10.1721675 56.268389,10.3636197 C56.0693898,10.5550719 55.7528665,10.5489539 55.5614142,10.3499547 C54.8792777,9.64092875 54.1622263,8.96615961 53.4131224,8.32838176 C53.2028628,8.14936925 53.1775319,7.83380179 53.3565444,7.62354211 C53.5355569,7.41328243 53.8511244,7.3879516 54.0613841,7.56696411 C54.8357321,8.22623452 55.576939,8.92373474 56.2820539,9.65664496 Z M50.7649247,5.12159673 C50.997247,5.27086493 51.0645755,5.58020509 50.9153073,5.81252731 C50.7660391,6.04484953 50.456699,6.11217812 50.2243767,5.96290991 C49.3967066,5.43112764 48.5429003,4.94098504 47.6660466,4.49454507 C47.4199634,4.36925465 47.3220416,4.06819688 47.447332,3.82211372 C47.5726224,3.57603056 47.8736802,3.47810869 48.1197633,3.6033991 C49.0264114,4.06500854 49.9091955,4.57178638 50.7649247,5.12159673 Z M44.3156488,1.98272379 C44.5764896,2.07336985 44.7144597,2.35830621 44.6238136,2.61914698 C44.5331676,2.87998774 44.2482312,3.01795781 43.9873904,2.92731175 C43.0595236,2.60486416 42.1147982,2.32890853 41.1560843,2.10074041 C40.8874451,2.03680591 40.7214992,1.7672017 40.7854337,1.49856256 C40.8493682,1.22992341 41.1189724,1.0639775 41.3876116,1.127912 C42.3790693,1.36387297 43.3560778,1.64925854 44.3156488,1.98272379 Z M37.4703951,0.462827937 C37.7450758,0.491202335 37.9447466,0.736877059 37.9163722,1.01155779 C37.8879978,1.28623852 37.6423231,1.48590926 37.3676423,1.45753486 C36.3932375,1.35687927 35.4103277,1.30422266 34.4212596,1.30024386 C34.1451195,1.29913301 33.9221642,1.07437668 33.923275,0.798236537 C33.9243859,0.522096396 34.1491422,0.299141104 34.4252824,0.300251953 C35.4473417,0.304363465 36.4632016,0.358785291 37.4703951,0.462827937 Z M30.3519687,0.553234316 C30.6258324,0.517832531 30.8765416,0.711144106 30.9119433,0.985007803 C30.9473451,1.2588715 30.7540336,1.50958071 30.4801699,1.54498249 C29.5013388,1.67151393 28.5327596,1.84664107 27.577091,2.0693739 C27.3081562,2.13205316 27.0393299,1.96485002 26.9766506,1.69591524 C26.9139714,1.42698045 27.0811745,1.15815414 27.3501093,1.09547488 C28.3383497,0.865150717 29.3398963,0.684062777 30.3519687,0.553234316 Z M23.4541655,2.28487298 C23.7122504,2.18665484 24.0010911,2.31625245 24.0993092,2.57433734 C24.1975273,2.83242223 24.0679297,3.1212629 23.8098449,3.21948103 C22.889629,3.56968319 21.988301,3.96582827 21.1089041,4.40620412 C20.861991,4.52985088 20.5615929,4.42992374 20.4379461,4.18301062 C20.3142994,3.9360975 20.4142265,3.63569936 20.6611396,3.5120526 C21.57049,3.05667694 22.5025497,2.6470249 23.4541655,2.28487298 Z M17.1151448,5.59866968 C17.3431545,5.44289366 17.6542744,5.50145065 17.8100504,5.72946039 C17.9658264,5.95747013 17.9072694,6.26858997 17.6792597,6.42436599 C16.8666612,6.97953246 16.0821283,7.57503519 15.3286845,8.20841291 C15.1173079,8.38610525 14.8019053,8.35879881 14.6242129,8.14742227 C14.4465206,7.93604573 14.473827,7.62064308 14.6852036,7.44295074 C15.4640672,6.78820401 16.2750868,6.17259644 17.1151448,5.59866968 Z M11.7706168,10.2406048 C11.9568137,10.03668 12.2730698,10.0223086 12.4769946,10.2085054 C12.6809195,10.3947023 12.6952909,10.7109584 12.509094,10.9148833 C11.845669,11.6414736 11.2187402,12.4006507 10.6308798,13.1894454 C10.4658663,13.4108616 10.1526031,13.4565849 9.93118686,13.2915714 C9.70977065,13.1265578 9.66404727,12.8132946 9.82906082,12.5918784 C10.4367595,11.7764646 11.0848297,10.9916864 11.7706168,10.2406048 Z M7.59854831,16.0480828 C7.73230057,15.8064945 8.03657427,15.719076 8.27816265,15.8528283 C8.51975103,15.9865805 8.60716948,16.2908542 8.47341723,16.5324426 C7.99707097,17.3928372 7.5640053,18.2767846 7.17606761,19.181215 C7.06721283,19.4349969 6.77323773,19.5524835 6.51945584,19.4436287 C6.26567394,19.3347739 6.1481873,19.0407988 6.25704208,18.787017 C6.65819825,17.8517693 7.10600547,16.9377323 7.59854831,16.0480828 Z M4.88862462,22.6955121 C4.96183246,22.4292506 5.23702679,22.2727496 5.50328836,22.3459574 C5.76954993,22.4191653 5.92605089,22.6943596 5.85284305,22.9606212 C5.59258501,23.9071962 5.37959949,24.868131 5.21498614,25.8406818 C5.16890192,26.1129517 4.91082498,26.2963113 4.63855515,26.2502271 C4.36628533,26.2041429 4.18292568,25.9460659 4.2290099,25.6737961 C4.39923021,24.6681189 4.61948155,23.6744026 4.88862462,22.6955121 Z M3.82277087,29.6106431 C3.83335463,29.3347036 4.0656276,29.1195903 4.34156708,29.1301741 C4.61750656,29.1407578 4.83261987,29.3730308 4.82203612,29.6489703 C4.80743591,30.0296266 4.80007897,30.4112885 4.80000064,30.7937223 C4.80000001,31.4034053 4.81811037,32.0054013 4.8543255,32.6054175 C4.87096233,32.8810583 4.66099817,33.1179961 4.38535741,33.1346329 C4.10971665,33.1512697 3.87277885,32.9413056 3.85614202,32.6656648 C3.81871479,32.0455664 3.79999999,31.4234786 3.80000065,30.7936194 C3.8000816,30.3983717 3.80768353,30.0040001 3.82277087,29.6106431 Z M4.37148074,36.7059786 C4.31830787,36.435004 4.49487109,36.1722305 4.76584573,36.1190576 C5.03682038,36.0658848 5.29959385,36.242448 5.35276673,36.5134226 C5.5425862,37.480763 5.78055544,38.4355649 6.06549967,39.3750339 C6.14564912,39.6392889 5.99640213,39.9184838 5.73214718,39.9986332 C5.46789224,40.0787827 5.18869731,39.9295357 5.10854786,39.6652808 C4.81386992,38.6937195 4.56777475,37.7063139 4.37148074,36.7059786 Z M6.55266058,43.4799243 C6.43773406,43.2288336 6.54811687,42.9321181 6.79920751,42.8171916 C7.05029814,42.702265 7.34701367,42.8126479 7.46194019,43.0637385 C7.87141383,43.9583535 8.32550362,44.8315573 8.82228394,45.6802706 C8.96177958,45.9185888 8.88166805,46.2248674 8.64334982,46.3643631 C8.4050316,46.5038587 8.09875294,46.4237472 7.9592573,46.185429 C7.44560376,45.307889 6.97607303,44.4049927 6.55266058,43.4799243 Z M10.2815959,49.6001613 C10.1112436,49.3828259 10.149331,49.0685428 10.3666665,48.8981905 C10.584002,48.7278383 10.898285,48.7659257 11.0686373,48.9832611 C11.6755439,49.7575527 12.3207587,50.5013033 13.0016456,51.2115799 C13.19274,51.4109226 13.1860534,51.7274345 12.9867106,51.9185289 C12.7873679,52.1096233 12.470856,52.1029367 12.2797616,51.9035939 C11.5759322,51.1693846 10.9089704,50.4005659 10.2815959,49.6001613 Z M15.2508423,54.6211428 C15.0352847,54.4485463 15.0004579,54.1338853 15.1730543,53.9183277 C15.3456508,53.7027702 15.6603118,53.6679433 15.8758694,53.8405398 C16.643925,54.4555202 17.4421444,55.0318955 18.2674843,55.5672768 C18.4991537,55.7175561 18.5651335,56.0271868 18.4148541,56.2588563 C18.2645748,56.4905257 17.9549442,56.5565055 17.7232747,56.4062261 C16.8700193,55.8527365 16.0448289,55.2568861 15.2508423,54.6211428 Z M21.3234492,58.4096329 C21.0736115,58.2920077 20.966432,57.9941201 21.0840573,57.7442823 C21.2016825,57.4944445 21.4995701,57.3872651 21.7494079,57.5048903 C22.6390392,57.9237345 23.5496438,58.2978528 24.4782021,58.6256128 C24.7385987,58.717527 24.8751808,59.0031313 24.7832666,59.2635279 C24.6913525,59.5239245 24.4057482,59.6605066 24.1453516,59.5685925 C23.1850883,59.2296412 22.2434105,58.8427566 21.3234492,58.4096329 Z M28.1464446,60.6788671 C27.8759218,60.6234412 27.7015513,60.3592076 27.7569773,60.0886848 C27.8124032,59.818162 28.0766368,59.6437915 28.3471596,59.6992175 C29.3080417,59.8960873 30.2808592,60.0451929 31.2630167,60.1456161 C31.5377268,60.1737045 31.7376532,60.4191712 31.7095648,60.6938814 C31.6814763,60.9685915 31.4360096,61.1685179 31.1612995,61.1404294 C30.1458777,61.036605 29.1400201,60.8824354 28.1464446,60.6788671 Z"
	      },
	      "haiku:69ab103a6f7e": {
	        "style.position": "absolute",
	        "translation.x": 49.04,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "style.margin": "0",
	        "sizeAbsolute.y": "auto",
	        "translation.y": 41.626,
	        "sizeMode.z": 1,
	        "origin.x": -2.468,
	        "origin.y": 0.385,
	        "style.zIndex": 4,
	        playback: {
	          "0": {
	            value: Haiku.inject(function(PlayIt) {
	              return PlayIt;
	            }, "PlayIt"),
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "2000": {
	            value: Haiku.inject(function(PlayIt) {
	              return PlayIt;
	            }, "PlayIt"),
	            edited: true
	          }
	        },
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "2000": { value: -6.284, edited: true }
	        }
	      },
	      "haiku:caca9a813e70": {
	        "style.position": "absolute",
	        "translation.x": 49.367,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "style.margin": "0",
	        "sizeAbsolute.y": "auto",
	        "translation.y": 42.114,
	        "sizeMode.z": 1,
	        "origin.x": 2.155,
	        "origin.y": 2.992,
	        "style.zIndex": 5,
	        playback: {
	          "0": {
	            value: Haiku.inject(function(PlayIt) {
	              return PlayIt;
	            }, "PlayIt"),
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "2000": {
	            value: Haiku.inject(function(PlayIt) {
	              return PlayIt;
	            }, "PlayIt"),
	            edited: true
	          }
	        },
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "2000": { value: 6.284, edited: true }
	        }
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Circle-2188d689141ec7f9",
	      "haiku-title": "Circle"
	    },
	    children: [
	      {
	        elementName: _code_deco1_code,
	        attributes: {
	          "haiku-id": "caca9a813e70",
	          "haiku-var": "_code_deco1_code",
	          "haiku-title": "Deco1",
	          "haiku-source": "./code/deco1/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: _code_deco2_code,
	        attributes: {
	          "haiku-id": "69ab103a6f7e",
	          "haiku-var": "_code_deco2_code",
	          "haiku-title": "Deco2",
	          "haiku-source": "./code/deco2/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "ed4fe6bab5b6",
	          "haiku-title": "Oval",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon3.sketch.contents/slices/Oval.svg"
	        },
	        children: [
	          {
	            elementName: "defs",
	            attributes: { "haiku-id": "c6e2677b93c4" },
	            children: [
	              {
	                elementName: "linearGradient",
	                attributes: {
	                  "haiku-id": "e7c744e551a3",
	                  "haiku-title": "linearGradient-1-2db749",
	                  id: "982ad81a6a7d"
	                },
	                children: [
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "a69aada6bec8" },
	                    children: []
	                  },
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "c2c2c63af1ff" },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            elementName: "g",
	            attributes: {
	              "haiku-id": "1335c9f9fd94",
	              "haiku-title": "Page-1",
	              id: "57057a8998eb"
	            },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "87a7c91c9246",
	                  "haiku-title": "NPM-icon",
	                  id: "2c0adf9e78d6"
	                },
	                children: [
	                  {
	                    elementName: "path",
	                    attributes: {
	                      "haiku-id": "ce246bcfc051",
	                      "haiku-title": "Oval",
	                      id: "a191d01552a5"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: _code_deco3_code,
	        attributes: {
	          "haiku-id": "f79f92ef6116",
	          "haiku-var": "_code_deco3_code",
	          "haiku-title": "Deco3",
	          "haiku-source": "./code/deco3/code.js"
	        },
	        children: []
	      }
	    ]
	  }
	};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	module.exports = {
	  metadata: {
	    uuid: "58cfb188-fd09-4522-857f-5c360ba7039e",
	    version: "0.0.0",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon3",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon3",
	    username: "tina@haiku.ai",
	    root: "https://cdn.haiku.ai/ecbab1b7-350c-4db4-ae46-f4da53963612/80b581d854fba9f81f33f065dfdb5d5b95871c62/",
	    core: "4.5.0",
	    title: "Deco1",
	    type: "haiku",
	    relpath: "code/deco1/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Deco1-b2dcea53f1bacc28": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 11,
	        "sizeAbsolute.y": 10,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:6937a4e9fe10": {
	        "sizeAbsolute.y": 10,
	        "sizeMode.x": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 11,
	        "style.margin": "0",
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "translation.x": 5.5,
	        "translation.y": 5,
	        "style.zIndex": 3,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "667": { value: 6.284, edited: true }
	        }
	      },
	      "haiku:be91a87ef5c0": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:f012d218044c": {
	        fill: "#EF33F8",
	        "translation.x": -51,
	        "translation.y": -46
	      },
	      "haiku:a3267c039ab1": {
	        x: 52.4641016,
	        y: 46.9641016,
	        width: 8,
	        height: 8,
	        rx: 2,
	        "translation.x": 33.046806,
	        "translation.y": -21.404156,
	        "rotation.z": 0.523599
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Deco1-b2dcea53f1bacc28",
	      "haiku-title": "Deco1"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "6937a4e9fe10",
	          "haiku-title": "deco1",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon3.sketch.contents/slices/deco1.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: {
	              "haiku-id": "be91a87ef5c0",
	              "haiku-title": "Page-1",
	              id: "a6d1a92b457e"
	            },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "f012d218044c",
	                  "haiku-title": "NPM-icon",
	                  id: "8c12bf1b0ca3"
	                },
	                children: [
	                  {
	                    elementName: "rect",
	                    attributes: {
	                      "haiku-id": "a3267c039ab1",
	                      "haiku-title": "deco1",
	                      id: "c008e8ddfe68"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	module.exports = {
	  metadata: {
	    uuid: "58cfb188-fd09-4522-857f-5c360ba7039e",
	    version: "0.0.0",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon3",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon3",
	    username: "tina@haiku.ai",
	    root: "https://cdn.haiku.ai/ecbab1b7-350c-4db4-ae46-f4da53963612/80b581d854fba9f81f33f065dfdb5d5b95871c62/",
	    core: "4.5.0",
	    title: "Deco2",
	    type: "haiku",
	    relpath: "code/deco2/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Deco2-20cb245cfb651e73": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 10.325,
	        "sizeAbsolute.y": 10.512,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:5e308e632567": {
	        "sizeAbsolute.y": 7,
	        "sizeMode.x": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 7,
	        "style.margin": "0",
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "translation.x": 5.1899999999999995,
	        "translation.y": 5.255000000000001,
	        "style.zIndex": 4,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "667": { value: 6.284, edited: true }
	        },
	        "scale.x": 1
	      },
	      "haiku:ed812c42eff9": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:84f884d220ec": {
	        fill: "#8934FF",
	        "translation.x": -46,
	        "translation.y": -1
	      },
	      "haiku:751ee469fd39": {
	        x: 46.6514216,
	        y: 1.15142164,
	        width: 5.94212411,
	        height: 5.94212411,
	        rx: 1,
	        "translation.x": 0.28376,
	        "translation.y": -2.59139,
	        "rotation.z": 0.05236
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Deco2-20cb245cfb651e73",
	      "haiku-title": "Deco2"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "5e308e632567",
	          "haiku-title": "deco2",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon3.sketch.contents/slices/deco2.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: {
	              "haiku-id": "ed812c42eff9",
	              "haiku-title": "Page-1",
	              id: "fc88fb5fbeef"
	            },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "84f884d220ec",
	                  "haiku-title": "NPM-icon",
	                  id: "9b80fb590d18"
	                },
	                children: [
	                  {
	                    elementName: "rect",
	                    attributes: {
	                      "haiku-id": "751ee469fd39",
	                      "haiku-title": "deco2",
	                      id: "0d6d88e8fc0a"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	module.exports = {
	  metadata: {
	    username: "tina@haiku.ai",
	    uuid: "58cfb188-fd09-4522-857f-5c360ba7039e",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon3",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon3",
	    version: "0.0.0",
	    root: "https://cdn.haiku.ai/ecbab1b7-350c-4db4-ae46-f4da53963612/80b581d854fba9f81f33f065dfdb5d5b95871c62/",
	    core: "4.5.0",
	    title: "Deco3",
	    type: "haiku",
	    relpath: "code/deco3/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Deco3-0c407b0457d72f75": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 9,
	        "sizeAbsolute.y": 8,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:92bd618bc39c": {
	        "style.margin": "0",
	        "sizeAbsolute.y": 8,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 9,
	        "sizeMode.x": 1,
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "translation.x": 4.5,
	        "translation.y": 4,
	        "style.zIndex": 5,
	        "rotation.z": {
	          "0": { value: 0, edited: true, curve: "linear" },
	          "667": { value: 6.284, edited: true }
	        }
	      },
	      "haiku:70f4dcf8922d": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:b662378bd21d": { fill: "#04B6CB", "translation.y": -21 },
	      "haiku:28501c8fb987": {
	        x: 1.32893795,
	        y: 22.0146654,
	        width: 5.94212411,
	        height: 5.94212411,
	        rx: 1,
	        "translation.x": -17.604164,
	        "translation.y": 12.219202,
	        "rotation.z": 5.410521
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Deco3-0c407b0457d72f75",
	      "haiku-title": "Deco3"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "92bd618bc39c",
	          "haiku-title": "deco3",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon3.sketch.contents/slices/deco3.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: {
	              "haiku-id": "70f4dcf8922d",
	              "haiku-title": "Page-1",
	              id: "c008d085398b"
	            },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "b662378bd21d",
	                  "haiku-title": "NPM-icon",
	                  id: "662362a3f52a"
	                },
	                children: [
	                  {
	                    elementName: "rect",
	                    attributes: {
	                      "haiku-id": "28501c8fb987",
	                      "haiku-title": "deco3",
	                      id: "29aa99b68293"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	var _code_circle_code = __webpack_require__(439);
	module.exports = {
	  metadata: {
	    uuid: "58cfb188-fd09-4522-857f-5c360ba7039e",
	    version: "0.0.1",
	    organization: "Tina",
	    project: "AnimatorWebsiteIcon3",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon3",
	    username: "tina@haiku.ai",
	    root: "https://cdn.haiku.ai/ecbab1b7-350c-4db4-ae46-f4da53963612/80b581d854fba9f81f33f065dfdb5d5b95871c62/",
	    core: "4.5.0",
	    title: "Main",
	    type: "haiku",
	    relpath: "code/main/code.js"
	  },
	  options: {},
	  states: { play: { type: "string", value: "stop", edited: true } },
	  eventHandlers: {
	    "haiku:Main-03757d2ca1026e0a": {
	      hover: {
	        handler: function(component, element, target, event) {
	          this.setState({ play: "loop" });
	        }
	      },
	      unhover: {
	        handler: function(component, element, target, event) {
	          this.setState({ play: "stop" });
	        }
	      }
	    }
	  },
	  timelines: {
	    Default: {
	      "haiku:Page-1-495b936d775bd71b": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Main-03757d2ca1026e0a": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "hidden",
	        "style.overflowY": "hidden",
	        "sizeAbsolute.x": 75.575,
	        "sizeAbsolute.y": 76.674,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:Code-Icon-bfe08a8c33848ff8": {
	        "sizeMode.x": 1,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 46,
	        "style.margin": "0",
	        "sizeAbsolute.y": 23,
	        "sizeMode.y": 1,
	        "translation.x": 37.78750000000001,
	        "translation.y": 37.99998474121094,
	        "style.zIndex": 2
	      },
	      "haiku:Linear-Gradient-1-Ec20bc-b036e44b3d0b4ff0": {
	        x1: "24.659504%",
	        y1: "40.0186951%",
	        x2: "80.3495914%",
	        y2: "57.7030424%"
	      },
	      "haiku:Stop-1432e3d34d3eea07": { stopColor: "#8934FF", offset: "0%" },
	      "haiku:Stop-2719a1cdd0637513": { stopColor: "#04B6CB", offset: "100%" },
	      "haiku:Npm-Icon-5eadcc51aff99800": {
	        fill: "url(#linearGradient-1-ec20bc)",
	        "translation.x": -12,
	        "translation.y": -19
	      },
	      "haiku:Code-Icon-0cb0a430b3145312": {
	        d:
	          "M23.2,41.4 C22.8928,41.4 22.5856,41.2824 22.3504,41.0496 L12.7504,31.4496 C12.2824,30.9816 12.2824,30.2208 12.7504,29.7528 L22.3504,20.1528 C22.8184,19.6848 23.5792,19.6848 24.0472,20.1528 C24.5152,20.6208 24.5152,21.3816 24.0472,21.8496 L15.2968,30.6 L24.0472,39.3504 C24.5152,39.8184 24.5152,40.5792 24.0472,41.0472 C23.812,41.2824 23.5048,41.3976 23.1976,41.3976 L23.2,41.4 Z M47.2,41.4 C46.8928,41.4 46.5856,41.2824 46.3504,41.0496 C45.8824,40.5816 45.8824,39.8208 46.3504,39.3528 L55.1008,30.6024 L46.3504,21.852 C45.8824,21.384 45.8824,20.6232 46.3504,20.1552 C46.8184,19.6872 47.5792,19.6872 48.0472,20.1552 L57.6472,29.7552 C58.1152,30.2232 58.1152,30.984 57.6472,31.452 L48.0472,41.052 C47.812,41.2872 47.5048,41.4024 47.1976,41.4024 L47.2,41.4 Z M29.2,41.4 C28.9816,41.4 28.7632,41.34 28.564,41.2176 C28.0024,40.8672 27.832,40.1256 28.1824,39.564 L40.1824,20.364 C40.5328,19.8024 41.2744,19.632 41.836,19.9824 C42.3976,20.3328 42.568,21.0744 42.2176,21.636 L30.2176,40.836 C29.9896,41.2008 29.5984,41.4 29.2,41.4 Z"
	      },
	      "haiku:Circle-55cdabc6476eeb96": {
	        "style.position": "absolute",
	        "translation.x": 37.49999999999999,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "style.margin": "0",
	        "sizeAbsolute.y": "auto",
	        "translation.y": 38.337,
	        "sizeMode.z": 1,
	        "origin.x": 0.5,
	        "origin.y": 0.5,
	        "style.zIndex": 1,
	        playback: {
	          "0": {
	            value: Haiku.inject(function(play) {
	              return play;
	            }, "play"),
	            edited: true
	          }
	        },
	        PlayIt: {
	          "0": {
	            value: Haiku.inject(function(play) {
	              return play;
	            }, "play"),
	            edited: true
	          }
	        }
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
	    children: [
	      {
	        elementName: _code_circle_code,
	        attributes: {
	          "haiku-id": "Circle-55cdabc6476eeb96",
	          "haiku-var": "_code_circle_code",
	          "haiku-title": "Circle",
	          "haiku-source": "./code/circle/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Code-Icon-bfe08a8c33848ff8",
	          "haiku-title": "Code-icon",
	          "haiku-source":
	            "designs/AnimatorWebsiteIcon3.sketch.contents/slices/Code-icon.svg"
	        },
	        children: [
	          {
	            elementName: "defs",
	            attributes: { "haiku-id": "Defs-1070aead04bcd3b2" },
	            children: [
	              {
	                elementName: "linearGradient",
	                attributes: {
	                  "haiku-id": "Linear-Gradient-1-Ec20bc-b036e44b3d0b4ff0",
	                  id: "linearGradient-1-ec20bc"
	                },
	                children: [
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-1432e3d34d3eea07" },
	                    children: []
	                  },
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-2719a1cdd0637513" },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-495b936d775bd71b", id: "Page-1" },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "Npm-Icon-5eadcc51aff99800",
	                  id: "NPM-icon"
	                },
	                children: [
	                  {
	                    elementName: "path",
	                    attributes: {
	                      "haiku-id": "Code-Icon-0cb0a430b3145312",
	                      id: "Code-icon"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var HaikuDOMAdapter = __webpack_require__(38)
	module.exports = HaikuDOMAdapter(__webpack_require__(443))

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1) // Installed as a peer dependency of '@haiku/core'
	var ReactDOM = __webpack_require__(21) // Installed as a peer dependency of '@haiku/core'
	var HaikuReactAdapter = __webpack_require__(39)
	var HaikuReactComponent = HaikuReactAdapter(__webpack_require__(444))
	if (HaikuReactComponent.default) HaikuReactComponent = HaikuReactComponent.default
	module.exports = HaikuReactComponent

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	// By default, a react-dom module is exported; see code/main/* for other options
	module.exports = __webpack_require__(445)

/***/ }),
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(8);
	module.exports = {
	  metadata: {
	    version: "0.0.2",
	    username: "zack+4@haiku.ai",
	    organization: "zack4",
	    project: "animatorLogo",
	    branch: "master",
	    folder: "/Users/zack/.haiku/projects/zack4/animatorLogo",
	    uuid: "981a3477-4e4a-4ade-bde4-e0151af36a60",
	    root: "https://cdn.haiku.ai/f20c7403-4da1-4110-b85f-fcff00ac0264/4dab159ad07325a14f9e56ec79871f23b9c0a44d/",
	    core: "4.5.0",
	    title: "Main",
	    type: "haiku",
	    relpath: "code/main/code.js"
	  },
	  options: {},
	  states: {
	    bgColor: { type: "string", value: "transparent", edited: true },
	    fgColor: { type: "string", value: "#070E18", edited: true }
	  },
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Path-2-dfa4f1f6cca73d4f": {
	        "style.margin": "0",
	        "sizeAbsolute.y": 114,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 128,
	        "sizeMode.x": 1,
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "translation.x": {
	          "0": { value: 397.753, edited: true },
	          "1000": { value: 39.027, edited: true, curve: "easeInOutQuad" },
	          "1067": { value: 58.312, edited: true, curve: "easeInOutQuad" },
	          "1283": { value: 65.604, edited: true },
	          "1567": { value: 65.604, edited: true, curve: "easeInOutQuad" },
	          "1917": { value: 65.496, edited: true, curve: "easeInOutQuad" },
	          "2033": { value: 65.481, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 65.45, edited: true }
	        },
	        "translation.y": {
	          "0": { value: 170.1780205078125, edited: true },
	          "1000": { value: 65.098, edited: true, curve: "easeInOutQuad" },
	          "1100": { value: 61.42, edited: true, curve: "easeInOutQuad" },
	          "1283": { value: 42.233, edited: true },
	          "1567": { value: 42.233, edited: true, curve: "easeInOutQuad" },
	          "1917": { value: 52.62, edited: true, curve: "easeInOutQuad" },
	          "2033": { value: 54.111, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 57.105, edited: true }
	        },
	        "style.zIndex": { "0": { value: 3, edited: true } },
	        "scale.x": {
	          "0": { value: 0.524, edited: true },
	          "1000": { value: 0.272, edited: true, curve: "easeOutBack" },
	          "1333": { value: 0.716, edited: true },
	          "1567": { value: 0.716, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 0.995, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 0.524, edited: true },
	          "1000": { value: 0.109, edited: true, curve: "easeOutBack" },
	          "1333": { value: 0.715, edited: true },
	          "1567": { value: 0.715, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 0.993, edited: true }
	        },
	        "rotation.z": {
	          "0": { value: 0, edited: true },
	          "1000": {
	            value: -2.5249999999999995,
	            edited: true,
	            curve: "easeOutBack"
	          },
	          "1283": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1733": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1917": { value: 0.129, edited: true, curve: "easeInOutQuad" },
	          "2033": { value: -0.22, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 0, edited: true }
	        },
	        opacity: 1
	      },
	      "haiku:Linear-Gradient-1-2db749-95a3f9579dad9a19": {
	        x1: "83.4146793%",
	        y1: "9.82956494%",
	        x2: "16.8409543%",
	        y2: "82.2812111%"
	      },
	      "haiku:Stop-cdeb99092b9623d8": { stopColor: "#F66045", offset: "0%" },
	      "haiku:Stop-c0421130149019d6": { stopColor: "#EF34F4", offset: "100%" },
	      "haiku:Page-1-9fa83a73d34094a2": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Path-2-c91fc96c9ea04b29": {
	        d: {
	          "0": {
	            value:
	              "M125.935288,107.829102 C124.656738,111.042969 120.056152,113.986774 118.626465,113.993387 C117.67334,113.997796 81.0653681,114 8.80254953,114 C4.98398786,113.164291 2.3914388,111.107325 1.02490234,107.829102 C-0.341634115,104.550879 -0.341634115,100.702571 1.02490234,96.2841797 L52.8833008,5.64257813 C54.3829922,2.03057516 57.6130583,0.187144733 62.5734991,0.11228684 C67.5339398,0.0374289466 71.1489258,2.33398437 73.418457,7.00195312 L125.935288,99.3154297 C127.645617,102.321825 127.213839,104.615234 125.935288,107.829102 Z",
	            edited: true
	          },
	          "1617": {
	            value:
	              "M125.935288,107.829102 C124.656738,111.042969 120.056152,113.986774 118.626465,113.993387 C117.67334,113.997796 81.0653681,114 8.80254953,114 C4.98398786,113.164291 2.3914388,111.107325 1.02490234,107.829102 C-0.341634115,104.550879 -0.341634115,100.702571 1.02490234,96.2841797 L52.8833008,5.64257813 C54.3829922,2.03057516 57.6130583,0.187144733 62.5734991,0.11228684 C67.5339398,0.0374289466 71.1489258,2.33398437 73.418457,7.00195312 L125.935288,99.3154297 C127.645617,102.321825 127.213839,104.615234 125.935288,107.829102 Z",
	            edited: true,
	            curve: [0.72, -0.13, 0.265, 1.5]
	          },
	          "2083": {
	            value:
	              "M100.722336,52.6813857 C100.722336,53.5441276 100.650038,54.2226777 100.323648,54.9732996 C85.3558139,89.3959115 51.4807595,113.536206 11.9699936,113.993393 C5.84648885,113.786717 0.945782475,108.757512 0.945782475,102.583686 C0.945782475,100.590429 1.46765962,98.6319083 2.45950137,96.9029429 L54.6932313,5.84979439 C57.8306188,0.380741873 64.807517,-1.50944607 70.2765695,1.62794145 C72.0333586,2.6357446 73.4904182,4.09276475 74.4982688,5.84952665 L100.073593,50.4293021 C100.44603,51.0578887 100.662277,51.7969067 100.722336,52.6463561 C100.722343,52.6580676 100.722336,52.6697263 100.722336,52.6813857 Z",
	            edited: true
	          }
	        },
	        fill: "url(#linearGradient-1-2db749)"
	      },
	      "haiku:Path-2-af1a6cd5d22c7ebf": {
	        "sizeMode.y": 1,
	        "sizeMode.x": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 128,
	        "style.margin": "0",
	        "sizeAbsolute.y": 114,
	        "style.position": "absolute",
	        "translation.x": {
	          "0": { value: 274.5, edited: true },
	          "1550": {
	            value: 65.19799804687501,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "1767": { value: 92.751, edited: true, curve: "easeInOutQuad" },
	          "1800": { value: 85.096, edited: true, curve: "easeInOutQuad" },
	          "1833": { value: 108.809, edited: true, curve: "easeInOutQuad" },
	          "1867": { value: 119.651, edited: true, curve: "easeInOutQuad" },
	          "1983": { value: 142.095, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 147.19, edited: true }
	        },
	        "translation.y": {
	          "0": { value: 200, edited: true },
	          "1550": {
	            value: 45.641996582031254,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "1767": { value: 67.454, edited: true, curve: "easeInOutQuad" },
	          "1800": { value: 70.747, edited: true, curve: "easeInOutQuad" },
	          "1833": { value: 79.417, edited: true, curve: "easeInOutQuad" },
	          "1867": { value: 88.179, edited: true, curve: "easeInOutQuad" },
	          "1983": { value: 98.777, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 123.338, edited: true }
	        },
	        "style.zIndex": { "0": { value: 2, edited: true } },
	        "scale.x": {
	          "0": { value: 1, edited: true },
	          "1550": { value: 0.656, edited: true, curve: "easeInOutQuad" },
	          "1767": { value: 0.248, edited: true, curve: "easeInOutQuad" },
	          "1800": { value: 0.415, edited: true, curve: "easeInOutQuad" },
	          "1867": { value: 0.353, edited: true, curve: "easeInOutQuad" },
	          "1983": { value: 0.622, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 0.984, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 1, edited: true },
	          "1550": { value: 0.656, edited: true, curve: "easeInOutQuad" },
	          "1767": { value: 0.375, edited: true, curve: "easeInOutQuad" },
	          "1800": { value: 0.395, edited: true, curve: "easeInOutQuad" },
	          "1867": { value: 0.338, edited: true, curve: "easeInOutQuad" },
	          "1983": { value: 0.604, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 0.984, edited: true }
	        },
	        "rotation.z": {
	          "0": { value: 0, edited: true },
	          "1700": { value: 0, edited: true },
	          "1717": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1767": { value: -0.257, edited: true, curve: "easeInOutQuad" },
	          "1867": { value: -0.155, edited: true, curve: "easeInOutQuad" },
	          "1983": { value: -0.254, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 0, edited: true }
	        },
	        opacity: 1
	      },
	      "haiku:Linear-Gradient-1-A2f1bf-dd579bf2bb55ca45": {
	        x1: "83.4146793%",
	        y1: "9.82956494%",
	        x2: "16.8409543%",
	        y2: "82.2812111%"
	      },
	      "haiku:Stop-490ca8708059018e": { stopColor: "#F66045", offset: "0%" },
	      "haiku:Stop-bd5d9c00639d63bb": { stopColor: "#EF34F4", offset: "100%" },
	      "haiku:Page-1-d0721883a5cc8b0d": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Path-2-7a635180adee9604": {
	        d: {
	          "0": {
	            value:
	              "M125.935288,107.829102 C124.656738,111.042969 120.056152,113.986774 118.626465,113.993387 C117.67334,113.997796 81.0653681,114 8.80254953,114 C4.98398786,113.164291 2.3914388,111.107325 1.02490234,107.829102 C-0.341634115,104.550879 -0.341634115,100.702571 1.02490234,96.2841797 L52.8833008,5.64257813 C54.3829922,2.03057516 57.6130583,0.187144733 62.5734991,0.11228684 C67.5339398,0.0374289466 71.1489258,2.33398437 73.418457,7.00195312 L125.935288,99.3154297 C127.645617,102.321825 127.213839,104.615234 125.935288,107.829102 Z",
	            edited: true
	          },
	          "1700": {
	            value:
	              "M125.935288,107.829102 C124.656738,111.042969 120.056152,113.986774 118.626465,113.993387 C117.67334,113.997796 81.0653681,114 8.80254953,114 C4.98398786,113.164291 2.3914388,111.107325 1.02490234,107.829102 C-0.341634115,104.550879 -0.341634115,100.702571 1.02490234,96.2841797 L52.8833008,5.64257813 C54.3829922,2.03057516 57.6130583,0.187144733 62.5734991,0.11228684 C67.5339398,0.0374289466 71.1489258,2.33398437 73.418457,7.00195312 L125.935288,99.3154297 C127.645617,102.321825 127.213839,104.615234 125.935288,107.829102 Z",
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "2100": {
	            value:
	              "M1.54068502,31.9079382 C5.26420899,20.3407875 10.7331511,11.5199377 17.3523328,2.44067783 C18.2596942,1.19608748 20.1434314,0.132261158 22.049509,0.304249421 C22.0520685,0.304206442 22.0547255,0.304066626 22.0574798,0.303830273 C22.0591685,0.303998584 22.0608436,0.304138301 22.0625049,0.304249421 C23.6506384,0.410476969 25.0221866,1.23694783 26.1771494,2.78366199 L41.7352708,29.9026752 C43.0206494,32.1431897 43.4622272,34.6367976 43.1596057,37.0158193 C42.6108383,42.6213479 37.9278784,47 32.2320957,47 C32.1658855,47 32.0998121,46.9994083 32.0338804,46.9982299 C31.9669075,46.9994093 31.8998879,47 31.8328289,47 L11.8294494,47 C11.8144014,46.9999693 11.7993184,47 11.7842282,47 C5.71944457,47 0.802966027,42.035629 0.802966027,35.911767 C0.802966027,35.1215293 0.884834901,34.3505994 1.04047558,33.6071532 C1.04966398,33.5148034 1.06835327,33.4210912 1.09725542,33.3259069 C1.10675639,33.2946171 1.11626982,33.2633475 1.12579569,33.232098 C1.2371392,32.7790728 1.37606988,32.337047 1.54068328,31.9079436 L1.54068502,31.9079382 Z",
	            edited: true
	          }
	        },
	        fill: "url(#linearGradient-1-a2f1bf)"
	      },
	      "haiku:Diamond-Copy-32-012380ac5456526a": {
	        "style.margin": "0",
	        "sizeMode.y": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 31,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 36,
	        "style.position": "absolute",
	        "translation.x": {
	          "0": { value: 500, edited: true, curve: "easeInBack" },
	          "817": { value: -0.147, edited: true, curve: "easeInOutQuad" },
	          "900": { value: 8.774, edited: true, curve: "easeInOutQuad" },
	          "983": { value: 42, edited: true, curve: [0.455, 0.03, 0.595, 0.77] },
	          "1317": { value: 60, edited: true, curve: "easeInOutQuad" },
	          "1450": {
	            value: 60.698,
	            edited: true,
	            curve: [0.515, 0, 0.43, 1.31]
	          },
	          "2250": { value: 115.928, edited: true }
	        },
	        "translation.y": {
	          "0": {
	            value: 60.95400000000001,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "817": { value: 60.805, edited: true, curve: "easeInCirc" },
	          "900": {
	            value: 60.95399999999999,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "1317": { value: 119.009, edited: true, curve: "easeInOutQuad" },
	          "1450": {
	            value: 118.992,
	            edited: true,
	            curve: [0.225, 0.335, 0.565, 1.2]
	          },
	          "2250": { value: 56.279, edited: true }
	        },
	        "style.zIndex": { "0": { value: 13, edited: true } },
	        "scale.x": {
	          "983": { value: 2, edited: true, curve: "easeInOutQuad" },
	          "0": { value: 2.437, edited: true, curve: "easeInOutQuad" },
	          "433": { value: 2.437, edited: true, curve: "easeInOutQuad" },
	          "817": { value: 5, edited: true, curve: "easeInOutQuad" },
	          "900": { value: 0.678, edited: true, curve: "easeInOutQuad" },
	          "250": { value: 2.1, edited: true, curve: "easeInOutQuad" },
	          "1283": { value: 1, edited: true },
	          "1433": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "1750": { value: 0.7, edited: true, curve: "easeInOutQuad" },
	          "1950": { value: 1, edited: true, curve: "easeOutBack" },
	          "2150": { value: 1, edited: true }
	        },
	        "scale.y": {
	          "983": { value: 2, edited: true, curve: "easeInOutQuad" },
	          "0": { value: 2.437, edited: true, curve: "easeInOutQuad" },
	          "433": { value: 2.437, edited: true, curve: "easeInOutQuad" },
	          "817": { value: 1.5, edited: true, curve: "easeInOutQuad" },
	          "900": { value: 3.302, edited: true, curve: "easeInOutQuad" },
	          "250": { value: 2.6, edited: true, curve: "easeInOutQuad" },
	          "1283": { value: 1, edited: true },
	          "1433": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "1750": { value: 1.3, edited: true },
	          "1917": { value: 1.3, edited: true, curve: "easeOutBack" },
	          "2250": { value: 1, edited: true }
	        },
	        "rotation.z": {
	          "0": { value: -3.1415927, edited: true },
	          "983": {
	            value: -3.1415927,
	            edited: true,
	            curve: [0.455, 0.03, 0.465, 0.985]
	          },
	          "1367": { value: 0, edited: true },
	          "1383": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1617": { value: 0.576, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 0, edited: true }
	        },
	        "origin.x": {
	          "0": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "433": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "817": {
	            value: 0.999,
	            edited: true,
	            curve: [0.485, 0.01, 0.515, 0.955]
	          },
	          "983": { value: 0.5, edited: true, curve: "easeInOutQuad" },
	          "1050": { value: 0.5, edited: true, curve: "easeInOutQuad" },
	          "1317": { value: 0.488, edited: true }
	        },
	        "origin.y": {
	          "0": { value: 0.5, edited: true },
	          "433": { value: 0.5, edited: true, curve: "easeInOutQuad" },
	          "817": { value: 0.499, edited: true, curve: "easeInOutQuad" },
	          "983": { value: 0.5, edited: true, curve: "easeInOutQuad" },
	          "1050": { value: 0.5, edited: true, curve: "easeInOutQuad" },
	          "1317": { value: 0.922, edited: true }
	        },
	        opacity: 1
	      },
	      "haiku:Linear-Gradient-1-13dfc6-38d7a30a8ef0258a": {
	        x1: "33.7565155%",
	        y1: "12.8556931%",
	        x2: "66.8709721%",
	        y2: "87.4887573%"
	      },
	      "haiku:Main-03757d2ca1026e0a": {
	        "sizeAbsolute.y": 121.908,
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.overflowX": "hidden",
	        "style.overflowY": "hidden",
	        "sizeAbsolute.x": 550,
	        "style.position": "relative",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1,
	        "style.backgroundColor": {
	          "0": {
	            value: Haiku.inject(function(bgColor) {
	              return bgColor;
	            }, "bgColor"),
	            edited: true
	          }
	        },
	        "style.background": { "0": { value: 1, edited: true } }
	      },
	      "haiku:Stop-bb8bcc406964d868": { stopColor: "#F246AB", offset: "100%" },
	      "haiku:Page-1-a697b632a22d76c8": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Diamond-Copy-32-89844bd46ba48c4f": {
	        d:
	          "M0.707191911,17.9706033 C0.687928678,16.3839694 1.51445752,14.4399786 3.25708443,12.3398411 L11.8253312,2.77847156 C14.0573044,0.0885953484 17.6548089,0.0983600319 19.8786797,2.77847156 L28.4469265,12.3398411 C30.1903558,14.4409456 31.0178793,16.3845567 30.9997072,17.9706033 C31.0178793,19.5566499 30.1903558,21.500261 28.4469265,23.6013655 L19.8786797,33.162735 C17.6548089,35.8428466 14.0573044,35.8526112 11.8253312,33.162735 L3.25708443,23.6013655 C1.51445752,21.501228 0.687928678,19.5572372 0.707191911,17.9706033 Z",
	        fill: { "0": { value: "url(#linearGradient-1-13dfc6)", edited: true } }
	      },
	      "haiku:Full-Group-086e4bed4e4c459c": {
	        "style.margin": "0",
	        "sizeAbsolute.y": 121,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 551,
	        "sizeMode.x": 1,
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "translation.x": 275,
	        "translation.y": 60.5,
	        "style.zIndex": { "0": { value: 1, edited: true } },
	        opacity: {
	          "0": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "2250": { value: 0, edited: true }
	        }
	      },
	      "haiku:Stop-988850c829312872": { stopColor: "#F5566E", offset: "0%" },
	      "haiku:By-Haiku-Copy-35944b0a063252e8": {
	        "sizeAbsolute.y": 28,
	        "style.position": "absolute",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 123,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeMode.y": 1,
	        "translation.x": {
	          "0": { value: 488, edited: true },
	          "1667": { value: 489, edited: true }
	        },
	        "translation.y": {
	          "0": { value: 151.333251953125, edited: true },
	          "1667": { value: 91.927, edited: true, curve: "easeInOutQuad" },
	          "2017": { value: 106.927, edited: true }
	        },
	        "style.zIndex": { "0": { value: 4, edited: true } },
	        opacity: {
	          "0": { value: 1, edited: true },
	          "1667": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "2367": { value: 1, edited: true }
	        }
	      },
	      "haiku:Linear-Gradient-1-176eee-23a6b10f96a0babb": {
	        x1: "100%",
	        y1: "15.7237935%",
	        x2: "18.9087946%",
	        y2: "81.9605306%"
	      },
	      "haiku:Stop-934c92bd402c280e": { stopColor: "#F66045", offset: "0%" },
	      "haiku:Stop-bed321f8d0b812fd": { stopColor: "#EF34F4", offset: "100%" },
	      "haiku:Page-1-82f29448178d578a": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Full-Group-37c9aede0f61e809": {
	        fillRule: "nonzero",
	        "translation.x": 1
	      },
	      "haiku:Animator-Copy-70d065c90ce41146": {
	        d:
	          "M188.914419,86.3374536 L185.445265,76.0679852 L163.804355,76.0679852 L160.335202,86.3374536 L145.55,86.3374536 L166.530119,28.1990111 L182.8847,28.1990111 L203.864819,86.3374536 L188.914419,86.3374536 Z M181.810914,65.1359703 L174.62481,43.8516687 L167.521306,65.1359703 L181.810914,65.1359703 Z M242.025507,86.3374536 L242.025507,61.2435105 C242.025507,54.9493201 238.556354,51.4709518 233.187426,51.4709518 C227.818498,51.4709518 224.349344,54.9493201 224.349344,61.2435105 L224.349344,86.3374536 L210.224933,86.3374536 L210.224933,40.1248455 L224.349344,40.1248455 L224.349344,46.2533993 C227.157706,42.3609394 232.11364,39.6279357 238.308557,39.6279357 C248.963814,39.6279357 256.067319,46.9159456 256.067319,59.3386897 L256.067319,86.3374536 L242.025507,86.3374536 Z M265.896587,86.3374536 L265.896587,40.1248455 L280.020998,40.1248455 L280.020998,86.3374536 L265.896587,86.3374536 Z M273.000092,35.3213844 C267.96156,35.3213844 264.575005,31.9258344 264.575005,27.7021014 C264.575005,23.3955501 267.96156,20 273.000092,20 C277.956026,20 281.34258,23.3955501 281.34258,27.7021014 C281.34258,31.9258344 277.956026,35.3213844 273.000092,35.3213844 Z M353.78181,86.3374536 L353.78181,61.2435105 C353.78181,55.197775 350.312656,51.8850433 344.943728,51.8850433 C339.5748,51.8850433 336.105647,55.197775 336.105647,61.2435105 L336.105647,86.3374536 L322.063835,86.3374536 L322.063835,61.2435105 C322.063835,55.197775 318.594681,51.8850433 313.225753,51.8850433 C307.856825,51.8850433 304.387672,55.197775 304.387672,61.2435105 L304.387672,86.3374536 L290.263261,86.3374536 L290.263261,40.1248455 L304.387672,40.1248455 L304.387672,45.9221261 C307.113435,42.1953028 311.821572,39.6279357 317.851291,39.6279357 C324.789598,39.6279357 330.406323,42.6922126 333.545081,48.2410383 C336.60124,43.354759 342.383163,39.6279357 349.073673,39.6279357 C360.47232,39.6279357 367.823622,46.9159456 367.823622,59.3386897 L367.823622,86.3374536 L353.78181,86.3374536 Z M374.927126,63.1483313 C374.927126,48.5723115 383.930406,39.4622991 395.246454,39.4622991 C402.102162,39.4622991 406.975497,42.6093943 409.453464,46.6674907 L409.453464,40.1248455 L423.577875,40.1248455 L423.577875,86.3374536 L409.453464,86.3374536 L409.453464,79.7948084 C406.892898,83.8529048 402.019563,87 395.163855,87 C383.930406,87 374.927126,77.7243511 374.927126,63.1483313 Z M409.453464,63.2311496 C409.453464,55.8603214 404.745327,51.802225 399.376399,51.802225 C394.09007,51.802225 389.299334,55.7775031 389.299334,63.1483313 C389.299334,70.5191595 394.09007,74.6600742 399.376399,74.6600742 C404.745327,74.6600742 409.453464,70.6019778 409.453464,63.2311496 Z M436.050307,70.2707046 L436.050307,51.8850433 L430.433583,51.8850433 L430.433583,40.1248455 L436.050307,40.1248455 L436.050307,28.8615575 L450.174718,28.8615575 L450.174718,40.1248455 L459.425794,40.1248455 L459.425794,51.8850433 L450.174718,51.8850433 L450.174718,70.4363412 C450.174718,73.1693449 451.331103,74.328801 454.469861,74.328801 L459.508393,74.328801 L459.508393,86.3374536 L452.322289,86.3374536 C442.740818,86.3374536 436.050307,82.2793572 436.050307,70.2707046 Z M512.454284,63.2311496 C512.454284,77.8899876 501.881625,87 488.335407,87 C474.789188,87 464.546926,77.8899876 464.546926,63.2311496 C464.546926,48.5723115 475.036985,39.4622991 488.500605,39.4622991 C502.046823,39.4622991 512.454284,48.5723115 512.454284,63.2311496 Z M478.919133,63.2311496 C478.919133,71.0160692 483.214275,74.7428925 488.335407,74.7428925 C493.373939,74.7428925 498.082076,71.0160692 498.082076,63.2311496 C498.082076,55.3634116 493.456538,51.7194067 488.500605,51.7194067 C483.379473,51.7194067 478.919133,55.3634116 478.919133,63.2311496 Z M534.095194,64.8875155 L534.095194,86.3374536 L519.970783,86.3374536 L519.970783,40.1248455 L534.095194,40.1248455 L534.095194,47.8269468 C537.316551,42.9406675 542.355083,39.6279357 548.55,39.6279357 L548.55,54.618047 L544.667852,54.618047 C537.977342,54.618047 534.095194,56.9369592 534.095194,64.8875155 Z",
	        fill: "#242B3A"
	      },
	      "haiku:By-Haiku-Copy-c0ce72c9dbe76d77": {
	        d:
	          "M429.665922,101.646418 C430.575892,100.030128 432.473829,98.7052993 434.995746,98.7052993 C438.843618,98.7052993 441.755522,101.619921 441.755522,106.150834 C441.755522,110.65525 438.817619,113.702355 434.995746,113.702355 C432.395832,113.702355 430.549893,112.377527 429.665922,110.787733 L429.665922,113.463886 L427.3,113.463886 L427.3,93.8564279 L429.665922,93.8564279 L429.665922,101.646418 Z M439.337602,106.150834 C439.337602,102.732777 437.127675,100.798528 434.501762,100.798528 C431.927847,100.798528 429.665922,102.812267 429.665922,106.177331 C429.665922,109.595388 431.927847,111.58263 434.501762,111.58263 C437.127675,111.58263 439.337602,109.568891 439.337602,106.150834 Z M450.28324,110.708243 L454.703094,98.9437684 L457.147013,98.9437684 L448.567297,120.3 L446.123378,120.3 L448.931285,113.304907 L443.185475,98.9437684 L445.811388,98.9437684 L450.28324,110.708243 Z M478.050322,113.463886 L478.050322,105.090972 L468.820627,105.090972 L468.820627,113.463886 L466.454706,113.463886 L466.454706,94.9957802 L468.820627,94.9957802 L468.820627,103.103729 L478.050322,103.103729 L478.050322,94.9957802 L480.416244,94.9957802 L480.416244,113.463886 L478.050322,113.463886 Z M483.536141,106.150834 C483.536141,101.619921 486.474044,98.7052993 490.295917,98.7052993 C492.94783,98.7052993 494.76777,100.083121 495.599742,101.593425 L495.599742,98.9437684 L497.991663,98.9437684 L497.991663,113.463886 L495.599742,113.463886 L495.599742,110.761237 C494.741771,112.324534 492.895832,113.702355 490.269918,113.702355 C486.474044,113.702355 483.536141,110.65525 483.536141,106.150834 Z M495.599742,106.177331 C495.599742,102.812267 493.363816,100.798528 490.763902,100.798528 C488.163988,100.798528 485.954061,102.732777 485.954061,106.150834 C485.954061,109.568891 488.163988,111.58263 490.763902,111.58263 C493.363816,111.58263 495.599742,109.595388 495.599742,106.177331 Z M501.995531,113.463886 L501.995531,98.9437684 L504.361453,98.9437684 L504.361453,113.463886 L501.995531,113.463886 Z M503.21749,96.5855741 C502.30752,96.5855741 501.605544,95.8701668 501.605544,94.942787 C501.605544,94.0154073 502.30752,93.3 503.21749,93.3 C504.075462,93.3 504.777439,94.0154073 504.777439,94.942787 C504.777439,95.8701668 504.075462,96.5855741 503.21749,96.5855741 Z M508.391319,113.463886 L508.391319,93.8564279 L510.757241,93.8564279 L510.757241,105.382434 L516.24306,98.9437684 L519.544951,98.9437684 L512.837172,106.177331 L519.57095,113.463886 L516.347056,113.463886 L510.757241,107.051717 L510.757241,113.463886 L508.391319,113.463886 Z M534.416459,98.9437684 L534.416459,113.463886 L532.050537,113.463886 L532.050537,111.317664 C531.140567,112.827969 529.398625,113.675859 527.500688,113.675859 C524.224796,113.675859 521.650881,111.609127 521.650881,107.449166 L521.650881,98.9437684 L523.990804,98.9437684 L523.990804,107.131207 C523.990804,110.072326 525.576751,111.58263 527.968672,111.58263 C530.412591,111.58263 532.050537,110.045829 532.050537,106.919235 L532.050537,98.9437684 L534.416459,98.9437684 Z M544.048174,95.7906771 C541.500258,95.7906771 539.888311,97.5924436 539.888311,100.16261 C539.888311,102.732777 541.500258,104.534544 544.048174,104.534544 C546.57009,104.534544 548.234035,102.732777 548.234035,100.16261 C548.234035,97.5924436 546.57009,95.7906771 544.048174,95.7906771 Z M544.048174,105.594406 C540.954276,105.594406 538.770348,103.289205 538.770348,100.16261 C538.770348,97.0360157 540.954276,94.7573111 544.048174,94.7573111 C547.116072,94.7573111 549.3,97.0360157 549.3,100.16261 C549.3,103.289205 547.116072,105.594406 544.048174,105.594406 Z M546.388096,99.0497547 C546.388096,99.8976447 545.920112,100.507066 545.166137,100.745535 L546.622089,102.94475 L544.984143,102.971246 L543.736184,100.851521 L543.294199,100.851521 L543.294199,102.971246 L541.942243,102.971246 L541.942243,97.2744848 L544.438161,97.2744848 C545.608122,97.2744848 546.388096,97.9633955 546.388096,99.0497547 Z M544.360163,98.5198234 L543.294199,98.5198234 L543.294199,99.7121688 L544.360163,99.7121688 C544.724151,99.7121688 545.036141,99.5266928 545.036141,99.1027478 C545.036141,98.6788027 544.724151,98.5198234 544.360163,98.5198234 Z",
	        fill: "#242B3A"
	      },
	      "haiku:Symbol-Copy-919a79d121aeac69": {
	        d:
	          "M85.540685,98.9079382 C89.264209,87.3407875 94.7331511,78.5199377 101.352333,69.4406778 C102.259694,68.1960875 104.143431,67.1322612 106.049509,67.3042494 C106.052068,67.3042064 106.054725,67.3040666 106.05748,67.3038303 C106.059169,67.3039986 106.060844,67.3041383 106.062505,67.3042494 C107.650638,67.410477 109.022187,68.2369478 110.177149,69.783662 L125.735271,96.9026752 C127.020649,99.1431897 127.462227,101.636798 127.159606,104.015819 C126.610838,109.621348 121.927878,114 116.232096,114 C116.165885,114 116.099812,113.999408 116.03388,113.99823 C115.966908,113.999409 115.899888,114 115.832829,114 L95.8294494,114 C95.8144014,113.999969 95.7993184,114 95.7842282,114 C89.7194446,114 84.802966,109.035629 84.802966,102.911767 C84.802966,102.121529 84.8848349,101.350599 85.0404756,100.607153 C85.049664,100.514803 85.0683533,100.421091 85.0972554,100.325907 C85.1067564,100.294617 85.1162698,100.263347 85.1257957,100.232098 C85.2371392,99.7790728 85.3760699,99.337047 85.5406833,98.9079436 Z M99.7223565,52.6464095 C99.7223429,52.6580676 99.722336,52.6697263 99.722336,52.6813857 C99.722336,53.5441276 99.6500376,54.2226777 99.323648,54.9732996 C84.3558139,89.3959115 50.4807595,113.536206 10.9699936,113.993393 C4.84648885,113.786717 -0.0542175247,108.757512 -0.0542175247,102.583686 C-0.0542175247,100.590429 0.467659619,98.6319083 1.45950137,96.9029429 L53.6932313,5.84979439 C56.8306188,0.380741873 63.807517,-1.50944607 69.2765695,1.62794145 C71.0333586,2.6357446 72.4904182,4.09276475 73.4982688,5.84952665 L99.0735933,50.4293021 C99.4460297,51.0578887 99.6622772,51.7969067 99.722336,52.6463561 L99.7223565,52.6464095 Z M100.707192,40.9706033 C100.687929,39.3839694 101.514458,37.4399786 103.257084,35.3398411 L111.825331,25.7784716 C114.057304,23.0885953 117.654809,23.09836 119.87868,25.7784716 L128.446926,35.3398411 C130.190356,37.4409456 131.017879,39.3845567 130.999707,40.9706033 C131.017879,42.5566499 130.190356,44.500261 128.446926,46.6013655 L119.87868,56.162735 C117.654809,58.8428466 114.057304,58.8526112 111.825331,56.162735 L103.257084,46.6013655 C101.514458,44.501228 100.687929,42.5572372 100.707192,40.9706033 Z",
	        fill: "url(#linearGradient-1-176eee)"
	      },
	      "haiku:Page-1-8231b9d094ee1082": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Full-Group-8927369bb14bff2f": {
	        fill: "#242B3A",
	        fillRule: "nonzero",
	        "translation.x": -427,
	        "translation.y": -93
	      },
	      "haiku:By-Haiku-Copy-57a5aa462a0d761b": {
	        d:
	          "M429.665922,101.646418 C430.575892,100.030128 432.473829,98.7052993 434.995746,98.7052993 C438.843618,98.7052993 441.755522,101.619921 441.755522,106.150834 C441.755522,110.65525 438.817619,113.702355 434.995746,113.702355 C432.395832,113.702355 430.549893,112.377527 429.665922,110.787733 L429.665922,113.463886 L427.3,113.463886 L427.3,93.8564279 L429.665922,93.8564279 L429.665922,101.646418 Z M439.337602,106.150834 C439.337602,102.732777 437.127675,100.798528 434.501762,100.798528 C431.927847,100.798528 429.665922,102.812267 429.665922,106.177331 C429.665922,109.595388 431.927847,111.58263 434.501762,111.58263 C437.127675,111.58263 439.337602,109.568891 439.337602,106.150834 Z M450.28324,110.708243 L454.703094,98.9437684 L457.147013,98.9437684 L448.567297,120.3 L446.123378,120.3 L448.931285,113.304907 L443.185475,98.9437684 L445.811388,98.9437684 L450.28324,110.708243 Z M478.050322,113.463886 L478.050322,105.090972 L468.820627,105.090972 L468.820627,113.463886 L466.454706,113.463886 L466.454706,94.9957802 L468.820627,94.9957802 L468.820627,103.103729 L478.050322,103.103729 L478.050322,94.9957802 L480.416244,94.9957802 L480.416244,113.463886 L478.050322,113.463886 Z M483.536141,106.150834 C483.536141,101.619921 486.474044,98.7052993 490.295917,98.7052993 C492.94783,98.7052993 494.76777,100.083121 495.599742,101.593425 L495.599742,98.9437684 L497.991663,98.9437684 L497.991663,113.463886 L495.599742,113.463886 L495.599742,110.761237 C494.741771,112.324534 492.895832,113.702355 490.269918,113.702355 C486.474044,113.702355 483.536141,110.65525 483.536141,106.150834 Z M495.599742,106.177331 C495.599742,102.812267 493.363816,100.798528 490.763902,100.798528 C488.163988,100.798528 485.954061,102.732777 485.954061,106.150834 C485.954061,109.568891 488.163988,111.58263 490.763902,111.58263 C493.363816,111.58263 495.599742,109.595388 495.599742,106.177331 Z M501.995531,113.463886 L501.995531,98.9437684 L504.361453,98.9437684 L504.361453,113.463886 L501.995531,113.463886 Z M503.21749,96.5855741 C502.30752,96.5855741 501.605544,95.8701668 501.605544,94.942787 C501.605544,94.0154073 502.30752,93.3 503.21749,93.3 C504.075462,93.3 504.777439,94.0154073 504.777439,94.942787 C504.777439,95.8701668 504.075462,96.5855741 503.21749,96.5855741 Z M508.391319,113.463886 L508.391319,93.8564279 L510.757241,93.8564279 L510.757241,105.382434 L516.24306,98.9437684 L519.544951,98.9437684 L512.837172,106.177331 L519.57095,113.463886 L516.347056,113.463886 L510.757241,107.051717 L510.757241,113.463886 L508.391319,113.463886 Z M534.416459,98.9437684 L534.416459,113.463886 L532.050537,113.463886 L532.050537,111.317664 C531.140567,112.827969 529.398625,113.675859 527.500688,113.675859 C524.224796,113.675859 521.650881,111.609127 521.650881,107.449166 L521.650881,98.9437684 L523.990804,98.9437684 L523.990804,107.131207 C523.990804,110.072326 525.576751,111.58263 527.968672,111.58263 C530.412591,111.58263 532.050537,110.045829 532.050537,106.919235 L532.050537,98.9437684 L534.416459,98.9437684 Z M544.048174,95.7906771 C541.500258,95.7906771 539.888311,97.5924436 539.888311,100.16261 C539.888311,102.732777 541.500258,104.534544 544.048174,104.534544 C546.57009,104.534544 548.234035,102.732777 548.234035,100.16261 C548.234035,97.5924436 546.57009,95.7906771 544.048174,95.7906771 Z M544.048174,105.594406 C540.954276,105.594406 538.770348,103.289205 538.770348,100.16261 C538.770348,97.0360157 540.954276,94.7573111 544.048174,94.7573111 C547.116072,94.7573111 549.3,97.0360157 549.3,100.16261 C549.3,103.289205 547.116072,105.594406 544.048174,105.594406 Z M546.388096,99.0497547 C546.388096,99.8976447 545.920112,100.507066 545.166137,100.745535 L546.622089,102.94475 L544.984143,102.971246 L543.736184,100.851521 L543.294199,100.851521 L543.294199,102.971246 L541.942243,102.971246 L541.942243,97.2744848 L544.438161,97.2744848 C545.608122,97.2744848 546.388096,97.9633955 546.388096,99.0497547 Z M544.360163,98.5198234 L543.294199,98.5198234 L543.294199,99.7121688 L544.360163,99.7121688 C544.724151,99.7121688 545.036141,99.5266928 545.036141,99.1027478 C545.036141,98.6788027 544.724151,98.5198234 544.360163,98.5198234 Z",
	        fill: {
	          "0": {
	            value: Haiku.inject(function(fgColor) {
	              return fgColor;
	            }, "fgColor"),
	            edited: true
	          }
	        }
	      },
	      "haiku:A-60a7b6cff49ddbcd": {
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 59,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeAbsolute.y": 59,
	        "translation.x": 175.5,
	        "translation.y": 57.634,
	        "style.zIndex": { "0": { value: 5, edited: true } },
	        opacity: {
	          "0": { value: 0, edited: true },
	          "733": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "833": { value: 1, edited: true }
	        },
	        "scale.x": {
	          "0": { value: 1, edited: true },
	          "733": { value: 0.2, edited: true, curve: "easeOutBack" },
	          "833": { value: 1, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 1, edited: true },
	          "733": { value: 0.2, edited: true, curve: "linear" },
	          "833": { value: 1, edited: true }
	        }
	      },
	      "haiku:Page-1-db53375093b5cfb6": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:A-7b799984cea8de28": {
	        d:
	          "M43.9144189,58.3374536 L40.4452654,48.0679852 L18.8043554,48.0679852 L15.3352019,58.3374536 L0.55,58.3374536 L21.5301189,0.199011125 L37.8846997,0.199011125 L58.8648186,58.3374536 L43.9144189,58.3374536 Z M36.8109141,37.1359703 L29.6248104,15.8516687 L22.5213056,37.1359703 L36.8109141,37.1359703 Z",
	        fill: {
	          "0": {
	            value: Haiku.inject(function(fgColor) {
	              return fgColor;
	            }, "fgColor"),
	            edited: true
	          }
	        },
	        fillRule: "nonzero"
	      },
	      "haiku:N-016521ebe7058254": {
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 47,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeAbsolute.y": 48,
	        "translation.x": 234.073,
	        "translation.y": 63.428,
	        "style.zIndex": { "0": { value: 6, edited: true } },
	        opacity: {
	          "0": { value: 0, edited: true },
	          "700": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "800": { value: 1, edited: true }
	        },
	        "scale.x": {
	          "0": { value: 1, edited: true },
	          "700": { value: 0.2, edited: true, curve: "easeOutBack" },
	          "800": { value: 1, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 1, edited: true },
	          "700": { value: 0.2, edited: true, curve: "linear" },
	          "800": { value: 1, edited: true }
	        }
	      },
	      "haiku:Page-1-0af6ab7808ab18ba": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:N-df271b68bc42b356": {
	        d:
	          "M32.0255073,47.3374536 L32.0255073,22.2435105 C32.0255073,15.9493201 28.5563538,12.4709518 23.1874257,12.4709518 C17.8184976,12.4709518 14.3493441,15.9493201 14.3493441,22.2435105 L14.3493441,47.3374536 L0.224933388,47.3374536 L0.224933388,1.12484549 L14.3493441,1.12484549 L14.3493441,7.25339926 C17.1577065,3.36093943 22.1136401,0.627935723 28.3085571,0.627935723 C38.9638143,0.627935723 46.0673191,7.91594561 46.0673191,20.3386897 L46.0673191,47.3374536 L32.0255073,47.3374536 Z",
	        fill: {
	          "0": {
	            value: Haiku.inject(function(fgColor) {
	              return fgColor;
	            }, "fgColor"),
	            edited: true
	          }
	        },
	        fillRule: "nonzero"
	      },
	      "haiku:I-cc1df529da5abb84": {
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 18,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeAbsolute.y": 67,
	        "translation.x": 273.736,
	        "translation.y": 53.572,
	        "style.zIndex": { "0": { value: 7, edited: true } },
	        opacity: {
	          "0": { value: 0, edited: true },
	          "667": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "783": { value: 1, edited: true }
	        },
	        "scale.x": {
	          "0": { value: 1, edited: true },
	          "667": { value: 0.2, edited: true, curve: "easeOutBack" },
	          "783": { value: 1, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 1, edited: true },
	          "667": { value: 0.2, edited: true, curve: "linear" },
	          "783": { value: 1, edited: true }
	        }
	      },
	      "haiku:Page-1-20a5c9ba7850082f": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:I-a9d6c79e21286a54": {
	        d:
	          "M1.89658742,66.3374536 L1.89658742,20.1248455 L16.0209982,20.1248455 L16.0209982,66.3374536 L1.89658742,66.3374536 Z M9.00009223,15.3213844 C3.96155975,15.3213844 0.575005124,11.9258344 0.575005124,7.70210136 C0.575005124,3.39555006 3.96155975,-5.32907052e-15 9.00009223,-5.32907052e-15 C13.9560258,-5.32907052e-15 17.3425804,3.39555006 17.3425804,7.70210136 C17.3425804,11.9258344 13.9560258,15.3213844 9.00009223,15.3213844 Z",
	        fill: {
	          "0": {
	            value: Haiku.inject(function(fgColor) {
	              return fgColor;
	            }, "fgColor"),
	            edited: true
	          }
	        },
	        fillRule: "nonzero"
	      },
	      "haiku:M-d3ac45be249f7398": {
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 78,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeAbsolute.y": 48,
	        "translation.x": 329.734,
	        "translation.y": 62.476,
	        "style.zIndex": { "0": { value: 8, edited: true } },
	        opacity: {
	          "0": { value: 0, edited: true },
	          "650": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "767": { value: 1, edited: true }
	        },
	        "scale.x": {
	          "0": { value: 1, edited: true },
	          "650": { value: 0.2, edited: true, curve: "easeOutBack" },
	          "767": { value: 1, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 1, edited: true },
	          "650": { value: 0.2, edited: true, curve: "linear" },
	          "767": { value: 1, edited: true }
	        }
	      },
	      "haiku:Page-1-98d5a353471c86f6": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:M-9717c88649b34a47": {
	        d:
	          "M63.7818098,47.3374536 L63.7818098,22.2435105 C63.7818098,16.197775 60.3126563,12.8850433 54.9437282,12.8850433 C49.5748002,12.8850433 46.1056466,16.197775 46.1056466,22.2435105 L46.1056466,47.3374536 L32.0638348,47.3374536 L32.0638348,22.2435105 C32.0638348,16.197775 28.5946813,12.8850433 23.2257532,12.8850433 C17.8568252,12.8850433 14.3876717,16.197775 14.3876717,22.2435105 L14.3876717,47.3374536 L0.263260914,47.3374536 L0.263260914,1.12484549 L14.3876717,1.12484549 L14.3876717,6.92212608 C17.1134351,3.19530284 21.821572,0.627935723 27.8512912,0.627935723 C34.7895983,0.627935723 40.406323,3.69221261 43.545081,9.24103832 C46.60124,4.35475896 52.3831625,0.627935723 59.0736729,0.627935723 C70.4723201,0.627935723 77.8236216,7.91594561 77.8236216,20.3386897 L77.8236216,47.3374536 L63.7818098,47.3374536 Z",
	        fill: {
	          "0": {
	            value: Haiku.inject(function(fgColor) {
	              return fgColor;
	            }, "fgColor"),
	            edited: true
	          }
	        },
	        fillRule: "nonzero"
	      },
	      "haiku:A-Minus-02c01a1208ad7ada": {
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 50,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeAbsolute.y": 48,
	        "translation.x": 401,
	        "translation.y": 62.522003173828125,
	        "style.zIndex": { "0": { value: 9, edited: true } },
	        opacity: {
	          "0": { value: 0, edited: true },
	          "633": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "733": { value: 1, edited: true }
	        },
	        "scale.x": {
	          "0": { value: 1, edited: true },
	          "633": { value: 0.2, edited: true, curve: "easeOutBack" },
	          "733": { value: 1, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 1, edited: true },
	          "633": { value: 0.2, edited: true, curve: "linear" },
	          "733": { value: 1, edited: true }
	        }
	      },
	      "haiku:Page-1-23d1396f42ac176b": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:A-Minus-53a8d74d102c7605": {
	        d:
	          "M0.92712646,24.1483313 C0.92712646,9.5723115 9.93040582,0.462299135 21.2464542,0.462299135 C28.1021623,0.462299135 32.975497,3.60939431 35.4534638,7.66749073 L35.4534638,1.12484549 L49.5778746,1.12484549 L49.5778746,47.3374536 L35.4534638,47.3374536 L35.4534638,40.7948084 C32.8928981,44.8529048 28.0195634,48 21.1638553,48 C9.93040582,48 0.92712646,38.7243511 0.92712646,24.1483313 Z M35.4534638,24.2311496 C35.4534638,16.8603214 30.7453269,12.802225 25.3763989,12.802225 C20.0900697,12.802225 15.2993339,16.7775031 15.2993339,24.1483313 C15.2993339,31.5191595 20.0900697,35.6600742 25.3763989,35.6600742 C30.7453269,35.6600742 35.4534638,31.6019778 35.4534638,24.2311496 Z",
	        fill: {
	          "0": {
	            value: Haiku.inject(function(fgColor) {
	              return fgColor;
	            }, "fgColor"),
	            edited: true
	          }
	        },
	        fillRule: "nonzero"
	      },
	      "haiku:T-ea14c5fbc8e7d36a": {
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 30,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeAbsolute.y": 59,
	        "translation.x": 445.917,
	        "translation.y": 57.381,
	        "style.zIndex": { "0": { value: 10, edited: true } },
	        opacity: {
	          "0": { value: 0, edited: true },
	          "550": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "650": { value: 1, edited: true }
	        },
	        "scale.x": {
	          "0": { value: 1, edited: true },
	          "550": { value: 0.2, edited: true, curve: "easeOutBack" },
	          "650": { value: 1, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 1, edited: true },
	          "550": { value: 0.2, edited: true, curve: "linear" },
	          "650": { value: 1, edited: true }
	        }
	      },
	      "haiku:Page-1-ffe2dea8e392c87d": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:T-845f4049f64732ee": {
	        d:
	          "M6.05030744,42.2707046 L6.05030744,23.8850433 L0.433582701,23.8850433 L0.433582701,12.1248455 L6.05030744,12.1248455 L6.05030744,0.861557478 L20.1747182,0.861557478 L20.1747182,12.1248455 L29.4257942,12.1248455 L29.4257942,23.8850433 L20.1747182,23.8850433 L20.1747182,42.4363412 C20.1747182,45.1693449 21.3311027,46.328801 24.4698606,46.328801 L29.5083931,46.328801 L29.5083931,58.3374536 L22.3222894,58.3374536 C12.7408178,58.3374536 6.05030744,54.2793572 6.05030744,42.2707046 Z",
	        fill: {
	          "0": {
	            value: Haiku.inject(function(fgColor) {
	              return fgColor;
	            }, "fgColor"),
	            edited: true
	          }
	        },
	        fillRule: "nonzero"
	      },
	      "haiku:O-5001e192f84a5f10": {
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 49,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeAbsolute.y": 48,
	        "translation.x": 488.772,
	        "translation.y": 62.333,
	        "style.zIndex": { "0": { value: 11, edited: true } },
	        opacity: {
	          "0": { value: 0, edited: true },
	          "483": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "583": { value: 1, edited: true }
	        },
	        "scale.x": {
	          "0": { value: 1, edited: true },
	          "483": { value: 0.2, edited: true, curve: "easeOutBack" },
	          "583": { value: 1, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 1, edited: true },
	          "483": { value: 0.2, edited: true, curve: "linear" },
	          "583": { value: 1, edited: true }
	        }
	      },
	      "haiku:Page-1-645384bc23013106": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:O-6f0a6cdca12f0d72": {
	        d:
	          "M48.4542837,24.2311496 C48.4542837,38.8899876 37.8816253,48 24.3354068,48 C10.7891884,48 0.5469256,38.8899876 0.5469256,24.2311496 C0.5469256,9.5723115 11.036985,0.462299135 24.5006046,0.462299135 C38.0468231,0.462299135 48.4542837,9.5723115 48.4542837,24.2311496 Z M14.919133,24.2311496 C14.919133,32.0160692 19.2142755,35.7428925 24.3354068,35.7428925 C29.3739393,35.7428925 34.0820762,32.0160692 34.0820762,24.2311496 C34.0820762,16.3634116 29.4565382,12.7194067 24.5006046,12.7194067 C19.3794733,12.7194067 14.919133,16.3634116 14.919133,24.2311496 Z",
	        fill: {
	          "0": {
	            value: Haiku.inject(function(fgColor) {
	              return fgColor;
	            }, "fgColor"),
	            edited: true
	          }
	        },
	        fillRule: "nonzero"
	      },
	      "haiku:R-786a3cdbf18d78b4": {
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 30,
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "sizeAbsolute.y": 48,
	        "translation.x": 534.198,
	        "translation.y": 62.285,
	        "style.zIndex": { "0": { value: 12, edited: true } },
	        opacity: {
	          "0": { value: 0, edited: true },
	          "433": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "533": { value: 1, edited: true }
	        },
	        "scale.x": {
	          "0": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "433": { value: 0.5, curve: "easeOutBack", edited: true },
	          "533": { value: 1, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "433": { value: 0.5, curve: "linear", edited: true },
	          "533": { value: 1, edited: true }
	        }
	      },
	      "haiku:Page-1-3fdbc356cdcb9e39": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:R-06efdfe2ab4f76a3": {
	        d:
	          "M15.0951937,25.8875155 L15.0951937,47.3374536 L0.970782947,47.3374536 L0.970782947,1.12484549 L15.0951937,1.12484549 L15.0951937,8.82694685 C18.3165505,3.94066749 23.355083,0.627935723 29.55,0.627935723 L29.55,15.618047 L25.667852,15.618047 C18.9773417,15.618047 15.0951937,17.9369592 15.0951937,25.8875155 Z",
	        fill: {
	          "0": {
	            value: Haiku.inject(function(fgColor) {
	              return fgColor;
	            }, "fgColor"),
	            edited: true
	          }
	        },
	        fillRule: "nonzero"
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "R-786a3cdbf18d78b4",
	          "haiku-title": "R",
	          "haiku-source": "designs/animator.sketch.contents/slices/R.svg#lock"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-3fdbc356cdcb9e39", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "R-06efdfe2ab4f76a3", id: "R" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "O-5001e192f84a5f10",
	          "haiku-title": "O",
	          "haiku-source": "designs/animator.sketch.contents/slices/O.svg#lock"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-645384bc23013106", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "O-6f0a6cdca12f0d72", id: "O" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "T-ea14c5fbc8e7d36a",
	          "haiku-title": "T",
	          "haiku-source": "designs/animator.sketch.contents/slices/T.svg#lock"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-ffe2dea8e392c87d", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "T-845f4049f64732ee", id: "T" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "A-Minus-02c01a1208ad7ada",
	          "haiku-title": "a-minus",
	          "haiku-source":
	            "designs/animator.sketch.contents/slices/a-minus.svg#lock"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-23d1396f42ac176b", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: {
	                  "haiku-id": "A-Minus-53a8d74d102c7605",
	                  id: "a-minus"
	                },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "M-d3ac45be249f7398",
	          "haiku-title": "M",
	          "haiku-source": "designs/animator.sketch.contents/slices/M.svg#lock"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-98d5a353471c86f6", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "M-9717c88649b34a47", id: "M" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "I-cc1df529da5abb84",
	          "haiku-title": "I",
	          "haiku-source": "designs/animator.sketch.contents/slices/I.svg#lock"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-20a5c9ba7850082f", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "I-a9d6c79e21286a54", id: "I" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "N-016521ebe7058254",
	          "haiku-title": "N",
	          "haiku-source": "designs/animator.sketch.contents/slices/N.svg#lock"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-0af6ab7808ab18ba", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "N-df271b68bc42b356", id: "N" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "A-60a7b6cff49ddbcd",
	          "haiku-title": "A",
	          "haiku-source": "designs/animator.sketch.contents/slices/A.svg#lock"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-db53375093b5cfb6", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "A-7b799984cea8de28", id: "A" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "By-Haiku-Copy-35944b0a063252e8",
	          "haiku-title": "byHaiku® Copy",
	          "haiku-source":
	            "designs/animator.sketch.contents/slices/byHaiku® Copy.svg#lock"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-8231b9d094ee1082", id: "Page-1" },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "Full-Group-8927369bb14bff2f",
	                  id: "FullGroup"
	                },
	                children: [
	                  {
	                    elementName: "path",
	                    attributes: {
	                      "haiku-id": "By-Haiku-Copy-57a5aa462a0d761b",
	                      id: "byHaiku®-Copy"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Full-Group-086e4bed4e4c459c",
	          "haiku-title": "FullGroup",
	          "haiku-source":
	            "designs/animator.sketch.contents/slices/FullGroup.svg",
	          "haiku-locked": true
	        },
	        children: [
	          {
	            elementName: "defs",
	            attributes: { "haiku-id": "Defs-57cbc94dd7438378" },
	            children: [
	              {
	                elementName: "linearGradient",
	                attributes: {
	                  "haiku-id": "Linear-Gradient-1-176eee-23a6b10f96a0babb",
	                  id: "linearGradient-1-176eee"
	                },
	                children: [
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-934c92bd402c280e" },
	                    children: []
	                  },
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-bed321f8d0b812fd" },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-82f29448178d578a", id: "Page-1" },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "Full-Group-37c9aede0f61e809",
	                  id: "FullGroup"
	                },
	                children: [
	                  {
	                    elementName: "path",
	                    attributes: {
	                      "haiku-id": "Animator-Copy-70d065c90ce41146",
	                      id: "Animator-Copy"
	                    },
	                    children: []
	                  },
	                  {
	                    elementName: "path",
	                    attributes: {
	                      "haiku-id": "By-Haiku-Copy-c0ce72c9dbe76d77",
	                      id: "byHaiku®-Copy"
	                    },
	                    children: []
	                  },
	                  {
	                    elementName: "path",
	                    attributes: {
	                      "haiku-id": "Symbol-Copy-919a79d121aeac69",
	                      id: "symbol-copy"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Diamond-Copy-32-012380ac5456526a",
	          "haiku-title": "HeroDiam",
	          "haiku-source":
	            "designs/animator.sketch.contents/slices/Diamond Copy 32.svg#lock"
	        },
	        children: [
	          {
	            elementName: "defs",
	            attributes: { "haiku-id": "Defs-e264f8021e5a187d" },
	            children: [
	              {
	                elementName: "linearGradient",
	                attributes: {
	                  "haiku-id": "Linear-Gradient-1-13dfc6-38d7a30a8ef0258a",
	                  id: "linearGradient-1-13dfc6"
	                },
	                children: [
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-988850c829312872" },
	                    children: []
	                  },
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-bb8bcc406964d868" },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-a697b632a22d76c8", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: {
	                  "haiku-id": "Diamond-Copy-32-89844bd46ba48c4f",
	                  id: "Diamond-Copy-32"
	                },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-2-af1a6cd5d22c7ebf",
	          "haiku-title": "Little Tri",
	          "haiku-source":
	            "designs/animator.sketch.contents/slices/Path 2.svg#lock"
	        },
	        children: [
	          {
	            elementName: "defs",
	            attributes: { "haiku-id": "Defs-f06a28a08f2d458d" },
	            children: [
	              {
	                elementName: "linearGradient",
	                attributes: {
	                  "haiku-id": "Linear-Gradient-1-A2f1bf-dd579bf2bb55ca45",
	                  id: "linearGradient-1-a2f1bf"
	                },
	                children: [
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-490ca8708059018e" },
	                    children: []
	                  },
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-bd5d9c00639d63bb" },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-d0721883a5cc8b0d", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: {
	                  "haiku-id": "Path-2-7a635180adee9604",
	                  id: "Path-2"
	                },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-2-dfa4f1f6cca73d4f",
	          "haiku-title": "Big Tri",
	          "haiku-source":
	            "designs/animator.sketch.contents/slices/Path 2.svg#lock"
	        },
	        children: [
	          {
	            elementName: "defs",
	            attributes: { "haiku-id": "Defs-10ae01dfbebcc0af" },
	            children: [
	              {
	                elementName: "linearGradient",
	                attributes: {
	                  "haiku-id": "Linear-Gradient-1-2db749-95a3f9579dad9a19",
	                  id: "linearGradient-1-2db749"
	                },
	                children: [
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-cdeb99092b9623d8" },
	                    children: []
	                  },
	                  {
	                    elementName: "stop",
	                    attributes: { "haiku-id": "Stop-c0421130149019d6" },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-9fa83a73d34094a2", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: {
	                  "haiku-id": "Path-2-c91fc96c9ea04b29",
	                  id: "Path-2"
	                },
	                children: []
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var HaikuDOMAdapter = __webpack_require__(38)
	module.exports = HaikuDOMAdapter(__webpack_require__(470))

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1) // Installed as a peer dependency of '@haiku/core'
	var ReactDOM = __webpack_require__(21) // Installed as a peer dependency of '@haiku/core'
	var HaikuReactAdapter = __webpack_require__(39)
	var HaikuReactComponent = HaikuReactAdapter(__webpack_require__(471))
	if (HaikuReactComponent.default) HaikuReactComponent = HaikuReactComponent.default
	module.exports = HaikuReactComponent

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	// By default, a react-dom module is exported; see code/main/* for other options
	module.exports = __webpack_require__(472)

/***/ }),
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shibui = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoMuted = {
	  fontStyle: 'italic',
	  height: 24,
	  maxWidth: 90,
	  opacity: .93,
	  fill: _shibui.colors.graphite.color,
	  margin: _shibui.spacing.sm + 'px ' + _shibui.spacing.md + 'px'
	};
	
	var logoMutedSquash = _extends({}, logoMuted, {
	  height: 20
	});
	
	var logoMutedStretch = _extends({}, logoMuted, {
	  height: 30
	});
	
	var benzStyle = _extends({}, logoMutedStretch, {
	  transform: "scale(1.4,1.4)"
	});
	
	var tripAdvisorStyle = _extends({}, logoMuted, {
	  transform: "scale(1.2, 1.2)"
	});
	
	var googleStyle = _extends({}, logoMuted, {
	  transform: "scale(1.1, 1.1)"
	});
	
	var legoStyle = _extends({}, logoMuted, {
	  opacity: 1,
	  fill: _shibui.colors.midnight.color,
	  transform: "scale(1.3, 1.3)"
	});
	
	var uberStyle = _extends({}, logoMutedSquash, {
	  transform: "scale(1.1, 1.1)"
	});
	
	var deloitteStyle = _extends({}, logoMuted, {
	  transform: "scale(1.1, 1.1)"
	});
	
	var mozillaStyle = _extends({}, logoMuted, {
	  transform: "scale(1.1, 1.1)"
	});
	
	var panasonicStyle = _extends({}, logoMuted, {
	  transform: "scale(1.1, 1.1)"
	});
	
	exports.default = {
	  GoogleSVG: function GoogleSVG() {
	    return _react2.default.createElement(
	      'svg',
	      { preserveAspectRatio: 'xMidYMid meet', style: googleStyle, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1000 327.884', id: 'google' },
	      _react2.default.createElement(
	        'g',
	        { id: 'layer1', transform: 'translate(-39.48794 -564.24099)' },
	        _react2.default.createElement('path', { d: 'M285.33912 680.03339H168.65035v34.62575h82.75554c-4.08825 48.55459-44.48413 69.26112-82.61562 69.26112-48.78524 0-91.35506-38.38403-91.35506-92.18436 0-52.40919 40.58019-92.77184 91.46282-92.77184 39.25646 0 62.38837 25.02538 62.38837 25.02538l24.24418-25.1062s-31.11802-34.64225-87.8717-34.64225c-72.262208 0-128.17094 60.99521-128.17094 126.87791 0 64.55746 52.59191 127.51095 130.01618 127.51095 68.09897 0 117.94797-46.65049 117.94797-115.6313 0-14.55366-2.11297-22.96516-2.11297-22.96516z', id: 'path2998' }),
	        _react2.default.createElement('path', { d: 'M380.92783 654.96024c-47.87965 0-82.19287 37.432-82.19287 81.08918 0 44.30267 33.28186 82.43092 82.75555 82.43092 44.78711 0 81.47872-34.23163 81.47872-81.47871 0-54.15184-42.68088-82.04139-82.0414-82.04139zm.47611 32.11538c23.54601 0 45.85748 19.03561 45.85748 49.70959 0 30.02326-22.21768 49.6014-45.96569 49.6014-26.09444 0-46.67983-20.89895-46.67983-49.83944 0-28.31984 20.33014-49.47155 46.78804-49.47155z', id: 'path3000' }),
	        _react2.default.createElement('path', { id: 'path3005', d: 'M559.69307 654.96024c-47.87967 0-82.19288 37.432-82.19288 81.08918 0 44.30267 33.28186 82.43092 82.75554 82.43092 44.78711 0 81.47872-34.23163 81.47872-81.47871 0-54.15184-42.68088-82.04139-82.04138-82.04139zm.47609 32.11538c23.54601 0 45.85748 19.03561 45.85748 49.70959 0 30.02326-22.21767 49.6014-45.96568 49.6014-26.09445 0-46.67984-20.89895-46.67984-49.83944 0-28.31984 20.33014-49.47155 46.78804-49.47155z' }),
	        _react2.default.createElement('path', { d: 'M735.01946 655.0468c-43.94828 0-78.49229 38.49196-78.49229 81.69513 0 49.21244 40.04888 81.84662 77.73481 81.84662 23.30231 0 35.69293-9.24978 44.84035-19.86653v16.12263c0 28.20833-17.12762 45.10003-42.97921 45.10003-24.97403 0-37.50084-18.5699-41.85387-29.10727l-31.42288 13.13615c11.14765 23.57012 33.58732 48.15143 73.53644 48.15143 43.69521 0 76.99901-27.52286 76.99901-85.24427V659.95933h-34.27949v13.8503c-10.53301-11.35731-24.94639-18.76283-44.08287-18.76283zm3.1812 32.05046c21.54699 0 43.67173 18.39795 43.67173 49.8178 0 31.93555-22.07758 49.53646-44.14783 49.53646-23.42973 0-45.22989-19.02445-45.22989-49.23348 0-31.38989 22.64151-50.12078 45.70599-50.12078z', id: 'path3007' }),
	        _react2.default.createElement('path', { d: 'M965.80009 654.85203c-41.45582 0-76.26322 32.98281-76.26322 81.65185 0 51.49823 38.79822 82.04139 80.24518 82.04139 34.59275 0 55.82405-18.92471 68.49405-35.88094l-28.2633-18.8061c-7.3342 11.382-19.59519 22.50674-40.05763 22.50674-22.98519 0-33.55352-12.58609-40.10098-24.77906l109.63371-45.48959-5.6916-13.33091c-10.5953-26.10703-35.3032-47.91338-67.99621-47.91338zm1.42824 31.44451c14.93818 0 25.68878 7.94215 30.25432 17.46437l-73.21185 30.6005c-3.15635-23.69118 19.28786-48.06487 42.95753-48.06487z', id: 'path3011' }),
	        _react2.default.createElement('path', { d: 'M837.2736 813.68879h36.01078V572.69356H837.2736z', id: 'path3015' })
	      )
	    );
	  },
	  TripAdvisorSVG: function TripAdvisorSVG() {
	    return _react2.default.createElement(
	      'svg',
	      { style: tripAdvisorStyle, id: 'Layer_2', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 512.2 320.2' },
	      _react2.default.createElement('path', { d: 'M128.2 127.9C92.7 127.9 64 156.6 64 192c0 35.4 28.7 64.1 64.1 64.1 35.4 0 64.1-28.7 64.1-64.1.1-35.4-28.6-64.1-64-64.1zm0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S174 166.7 174 192s-20.5 45.9-45.8 45.9z' }),
	      _react2.default.createElement('circle', { cx: '128.4', cy: '191.9', r: '31.9' }),
	      _react2.default.createElement('path', { d: 'M384.2 127.9c-35.4 0-64.1 28.7-64.1 64.1 0 35.4 28.7 64.1 64.1 64.1 35.4 0 64.1-28.7 64.1-64.1 0-35.4-28.7-64.1-64.1-64.1zm0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S430 166.7 430 192s-20.5 45.9-45.8 45.9z' }),
	      _react2.default.createElement('circle', { cx: '384.4', cy: '191.9', r: '31.9' }),
	      _react2.default.createElement('path', { d: 'M474.4 101.2l37.7-37.4h-76.4C392.9 29 321.8 0 255.9 0c-66 0-136.5 29-179.3 63.8H0l37.7 37.4C14.4 124.4 0 156.5 0 192c0 70.8 57.4 128.2 128.2 128.2 32.5 0 62.2-12.1 84.8-32.1l43.4 31.9 42.9-31.2-.5-1.2c22.7 20.2 52.5 32.5 85.3 32.5 70.8 0 128.2-57.4 128.2-128.2-.1-35.4-14.6-67.5-37.9-90.7zM368 64.8c-60.7 7.6-108.3 57.6-111.9 119.5-3.7-62-51.4-112.1-112.3-119.5 30.6-22 69.6-32.8 112.1-32.8S337.4 42.8 368 64.8zM128.2 288.2C75 288.2 32 245.1 32 192s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2zm256 0c-53.1 0-96.2-43.1-96.2-96.2s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2z' })
	    );
	  },
	  BenzSVG: function BenzSVG() {
	    return _react2.default.createElement(
	      'svg',
	      { style: benzStyle, xmlns: 'http://www.w3.org/2000/svg', version: '1', viewBox: '0 0 80 80', id: 'svg3544' },
	      _react2.default.createElement(
	        'g',
	        { id: 'layer1' },
	        _react2.default.createElement('path', { d: 'M57.63597 6.309c12.099 6.363 20.364 19.049 20.364 33.672 0 14.623-8.265 27.349-20.364 33.673v-4.348c4.627-2.768 8.541-6.641 11.389-11.225l-11.389-4.623v-7.035l12.495 9.762c2.61-4.822 4.073-10.316 4.073-16.205 0-12.41-6.644-23.317-16.568-29.325V6.309zM40.04 2.001c6.327 0 12.29697 1.542 17.59597 4.308v4.348C52.77197 7.731 47.078 5.993 41.068 5.795l4.349 31.104 12.21897 9.525v7.035L39.96 46.305l-17.557 7.193v-6.996l12.298-9.604 4.31-31.104c-6.09.198-11.744 1.937-16.608 4.861V6.309c5.26-2.766 11.27-4.308 17.637-4.308zm17.59597 71.653C52.33697 76.42 46.366 78 40.04 78c-6.366 0-12.376-1.58-17.636-4.307v-4.387c5.141 3.121 11.19 4.9 17.636 4.9 6.406 0 12.41697-1.779 17.59597-4.9v4.348zm-35.23197.039C10.264 67.33 2 54.604 2 39.981c0-14.623 8.264-27.309 20.404-33.672v4.348C12.439 16.664 5.796 27.532 5.796 39.981c0 5.888 1.503 11.462 4.113 16.283l12.495-9.762v6.996L11.055 58.16c2.847 4.547 6.722 8.379 11.349 11.146v4.387z', id: 'path3524', fill: _shibui.colors.graphite.color, fillRule: 'evenodd' })
	      )
	    );
	  },
	  LegoSVG: function LegoSVG() {
	    return _react2.default.createElement(
	      'svg',
	      { style: legoStyle, viewBox: '0 0 134 62', xmlns: 'http://www.w3.org/2000/svg' },
	      _react2.default.createElement(
	        'g',
	        { id: 'v6-(Animator-launch-Mar-\'19)', fill: 'none', fillRule: 'evenodd' },
	        _react2.default.createElement(
	          'g',
	          { id: 'Homepage---Look-and-feel', transform: 'translate(-1132 -6400)' },
	          _react2.default.createElement(
	            'g',
	            { id: 'lego-copy', transform: 'translate(1132 6400)' },
	            _react2.default.createElement(
	              'g',
	              { id: 'Path-+-Shape-+-Shape-+-Shape-+-Shape-Mask' },
	              _react2.default.createElement(
	                'mask',
	                { id: 'mask-2', fill: _shibui.colors.tiger50.color },
	                _react2.default.createElement('path', { id: 'path-1393939', d: 'M0 0h134v62H0z' })
	              ),
	              _react2.default.createElement('path', { id: 'Path', fill: '#ffffff00', mask: 'url(#mask-2)', d: 'M-4-38.05v139.84h139.8V-38.05z' }),
	              _react2.default.createElement('path', { d: 'M-4-38.05v139.84h139.8V-38.05H-4zm130.5 58.13a56.0599855 56.0599855 0 0 1-2.84 13.41C118.74 48.1 113 57.15 99.84 57.15c-3.89 0-10.78-1-13.32-7.95l-.6-1.64-1.08 1.37c-4.0470525 5.1970786-10.2531319 8.2522091-16.84 8.29-5 0-9.09-1.66-11.71-4.88l-.72-.88-.76.84c-2.8 3.09-7.67 4.86-13.36 4.86-4.0666105.1634686-8.0147102-1.3896442-10.88-4.28l-.69-.75-.72.73c-2.83 2.84-7.28 4.28-12.88 4.14-6.79-.16-10.92-4-11.06-10.14-.2-9.54 9-29.62 12.85-35.73 2.48-4.08 5.9-6.06 10.44-6.06 3.09 0 5.21.65 6.46 2s1.37 2.23 1.47 4.69l.13 3.17 1.68-2.7C42.3 5.7 49.02 4.8 55.68 4.8c4.63 0 8.67 1.7 10.29 4.34l.6 1 .87-.74c3.8710406-3.0614966 8.6966832-4.661783 13.63-4.52 5.85 0 10.1 1.45 12.63 4.32a8.0000003 8.0000003 0 0 1 1.49 2.22l.65 1.37 1-1.15C100.53 7.2 105.6 5 111.89 5c5 0 8.76 1.32 11.23 3.94 3.11 3.25 3.55 7.85 3.38 11.14z', id: 'Shape', fill: 'transparent', fillRule: 'nonzero', mask: 'url(#mask-2)' }),
	              _react2.default.createElement('path', { d: 'M-4-38.05v139.84h139.8V-38.05H-4zm134.43 63.49c-.63 5.09-4.07 14.52-5.9 18.29-4.9 10.1-11.45 17.86-24.07 17.86-6.74 0-12.29-2.15-15.53-6.28-4.6913976 4.13666-10.7455458 6.3945011-17 6.34-4.4899311.1188775-8.8869855-1.291565-12.47-4-4.1298475 2.7241-8.9940933 4.1198664-13.94 4-4.2078323.0909951-8.3371282-1.1477937-11.8-3.54-3.53 2.34-8.15 3.51-13.58 3.38-9-.21-15.27-5.94-15.45-14.26C.5 36.14 9.8 15.91 14.19 8.91 17.1175317 3.7112553 22.6543184.5303848 28.62.62c6.66 0 9.08 1.9 10.27 4.33C44.03.58 50.89.33 55.7.33c5.36 0 8.72 1.42 11.57 3.7C71.4695819 1.5659061 76.2721451.3193864 81.14.43c6.9 0 12 1.6 15.6 5.14 4.17-3.47 9.39-5 15.23-5 7.72 0 12.81 2.79 15.79 6.94 4.24 5.8 3.45 11.7 2.67 17.93z', id: 'Shape', fill: 'transparent', fillRule: 'nonzero', mask: 'url(#mask-2)' }),
	              _react2.default.createElement('path', { d: 'M129.75 3.53v-1h.65c.48 0 .73.17.73.48 0 .31-.16.49-.65.49l-.73.03zm2.35 2l-.41-.71c-.35-.62-.45-.72-.76-.82.532667-.0266663.950667-.4666665.95-1 0-.56-.35-1-1.11-1H129v3.52h.73V4.09h.13c.31 0 .43 0 .58.18a3.2299952 3.2299952 0 0 1 .48.69l.28.58.9-.01zM130.37 1c1.105083-.004048 2.103605.6585226 2.52931 1.6783265.425704 1.019804.194612 2.195662-.58537 2.9785114-.779981.7828494-1.954984 1.0182553-2.976343.5962958C128.316238 5.8311742 127.650007 4.8350903 127.65 3.73c-.00001-1.5038407 1.216169-2.7244914 2.72-2.73zm0-.67c-1.877768 0-3.4 1.5222318-3.4 3.4s1.522232 3.4 3.4 3.4c1.877768 0 3.4-1.5222318 3.4-3.4-.016492-1.8644241-1.535511-3.365573-3.4-3.36V.33zM111.89 4c-7.32 0-12.39 2.9-15.81 7a9.0000009 9.0000009 0 0 0-1.64-2.45C91.63 5.38 87.13 3.9 81.08 3.9c-5.1659954-.1562906-10.2196215 1.52707-14.26 4.75-1.78-2.89-6-4.8-11.12-4.8-6.67 0-13.95.94-18.26 7.9-.1-2.5-.33-3.83-1.74-5.32-1.71-1.81-4.48-2.28-7.17-2.28-4.91 0-8.6 2.15-11.27 6.51C13.4 16.79 4 37.07 4.25 46.89c.14 6.34 4.39 10.92 12 11.1 6 .14 10.62-1.45 13.59-4.45 2.67 2.9 6.73 4.59 11.6 4.59 5.42 0 10.87-1.63 14.09-5.18 2.71 3.33 7 5.27 12.47 5.24 6.8796788-.0351227 13.3645027-3.2185817 17.6-8.64 2.26 6.15 8 8.59 14.24 8.59 13.71 0 19.73-9.43 24.75-24.33 1.519595-4.4210983 2.490201-9.0121636 2.89-13.67.41-7.85-2.91-16.14-15.59-16.14zM20.67 41.48c7.09-1.23 8.88 1.33 8.65 3.71-.67 7.11-7.19 8.7-12.85 8.57-4.11-.1-7.8-2-7.9-6.75-.18-8.34 8.33-27.64 12.33-34 1.85-3 4.1-4.54 7.7-4.54 3.41 0 4.25 1.75 4.2 3.84-.13 5.55-9.16 22.53-12.13 29.17zm23.1-6.55c-.47 1.27-1.36 3.93-2.08 6.75 2.2922132-.6661281 4.6737925-.9731022 7.06-.91 3.41.08 5.59 1.5 5.59 4.31 0 6.83-7.55 8.84-12.79 8.84-5.75 0-10.8-3.28-10.8-9.56 0-7.37 4-18.55 7.75-26C43.11 9.2 47.81 8 55.92 8c3.56 0 7.67 1.52 7.67 4.89 0 4.66-3.95 6.44-7.87 6.67a55.0000058 55.0000058 0 0 1-5.79.08 32.7199958 32.7199958 0 0 0-2.69 5.52c7.25-1 10.33.63 9.1 4.82-1.65 5.65-6.56 6.02-12.57 4.95zm35.67-17.64c-1.7468126.0924976-3.3278173 1.0636862-4.2 2.58-2.1 3-6.66 14.78-7.36 19.64-.49 3.33 1 4 2.52 4 2.52 0 5.35-2.67 6.31-7.06 0 0-4.8-.12-3.47-4.37C74.57 27.83 77 27.06 81 26.9c8-.32 7.18 5.55 6.54 8.69C85.46 45.77 78.22 53.94 68 53.94c-7 0-11.37-3.88-11.37-11 0-5.1 2.53-13.1 4.53-17.78 4.27-10 8.74-16.94 20.14-16.94 6.84 0 12.24 2.46 11.44 8.87-.58 4.7-2.93 7.47-7.21 7.8-1.2.09-6.09 0-4.47-4.66.55-1.67.78-2.94-1.62-2.94zm43.06 8.41c-1.395748 6.42643-3.705932 12.6194743-6.86 18.39-4.8 8.63-10.63 9.84-15.72 9.78-5.09-.06-10.84-1.93-10.92-9.79 0-5.64 2.4-13.6 4.47-18.82 3.6-9.46 7.28-17.17 18.9-17 13.63.14 11.18 12.2 10.13 17.45v-.01zM111 17.49c-1.260209-.1210003-2.472715.5146828-3.09 1.62-2.05 2.66-8 19-7.94 22.31-.0433139.5833733.16466 1.1574627.571562 1.5777375.406903.4202748.973969.6466967 1.558438.6222625 1.66 0 2.58-1.14 3.4-2.53 1.89-3.19 7.19-17.68 7.34-21.3.03-1.05-.15-2.28-1.84-2.3z', id: 'Shape', fill: _shibui.colors.midnight.color, fillRule: 'nonzero', mask: 'url(#mask-2)' })
	            )
	          )
	        )
	      )
	    );
	  },
	  DeloitteSVG: function DeloitteSVG() {
	    return _react2.default.createElement(
	      'svg',
	      { style: deloitteStyle, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 919.99995 200.00003', id: 'svg2' },
	      _react2.default.createElement(
	        'defs',
	        { id: 'defs4' },
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath3350' },
	          _react2.default.createElement('path', { id: 'path3352', d: 'M42.52 723.968h130.394v24.378H42.52v-24.378z' })
	        ),
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath3708' },
	          _react2.default.createElement('path', { id: 'path3710', d: 'M335.433 531.507h135v51.596h-135v-51.596z' })
	        ),
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath3862' },
	          _react2.default.createElement('path', { id: 'path3864', d: 'M335.433 476.232h135v51.565h-135v-51.565z' })
	        ),
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath3882' },
	          _react2.default.createElement('path', { id: 'path3884', d: 'M335.433 420.927h135v51.564h-135v-51.564z' })
	        ),
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath3936' },
	          _react2.default.createElement('path', { id: 'path3938', d: 'M335.433 365.621h135v51.564h-135v-51.564z' })
	        ),
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath3984' },
	          _react2.default.createElement('path', { id: 'path3986', d: 'M335.433 310.315h135v51.564h-135v-51.564z' })
	        ),
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath4038' },
	          _react2.default.createElement('path', { id: 'path4040', d: 'M335.433 255.01h135v51.564h-135V255.01z' })
	        ),
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath3350-9' },
	          _react2.default.createElement('path', { id: 'path3352-1', d: 'M42.52 723.968h130.394v24.378H42.52v-24.378z' })
	        )
	      ),
	      _react2.default.createElement(
	        'g',
	        { id: 'layer1', transform: 'translate(-2521.9698 -654.34261)' },
	        _react2.default.createElement(
	          'g',
	          { id: 'g3359', transform: 'matrix(3.06764 0 0 3.06764 -6165.655 -2195.369)' },
	          _react2.default.createElement(
	            'g',
	            { id: 'g3371', transform: 'matrix(1.77165 0 0 1.77165 -2301.0501 -745.37663)' },
	            _react2.default.createElement('path', { id: 'path3356', d: 'M3054.8273 974.3862c0-2.385 1.9363-4.32 4.32-4.32 2.385 0 4.3188 1.935 4.3188 4.32 0 2.385-1.9338 4.31875-4.3188 4.31875-2.3837 0-4.32-1.93375-4.32-4.31875', fill: _shibui.colors.ivory.color }),
	            _react2.default.createElement('path', { id: 'path3360', d: 'M2917.0546 962.94557c0-2.73625-.5287-4.76625-1.5862-6.08875-1.0588-1.32125-2.6626-1.98125-4.8188-1.98125h-2.2937v16.7325h1.755c2.395 0 4.15-.71 5.2675-2.135 1.1162-1.4225 1.6762-3.59875 1.6762-6.5275m8.18-.285c0 4.985-1.34 8.82625-4.02 11.5225-2.68 2.6975-6.4475 4.04625-11.3038 4.04625h-9.4362v-29.87125h10.095c4.6825 0 8.2975 1.22625 10.845 3.6775 2.5463 2.4525 3.82 5.9925 3.82 10.625', fill: _shibui.colors.graphite.color }),
	            _react2.default.createElement('path', { d: 'M2951.3731 978.22895h7.5087V948.2327h-7.5087v29.99625z', id: 'path3362', fill: _shibui.colors.graphite.color }),
	            _react2.default.createElement('path', { id: 'path3366', d: 'M2969.4302 967.0402c0 1.9125.25 3.37125.7488 4.37375.5 1.00375 1.3374 1.505 2.5149 1.505 1.165 0 1.9888-.50125 2.4688-1.505.48-1.0025.7187-2.46125.7187-4.37375 0-1.9025-.2425-3.3375-.7287-4.30625-.4875-.97125-1.3188-1.4575-2.4975-1.4575-1.1525 0-1.9762.48375-2.4762 1.44625-.4988.96375-.7488 2.4025-.7488 4.3175m14.0937 0c0 3.64375-.955 6.48625-2.87 8.52375-1.9137 2.03875-4.5925 3.05875-8.0362 3.05875-3.3025 0-5.9313-1.0425-7.8825-3.1275-1.9537-2.085-2.93-4.9025-2.93-8.455 0-3.6325.9563-6.455 2.8713-8.4675 1.9149-2.0125 4.5999-3.01875 8.0574-3.01875 2.1363 0 4.0263.46625 5.6638 1.3975 1.6387.93125 2.9038 2.265 3.7925 4.0025.89 1.735 1.3337 3.765 1.3337 6.08625', fill: _shibui.colors.graphite.color }),
	            _react2.default.createElement('path', { id: 'path3370', d: 'M2986.5059 978.22907h7.51v-22.28125h-7.51v22.28125z', fill: _shibui.colors.graphite.color }),
	            _react2.default.createElement('path', { d: 'M2986.5056 953.2527h7.51v-5.02125h-7.51v5.02125z', id: 'path3372', fill: _shibui.colors.graphite.color }),
	            _react2.default.createElement('path', { id: 'path3376', d: 'M3009.2307 972.54595c1.0138 0 2.2213-.2575 3.63-.76875v5.60625c-1.0125.445-1.975.76375-2.89.9525-.915.19125-1.9888.28625-3.2175.28625-2.5213 0-4.3387-.63375-5.455-1.89875-1.1112-1.265-1.6687-3.2075-1.6687-5.82875v-9.185h-2.63v-5.76h2.63v-5.69l7.5675-1.31625v7.00625h4.7912v5.76h-4.7912v8.6725c0 1.4425.6787 2.16375 2.0337 2.16375', fill: _shibui.colors.graphite.color }),
	            _react2.default.createElement('path', { id: 'path3380', d: 'M3026.6116 972.54595c1.0138 0 2.2213-.2575 3.63-.76875v5.60625c-1.0112.445-1.975.76375-2.89.9525-.9162.19125-1.9862.28625-3.2175.28625-2.5212 0-4.3387-.63375-5.4525-1.89875-1.1137-1.265-1.6712-3.2075-1.6712-5.82875v-9.185h-2.6313v-5.76h2.6313v-5.77625l7.5662-1.23v7.00625h4.7938v5.76h-4.7938v8.6725c0 1.4425.6788 2.16375 2.035 2.16375', fill: _shibui.colors.graphite.color }),
	            _react2.default.createElement('path', { id: 'path3384', d: 'M3039.7174 964.32582c.1025-1.22.4513-2.11375 1.0462-2.685.5976-.57 1.3351-.855 2.2176-.855.9625 0 1.7275.32 2.295.965.5712.64125.8687 1.5.8925 2.575h-6.4513zm10.59-6.145c-1.785-1.75-4.3175-2.62625-7.5937-2.62625-3.4438 0-6.0938 1.00625-7.9513 3.01875-1.8563 2.0125-2.785 4.9-2.785 8.6625 0 3.64375 1.0038 6.45375 3.0063 8.42625 2.0037 1.9725 4.8174 2.96 8.4412 2.96 1.74 0 3.2375-.11875 4.4925-.355 1.2475-.23375 2.455-.65625 3.6263-1.26625l-1.1538-5.02125c-.8512.3475-1.6612.615-2.4262.79125-1.105.25625-2.3175.385-3.6376.385-1.4474 0-2.5899-.35375-3.4274-1.06125-.8375-.70875-1.2838-1.68625-1.335-2.93125h13.4225v-3.42125c0-3.29125-.8926-5.8125-2.6788-7.56125', fill: _shibui.colors.graphite.color }),
	            _react2.default.createElement('path', { id: 'path3388', d: 'M2935.2007 964.32582c.1025-1.22.4513-2.11375 1.0462-2.685.5963-.57 1.335-.855 2.2188-.855.96 0 1.725.32 2.2938.965.5712.64125.8674 1.5.8937 2.575h-6.4525zm10.5912-6.145c-1.7862-1.75-4.3175-2.62625-7.5949-2.62625-3.4451 0-6.0938 1.00625-7.9501 3.01875-1.8562 2.0125-2.7862 4.9-2.7862 8.6625 0 3.64375 1.0025 6.45375 3.0075 8.42625 2.0025 1.9725 4.8162 2.96 8.44 2.96 1.74 0 3.2375-.11875 4.4925-.355 1.2475-.23375 2.455-.65625 3.6275-1.26625l-1.155-5.02125c-.8513.3475-1.6613.615-2.425.79125-1.1075.25625-2.3187.385-3.6388.385-1.4462 0-2.5899-.35375-3.4274-1.06125-.8388-.70875-1.2838-1.68625-1.335-2.93125h13.4225v-3.42125c0-3.29125-.8926-5.8125-2.6776-7.56125', fill: _shibui.colors.graphite.color })
	          )
	        )
	      )
	    );
	  },
	  MozillaSVG: function MozillaSVG() {
	    return _react2.default.createElement(
	      'svg',
	      { style: mozillaStyle, version: '1.1', id: 'Layer_1', xmlns: 'http://www.w3.org/2000/svg', x: '0px', y: '0px',
	        viewBox: '0 0 2000 571.9', enableBackground: 'new 0 0 2000 571.9;' },
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('rect', { y: '0', width: '2000', height: '571.9' }),
	        _react2.default.createElement('path', { fill: _shibui.colors.ivory.color, d: 'M1910.2,410.5c-3.9,1.1-7.2,1.7-10.5,1.7c-11.7,0-17.2-5-17.2-19.4V284.1c0-57.1-45.5-84.9-99.3-84.9 c-41.1,0-63.2,5-107.1,22.7l-9.8,57.6l57.1,6.1l8.1-28.2c11.7-6.1,23.3-7.2,38.3-7.2c40.5,0,41.1,30.5,41.1,56v8.3 c-12.8-1.7-27.2-2.2-41.1-2.2c-57.1,0-116.5,14.4-116.5,76c0,52.1,41,71.6,77.1,71.6c40.5,0,66-24.4,80.4-49.9 c3.3,30.5,21.6,49.9,54.9,49.9c15.5,0,31.6-4.4,44.9-11.7L1910.2,410.5z M1756.6,408.9c-21.6,0-29.4-12.8-29.4-28.9 c0-27.2,22.2-34.4,47.7-34.4c11.6,0,24.4,1.7,36.1,3.3C1809.3,390.6,1782.1,408.9,1756.6,408.9z M1660.5,72.7l-108.2,381.7h-70.5 L1590,72.7H1660.5z M1515.2,72.7L1407,454.4h-70.4l108.2-381.7H1515.2z M1214.8,204.2h74.9V294h-74.9V204.2z M1214.8,364.5h74.9 v89.9h-74.9V364.5z M1105.8,361.2l56.6,5.5l-15.5,87.7H928.3l-7.2-37.7l137.6-158.1h-78.2l-11.1,38.8l-51.6-5.6l8.9-87.7h219.7 l5.6,37.7L1013.2,400h81L1105.8,361.2z M747.3,199.2c-89.9,0-134.3,60.5-134.3,133.7c0,79.9,53.3,127,130.4,127 c79.9,0,137.6-50.5,137.6-130.4C881,259.6,837.1,199.2,747.3,199.2z M745.6,405c-38.8,0-58.8-33.3-58.8-76.6 c0-47.2,22.7-74.3,59.4-74.3c33.8,0,61,22.7,61,73.2C807.2,375,782.8,405,745.6,405z M548.6,400h33.3v54.4H477V313.5 c0-43.3-14.4-59.9-42.7-59.9c-34.4,0-48.3,24.4-48.3,59.4V400h33.3v54.4H314.5V313.5c0-43.3-14.4-59.9-42.7-59.9 c-34.4,0-48.3,24.4-48.3,59.4V400h47.7v54.4H118.7V400h33.3V258.5h-33.3v-54.4h104.8v37.7c15-26.6,41.1-42.7,76-42.7 c36.1,0,69.3,17.2,81.6,53.8c13.9-33.3,42.2-53.8,81.6-53.8c44.9,0,86,27.2,86,86.5V400z' })
	      )
	    );
	  },
	  PanasonicSVG: function PanasonicSVG() {
	    return _react2.default.createElement(
	      'svg',
	      { style: panasonicStyle, id: 'svg3336', xmlns: 'http://www.w3.org/2000/svg', height: '80.399', width: '504', version: '1.1', viewBox: '0 0 503.99998 80.399238' },
	      _react2.default.createElement(
	        'defs',
	        { id: 'defs3340' },
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath3536', clipPathUnits: 'userSpaceOnUse' },
	          _react2.default.createElement('path', { id: 'path3538', d: 'm283.61 700.16h166.16v-25.242h-166.16v25.242z' })
	        ),
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath3560', clipPathUnits: 'userSpaceOnUse' },
	          _react2.default.createElement('path', { id: 'path3562', d: 'm283.61 700.16h166.16v-25.242h-166.16v25.242z' })
	        ),
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath3580', clipPathUnits: 'userSpaceOnUse' },
	          _react2.default.createElement('path', { id: 'path3582', d: 'm283.61 700.16h166.16v-25.242h-166.16v25.242z' })
	        )
	      ),
	      _react2.default.createElement(
	        'g',
	        { id: 'g3344', fill: _shibui.colors.graphite.color, transform: 'matrix(1.25 0 0 -1.25 -352.51 1003.9)' },
	        _react2.default.createElement(
	          'g',
	          { id: 'g3532', transform: 'matrix(2.4328 0 0 2.4328 -406.36 -901.55)' },
	          _react2.default.createElement(
	            'g',
	            { id: 'g3534', fill: _shibui.colors.graphite.color, clipPath: 'url(#clipPath3536)' },
	            _react2.default.createElement(
	              'g',
	              { id: 'g3540', fill: _shibui.colors.graphite.color, transform: 'translate(446.22 677.78)' },
	              _react2.default.createElement('path', { id: 'path3542', d: 'm0 0c-1.324-1.392-2.825-2.222-4.708-2.601-1.271-0.257-2.384-0.311-3.676-0.177-1.712 0.176-3.125 0.726-4.503 1.757-1.127 0.84-1.934 1.749-2.639 2.967-0.544 0.943-0.861 1.825-1.037 2.899-0.247 1.49-0.182 2.801 0.21 4.258 0.896 3.314 3.389 5.663 6.749 6.362 1.919 0.399 3.625 0.358 5.522-0.132 1.351-0.349 2.424-0.937 3.446-1.888 0.645-0.598 1.103-1.199 1.509-1.977 0.481-0.92 0.675-1.814 0.62-2.85h-5.993c-0.13 0.803-0.515 1.443-1.162 1.935-0.838 0.639-1.919 0.69-2.815 0.136-0.612-0.381-1.014-0.899-1.231-1.586-0.516-1.637-0.539-3.16-0.079-4.813 0.196-0.695 0.525-1.24 1.051-1.736 0.599-0.572 1.346-0.807 2.166-0.686 0.508 0.074 0.921 0.296 1.263 0.681 0.359 0.397 0.564 0.823 0.658 1.35 0.066 0.371 0.103 0.685 0.123 1.061h6.318c0.126-1.905-0.478-3.578-1.792-4.96', fill: _shibui.colors.graphite.color })
	            )
	          )
	        ),
	        _react2.default.createElement('path', { id: 'path3544', d: 'm620.44 790.25h15.945v11.264h-15.945v-11.264z' }),
	        _react2.default.createElement('path', { id: 'path3546', d: 'm620.44 741.82h15.945v42.64h-15.945v-42.64z' }),
	        _react2.default.createElement(
	          'g',
	          { id: 'g3548', transform: 'matrix(2.4328 0 0 2.4328 587.41 779.96)' },
	          _react2.default.createElement('path', { id: 'path3550', d: 'm0 0c0.862 0.754 1.684 1.286 2.724 1.767 1.693 0.782 3.386 0.909 5.177 0.386 1.921-0.563 3.305-1.914 3.911-3.823 0.291-0.917 0.417-1.731 0.417-2.693v-11.312h-6.961v10.173c0 0.34-0.041 0.628-0.143 0.954-0.178 0.584-0.564 1.014-1.128 1.252-1.234 0.524-2.637 0.06-3.314-1.096-0.283-0.482-0.412-0.957-0.412-1.517v-9.766h-6.742v17.528h6.325l0.146-1.853', fill: _shibui.colors.graphite.color })
	        ),
	        _react2.default.createElement(
	          'g',
	          { id: 'g3552', transform: 'matrix(2.4328 0 0 2.4328 398.82 779.96)' },
	          _react2.default.createElement('path', { id: 'path3554', d: 'm0 0c0.862 0.754 1.684 1.286 2.722 1.767 1.694 0.782 3.388 0.909 5.178 0.386 1.922-0.563 3.306-1.914 3.912-3.823 0.291-0.917 0.417-1.731 0.417-2.693v-11.312h-6.961v10.173c0 0.34-0.043 0.628-0.142 0.954-0.18 0.584-0.566 1.014-1.131 1.252-1.233 0.524-2.636 0.06-3.312-1.096-0.284-0.482-0.413-0.957-0.413-1.517v-9.766h-6.741v17.528h6.324l0.147-1.853', fill: _shibui.colors.graphite.color })
	        ),
	        _react2.default.createElement(
	          'g',
	          { id: 'g3556', transform: 'matrix(2.4328 0 0 2.4328 -406.36 -901.55)' },
	          _react2.default.createElement(
	            'g',
	            { id: 'g3558', fill: _shibui.colors.graphite.color, clipPath: 'url(#clipPath3560)' },
	            _react2.default.createElement(
	              'g',
	              { id: 'g3564', fill: _shibui.colors.graphite.color, transform: 'translate(372.28 681.95)' },
	              _react2.default.createElement('path', { id: 'path3566', d: 'm0 0c0.502-0.085 0.922-0.19 1.404-0.351 0.403-0.132 0.68-0.444 0.768-0.857 0.096-0.451-0.031-0.879-0.355-1.204-0.329-0.333-0.704-0.525-1.166-0.597-0.618-0.099-1.166-0.048-1.755 0.166-0.285 0.102-0.511 0.231-0.745 0.424-0.301 0.254-0.495 0.545-0.612 0.921-0.098 0.319-0.137 0.601-0.131 0.935h-6.419v-0.374c0-0.604 0.094-1.116 0.306-1.681 0.322-0.85 0.763-1.507 1.429-2.127 0.869-0.813 1.776-1.32 2.919-1.647 2.373-0.676 4.51-0.81 6.949-0.436 1.144 0.175 2.088 0.483 3.117 1.016 0.453 0.235 0.816 0.478 1.207 0.806 1.734 1.456 2.377 3.678 1.684 5.833-0.262 0.812-0.676 1.438-1.321 1.998-0.884 0.766-1.779 1.254-2.903 1.582-0.246 0.071-0.456 0.131-0.704 0.199-1.375 0.382-2.556 0.634-3.968 0.844-0.378 0.056-0.696 0.117-1.069 0.204-0.172 0.041-0.315 0.089-0.475 0.162-0.395 0.178-0.57 0.643-0.392 1.037 0.01 0.021 0.019 0.04 0.03 0.06 0.212 0.379 0.526 0.626 0.94 0.747 0.733 0.212 1.408 0.194 2.127-0.051 0.69-0.235 1.123-0.868 1.093-1.597h6.185c-0.006 0.76-0.122 1.402-0.378 2.116-0.262 0.724-0.66 1.275-1.265 1.752-0.526 0.418-1.025 0.702-1.652 0.945-0.61 0.237-1.148 0.385-1.793 0.498-1.533 0.264-2.852 0.341-4.404 0.249-0.887-0.051-1.635-0.161-2.503-0.364-1.168-0.275-2.109-0.726-3.053-1.466-0.802-0.629-1.327-1.364-1.663-2.326-0.153-0.436-0.226-0.823-0.246-1.282-0.035-0.769 0.076-1.424 0.361-2.139 0.51-1.28 1.416-2.187 2.698-2.698 0.649-0.259 1.218-0.429 1.903-0.569 1.35-0.279 2.493-0.496 3.852-0.728', fill: _shibui.colors.graphite.color })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'g',
	          { id: 'g3568', transform: 'matrix(2.4328 0 0 2.4328 312.66 760.21)' },
	          _react2.default.createElement('path', { id: 'path3570', d: 'm0 0h-4.498v5.751h2.923c0.555 0 1.025 0.013 1.58 0.044 0.769 0.042 1.408 0.386 1.866 1.005 0.243 0.329 0.38 0.661 0.438 1.067 0.048 0.342 0.055 0.634 0.021 0.976-0.125 1.28-1.185 2.24-2.47 2.24h-4.358v-18.641h-7.446v24.538h12.171c0.484 0 0.893-0.009 1.376-0.036 3.229-0.173 5.889-1.966 7.257-4.896 0.712-1.525 0.954-2.991 0.771-4.665-0.386-3.524-2.851-6.265-6.314-7.024-1.148-0.252-2.142-0.359-3.317-0.359', fill: _shibui.colors.graphite.color })
	        ),
	        _react2.default.createElement(
	          'g',
	          { id: 'g3572', transform: 'matrix(2.4328 0 0 2.4328 550.47 785.28)' },
	          _react2.default.createElement('path', { id: 'path3574', d: 'm0 0c-0.693 0.11-1.285 0.155-1.986 0.155-0.702 0-1.293-0.045-1.987-0.155-2.012-0.315-3.642-1.124-5.111-2.534-1.572-1.511-2.433-3.299-2.63-5.47-0.12-1.333-0.017-2.482 0.342-3.771 0.55-1.978 1.583-3.506 3.213-4.754 1.073-0.825 2.14-1.319 3.462-1.607 0.939-0.206 1.75-0.291 2.711-0.291 0.96 0 1.772 0.085 2.712 0.291 1.321 0.288 2.388 0.782 3.461 1.607l-3.766 4.104c-0.599-1.33-2.159-1.923-3.49-1.324-0.613 0.276-1.048 0.71-1.325 1.324-0.255 0.567-0.404 1.075-0.496 1.691-0.186 1.231-0.165 2.3 0.076 3.523 0.123 0.635 0.335 1.153 0.689 1.694 0.774 1.181 2.358 1.511 3.541 0.738 0.309-0.203 0.535-0.429 0.736-0.738 0.355-0.541 0.567-1.059 0.69-1.694 0.238-1.223 0.262-2.292 0.076-3.523-0.093-0.616-0.242-1.124-0.497-1.691l3.766-4.104c1.631 1.248 2.664 2.776 3.213 4.754 0.359 1.289 0.461 2.438 0.342 3.771-0.197 2.171-1.056 3.959-2.629 5.47-1.47 1.412-3.099 2.219-5.113 2.534', fill: _shibui.colors.graphite.color })
	        ),
	        _react2.default.createElement(
	          'g',
	          { id: 'g3576', transform: 'matrix(2.4328 0 0 2.4328 -406.36 -901.55)' },
	          _react2.default.createElement(
	            'g',
	            { id: 'g3578', fill: _shibui.colors.graphite.color, clipPath: 'url(#clipPath3580)' },
	            _react2.default.createElement(
	              'g',
	              { id: 'g3584', transform: 'translate(362.55 676.88)' },
	              _react2.default.createElement('path', { id: 'path3586', d: 'm0 0c-0.098 1.444-0.153 2.667-0.182 4.116-0.038 1.904-0.061 3.51-0.074 5.413-0.008 1.027-0.121 1.894-0.378 2.888-0.337 1.303-1.1 2.293-2.275 2.951-0.71 0.397-1.361 0.641-2.155 0.813-2.528 0.541-4.759 0.586-7.306 0.144-0.716-0.124-1.308-0.296-1.98-0.574-1.552-0.642-2.621-1.812-3.119-3.415-0.191-0.613-0.242-1.169-0.169-1.808 0.014-0.117 0.043-0.216 0.096-0.323l5.898-0.144c-0.015 0.376 0.034 0.694 0.161 1.047 0.193 0.538 0.573 0.92 1.111 1.116 0.791 0.291 1.553 0.302 2.355 0.04 0.527-0.173 0.901-0.553 1.065-1.082 0.103-0.331 0.052-0.657-0.148-0.94-0.174-0.25-0.389-0.418-0.674-0.527-0.176-0.067-0.326-0.116-0.506-0.164-0.82-0.221-1.52-0.373-2.357-0.512-0.663-0.109-1.221-0.212-1.878-0.346-0.893-0.177-1.639-0.373-2.504-0.653-0.792-0.256-1.416-0.62-2.028-1.183-0.796-0.728-1.251-1.591-1.403-2.662-0.1-0.714-0.077-1.336 0.081-2.039 0.413-1.828 1.682-3.18 3.483-3.704 1.996-0.579 3.869-0.484 5.796 0.294 0.938 0.377 1.652 0.9 2.297 1.678l-0.416 3.013c-0.297-0.46-0.666-0.774-1.165-0.994-0.468-0.207-0.891-0.316-1.4-0.368-0.424-0.042-0.792-0.011-1.203 0.104-0.334 0.092-0.595 0.248-0.832 0.5-0.2 0.216-0.319 0.448-0.38 0.736-0.093 0.442 0.052 0.867 0.397 1.16 0.231 0.197 0.457 0.329 0.74 0.433 0.685 0.252 1.27 0.441 1.971 0.64 0.848 0.239 1.55 0.498 2.35 0.866 0.079-0.641 0.075-1.19-0.014-1.828-0.065-0.468-0.207-0.853-0.464-1.249l0.416-3.013c0.129-0.428 0.248-0.786 0.394-1.205 0.083-0.235 0.191-0.417 0.355-0.6h6.497c-0.277 0.435-0.418 0.865-0.453 1.381', fill: _shibui.colors.graphite.color })
	            ),
	            _react2.default.createElement(
	              'g',
	              { id: 'g3588', transform: 'translate(323.2 676.88)' },
	              _react2.default.createElement('path', { id: 'path3590', d: 'm0 0c-0.098 1.444-0.153 2.667-0.182 4.116-0.039 1.904-0.061 3.51-0.074 5.413-0.007 1.027-0.12 1.894-0.378 2.888-0.337 1.303-1.099 2.293-2.275 2.951-0.71 0.397-1.361 0.641-2.155 0.813-2.528 0.541-4.759 0.586-7.307 0.144-0.714-0.124-1.308-0.296-1.979-0.574-1.552-0.642-2.621-1.812-3.119-3.415-0.19-0.613-0.242-1.169-0.168-1.808 0.013-0.117 0.042-0.216 0.095-0.323l5.898-0.144c-0.014 0.376 0.034 0.694 0.161 1.047 0.193 0.538 0.573 0.92 1.111 1.116 0.792 0.291 1.553 0.302 2.354 0.04 0.528-0.173 0.903-0.553 1.068-1.082 0.101-0.331 0.05-0.657-0.15-0.94-0.175-0.25-0.39-0.418-0.674-0.527-0.176-0.067-0.326-0.116-0.507-0.164-0.819-0.221-1.52-0.373-2.356-0.512-0.662-0.109-1.221-0.212-1.879-0.346-0.892-0.177-1.637-0.373-2.504-0.653-0.79-0.256-1.414-0.62-2.027-1.183-0.796-0.728-1.25-1.591-1.403-2.662-0.101-0.714-0.077-1.336 0.082-2.039 0.411-1.828 1.682-3.18 3.481-3.704 1.998-0.579 3.869-0.484 5.797 0.294 0.937 0.377 1.653 0.9 2.298 1.678l-0.416 3.013c-0.297-0.46-0.667-0.774-1.167-0.994-0.467-0.207-0.891-0.316-1.398-0.368-0.426-0.042-0.792-0.011-1.204 0.104-0.334 0.092-0.595 0.248-0.831 0.5-0.201 0.216-0.32 0.448-0.381 0.736-0.092 0.442 0.052 0.867 0.397 1.16 0.23 0.197 0.456 0.329 0.74 0.433 0.685 0.252 1.271 0.441 1.972 0.64 0.848 0.239 1.549 0.498 2.35 0.866 0.078-0.641 0.074-1.19-0.015-1.828-0.065-0.468-0.208-0.853-0.463-1.249l0.416-3.013c0.128-0.428 0.247-0.786 0.394-1.205 0.082-0.235 0.19-0.417 0.354-0.6h6.497c-0.277 0.435-0.417 0.865-0.453 1.381', fill: _shibui.colors.graphite.color })
	            )
	          )
	        )
	      )
	    );
	  },
	  UberSVG: function UberSVG() {
	    return _react2.default.createElement(
	      'svg',
	      { style: uberStyle, version: '1.1', id: 'Capa_1', xmlns: 'http://www.w3.org/2000/svg', x: '0px', y: '0px',
	        width: '926.906px', height: '321.777px', viewBox: '0 0 926.906 321.777', enableBackground: 'new 0 0 926.906 321.777' },
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('path', { fill: _shibui.colors.graphite.color, d: 'M53.328,229.809c3.917,10.395,9.34,19.283,16.27,26.664c6.93,7.382,15.14,13.031,24.63,16.948 c9.491,3.917,19.81,5.875,30.958,5.875c10.847,0,21.015-2.034,30.506-6.102s17.776-9.792,24.856-17.173 c7.08-7.382,12.579-16.194,16.496-26.438c3.917-10.244,5.875-21.692,5.875-34.347V0h47.453v316.354h-47.001v-29.376 c-10.545,11.147-22.974,19.734-37.285,25.761c-14.312,6.025-29.752,9.038-46.323,9.038c-16.873,0-32.615-2.938-47.228-8.813 c-14.612-5.875-27.267-14.235-37.962-25.082S15.441,264.006,9.265,248.79C3.088,233.575,0,216.628,0,197.947V0h47.453v195.236 C47.453,207.891,49.411,219.414,53.328,229.809z' }),
	        _react2.default.createElement('path', { fill: _shibui.colors.graphite.color, d: 'M332.168,0v115.243c10.545-10.545,22.748-18.905,36.607-25.082s28.924-9.265,45.193-9.265 c16.873,0,32.689,3.163,47.453,9.49c14.763,6.327,27.567,14.914,38.414,25.761s19.434,23.651,25.761,38.414 c6.327,14.764,9.49,30.431,9.49,47.002c0,16.57-3.163,32.162-9.49,46.774c-6.327,14.613-14.914,27.343-25.761,38.188 c-10.847,10.847-23.651,19.434-38.414,25.761c-14.764,6.327-30.581,9.49-47.453,9.49c-16.27,0-31.409-3.088-45.419-9.265 c-14.01-6.176-26.288-14.537-36.833-25.082v28.924h-45.193V0H332.168z M337.365,232.746c4.067,9.642,9.717,18.078,16.948,25.309 c7.231,7.231,15.667,12.956,25.308,17.174c9.642,4.218,20.036,6.327,31.184,6.327c10.847,0,21.09-2.109,30.731-6.327 s18.001-9.942,25.083-17.174c7.08-7.23,12.729-15.667,16.947-25.309c4.218-9.641,6.327-20.035,6.327-31.183 c0-11.148-2.109-21.618-6.327-31.41s-9.867-18.303-16.947-25.534c-7.081-7.23-15.441-12.88-25.083-16.947 s-19.885-6.102-30.731-6.102c-10.846,0-21.09,2.034-30.731,6.102s-18.077,9.717-25.309,16.947 c-7.23,7.231-12.955,15.742-17.173,25.534c-4.218,9.792-6.327,20.262-6.327,31.41C331.264,212.711,333.298,223.105,337.365,232.746 z' }),
	        _react2.default.createElement('path', { fill: _shibui.colors.graphite.color, d: 'M560.842,155.014c6.025-14.462,14.312-27.191,24.856-38.188s23.049-19.659,37.511-25.986 s30.129-9.49,47.001-9.49c16.571,0,31.937,3.013,46.098,9.038c14.16,6.026,26.362,14.387,36.606,25.083 c10.244,10.695,18.229,23.35,23.952,37.962c5.725,14.613,8.587,30.506,8.587,47.68v14.914H597.901 c1.507,9.34,4.52,18.002,9.039,25.985c4.52,7.984,10.168,14.914,16.947,20.789c6.779,5.876,14.462,10.471,23.049,13.784 c8.587,3.314,17.7,4.972,27.342,4.972c27.418,0,49.563-11.299,66.435-33.896l32.991,24.404 c-11.449,15.366-25.609,27.418-42.481,36.155c-16.873,8.737-35.854,13.106-56.944,13.106c-17.174,0-33.217-3.014-48.131-9.039 s-27.869-14.462-38.866-25.309s-19.659-23.576-25.986-38.188s-9.491-30.506-9.491-47.679 C551.803,184.842,554.817,169.476,560.842,155.014z M624.339,137.162c-12.805,10.696-21.316,24.932-25.534,42.708h140.552 c-3.917-17.776-12.278-32.012-25.083-42.708c-12.805-10.695-27.794-16.043-44.967-16.043 C652.133,121.119,637.144,126.467,624.339,137.162z' }),
	        _react2.default.createElement('path', { fill: _shibui.colors.graphite.color, d: 'M870.866,142.359c-9.641,10.545-14.462,24.856-14.462,42.934v131.062h-45.646V85.868h45.193v28.472 c5.725-9.34,13.182-16.722,22.371-22.145c9.189-5.424,20.111-8.136,32.766-8.136h15.817v42.482h-18.981 C892.86,126.542,880.507,131.814,870.866,142.359z' })
	      )
	    );
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shibui = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  CTASVG: function CTASVG() {
	    return _react2.default.createElement(
	      'svg',
	      {
	        style: { position: 'absolute', top: '-45%', left: '50%', transform: 'translateX(-50%)' },
	        width: '1440', height: '791', viewBox: '0 0 1440 791', xmlns: 'http://www.w3.org/2000/svg' },
	      _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement('rect', { id: 'a-23i2388', width: '1577', height: '672', rx: '20' }),
	        _react2.default.createElement(
	          'linearGradient',
	          { x1: '-56.4856953%', y1: '62.499299%', x2: '82.7441255%', y2: '42.0954089%', id: 'c-reiurwiu' },
	          _react2.default.createElement('stop', { stopColor: _shibui.colors.amethyst50.color, offset: '0%' }),
	          _react2.default.createElement('stop', { stopColor: _shibui.colors.graphite.color, offset: '100%' })
	        )
	      ),
	      _react2.default.createElement(
	        'g',
	        { fill: 'none', fillRule: 'evenodd' },
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(-58 59.192)' },
	          _react2.default.createElement('use', { href: '#a-23i2388' })
	        ),
	        _react2.default.createElement('path', { d: 'M310.725 106.694h110.017c34.77 0 47.378 3.62 60.089 10.418 12.711 6.798 22.687 16.774 29.485 29.485 6.798 12.71 10.418 25.319 10.418 60.088v110.017c0 34.77-3.62 47.378-10.418 60.089-6.798 12.71-16.774 22.687-29.485 29.485-12.711 6.798-25.32 10.418-60.089 10.418H310.725c-34.769 0-47.377-3.62-60.088-10.418-12.711-6.798-22.687-16.774-29.485-29.485-6.798-12.711-10.418-25.32-10.418-60.089V206.685c0-34.769 3.62-47.377 10.418-60.088 6.798-12.711 16.774-22.687 29.485-29.485 12.711-6.798 25.32-10.418 60.088-10.418z', fill: 'url(#c-reiurwiu)', transform: 'rotate(-150 344.664 299.06)' }),
	        _react2.default.createElement('path', { d: 'M1131.725 253.694h110.017c34.77 0 47.378 3.62 60.089 10.418 12.711 6.798 22.687 16.774 29.485 29.485 6.798 12.71 10.418 25.319 10.418 60.088v110.017c0 34.77-3.62 47.378-10.418 60.089-6.798 12.71-16.774 22.687-29.485 29.485-12.711 6.798-25.32 10.418-60.089 10.418h-110.017c-34.769 0-47.377-3.62-60.088-10.418-12.711-6.798-22.687-16.774-29.485-29.485-6.798-12.711-10.418-25.32-10.418-60.089V353.685c0-34.769 3.62-47.377 10.418-60.088 6.798-12.711 16.774-22.687 29.485-29.485 12.711-6.798 25.32-10.418 60.088-10.418z', fill: 'url(#c-reiurwiu)', transform: 'rotate(30 1047.28 330.06)' })
	      )
	    );
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shibui = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  HeroSVG: function HeroSVG(_ref) {
	    var _ref$offset = _ref.offset,
	        offset = _ref$offset === undefined ? '-6%' : _ref$offset;
	    return _react2.default.createElement(
	      'svg',
	      {
	        width: '4788',
	        height: '1921',
	        style: { transform: 'translate(-18%, ' + offset + ')' },
	        xmlns: 'http://www.w3.org/2000/svg' },
	      _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement('path', { id: 'a-23i23', d: 'M3132 3471h1441v1664H3132z' }),
	        _react2.default.createElement(
	          'linearGradient',
	          { x1: '100%', y1: '86.413%', x2: '0%', y2: '100%', id: 'b-e9393' },
	          _react2.default.createElement('stop', { stopColor: '#362C4C', offset: '0%' }),
	          _react2.default.createElement('stop', { stopColor: _shibui.colors.graphite.color, offset: '100%' })
	        ),
	        _react2.default.createElement(
	          'linearGradient',
	          { x1: '297.88%', y1: '56.579%', x2: '32.238%', y2: '89.451%', id: 'c-29292' },
	          _react2.default.createElement('stop', { stopColor: '#16181C', offset: '0%' }),
	          _react2.default.createElement('stop', { stopColor: _shibui.colors.fuss50.color, offset: '24.621%' }),
	          _react2.default.createElement('stop', { stopColor: '#222B39', offset: '100%' })
	        ),
	        _react2.default.createElement(
	          'linearGradient',
	          { x1: '70.794%', y1: '-11.368%', x2: '14.819%', y2: '85.258%', id: 'd-23i3223' },
	          _react2.default.createElement('stop', { stopColor: '#16181C', offset: '0%' }),
	          _react2.default.createElement('stop', { stopColor: _shibui.colors.amethyst50.color, offset: '.058%' }),
	          _react2.default.createElement('stop', { stopColor: '#222B39', offset: '100%' })
	        )
	      ),
	      _react2.default.createElement(
	        'g',
	        { transform: 'translate(-497 -2956)', fill: 'none', fillRule: 'evenodd' },
	        _react2.default.createElement('use', { fillOpacity: '0', href: '#a-23i23' }),
	        _react2.default.createElement('path', { d: 'M1678.757 152.65l2259.06 6.375c223.228.63 403.857 181.769 403.857 404.998v3892.632c0 223.676-181.325 405-405 405H1681.753c-223.508 0-404.763-181.063-405-404.57l-4.139-3899.006c-.237-223.675 180.895-405.192 404.57-405.43.524 0 1.048 0 1.573.002z', fill: 'url(#b-e9393)', transform: 'rotate(-60 2807.144 2507.152)' }),
	        _react2.default.createElement('rect', { fill: 'url(#c-29292)', transform: 'rotate(-60 2865.33 2692.818)', x: '1743.584', y: '803.573', width: '2243.491', height: '3778.491', rx: '307' }),
	        _react2.default.createElement('rect', { fill: 'url(#d-23i3223)', transform: 'rotate(-60 3083.82 2814.996)', x: '2283.574', y: '1484.25', width: '1600.491', height: '2661.491', rx: '240' })
	      )
	    );
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(16);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _color = __webpack_require__(220);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(269);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactScrollToComponent = __webpack_require__(1062);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _demo_next = __webpack_require__(1094);
	
	var _demo_next2 = _interopRequireDefault(_demo_next);
	
	var _timeline_base = __webpack_require__(1102);
	
	var _timeline_base2 = _interopRequireDefault(_timeline_base);
	
	var _timeline_timeline = __webpack_require__(1103);
	
	var _timeline_timeline2 = _interopRequireDefault(_timeline_timeline);
	
	var _timeline_toggle = __webpack_require__(1104);
	
	var _timeline_toggle2 = _interopRequireDefault(_timeline_toggle);
	
	var _interact_base = __webpack_require__(1096);
	
	var _interact_base2 = _interopRequireDefault(_interact_base);
	
	var _interact_states = __webpack_require__(1098);
	
	var _interact_states2 = _interopRequireDefault(_interact_states);
	
	var _interact_expression = __webpack_require__(1097);
	
	var _interact_expression2 = _interopRequireDefault(_interact_expression);
	
	var _pub_base = __webpack_require__(1099);
	
	var _pub_base2 = _interopRequireDefault(_pub_base);
	
	var _pub_modal = __webpack_require__(1101);
	
	var _pub_modal2 = _interopRequireDefault(_pub_modal);
	
	var _pub_btns = __webpack_require__(1100);
	
	var _pub_btns2 = _interopRequireDefault(_pub_btns);
	
	var _sketch = __webpack_require__(1116);
	
	var _sketch2 = _interopRequireDefault(_sketch);
	
	var _figma = __webpack_require__(1105);
	
	var _figma2 = _interopRequireDefault(_figma);
	
	var _illustrator = __webpack_require__(1106);
	
	var _illustrator2 = _interopRequireDefault(_illustrator);
	
	var _svg = __webpack_require__(1117);
	
	var _svg2 = _interopRequireDefault(_svg);
	
	var _kwame = __webpack_require__(1112);
	
	var _kwame2 = _interopRequireDefault(_kwame);
	
	var _stu = __webpack_require__(1113);
	
	var _stu2 = _interopRequireDefault(_stu);
	
	var _josh = __webpack_require__(1110);
	
	var _josh2 = _interopRequireDefault(_josh);
	
	var _evan = __webpack_require__(1109);
	
	var _evan2 = _interopRequireDefault(_evan);
	
	var _alvaro = __webpack_require__(1107);
	
	var _alvaro2 = _interopRequireDefault(_alvaro);
	
	var _khan = __webpack_require__(1111);
	
	var _khan2 = _interopRequireDefault(_khan);
	
	var _sus = __webpack_require__(1114);
	
	var _sus2 = _interopRequireDefault(_sus);
	
	var _bh = __webpack_require__(1108);
	
	var _bh2 = _interopRequireDefault(_bh);
	
	var _lottie = __webpack_require__(1121);
	
	var _lottie2 = _interopRequireDefault(_lottie);
	
	var _android = __webpack_require__(1118);
	
	var _android2 = _interopRequireDefault(_android);
	
	var _ios = __webpack_require__(1120);
	
	var _ios2 = _interopRequireDefault(_ios);
	
	var _vue = __webpack_require__(1123);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _react3 = __webpack_require__(1122);
	
	var _react4 = _interopRequireDefault(_react3);
	
	var _angular = __webpack_require__(1119);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _icons = __webpack_require__(73);
	
	var _herobg = __webpack_require__(484);
	
	var _ctabg = __webpack_require__(483);
	
	var _companies = __webpack_require__(482);
	
	var _react5 = __webpack_require__(430);
	
	var _react6 = _interopRequireDefault(_react5);
	
	var _react7 = __webpack_require__(438);
	
	var _react8 = _interopRequireDefault(_react7);
	
	var _react9 = __webpack_require__(446);
	
	var _react10 = _interopRequireDefault(_react9);
	
	var _react11 = __webpack_require__(473);
	
	var _react12 = _interopRequireDefault(_react11);
	
	var _shibui = __webpack_require__(15);
	
	var _sharedStyles = __webpack_require__(63);
	
	var _sharedStyles2 = _interopRequireDefault(_sharedStyles);
	
	var _reactScrollParallax = __webpack_require__(207);
	
	var _gatsbyLink = __webpack_require__(68);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _nukaCarousel = __webpack_require__(861);
	
	var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);
	
	var _mobileContent = __webpack_require__(23);
	
	var _mobileContent2 = _interopRequireDefault(_mobileContent);
	
	var _navbar = __webpack_require__(19);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _cardWithIcon = __webpack_require__(246);
	
	var _cardWithIcon2 = _interopRequireDefault(_cardWithIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var windowPresent = typeof window !== 'undefined';
	
	var S = {
	  page: {
	    backgroundColor: _shibui.colors.ivory.color,
	    fontFamily: "'Poppins', sans-serif",
	    color: _shibui.colors.midnight.color,
	    overflowX: 'hidden'
	  },
	  top: {
	    transition: 'opacity linear 300ms',
	    position: 'relative',
	    overflowX: 'hidden'
	  },
	  hero: {
	    position: 'relative',
	    zIndex: 1,
	    height: _shibui.sizing.xl,
	    width: '100%',
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    justifyContent: 'center',
	    transform: 'translateY(-44px)',
	    '@media screen and (max-width: 870px)': {
	      minHeight: 'calc(100vh + 330px)',
	      width: '100%'
	    }
	  },
	  heroHolster: {
	    marginTop: -_shibui.spacing.lg,
	    width: '100%'
	  },
	  haikuHolster: {
	    height: 170,
	    margin: '0 auto',
	    '@media screen and (max-width: 870px)': {
	      maxWidth: '93%'
	    }
	  },
	  bg: {
	    position: 'absolute',
	    zIndex: -1,
	    top: 0,
	    left: '50%',
	    transform: 'translate(-50%, -20%)'
	  },
	  section: {
	    position: 'relative',
	    fontSize: 20,
	    lineHeight: '1.8em',
	    width: '100%',
	    maxWidth: _shibui.sizing.xxl,
	    margin: '0 auto'
	  },
	  sectionQuotes: {
	    maxHeight: 340,
	    marginBottom: _shibui.sizing.sm,
	    '@media screen and (max-width: 670px)': {
	      display: 'none'
	    }
	  },
	  heartedCard: {
	    backgroundColor: _shibui.colors.ivoryMuted.color,
	    borderRadius: _shibui.borderRadii.modal,
	    width: '100%',
	    maxWidth: _shibui.sizing.xxxl,
	    position: 'absolute',
	    bottom: 30,
	    padding: _shibui.spacing.md + _shibui.spacing.xs + 'px ' + _shibui.spacing.lg + 'px',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'space-between',
	    flexWrap: 'wrap',
	    '@media screen and (max-width: 870px)': {
	      justifyContent: 'center',
	      bottom: '0'
	    }
	  },
	  hearted: {
	    marginRight: _shibui.spacing.md,
	    marginLeft: _shibui.spacing.sm,
	    '@media screen and (max-width: 870px)': {
	      flex: '0 0 100%',
	      marginBottom: _shibui.spacing.lg,
	      textAlign: 'center'
	    }
	  },
	  geef: {
	    maxWidth: _shibui.sizing.xxxl,
	    textAlign: 'center',
	    position: 'relative',
	    zIndex: 1,
	    margin: '0 auto ' + _shibui.spacing.xxl + 'px'
	  },
	  vidHolster: {
	    borderRadius: _shibui.borderRadii.modal,
	    overflow: 'visible',
	    maxWidth: '100%',
	    maxHeight: 'calc(100vh - 30px)',
	    boxShadow: _shibui.shadows.modalOnDark.boxShadow
	  },
	  cardsHolster: {
	    marginTop: _shibui.spacing.xl,
	    display: 'flex',
	    flexWrap: 'wrap'
	  },
	  description: {
	    fontSize: '1.18rem'
	  },
	  cardTitle: {
	    textAlign: 'center'
	  },
	  divider: {
	    margin: _shibui.sizing.xs,
	    textAlign: 'center',
	    '@media screen and (max-width: 758px)': {
	      opacity: 0,
	      margin: _shibui.spacing.lg
	    }
	  },
	  splitter: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    margin: '0 auto ' + _shibui.spacing.xl + 'px'
	  },
	  split: {
	    width: '50%',
	    '@media screen and (max-width: 870px)': {
	      width: '100%'
	    }
	  },
	  splitSplitter: {
	    display: 'flex',
	    '@media screen and (max-width: 500px)': {
	      flexWrap: 'wrap'
	    }
	  },
	  lined: {
	    borderRight: '1px solid ' + _shibui.colorsMapped.borderColor.color
	  },
	  targetsTextHolster: {
	    paddingLeft: _shibui.spacing.xl,
	    paddingRight: _shibui.spacing.xl
	  },
	  splitText: {
	    width: '50%',
	    paddingLeft: _shibui.spacing.xxl,
	    paddingRight: _shibui.spacing.lg,
	    '@media screen and (max-width: 870px)': {
	      width: '100%',
	      paddingLeft: _shibui.spacing.md
	    }
	  },
	  splitTextLeft: {
	    width: '50%',
	    paddingRight: _shibui.spacing.lg,
	    paddingLeft: _shibui.spacing.xl,
	    '@media screen and (max-width: 870px)': {
	      order: 1,
	      width: '100%',
	      paddingLeft: _shibui.spacing.md,
	      paddingRight: _shibui.spacing.md
	    }
	  },
	  circleFloat: {
	    borderRadius: _shibui.borderRadii.avatar,
	    boxShadow: _shibui.shadows.card.boxShadow,
	    width: 77,
	    height: 77,
	    padding: _shibui.spacing.md,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  avatarColumn: {
	    minWidth: 80,
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'space-between',
	    '@media screen and (max-width: 500px)': {
	      flexDirection: 'row',
	      width: '100%',
	      justifyContent: 'space-around'
	    }
	  },
	  orderReverse: {
	    '@media screen and (max-width: 500)': {
	      order: 1 + '!important'
	    }
	  },
	  cardLink: {
	    color: _shibui.colors.midnight.color
	  },
	  bullets: {
	    fontSize: 16
	  },
	  quote: {
	    fontSize: 20
	  },
	  quoteCompany: {
	    height: 60,
	    marginTop: _shibui.spacing.xs,
	    paddingTop: _shibui.spacing.md
	  },
	  quoteCredsLeft: {
	    float: 'left',
	    borderRight: '1px solid ' + _shibui.colorsMapped.borderColor.color,
	    paddingRight: _shibui.spacing.lg
	  },
	  quoteCredsRight: {
	    marginLeft: _shibui.spacing.lg,
	    float: 'left'
	  },
	  personHolster: {
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  name: {
	    textAlign: 'left',
	    paddingLeft: _shibui.spacing.lg,
	    textTransform: 'uppercase',
	    marginTop: 12,
	    marginBottom: 0
	  },
	  position: {
	    paddingLeft: _shibui.spacing.lg,
	    textAlign: 'left',
	    fontWeight: 700,
	    fontSize: '.9rem',
	    marginTop: 0
	  },
	  ctaSection: {
	    position: 'relative',
	    padding: _shibui.spacing.xl,
	    marginTop: _shibui.sizing.sm,
	    overflow: 'hidden',
	    backgroundColor: _shibui.colors.graphite.color,
	    boxShadow: '0 0 60px 0 ' + (0, _color2.default)(_shibui.colors.amethyst50.color).alpha(0.5),
	    '@media screen and (max-width: 758px)': {
	      display: 'none'
	    }
	  },
	  avatarHolster: {
	    width: 69,
	    height: 69
	  },
	  arrivals: {
	    transition: 'transform 700ms \'cubic-bezier(0.03, 0.07, 0.12, 1.07)\', opacity 400ms',
	    transform: 'translateY(0)'
	  },
	  arrival2: {
	    fontSize: '2.24rem',
	    transition: 'transform 700ms \'cubic-bezier(0.03, 0.07, 0.12, 1.07)\' 160ms, opacity 400ms 160ms'
	  },
	  arrival3: {
	    transition: 'transform 700ms \'cubic-bezier(0.03, 0.07, 0.12, 1.07)\' 320ms, opacity 400ms 320ms'
	  },
	  airborne: {
	    transform: 'translateY(40px)',
	    opacity: 0
	  },
	  inlineCode: {
	    fontFamily: 'courier, monospace',
	    backgroundColor: _shibui.colors.seattleMuted.color,
	    borderRadius: _shibui.borderRadii.input,
	    padding: '0 ' + _shibui.spacing.sm + 'px'
	  }
	};
	
	var Animator = function (_Component) {
	  _inherits(Animator, _Component);
	
	  function Animator() {
	    _classCallCheck(this, Animator);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.updateDimensions = (0, _lodash2.default)(function () {
	      _this.setState({ windowWidth: windowPresent ? window.innerWidth : 1920, windowHeight: windowPresent ? window.innerHeight : 1920 });
	    }, 40);
	
	
	    _this.state = {
	      finishedLoad: false,
	      AnimatorLogo: null,
	      windowWidth: windowPresent ? window.innerWidth : 1920,
	      windowHeight: windowPresent ? window.innerHeight : 1920
	    };
	    return _this;
	  }
	
	  Animator.prototype.componentDidMount = function componentDidMount() {
	    // this.setState({ windowWidth: windowPresent ? window.innerWidth : 1920 })
	    this.setState({ finishedLoad: true });
	    // windowPresent && window.addEventListener("resize", this.updateDimensions)
	
	    if (this.props.location.hash) {
	      (0, _reactScrollToComponent2.default)(this[this.props.location.hash.substr(1)], { align: 'top' });
	    }
	
	    this.context.parallaxController.update();
	  };
	
	  Animator.prototype.componentWillUnmount = function componentWillUnmount() {
	    // windowPresent && window.removeEventListener("resize", this.updateDimensions)
	    // if (this.orientationHandler) windowPresent && window.removeEventListener("deviceorientation", this.orientationHandler)
	  };
	
	  Animator.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        id: 'top',
	        style: [S.page, { opacity: this.state.finishedLoad ? 1 : 0 }],
	        onMouseMove: this.mouseMoveCallback },
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Haiku Animator | Create engaging animations for any app or website.'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Make Lottie animations or dynamic web components using Animator\'s timeline, stage, and design tool integrations.' })
	      ),
	      _react2.default.createElement(_navbar2.default, { location: 'animator' }),
	      _react2.default.createElement(
	        'section',
	        { id: 'hero', style: S.hero },
	        _react2.default.createElement(
	          'div',
	          { style: S.bg },
	          _react2.default.createElement(_herobg.HeroSVG, { offset: this.state.windowWidth < 800 ? '-20%' : '-6%' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: [_sharedStyles2.default.container, _sharedStyles2.default.container.narrow, _sharedStyles2.default.centerer] },
	          _react2.default.createElement(
	            'div',
	            { style: S.heroHolster },
	            _react2.default.createElement(
	              'div',
	              {
	                style: S.haikuHolster,
	                onClick: function onClick() {
	                  _this2.state.AnimatorLogo.getDefaultTimeline().gotoAndPlay(0);
	                } },
	              _react2.default.createElement(_react12.default, {
	                haikuStates: { fgColor: { value: _shibui.colors.ivory.color } },
	                onHaikuComponentDidMount: function onHaikuComponentDidMount(component) {
	                  return _this2.setState({ AnimatorLogo: component });
	                },
	                sizing: 'contain' })
	            ),
	            _react2.default.createElement(
	              'h4',
	              { style: [_sharedStyles2.default.heading4, { fontSize: '1.7rem', color: _shibui.colors.ivory.color }, _sharedStyles2.default.centerer, S.arrivals, S.arrival2, !this.state.finishedLoad && S.airborne, { margin: _shibui.spacing.lg + 'px auto' }] },
	              'Create engaging animations ',
	              _react2.default.createElement('br', null),
	              'for any app or website.'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                key: 'cta1',
	                href: 'https://github.com/HaikuTeam/animator/',
	                style: [_sharedStyles2.default.btn, _sharedStyles2.default.cta, S.arrivals, S.arrival3, !this.state.finishedLoad && S.airborne] },
	              'Download on Github'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { color: _shibui.colors.ivory.color } },
	              _react2.default.createElement(
	                'span',
	                { style: [_sharedStyles2.default.badge, S.badgePositioning] },
	                'New!'
	              ),
	              ' Haiku Animator goes open-source: ',
	              _react2.default.createElement(
	                'a',
	                { href: '/blog/open-source' },
	                'read more'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: S.heartedCard },
	          _react2.default.createElement(
	            'span',
	            { style: S.hearted },
	            _react2.default.createElement(_icons.HeartSVG, null),
	            '\'d by lovely folks at'
	          ),
	          _react2.default.createElement(_companies.DeloitteSVG, null),
	          _react2.default.createElement(_companies.UberSVG, null),
	          _react2.default.createElement(_companies.LegoSVG, null),
	          _react2.default.createElement(_companies.GoogleSVG, null),
	          _react2.default.createElement(_companies.BenzSVG, null),
	          _react2.default.createElement(_companies.TripAdvisorSVG, null)
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'geef', style: S.geef },
	        _react2.default.createElement(
	          'video',
	          {
	            ref: 'vid0',
	            style: S.vidHolster,
	            onLoadedData: function onLoadedData() {
	              return _this2.context.parallaxController.update();
	            },
	            loop: true, autoPlay: true, muted: true, playsInline: true, preload: 'metadata' },
	          _react2.default.createElement('source', { src: _demo_next2.default, type: 'video/mp4' })
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'drawing-tools', style: S.q },
	        _react2.default.createElement(
	          'div',
	          { style: [_sharedStyles2.default.container, _sharedStyles2.default.container.narrow, _sharedStyles2.default.centerer] },
	          _react2.default.createElement(
	            'h2',
	            { style: [_shibui.typography.heading2, _sharedStyles2.default.centerer] },
	            'Motion design for your team\'s workflow'
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: S.description },
	            'Animations are hard.  Collaborating between designers and developers, even harder.',
	            _react2.default.createElement('br', null),
	            'Luckily for you, Haiku Animator lets you bring motion design to production, starting with ',
	            _react2.default.createElement(
	              'span',
	              { style: { fontStyle: 'italic' } },
	              'your'
	            ),
	            ' design tools and finishing with ',
	            _react2.default.createElement(
	              'span',
	              { style: { fontStyle: 'italic' } },
	              'your'
	            ),
	            ' codebase.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: [_sharedStyles2.default.container, _sharedStyles2.default.centerer] },
	          _react2.default.createElement(
	            'div',
	            { style: S.cardsHolster },
	            _react2.default.createElement(
	              'div',
	              { key: '1', style: [_sharedStyles2.default.card, _sharedStyles2.default.flexDivision] },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/learn/#drawing' },
	                _react2.default.createElement('img', { src: _sketch2.default, alt: 'sketch app' }),
	                _react2.default.createElement(
	                  'div',
	                  { style: [_sharedStyles2.default.heading4, S.cardTitle] },
	                  'Sketch'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: _sharedStyles2.default.btnLink },
	                  'Learn more ',
	                  _react2.default.createElement(_icons.RightArrowSVG, { style: _sharedStyles2.default.rightArrow })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { key: '2', style: [_sharedStyles2.default.card, _sharedStyles2.default.flexDivision] },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/learn/#drawing' },
	                _react2.default.createElement('img', { src: _figma2.default, alt: 'figma' }),
	                _react2.default.createElement(
	                  'div',
	                  { style: [_sharedStyles2.default.heading4, S.cardTitle] },
	                  'Figma'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: _sharedStyles2.default.btnLink },
	                  'Learn more ',
	                  _react2.default.createElement(_icons.RightArrowSVG, { style: _sharedStyles2.default.rightArrow })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { key: '3', style: [_sharedStyles2.default.card, _sharedStyles2.default.flexDivision] },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/learn/#drawing' },
	                _react2.default.createElement('img', { src: _illustrator2.default, alt: 'adobe illustator' }),
	                _react2.default.createElement(
	                  'div',
	                  { style: [_sharedStyles2.default.heading4, S.cardTitle] },
	                  'Illustrator'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: _sharedStyles2.default.btnLink },
	                  'Learn more ',
	                  _react2.default.createElement(_icons.RightArrowSVG, { style: _sharedStyles2.default.rightArrow })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { key: '4', style: [_sharedStyles2.default.card, _sharedStyles2.default.flexDivision] },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/learn/#drawing' },
	                _react2.default.createElement('img', { src: _svg2.default, alt: 'svg logo' }),
	                _react2.default.createElement(
	                  'div',
	                  { style: [_sharedStyles2.default.heading4, S.cardTitle] },
	                  'SVG'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: _sharedStyles2.default.btnLink },
	                  'Learn more ',
	                  _react2.default.createElement(_icons.RightArrowSVG, { style: _sharedStyles2.default.rightArrow })
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: S.divider },
	        _react2.default.createElement(_icons.KeyframeSVG, null)
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'features' },
	        _react2.default.createElement(
	          'div',
	          { id: 'timeline-n-code', style: [_sharedStyles2.default.container, S.splitter] },
	          _react2.default.createElement(
	            'div',
	            { style: [S.split, { maxHeight: 380, position: 'relative' }] },
	            _react2.default.createElement(
	              _reactScrollParallax.Parallax,
	              {
	                slowerScrollRate: true,
	                offsetYMax: 4,
	                offsetYMin: -4,
	                styleOuter: { transform: 'translate(0, 20px)' } },
	              _react2.default.createElement('img', { src: _timeline_base2.default })
	            ),
	            _react2.default.createElement(
	              _reactScrollParallax.Parallax,
	              {
	                offsetYMax: 50,
	                offsetYMin: -50,
	                styleOuter: { transform: 'translate(0, -60%)', width: '105%' } },
	              _react2.default.createElement('img', { src: _timeline_timeline2.default })
	            ),
	            _react2.default.createElement(
	              _reactScrollParallax.Parallax,
	              {
	                offsetYMax: 17,
	                offsetYMin: -17,
	                styleOuter: { transform: 'translate(97%, -610%)', width: '43%' } },
	              _react2.default.createElement('img', { src: _timeline_toggle2.default })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: S.splitText },
	            _react2.default.createElement(
	              'h3',
	              { style: _shibui.typography.heading3 },
	              'Timeline & code mode'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: S.description },
	              'With Timeline, choreograph animations in your designs visually. Sequence and animate elements using the built-in easing curves library, or finesse the details with the custom curve editor.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: S.description },
	              'You can also animate directly from code, using any code editor of your choice, or using Animator\u2019s built-in Code mode.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'interactivity', style: [_sharedStyles2.default.container, S.splitter] },
	          _react2.default.createElement(
	            'div',
	            { style: S.splitTextLeft },
	            _react2.default.createElement(
	              'h3',
	              { style: _shibui.typography.heading3 },
	              'Interactivity'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: S.description },
	              'Add interactivity to your designs with Haiku\'s easy-to-use, beginner-friendly scripting tools.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: S.description },
	              'If you can write a spreadsheet formula, you can create interactions in Animator!'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/learn/#interactivity', style: _sharedStyles2.default.btnLink },
	              'Learn more ',
	              _react2.default.createElement(_icons.RightArrowSVG, { style: _sharedStyles2.default.rightArrow })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: [S.split, { maxHeight: 380, position: 'relative' }] },
	            _react2.default.createElement(
	              _reactScrollParallax.Parallax,
	              {
	                slowerScrollRate: true,
	                offsetYMax: 4,
	                offsetYMin: -4,
	                styleOuter: { transform: 'translate(0, 20px)' } },
	              _react2.default.createElement('img', { src: _interact_base2.default })
	            ),
	            _react2.default.createElement(
	              _reactScrollParallax.Parallax,
	              {
	                offsetYMax: 30,
	                offsetYMin: -30,
	                styleOuter: { transform: 'translate(-10%, -100%)', width: '34%' } },
	              _react2.default.createElement('img', { src: _interact_states2.default })
	            ),
	            _react2.default.createElement(
	              _reactScrollParallax.Parallax,
	              {
	                offsetYMax: 20,
	                offsetYMin: -20,
	                styleOuter: { transform: 'translate(60%, -260%)', width: '53%' } },
	              _react2.default.createElement('img', { src: _interact_expression2.default })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'embedding', style: [_sharedStyles2.default.container, S.splitter] },
	          _react2.default.createElement(
	            'div',
	            { style: [S.split, { maxHeight: 380, position: 'relative' }] },
	            _react2.default.createElement(
	              _reactScrollParallax.Parallax,
	              {
	                slowerScrollRate: true,
	                offsetYMax: 4,
	                offsetYMin: -4,
	                styleOuter: { transform: 'translate(0, 20px)' } },
	              _react2.default.createElement('img', { src: _pub_base2.default })
	            ),
	            _react2.default.createElement(
	              _reactScrollParallax.Parallax,
	              {
	                offsetYMax: 20,
	                offsetYMin: -30,
	                styleOuter: { transform: 'translate(10%, -64%)', width: '55%' } },
	              _react2.default.createElement('img', { src: _pub_modal2.default })
	            ),
	            _react2.default.createElement(
	              _reactScrollParallax.Parallax,
	              {
	                offsetYMax: 20,
	                offsetYMin: -20,
	                styleOuter: { transform: 'translate(110%, -620%)', width: '53%' } },
	              _react2.default.createElement('img', { src: _pub_btns2.default })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: S.splitText },
	            _react2.default.createElement(
	              'h3',
	              { style: _shibui.typography.heading3 },
	              'Publishing & embedding'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: S.description },
	              'Animator delivers your animations to your codebase with convenient shareable links and embed instructions for different kinds of codebases.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: S.description },
	              'Want GIFs or videos instead of code?  Lucky you, they\'re just an "Export" away.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: S.divider },
	        _react2.default.createElement(_icons.KeyframeSVG, null)
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'code', style: S.sectionCode },
	        _react2.default.createElement(
	          'div',
	          { style: [_sharedStyles2.default.container, _sharedStyles2.default.container.narrow, _sharedStyles2.default.centerer] },
	          _react2.default.createElement(
	            'h2',
	            { style: [_shibui.typography.heading2, _sharedStyles2.default.centerer, { marginBottom: _shibui.spacing.xl }] },
	            'Loved by designers & developers alike'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: [_sharedStyles2.default.container, S.splitter] },
	          _react2.default.createElement(
	            'div',
	            { style: [S.split, S.splitSplitter, S.lined] },
	            _react2.default.createElement(
	              'div',
	              { style: S.avatarColumn },
	              _react2.default.createElement(
	                'div',
	                { style: S.circleFloat },
	                _react2.default.createElement('img', { src: _lottie2.default, alt: 'lottie' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: S.circleFloat },
	                _react2.default.createElement('img', { src: _ios2.default, alt: 'ios' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: S.circleFloat },
	                _react2.default.createElement('img', { src: _android2.default, alt: 'android' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: S.targetsTextHolster },
	              _react2.default.createElement(
	                'h3',
	                { style: _sharedStyles2.default.heading4 },
	                'Native iOS and Android animations, powered by Lottie'
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: S.description },
	                'Haiku Animator is the premier solution for creating cross-platform UI animations, with iOS and Android rendering powered by ',
	                _react2.default.createElement(
	                  'a',
	                  { key: 'lotto', style: _sharedStyles2.default.linkNaked, href: 'https://airbnb.design/lottie/', target: '_blank' },
	                  'Airbnb\'s open-source Lottie'
	                ),
	                ' engine.'
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: _sharedStyles2.default.note },
	                '*Lottie has certain ',
	                _react2.default.createElement(
	                  'a',
	                  { key: 'limits', style: _sharedStyles2.default.linkNaked, target: '_blank', href: 'https://docs.haiku.ai/embedding-and-using-haiku/lottie.html#limitations' },
	                  'limitations'
	                ),
	                '.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: [S.split, S.splitSplitter] },
	            _react2.default.createElement(
	              'div',
	              { style: S.targetsTextHolster },
	              _react2.default.createElement(
	                'h3',
	                { style: _sharedStyles2.default.heading4 },
	                'Works with your codebase & workflow'
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: S.description },
	                'Design once, embed anywhere. Haiku animations work with all major browsers and integrates with any web codebase, with first-class support for React, Vue, and Angular. '
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: [S.avatarColumn, S.orderReverse] },
	              _react2.default.createElement(
	                'div',
	                { style: S.circleFloat },
	                _react2.default.createElement('img', { src: _react4.default, alt: 'react' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: S.circleFloat },
	                _react2.default.createElement('img', { src: _vue2.default, alt: 'vue', style: { transform: 'translateY(4px)' } })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: S.circleFloat },
	                _react2.default.createElement('img', { src: _angular2.default, alt: 'angular' })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: S.divider },
	        _react2.default.createElement(_icons.KeyframeSVG, null)
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'quotes', style: S.sectionQuotes },
	        _react2.default.createElement(
	          'div',
	          { style: [_sharedStyles2.default.container, _sharedStyles2.default.container.narrow, _sharedStyles2.default.centerer] },
	          _react2.default.createElement(
	            _nukaCarousel2.default,
	            { autoplay: false, easing: 'easeCubicInOut', wrapAround: true, autoplayInterval: 6000 },
	            _react2.default.createElement(
	              'div',
	              { className: 'slide' },
	              _react2.default.createElement(
	                'p',
	                { style: S.quote },
	                '"Quite impressed with @HaikuForTeams - allows you to design complex animations with GUI and use in an existing Vue app as a component.\u201D'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: S.personHolster },
	                _react2.default.createElement(
	                  'div',
	                  { style: S.avatarHolster },
	                  _react2.default.createElement('img', { src: _evan2.default, alt: 'person' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { style: S.quoteCredsLeft },
	                    _react2.default.createElement(
	                      'p',
	                      { style: S.name },
	                      'Evan You'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { style: S.position },
	                      'Creator of @vuejs'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { style: S.quoteCredsRight },
	                    _react2.default.createElement('img', { style: S.quoteCompany, src: _vue2.default, alt: 'vue' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'slide' },
	              _react2.default.createElement(
	                'p',
	                { style: S.quote },
	                '"@HaikuForTeams is one of the most amazing frontend design products I\'ve seen to date, it ended my search for rapid prototyping tools that move from creative to production. Looking forward to improvements to come!\u201D'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: S.personHolster },
	                _react2.default.createElement(
	                  'div',
	                  { style: S.avatarHolster },
	                  _react2.default.createElement('img', { src: _kwame2.default, alt: 'person' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { style: S.quoteCredsLeft },
	                    _react2.default.createElement(
	                      'p',
	                      { style: S.name },
	                      'Kwame Porter Robinson'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { style: S.position },
	                      'Lead Data Scientist'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { style: S.quoteCredsRight },
	                    _react2.default.createElement('img', { style: S.quoteCompany, src: _bh2.default, alt: 'brighthive' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'slide' },
	              _react2.default.createElement(
	                'p',
	                { style: S.quote },
	                '"Loving the capabilities of @figmadesign & @HaikuForTeams this month. The best set of tools that we\'ve used for #UI & animation by far! Farewell Sketch & Aftereffects :( #uidesign"'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: S.personHolster },
	                _react2.default.createElement(
	                  'div',
	                  { style: S.avatarHolster },
	                  _react2.default.createElement('img', { src: _stu2.default, alt: 'person' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { style: S.quoteCredsLeft },
	                    _react2.default.createElement(
	                      'p',
	                      { style: S.name },
	                      'Stu Collett'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { style: S.position },
	                      'Experience & Product Design Director'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { style: S.quoteCredsRight },
	                    _react2.default.createElement('img', { style: S.quoteCompany, src: _sus2.default, alt: 'sus' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'slide' },
	              _react2.default.createElement(
	                'p',
	                { style: S.quote },
	                '"How is it that I hadn\'t heard of @HaikuForTeams yet?! Such a compelling product :o"'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: S.personHolster },
	                _react2.default.createElement(
	                  'div',
	                  { style: S.avatarHolster },
	                  _react2.default.createElement('img', { src: _josh2.default, alt: 'person' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { style: S.quoteCredsLeft },
	                    _react2.default.createElement(
	                      'p',
	                      { style: S.name },
	                      'Josh Comeau'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { style: S.position },
	                      'Software developer'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { style: S.quoteCredsRight },
	                    _react2.default.createElement('img', { style: S.quoteCompany, src: _khan2.default, alt: 'Khan Academy' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'slide' },
	              _react2.default.createElement(
	                'p',
	                { style: S.quote },
	                '"I\'ve just discovered  @HaikuForTeams and I\'ve fell in love at first sight, I foresee a great future developing animated @vuejs components with @sketchapp designs! #ILoveFrontEndDevelopment"'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: S.personHolster },
	                _react2.default.createElement(
	                  'div',
	                  { style: S.avatarHolster },
	                  _react2.default.createElement('img', { src: _alvaro2.default, alt: 'person' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'p',
	                    { style: S.name },
	                    'Alvaro Isorna'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { style: S.position },
	                    'Freelance Full-stack developer'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'cta', style: S.ctaSection },
	        _react2.default.createElement(_ctabg.CTASVG, null),
	        _react2.default.createElement(
	          'div',
	          { style: [_sharedStyles2.default.centerer, { position: 'relative', zIndex: 1 }] },
	          _react2.default.createElement(
	            'h1',
	            { style: [_shibui.typography.heading1, { color: _shibui.colors.ivory.color }] },
	            'Free and open source forever'
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              key: 'cta2',
	              style: [_sharedStyles2.default.btn, _sharedStyles2.default.cta],
	              href: 'https://github.com/HaikuTeam/animator/' },
	            'Download on Github'
	          )
	        )
	      ),
	      _react2.default.createElement(_mobileContent2.default, null)
	    );
	  };
	
	  return Animator;
	}(_react.Component);
	
	Animator.contextTypes = {
	  parallaxController: _react.PropTypes.object.isRequired
	};
	exports.default = (0, _radium2.default)(Animator);
	module.exports = exports['default'];

/***/ }),
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var type;
	try {
	  type = __webpack_require__(310);
	} catch (_) {
	  type = __webpack_require__(310);
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = clone;
	
	/**
	 * Clones objects.
	 *
	 * @param {Mixed} any object
	 * @api public
	 */
	
	function clone(obj){
	  switch (type(obj)) {
	    case 'object':
	      var copy = {};
	      for (var key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          copy[key] = clone(obj[key]);
	        }
	      }
	      return copy;
	
	    case 'array':
	      var copy = new Array(obj.length);
	      for (var i = 0, l = obj.length; i < l; i++) {
	        copy[i] = clone(obj[i]);
	      }
	      return copy;
	
	    case 'regexp':
	      // from millermedeiros/amd-utils - MIT
	      var flags = '';
	      flags += obj.multiline ? 'm' : '';
	      flags += obj.global ? 'g' : '';
	      flags += obj.ignoreCase ? 'i' : '';
	      return new RegExp(obj.source, flags);
	
	    case 'date':
	      return new Date(obj.getTime());
	
	    default: // string, number, boolean, …
	      return obj;
	  }
	}


/***/ }),
/* 524 */
/***/ (function(module, exports) {

	/**
	 * Expose `requestAnimationFrame()`.
	 */
	
	exports = module.exports = window.requestAnimationFrame
	  || window.webkitRequestAnimationFrame
	  || window.mozRequestAnimationFrame
	  || fallback;
	
	/**
	 * Fallback implementation.
	 */
	
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime();
	  var ms = Math.max(0, 16 - (curr - prev));
	  var req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	/**
	 * Cancel.
	 */
	
	var cancel = window.cancelAnimationFrame
	  || window.webkitCancelAnimationFrame
	  || window.mozCancelAnimationFrame
	  || window.clearTimeout;
	
	exports.cancel = function(id){
	  cancel.call(window, id);
	};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(526);
	var clone = __webpack_require__(523);
	var type = __webpack_require__(527);
	var ease = __webpack_require__(607);
	
	/**
	 * Expose `Tween`.
	 */
	
	module.exports = Tween;
	
	/**
	 * Initialize a new `Tween` with `obj`.
	 *
	 * @param {Object|Array} obj
	 * @api public
	 */
	
	function Tween(obj) {
	  if (!(this instanceof Tween)) return new Tween(obj);
	  this._from = obj;
	  this.ease('linear');
	  this.duration(500);
	}
	
	/**
	 * Mixin emitter.
	 */
	
	Emitter(Tween.prototype);
	
	/**
	 * Reset the tween.
	 *
	 * @api public
	 */
	
	Tween.prototype.reset = function(){
	  this.isArray = 'array' === type(this._from);
	  this._curr = clone(this._from);
	  this._done = false;
	  this._start = Date.now();
	  return this;
	};
	
	/**
	 * Tween to `obj` and reset internal state.
	 *
	 *    tween.to({ x: 50, y: 100 })
	 *
	 * @param {Object|Array} obj
	 * @return {Tween} self
	 * @api public
	 */
	
	Tween.prototype.to = function(obj){
	  this.reset();
	  this._to = obj;
	  return this;
	};
	
	/**
	 * Set duration to `ms` [500].
	 *
	 * @param {Number} ms
	 * @return {Tween} self
	 * @api public
	 */
	
	Tween.prototype.duration = function(ms){
	  this._duration = ms;
	  return this;
	};
	
	/**
	 * Set easing function to `fn`.
	 *
	 *    tween.ease('in-out-sine')
	 *
	 * @param {String|Function} fn
	 * @return {Tween}
	 * @api public
	 */
	
	Tween.prototype.ease = function(fn){
	  fn = 'function' == typeof fn ? fn : ease[fn];
	  if (!fn) throw new TypeError('invalid easing function');
	  this._ease = fn;
	  return this;
	};
	
	/**
	 * Stop the tween and immediately emit "stop" and "end".
	 *
	 * @return {Tween}
	 * @api public
	 */
	
	Tween.prototype.stop = function(){
	  this.stopped = true;
	  this._done = true;
	  this.emit('stop');
	  this.emit('end');
	  return this;
	};
	
	/**
	 * Perform a step.
	 *
	 * @return {Tween} self
	 * @api private
	 */
	
	Tween.prototype.step = function(){
	  if (this._done) return;
	
	  // duration
	  var duration = this._duration;
	  var now = Date.now();
	  var delta = now - this._start;
	  var done = delta >= duration;
	
	  // complete
	  if (done) {
	    this._from = this._to;
	    this._update(this._to);
	    this._done = true;
	    this.emit('end');
	    return this;
	  }
	
	  // tween
	  var from = this._from;
	  var to = this._to;
	  var curr = this._curr;
	  var fn = this._ease;
	  var p = (now - this._start) / duration;
	  var n = fn(p);
	
	  // array
	  if (this.isArray) {
	    for (var i = 0; i < from.length; ++i) {
	      curr[i] = from[i] + (to[i] - from[i]) * n;
	    }
	
	    this._update(curr);
	    return this;
	  }
	
	  // objech
	  for (var k in from) {
	    curr[k] = from[k] + (to[k] - from[k]) * n;
	  }
	
	  this._update(curr);
	  return this;
	};
	
	/**
	 * Set update function to `fn` or
	 * when no argument is given this performs
	 * a "step".
	 *
	 * @param {Function} fn
	 * @return {Tween} self
	 * @api public
	 */
	
	Tween.prototype.update = function(fn){
	  if (0 == arguments.length) return this.step();
	  this._update = fn;
	  return this;
	};

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	/**
	 * toString ref.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Return the type of `val`.
	 *
	 * @param {Mixed} val
	 * @return {String}
	 * @api public
	 */
	
	module.exports = function(val){
	  switch (toString.call(val)) {
	    case '[object Date]': return 'date';
	    case '[object RegExp]': return 'regexp';
	    case '[object Arguments]': return 'arguments';
	    case '[object Array]': return 'array';
	    case '[object Error]': return 'error';
	  }
	
	  if (val === null) return 'null';
	  if (val === undefined) return 'undefined';
	  if (val !== val) return 'nan';
	  if (val && val.nodeType === 1) return 'element';
	
	  val = val.valueOf
	    ? val.valueOf()
	    : Object.prototype.valueOf.apply(val)
	
	  return typeof val;
	};


/***/ }),
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ v1.0.5 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI,
	    halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11,
	    b2 = 6 / 11,
	    b3 = 8 / 11,
	    b4 = 3 / 4,
	    b5 = 9 / 11,
	    b6 = 10 / 11,
	    b7 = 15 / 16,
	    b8 = 21 / 22,
	    b9 = 63 / 64,
	    b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI,
	    amplitude = 1,
	    period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */
/***/ (function(module, exports) {

	
	// easing functions from "Tween.js"
	
	exports.linear = function(n){
	  return n;
	};
	
	exports.inQuad = function(n){
	  return n * n;
	};
	
	exports.outQuad = function(n){
	  return n * (2 - n);
	};
	
	exports.inOutQuad = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n;
	  return - 0.5 * (--n * (n - 2) - 1);
	};
	
	exports.inCube = function(n){
	  return n * n * n;
	};
	
	exports.outCube = function(n){
	  return --n * n * n + 1;
	};
	
	exports.inOutCube = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n * n;
	  return 0.5 * ((n -= 2 ) * n * n + 2);
	};
	
	exports.inQuart = function(n){
	  return n * n * n * n;
	};
	
	exports.outQuart = function(n){
	  return 1 - (--n * n * n * n);
	};
	
	exports.inOutQuart = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n * n * n;
	  return -0.5 * ((n -= 2) * n * n * n - 2);
	};
	
	exports.inQuint = function(n){
	  return n * n * n * n * n;
	}
	
	exports.outQuint = function(n){
	  return --n * n * n * n * n + 1;
	}
	
	exports.inOutQuint = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n * n * n * n;
	  return 0.5 * ((n -= 2) * n * n * n * n + 2);
	};
	
	exports.inSine = function(n){
	  return 1 - Math.cos(n * Math.PI / 2 );
	};
	
	exports.outSine = function(n){
	  return Math.sin(n * Math.PI / 2);
	};
	
	exports.inOutSine = function(n){
	  return .5 * (1 - Math.cos(Math.PI * n));
	};
	
	exports.inExpo = function(n){
	  return 0 == n ? 0 : Math.pow(1024, n - 1);
	};
	
	exports.outExpo = function(n){
	  return 1 == n ? n : 1 - Math.pow(2, -10 * n);
	};
	
	exports.inOutExpo = function(n){
	  if (0 == n) return 0;
	  if (1 == n) return 1;
	  if ((n *= 2) < 1) return .5 * Math.pow(1024, n - 1);
	  return .5 * (-Math.pow(2, -10 * (n - 1)) + 2);
	};
	
	exports.inCirc = function(n){
	  return 1 - Math.sqrt(1 - n * n);
	};
	
	exports.outCirc = function(n){
	  return Math.sqrt(1 - (--n * n));
	};
	
	exports.inOutCirc = function(n){
	  n *= 2
	  if (n < 1) return -0.5 * (Math.sqrt(1 - n * n) - 1);
	  return 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1);
	};
	
	exports.inBack = function(n){
	  var s = 1.70158;
	  return n * n * (( s + 1 ) * n - s);
	};
	
	exports.outBack = function(n){
	  var s = 1.70158;
	  return --n * n * ((s + 1) * n + s) + 1;
	};
	
	exports.inOutBack = function(n){
	  var s = 1.70158 * 1.525;
	  if ( ( n *= 2 ) < 1 ) return 0.5 * ( n * n * ( ( s + 1 ) * n - s ) );
	  return 0.5 * ( ( n -= 2 ) * n * ( ( s + 1 ) * n + s ) + 2 );
	};
	
	exports.inBounce = function(n){
	  return 1 - exports.outBounce(1 - n);
	};
	
	exports.outBounce = function(n){
	  if ( n < ( 1 / 2.75 ) ) {
	    return 7.5625 * n * n;
	  } else if ( n < ( 2 / 2.75 ) ) {
	    return 7.5625 * ( n -= ( 1.5 / 2.75 ) ) * n + 0.75;
	  } else if ( n < ( 2.5 / 2.75 ) ) {
	    return 7.5625 * ( n -= ( 2.25 / 2.75 ) ) * n + 0.9375;
	  } else {
	    return 7.5625 * ( n -= ( 2.625 / 2.75 ) ) * n + 0.984375;
	  }
	};
	
	exports.inOutBounce = function(n){
	  if (n < .5) return exports.inBounce(n * 2) * .5;
	  return exports.outBounce(n * 2 - 1) * .5 + .5;
	};
	
	// aliases
	
	exports['in-quad'] = exports.inQuad;
	exports['out-quad'] = exports.outQuad;
	exports['in-out-quad'] = exports.inOutQuad;
	exports['in-cube'] = exports.inCube;
	exports['out-cube'] = exports.outCube;
	exports['in-out-cube'] = exports.inOutCube;
	exports['in-quart'] = exports.inQuart;
	exports['out-quart'] = exports.outQuart;
	exports['in-out-quart'] = exports.inOutQuart;
	exports['in-quint'] = exports.inQuint;
	exports['out-quint'] = exports.outQuint;
	exports['in-out-quint'] = exports.inOutQuint;
	exports['in-sine'] = exports.inSine;
	exports['out-sine'] = exports.outSine;
	exports['in-out-sine'] = exports.inOutSine;
	exports['in-expo'] = exports.inExpo;
	exports['out-expo'] = exports.outExpo;
	exports['in-out-expo'] = exports.inOutExpo;
	exports['in-circ'] = exports.inCirc;
	exports['out-circ'] = exports.outCirc;
	exports['in-out-circ'] = exports.inOutCirc;
	exports['in-back'] = exports.inBack;
	exports['out-back'] = exports.outBack;
	exports['in-out-back'] = exports.inOutBack;
	exports['in-bounce'] = exports.inBounce;
	exports['out-bounce'] = exports.outBounce;
	exports['in-out-bounce'] = exports.inOutBounce;


/***/ }),
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _d3Timer = __webpack_require__(334);
	
	var _utils = __webpack_require__(346);
	
	var _Events = _interopRequireDefault(__webpack_require__(767));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var BaseNode =
	/*#__PURE__*/
	function () {
	  function BaseNode(state) {
	    _classCallCheck(this, BaseNode);
	
	    this.state = state || {};
	  }
	
	  _createClass(BaseNode, [{
	    key: "transition",
	    value: function transition(config) {
	      if (Array.isArray(config)) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = config[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	            this.parse(item);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return != null) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      } else {
	        this.parse(config);
	      }
	    }
	  }, {
	    key: "isTransitioning",
	    value: function isTransitioning() {
	      return !!this.transitionData;
	    }
	  }, {
	    key: "stopTransitions",
	    value: function stopTransitions() {
	      var transitions = this.transitionData;
	
	      if (transitions) {
	        Object.keys(transitions).forEach(function (t) {
	          transitions[t].timer.stop();
	        });
	      }
	    }
	  }, {
	    key: "setState",
	    value: function setState(update) {
	      if (typeof update === 'function') {
	        (0, _utils.extend)(this.state, update(this.state));
	      } else {
	        (0, _utils.extend)(this.state, update);
	      }
	    }
	  }, {
	    key: "getInterpolator",
	    value: function getInterpolator(begValue, endValue, attr, nameSpace) {
	      throw new Error('You must implement getInterpolator.');
	    }
	  }, {
	    key: "parse",
	    value: function parse(config) {
	      var _this = this;
	
	      var clone = _objectSpread({}, config);
	
	      var events = new _Events.default(clone);
	
	      if (clone.events) {
	        delete clone.events;
	      }
	
	      var timing = _objectSpread({}, _utils.timingDefaults, {}, clone.timing || {}, {
	        time: (0, _d3Timer.now)()
	      });
	
	      if (clone.timing) {
	        delete clone.timing;
	      }
	
	      Object.keys(clone).forEach(function (stateKey) {
	        var tweens = [];
	        var next = clone[stateKey];
	
	        if (_typeof(next) === 'object' && Array.isArray(next) === false) {
	          Object.keys(next).forEach(function (attr) {
	            var val = next[attr];
	
	            if (Array.isArray(val)) {
	              if (val.length === 1) {
	                tweens.push(_this.getTween(attr, val[0], stateKey));
	              } else {
	                _this.setState(function (state) {
	                  var _objectSpread2, _ref;
	
	                  return _ref = {}, _ref[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread2 = {}, _objectSpread2[attr] = val[0], _objectSpread2)), _ref;
	                });
	
	                tweens.push(_this.getTween(attr, val[1], stateKey));
	              }
	            } else if (typeof val === 'function') {
	              var getNameSpacedCustomTween = function getNameSpacedCustomTween() {
	                var kapellmeisterNamespacedTween = function kapellmeisterNamespacedTween(t) {
	                  _this.setState(function (state) {
	                    var _objectSpread3, _ref2;
	
	                    return _ref2 = {}, _ref2[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread3 = {}, _objectSpread3[attr] = val(t), _objectSpread3)), _ref2;
	                  });
	                };
	
	                return kapellmeisterNamespacedTween;
	              };
	
	              tweens.push(getNameSpacedCustomTween);
	            } else {
	              _this.setState(function (state) {
	                var _objectSpread4, _ref3;
	
	                return _ref3 = {}, _ref3[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread4 = {}, _objectSpread4[attr] = val, _objectSpread4)), _ref3;
	              });
	
	              tweens.push(_this.getTween(attr, val, stateKey));
	            }
	          });
	        } else {
	          if (Array.isArray(next)) {
	            if (next.length === 1) {
	              tweens.push(_this.getTween(stateKey, next[0], null));
	            } else {
	              var _this$setState;
	
	              _this.setState((_this$setState = {}, _this$setState[stateKey] = next[0], _this$setState));
	
	              tweens.push(_this.getTween(stateKey, next[1], null));
	            }
	          } else if (typeof next === 'function') {
	            var getCustomTween = function getCustomTween() {
	              var kapellmeisterTween = function kapellmeisterTween(t) {
	                var _this$setState2;
	
	                _this.setState((_this$setState2 = {}, _this$setState2[stateKey] = next(t), _this$setState2));
	              };
	
	              return kapellmeisterTween;
	            };
	
	            tweens.push(getCustomTween);
	          } else {
	            var _this$setState3;
	
	            _this.setState((_this$setState3 = {}, _this$setState3[stateKey] = next, _this$setState3));
	
	            tweens.push(_this.getTween(stateKey, next, null));
	          }
	        }
	
	        _this.update({
	          stateKey: stateKey,
	          timing: timing,
	          tweens: tweens,
	          events: events,
	          status: 0
	        });
	      });
	    }
	  }, {
	    key: "getTween",
	    value: function getTween(attr, endValue, nameSpace) {
	      var _this2 = this;
	
	      return function () {
	        var begValue = nameSpace ? _this2.state[nameSpace][attr] : _this2.state[attr];
	
	        if (begValue === endValue) {
	          return null;
	        }
	
	        var i = _this2.getInterpolator(begValue, endValue, attr, nameSpace);
	
	        var stateTween;
	
	        if (nameSpace === null) {
	          stateTween = function stateTween(t) {
	            var _this2$setState;
	
	            _this2.setState((_this2$setState = {}, _this2$setState[attr] = i(t), _this2$setState));
	          };
	        } else {
	          stateTween = function stateTween(t) {
	            _this2.setState(function (state) {
	              var _objectSpread5, _ref4;
	
	              return _ref4 = {}, _ref4[nameSpace] = _objectSpread({}, state[nameSpace], (_objectSpread5 = {}, _objectSpread5[attr] = i(t), _objectSpread5)), _ref4;
	            });
	          };
	        }
	
	        return stateTween;
	      };
	    }
	  }, {
	    key: "update",
	    value: function update(transition) {
	      if (!this.transitionData) {
	        this.transitionData = {};
	      }
	
	      this.init((0, _utils.getTransitionId)(), transition);
	    }
	  }, {
	    key: "init",
	    value: function init(id, transition) {
	      var _this3 = this;
	
	      var n = transition.tweens.length;
	      var tweens = new Array(n);
	
	      var queue = function queue(elapsed) {
	        transition.status = 1;
	        transition.timer.restart(start, transition.timing.delay, transition.timing.time);
	
	        if (transition.timing.delay <= elapsed) {
	          start(elapsed - transition.timing.delay);
	        }
	      };
	
	      this.transitionData[id] = transition;
	      transition.timer = (0, _d3Timer.timer)(queue, 0, transition.timing.time);
	
	      var start = function start(elapsed) {
	        if (transition.status !== 1) return stop();
	
	        for (var tid in _this3.transitionData) {
	          var t = _this3.transitionData[tid];
	
	          if (t.stateKey !== transition.stateKey) {
	            continue;
	          }
	
	          if (t.status === 3) {
	            return (0, _d3Timer.timeout)(start);
	          }
	
	          if (t.status === 4) {
	            t.status = 6;
	            t.timer.stop();
	
	            if (t.events.interrupt) {
	              t.events.interrupt.call(_this3);
	            }
	
	            delete _this3.transitionData[tid];
	          } else if (+tid < id) {
	            t.status = 6;
	            t.timer.stop();
	            delete _this3.transitionData[tid];
	          }
	        }
	
	        (0, _d3Timer.timeout)(function () {
	          if (transition.status === 3) {
	            transition.status = 4;
	            transition.timer.restart(tick, transition.timing.delay, transition.timing.time);
	            tick(elapsed);
	          }
	        });
	        transition.status = 2;
	
	        if (transition.events.start) {
	          transition.events.start.call(_this3);
	        }
	
	        if (transition.status !== 2) {
	          return;
	        }
	
	        transition.status = 3;
	        var j = -1;
	
	        for (var i = 0; i < n; ++i) {
	          var res = transition.tweens[i]();
	
	          if (res) {
	            tweens[++j] = res;
	          }
	        }
	
	        tweens.length = j + 1;
	      };
	
	      var tick = function tick(elapsed) {
	        var t = 1;
	
	        if (elapsed < transition.timing.duration) {
	          t = transition.timing.ease(elapsed / transition.timing.duration);
	        } else {
	          transition.timer.restart(stop);
	          transition.status = 5;
	        }
	
	        var i = -1;
	
	        while (++i < tweens.length) {
	          tweens[i](t);
	        }
	
	        if (transition.status === 5) {
	          if (transition.events.end) {
	            transition.events.end.call(_this3);
	          }
	
	          stop();
	        }
	      };
	
	      var stop = function stop() {
	        transition.status = 6;
	        transition.timer.stop();
	        delete _this3.transitionData[id];
	
	        for (var i in _this3.transitionData) {
	          return;
	        }
	
	        delete _this3.transitionData;
	      };
	    }
	  }]);
	
	  return BaseNode;
	}();
	
	var _default = BaseNode;
	exports.default = _default;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Events = void 0;
	
	var _utils = __webpack_require__(346);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Events = function Events(config) {
	  var _this = this;
	
	  _classCallCheck(this, Events);
	
	  this.start = null;
	  this.interrupt = null;
	  this.end = null;
	
	  if (config.events) {
	    Object.keys(config.events).forEach(function (d) {
	      if (typeof config.events[d] !== 'function') {
	        throw new Error('Event handlers must be a function');
	      } else {
	        _this[d] = (0, _utils.once)(config.events[d]);
	      }
	    });
	  }
	};
	
	exports.Events = Events;
	var _default = Events;
	exports.default = _default;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "BaseNode", {
	  enumerable: true,
	  get: function get() {
	    return _BaseNode.default;
	  }
	});
	Object.defineProperty(exports, "now", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.now;
	  }
	});
	Object.defineProperty(exports, "timer", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.timer;
	  }
	});
	Object.defineProperty(exports, "interval", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.interval;
	  }
	});
	Object.defineProperty(exports, "timeout", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.timeout;
	  }
	});
	
	var _BaseNode = _interopRequireDefault(__webpack_require__(766));
	
	var _d3Timer = __webpack_require__(334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(865).default;
	module.exports.default = module.exports;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _scrollTransition = _interopRequireDefault(__webpack_require__(867));
	
	var _fadeTransition = _interopRequireDefault(__webpack_require__(866));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  fade: _fadeTransition.default,
	  scroll: _scrollTransition.default
	};
	exports.default = _default;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.defaultRenderAnnounceSlideMessage = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnnounceSlide = function AnnounceSlide(_ref) {
	  var message = _ref.message;
	  var styles = {
	    position: 'absolute',
	    left: '-10000px',
	    top: 'auto',
	    width: '1px',
	    height: '1px',
	    overflow: 'hidden'
	  };
	  return _react.default.createElement("div", {
	    "aria-live": "polite",
	    "aria-atomic": "true",
	    style: styles,
	    tabIndex: -1
	  }, message);
	};
	
	var defaultRenderAnnounceSlideMessage = function defaultRenderAnnounceSlideMessage(_ref2) {
	  var currentSlide = _ref2.currentSlide,
	      slideCount = _ref2.slideCount;
	  return "Slide ".concat(currentSlide + 1, " of ").concat(slideCount);
	};
	
	exports.defaultRenderAnnounceSlideMessage = defaultRenderAnnounceSlideMessage;
	var _default = AnnounceSlide;
	exports.default = _default;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PagingDots = exports.NextButton = exports.PreviousButton = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var defaultButtonStyles = function defaultButtonStyles(disabled) {
	  return {
	    border: 0,
	    background: 'rgba(0,0,0,0.4)',
	    color: 'white',
	    padding: 10,
	    opacity: disabled ? 0.3 : 1,
	    cursor: disabled ? 'not-allowed' : 'pointer'
	  };
	};
	
	var PreviousButton =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(PreviousButton, _React$Component);
	
	  function PreviousButton() {
	    var _this;
	
	    _classCallCheck(this, PreviousButton);
	
	    _this = _possibleConstructorReturn(this, (PreviousButton.__proto__ || Object.getPrototypeOf(PreviousButton)).apply(this, arguments));
	    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(PreviousButton, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.props.previousSlide();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var disabled = this.props.currentSlide === 0 && !this.props.wrapAround || this.props.slideCount === 0;
	      return _react.default.createElement("button", {
	        style: defaultButtonStyles(disabled),
	        disabled: disabled,
	        onClick: this.handleClick,
	        "aria-label": "previous"
	      }, "PREV");
	    }
	  }]);
	
	  return PreviousButton;
	}(_react.default.Component);
	
	exports.PreviousButton = PreviousButton;
	
	var NextButton =
	/*#__PURE__*/
	function (_React$Component2) {
	  _inherits(NextButton, _React$Component2);
	
	  function NextButton() {
	    var _this2;
	
	    _classCallCheck(this, NextButton);
	
	    _this2 = _possibleConstructorReturn(this, (NextButton.__proto__ || Object.getPrototypeOf(NextButton)).apply(this, arguments));
	    _this2.handleClick = _this2.handleClick.bind(_assertThisInitialized(_this2));
	    _this2.nextButtonDisable = _this2.nextButtonDisabled.bind(_assertThisInitialized(_this2));
	    return _this2;
	  }
	
	  _createClass(NextButton, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.props.nextSlide();
	    }
	  }, {
	    key: "nextButtonDisabled",
	    value: function nextButtonDisabled(params) {
	      var wrapAround = params.wrapAround,
	          slidesToShow = params.slidesToShow,
	          currentSlide = params.currentSlide,
	          cellAlign = params.cellAlign,
	          slideCount = params.slideCount;
	      var buttonDisabled = false;
	
	      if (!wrapAround) {
	        var lastSlideIndex = slideCount - 1;
	        var slidesShowing = slidesToShow;
	        var lastSlideOffset = 0;
	
	        switch (cellAlign) {
	          case 'center':
	            slidesShowing = (slidesToShow - 1) * 0.5;
	            lastSlideOffset = Math.floor(slidesToShow * 0.5) - 1;
	            break;
	
	          case 'right':
	            slidesShowing = 1;
	            break;
	        }
	
	        if (slidesToShow > 1) {
	          buttonDisabled = currentSlide + slidesShowing > lastSlideIndex + lastSlideOffset;
	        } else {
	          buttonDisabled = currentSlide + 1 > lastSlideIndex;
	        }
	      }
	
	      return buttonDisabled;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          wrapAround = _props.wrapAround,
	          slidesToShow = _props.slidesToShow,
	          currentSlide = _props.currentSlide,
	          cellAlign = _props.cellAlign,
	          slideCount = _props.slideCount;
	      var disabled = this.nextButtonDisabled({
	        wrapAround: wrapAround,
	        slidesToShow: slidesToShow,
	        currentSlide: currentSlide,
	        cellAlign: cellAlign,
	        slideCount: slideCount
	      });
	      return _react.default.createElement("button", {
	        style: defaultButtonStyles(disabled),
	        disabled: disabled,
	        onClick: this.handleClick,
	        "aria-label": "next"
	      }, "NEXT");
	    }
	  }]);
	
	  return NextButton;
	}(_react.default.Component);
	
	exports.NextButton = NextButton;
	
	var PagingDots =
	/*#__PURE__*/
	function (_React$Component3) {
	  _inherits(PagingDots, _React$Component3);
	
	  function PagingDots() {
	    _classCallCheck(this, PagingDots);
	
	    return _possibleConstructorReturn(this, (PagingDots.__proto__ || Object.getPrototypeOf(PagingDots)).apply(this, arguments));
	  }
	
	  _createClass(PagingDots, [{
	    key: "getDotIndexes",
	    value: function getDotIndexes(slideCount, slidesToScroll, slidesToShow, cellAlign) {
	      var dotIndexes = [];
	      var lastDotIndex = slideCount - slidesToShow;
	
	      switch (cellAlign) {
	        case 'center':
	        case 'right':
	          lastDotIndex += slidesToShow - 1;
	          break;
	      }
	
	      if (lastDotIndex < 0) {
	        return [0];
	      }
	
	      for (var i = 0; i < lastDotIndex; i += slidesToScroll) {
	        dotIndexes.push(i);
	      }
	
	      dotIndexes.push(lastDotIndex);
	      return dotIndexes;
	    }
	  }, {
	    key: "getListStyles",
	    value: function getListStyles() {
	      return {
	        position: 'relative',
	        margin: 0,
	        top: -10,
	        padding: 0
	      };
	    }
	  }, {
	    key: "getListItemStyles",
	    value: function getListItemStyles() {
	      return {
	        listStyleType: 'none',
	        display: 'inline-block'
	      };
	    }
	  }, {
	    key: "getButtonStyles",
	    value: function getButtonStyles(active) {
	      return {
	        border: 0,
	        background: 'transparent',
	        color: 'black',
	        cursor: 'pointer',
	        padding: 10,
	        fontSize: 24,
	        opacity: active ? 1 : 0.5
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var indexes = this.getDotIndexes(this.props.slideCount, this.props.slidesToScroll, this.props.slidesToShow, this.props.cellAlign);
	      return _react.default.createElement("ul", {
	        style: this.getListStyles()
	      }, indexes.map(function (index) {
	        return _react.default.createElement("li", {
	          style: _this3.getListItemStyles(),
	          key: index
	        }, _react.default.createElement("button", {
	          style: _this3.getButtonStyles(_this3.props.currentSlide === index),
	          onClick: _this3.props.goToSlide.bind(null, index),
	          "aria-label": "slide ".concat(index + 1, " bullet")
	        }, "\u2022"));
	      }));
	    }
	  }]);
	
	  return PagingDots;
	}(_react.default.Component);
	
	exports.PagingDots = PagingDots;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "PagingDots", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.PagingDots;
	  }
	});
	Object.defineProperty(exports, "PreviousButton", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.PreviousButton;
	  }
	});
	Object.defineProperty(exports, "NextButton", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.NextButton;
	  }
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _exenv = _interopRequireDefault(__webpack_require__(264));
	
	var _Animate = _interopRequireDefault(__webpack_require__(1041));
	
	var easing = _interopRequireWildcard(__webpack_require__(597));
	
	var _defaultControls = __webpack_require__(864);
	
	var _allTransitions = _interopRequireDefault(__webpack_require__(862));
	
	var _announceSlide = _interopRequireWildcard(__webpack_require__(863));
	
	var _utilities = __webpack_require__(870);
	
	var _styleUtilities = __webpack_require__(869);
	
	var _bootstrappingUtilities = __webpack_require__(868);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var Carousel =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  function Carousel() {
	    var _this;
	
	    _classCallCheck(this, Carousel);
	
	    _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).apply(this, arguments));
	    _this.displayName = 'Carousel';
	    _this.clickDisabled = false;
	    _this.isTransitioning = false;
	    _this.touchObject = {};
	    _this.controlsMap = [{
	      funcName: 'renderTopLeftControls',
	      key: 'TopLeft'
	    }, {
	      funcName: 'renderTopCenterControls',
	      key: 'TopCenter'
	    }, {
	      funcName: 'renderTopRightControls',
	      key: 'TopRight'
	    }, {
	      funcName: 'renderCenterLeftControls',
	      key: 'CenterLeft'
	    }, {
	      funcName: 'renderCenterCenterControls',
	      key: 'CenterCenter'
	    }, {
	      funcName: 'renderCenterRightControls',
	      key: 'CenterRight'
	    }, {
	      funcName: 'renderBottomLeftControls',
	      key: 'BottomLeft'
	    }, {
	      funcName: 'renderBottomCenterControls',
	      key: 'BottomCenter'
	    }, {
	      funcName: 'renderBottomRightControls',
	      key: 'BottomRight'
	    }];
	    _this.state = _objectSpread({
	      currentSlide: _this.props.slideIndex,
	      dragging: false,
	      easing: _this.props.disableAnimation ? '' : easing.easeCircleOut,
	      hasInteraction: false,
	      // to remove animation from the initial slide on the page load when non-default slideIndex is used
	      isWrappingAround: false,
	      left: 0,
	      resetWrapAroundPosition: false,
	      slideCount: (0, _bootstrappingUtilities.getValidChildren)(_this.props.children).length,
	      top: 0,
	      wrapToIndex: null
	    }, (0, _utilities.calcSomeInitialState)(_this.props));
	    _this.autoplayIterator = _this.autoplayIterator.bind(_assertThisInitialized(_this));
	    _this.calcSlideHeightAndWidth = _this.calcSlideHeightAndWidth.bind(_assertThisInitialized(_this));
	    _this.getChildNodes = _this.getChildNodes.bind(_assertThisInitialized(_this));
	    _this.getMouseEvents = _this.getMouseEvents.bind(_assertThisInitialized(_this));
	    _this.getOffsetDeltas = _this.getOffsetDeltas.bind(_assertThisInitialized(_this));
	    _this.getTargetLeft = _this.getTargetLeft.bind(_assertThisInitialized(_this));
	    _this.getTouchEvents = _this.getTouchEvents.bind(_assertThisInitialized(_this));
	    _this.goToSlide = _this.goToSlide.bind(_assertThisInitialized(_this));
	    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
	    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_this));
	    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized(_this));
	    _this.handleSwipe = _this.handleSwipe.bind(_assertThisInitialized(_this));
	    _this.nextSlide = _this.nextSlide.bind(_assertThisInitialized(_this));
	    _this.onReadyStateChange = _this.onReadyStateChange.bind(_assertThisInitialized(_this));
	    _this.onResize = _this.onResize.bind(_assertThisInitialized(_this));
	    _this.onVisibilityChange = _this.onVisibilityChange.bind(_assertThisInitialized(_this));
	    _this.previousSlide = _this.previousSlide.bind(_assertThisInitialized(_this));
	    _this.renderControls = _this.renderControls.bind(_assertThisInitialized(_this));
	    _this.resetAutoplay = _this.resetAutoplay.bind(_assertThisInitialized(_this));
	    _this.setDimensions = _this.setDimensions.bind(_assertThisInitialized(_this));
	    _this.setLeft = _this.setLeft.bind(_assertThisInitialized(_this));
	    _this.setSlideHeightAndWidth = _this.setSlideHeightAndWidth.bind(_assertThisInitialized(_this));
	    _this.startAutoplay = _this.startAutoplay.bind(_assertThisInitialized(_this));
	    _this.stopAutoplay = _this.stopAutoplay.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(Carousel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	      this.mounted = true;
	      this.setLeft();
	      this.setDimensions();
	      this.bindEvents();
	
	      if (this.props.autoplay) {
	        this.startAutoplay();
	      }
	    } // @TODO Remove deprecated componentWillReceiveProps with getDerivedStateFromProps
	    // eslint-disable-next-line react/no-deprecated
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var slideCount = (0, _bootstrappingUtilities.getValidChildren)(nextProps.children).length;
	      var slideCountChanged = slideCount !== this.state.slideCount;
	      this.setState(function (prevState) {
	        return {
	          slideCount: slideCount,
	          currentSlide: slideCountChanged ? nextProps.slideIndex : prevState.currentSlide
	        };
	      });
	
	      if (slideCount <= this.state.currentSlide) {
	        this.goToSlide(Math.max(slideCount - 1, 0), nextProps);
	      }
	
	      var updateDimensions = slideCountChanged || (0, _utilities.shouldUpdate)(this.props, nextProps, ['cellSpacing', 'vertical', 'slideWidth', 'slideHeight', 'heightMode', 'slidesToScroll', 'slidesToShow', 'transitionMode', 'cellAlign']);
	
	      if (updateDimensions) {
	        this.setDimensions(nextProps);
	      }
	
	      if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide && !this.state.isWrappingAround) {
	        this.goToSlide(nextProps.slideIndex, this.props);
	      }
	
	      if (this.props.autoplay !== nextProps.autoplay) {
	        if (nextProps.autoplay) {
	          this.startAutoplay();
	        } else {
	          this.stopAutoplay();
	        }
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var slideChanged = prevState.currentSlide !== this.state.currentSlide;
	      var heightModeChanged = prevProps.heightMode !== this.props.heightMode;
	
	      if (slideChanged || heightModeChanged) {
	        this.setSlideHeightAndWidth();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unbindEvents();
	      this.stopAutoplay(); // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	
	      this.mounted = false;
	    }
	  }, {
	    key: "getTouchEvents",
	    value: function getTouchEvents() {
	      var _this2 = this;
	
	      if (this.props.swiping === false) {
	        return {
	          onTouchStart: function onTouchStart() {
	            _this2.handleMouseOver();
	          },
	          onTouchEnd: function onTouchEnd() {
	            _this2.handleMouseOut();
	          }
	        };
	      }
	
	      return {
	        onTouchStart: function onTouchStart(e) {
	          _this2.touchObject = {
	            startX: e.touches[0].pageX,
	            startY: e.touches[0].pageY
	          };
	
	          _this2.handleMouseOver();
	
	          _this2.setState({
	            dragging: true
	          });
	        },
	        onTouchMove: function onTouchMove(e) {
	          var direction = (0, _utilities.swipeDirection)(_this2.touchObject.startX, e.touches[0].pageX, _this2.touchObject.startY, e.touches[0].pageY, _this2.props.vertical);
	
	          if (direction !== 0) {
	            e.preventDefault();
	          }
	
	          var length = _this2.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - _this2.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - _this2.touchObject.startX, 2)));
	          _this2.touchObject = {
	            startX: _this2.touchObject.startX,
	            startY: _this2.touchObject.startY,
	            endX: e.touches[0].pageX,
	            endY: e.touches[0].pageY,
	            length: length,
	            direction: direction
	          };
	
	          _this2.setState({
	            left: _this2.props.vertical ? 0 : _this2.getTargetLeft(_this2.touchObject.length * _this2.touchObject.direction),
	            top: _this2.props.vertical ? _this2.getTargetLeft(_this2.touchObject.length * _this2.touchObject.direction) : 0
	          });
	        },
	        onTouchEnd: function onTouchEnd(e) {
	          _this2.handleSwipe(e);
	
	          _this2.handleMouseOut();
	        },
	        onTouchCancel: function onTouchCancel(e) {
	          _this2.handleSwipe(e);
	        }
	      };
	    }
	  }, {
	    key: "getMouseEvents",
	    value: function getMouseEvents() {
	      var _this3 = this;
	
	      if (this.props.dragging === false) {
	        return {
	          onMouseOver: function onMouseOver() {
	            return _this3.handleMouseOver();
	          },
	          onMouseOut: function onMouseOut() {
	            return _this3.handleMouseOut();
	          }
	        };
	      }
	
	      return {
	        onMouseOver: function onMouseOver() {
	          return _this3.handleMouseOver();
	        },
	        onMouseOut: function onMouseOut() {
	          return _this3.handleMouseOut();
	        },
	        onMouseDown: function onMouseDown(e) {
	          _this3.touchObject = {
	            startX: e.clientX,
	            startY: e.clientY
	          };
	
	          _this3.setState({
	            dragging: true
	          });
	        },
	        onMouseMove: function onMouseMove(e) {
	          if (!_this3.state.dragging) {
	            return;
	          }
	
	          var direction = (0, _utilities.swipeDirection)(_this3.touchObject.startX, e.clientX, _this3.touchObject.startY, e.clientY, _this3.props.vertical);
	
	          if (direction !== 0) {
	            e.preventDefault();
	          }
	
	          var length = _this3.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - _this3.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - _this3.touchObject.startX, 2))); // prevents disabling click just because mouse moves a fraction of a pixel
	
	          if (length >= 10) _this3.clickDisabled = true;
	          _this3.touchObject = {
	            startX: _this3.touchObject.startX,
	            startY: _this3.touchObject.startY,
	            endX: e.clientX,
	            endY: e.clientY,
	            length: length,
	            direction: direction
	          };
	
	          _this3.setState({
	            left: _this3.props.vertical ? 0 : _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction),
	            top: _this3.props.vertical ? _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction) : 0
	          });
	        },
	        onMouseUp: function onMouseUp(e) {
	          if (_this3.touchObject.length === 0 || _this3.touchObject.length === undefined) {
	            _this3.setState({
	              dragging: false
	            });
	
	            return;
	          }
	
	          _this3.handleSwipe(e);
	        },
	        onMouseLeave: function onMouseLeave(e) {
	          if (!_this3.state.dragging) {
	            return;
	          }
	
	          _this3.handleSwipe(e);
	        }
	      };
	    }
	  }, {
	    key: "pauseAutoplay",
	    value: function pauseAutoplay() {
	      if (this.props.autoplay) {
	        this.autoplayPaused = true;
	        this.stopAutoplay();
	      }
	    }
	  }, {
	    key: "unpauseAutoplay",
	    value: function unpauseAutoplay() {
	      if (this.props.autoplay && this.autoplayPaused) {
	        this.startAutoplay();
	        this.autoplayPaused = null;
	      }
	    }
	  }, {
	    key: "handleMouseOver",
	    value: function handleMouseOver() {
	      if (this.props.pauseOnHover) {
	        this.pauseAutoplay();
	      }
	    }
	  }, {
	    key: "handleMouseOut",
	    value: function handleMouseOut() {
	      if (this.autoplayPaused) {
	        this.unpauseAutoplay();
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      if (this.clickDisabled === true) {
	        if (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey) {
	          return;
	        }
	
	        event.preventDefault();
	        event.stopPropagation();
	
	        if (event.nativeEvent) {
	          event.nativeEvent.stopPropagation();
	        }
	      }
	    }
	  }, {
	    key: "handleSwipe",
	    value: function handleSwipe() {
	      var _this4 = this;
	
	      var slidesToShow = this.state.slidesToShow;
	
	      if (this.props.slidesToScroll === 'auto') {
	        slidesToShow = this.state.slidesToScroll;
	      }
	
	      if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
	        if (this.touchObject.direction === 1) {
	          if (this.state.currentSlide >= this.state.slideCount - slidesToShow && !this.props.wrapAround) {
	            this.setState({
	              easing: easing[this.props.edgeEasing]
	            });
	          } else {
	            this.nextSlide();
	          }
	        } else if (this.touchObject.direction === -1) {
	          if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	            this.setState({
	              easing: easing[this.props.edgeEasing]
	            });
	          } else {
	            this.previousSlide();
	          }
	        }
	      } else {
	        this.goToSlide(this.state.currentSlide);
	      } // wait for `handleClick` event before resetting clickDisabled
	
	
	      setTimeout(function () {
	        _this4.clickDisabled = false;
	      }, 0);
	      this.touchObject = {};
	      this.setState({
	        dragging: false
	      });
	    } // eslint-disable-next-line complexity
	
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(e) {
	      if (this.props.enableKeyboardControls) {
	        switch (e.keyCode) {
	          case 39:
	          case 68:
	          case 38:
	          case 87:
	            this.nextSlide();
	            break;
	
	          case 37:
	          case 65:
	          case 40:
	          case 83:
	            this.previousSlide();
	            break;
	
	          case 81:
	            this.goToSlide(0, this.props);
	            break;
	
	          case 69:
	            this.goToSlide(this.state.slideCount - 1, this.props);
	            break;
	
	          case 32:
	            if (this.state.pauseOnHover && this.props.autoplay) {
	              this.setState({
	                pauseOnHover: false
	              });
	              this.pauseAutoplay();
	              break;
	            } else {
	              this.setState({
	                pauseOnHover: true
	              });
	              this.unpauseAutoplay();
	              break;
	            }
	
	        }
	      }
	    }
	  }, {
	    key: "autoplayIterator",
	    value: function autoplayIterator() {
	      if (this.props.wrapAround) {
	        this.nextSlide();
	        return;
	      }
	
	      if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
	        this.nextSlide();
	      } else {
	        this.stopAutoplay();
	      }
	    }
	  }, {
	    key: "startAutoplay",
	    value: function startAutoplay() {
	      this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
	    }
	  }, {
	    key: "resetAutoplay",
	    value: function resetAutoplay() {
	      if (this.props.autoplay && !this.autoplayPaused) {
	        this.stopAutoplay();
	        this.startAutoplay();
	      }
	    }
	  }, {
	    key: "stopAutoplay",
	    value: function stopAutoplay() {
	      if (this.autoplayID) {
	        clearInterval(this.autoplayID);
	      }
	    } // Animation Method
	
	  }, {
	    key: "getTargetLeft",
	    value: function getTargetLeft(touchOffset, slide) {
	      var offset;
	      var target = slide || this.state.currentSlide;
	
	      switch (this.state.cellAlign) {
	        case 'left':
	          {
	            offset = 0;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	
	        case 'center':
	          {
	            offset = (this.state.frameWidth - this.state.slideWidth) / 2;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	
	        case 'right':
	          {
	            offset = this.state.frameWidth - this.state.slideWidth;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	      }
	
	      var left = this.state.slideWidth * target;
	      var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;
	
	      if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
	        left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
	        offset = 0;
	        offset -= this.props.cellSpacing * (this.state.slideCount - 1);
	      }
	
	      offset -= touchOffset || 0;
	      return (left - offset) * -1;
	    }
	  }, {
	    key: "getOffsetDeltas",
	    value: function getOffsetDeltas() {
	      var offset = 0;
	
	      if (this.state.isWrappingAround) {
	        offset = this.getTargetLeft(null, this.state.wrapToIndex);
	      } else {
	        offset = this.getTargetLeft(this.touchObject.length * this.touchObject.direction);
	      }
	
	      return {
	        tx: [this.props.vertical ? 0 : offset],
	        ty: [this.props.vertical ? offset : 0]
	      };
	    } // Action Methods
	
	  }, {
	    key: "goToSlide",
	    value: function goToSlide(index, props) {
	      var _this5 = this;
	
	      if (props === undefined) {
	        props = this.props;
	      }
	
	      if (this.isTransitioning) {
	        return;
	      }
	
	      this.setState({
	        hasInteraction: true,
	        easing: easing[props.easing]
	      });
	      this.isTransitioning = true;
	      var previousSlide = this.state.currentSlide;
	
	      if (index >= this.state.slideCount || index < 0) {
	        if (!props.wrapAround) {
	          this.isTransitioning = false;
	          return;
	        }
	
	        if (index >= this.state.slideCount) {
	          props.beforeSlide(this.state.currentSlide, 0);
	          this.setState(function (prevState) {
	            return {
	              left: props.vertical ? 0 : _this5.getTargetLeft(_this5.state.slideWidth, prevState.currentSlide),
	              top: props.vertical ? _this5.getTargetLeft(_this5.state.slideWidth, prevState.currentSlide) : 0,
	              currentSlide: 0,
	              isWrappingAround: true,
	              wrapToIndex: index
	            };
	          }, function () {
	            setTimeout(function () {
	              _this5.resetAutoplay();
	
	              _this5.isTransitioning = false;
	
	              if (index !== previousSlide) {
	                _this5.props.afterSlide(0);
	              }
	            }, props.speed);
	          });
	          return;
	        } else {
	          var endSlide = this.state.slideCount - this.state.slidesToScroll;
	          props.beforeSlide(this.state.currentSlide, endSlide);
	          this.setState(function (prevState) {
	            return {
	              left: props.vertical ? 0 : _this5.getTargetLeft(0, prevState.currentSlide),
	              top: props.vertical ? _this5.getTargetLeft(0, prevState.currentSlide) : 0,
	              currentSlide: endSlide,
	              isWrappingAround: true,
	              wrapToIndex: index
	            };
	          }, function () {
	            setTimeout(function () {
	              _this5.resetAutoplay();
	
	              _this5.isTransitioning = false;
	
	              if (index !== previousSlide) {
	                _this5.props.afterSlide(_this5.state.slideCount - 1);
	              }
	            }, props.speed);
	          });
	          return;
	        }
	      }
	
	      this.props.beforeSlide(this.state.currentSlide, index);
	      this.setState({
	        currentSlide: index
	      }, function () {
	        return setTimeout(function () {
	          _this5.resetAutoplay();
	
	          _this5.isTransitioning = false;
	
	          if (index !== previousSlide) {
	            _this5.props.afterSlide(index);
	          }
	        }, props.speed);
	      });
	    }
	  }, {
	    key: "nextSlide",
	    value: function nextSlide() {
	      var childrenCount = this.state.slideCount;
	      var slidesToShow = this.state.slidesToShow;
	
	      if (this.props.slidesToScroll === 'auto') {
	        slidesToShow = this.state.slidesToScroll;
	      }
	
	      if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround && this.props.cellAlign === 'left') {
	        return;
	      }
	
	      if (this.props.wrapAround) {
	        this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	      } else {
	        if (this.props.slideWidth !== 1) {
	          this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	          return;
	        }
	
	        var offset = this.state.currentSlide + this.state.slidesToScroll;
	        var nextSlideIndex = this.props.cellAlign !== 'left' ? offset : Math.min(offset, childrenCount - slidesToShow);
	        this.goToSlide(nextSlideIndex);
	      }
	    }
	  }, {
	    key: "previousSlide",
	    value: function previousSlide() {
	      if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	        return;
	      }
	
	      if (this.props.wrapAround) {
	        this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
	      } else {
	        this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
	      }
	    } // Bootstrapping
	
	  }, {
	    key: "bindEvents",
	    value: function bindEvents() {
	      if (_exenv.default.canUseDOM) {
	        (0, _utilities.addEvent)(window, 'resize', this.onResize);
	        (0, _utilities.addEvent)(document, 'readystatechange', this.onReadyStateChange);
	        (0, _utilities.addEvent)(document, 'visibilitychange', this.onVisibilityChange);
	        (0, _utilities.addEvent)(document, 'keydown', this.handleKeyPress);
	      }
	    }
	  }, {
	    key: "onResize",
	    value: function onResize() {
	      this.setDimensions(null, this.props.onResize);
	    }
	  }, {
	    key: "onReadyStateChange",
	    value: function onReadyStateChange() {
	      this.setDimensions();
	    }
	  }, {
	    key: "onVisibilityChange",
	    value: function onVisibilityChange() {
	      if (document.hidden) {
	        this.pauseAutoplay();
	      } else {
	        this.unpauseAutoplay();
	      }
	    }
	  }, {
	    key: "unbindEvents",
	    value: function unbindEvents() {
	      if (_exenv.default.canUseDOM) {
	        (0, _utilities.removeEvent)(window, 'resize', this.onResize);
	        (0, _utilities.removeEvent)(document, 'readystatechange', this.onReadyStateChange);
	        (0, _utilities.removeEvent)(document, 'visibilitychange', this.onVisibilityChange);
	        (0, _utilities.removeEvent)(document, 'keydown', this.handleKeyPress);
	      }
	    }
	  }, {
	    key: "calcSlideHeightAndWidth",
	    value: function calcSlideHeightAndWidth(props) {
	      // slide height
	      props = props || this.props;
	      var childNodes = this.getChildNodes();
	      var slideHeight = (0, _bootstrappingUtilities.getSlideHeight)(props, this.state, childNodes); //slide width
	
	      var _getPropsByTransition = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToShow']),
	          slidesToShow = _getPropsByTransition.slidesToShow;
	
	      var frame = this.frame;
	      var slideWidth;
	
	      if (this.props.animation === 'zoom') {
	        slideWidth = frame.offsetWidth - frame.offsetWidth * 15 / 100;
	      } else if (typeof props.slideWidth !== 'number') {
	        slideWidth = parseInt(props.slideWidth);
	      } else if (props.vertical) {
	        slideWidth = slideHeight / slidesToShow * props.slideWidth;
	      } else {
	        slideWidth = frame.offsetWidth / slidesToShow * props.slideWidth;
	      }
	
	      if (!props.vertical) {
	        slideWidth -= props.cellSpacing * ((100 - 100 / slidesToShow) / 100);
	      }
	
	      return {
	        slideHeight: slideHeight,
	        slideWidth: slideWidth
	      };
	    }
	  }, {
	    key: "setSlideHeightAndWidth",
	    value: function setSlideHeightAndWidth() {
	      this.setState(this.calcSlideHeightAndWidth());
	    }
	  }, {
	    key: "setDimensions",
	    value: function setDimensions(props) {
	      var _this6 = this;
	
	      var stateCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	      props = props || this.props;
	
	      var _getPropsByTransition2 = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToShow', 'cellAlign']),
	          slidesToShow = _getPropsByTransition2.slidesToShow,
	          cellAlign = _getPropsByTransition2.cellAlign;
	
	      var frame = this.frame;
	
	      var _calcSlideHeightAndWi = this.calcSlideHeightAndWidth(props),
	          slideHeight = _calcSlideHeightAndWi.slideHeight,
	          slideWidth = _calcSlideHeightAndWi.slideWidth;
	
	      var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
	      var frameWidth = props.vertical ? frameHeight : frame.offsetWidth;
	
	      var _getPropsByTransition3 = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToScroll']),
	          slidesToScroll = _getPropsByTransition3.slidesToScroll;
	
	      if (slidesToScroll === 'auto') {
	        slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
	      }
	
	      this.setState({
	        frameWidth: frameWidth,
	        slideHeight: slideHeight,
	        slidesToScroll: slidesToScroll,
	        slidesToShow: slidesToShow,
	        slideWidth: slideWidth,
	        cellAlign: cellAlign,
	        left: props.vertical ? 0 : this.getTargetLeft(),
	        top: props.vertical ? this.getTargetLeft() : 0
	      }, function () {
	        stateCb();
	
	        _this6.setLeft();
	      });
	    }
	  }, {
	    key: "getChildNodes",
	    value: function getChildNodes() {
	      return this.frame.childNodes[0].childNodes;
	    }
	  }, {
	    key: "setLeft",
	    value: function setLeft() {
	      var newLeft = this.props.vertical ? 0 : this.getTargetLeft();
	      var newTop = this.props.vertical ? this.getTargetLeft() : 0;
	
	      if (newLeft !== this.state.left || newTop !== this.state.top) {
	        this.setState({
	          left: newLeft,
	          top: newTop
	        });
	      }
	    }
	  }, {
	    key: "renderControls",
	    value: function renderControls() {
	      var _this7 = this;
	
	      if (this.props.withoutControls) {
	        return this.controlsMap.map(function () {
	          return null;
	        });
	      } else {
	        return this.controlsMap.map(function (_ref) {
	          var funcName = _ref.funcName,
	              key = _ref.key;
	          var func = _this7.props[funcName];
	          return func && typeof func === 'function' && _react.default.createElement("div", {
	            className: "slider-control-".concat(key.toLowerCase()),
	            style: (0, _styleUtilities.getDecoratorStyles)(key),
	            key: key
	          }, func({
	            cellAlign: _this7.props.cellAlign,
	            cellSpacing: _this7.props.cellSpacing,
	            currentSlide: _this7.state.currentSlide,
	            frameWidth: _this7.state.frameWidth,
	            goToSlide: function goToSlide(index) {
	              return _this7.goToSlide(index);
	            },
	            nextSlide: function nextSlide() {
	              return _this7.nextSlide();
	            },
	            previousSlide: function previousSlide() {
	              return _this7.previousSlide();
	            },
	            slideCount: _this7.state.slideCount,
	            slidesToScroll: _this7.state.slidesToScroll,
	            slidesToShow: _this7.state.slidesToShow,
	            slideWidth: _this7.state.slideWidth,
	            wrapAround: _this7.props.wrapAround
	          }));
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var _state = this.state,
	          currentSlide = _state.currentSlide,
	          slideCount = _state.slideCount,
	          frameWidth = _state.frameWidth;
	      var _props = this.props,
	          frameOverflow = _props.frameOverflow,
	          vertical = _props.vertical,
	          framePadding = _props.framePadding,
	          slidesToShow = _props.slidesToShow,
	          renderAnnounceSlideMessage = _props.renderAnnounceSlideMessage,
	          disableAnimation = _props.disableAnimation;
	      var duration = this.state.dragging || this.state.resetWrapAroundPosition || disableAnimation || !this.state.hasInteraction ? 0 : this.props.speed;
	      var frameStyles = (0, _styleUtilities.getFrameStyles)(frameOverflow, vertical, framePadding, frameWidth);
	      var touchEvents = this.getTouchEvents();
	      var mouseEvents = this.getMouseEvents();
	      var TransitionControl = _allTransitions.default[this.props.transitionMode];
	      var validChildren = (0, _bootstrappingUtilities.addAccessibility)((0, _bootstrappingUtilities.getValidChildren)(this.props.children), slidesToShow, currentSlide);
	      var transitionProps = (0, _styleUtilities.getTransitionProps)(this.props, this.state);
	      return _react.default.createElement("div", {
	        className: ['slider', this.props.className || ''].join(' '),
	        style: _extends({}, (0, _styleUtilities.getSliderStyles)(this.props.width, this.state.slideWidth), this.props.style)
	      }, !this.props.autoplay && _react.default.createElement(_announceSlide.default, {
	        message: renderAnnounceSlideMessage({
	          currentSlide: currentSlide,
	          slideCount: slideCount
	        })
	      }), _react.default.createElement("div", _extends({
	        className: "slider-frame",
	        ref: function ref(frame) {
	          return _this8.frame = frame;
	        },
	        style: frameStyles
	      }, touchEvents, mouseEvents, {
	        onClickCapture: this.handleClick
	      }), _react.default.createElement(_Animate.default, {
	        show: true,
	        start: {
	          tx: 0,
	          ty: 0
	        },
	        update: function update() {
	          var _this8$getOffsetDelta = _this8.getOffsetDeltas(),
	              tx = _this8$getOffsetDelta.tx,
	              ty = _this8$getOffsetDelta.ty;
	
	          return {
	            tx: tx,
	            ty: ty,
	            timing: {
	              duration: duration,
	              ease: _this8.state.easing
	            },
	            events: {
	              end: function end() {
	                var newLeft = _this8.props.vertical ? 0 : _this8.getTargetLeft();
	                var newTop = _this8.props.vertical ? _this8.getTargetLeft() : 0;
	
	                if (newLeft !== _this8.state.left || newTop !== _this8.state.top) {
	                  _this8.setState({
	                    left: newLeft,
	                    top: newTop,
	                    isWrappingAround: false,
	                    resetWrapAroundPosition: true
	                  }, function () {
	                    _this8.setState({
	                      resetWrapAroundPosition: false
	                    });
	                  });
	                }
	              }
	            }
	          };
	        },
	        children: function children(_ref2) {
	          var tx = _ref2.tx,
	              ty = _ref2.ty;
	          return _react.default.createElement(TransitionControl, _extends({}, transitionProps, {
	            deltaX: tx,
	            deltaY: ty
	          }), validChildren);
	        }
	      })), this.renderControls(), this.props.autoGenerateStyleTag && _react.default.createElement("style", {
	        type: "text/css",
	        dangerouslySetInnerHTML: {
	          __html: (0, _styleUtilities.getImgTagStyles)()
	        }
	      }));
	    }
	  }]);
	
	  return Carousel;
	}(_react.default.Component);
	
	exports.default = Carousel;
	Carousel.propTypes = {
	  afterSlide: _propTypes.default.func,
	  animation: _propTypes.default.oneOf(['zoom']),
	  autoGenerateStyleTag: _propTypes.default.bool,
	  autoplay: _propTypes.default.bool,
	  autoplayInterval: _propTypes.default.number,
	  beforeSlide: _propTypes.default.func,
	  cellAlign: _propTypes.default.oneOf(['left', 'center', 'right']),
	  cellSpacing: _propTypes.default.number,
	  enableKeyboardControls: _propTypes.default.bool,
	  disableAnimation: _propTypes.default.bool,
	  dragging: _propTypes.default.bool,
	  easing: _propTypes.default.string,
	  edgeEasing: _propTypes.default.string,
	  frameOverflow: _propTypes.default.string,
	  framePadding: _propTypes.default.string,
	  heightMode: _propTypes.default.oneOf(['first', 'current', 'max']),
	  initialSlideHeight: _propTypes.default.number,
	  initialSlideWidth: _propTypes.default.number,
	  onResize: _propTypes.default.func,
	  pauseOnHover: _propTypes.default.bool,
	  renderAnnounceSlideMessage: _propTypes.default.func,
	  renderBottomCenterControls: _propTypes.default.func,
	  renderBottomLeftControls: _propTypes.default.func,
	  renderBottomRightControls: _propTypes.default.func,
	  renderCenterCenterControls: _propTypes.default.func,
	  renderCenterLeftControls: _propTypes.default.func,
	  renderCenterRightControls: _propTypes.default.func,
	  renderTopCenterControls: _propTypes.default.func,
	  renderTopLeftControls: _propTypes.default.func,
	  renderTopRightControls: _propTypes.default.func,
	  slideIndex: _propTypes.default.number,
	  slideOffset: _propTypes.default.number,
	  slidesToScroll: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
	  slidesToShow: _propTypes.default.number,
	  slideWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  speed: _propTypes.default.number,
	  swiping: _propTypes.default.bool,
	  transitionMode: _propTypes.default.oneOf(['scroll', 'fade']),
	  vertical: _propTypes.default.bool,
	  width: _propTypes.default.string,
	  withoutControls: _propTypes.default.bool,
	  wrapAround: _propTypes.default.bool
	};
	Carousel.defaultProps = {
	  afterSlide: function afterSlide() {},
	  autoGenerateStyleTag: true,
	  autoplay: false,
	  autoplayInterval: 3000,
	  beforeSlide: function beforeSlide() {},
	  cellAlign: 'left',
	  cellSpacing: 0,
	  enableKeyboardControls: false,
	  disableAnimation: false,
	  dragging: true,
	  easing: 'easeCircleOut',
	  edgeEasing: 'easeElasticOut',
	  frameOverflow: 'hidden',
	  framePadding: '0px',
	  heightMode: 'max',
	  onResize: function onResize() {},
	  pauseOnHover: true,
	  renderAnnounceSlideMessage: _announceSlide.defaultRenderAnnounceSlideMessage,
	  renderBottomCenterControls: function renderBottomCenterControls(props) {
	    return _react.default.createElement(_defaultControls.PagingDots, props);
	  },
	  renderCenterLeftControls: function renderCenterLeftControls(props) {
	    return _react.default.createElement(_defaultControls.PreviousButton, props);
	  },
	  renderCenterRightControls: function renderCenterRightControls(props) {
	    return _react.default.createElement(_defaultControls.NextButton, props);
	  },
	  slideIndex: 0,
	  slideOffset: 25,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  slideWidth: 1,
	  speed: 500,
	  style: {},
	  swiping: true,
	  transitionMode: 'scroll',
	  vertical: false,
	  width: '100%',
	  withoutControls: false,
	  wrapAround: false
	};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FadeTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(FadeTransition, _React$Component);
	
	  function FadeTransition(props) {
	    var _this;
	
	    _classCallCheck(this, FadeTransition);
	
	    _this = _possibleConstructorReturn(this, (FadeTransition.__proto__ || Object.getPrototypeOf(FadeTransition)).call(this, props));
	    _this.fadeFromSlide = props.currentSlide;
	    return _this;
	  }
	
	  _createClass(FadeTransition, [{
	    key: "formatChildren",
	    value: function formatChildren(children, opacity) {
	      var _this2 = this;
	
	      var _props = this.props,
	          currentSlide = _props.currentSlide,
	          slidesToShow = _props.slidesToShow;
	      return _react.default.Children.map(children, function (child, index) {
	        var visible = index >= currentSlide && index < currentSlide + slidesToShow;
	        return _react.default.createElement("li", {
	          className: "slider-slide".concat(visible ? ' slide-visible' : ''),
	          style: _this2.getSlideStyles(index, opacity),
	          key: index
	        }, child);
	      });
	    }
	  }, {
	    key: "getSlideOpacityAndLeftMap",
	    value: function getSlideOpacityAndLeftMap(fadeFrom, fadeTo, fade) {
	      // Figure out which position to fade to
	      var fadeToPosition = fadeTo;
	
	      if (fadeFrom > fade && fadeFrom === 0) {
	        fadeToPosition = fadeFrom - this.props.slidesToShow;
	      } else if (fadeFrom < fade && fadeFrom + this.props.slidesToShow > this.props.slideCount - 1) {
	        fadeToPosition = fadeFrom + this.props.slidesToShow;
	      } // Calculate opacity for active slides
	
	
	      var opacity = {};
	
	      if (fadeFrom === fadeTo) {
	        opacity[fadeFrom] = 1;
	      } else {
	        var distance = fadeFrom - fadeToPosition;
	        opacity[fadeFrom] = (fade - fadeToPosition) / distance;
	        opacity[fadeTo] = (fadeFrom - fade) / distance;
	      } // Calculate left for slides and merge in opacity
	
	
	      var map = {};
	
	      for (var i = 0; i < this.props.slidesToShow; i++) {
	        map[fadeFrom + i] = {
	          opacity: opacity[fadeFrom],
	          left: this.props.slideWidth * i
	        };
	        map[fadeTo + i] = {
	          opacity: opacity[fadeTo],
	          left: this.props.slideWidth * i
	        };
	      }
	
	      return map;
	    }
	  }, {
	    key: "getSlideStyles",
	    value: function getSlideStyles(index, data) {
	      return {
	        boxSizing: 'border-box',
	        display: 'block',
	        height: 'auto',
	        left: data[index] ? data[index].left : 0,
	        listStyleType: 'none',
	        marginBottom: 'auto',
	        marginLeft: this.props.cellSpacing / 2,
	        marginRight: this.props.cellSpacing / 2,
	        marginTop: 'auto',
	        MozBoxSizing: 'border-box',
	        opacity: data[index] ? data[index].opacity : 0,
	        position: 'absolute',
	        top: 0,
	        verticalAlign: 'top',
	        visibility: data[index] ? 'inherit' : 'hidden',
	        width: this.props.slideWidth
	      };
	    }
	  }, {
	    key: "getContainerStyles",
	    value: function getContainerStyles() {
	      var width = this.props.slideWidth * this.props.slidesToShow;
	      return {
	        boxSizing: 'border-box',
	        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
	        display: 'block',
	        height: this.props.slideHeight,
	        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
	        MozBoxSizing: 'border-box',
	        padding: 0,
	        touchAction: 'none',
	        width: width
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var fade = -(this.props.deltaX || this.props.deltaY) / this.props.slideWidth;
	
	      if (parseInt(fade) === fade) {
	        this.fadeFromSlide = fade;
	      }
	
	      var opacityAndLeftMap = this.getSlideOpacityAndLeftMap(this.fadeFromSlide, this.props.currentSlide, fade);
	      var children = this.formatChildren(this.props.children, opacityAndLeftMap);
	      return _react.default.createElement("ul", {
	        className: "slider-list",
	        style: this.getContainerStyles()
	      }, children);
	    }
	  }]);
	
	  return FadeTransition;
	}(_react.default.Component);
	
	exports.default = FadeTransition;
	FadeTransition.propTypes = {
	  cellSpacing: _propTypes.default.number,
	  currentSlide: _propTypes.default.number,
	  deltaX: _propTypes.default.number,
	  deltaY: _propTypes.default.number,
	  dragging: _propTypes.default.bool,
	  isWrappingAround: _propTypes.default.bool,
	  left: _propTypes.default.number,
	  slideCount: _propTypes.default.number,
	  slideHeight: _propTypes.default.number,
	  slidesToShow: _propTypes.default.number,
	  slideWidth: _propTypes.default.number,
	  top: _propTypes.default.number,
	  vertical: _propTypes.default.bool,
	  wrapAround: _propTypes.default.bool
	};
	FadeTransition.defaultProps = {
	  cellSpacing: 0,
	  currentSlide: 0,
	  deltaX: 0,
	  deltaY: 0,
	  dragging: false,
	  isWrappingAround: false,
	  left: 0,
	  slideCount: 0,
	  slideHeight: 0,
	  slidesToShow: 1,
	  slideWidth: 0,
	  top: 0,
	  vertical: false,
	  wrapAround: false
	};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var MIN_ZOOM_SCALE = 0;
	var MAX_ZOOM_SCALE = 1;
	
	var ScrollTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ScrollTransition, _React$Component);
	
	  function ScrollTransition(props) {
	    var _this;
	
	    _classCallCheck(this, ScrollTransition);
	
	    _this = _possibleConstructorReturn(this, (ScrollTransition.__proto__ || Object.getPrototypeOf(ScrollTransition)).call(this, props));
	    _this.getListStyles = _this.getListStyles.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(ScrollTransition, [{
	    key: "getSlideDirection",
	    value: function getSlideDirection(start, end, isWrapping) {
	      var direction = 0;
	      if (start === end) return direction;
	
	      if (isWrapping) {
	        direction = start < end ? -1 : 1;
	      } else {
	        direction = start < end ? 1 : -1;
	      }
	
	      return direction;
	    }
	    /* eslint-disable complexity */
	
	  }, {
	    key: "getSlideTargetPosition",
	    value: function getSlideTargetPosition(index, positionValue) {
	      var targetPosition = (this.props.slideWidth + this.props.cellSpacing) * index;
	      var startSlide = Math.min(Math.abs(Math.floor(positionValue / this.props.slideWidth)), this.props.slideCount - 1);
	      var offset = 0;
	
	      if (this.props.animation === 'zoom' && (this.props.currentSlide === index + 1 || this.props.currentSlide === 0 && index === this.props.children.length - 1)) {
	        offset = this.props.slideOffset;
	      } else if (this.props.animation === 'zoom' && (this.props.currentSlide === index - 1 || this.props.currentSlide === this.props.children.length - 1 && index === 0)) {
	        offset = -this.props.slideOffset;
	      }
	
	      if (this.props.wrapAround && index !== startSlide) {
	        var direction = this.getSlideDirection(startSlide, this.props.currentSlide, this.props.isWrappingAround);
	        var slidesBefore = Math.floor((this.props.slideCount - 1) / 2);
	        var slidesAfter = this.props.slideCount - slidesBefore - 1;
	
	        if (direction < 0) {
	          var temp = slidesBefore;
	          slidesBefore = slidesAfter;
	          slidesAfter = temp;
	        }
	
	        var distanceFromStart = Math.abs(startSlide - index);
	
	        if (index < startSlide) {
	          if (distanceFromStart > slidesBefore) {
	            targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount + index);
	          }
	        } else if (distanceFromStart > slidesAfter) {
	          targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount - index) * -1;
	        }
	      }
	
	      return targetPosition + offset;
	    }
	    /* eslint-enable complexity */
	
	  }, {
	    key: "formatChildren",
	    value: function formatChildren(children) {
	      var _this2 = this;
	
	      var _props = this.props,
	          top = _props.top,
	          left = _props.left,
	          currentSlide = _props.currentSlide,
	          slidesToShow = _props.slidesToShow;
	      var positionValue = this.props.vertical ? top : left;
	      return _react.default.Children.map(children, function (child, index) {
	        var visible = index >= currentSlide && index < currentSlide + slidesToShow;
	        return _react.default.createElement("li", {
	          className: "slider-slide".concat(visible ? ' slide-visible' : ''),
	          style: _this2.getSlideStyles(index, positionValue),
	          key: index
	        }, child);
	      });
	    }
	  }, {
	    key: "getSlideStyles",
	    value: function getSlideStyles(index, positionValue) {
	      var targetPosition = this.getSlideTargetPosition(index, positionValue);
	      var transformScale = this.props.animation === 'zoom' && this.props.currentSlide !== index ? Math.max(Math.min(this.props.zoomScale, MAX_ZOOM_SCALE), MIN_ZOOM_SCALE) : 1.0;
	      return {
	        boxSizing: 'border-box',
	        display: this.props.vertical ? 'block' : 'inline-block',
	        height: 'auto',
	        left: this.props.vertical ? 0 : targetPosition,
	        listStyleType: 'none',
	        marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        MozBoxSizing: 'border-box',
	        position: 'absolute',
	        top: this.props.vertical ? targetPosition : 0,
	        transform: "scale(".concat(transformScale, ")"),
	        transition: 'transform .4s linear',
	        verticalAlign: 'top',
	        width: this.props.vertical ? '100%' : this.props.slideWidth
	      };
	    }
	  }, {
	    key: "getListStyles",
	    value: function getListStyles(styles) {
	      var deltaX = styles.deltaX,
	          deltaY = styles.deltaY;
	
	      var listWidth = this.props.slideWidth * _react.default.Children.count(this.props.children);
	
	      var spacingOffset = this.props.cellSpacing * _react.default.Children.count(this.props.children);
	
	      var transform = "translate3d(".concat(deltaX, "px, ").concat(deltaY, "px, 0)");
	      return {
	        transform: transform,
	        WebkitTransform: transform,
	        msTransform: "translate(".concat(deltaX, "px, ").concat(deltaY, "px)"),
	        position: 'relative',
	        display: 'block',
	        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
	        padding: 0,
	        height: this.props.vertical ? listWidth + spacingOffset : this.props.slideHeight,
	        width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
	        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y')
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.formatChildren(this.props.children);
	      var deltaX = this.props.deltaX;
	      var deltaY = this.props.deltaY;
	      return _react.default.createElement("ul", {
	        className: "slider-list",
	        style: this.getListStyles({
	          deltaX: deltaX,
	          deltaY: deltaY
	        })
	      }, children);
	    }
	  }]);
	
	  return ScrollTransition;
	}(_react.default.Component);
	
	exports.default = ScrollTransition;
	ScrollTransition.propTypes = {
	  animation: _propTypes.default.oneOf(['zoom']),
	  cellSpacing: _propTypes.default.number,
	  currentSlide: _propTypes.default.number,
	  deltaX: _propTypes.default.number,
	  deltaY: _propTypes.default.number,
	  dragging: _propTypes.default.bool,
	  isWrappingAround: _propTypes.default.bool,
	  left: _propTypes.default.number,
	  slideCount: _propTypes.default.number,
	  slideHeight: _propTypes.default.number,
	  slideOffset: _propTypes.default.number,
	  slideWidth: _propTypes.default.number,
	  top: _propTypes.default.number,
	  vertical: _propTypes.default.bool,
	  wrapAround: _propTypes.default.bool,
	  zoomScale: _propTypes.default.number
	};
	ScrollTransition.defaultProps = {
	  cellSpacing: 0,
	  currentSlide: 0,
	  deltaX: 0,
	  deltaY: 0,
	  dragging: false,
	  isWrappingAround: false,
	  left: 0,
	  slideCount: 0,
	  slideHeight: 0,
	  slideWidth: 0,
	  top: 0,
	  vertical: false,
	  wrapAround: false,
	  zoomScale: 0.85
	};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSlideHeight = exports.getValidChildren = exports.addAccessibility = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var addAccessibility = function addAccessibility(children, slidesToShow, currentSlide) {
	  var needsTabIndex;
	
	  if (slidesToShow > 1) {
	    return _react.default.Children.map(children, function (child, index) {
	      // create a range from first visible slide to last visible slide
	      var firstVisibleSlide = index >= currentSlide;
	      var lastVisibleSlide = index < slidesToShow + currentSlide;
	      needsTabIndex = firstVisibleSlide && lastVisibleSlide; // if the index of the slide is in range add ariaProps to the slide
	
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      } : {
	        'aria-hidden': 'true'
	      };
	      return _react.default.cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  } else {
	    // when slidesToshow is 1
	    return _react.default.Children.map(children, function (child, index) {
	      needsTabIndex = index !== currentSlide;
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'true'
	      } : {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      };
	      return _react.default.cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  }
	};
	
	exports.addAccessibility = addAccessibility;
	
	var getValidChildren = function getValidChildren(children) {
	  // .toArray automatically removes invalid React children
	  return _react.default.Children.toArray(children);
	};
	
	exports.getValidChildren = getValidChildren;
	
	var findMaxHeightSlide = function findMaxHeightSlide(slides) {
	  var maxHeight = 0;
	
	  for (var i = 0; i < slides.length; i++) {
	    if (slides[i].offsetHeight > maxHeight) {
	      maxHeight = slides[i].offsetHeight;
	    }
	  }
	
	  return maxHeight;
	};
	
	var getSlideHeight = function getSlideHeight(props, state) {
	  var childNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var heightMode = props.heightMode,
	      vertical = props.vertical,
	      initialSlideHeight = props.initialSlideHeight;
	  var slidesToShow = state.slidesToShow,
	      currentSlide = state.currentSlide;
	  var firstSlide = childNodes[0];
	
	  if (firstSlide && heightMode === 'first') {
	    return vertical ? firstSlide.offsetHeight * slidesToShow : firstSlide.offsetHeight;
	  }
	
	  if (heightMode === 'max') {
	    return findMaxHeightSlide(childNodes);
	  }
	
	  if (heightMode === 'current') {
	    return childNodes[currentSlide].offsetHeight;
	  }
	
	  return initialSlideHeight || 100;
	};
	
	exports.getSlideHeight = getSlideHeight;

/***/ }),
/* 869 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = exports.getFrameStyles = exports.getSliderStyles = exports.getDecoratorStyles = exports.getImgTagStyles = void 0;
	
	var getImgTagStyles = function getImgTagStyles() {
	  return ".slider-slide > img { width: 100%; display: block; }\n          .slider-slide > img:focus { margin: auto; }";
	};
	
	exports.getImgTagStyles = getImgTagStyles;
	
	var getDecoratorStyles = function getDecoratorStyles(position) {
	  switch (position) {
	    case 'TopLeft':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: 0
	        };
	      }
	
	    case 'TopCenter':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: '50%',
	          transform: 'translateX(-50%)',
	          WebkitTransform: 'translateX(-50%)',
	          msTransform: 'translateX(-50%)'
	        };
	      }
	
	    case 'TopRight':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          right: 0
	        };
	      }
	
	    case 'CenterLeft':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          left: 0,
	          transform: 'translateY(-50%)',
	          WebkitTransform: 'translateY(-50%)',
	          msTransform: 'translateY(-50%)'
	        };
	      }
	
	    case 'CenterCenter':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          left: '50%',
	          transform: 'translate(-50%,-50%)',
	          WebkitTransform: 'translate(-50%, -50%)',
	          msTransform: 'translate(-50%, -50%)'
	        };
	      }
	
	    case 'CenterRight':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          right: 0,
	          transform: 'translateY(-50%)',
	          WebkitTransform: 'translateY(-50%)',
	          msTransform: 'translateY(-50%)'
	        };
	      }
	
	    case 'BottomLeft':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          left: 0
	        };
	      }
	
	    case 'BottomCenter':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          left: '50%',
	          transform: 'translateX(-50%)',
	          WebkitTransform: 'translateX(-50%)',
	          msTransform: 'translateX(-50%)'
	        };
	      }
	
	    case 'BottomRight':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          right: 0
	        };
	      }
	
	    default:
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: 0
	        };
	      }
	  }
	};
	
	exports.getDecoratorStyles = getDecoratorStyles;
	
	var getSliderStyles = function getSliderStyles(propWidth, stateSlideWidth) {
	  return {
	    boxSizing: 'border-box',
	    display: 'block',
	    height: 'auto',
	    MozBoxSizing: 'border-box',
	    position: 'relative',
	    visibility: stateSlideWidth ? 'inherit' : 'hidden',
	    width: propWidth
	  };
	};
	
	exports.getSliderStyles = getSliderStyles;
	
	var getFrameStyles = function getFrameStyles(propFrameOverFlow, propVertical, propFramePadding, stateFrameWidth) {
	  return {
	    boxSizing: 'border-box',
	    display: 'block',
	    height: propVertical ? stateFrameWidth || 'initial' : '100%',
	    margin: propFramePadding,
	    MozBoxSizing: 'border-box',
	    msTransform: 'translate(0, 0)',
	    overflow: propFrameOverFlow,
	    padding: 0,
	    position: 'relative',
	    touchAction: "pinch-zoom ".concat(propVertical ? 'pan-x' : 'pan-y'),
	    transform: 'translate3d(0, 0, 0)',
	    WebkitTransform: 'translate3d(0, 0, 0)'
	  };
	};
	
	exports.getFrameStyles = getFrameStyles;
	
	var getTransitionProps = function getTransitionProps(props, state) {
	  return {
	    animation: props.animation,
	    cellSpacing: props.cellSpacing,
	    currentSlide: state.currentSlide,
	    dragging: props.dragging,
	    isWrappingAround: state.isWrappingAround,
	    left: state.left,
	    slideCount: state.slideCount,
	    slideHeight: state.slideHeight,
	    slideOffset: props.slideOffset,
	    slidesToShow: state.slidesToShow,
	    slideWidth: state.slideWidth,
	    top: state.top,
	    vertical: props.vertical,
	    wrapAround: props.wrapAround,
	    zoomScale: props.zoomScale
	  };
	};
	
	exports.getTransitionProps = getTransitionProps;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calcSomeInitialState = exports.shouldUpdate = exports.swipeDirection = exports.getPropsByTransitionMode = exports.addAccessibility = exports.removeEvent = exports.addEvent = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var addEvent = function addEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	
	  if (elem.addEventListener) {
	    elem.addEventListener(type, eventHandle, false);
	  } else if (elem.attachEvent) {
	    elem.attachEvent("on".concat(type), eventHandle);
	  } else {
	    elem["on".concat(type)] = eventHandle;
	  }
	};
	
	exports.addEvent = addEvent;
	
	var removeEvent = function removeEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	
	  if (elem.removeEventListener) {
	    elem.removeEventListener(type, eventHandle, false);
	  } else if (elem.detachEvent) {
	    elem.detachEvent("on".concat(type), eventHandle);
	  } else {
	    elem["on".concat(type)] = null;
	  }
	};
	
	exports.removeEvent = removeEvent;
	
	var addAccessibility = function addAccessibility(children, slidesToShow, currentSlide) {
	  var needsTabIndex;
	
	  if (slidesToShow > 1) {
	    return _react.default.Children.map(children, function (child, index) {
	      var firstVisibleSlide = index >= currentSlide;
	      var lastVisibleSlide = index < slidesToShow + currentSlide;
	      needsTabIndex = firstVisibleSlide && lastVisibleSlide;
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      } : {
	        'aria-hidden': 'true'
	      };
	      return _react.default.cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  } else {
	    return _react.default.Children.map(children, function (child, index) {
	      needsTabIndex = index !== currentSlide;
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'true'
	      } : {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      };
	      return _react.default.cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  }
	};
	
	exports.addAccessibility = addAccessibility;
	
	var getPropsByTransitionMode = function getPropsByTransitionMode(props, keys) {
	  var slidesToShow = props.slidesToShow,
	      transitionMode = props.transitionMode;
	  var updatedDefaults = {};
	
	  if (transitionMode === 'fade') {
	    keys.forEach(function (key) {
	      switch (key) {
	        case 'slidesToShow':
	          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
	          break;
	
	        case 'slidesToScroll':
	          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
	          break;
	
	        case 'cellAlign':
	          updatedDefaults[key] = 'left';
	          break;
	
	        default:
	          updatedDefaults[key] = props[key];
	          break;
	      }
	    });
	  } else {
	    keys.forEach(function (key) {
	      updatedDefaults[key] = props[key];
	    });
	  }
	
	  return updatedDefaults;
	};
	
	exports.getPropsByTransitionMode = getPropsByTransitionMode;
	
	var swipeDirection = function swipeDirection(x1, x2, y1, y2, vertical) {
	  var xDist = x1 - x2;
	  var yDist = y1 - y2;
	  var r = Math.atan2(yDist, xDist);
	  var swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0) {
	    return 1;
	  }
	
	  if (swipeAngle <= 360 && swipeAngle >= 315) {
	    return 1;
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return -1;
	  }
	
	  if (vertical === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return 1;
	    } else {
	      return -1;
	    }
	  }
	
	  return 0;
	};
	
	exports.swipeDirection = swipeDirection;
	
	var shouldUpdate = function shouldUpdate(curr, next, keys) {
	  var update = false;
	
	  for (var i = 0; i < keys.length; i++) {
	    if (curr[keys[i]] !== next[keys[i]]) {
	      update = true;
	      break;
	    }
	  }
	
	  return update;
	};
	
	exports.shouldUpdate = shouldUpdate;
	
	var calcSomeInitialState = function calcSomeInitialState(props) {
	  var _getPropsByTransition = getPropsByTransitionMode(props, ['slidesToScroll', 'slidesToShow', 'cellAlign']),
	      slidesToScroll = _getPropsByTransition.slidesToScroll,
	      slidesToShow = _getPropsByTransition.slidesToShow,
	      cellAlign = _getPropsByTransition.cellAlign;
	
	  var slideWidth = props.vertical ? props.initialSlideHeight || 0 : props.initialSlideWidth || 0;
	  var slideHeight = props.vertical ? (props.initialSlideHeight || 0) * props.slidesToShow : props.initialSlideHeight || 0;
	  var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
	  var frameWidth = props.vertical ? frameHeight : '100%';
	  return {
	    slideWidth: slideWidth,
	    slideHeight: slideHeight,
	    frameWidth: frameWidth,
	    slidesToScroll: slidesToScroll,
	    slidesToShow: slidesToShow,
	    cellAlign: cellAlign
	  };
	};
	
	exports.calcSomeInitialState = calcSomeInitialState;

/***/ }),
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _NodeGroup = _interopRequireDefault(__webpack_require__(1042));
	
	var _utils = __webpack_require__(398);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var keyAccessor = function keyAccessor() {
	  return '$$key$$';
	};
	
	var Animate = function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate() {
	    _classCallCheck(this, Animate);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Animate).apply(this, arguments));
	  }
	
	  _createClass(Animate, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          show = _this$props.show,
	          start = _this$props.start,
	          enter = _this$props.enter,
	          update = _this$props.update,
	          leave = _this$props.leave,
	          interpolation = _this$props.interpolation,
	          children = _this$props.children;
	      var data = typeof start === 'function' ? start() : start;
	      return _react.default.createElement(_NodeGroup.default, {
	        data: show ? [data] : [],
	        start: function start() {
	          return data;
	        },
	        keyAccessor: keyAccessor,
	        interpolation: interpolation,
	        enter: typeof enter === 'function' ? enter : function () {
	          return enter;
	        },
	        update: typeof update === 'function' ? update : function () {
	          return update;
	        },
	        leave: typeof leave === 'function' ? leave : function () {
	          return leave;
	        }
	      }, function (nodes) {
	        if (!nodes[0]) {
	          return null;
	        }
	
	        var renderedChildren = children(nodes[0].state);
	        return renderedChildren && _react.default.Children.only(renderedChildren);
	      });
	    }
	  }]);
	
	  return Animate;
	}(_react.Component);
	
	Animate.propTypes =  false ? {
	  show: _propTypes.default.bool,
	  interpolation: _propTypes.default.func,
	  start: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	  enter: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),
	  update: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),
	  leave: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),
	  children: _propTypes.default.func.isRequired
	} : {};
	Animate.defaultProps = {
	  show: true,
	  interpolation: _utils.numeric
	};
	var _default = Animate;
	exports.default = _default;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(1040);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _kapellmeister = __webpack_require__(768);
	
	var _mergeKeys = _interopRequireDefault(__webpack_require__(1043));
	
	var _types = __webpack_require__(1044);
	
	var _utils = __webpack_require__(398);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NodeGroup = function (_Component) {
	  _inherits(NodeGroup, _Component);
	
	  function NodeGroup(props) {
	    var _this;
	
	    _classCallCheck(this, NodeGroup);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(NodeGroup).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "animate", function () {
	      var _this$state = _this.state,
	          nodeKeys = _this$state.nodeKeys,
	          nodeHash = _this$state.nodeHash;
	
	      if (_this.unmounting) {
	        return;
	      }
	
	      var pending = false;
	      var nextNodeKeys = [];
	      var length = nodeKeys.length;
	
	      for (var i = 0; i < length; i++) {
	        var k = nodeKeys[i];
	        var n = nodeHash[k];
	        var isTransitioning = n.isTransitioning();
	
	        if (isTransitioning) {
	          pending = true;
	        }
	
	        if (n.type === _types.LEAVE && !isTransitioning) {
	          delete nodeHash[k];
	        } else {
	          nextNodeKeys.push(k);
	        }
	      }
	
	      if (!pending) {
	        _this.interval.stop();
	      }
	
	      _this.setState(function () {
	        return {
	          nodeKeys: nextNodeKeys,
	          nodes: nextNodeKeys.map(function (key) {
	            return nodeHash[key];
	          })
	        };
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "interval", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "unmounting", false);
	
	    var interpolation = props.interpolation;
	
	    var Node = function (_BaseNode) {
	      _inherits(Node, _BaseNode);
	
	      function Node(key, data) {
	        var _this2;
	
	        _classCallCheck(this, Node);
	
	        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Node).call(this));
	
	        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "getInterpolator", interpolation);
	
	        _this2.key = key;
	        _this2.data = data;
	        _this2.type = _types.ENTER;
	        return _this2;
	      }
	
	      return Node;
	    }(_kapellmeister.BaseNode);
	
	    _this.state = {
	      Node: Node,
	      nodeKeys: [],
	      nodeHash: {},
	      nodes: [],
	      data: null
	    };
	    return _this;
	  }
	
	  _createClass(NodeGroup, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startInterval();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.data !== this.props.data && !this.unmounting) {
	        this.startInterval();
	      }
	    }
	  }, {
	    key: "startInterval",
	    value: function startInterval() {
	      if (!this.interval) {
	        this.interval = (0, _kapellmeister.interval)(this.animate);
	      } else {
	        this.interval.restart(this.animate);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this$state2 = this.state,
	          nodeKeys = _this$state2.nodeKeys,
	          nodeHash = _this$state2.nodeHash;
	      this.unmounting = true;
	
	      if (this.interval) {
	        this.interval.stop();
	      }
	
	      nodeKeys.forEach(function (key) {
	        nodeHash[key].stopTransitions();
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var renderedChildren = this.props.children(this.state.nodes);
	      return renderedChildren && _react.default.Children.only(renderedChildren);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (nextProps.data !== prevState.data) {
	        var data = nextProps.data,
	            keyAccessor = nextProps.keyAccessor,
	            start = nextProps.start,
	            enter = nextProps.enter,
	            update = nextProps.update,
	            leave = nextProps.leave;
	        var Node = prevState.Node,
	            nodeKeys = prevState.nodeKeys,
	            nodeHash = prevState.nodeHash;
	        var keyIndex = {};
	
	        for (var i = 0; i < nodeKeys.length; i++) {
	          keyIndex[nodeKeys[i]] = i;
	        }
	
	        var nextKeyIndex = {};
	        var nextNodeKeys = [];
	
	        for (var _i = 0; _i < data.length; _i++) {
	          var d = data[_i];
	          var k = keyAccessor(d, _i);
	          nextKeyIndex[k] = _i;
	          nextNodeKeys.push(k);
	
	          if (keyIndex[k] === undefined) {
	            var node = new Node();
	            node.key = k;
	            node.data = d;
	            node.type = _types.ENTER;
	            nodeHash[k] = node;
	          }
	        }
	
	        for (var _i2 = 0; _i2 < nodeKeys.length; _i2++) {
	          var _k = nodeKeys[_i2];
	          var n = nodeHash[_k];
	
	          if (nextKeyIndex[_k] !== undefined) {
	            n.data = data[nextKeyIndex[_k]];
	            n.type = _types.UPDATE;
	          } else {
	            n.type = _types.LEAVE;
	          }
	        }
	
	        var mergedNodeKeys = (0, _mergeKeys.default)(nodeKeys, keyIndex, nextNodeKeys, nextKeyIndex);
	
	        for (var _i3 = 0; _i3 < mergedNodeKeys.length; _i3++) {
	          var _k2 = mergedNodeKeys[_i3];
	          var _n = nodeHash[_k2];
	          var _d = _n.data;
	
	          if (_n.type === _types.ENTER) {
	            _n.setState(start(_d, nextKeyIndex[_k2]));
	
	            _n.transition(enter(_d, nextKeyIndex[_k2]));
	          } else if (_n.type === _types.LEAVE) {
	            _n.transition(leave(_d, keyIndex[_k2]));
	          } else {
	            _n.transition(update(_d, nextKeyIndex[_k2]));
	          }
	        }
	
	        return {
	          data: data,
	          nodes: mergedNodeKeys.map(function (key) {
	            return nodeHash[key];
	          }),
	          nodeHash: nodeHash,
	          nodeKeys: mergedNodeKeys
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return NodeGroup;
	}(_react.Component);
	
	NodeGroup.propTypes =  false ? {
	  data: _propTypes.default.array.isRequired,
	  keyAccessor: _propTypes.default.func.isRequired,
	  interpolation: _propTypes.default.func,
	  start: _propTypes.default.func.isRequired,
	  enter: _propTypes.default.func,
	  update: _propTypes.default.func,
	  leave: _propTypes.default.func,
	  children: _propTypes.default.func.isRequired
	} : {};
	NodeGroup.defaultProps = {
	  enter: function enter() {},
	  update: function update() {},
	  leave: function leave() {},
	  interpolation: _utils.numeric
	};
	(0, _reactLifecyclesCompat.polyfill)(NodeGroup);
	var _default = NodeGroup;
	exports.default = _default;

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function mergeKeys(currNodeKeys, currKeyIndex, nextNodeKeys, nextKeyIndex) {
	  var allKeys = [];
	
	  for (var i = 0; i < nextNodeKeys.length; i++) {
	    allKeys[i] = nextNodeKeys[i];
	  }
	
	  for (var _i = 0; _i < currNodeKeys.length; _i++) {
	    if (nextKeyIndex[currNodeKeys[_i]] === undefined) {
	      allKeys.push(currNodeKeys[_i]);
	    }
	  }
	
	  return allKeys.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a];
	    var nextOrderB = nextKeyIndex[b];
	    var currOrderA = currKeyIndex[a];
	    var currOrderB = currKeyIndex[b];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      return nextKeyIndex[a] - nextKeyIndex[b];
	    } else if (currOrderA != null && currOrderB != null) {
	      return currKeyIndex[a] - currKeyIndex[b];
	    } else if (nextOrderA != null) {
	      for (var _i2 = 0; _i2 < nextNodeKeys.length; _i2++) {
	        var pivot = nextNodeKeys[_i2];
	
	        if (!currKeyIndex[pivot]) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && currOrderB > currKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && currOrderB < currKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	
	      return 1;
	    }
	
	    for (var _i3 = 0; _i3 < nextNodeKeys.length; _i3++) {
	      var _pivot = nextNodeKeys[_i3];
	
	      if (!currKeyIndex[_pivot]) {
	        continue;
	      }
	
	      if (nextOrderB < nextKeyIndex[_pivot] && currOrderA > currKeyIndex[_pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[_pivot] && currOrderA < currKeyIndex[_pivot]) {
	        return -1;
	      }
	    }
	
	    return -1;
	  });
	}
	
	var _default = mergeKeys;
	exports.default = _default;

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LEAVE = exports.UPDATE = exports.ENTER = void 0;
	var ENTER = 'ENTER';
	exports.ENTER = ENTER;
	var UPDATE = 'UPDATE';
	exports.UPDATE = UPDATE;
	var LEAVE = 'LEAVE';
	exports.LEAVE = LEAVE;

/***/ }),
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	var ReactDOM = __webpack_require__(21);
	var scroll = __webpack_require__(1082);
	
	function calculateScrollOffset(element, offset, alignment) {
	  var body = document.body,
	      html = document.documentElement;
	  var elementRect = element.getBoundingClientRect();
	  var clientHeight = html.clientHeight;
	  var documentHeight = Math.max( body.scrollHeight, body.offsetHeight, 
	                                 html.clientHeight, html.scrollHeight, html.offsetHeight );
	  offset = offset || 0; // additional offset to top
	  var scrollPosition;
	  switch(alignment) {
	      case 'top': scrollPosition = elementRect.top; break;
	      case 'middle': scrollPosition = elementRect.bottom - clientHeight / 2 - elementRect.height / 2; break;
	      case 'bottom': scrollPosition = elementRect.bottom - clientHeight; break;
	      default: scrollPosition = elementRect.bottom - clientHeight / 2 - elementRect.height / 2; break; //defaul to middle
	    }
	  var maxScrollPosition = documentHeight - clientHeight;
	  return Math.min(scrollPosition + offset + window.pageYOffset,
	                  maxScrollPosition);
	}
	
	module.exports = function (ref, options) {
	  options = options || {
	    offset: 0,
	    align: 'middle'
	  };
	  var element = ReactDOM.findDOMNode(ref);
	  if (element === null) return 0;
	  return scroll(0, calculateScrollOffset(element, options.offset, options.align), options);
	};

/***/ }),
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Tween = __webpack_require__(525);
	var raf = __webpack_require__(524);
	
	/**
	 * Expose `scrollTo`.
	 */
	
	module.exports = scrollTo;
	
	/**
	 * Scroll to `(x, y)`.
	 *
	 * @param {Number} x
	 * @param {Number} y
	 * @api public
	 */
	
	function scrollTo(x, y, options) {
	  options = options || {};
	
	  // start position
	  var start = scroll();
	
	  // setup tween
	  var tween = Tween(start)
	    .ease(options.ease || 'out-circ')
	    .to({ top: y, left: x })
	    .duration(options.duration || 1000);
	
	  // scroll
	  tween.update(function(o){
	    window.scrollTo(o.left | 0, o.top | 0);
	  });
	
	  // handle end
	  tween.on('end', function(){
	    animate = function(){};
	  });
	
	  // animate
	  function animate() {
	    raf(animate);
	    tween.update();
	  }
	
	  animate();
	  
	  return tween;
	}
	
	/**
	 * Return scroll position.
	 *
	 * @return {Object}
	 * @api private
	 */
	
	function scroll() {
	  var y = window.pageYOffset || document.documentElement.scrollTop;
	  var x = window.pageXOffset || document.documentElement.scrollLeft;
	  return { top: y, left: x };
	}


/***/ }),
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/demo_next.4bc467f3.mp4";

/***/ }),
/* 1095 */,
/* 1096 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjM3IiBoZWlnaHQ9IjQxOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8cmVjdCBpZD0iYiIgeT0iLjUzMTIyODMiIHdpZHRoPSI1NTgiIGhlaWdodD0iMzM5Ljk2MTcyMiIgcng9IjEwIi8+CiAgICA8ZmlsdGVyIHg9Ii0xMC44JSIgeT0iLTE3LjYlIiB3aWR0aD0iMTIxLjUlIiBoZWlnaHQ9IjEzNS4zJSIgZmlsdGVyVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiBpZD0iYSI+CiAgICAgIDxmZU9mZnNldCBpbj0iU291cmNlQWxwaGEiIHJlc3VsdD0ic2hhZG93T2Zmc2V0T3V0ZXIxIi8+CiAgICAgIDxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjIwIiBpbj0ic2hhZG93T2Zmc2V0T3V0ZXIxIiByZXN1bHQ9InNoYWRvd0JsdXJPdXRlcjEiLz4KICAgICAgPGZlQ29tcG9zaXRlIGluPSJzaGFkb3dCbHVyT3V0ZXIxIiBpbjI9IlNvdXJjZUFscGhhIiBvcGVyYXRvcj0ib3V0IiByZXN1bHQ9InNoYWRvd0JsdXJPdXRlcjEiLz4KICAgICAgPGZlQ29sb3JNYXRyaXggdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjIgMCIgaW49InNoYWRvd0JsdXJPdXRlcjEiLz4KICAgIDwvZmlsdGVyPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzkuMTY2NjY3IDM4LjY5MTUxMykiPgogICAgICA8dXNlIGZpbGw9IiMwMDAiIGZpbHRlcj0idXJsKCNhKSIgeGxpbms6aHJlZj0iI2IiLz4KICAgICAgPHJlY3Qgc3Ryb2tlPSIjRkFGQkZDIiBzdHJva2UtbGluZWpvaW49InNxdWFyZSIgZmlsbD0iIzFBMUUyNSIgeD0iLjUiIHk9IjEuMDMxMjI4MyIgd2lkdGg9IjU1NyIgaGVpZ2h0PSIzMzguOTYxNzIyIiByeD0iMTAiLz4KICAgIDwvZz4KICAgIDxwYXRoIGZpbGw9IiNFQUVBRUEiIGQ9Ik0xNTguMTY2NjY3IDUzLjcwNzkxMTRoNDM4djE5NmgtNDM4eiIvPgogICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTI1MC4xNjY2NjcgMTE0LjY5MTUxM2gyNzJ2MTM1aC0yNzJ6Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1NC4xNjY2NjcgNDUuNjkxNTEzKSI+CiAgICAgIDxjaXJjbGUgZmlsbD0iI0ZGNUY1OCIgY3g9IjIiIGN5PSIyIiByPSIyIi8+CiAgICAgIDxjaXJjbGUgZmlsbD0iI0ZGQkUzMyIgY3g9IjExIiBjeT0iMiIgcj0iMiIvPgogICAgICA8Y2lyY2xlIGZpbGw9IiMyQkM3NDEiIGN4PSIyMCIgY3k9IjIiIHI9IjIiLz4KICAgIDwvZz4KICAgIDxwYXRoIGQ9Ik00MC4xNjY2NjcgMjYzLjMyNjk1Nmg1NTUuNjQ1NzIydjEwMy42Nzg0MDlINDAuMTY2NjY3eiIgZmlsbD0iIzJEMzczQSIvPgogIDwvZz4KPC9zdmc+"

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzY5IiBoZWlnaHQ9IjE2OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8ZmlsdGVyIHg9Ii01NC4xJSIgeT0iLTM1OC4xJSIgd2lkdGg9IjIyMiUiIGhlaWdodD0iOTA4LjElIiBmaWx0ZXJVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIGlkPSJhIj4KICAgICAgPGZlT2Zmc2V0IGR4PSIxNyIgZHk9IjE3IiBpbj0iU291cmNlQWxwaGEiIHJlc3VsdD0ic2hhZG93T2Zmc2V0T3V0ZXIxIi8+CiAgICAgIDxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjIwIiBpbj0ic2hhZG93T2Zmc2V0T3V0ZXIxIiByZXN1bHQ9InNoYWRvd0JsdXJPdXRlcjEiLz4KICAgICAgPGZlQ29sb3JNYXRyaXggdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjIgMCIgaW49InNoYWRvd0JsdXJPdXRlcjEiIHJlc3VsdD0ic2hhZG93TWF0cml4T3V0ZXIxIi8+CiAgICAgIDxmZU1lcmdlPgogICAgICAgIDxmZU1lcmdlTm9kZSBpbj0ic2hhZG93TWF0cml4T3V0ZXIxIi8+CiAgICAgICAgPGZlTWVyZ2VOb2RlIGluPSJTb3VyY2VHcmFwaGljIi8+CiAgICAgIDwvZmVNZXJnZT4KICAgIDwvZmlsdGVyPgogICAgPHJlY3QgaWQ9ImMiIHg9Ii4yNSIgeT0iLjk5NDEyMzUiIHdpZHRoPSIyNDQiIGhlaWdodD0iMzUuNDIzMDE5NiIgcng9IjYiLz4KICAgIDxmaWx0ZXIgeD0iLTIxLjElIiB5PSItMTQ1LjQlIiB3aWR0aD0iMTU2LjElIiBoZWlnaHQ9IjQ4Ni44JSIgZmlsdGVyVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiBpZD0iYiI+CiAgICAgIDxmZU9mZnNldCBkeD0iMTciIGR5PSIxNyIgaW49IlNvdXJjZUFscGhhIiByZXN1bHQ9InNoYWRvd09mZnNldE91dGVyMSIvPgogICAgICA8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyMCIgaW49InNoYWRvd09mZnNldE91dGVyMSIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIi8+CiAgICAgIDxmZUNvbXBvc2l0ZSBpbj0ic2hhZG93Qmx1ck91dGVyMSIgaW4yPSJTb3VyY2VBbHBoYSIgb3BlcmF0b3I9Im91dCIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIi8+CiAgICAgIDxmZUNvbG9yTWF0cml4IHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4yIDAiIGluPSJzaGFkb3dCbHVyT3V0ZXIxIi8+CiAgICA8L2ZpbHRlcj4KICAgIDxsaW5lYXJHcmFkaWVudCB4MT0iMTEuNDU5ODcwMyUiIHkxPSIxMi42Njc5NjU3JSIgeDI9IjgxLjU0MzgzNDMlIiB5Mj0iODYuMjgwMTc0NSUiIGlkPSJkIj4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0VGMzNGOCIgb2Zmc2V0PSIwJSIvPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRjc1RDRBIiBvZmZzZXQ9IjEwMCUiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxnIGZpbHRlcj0idXJsKCNhKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjguMjQ0OTYyIDMxLjAzMzQ2MSkiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8dXNlIGZpbGw9IiMwMDAiIGZpbHRlcj0idXJsKCNiKSIgeGxpbms6aHJlZj0iI2MiLz4KICAgIDxyZWN0IHN0cm9rZT0iIzFCMUYyOCIgc3Ryb2tlLWxpbmVqb2luPSJzcXVhcmUiIGZpbGw9IiMzRDQ5NEMiIHg9Ii43NSIgeT0iMS40OTQxMjM1IiB3aWR0aD0iMjQzIiBoZWlnaHQ9IjM0LjQyMzAxOTYiIHJ4PSI2Ii8+CiAgICA8cGF0aCBkPSJNMTA0LjU3MyAxNi44ODg2NzV2MS4wNTNoLTYuNzZ2LTEuMDUzaDYuNzZ6bTAgMi43OTV2MS4wNTNoLTYuNzZ2LTEuMDUzaDYuNzZ6IiBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz4KICAgIDxwYXRoIGQ9Ik0xMTIuMjk1IDE4LjU3ODY3NWMtLjQ4NTMzNTgtLjE5MDY2NzYtLjg1Nzk5ODctLjQ2Nzk5ODItMS4xMTgtLjgzMi0uMjYwMDAxMy0uMzY0MDAxOC0uMzktLjgwMTY2NDEtLjM5LTEuMzEzIDAtLjQ3NjY2OS4xMTY5OTg4LS45MDM0OTgxLjM1MS0xLjI4MDUuMjM0MDAxMi0uMzc3MDAxOS41ODI4MzEtLjY3NTk5ODkgMS4wNDY1LS44OTcuNDYzNjY5LS4yMjEwMDExIDEuMDI0ODMtLjMzMTUgMS42ODM1LS4zMzE1LjY1ODY3IDAgMS4yMTk4MzEuMTEwNDk4OSAxLjY4MzUuMzMxNS40NjM2NjkuMjIxMDAxMS44MTQ2NjU1LjUyMjE2NDggMS4wNTMuOTAzNS4yMzgzMzQ1LjM4MTMzNTIuMzU3NS44MDU5OTc3LjM1NzUgMS4yNzQgMCAuNTAyNjY5Mi0uMTM0MzMyLjk0MDMzMTUtLjQwMyAxLjMxMy0uMjY4NjY4LjM3MjY2ODUtLjYzNjk5NzcuNjQ5OTk5LTEuMTA1LjgzMi41NDYwMDI3LjE3MzMzNDIuOTc0OTk4NC40Njc5OTggMS4yODcuODg0LjMxMjAwMTYuNDE2MDAyLjQ2OC45MjI5OTcuNDY4IDEuNTIxIDAgLjU4MDY2OTYtLjEzODY2NTMgMS4wODU0OTc5LS40MTYgMS41MTQ1LS4yNzczMzQ3LjQyOTAwMjEtLjY2OTQ5NzUuNzU4MzMyMi0xLjE3NjUuOTg4LS41MDcwMDI1LjIyOTY2NzgtMS4wODk4My4zNDQ1LTEuNzQ4NS4zNDQ1LS42NTg2NyAwLTEuMjM3MTY0Mi0uMTE0ODMyMi0xLjczNTUtLjM0NDUtLjQ5ODMzNTgtLjIyOTY2NzgtLjg4NjE2NTMtLjU1ODk5NzktMS4xNjM1LS45ODgtLjI3NzMzNDctLjQyOTAwMjEtLjQxNi0uOTMzODMwNC0uNDE2LTEuNTE0NSAwLS42MDY2Njk3LjE1NTk5ODQtMS4xMTc5OTguNDY4LTEuNTM0cy43MzY2NjQtLjcwNjMzMjUgMS4yNzQtLjg3MXptMS41NzMtMy42NjZjLS41ODkzMzYzIDAtMS4wNTk0OTgyLjE0Mjk5ODYtMS40MTA1LjQyOS0uMzUxMDAxOC4yODYwMDE0LS41MjY1LjY5NzY2NC0uNTI2NSAxLjIzNSAwIC40ODUzMzU4LjE3OTgzMTUuODc3NDk4NS41Mzk1IDEuMTc2NS4zNTk2Njg1LjI5OTAwMTUuODI1NDk3MS40NDg1IDEuMzk3NS40NDg1LjU4MDY2OTYgMCAxLjA1MDgzMTUtLjE1MTY2NTIgMS40MTA1LS40NTUuMzU5NjY4NS0uMzAzMzM0OS41Mzk1LS42OTc2NjQyLjUzOTUtMS4xODMgMC0uNTI4NjY5My0uMTc1NDk4Mi0uOTM1OTk4Ni0uNTI2NS0xLjIyMi0uMzUxMDAxOC0uMjg2MDAxNC0uODI1NDk3LS40MjktMS40MjM1LS40Mjl6bTAgNC4xODZjLS42NDEzMzY1IDAtMS4xNjU2NjQ2LjE1MzgzMTgtMS41NzMuNDYxNS0uNDA3MzM1NC4zMDc2NjgyLS42MTEuNzY5MTYzNi0uNjExIDEuMzg0NSAwIC41ODA2Njk2LjE5NzE2NDcgMS4wNDIxNjUuNTkxNSAxLjM4NDUuMzk0MzM1My4zNDIzMzUuOTI1MTYzMy41MTM1IDEuNTkyNS41MTM1czEuMTk1OTk4LS4xNzMzMzE2IDEuNTg2LS41MmMuMzkwMDAxOS0uMzQ2NjY4NC41ODUtLjgwNTk5NzEuNTg1LTEuMzc4IDAtLjYwNjY2OTctLjE5OTMzMTMtMS4wNjU5OTg0LS41OTgtMS4zNzgtLjM5ODY2ODctLjMxMjAwMTYtLjkyMjk5NjgtLjQ2OC0xLjU3My0uNDY4em00LjYyOCAyLjM3OXYtLjg5N2w0LjU2My02LjMxOGgxLjQxN3Y2LjE4OGgxLjN2MS4wMjdoLTEuM3YyLjA5M2gtMS4xN3YtMi4wOTNoLTQuODF6bTQuODYyLTUuOThsLTMuNDk3IDQuOTUzaDMuNDk3di00Ljk1M3oiIGZpbGw9IiMwNEI2Q0IiIGZpbGwtcnVsZT0ibm9uemVybyIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQ0Ljc1NTAzOCAxMC45NjY1MzkpIj4KICAgICAgPHJlY3QgZmlsbD0idXJsKCNkKSIgd2lkdGg9IjU5IiBoZWlnaHQ9IjE1IiByeD0iMyIvPgogICAgICA8dGV4dCBmb250LWZhbWlseT0iUG9wcGlucy1SZWd1bGFyLCBQb3BwaW5zIiBmb250LXNpemU9IjEwIiBmaWxsPSIjRkZGIj4KICAgICAgICA8dHNwYW4geD0iOSIgeT0iMTEiPk15U3RhdGU8L3RzcGFuPgogICAgICA8L3RleHQ+CiAgICA8L2c+CiAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xMzcuNzg4IDE5LjM0NTY3NWgtMi43NTZ2Mi43ODJoLTEuMTMxdi0yLjc4MmgtMi43NDN2LTEuMDUzaDIuNzQzdi0yLjc5NWgxLjEzMXYyLjc5NWgyLjc1NnoiLz4KICAgIDxwYXRoIGQ9Ik04OS43NSAxLjEwODIwODd2MzUuNDIzMDE5Nkg2LjI1Yy0zLjMxMzcwODUgMC02LTIuNjg2MjkxNS02LTZWNy4xMDgyMDg3YzAtMy4zMTM3MDg1IDIuNjg2MjkxNS02IDYtNmg4My41eiIgZmlsbD0iIzFCMUYyOCIvPgogICAgPHRleHQgZm9udC1mYW1pbHk9IlBvcHBpbnMtUmVndWxhciwgUG9wcGlucyIgZm9udC1zaXplPSIxMCIgZmlsbD0iI0ZGRiI+CiAgICAgIDx0c3BhbiB4PSIyNS41IiB5PSIyMi4yMDU2MzMzIj5TQ0FMRSBYPC90c3Bhbj4KICAgIDwvdGV4dD4KICAgIDxwYXRoIGZpbGw9IiMwNEI2Q0IiIGQ9Ik0yMTIuMTUzNzQxIDYuMTk5NTAzN2gxVjMyLjc1NzY1NWgtMXoiLz4KICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTk4IiBoZWlnaHQ9IjM3OSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8cmVjdCBpZD0iYiIgeT0iLjUzMTIyODMiIHdpZHRoPSI1NTgiIGhlaWdodD0iMzM5Ljk2MTcyMiIgcng9IjEwIi8+CiAgICA8ZmlsdGVyIHg9Ii01LjQlIiB5PSItOC44JSIgd2lkdGg9IjExMC44JSIgaGVpZ2h0PSIxMTcuNiUiIGZpbHRlclVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgaWQ9ImEiPgogICAgICA8ZmVPZmZzZXQgaW49IlNvdXJjZUFscGhhIiByZXN1bHQ9InNoYWRvd09mZnNldE91dGVyMSIvPgogICAgICA8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxMCIgaW49InNoYWRvd09mZnNldE91dGVyMSIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIi8+CiAgICAgIDxmZUNvbXBvc2l0ZSBpbj0ic2hhZG93Qmx1ck91dGVyMSIgaW4yPSJTb3VyY2VBbHBoYSIgb3BlcmF0b3I9Im91dCIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIi8+CiAgICAgIDxmZUNvbG9yTWF0cml4IHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4yIDAiIGluPSJzaGFkb3dCbHVyT3V0ZXIxIi8+CiAgICA8L2ZpbHRlcj4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwIDE5LjIyMjc0MSkiPgogICAgICA8dXNlIGZpbGw9IiMwMDAiIGZpbHRlcj0idXJsKCNhKSIgeGxpbms6aHJlZj0iI2IiLz4KICAgICAgPHJlY3Qgc3Ryb2tlPSIjRkFGQkZDIiBzdHJva2UtbGluZWpvaW49InNxdWFyZSIgZmlsbD0iIzFCMUYyOCIgeD0iLjUiIHk9IjEuMDMxMjI4MyIgd2lkdGg9IjU1NyIgaGVpZ2h0PSIzMzguOTYxNzIyIiByeD0iMTAiLz4KICAgIDwvZz4KICAgIDxwYXRoIGZpbGw9IiNFQUVBRUEiIGQ9Ik0xMzkgMzQuMjM5MTM5NGg0Mzh2MTk2SDEzOXoiLz4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0yMzEgOTUuMjIyNzQxaDI3MnYxMzVIMjMxeiIvPgogICAgPHBhdGggZmlsbD0iIzM1M0Y0MSIgZD0iTTM0LjgzMzMzMzMgMzQuNDg1Njc5OWgxMDR2MTk2aC0xMDR6Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNSAyNi4yMjI3NDEpIj4KICAgICAgPGNpcmNsZSBmaWxsPSIjRkY1RjU4IiBjeD0iMiIgY3k9IjIiIHI9IjIiLz4KICAgICAgPGNpcmNsZSBmaWxsPSIjRkZCRTMzIiBjeD0iMTEiIGN5PSIyIiByPSIyIi8+CiAgICAgIDxjaXJjbGUgZmlsbD0iIzJCQzc0MSIgY3g9IjIwIiBjeT0iMiIgcj0iMiIvPgogICAgPC9nPgogICAgPHBhdGggZmlsbD0iIzJEMzczQSIgZD0iTTIxIDI0My44NTgxODRoNTU1LjY0NTcyMnYxMDMuNjc4NDA5SDIxeiIvPgogIDwvZz4KPC9zdmc+"

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjg1IiBoZWlnaHQ9IjExNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZGVmcz4KICAgIDxmaWx0ZXIgeD0iLTUyLjklIiB5PSItMjgwLjglIiB3aWR0aD0iMjA1LjglIiBoZWlnaHQ9IjY2MS41JSIgZmlsdGVyVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiBpZD0iYSI+CiAgICAgIDxmZU9mZnNldCBkeD0iLTE3IiBkeT0iMTciIGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dPZmZzZXRPdXRlcjEiLz4KICAgICAgPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMjAiIGluPSJzaGFkb3dPZmZzZXRPdXRlcjEiIHJlc3VsdD0ic2hhZG93Qmx1ck91dGVyMSIvPgogICAgICA8ZmVDb2xvck1hdHJpeCB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMiAwIiBpbj0ic2hhZG93Qmx1ck91dGVyMSIgcmVzdWx0PSJzaGFkb3dNYXRyaXhPdXRlcjEiLz4KICAgICAgPGZlTWVyZ2U+CiAgICAgICAgPGZlTWVyZ2VOb2RlIGluPSJzaGFkb3dNYXRyaXhPdXRlcjEiLz4KICAgICAgICA8ZmVNZXJnZU5vZGUgaW49IlNvdXJjZUdyYXBoaWMiLz4KICAgICAgPC9mZU1lcmdlPgogICAgPC9maWx0ZXI+CiAgICA8bGluZWFyR3JhZGllbnQgeDE9IjExLjQ1OTg3MDMlIiB5MT0iMTIuNjY3OTY1NyUiIHgyPSI4MS41NDM4MzQzJSIgeTI9Ijg2LjI4MDE3NDUlIiBpZD0iYiI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNFRjMzRjgiIG9mZnNldD0iMCUiLz4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0Y3NUQ0QSIgb2Zmc2V0PSIxMDAlIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8ZyBmaWx0ZXI9InVybCgjYSkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU2LjMzMzMzMyAyMi40MzkzNTYpIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAuMTg1MDk5KSI+CiAgICAgIDxyZWN0IGZpbGw9IiMxQjFGMjgiIHg9Ii4xNzc0MzU3IiB5PSIuMTY5OTE3MSIgd2lkdGg9IjQ2LjUiIGhlaWdodD0iMzcuNSIgcng9IjQuNSIvPgogICAgICA8cGF0aCBkPSJNMzguNTc0NzM2OSAxOC44Nzc2MjUxYy0uMDcwNS0uMDc5NS0xLjc3My0xLjk1NzUtNC40MzQtMy44NTgtMS41NzA1LTEuMTIyLTMuMTUtMi4wMTYtNC42OTUtMi42NTk1LTEuOTU3NS0uODE2LTMuODY4NS0xLjIzLTUuNjc5LTEuMjMtMS44MTA1IDAtMy43MjE1LjQxNC01LjY3OSAxLjIzLTEuNTQ1LjY0MzUtMy4xMjQ1IDEuNTM5LTQuNjk1IDIuNjU5NS0yLjY2MSAxLjkwMDUtNC4zNjM1IDMuNzgtNC40MzQgMy44NTgtLjI1NjUuMjg1LS4yNTY1LjcxODUgMCAxLjAwMzUuMDcwNS4wNzk1IDEuNzczIDEuOTU3NSA0LjQzNCAzLjg1OCAxLjU3MDUgMS4xMjIgMy4xNSAyLjAxNiA0LjY5NSAyLjY1OTUgMS45NTc1LjgxNiAzLjg2ODUgMS4yMyA1LjY3OSAxLjIzIDEuODEwNSAwIDMuNzIxNS0uNDE0IDUuNjc5LTEuMjMgMS41NDUtLjY0MzUgMy4xMjQ1LTEuNTM5IDQuNjk1LTIuNjU5NSAyLjY2MS0xLjkwMDUgNC4zNjM1LTMuNzggNC40MzQtMy44NTguMjU2NS0uMjg1LjI1NjUtLjcxODUgMC0xLjAwMzV6bS0xMC45NDctNS41OTJjMS4zNjA1IDEuMTQ0NSAyLjEzOSAyLjgwOTUgMi4xMzkgNC41OTMgMCAzLjMwOS0yLjY5MSA2LTYgNnMtNi0yLjY5MS02LTZjMC0xLjc4Mi43Nzg1LTMuNDQ4NSAyLjEzOS00LjU5MyAxLjIzMy0uNDAyIDIuNTM2NS0uNjU3IDMuODYxLS42NTdzMi42MjguMjU1IDMuODYxLjY1N3ptNS42MTQ1IDkuMjUyYy0yLjI5OTUgMS42MzgtNS44MDk1IDMuNTkxLTkuNDc1NSAzLjU5MS0zLjY2NiAwLTcuMTc2LTEuOTUzLTkuNDc1NS0zLjU5MS0xLjczNTUtMS4yMzYtMy4wNjMtMi40ODctMy43MzM1LTMuMTU5LjY3MDUtLjY3MiAxLjk5OC0xLjkyMTUgMy43MzM1LTMuMTU5Ljc5NS0uNTY3IDEuNzM0LTEuMTcgMi43NzUtMS43MTc1LS41MjA1IDEuMDMyLS43OTk1IDIuMTgyNS0uNzk5NSAzLjM3NjUgMCA0LjEzNTUgMy4zNjQ1IDcuNSA3LjUgNy41czcuNS0zLjM2NDUgNy41LTcuNWMwLTEuMTk0LS4yNzktMi4zNDQ1LS43OTk1LTMuMzc2NSAxLjA0MS41NDc1IDEuOTggMS4xNTIgMi43NzUgMS43MTc1IDEuNzM1NSAxLjIzNiAzLjA2MyAyLjQ4NyAzLjczMzUgMy4xNTktLjY3MDUuNjcyLTEuOTk4IDEuOTIxNS0zLjczMzUgMy4xNTl6IiBmaWxsPSJ1cmwoI2IpIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz4KICAgIDwvZz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY0LjUgLjE4NTA5OSkiPgogICAgICA8cmVjdCBmaWxsPSIjMUIxRjI4IiB4PSIuMTc3NDM1NyIgeT0iLjE3NTA3OTEiIHdpZHRoPSIxNDEiIGhlaWdodD0iMzcuNSIgcng9IjQuNSIvPgogICAgICA8cGF0aCBkPSJNNTYuNDkgMTcuMDUzMjM1OGMwIC44NzAwMDQ0LS4yOTc0OTcgMS41OTI0OTcxLS44OTI1IDIuMTY3NS0uNTk1MDAzLjU3NTAwMjktMS41MDI0OTM5Ljg2MjUtMi43MjI1Ljg2MjVoLTIuMDF2NC4zNjVINDkuNXYtMTAuNDU1aDMuMzc1YzEuMTgwMDA1OSAwIDIuMDc3NDk2OS4yODQ5OTcyIDIuNjkyNS44NTUuNjE1MDAzMS41NzAwMDI5LjkyMjUgMS4zMDQ5OTU1LjkyMjUgMi4yMDV6bS0zLjYxNSAxLjk1Yy43NTAwMDM4IDAgMS4zMDc0OTgyLS4xNzI0OTgzIDEuNjcyNS0uNTE3NS4zNjUwMDE4LS4zNDUwMDE3LjU0NzUtLjgyMjQ5NjkuNTQ3NS0xLjQzMjUgMC0uNjMwMDAzMS0uMTc5OTk4Mi0xLjExNzQ5ODMtLjU0LTEuNDYyNS0uMzYwMDAxOC0uMzQ1MDAxNy0uOTE5OTk2Mi0uNTE3NS0xLjY4LS41MTc1aC0yLjAxdjMuOTNoMi4wMXptOS42NDUtNS4wMXY2LjZjMCAuOTIwMDA0Ni4yMjk5OTc3IDEuNjA3NDk3Ny42OSAyLjA2MjUuNDYwMDAyMy40NTUwMDIzIDEuMDg5OTk2LjY4MjUgMS44OS42ODI1LjgwMDAwNCAwIDEuNDI3NDk3Ny0uMjI3NDk3NyAxLjg4MjUtLjY4MjUuNDU1MDAyMy0uNDU1MDAyMy42ODI1LTEuMTQyNDk1NC42ODI1LTIuMDYyNXYtNi42aDEuMzY1djYuNmMwIC44NzAwMDQ0LS4xNzQ5OTgyIDEuNjAyNDk3LS41MjUgMi4xOTc1LS4zNTAwMDE3LjU5NTAwMy0uODIyNDk3IDEuMDM3NDk4Ni0xLjQxNzUgMS4zMjc1LS41OTUwMDMuMjkwMDAxNS0xLjI2MjQ5NjMuNDM1LTIuMDAyNS40MzUtLjc0MDAwMzcgMC0xLjQwNzQ5Ny0uMTQ0OTk4NS0yLjAwMjUtLjQzNS0uNTk1MDAzLS4yOTAwMDE0LTEuMDY0OTk4My0uNzMyNDk3LTEuNDEtMS4zMjc1LS4zNDUwMDE3LS41OTUwMDMtLjUxNzUtMS4zMjc0OTU2LS41MTc1LTIuMTk3NXYtNi42aDEuMzY1em0xNy4wMjUgNS4wN2MuMzgwMDAxOS4wNjAwMDAzLjcyNzQ5ODQuMjE0OTk4OCAxLjA0MjUuNDY1LjMxNTAwMTYuMjUwMDAxMy41NjQ5OTkxLjU1OTk5ODIuNzUuOTMuMTg1MDAwOS4zNzAwMDE5LjI3NzUuNzY0OTk3OS4yNzc1IDEuMTg1IDAgLjUzMDAwMjctLjEzNDk5ODYgMS4wMDc0OTc5LS40MDUgMS40MzI1LS4yNzAwMDEzLjQyNTAwMjEtLjY2MjQ5NzQuNzU5OTk4OC0xLjE3NzUgMS4wMDUtLjUxNTAwMjYuMjQ1MDAxMi0xLjEyMjQ5NjUuMzY3NS0xLjgyMjUuMzY3NWgtMy45di0xMC40NTVoMy43NWMuNzEwMDAzNiAwIDEuMzE0OTk3NS4xMTc0OTg4IDEuODE1LjM1MjUuNTAwMDAyNS4yMzUwMDEyLjg3NDk5ODguNTUyNDk4IDEuMTI1Ljk1MjUuMjUwMDAxMy40MDAwMDIuMzc1Ljg0OTk5NzUuMzc1IDEuMzUgMCAuNjIwMDAzMS0uMTY3NDk4MyAxLjEzMjQ5OC0uNTAyNSAxLjUzNzUtLjMzNTAwMTcuNDA1MDAyLS43Nzc0OTcyLjY5NzQ5OTEtMS4zMjc1Ljg3NzV6bS0zLjg3LS41MjVoMi4yOTVjLjYzMDAwMzIgMCAxLjEyMjQ5ODItLjE1MjQ5ODUgMS40Nzc1LS40NTc1LjM1NTAwMTgtLjMwNTAwMTUuNTMyNS0uNzI3NDk3My41MzI1LTEuMjY3NSAwLS41NDAwMDI3LS4xNzQ5OTgyLS45NjQ5OTg0LS41MjUtMS4yNzUtLjM1MDAwMTctLjMxMDAwMTUtLjg1NDk5NjctLjQ2NS0xLjUxNS0uNDY1aC0yLjI2NXYzLjQ2NXptMi40MTUgNC44M2MuNjcwMDAzNCAwIDEuMTk3NDk4MS0uMTY0OTk4MyAxLjU4MjUtLjQ5NS4zODUwMDE5LS4zMzAwMDE2LjU3NzUtLjc4NDk5NzEuNTc3NS0xLjM2NXMtLjE5OTk5OC0xLjAzOTk5ODMtLjYtMS4zOGMtLjQwMDAwMi0uMzQwMDAxNy0uOTM0OTk2Ni0uNTEtMS42MDUtLjUxaC0yLjM3djMuNzVoMi40MTV6bTkuNzguMDNoMy42NnYxLjA1aC01LjAyNXYtMTAuNDU1aDEuMzY1djkuNDA1em05LjQ4LTkuNDA1djEwLjQ1NWgtMS4zNjV2LTEwLjQ1NWgxLjM2NXptOC42NCAxMC41NmMtLjY5MDAwMyAwLTEuMzA3NDk3LS4xMjI0OTg4LTEuODUyNS0uMzY3NS0uNTQ1MDAzLS4yNDUwMDEyLS45NzI0OTgtLjU4NDk5NzgtMS4yODI1LTEuMDJzLS40Ny0uOTM3NDk3MS0uNDgtMS41MDc1aDEuNDU1Yy4wNS41MDAwMDI1LjI1NDk5OC45MjI0OTgzLjYxNSAxLjI2NzUuMzYwMDAyLjM0NTAwMTcuODc0OTk3LjUxNzUgMS41NDUuNTE3NS42NDAwMDMgMCAxLjE0OTk5OC0uMTY3NDk4MyAxLjUzLS41MDI1LjM4MDAwMi0uMzM1MDAxNy41Ny0uNzYyNDk3NC41Ny0xLjI4MjUgMC0uNDAwMDAyLS4xMDk5OTktLjcyNDk5ODctLjMzLS45NzUtLjIyMDAwMS0uMjUwMDAxMi0uNDk0OTk4LS40Mzk5OTkzLS44MjUtLjU3LS4zMzAwMDItLjEzMDAwMDYtLjc3NDk5Ny0uMjY5OTk5Mi0xLjMzNS0uNDItLjY5MDAwMy0uMTgwMDAwOS0xLjI0MjQ5OC0uMzU5OTk5MS0xLjY1NzUtLjU0LS40MTUwMDItLjE4MDAwMDktLjc2OTk5OS0uNDYyNDk4MS0xLjA2NS0uODQ3NS0uMjk1MDAxLS4zODUwMDE5LS40NDI1LS45MDI0OTY3LS40NDI1LTEuNTUyNSAwLS41NzAwMDI4LjE0NDk5OS0xLjA3NDk5NzguNDM1LTEuNTE1LjI5MDAwMS0uNDQwMDAyMi42OTc0OTctLjc3OTk5ODggMS4yMjI1LTEuMDIuNTI1MDAzLS4yNDAwMDEyIDEuMTI3NDk3LS4zNiAxLjgwNzUtLjM2Ljk4MDAwNSAwIDEuNzgyNDk3LjI0NDk5NzYgMi40MDc1LjczNS42MjUwMDMuNDkwMDAyNS45Nzc1IDEuMTM5OTk2IDEuMDU3NSAxLjk1aC0xLjVjLS4wNS0uNDMwMDAyMS0uMjU3NDk4LS43OTc0OTg1LS42MjI1LTEuMTAyNS0uMzY1MDAyLS4zMDUwMDE1LS44NTc0OTctLjQ1NzUtMS40Nzc1LS40NTc1LS41NzAwMDMgMC0xLjAzNDk5OC4xNDk5OTg1LTEuMzk1LjQ1LS4zNjAwMDIuMzAwMDAxNS0uNTQuNzI0OTk3My0uNTQgMS4yNzUgMCAuMzgwMDAxOS4xMDc0OTkuNjg5OTk4OC4zMjI1LjkzLjIxNTAwMS4yNDAwMDEyLjQ3OTk5OC40MjI0OTk0Ljc5NS41NDc1LjMxNTAwMi4xMjUwMDA2Ljc1NzQ5Ny4yNjc0OTkyIDEuMzI3NS40Mjc1LjY5MDAwMy4xOTAwMDEgMS4yNDQ5OTguMzc3NDk5MSAxLjY2NS41NjI1LjQyMDAwMi4xODUwMDA5Ljc3OTk5OS40Njk5OTgxIDEuMDguODU1LjMwMDAwMi4zODUwMDE5LjQ1LjkwNzQ5NjcuNDUgMS41Njc1IDAgLjUxMDAwMjYtLjEzNDk5OS45ODk5OTc4LS40MDUgMS40NC0uMjcwMDAxLjQ1MDAwMjMtLjY2OTk5Ny44MTQ5OTg2LTEuMiAxLjA5NS0uNTMwMDAzLjI4MDAwMTQtMS4xNTQ5OTYuNDItMS44NzUuNDJ6bTE2LjU0NS0xMC41NnYxMC40NTVoLTEuMzY1di00Ljc3aC01LjMyNXY0Ljc3aC0xLjM2NXYtMTAuNDU1aDEuMzY1djQuNjJoNS4zMjV2LTQuNjJoMS4zNjV6TTMwLjQyMzYgMjAuMjY1OThsLS4wMDEyLS4wMDEyYy4yMzQuMjM0LjIzNC42MTQ0IDAgLjg0ODQtLjExNjQuMTE3Ni0uMjcxMi4xNzY0LS40MjM2LjE3NjQtLjE1MjQgMC0uMzA2LS4wNTc2LS40MjM2LS4xNzUybC0xLjM3NjQtMS4zNzUydjUuMTUxNmMwIC4zMzEyLS4yNjg4LjYtLjYuNnMtLjYtLjI2ODgtLjYtLjZ2LTUuMTUxNmwtMS4zNzUyIDEuMzc1MmMtLjIzNC4yMzQtLjYxNDQuMjM0LS44NDg0IDAtLjIzNC0uMjM0LS4yMzQtLjYxNDQgMC0uODQ4NGwyLjQtMi40Yy4yMzQtLjIzNC42MTQ0LS4yMzQuODQ4NCAwbDIuNCAyLjR6bTMuNzgzNiA1LjIyMzZIMzBjLS4zMzEyIDAtLjYtLjI2ODgtLjYtLjZzLjI2ODgtLjYuNi0uNmg0LjIwNzJjMS45ODEyIDAgMy41OTI4LTEuNjExNiAzLjU5MjgtMy41OTI4cy0xLjYxMTYtMy41OTI4LTMuNTkyOC0zLjU5MjhjLS40MjQ4IDAtLjgzODguMDczMi0xLjIzMTIuMjE2LS4yNjE2LjA5Ni0uNTU0NC0uMDAxMi0uNzA4LS4yMzQtLjE1MzYtLjIzMjgtLjEyNDgtLjU0LjA2NzItLjc0MjguNDI4NC0uNDUxMi42NjQ4LTEuMDM4LjY2NDgtMS42NTQ4IDAtMS4zMjM2LTEuMDc2NC0yLjQtMi40LTIuNC0uNzcwNCAwLTEuNDc0OC4zNTY0LTEuOTMyLjk3NjgtLjI3Ni4zNzQ0LS40MzguODEzNi0uNDY1NiAxLjI2ODQtLjAxNTYuMjU0NC0uMTkwOC40NzA0LS40MzU2LjU0LS4yNDQ4LjA2OTYtLjUwNzYtLjAyNC0uNjU0LS4yMzE2LS4xMzItLjE4NzItLjI3NDgtLjM2ODQtLjQyNDgtLjUzNjQtMS4xMzg4LTEuMjgxNi0yLjc3NDQtMi4wMTcyLTQuNDg4LTIuMDE3Mi0zLjMwODQgMC02IDIuNjkxNi02IDZzMi42OTE2IDYgNiA2aDNjLjMzMTIgMCAuNi4yNjg4LjYuNnMtLjI2ODguNi0uNi42aC0zYy0zLjk2OTYgMC03LjItMy4yMzA0LTcuMi03LjIgMC0zLjk2OTYgMy4yMzA0LTcuMiA3LjItNy4yIDEuOTIyNCAwIDMuNzY0NC43NzE2IDUuMTEyIDIuMTMuMTA1Ni0uMjMyOC4yMzUyLS40NTYuMzktLjY2Ni42NzY4LS45MTY4IDEuNzYwNC0xLjQ2NCAyLjg5OC0xLjQ2NCAxLjk4NDggMCAzLjYgMS42MTUyIDMuNiAzLjYgMCAuNDIxMi0uMDczMi44MzI4LS4yMTM2IDEuMjIwNC4wNzMyLS4wMDM2LjE0NjQtLjAwNDguMjIwOC0uMDA0OCAyLjY0MjQgMCA0Ljc5MjggMi4xNTA0IDQuNzkyOCA0Ljc5MjhzLTIuMTUwNCA0Ljc5MjgtNC43OTI4IDQuNzkyOHoiIGZpbGw9InVybCgjYikiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pub_modal.0a440709.svg";

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTk3IDM3OSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8cmVjdCBpZD0iYiIgeT0iLjUzMTIyODMiIHdpZHRoPSI1NTgiIGhlaWdodD0iMzM5Ljk2MTcyMiIgcng9IjEwIi8+CiAgICA8ZmlsdGVyIHg9Ii01LjQlIiB5PSItOC44JSIgd2lkdGg9IjExMC44JSIgaGVpZ2h0PSIxMTcuNiUiIGZpbHRlclVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgaWQ9ImEiPgogICAgICA8ZmVPZmZzZXQgaW49IlNvdXJjZUFscGhhIiByZXN1bHQ9InNoYWRvd09mZnNldE91dGVyMSIvPgogICAgICA8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxMCIgaW49InNoYWRvd09mZnNldE91dGVyMSIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIi8+CiAgICAgIDxmZUNvbXBvc2l0ZSBpbj0ic2hhZG93Qmx1ck91dGVyMSIgaW4yPSJTb3VyY2VBbHBoYSIgb3BlcmF0b3I9Im91dCIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIi8+CiAgICAgIDxmZUNvbG9yTWF0cml4IHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4yIDAiIGluPSJzaGFkb3dCbHVyT3V0ZXIxIi8+CiAgICA8L2ZpbHRlcj4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5LjY2NjY2NyAxOS4zNDk2MDQpIj4KICAgICAgPHVzZSBmaWxsPSIjMDAwIiBmaWx0ZXI9InVybCgjYSkiIHhsaW5rOmhyZWY9IiNiIi8+CiAgICAgIDxyZWN0IHN0cm9rZT0iI0ZBRkJGQyIgc3Ryb2tlLWxpbmVqb2luPSJzcXVhcmUiIGZpbGw9IiMxNjE4MUMiIHg9Ii41IiB5PSIxLjAzMTIyODMiIHdpZHRoPSI1NTciIGhlaWdodD0iMzM4Ljk2MTcyMiIgcng9IjEwIi8+CiAgICA8L2c+CiAgICA8cGF0aCBmaWxsPSIjRUFFQUVBIiBkPSJNMTM4LjY2NjY2NyAzNC4zNjYwMDI0aDQzOHYxOTZoLTQzOHoiLz4KICAgIDxwYXRoIGZpbGw9IiMyRDM3M0EiIGQ9Ik0zNC42NjY2NjcgMzQuMzY2MDAyNGgxMDR2MTk2aC0xMDR6Ii8+CiAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNMjMwLjY2NjY2NyA5NS4zNDk2MDRoMjcydjEzNWgtMjcyeiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzQuNjY2NjY3IDI2LjM0OTYwNCkiPgogICAgICA8Y2lyY2xlIGZpbGw9IiNGRjVGNTgiIGN4PSIyIiBjeT0iMiIgcj0iMiIvPgogICAgICA8Y2lyY2xlIGZpbGw9IiNGRkJFMzMiIGN4PSIxMSIgY3k9IjIiIHI9IjIiLz4KICAgICAgPGNpcmNsZSBmaWxsPSIjMkJDNzQxIiBjeD0iMjAiIGN5PSIyIiByPSIyIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNzYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik0xMi43MzMgNzUuNmM2Ljk1NiAwIDEyLjYtNS42NDUgMTIuNi0xMi42VjUwLjRoLTEyLjZDNS43NzggNTAuNC4xMzMgNTYuMDQ1LjEzMyA2M3M1LjY0NSAxMi42IDEyLjYgMTIuNnoiIGZpbGw9IiMwQUNGODMiLz4KICAgIDxwYXRoIGQ9Ik0uMTMzIDM3LjhjMC02Ljk1NSA1LjY0NS0xMi42IDEyLjYtMTIuNmgxMi42djI1LjJoLTEyLjZjLTYuOTU1IDAtMTIuNi01LjY0NS0xMi42LTEyLjZ6IiBmaWxsPSIjQTI1OUZGIi8+CiAgICA8cGF0aCBkPSJNLjEzMyAxMi42Qy4xMzMgNS42NDUgNS43NzggMCAxMi43MzMgMGgxMi42djI1LjJoLTEyLjZjLTYuOTU1IDAtMTIuNi01LjY0NS0xMi42LTEyLjZ6IiBmaWxsPSIjRjI0RTFFIi8+CiAgICA8cGF0aCBkPSJNMjUuMzMzIDBoMTIuNmM2Ljk1NiAwIDEyLjYgNS42NDUgMTIuNiAxMi42cy01LjY0NCAxMi42LTEyLjYgMTIuNmgtMTIuNlYweiIgZmlsbD0iI0ZGNzI2MiIvPgogICAgPHBhdGggZD0iTTUwLjUzMyAzNy44YzAgNi45NTUtNS42NDQgMTIuNi0xMi42IDEyLjYtNi45NTUgMC0xMi42LTUuNjQ1LTEyLjYtMTIuNnM1LjY0NS0xMi42IDEyLjYtMTIuNmM2Ljk1NiAwIDEyLjYgNS42NDUgMTIuNiAxMi42eiIgZmlsbD0iIzFBQkNGRSIvPgogIDwvZz4KPC9zdmc+"

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzMiIGhlaWdodD0iNzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGZpbGw9IiMyNjEzMDAiIGQ9Ik0zLjY2NyAzLjU2N2g2NnY2NC4yaC02NnoiLz4KICAgIDxwYXRoIGQ9Ik0uNjY3LjU2N3Y3MC4yaDcyVi41NjdoLTcyem0zIDNoNjZ2NjQuMmgtNjZ2LTY0LjJ6IiBmaWxsPSIjRkY3QzAwIi8+CiAgICA8cGF0aCBkPSJNMjUuNjU3IDQwLjMxN2wtMi4zNyA5Yy0uMDYuMjQtLjE1LjMtLjQ1LjNoLTQuNDFjLS4zIDAtLjM2LS4wOS0uMy0uNDVsOC41Mi0yOS44MmMuMTUtLjU0LjI0LTEuMDIuMy0yLjQ5IDAtLjIxLjA5LS4zLjI0LS4zaDYuM2MuMjEgMCAuMy4wNi4zNi4zbDkuNTQgMzIuMzdjLjA2LjI0IDAgLjM5LS4yNC4zOWgtNC45OGMtLjI0IDAtLjM5LS4wNi0uNDUtLjI3bC0yLjQ5LTkuMDNoLTkuNTd6bTguMzQtNC44NmMtLjg0LTMuMzMtMi44Mi0xMC41OS0zLjU3LTE0LjFoLS4wNmMtLjYzIDMuNTEtMi4yMiA5LjQ1LTMuNDggMTQuMWg3LjExem0xMy41LTE2LjY4YzAtMS45MiAxLjM1LTMuMDYgMy4wNi0zLjA2IDEuODMgMCAzLjA2IDEuMjMgMy4wNiAzLjA2IDAgMS45OC0xLjI5IDMuMDYtMy4xMiAzLjA2LTEuNzQgMC0zLTEuMDgtMy0zLjA2em0uMzYgNi44MWMwLS4yNC4wOS0uMzYuMzYtLjM2aDQuNzFjLjI0IDAgLjM2LjA5LjM2LjM2djIzLjY3YzAgLjI0LS4wNi4zNi0uMzYuMzZoLTQuNjVjLS4zIDAtLjM5LS4xNS0uMzktLjM5di0yMy42NGgtLjAzeiIgZmlsbD0iI0ZGN0MwMCIvPgogIDwvZz4KPC9zdmc+"

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/alvaro.3430e089.png";

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bh.3eb55e3b.png";

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/evan.5f58da6d.png";

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/josh.7f3f8b6d.png";

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kwame.7124fd9c.png";

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stu.3a974947.png";

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1115 */,
/* 1116 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik00MCA3MS41MkwuNDggMjUuNiAxNy42IDIuNCA0MCAwbDIyLjQgMi40IDE3LjEyIDIzLjJ6IiBmaWxsPSIjRkZBRTAwIi8+CiAgICA8cGF0aCBkPSJNNDAgNzEuNTJMLjQ4IDI1LjZoNzkuMDR6IiBmaWxsPSIjRUM2QzAwIi8+CiAgICA8cGF0aCBkPSJNNDAgNzEuNTJMMTYuNDggMjUuNmg0Ny4wNHoiIGZpbGw9IiNGRkFFMDAiLz4KICAgIDxwYXRoIGQ9Ik00MCAwTDE2LjQ4IDI1LjZoNDcuMDR6IiBmaWxsPSIjRkZFRkI0Ii8+CiAgICA8cGF0aCBkPSJNMTcuNiAyLjRMOC44IDE0LjA4LjQ4IDI1LjZoMTYuMTZ6TTYyLjQgMi40bDguOCAxMS42OCA4LjMyIDExLjUySDYzLjM2eiIgZmlsbD0iI0ZGQUUwMCIvPgogICAgPHBhdGggZD0iTTE3LjYgMi40bC0xLjEyIDIzLjJMNDAgMHpNNjIuNCAyLjRsMS4xMiAyMy4yTDQwIDB6IiBmaWxsPSIjRkVEMzA1Ii8+CiAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzYiIGhlaWdodD0iNzciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgZmlsbD0iI0ZGQjEzQiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgIDxnIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIxMC4xMzYiPgogICAgICA8cGF0aCBkPSJNMTUuNTYgMzQuNDRhNS45NzggNS45NzggMCAxIDAgMCA4LjQ1NGg0NC44OGE1Ljk3OCA1Ljk3OCAwIDEgMCAwLTguNDU0SDE1LjU2eiIvPgogICAgICA8cGF0aCBkPSJNMjUuMTIyIDE5LjgxYTUuOTc4IDUuOTc4IDAgMSAwLTUuOTc4IDUuOTc4bDMxLjczNCAzMS43MzVhNS45NzggNS45NzggMCAxIDAgNS45NzgtNS45NzhMMjUuMTIyIDE5LjgxeiIvPgogICAgICA8cGF0aCBkPSJNNDIuMjI3IDE2LjIyN2E1Ljk3OCA1Ljk3OCAwIDEgMC04LjQ1NCAwdjQ0Ljg4YTUuOTc4IDUuOTc4IDAgMSAwIDguNDU0IDB2LTQ0Ljg4eiIvPgogICAgICA8cGF0aCBkPSJNNTYuODU2IDI1Ljc4OGE1Ljk3OCA1Ljk3OCAwIDEgMC01Ljk3OC01Ljk3OEwxOS4xNDQgNTEuNTQ1YTUuOTc4IDUuOTc4IDAgMSAwIDUuOTc4IDUuOTc4bDMxLjczNC0zMS43MzV6Ii8+CiAgICA8L2c+CiAgICA8cGF0aCBkPSJNMTUuNTYgMzQuNDRhNS45NzggNS45NzggMCAxIDAgMCA4LjQ1NGg0NC44OGE1Ljk3OCA1Ljk3OCAwIDEgMCAwLTguNDU0SDE1LjU2eiIvPgogICAgPHBhdGggZD0iTTI1LjEyMiAxOS44MWE1Ljk3OCA1Ljk3OCAwIDEgMC01Ljk3OCA1Ljk3OGwzMS43MzQgMzEuNzM1YTUuOTc4IDUuOTc4IDAgMSAwIDUuOTc4LTUuOTc4TDI1LjEyMiAxOS44MXoiLz4KICAgIDxwYXRoIGQ9Ik00Mi4yMjcgMTYuMjI3YTUuOTc4IDUuOTc4IDAgMSAwLTguNDU0IDB2NDQuODhhNS45NzggNS45NzggMCAxIDAgOC40NTQgMHYtNDQuODh6Ii8+CiAgICA8cGF0aCBkPSJNNTYuODU2IDI1Ljc4OGE1Ljk3OCA1Ljk3OCAwIDEgMC01Ljk3OC01Ljk3OEwxOS4xNDQgNTEuNTQ1YTUuOTc4IDUuOTc4IDAgMSAwIDUuOTc4IDUuOTc4bDMxLjczNC0zMS43MzV6Ii8+CiAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDQgNDciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgaWQ9InY2LShBbmltYXRvci1sYXVuY2gtTWFyLScxOSkiIGZpbGw9Im5vbmUiIGZpbGxSdWxlPSJldmVub2RkIj4KICAgIDxnIGlkPSJIb21lcGFnZS0tLUxvb2stYW5kLWZlZWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTk5IC00OTEwKSIgZmlsbFJ1bGU9Im5vbnplcm8iPgogICAgICA8ZyBpZD0iUmVhZHMtYW5kLXdyaXRlcy1jb2RlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTkgNDQ2NCkiPgogICAgICAgIDxnIGlkPSJUZWFtcy1jb2RlYmFzZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjIyLjAwNSAxNDMpIj4KICAgICAgICAgIDxnIGlkPSJUZWFtcy1jb2RlYmFzZS1pY29ucyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDM5LjUwNSA1LjYxMDY0NCkiPgogICAgICAgICAgICA8ZyBpZD0iQW5ndWxhciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS45OTUgMjgyLjg1KSI+CiAgICAgICAgICAgICAgPGcgaWQ9IkFuZ3VsYXItbG9nbyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYuNjMgMTUuMjUpIj4KICAgICAgICAgICAgICAgIDxwYXRoIGlkPSJQYXRoIiBmaWxsPSIjREQwMDMxIiBkPSJNMjEuNjIgMEwuMjA3IDcuNjM2bDMuMjY2IDI4LjMxM0wyMS42MiA0NmwxOC4xNDctMTAuMDUxIDMuMjY2LTI4LjMxM3oiLz4KICAgICAgICAgICAgICAgIDxwYXRoIGlkPSJQYXRoIiBmaWxsPSIjQzMwMDJGIiBkPSJNMjEuNjIgMHY1LjEwNi0uMDIzVjQ2bDE4LjE0Ny0xMC4wNTEgMy4yNjYtMjguMzEzeiIvPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTIxLjYyIDUuMDgzTDguMjM0IDM1LjA5OGg0Ljk5MWwyLjY5MS02LjcxNmgxMS4zNjJsMi42OTEgNi43MTZoNC45OTFMMjEuNjIgNS4wODN6bTMuOTEgMTkuMTU5aC03LjgybDMuOTEtOS40MDcgMy45MSA5LjQwN3oiIGlkPSJTaGFwZSIgZmlsbD0iI0ZGRiIvPgogICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+"

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiIgdmlld0JveD0iMCAwIDQ1IDM5IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxnIGlkPSJ2Ni0oQW5pbWF0b3ItbGF1bmNoLU1hci0nMTkpIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPGcgaWQ9IkhvbWVwYWdlLS0tTG9vay1hbmQtZmVlbCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExOTcgLTQ3NzcpIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICA8ZyBpZD0iUmVhZHMtYW5kLXdyaXRlcy1jb2RlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTkgNDQ2NCkiPgogICAgICAgIDxnIGlkPSJUZWFtcy1jb2RlYmFzZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjIyLjAwNSAxNDMpIj4KICAgICAgICAgIDxnIGlkPSJUZWFtcy1jb2RlYmFzZS1pY29ucyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDM5LjUwNSA1LjYxMDY0NCkiPgogICAgICAgICAgICA8ZyBpZD0iVnVlLUpTIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSguOTc1IDE0MS4yOSkiPgogICAgICAgICAgICAgIDxnIGlkPSJWdWUtbG9nbyIgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMTUuMTE2ODA3IDYyLjEwMTQ5NikiPgogICAgICAgICAgICAgICAgPHBhdGggaWQ9IlBhdGgiIGZpbGw9IiM0MUI4ODMiIGQ9Ik0yOC4yOTYzNzEyIDM4Ljk4NDk0NzZsLTUuMTM4MTc4Mi04Ljg5OTYxNzUtNS4xMzgxNzgyIDguODk5NjE3NUguOTA5MTQ5MkwyMy4xNTgxOTMuNDQ4MDQ0NGwyMi4yNDkwNDM4IDM4LjUzNjkwMzJ6Ii8+CiAgICAgICAgICAgICAgICA8cGF0aCBpZD0iUGF0aCIgZmlsbD0iIzM0NDk1RSIgZD0iTTI4LjQzOTU4MDcgMzguNzYxMjk3NmwtNS4xMzgxNzgyLTguODk5NjE3NS01LjEzODE3ODMgOC44OTk2MTc1aC04LjIxMTI0OEwyMy4zMDE0MDI1IDE1LjYzOTYwOWwxMy4zNDk0MjYyIDIzLjEyMTY4ODZ6Ii8+CiAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4="

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-index-js-d8611f2898962ba5382d.js